(function () {

var $parcel$bundleURL;
function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  if (!$parcel$bundleURL) {
    try {
      throw new Error();
    } catch (err) {
      var matches = ('' + err.stack).match(
        /(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g,
      );
      if (matches) {
        $parcel$bundleURL = matches[0];
      } else {
        return $parcel$distDir + url;
      }
    }
  }
  return new URL($parcel$distDir + url, $parcel$bundleURL).toString();
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire4c53"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire4c53"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("cnCS2", function(module, exports) {

module.exports = (parcelRequire("4WKyX"))($parcel$resolve("clwvD")).then(()=>parcelRequire('S0nQY'));

});
parcelRegister("4WKyX", function(module, exports) {
"use strict";

var $2prpb = parcelRequire("2prpb");
module.exports = $2prpb(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName('script');
        if ([].concat(existingScripts).some(function(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement('link');
        preloadLink.href = bundle;
        preloadLink.rel = 'preload';
        preloadLink.as = 'script';
        document.head.appendChild(preloadLink);
        var script = document.createElement('script');
        script.async = true;
        script.type = 'text/javascript';
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(script);
    });
});

});
parcelRegister("2prpb", function(module, exports) {
"use strict";
var $1c132cac09cd18d9$var$cachedBundles = {};
var $1c132cac09cd18d9$var$cachedPreloads = {};
var $1c132cac09cd18d9$var$cachedPrefetches = {};
function $1c132cac09cd18d9$var$getCache(type) {
    switch(type){
        case 'preload':
            return $1c132cac09cd18d9$var$cachedPreloads;
        case 'prefetch':
            return $1c132cac09cd18d9$var$cachedPrefetches;
        default:
            return $1c132cac09cd18d9$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $1c132cac09cd18d9$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});



parcelRegister("gnS5A", function(module, exports) {

$parcel$export(module.exports, "rotation", function () { return ye; });

var $3aNd6 = parcelRequire("3aNd6");
var $49decdd7c8e65498$require$Buffer = $3aNd6.Buffer;
function e(e, t, s) {
    return t in e ? Object.defineProperty(e, t, {
        value: s,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[t] = s, e;
}
var t = "undefined" != typeof self ? self : $parcel$global;
const s = "undefined" != typeof navigator, i = s && "undefined" == typeof HTMLImageElement, n = (typeof $parcel$global, false), r = t.Buffer, a = !!r, h = (e)=>void 0 !== e;
function f(e) {
    return void 0 === e || (e instanceof Map ? 0 === e.size : 0 === Object.values(e).filter(h).length);
}
function l(e) {
    let t = new Error(e);
    throw delete t.stack, t;
}
function o(e) {
    let t = function(e) {
        let t = 0;
        return e.ifd0.enabled && (t += 1024), e.exif.enabled && (t += 2048), e.makerNote && (t += 2048), e.userComment && (t += 1024), e.gps.enabled && (t += 512), e.interop.enabled && (t += 100), e.ifd1.enabled && (t += 1024), t + 2048;
    }(e);
    return e.jfif.enabled && (t += 50), e.xmp.enabled && (t += 2e4), e.iptc.enabled && (t += 14e3), e.icc.enabled && (t += 6e3), t;
}
const u = (e)=>String.fromCharCode.apply(null, e), d = "undefined" != typeof TextDecoder ? new TextDecoder("utf-8") : void 0;
class c {
    static from(e, t) {
        return e instanceof this && e.le === t ? e : new c(e, void 0, void 0, t);
    }
    constructor(e, t = 0, s, i){
        if ("boolean" == typeof i && (this.le = i), Array.isArray(e) && (e = new Uint8Array(e)), 0 === e) this.byteOffset = 0, this.byteLength = 0;
        else if (e instanceof ArrayBuffer) {
            void 0 === s && (s = e.byteLength - t);
            let i = new DataView(e, t, s);
            this._swapDataView(i);
        } else if (e instanceof Uint8Array || e instanceof DataView || e instanceof c) {
            void 0 === s && (s = e.byteLength - t), (t += e.byteOffset) + s > e.byteOffset + e.byteLength && l("Creating view outside of available memory in ArrayBuffer");
            let i = new DataView(e.buffer, t, s);
            this._swapDataView(i);
        } else if ("number" == typeof e) {
            let t = new DataView(new ArrayBuffer(e));
            this._swapDataView(t);
        } else l("Invalid input argument for BufferView: " + e);
    }
    _swapArrayBuffer(e) {
        this._swapDataView(new DataView(e));
    }
    _swapBuffer(e) {
        this._swapDataView(new DataView(e.buffer, e.byteOffset, e.byteLength));
    }
    _swapDataView(e) {
        this.dataView = e, this.buffer = e.buffer, this.byteOffset = e.byteOffset, this.byteLength = e.byteLength;
    }
    _lengthToEnd(e) {
        return this.byteLength - e;
    }
    set(e, t, s = c) {
        return e instanceof DataView || e instanceof c ? e = new Uint8Array(e.buffer, e.byteOffset, e.byteLength) : e instanceof ArrayBuffer && (e = new Uint8Array(e)), e instanceof Uint8Array || l("BufferView.set(): Invalid data argument."), this.toUint8().set(e, t), new s(this, t, e.byteLength);
    }
    subarray(e, t) {
        return t = t || this._lengthToEnd(e), new c(this, e, t);
    }
    toUint8() {
        return new Uint8Array(this.buffer, this.byteOffset, this.byteLength);
    }
    getUint8Array(e, t) {
        return new Uint8Array(this.buffer, this.byteOffset + e, t);
    }
    getString(e = 0, t = this.byteLength) {
        let s = this.getUint8Array(e, t);
        var i;
        return i = s, d ? d.decode(i) : a ? $49decdd7c8e65498$require$Buffer.from(i).toString("utf8") : decodeURIComponent(escape(u(i)));
    }
    getLatin1String(e = 0, t = this.byteLength) {
        let s = this.getUint8Array(e, t);
        return u(s);
    }
    getUnicodeString(e = 0, t = this.byteLength) {
        const s = [];
        for(let i = 0; i < t && e + i < this.byteLength; i += 2)s.push(this.getUint16(e + i));
        return u(s);
    }
    getInt8(e) {
        return this.dataView.getInt8(e);
    }
    getUint8(e) {
        return this.dataView.getUint8(e);
    }
    getInt16(e, t = this.le) {
        return this.dataView.getInt16(e, t);
    }
    getInt32(e, t = this.le) {
        return this.dataView.getInt32(e, t);
    }
    getUint16(e, t = this.le) {
        return this.dataView.getUint16(e, t);
    }
    getUint32(e, t = this.le) {
        return this.dataView.getUint32(e, t);
    }
    getFloat32(e, t = this.le) {
        return this.dataView.getFloat32(e, t);
    }
    getFloat64(e, t = this.le) {
        return this.dataView.getFloat64(e, t);
    }
    getFloat(e, t = this.le) {
        return this.dataView.getFloat32(e, t);
    }
    getDouble(e, t = this.le) {
        return this.dataView.getFloat64(e, t);
    }
    getUintBytes(e, t, s) {
        switch(t){
            case 1:
                return this.getUint8(e, s);
            case 2:
                return this.getUint16(e, s);
            case 4:
                return this.getUint32(e, s);
            case 8:
                return this.getUint64 && this.getUint64(e, s);
        }
    }
    getUint(e, t, s) {
        switch(t){
            case 8:
                return this.getUint8(e, s);
            case 16:
                return this.getUint16(e, s);
            case 32:
                return this.getUint32(e, s);
            case 64:
                return this.getUint64 && this.getUint64(e, s);
        }
    }
    toString(e) {
        return this.dataView.toString(e, this.constructor.name);
    }
    ensureChunk() {}
}
function p(e, t) {
    l(`${e} '${t}' was not loaded, try using full build of exifr.`);
}
class g extends Map {
    constructor(e){
        super(), this.kind = e;
    }
    get(e, t) {
        return this.has(e) || p(this.kind, e), t && (e in t || function(e, t) {
            l(`Unknown ${e} '${t}'.`);
        }(this.kind, e), t[e].enabled || p(this.kind, e)), super.get(e);
    }
    keyList() {
        return Array.from(this.keys());
    }
}
var m = new g("file parser"), y = new g("segment parser"), b = new g("file reader");
let w = t.fetch;
function k(e, t) {
    var i;
    return (i = e).startsWith("data:") || i.length > 1e4 ? v(e, t, "base64") : n && e.includes("://") ? O(e, t, "url", S) : n ? v(e, t, "fs") : s ? O(e, t, "url", S) : void l("Invalid input argument");
}
async function O(e, t, s, i) {
    return b.has(s) ? v(e, t, s) : i ? async function(e, t) {
        let s = await t(e);
        return new c(s);
    }(e, i) : void l(`Parser ${s} is not loaded`);
}
async function v(e, t, s) {
    let i = new (b.get(s))(e, t);
    return await i.read(), i;
}
const S = (e)=>w(e).then((e)=>e.arrayBuffer()), A = (e)=>new Promise((t, s)=>{
        let i = new FileReader;
        i.onloadend = ()=>t(i.result || new ArrayBuffer), i.onerror = s, i.readAsArrayBuffer(e);
    });
class U extends Map {
    get tagKeys() {
        return this.allKeys || (this.allKeys = Array.from(this.keys())), this.allKeys;
    }
    get tagValues() {
        return this.allValues || (this.allValues = Array.from(this.values())), this.allValues;
    }
}
function x(e, t, s) {
    let i = new U;
    for (let [e, t] of s)i.set(e, t);
    if (Array.isArray(t)) for (let s of t)e.set(s, i);
    else e.set(t, i);
    return i;
}
function C(e, t, s) {
    let i, n = e.get(t);
    for (i of s)n.set(i[0], i[1]);
}
const B = new Map, V = new Map, I = new Map, L = [
    "chunked",
    "firstChunkSize",
    "firstChunkSizeNode",
    "firstChunkSizeBrowser",
    "chunkSize",
    "chunkLimit"
], T = [
    "jfif",
    "xmp",
    "icc",
    "iptc",
    "ihdr"
], z = [
    "tiff",
    ...T
], P = [
    "ifd0",
    "ifd1",
    "exif",
    "gps",
    "interop"
], F = [
    ...z,
    ...P
], j = [
    "makerNote",
    "userComment"
], E = [
    "translateKeys",
    "translateValues",
    "reviveValues",
    "multiSegment"
], M = [
    ...E,
    "sanitize",
    "mergeOutput",
    "silentErrors"
];
class _ {
    get translate() {
        return this.translateKeys || this.translateValues || this.reviveValues;
    }
}
class D extends _ {
    get needed() {
        return this.enabled || this.deps.size > 0;
    }
    constructor(t, s, i, n){
        if (super(), e(this, "enabled", !1), e(this, "skip", new Set), e(this, "pick", new Set), e(this, "deps", new Set), e(this, "translateKeys", !1), e(this, "translateValues", !1), e(this, "reviveValues", !1), this.key = t, this.enabled = s, this.parse = this.enabled, this.applyInheritables(n), this.canBeFiltered = P.includes(t), this.canBeFiltered && (this.dict = B.get(t)), void 0 !== i) {
            if (Array.isArray(i)) this.parse = this.enabled = !0, this.canBeFiltered && i.length > 0 && this.translateTagSet(i, this.pick);
            else if ("object" == typeof i) {
                if (this.enabled = !0, this.parse = !1 !== i.parse, this.canBeFiltered) {
                    let { pick: e, skip: t } = i;
                    e && e.length > 0 && this.translateTagSet(e, this.pick), t && t.length > 0 && this.translateTagSet(t, this.skip);
                }
                this.applyInheritables(i);
            } else !0 === i || !1 === i ? this.parse = this.enabled = i : l(`Invalid options argument: ${i}`);
        }
    }
    applyInheritables(e) {
        let t, s;
        for (t of E)s = e[t], void 0 !== s && (this[t] = s);
    }
    translateTagSet(e, t) {
        if (this.dict) {
            let s, i, { tagKeys: n, tagValues: r } = this.dict;
            for (s of e)"string" == typeof s ? (i = r.indexOf(s), -1 === i && (i = n.indexOf(Number(s))), -1 !== i && t.add(Number(n[i]))) : t.add(s);
        } else for (let s of e)t.add(s);
    }
    finalizeFilters() {
        !this.enabled && this.deps.size > 0 ? (this.enabled = !0, X(this.pick, this.deps)) : this.enabled && this.pick.size > 0 && X(this.pick, this.deps);
    }
}
var N = {
    jfif: !1,
    tiff: !0,
    xmp: !1,
    icc: !1,
    iptc: !1,
    ifd0: !0,
    ifd1: !1,
    exif: !0,
    gps: !0,
    interop: !1,
    ihdr: void 0,
    makerNote: !1,
    userComment: !1,
    multiSegment: !1,
    skip: [],
    pick: [],
    translateKeys: !0,
    translateValues: !0,
    reviveValues: !0,
    sanitize: !0,
    mergeOutput: !0,
    silentErrors: !0,
    chunked: !0,
    firstChunkSize: void 0,
    firstChunkSizeNode: 512,
    firstChunkSizeBrowser: 65536,
    chunkSize: 65536,
    chunkLimit: 5
}, $ = new Map;
class R extends _ {
    static useCached(e) {
        let t = $.get(e);
        return void 0 !== t || (t = new this(e), $.set(e, t)), t;
    }
    constructor(e){
        super(), !0 === e ? this.setupFromTrue() : void 0 === e ? this.setupFromUndefined() : Array.isArray(e) ? this.setupFromArray(e) : "object" == typeof e ? this.setupFromObject(e) : l(`Invalid options argument ${e}`), void 0 === this.firstChunkSize && (this.firstChunkSize = s ? this.firstChunkSizeBrowser : this.firstChunkSizeNode), this.mergeOutput && (this.ifd1.enabled = !1), this.filterNestedSegmentTags(), this.traverseTiffDependencyTree(), this.checkLoadedPlugins();
    }
    setupFromUndefined() {
        let e;
        for (e of L)this[e] = N[e];
        for (e of M)this[e] = N[e];
        for (e of j)this[e] = N[e];
        for (e of F)this[e] = new D(e, N[e], void 0, this);
    }
    setupFromTrue() {
        let e;
        for (e of L)this[e] = N[e];
        for (e of M)this[e] = N[e];
        for (e of j)this[e] = !0;
        for (e of F)this[e] = new D(e, !0, void 0, this);
    }
    setupFromArray(e) {
        let t;
        for (t of L)this[t] = N[t];
        for (t of M)this[t] = N[t];
        for (t of j)this[t] = N[t];
        for (t of F)this[t] = new D(t, !1, void 0, this);
        this.setupGlobalFilters(e, void 0, P);
    }
    setupFromObject(e) {
        let t;
        for (t of (P.ifd0 = P.ifd0 || P.image, P.ifd1 = P.ifd1 || P.thumbnail, Object.assign(this, e), L))this[t] = W(e[t], N[t]);
        for (t of M)this[t] = W(e[t], N[t]);
        for (t of j)this[t] = W(e[t], N[t]);
        for (t of z)this[t] = new D(t, N[t], e[t], this);
        for (t of P)this[t] = new D(t, N[t], e[t], this.tiff);
        this.setupGlobalFilters(e.pick, e.skip, P, F), !0 === e.tiff ? this.batchEnableWithBool(P, !0) : !1 === e.tiff ? this.batchEnableWithUserValue(P, e) : Array.isArray(e.tiff) ? this.setupGlobalFilters(e.tiff, void 0, P) : "object" == typeof e.tiff && this.setupGlobalFilters(e.tiff.pick, e.tiff.skip, P);
    }
    batchEnableWithBool(e, t) {
        for (let s of e)this[s].enabled = t;
    }
    batchEnableWithUserValue(e, t) {
        for (let s of e){
            let e = t[s];
            this[s].enabled = !1 !== e && void 0 !== e;
        }
    }
    setupGlobalFilters(e, t, s, i = s) {
        if (e && e.length) {
            for (let e of i)this[e].enabled = !1;
            let t = K(e, s);
            for (let [e, s] of t)X(this[e].pick, s), this[e].enabled = !0;
        } else if (t && t.length) {
            let e = K(t, s);
            for (let [t, s] of e)X(this[t].skip, s);
        }
    }
    filterNestedSegmentTags() {
        let { ifd0: e, exif: t, xmp: s, iptc: i, icc: n } = this;
        this.makerNote ? t.deps.add(37500) : t.skip.add(37500), this.userComment ? t.deps.add(37510) : t.skip.add(37510), s.enabled || e.skip.add(700), i.enabled || e.skip.add(33723), n.enabled || e.skip.add(34675);
    }
    traverseTiffDependencyTree() {
        let { ifd0: e, exif: t, gps: s, interop: i } = this;
        i.needed && (t.deps.add(40965), e.deps.add(40965)), t.needed && e.deps.add(34665), s.needed && e.deps.add(34853), this.tiff.enabled = P.some((e)=>!0 === this[e].enabled) || this.makerNote || this.userComment;
        for (let e of P)this[e].finalizeFilters();
    }
    get onlyTiff() {
        return !T.map((e)=>this[e].enabled).some((e)=>!0 === e) && this.tiff.enabled;
    }
    checkLoadedPlugins() {
        for (let e of z)this[e].enabled && !y.has(e) && p("segment parser", e);
    }
}
function K(e, t) {
    let s, i, n, r, a = [];
    for (n of t){
        for (r of (s = B.get(n), i = [], s))(e.includes(r[0]) || e.includes(r[1])) && i.push(r[0]);
        i.length && a.push([
            n,
            i
        ]);
    }
    return a;
}
function W(e, t) {
    return void 0 !== e ? e : void 0 !== t ? t : void 0;
}
function X(e, t) {
    for (let s of t)e.add(s);
}
e(R, "default", N);
class H {
    constructor(t){
        e(this, "parsers", {}), e(this, "output", {}), e(this, "errors", []), e(this, "pushToErrors", (e)=>this.errors.push(e)), this.options = R.useCached(t);
    }
    async read(e) {
        this.file = await function(e, t) {
            return "string" == typeof e ? k(e, t) : s && !i && e instanceof HTMLImageElement ? k(e.src, t) : e instanceof Uint8Array || e instanceof ArrayBuffer || e instanceof DataView ? new c(e) : s && e instanceof Blob ? O(e, t, "blob", A) : void l("Invalid input argument");
        }(e, this.options);
    }
    setup() {
        if (this.fileParser) return;
        let { file: e } = this, t = e.getUint16(0);
        for (let [s, i] of m)if (i.canHandle(e, t)) return this.fileParser = new i(this.options, this.file, this.parsers), e[s] = !0;
        this.file.close && this.file.close(), l("Unknown file format");
    }
    async parse() {
        let { output: e, errors: t } = this;
        var s;
        return this.setup(), this.options.silentErrors ? (await this.executeParsers().catch(this.pushToErrors), t.push(...this.fileParser.errors)) : await this.executeParsers(), this.file.close && this.file.close(), this.options.silentErrors && t.length > 0 && (e.errors = t), f(s = e) ? void 0 : s;
    }
    async executeParsers() {
        let { output: e } = this;
        await this.fileParser.parse();
        let t = Object.values(this.parsers).map(async (t)=>{
            let s = await t.parse();
            t.assignToOutput(e, s);
        });
        this.options.silentErrors && (t = t.map((e)=>e.catch(this.pushToErrors))), await Promise.all(t);
    }
    async extractThumbnail() {
        this.setup();
        let { options: e, file: t } = this, s = y.get("tiff", e);
        var i;
        if (t.tiff ? i = {
            start: 0,
            type: "tiff"
        } : t.jpeg && (i = await this.fileParser.getOrFindSegment("tiff")), void 0 === i) return;
        let n = await this.fileParser.ensureSegmentChunk(i), r = this.parsers.tiff = new s(n, e, t), a = await r.extractThumbnail();
        return t.close && t.close(), a;
    }
}
async function Y(e, t) {
    let s = new H(t);
    return await s.read(e), s.parse();
}
var G = Object.freeze({
    __proto__: null,
    parse: Y,
    Exifr: H,
    fileParsers: m,
    segmentParsers: y,
    fileReaders: b,
    tagKeys: B,
    tagValues: V,
    tagRevivers: I,
    createDictionary: x,
    extendDictionary: C,
    fetchUrlAsArrayBuffer: S,
    readBlobAsArrayBuffer: A,
    chunkedProps: L,
    otherSegments: T,
    segments: z,
    tiffBlocks: P,
    segmentsAndBlocks: F,
    tiffExtractables: j,
    inheritables: E,
    allFormatters: M,
    Options: R
});
class J {
    static findPosition(e, t) {
        let s = e.getUint16(t + 2) + 2, i = "function" == typeof this.headerLength ? this.headerLength(e, t, s) : this.headerLength, n = t + i, r = s - i;
        return {
            offset: t,
            length: s,
            headerLength: i,
            start: n,
            size: r,
            end: n + r
        };
    }
    static parse(e, t = {}) {
        return new this(e, new R({
            [this.type]: t
        }), e).parse();
    }
    normalizeInput(e) {
        return e instanceof c ? e : new c(e);
    }
    constructor(t, s = {}, i){
        e(this, "errors", []), e(this, "raw", new Map), e(this, "handleError", (e)=>{
            if (!this.options.silentErrors) throw e;
            this.errors.push(e.message);
        }), this.chunk = this.normalizeInput(t), this.file = i, this.type = this.constructor.type, this.globalOptions = this.options = s, this.localOptions = s[this.type], this.canTranslate = this.localOptions && this.localOptions.translate;
    }
    translate() {
        this.canTranslate && (this.translated = this.translateBlock(this.raw, this.type));
    }
    get output() {
        return this.translated ? this.translated : this.raw ? Object.fromEntries(this.raw) : void 0;
    }
    translateBlock(e, t) {
        let s = I.get(t), i = V.get(t), n = B.get(t), r = this.options[t], a = r.reviveValues && !!s, h = r.translateValues && !!i, f = r.translateKeys && !!n, l = {};
        for (let [t, r] of e)a && s.has(t) ? r = s.get(t)(r) : h && i.has(t) && (r = this.translateValue(r, i.get(t))), f && n.has(t) && (t = n.get(t) || t), l[t] = r;
        return l;
    }
    translateValue(e, t) {
        return t[e] || t.DEFAULT || e;
    }
    assignToOutput(e, t) {
        this.assignObjectToOutput(e, this.constructor.type, t);
    }
    assignObjectToOutput(e, t, s) {
        if (this.globalOptions.mergeOutput) return Object.assign(e, s);
        e[t] ? Object.assign(e[t], s) : e[t] = s;
    }
}
e(J, "headerLength", 4), e(J, "type", void 0), e(J, "multiSegment", !1), e(J, "canHandle", ()=>!1);
function q(e) {
    return 192 === e || 194 === e || 196 === e || 219 === e || 221 === e || 218 === e || 254 === e;
}
function Q(e) {
    return e >= 224 && e <= 239;
}
function Z(e, t, s) {
    for (let [i, n] of y)if (n.canHandle(e, t, s)) return i;
}
class ee extends class {
    constructor(t, s, i){
        e(this, "errors", []), e(this, "ensureSegmentChunk", async (e)=>{
            let t = e.start, s = e.size || 65536;
            if (this.file.chunked) {
                if (this.file.available(t, s)) e.chunk = this.file.subarray(t, s);
                else try {
                    e.chunk = await this.file.readChunk(t, s);
                } catch (t) {
                    l(`Couldn't read segment: ${JSON.stringify(e)}. ${t.message}`);
                }
            } else this.file.byteLength > t + s ? e.chunk = this.file.subarray(t, s) : void 0 === e.size ? e.chunk = this.file.subarray(t) : l("Segment unreachable: " + JSON.stringify(e));
            return e.chunk;
        }), this.extendOptions && this.extendOptions(t), this.options = t, this.file = s, this.parsers = i;
    }
    injectSegment(e, t) {
        this.options[e].enabled && this.createParser(e, t);
    }
    createParser(e, t) {
        let s = new (y.get(e))(t, this.options, this.file);
        return this.parsers[e] = s;
    }
    createParsers(e) {
        for (let t of e){
            let { type: e, chunk: s } = t, i = this.options[e];
            if (i && i.enabled) {
                let t = this.parsers[e];
                t && t.append || t || this.createParser(e, s);
            }
        }
    }
    async readSegments(e) {
        let t = e.map(this.ensureSegmentChunk);
        await Promise.all(t);
    }
} {
    constructor(...t){
        super(...t), e(this, "appSegments", []), e(this, "jpegSegments", []), e(this, "unknownSegments", []);
    }
    static canHandle(e, t) {
        return 65496 === t;
    }
    async parse() {
        await this.findAppSegments(), await this.readSegments(this.appSegments), this.mergeMultiSegments(), this.createParsers(this.mergedAppSegments || this.appSegments);
    }
    setupSegmentFinderArgs(e) {
        !0 === e ? (this.findAll = !0, this.wanted = new Set(y.keyList())) : (e = void 0 === e ? y.keyList().filter((e)=>this.options[e].enabled) : e.filter((e)=>this.options[e].enabled && y.has(e)), this.findAll = !1, this.remaining = new Set(e), this.wanted = new Set(e)), this.unfinishedMultiSegment = !1;
    }
    async findAppSegments(e = 0, t) {
        this.setupSegmentFinderArgs(t);
        let { file: s, findAll: i, wanted: n, remaining: r } = this;
        if (!i && this.file.chunked && (i = Array.from(n).some((e)=>{
            let t = y.get(e), s = this.options[e];
            return t.multiSegment && s.multiSegment;
        }), i && await this.file.readWhole()), e = this.findAppSegmentsInRange(e, s.byteLength), !this.options.onlyTiff && s.chunked) {
            let t = !1;
            for(; r.size > 0 && !t && (s.canReadNextChunk || this.unfinishedMultiSegment);){
                let { nextChunkOffset: i } = s, n = this.appSegments.some((e)=>!this.file.available(e.offset || e.start, e.length || e.size));
                if (t = e > i && !n ? !await s.readNextChunk(e) : !await s.readNextChunk(i), void 0 === (e = this.findAppSegmentsInRange(e, s.byteLength))) return;
            }
        }
    }
    findAppSegmentsInRange(e, t) {
        t -= 2;
        let s, i, n, r, a, h, { file: f, findAll: l, wanted: o, remaining: u, options: d } = this;
        for(; e < t; e++)if (255 === f.getUint8(e)) {
            if (s = f.getUint8(e + 1), Q(s)) {
                if (i = f.getUint16(e + 2), n = Z(f, e, i), n && o.has(n) && (r = y.get(n), a = r.findPosition(f, e), h = d[n], a.type = n, this.appSegments.push(a), !l && (r.multiSegment && h.multiSegment ? (this.unfinishedMultiSegment = a.chunkNumber < a.chunkCount, this.unfinishedMultiSegment || u.delete(n)) : u.delete(n), 0 === u.size))) break;
                d.recordUnknownSegments && (a = J.findPosition(f, e), a.marker = s, this.unknownSegments.push(a)), e += i + 1;
            } else if (q(s)) {
                if (i = f.getUint16(e + 2), 218 === s && !1 !== d.stopAfterSos) return;
                d.recordJpegSegments && this.jpegSegments.push({
                    offset: e,
                    length: i,
                    marker: s
                }), e += i + 1;
            }
        }
        return e;
    }
    mergeMultiSegments() {
        if (!this.appSegments.some((e)=>e.multiSegment)) return;
        let e = function(e, t) {
            let s, i, n, r = new Map;
            for(let a = 0; a < e.length; a++)s = e[a], i = s[t], r.has(i) ? n = r.get(i) : r.set(i, n = []), n.push(s);
            return Array.from(r);
        }(this.appSegments, "type");
        this.mergedAppSegments = e.map(([e, t])=>{
            let s = y.get(e, this.options);
            if (s.handleMultiSegments) return {
                type: e,
                chunk: s.handleMultiSegments(t)
            };
            return t[0];
        });
    }
    getSegment(e) {
        return this.appSegments.find((t)=>t.type === e);
    }
    async getOrFindSegment(e) {
        let t = this.getSegment(e);
        return void 0 === t && (await this.findAppSegments(0, [
            e
        ]), t = this.getSegment(e)), t;
    }
}
e(ee, "type", "jpeg"), m.set("jpeg", ee);
const te = [
    void 0,
    1,
    1,
    2,
    4,
    8,
    1,
    1,
    2,
    4,
    8,
    4,
    8,
    4
];
class se extends J {
    parseHeader() {
        var e = this.chunk.getUint16();
        18761 === e ? this.le = !0 : 19789 === e && (this.le = !1), this.chunk.le = this.le, this.headerParsed = !0;
    }
    parseTags(e, t, s = new Map) {
        let { pick: i, skip: n } = this.options[t];
        i = new Set(i);
        let r = i.size > 0, a = 0 === n.size, h = this.chunk.getUint16(e);
        e += 2;
        for(let f = 0; f < h; f++){
            let h = this.chunk.getUint16(e);
            if (r) {
                if (i.has(h) && (s.set(h, this.parseTag(e, h, t)), i.delete(h), 0 === i.size)) break;
            } else !a && n.has(h) || s.set(h, this.parseTag(e, h, t));
            e += 12;
        }
        return s;
    }
    parseTag(e, t, s) {
        let { chunk: i } = this, n = i.getUint16(e + 2), r = i.getUint32(e + 4), a = te[n];
        if (a * r <= 4 ? e += 8 : e = i.getUint32(e + 8), (n < 1 || n > 13) && l(`Invalid TIFF value type. block: ${s.toUpperCase()}, tag: ${t.toString(16)}, type: ${n}, offset ${e}`), e > i.byteLength && l(`Invalid TIFF value offset. block: ${s.toUpperCase()}, tag: ${t.toString(16)}, type: ${n}, offset ${e} is outside of chunk size ${i.byteLength}`), 1 === n) return i.getUint8Array(e, r);
        if (2 === n) return "" === (h = (function(e) {
            for(; e.endsWith("\0");)e = e.slice(0, -1);
            return e;
        })(h = i.getString(e, r)).trim()) ? void 0 : h;
        var h;
        if (7 === n) return i.getUint8Array(e, r);
        if (1 === r) return this.parseTagValue(n, e);
        {
            let t = new (function(e) {
                switch(e){
                    case 1:
                        return Uint8Array;
                    case 3:
                        return Uint16Array;
                    case 4:
                        return Uint32Array;
                    case 5:
                        return Array;
                    case 6:
                        return Int8Array;
                    case 8:
                        return Int16Array;
                    case 9:
                        return Int32Array;
                    case 10:
                        return Array;
                    case 11:
                        return Float32Array;
                    case 12:
                        return Float64Array;
                    default:
                        return Array;
                }
            }(n))(r), s = a;
            for(let i = 0; i < r; i++)t[i] = this.parseTagValue(n, e), e += s;
            return t;
        }
    }
    parseTagValue(e, t) {
        let { chunk: s } = this;
        switch(e){
            case 1:
                return s.getUint8(t);
            case 3:
                return s.getUint16(t);
            case 4:
                return s.getUint32(t);
            case 5:
                return s.getUint32(t) / s.getUint32(t + 4);
            case 6:
                return s.getInt8(t);
            case 8:
                return s.getInt16(t);
            case 9:
                return s.getInt32(t);
            case 10:
                return s.getInt32(t) / s.getInt32(t + 4);
            case 11:
                return s.getFloat(t);
            case 12:
                return s.getDouble(t);
            case 13:
                return s.getUint32(t);
            default:
                l(`Invalid tiff type ${e}`);
        }
    }
}
class ie extends se {
    static canHandle(e, t) {
        return 225 === e.getUint8(t + 1) && 1165519206 === e.getUint32(t + 4) && 0 === e.getUint16(t + 8);
    }
    async parse() {
        this.parseHeader();
        let { options: e } = this;
        return e.ifd0.enabled && await this.parseIfd0Block(), e.exif.enabled && await this.safeParse("parseExifBlock"), e.gps.enabled && await this.safeParse("parseGpsBlock"), e.interop.enabled && await this.safeParse("parseInteropBlock"), e.ifd1.enabled && await this.safeParse("parseThumbnailBlock"), this.createOutput();
    }
    safeParse(e) {
        let t = this[e]();
        return void 0 !== t.catch && (t = t.catch(this.handleError)), t;
    }
    findIfd0Offset() {
        void 0 === this.ifd0Offset && (this.ifd0Offset = this.chunk.getUint32(4));
    }
    findIfd1Offset() {
        if (void 0 === this.ifd1Offset) {
            this.findIfd0Offset();
            let e = this.chunk.getUint16(this.ifd0Offset), t = this.ifd0Offset + 2 + 12 * e;
            this.ifd1Offset = this.chunk.getUint32(t);
        }
    }
    parseBlock(e, t) {
        let s = new Map;
        return this[t] = s, this.parseTags(e, t, s), s;
    }
    async parseIfd0Block() {
        if (this.ifd0) return;
        let { file: e } = this;
        this.findIfd0Offset(), this.ifd0Offset < 8 && l("Malformed EXIF data"), !e.chunked && this.ifd0Offset > e.byteLength && l(`IFD0 offset points to outside of file.\nthis.ifd0Offset: ${this.ifd0Offset}, file.byteLength: ${e.byteLength}`), e.tiff && await e.ensureChunk(this.ifd0Offset, o(this.options));
        let t = this.parseBlock(this.ifd0Offset, "ifd0");
        return 0 !== t.size ? (this.exifOffset = t.get(34665), this.interopOffset = t.get(40965), this.gpsOffset = t.get(34853), this.xmp = t.get(700), this.iptc = t.get(33723), this.icc = t.get(34675), this.options.sanitize && (t.delete(34665), t.delete(40965), t.delete(34853), t.delete(700), t.delete(33723), t.delete(34675)), t) : void 0;
    }
    async parseExifBlock() {
        if (this.exif) return;
        if (this.ifd0 || await this.parseIfd0Block(), void 0 === this.exifOffset) return;
        this.file.tiff && await this.file.ensureChunk(this.exifOffset, o(this.options));
        let e = this.parseBlock(this.exifOffset, "exif");
        return this.interopOffset || (this.interopOffset = e.get(40965)), this.makerNote = e.get(37500), this.userComment = e.get(37510), this.options.sanitize && (e.delete(40965), e.delete(37500), e.delete(37510)), this.unpack(e, 41728), this.unpack(e, 41729), e;
    }
    unpack(e, t) {
        let s = e.get(t);
        s && 1 === s.length && e.set(t, s[0]);
    }
    async parseGpsBlock() {
        if (this.gps) return;
        if (this.ifd0 || await this.parseIfd0Block(), void 0 === this.gpsOffset) return;
        let e = this.parseBlock(this.gpsOffset, "gps");
        return e && e.has(2) && e.has(4) && (e.set("latitude", ne(...e.get(2), e.get(1))), e.set("longitude", ne(...e.get(4), e.get(3)))), e;
    }
    async parseInteropBlock() {
        if (!this.interop && (this.ifd0 || await this.parseIfd0Block(), void 0 !== this.interopOffset || this.exif || await this.parseExifBlock(), void 0 !== this.interopOffset)) return this.parseBlock(this.interopOffset, "interop");
    }
    async parseThumbnailBlock(e = !1) {
        if (!this.ifd1 && !this.ifd1Parsed && (!this.options.mergeOutput || e)) return this.findIfd1Offset(), this.ifd1Offset > 0 && (this.parseBlock(this.ifd1Offset, "ifd1"), this.ifd1Parsed = !0), this.ifd1;
    }
    async extractThumbnail() {
        if (this.headerParsed || this.parseHeader(), this.ifd1Parsed || await this.parseThumbnailBlock(!0), void 0 === this.ifd1) return;
        let e = this.ifd1.get(513), t = this.ifd1.get(514);
        return this.chunk.getUint8Array(e, t);
    }
    get image() {
        return this.ifd0;
    }
    get thumbnail() {
        return this.ifd1;
    }
    createOutput() {
        let e, t, s, i = {};
        for (t of P)if (e = this[t], !f(e)) {
            if (s = this.canTranslate ? this.translateBlock(e, t) : Object.fromEntries(e), this.options.mergeOutput) {
                if ("ifd1" === t) continue;
                Object.assign(i, s);
            } else i[t] = s;
        }
        return this.makerNote && (i.makerNote = this.makerNote), this.userComment && (i.userComment = this.userComment), i;
    }
    assignToOutput(e, t) {
        if (this.globalOptions.mergeOutput) Object.assign(e, t);
        else for (let [s, i] of Object.entries(t))this.assignObjectToOutput(e, s, i);
    }
}
function ne(e, t, s, i) {
    var n = e + t / 60 + s / 3600;
    return "S" !== i && "W" !== i || (n *= -1), n;
}
e(ie, "type", "tiff"), e(ie, "headerLength", 10), y.set("tiff", ie);
var re = Object.freeze({
    __proto__: null,
    default: G,
    Exifr: H,
    fileParsers: m,
    segmentParsers: y,
    fileReaders: b,
    tagKeys: B,
    tagValues: V,
    tagRevivers: I,
    createDictionary: x,
    extendDictionary: C,
    fetchUrlAsArrayBuffer: S,
    readBlobAsArrayBuffer: A,
    chunkedProps: L,
    otherSegments: T,
    segments: z,
    tiffBlocks: P,
    segmentsAndBlocks: F,
    tiffExtractables: j,
    inheritables: E,
    allFormatters: M,
    Options: R,
    parse: Y
});
const ae = {
    ifd0: !1,
    ifd1: !1,
    exif: !1,
    gps: !1,
    interop: !1,
    sanitize: !1,
    reviveValues: !0,
    translateKeys: !1,
    translateValues: !1,
    mergeOutput: !1
}, he = Object.assign({}, ae, {
    firstChunkSize: 4e4,
    gps: [
        1,
        2,
        3,
        4
    ]
});
async function fe(e) {
    let t = new H(he);
    await t.read(e);
    let s = await t.parse();
    if (s && s.gps) {
        let { latitude: e, longitude: t } = s.gps;
        return {
            latitude: e,
            longitude: t
        };
    }
}
const le = Object.assign({}, ae, {
    tiff: !1,
    ifd1: !0,
    mergeOutput: !1
});
async function oe(e) {
    let t = new H(le);
    await t.read(e);
    let s = await t.extractThumbnail();
    return s && a ? r.from(s) : s;
}
async function ue(e) {
    let t = await this.thumbnail(e);
    if (void 0 !== t) {
        let e = new Blob([
            t
        ]);
        return URL.createObjectURL(e);
    }
}
const de = Object.assign({}, ae, {
    firstChunkSize: 4e4,
    ifd0: [
        274
    ]
});
async function ce(e) {
    let t = new H(de);
    await t.read(e);
    let s = await t.parse();
    if (s && s.ifd0) return s.ifd0[274];
}
const pe = Object.freeze({
    1: {
        dimensionSwapped: !1,
        scaleX: 1,
        scaleY: 1,
        deg: 0,
        rad: 0
    },
    2: {
        dimensionSwapped: !1,
        scaleX: -1,
        scaleY: 1,
        deg: 0,
        rad: 0
    },
    3: {
        dimensionSwapped: !1,
        scaleX: 1,
        scaleY: 1,
        deg: 180,
        rad: 180 * Math.PI / 180
    },
    4: {
        dimensionSwapped: !1,
        scaleX: -1,
        scaleY: 1,
        deg: 180,
        rad: 180 * Math.PI / 180
    },
    5: {
        dimensionSwapped: !0,
        scaleX: 1,
        scaleY: -1,
        deg: 90,
        rad: 90 * Math.PI / 180
    },
    6: {
        dimensionSwapped: !0,
        scaleX: 1,
        scaleY: 1,
        deg: 90,
        rad: 90 * Math.PI / 180
    },
    7: {
        dimensionSwapped: !0,
        scaleX: 1,
        scaleY: -1,
        deg: 270,
        rad: 270 * Math.PI / 180
    },
    8: {
        dimensionSwapped: !0,
        scaleX: 1,
        scaleY: 1,
        deg: 270,
        rad: 270 * Math.PI / 180
    }
});
let ge = !0, me = !0;
if ("object" == typeof navigator) {
    let e = navigator.userAgent;
    if (e.includes("iPad") || e.includes("iPhone")) {
        let t = e.match(/OS (\d+)_(\d+)/);
        if (t) {
            let [, e, s] = t, i = Number(e) + .1 * Number(s);
            ge = i < 13.4, me = !1;
        }
    } else if (e.includes("OS X 10")) {
        let [, t] = e.match(/OS X 10[_.](\d+)/);
        ge = me = Number(t) < 15;
    }
    if (e.includes("Chrome/")) {
        let [, t] = e.match(/Chrome\/(\d+)/);
        ge = me = Number(t) < 81;
    } else if (e.includes("Firefox/")) {
        let [, t] = e.match(/Firefox\/(\d+)/);
        ge = me = Number(t) < 77;
    }
}
async function ye(e) {
    let t = await ce(e);
    return Object.assign({
        canvas: ge,
        css: me
    }, pe[t]);
}
class be extends c {
    constructor(...t){
        super(...t), e(this, "ranges", new we), 0 !== this.byteLength && this.ranges.add(0, this.byteLength);
    }
    _tryExtend(e, t, s) {
        if (0 === e && 0 === this.byteLength && s) {
            let e = new DataView(s.buffer || s, s.byteOffset, s.byteLength);
            this._swapDataView(e);
        } else {
            let s = e + t;
            if (s > this.byteLength) {
                let { dataView: e } = this._extend(s);
                this._swapDataView(e);
            }
        }
    }
    _extend(e) {
        let t;
        t = a ? r.allocUnsafe(e) : new Uint8Array(e);
        let s = new DataView(t.buffer, t.byteOffset, t.byteLength);
        return t.set(new Uint8Array(this.buffer, this.byteOffset, this.byteLength), 0), {
            uintView: t,
            dataView: s
        };
    }
    subarray(e, t, s = !1) {
        return t = t || this._lengthToEnd(e), s && this._tryExtend(e, t), this.ranges.add(e, t), super.subarray(e, t);
    }
    set(e, t, s = !1) {
        s && this._tryExtend(t, e.byteLength, e);
        let i = super.set(e, t);
        return this.ranges.add(t, i.byteLength), i;
    }
    async ensureChunk(e, t) {
        this.chunked && (this.ranges.available(e, t) || await this.readChunk(e, t));
    }
    available(e, t) {
        return this.ranges.available(e, t);
    }
}
class we {
    constructor(){
        e(this, "list", []);
    }
    get length() {
        return this.list.length;
    }
    add(e, t, s = 0) {
        let i = e + t, n = this.list.filter((t)=>ke(e, t.offset, i) || ke(e, t.end, i));
        if (n.length > 0) {
            e = Math.min(e, ...n.map((e)=>e.offset)), i = Math.max(i, ...n.map((e)=>e.end)), t = i - e;
            let s = n.shift();
            s.offset = e, s.length = t, s.end = i, this.list = this.list.filter((e)=>!n.includes(e));
        } else this.list.push({
            offset: e,
            length: t,
            end: i
        });
    }
    available(e, t) {
        let s = e + t;
        return this.list.some((t)=>t.offset <= e && s <= t.end);
    }
}
function ke(e, t, s) {
    return e <= t && t <= s;
}
class Oe extends be {
    constructor(t, s){
        super(0), e(this, "chunksRead", 0), this.input = t, this.options = s;
    }
    async readWhole() {
        this.chunked = !1, await this.readChunk(this.nextChunkOffset);
    }
    async readChunked() {
        this.chunked = !0, await this.readChunk(0, this.options.firstChunkSize);
    }
    async readNextChunk(e = this.nextChunkOffset) {
        if (this.fullyRead) return this.chunksRead++, !1;
        let t = this.options.chunkSize, s = await this.readChunk(e, t);
        return !!s && s.byteLength === t;
    }
    async readChunk(e, t) {
        if (this.chunksRead++, 0 !== (t = this.safeWrapAddress(e, t))) return this._readChunk(e, t);
    }
    safeWrapAddress(e, t) {
        return void 0 !== this.size && e + t > this.size ? Math.max(0, this.size - e) : t;
    }
    get nextChunkOffset() {
        if (0 !== this.ranges.list.length) return this.ranges.list[0].length;
    }
    get canReadNextChunk() {
        return this.chunksRead < this.options.chunkLimit;
    }
    get fullyRead() {
        return void 0 !== this.size && this.nextChunkOffset === this.size;
    }
    read() {
        return this.options.chunked ? this.readChunked() : this.readWhole();
    }
    close() {}
}
b.set("blob", class extends Oe {
    async readWhole() {
        this.chunked = !1;
        let e = await A(this.input);
        this._swapArrayBuffer(e);
    }
    readChunked() {
        return this.chunked = !0, this.size = this.input.size, super.readChunked();
    }
    async _readChunk(e, t) {
        let s = t ? e + t : void 0, i = this.input.slice(e, s), n = await A(i);
        return this.set(n, e, !0);
    }
});
var $49decdd7c8e65498$export$2e2bcd8739ae039 = re;

});
parcelRegister("3aNd6", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $24f87a6f86a8996f$export$a143d493d941bafc; }, function (v) { return $24f87a6f86a8996f$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $24f87a6f86a8996f$export$f99ded8fe4b79145; }, function (v) { return $24f87a6f86a8996f$export$f99ded8fe4b79145 = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $24f87a6f86a8996f$export$a143d493d941bafc;
var $24f87a6f86a8996f$export$e4cf37d7f6fb9e0a;
var $24f87a6f86a8996f$export$f99ded8fe4b79145;
var $24f87a6f86a8996f$export$599f31c3813fae4d;
'use strict';

var $5d11t = parcelRequire("5d11t");

var $7rddL = parcelRequire("7rddL");
const $24f87a6f86a8996f$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$24f87a6f86a8996f$export$a143d493d941bafc = $24f87a6f86a8996f$var$Buffer;
$24f87a6f86a8996f$export$e4cf37d7f6fb9e0a = $24f87a6f86a8996f$var$SlowBuffer;
$24f87a6f86a8996f$export$f99ded8fe4b79145 = 50;
const $24f87a6f86a8996f$var$K_MAX_LENGTH = 0x7fffffff;
$24f87a6f86a8996f$export$599f31c3813fae4d = $24f87a6f86a8996f$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $24f87a6f86a8996f$var$Buffer.TYPED_ARRAY_SUPPORT = $24f87a6f86a8996f$var$typedArraySupport();
if (!$24f87a6f86a8996f$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $24f87a6f86a8996f$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($24f87a6f86a8996f$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$24f87a6f86a8996f$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($24f87a6f86a8996f$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$24f87a6f86a8996f$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $24f87a6f86a8996f$var$createBuffer(length) {
    if (length > $24f87a6f86a8996f$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $24f87a6f86a8996f$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $24f87a6f86a8996f$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $24f87a6f86a8996f$var$allocUnsafe(arg);
    }
    return $24f87a6f86a8996f$var$from(arg, encodingOrOffset, length);
}
$24f87a6f86a8996f$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $24f87a6f86a8996f$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $24f87a6f86a8996f$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $24f87a6f86a8996f$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($24f87a6f86a8996f$var$isInstance(value, ArrayBuffer) || value && $24f87a6f86a8996f$var$isInstance(value.buffer, ArrayBuffer)) return $24f87a6f86a8996f$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($24f87a6f86a8996f$var$isInstance(value, SharedArrayBuffer) || value && $24f87a6f86a8996f$var$isInstance(value.buffer, SharedArrayBuffer))) return $24f87a6f86a8996f$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $24f87a6f86a8996f$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $24f87a6f86a8996f$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $24f87a6f86a8996f$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $24f87a6f86a8996f$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $24f87a6f86a8996f$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($24f87a6f86a8996f$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($24f87a6f86a8996f$var$Buffer, Uint8Array);
function $24f87a6f86a8996f$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $24f87a6f86a8996f$var$alloc(size, fill, encoding) {
    $24f87a6f86a8996f$var$assertSize(size);
    if (size <= 0) return $24f87a6f86a8996f$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $24f87a6f86a8996f$var$createBuffer(size).fill(fill, encoding) : $24f87a6f86a8996f$var$createBuffer(size).fill(fill);
    return $24f87a6f86a8996f$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $24f87a6f86a8996f$var$Buffer.alloc = function(size, fill, encoding) {
    return $24f87a6f86a8996f$var$alloc(size, fill, encoding);
};
function $24f87a6f86a8996f$var$allocUnsafe(size) {
    $24f87a6f86a8996f$var$assertSize(size);
    return $24f87a6f86a8996f$var$createBuffer(size < 0 ? 0 : $24f87a6f86a8996f$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $24f87a6f86a8996f$var$Buffer.allocUnsafe = function(size) {
    return $24f87a6f86a8996f$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $24f87a6f86a8996f$var$Buffer.allocUnsafeSlow = function(size) {
    return $24f87a6f86a8996f$var$allocUnsafe(size);
};
function $24f87a6f86a8996f$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$24f87a6f86a8996f$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $24f87a6f86a8996f$var$byteLength(string, encoding) | 0;
    let buf = $24f87a6f86a8996f$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $24f87a6f86a8996f$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $24f87a6f86a8996f$var$checked(array.length) | 0;
    const buf = $24f87a6f86a8996f$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $24f87a6f86a8996f$var$fromArrayView(arrayView) {
    if ($24f87a6f86a8996f$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $24f87a6f86a8996f$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $24f87a6f86a8996f$var$fromArrayLike(arrayView);
}
function $24f87a6f86a8996f$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $24f87a6f86a8996f$var$Buffer.prototype);
    return buf;
}
function $24f87a6f86a8996f$var$fromObject(obj) {
    if ($24f87a6f86a8996f$var$Buffer.isBuffer(obj)) {
        const len = $24f87a6f86a8996f$var$checked(obj.length) | 0;
        const buf = $24f87a6f86a8996f$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $24f87a6f86a8996f$var$numberIsNaN(obj.length)) return $24f87a6f86a8996f$var$createBuffer(0);
        return $24f87a6f86a8996f$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $24f87a6f86a8996f$var$fromArrayLike(obj.data);
}
function $24f87a6f86a8996f$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $24f87a6f86a8996f$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $24f87a6f86a8996f$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $24f87a6f86a8996f$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $24f87a6f86a8996f$var$Buffer.alloc(+length);
}
$24f87a6f86a8996f$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $24f87a6f86a8996f$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$24f87a6f86a8996f$var$Buffer.compare = function compare(a, b) {
    if ($24f87a6f86a8996f$var$isInstance(a, Uint8Array)) a = $24f87a6f86a8996f$var$Buffer.from(a, a.offset, a.byteLength);
    if ($24f87a6f86a8996f$var$isInstance(b, Uint8Array)) b = $24f87a6f86a8996f$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$24f87a6f86a8996f$var$Buffer.isBuffer(a) || !$24f87a6f86a8996f$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$24f87a6f86a8996f$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$24f87a6f86a8996f$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $24f87a6f86a8996f$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $24f87a6f86a8996f$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($24f87a6f86a8996f$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$24f87a6f86a8996f$var$Buffer.isBuffer(buf)) buf = $24f87a6f86a8996f$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$24f87a6f86a8996f$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $24f87a6f86a8996f$var$byteLength(string, encoding) {
    if ($24f87a6f86a8996f$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $24f87a6f86a8996f$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $24f87a6f86a8996f$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $24f87a6f86a8996f$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $24f87a6f86a8996f$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$24f87a6f86a8996f$var$Buffer.byteLength = $24f87a6f86a8996f$var$byteLength;
function $24f87a6f86a8996f$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $24f87a6f86a8996f$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $24f87a6f86a8996f$var$utf8Slice(this, start, end);
        case 'ascii':
            return $24f87a6f86a8996f$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $24f87a6f86a8996f$var$latin1Slice(this, start, end);
        case 'base64':
            return $24f87a6f86a8996f$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $24f87a6f86a8996f$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$24f87a6f86a8996f$var$Buffer.prototype._isBuffer = true;
function $24f87a6f86a8996f$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$24f87a6f86a8996f$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$24f87a6f86a8996f$var$swap(this, i, i + 1);
    return this;
};
$24f87a6f86a8996f$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $24f87a6f86a8996f$var$swap(this, i, i + 3);
        $24f87a6f86a8996f$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$24f87a6f86a8996f$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $24f87a6f86a8996f$var$swap(this, i, i + 7);
        $24f87a6f86a8996f$var$swap(this, i + 1, i + 6);
        $24f87a6f86a8996f$var$swap(this, i + 2, i + 5);
        $24f87a6f86a8996f$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$24f87a6f86a8996f$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $24f87a6f86a8996f$var$utf8Slice(this, 0, length);
    return $24f87a6f86a8996f$var$slowToString.apply(this, arguments);
};
$24f87a6f86a8996f$var$Buffer.prototype.toLocaleString = $24f87a6f86a8996f$var$Buffer.prototype.toString;
$24f87a6f86a8996f$var$Buffer.prototype.equals = function equals(b) {
    if (!$24f87a6f86a8996f$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $24f87a6f86a8996f$var$Buffer.compare(this, b) === 0;
};
$24f87a6f86a8996f$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $24f87a6f86a8996f$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($24f87a6f86a8996f$var$customInspectSymbol) $24f87a6f86a8996f$var$Buffer.prototype[$24f87a6f86a8996f$var$customInspectSymbol] = $24f87a6f86a8996f$var$Buffer.prototype.inspect;
$24f87a6f86a8996f$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($24f87a6f86a8996f$var$isInstance(target, Uint8Array)) target = $24f87a6f86a8996f$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$24f87a6f86a8996f$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $24f87a6f86a8996f$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($24f87a6f86a8996f$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $24f87a6f86a8996f$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($24f87a6f86a8996f$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $24f87a6f86a8996f$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $24f87a6f86a8996f$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $24f87a6f86a8996f$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$24f87a6f86a8996f$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$24f87a6f86a8996f$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $24f87a6f86a8996f$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$24f87a6f86a8996f$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $24f87a6f86a8996f$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $24f87a6f86a8996f$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($24f87a6f86a8996f$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $24f87a6f86a8996f$var$utf8Write(buf, string, offset, length) {
    return $24f87a6f86a8996f$var$blitBuffer($24f87a6f86a8996f$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $24f87a6f86a8996f$var$asciiWrite(buf, string, offset, length) {
    return $24f87a6f86a8996f$var$blitBuffer($24f87a6f86a8996f$var$asciiToBytes(string), buf, offset, length);
}
function $24f87a6f86a8996f$var$base64Write(buf, string, offset, length) {
    return $24f87a6f86a8996f$var$blitBuffer($24f87a6f86a8996f$var$base64ToBytes(string), buf, offset, length);
}
function $24f87a6f86a8996f$var$ucs2Write(buf, string, offset, length) {
    return $24f87a6f86a8996f$var$blitBuffer($24f87a6f86a8996f$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$24f87a6f86a8996f$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $24f87a6f86a8996f$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $24f87a6f86a8996f$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $24f87a6f86a8996f$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $24f87a6f86a8996f$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $24f87a6f86a8996f$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$24f87a6f86a8996f$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $24f87a6f86a8996f$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $5d11t.fromByteArray(buf);
    else return $5d11t.fromByteArray(buf.slice(start, end));
}
function $24f87a6f86a8996f$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $24f87a6f86a8996f$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $24f87a6f86a8996f$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $24f87a6f86a8996f$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $24f87a6f86a8996f$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $24f87a6f86a8996f$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $24f87a6f86a8996f$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $24f87a6f86a8996f$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $24f87a6f86a8996f$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $24f87a6f86a8996f$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $24f87a6f86a8996f$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$24f87a6f86a8996f$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $24f87a6f86a8996f$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $24f87a6f86a8996f$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$24f87a6f86a8996f$var$Buffer.prototype.readUintLE = $24f87a6f86a8996f$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$24f87a6f86a8996f$var$Buffer.prototype.readUintBE = $24f87a6f86a8996f$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$24f87a6f86a8996f$var$Buffer.prototype.readUint8 = $24f87a6f86a8996f$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$24f87a6f86a8996f$var$Buffer.prototype.readUint16LE = $24f87a6f86a8996f$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$24f87a6f86a8996f$var$Buffer.prototype.readUint16BE = $24f87a6f86a8996f$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$24f87a6f86a8996f$var$Buffer.prototype.readUint32LE = $24f87a6f86a8996f$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$24f87a6f86a8996f$var$Buffer.prototype.readUint32BE = $24f87a6f86a8996f$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$24f87a6f86a8996f$var$Buffer.prototype.readBigUInt64LE = $24f87a6f86a8996f$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $24f87a6f86a8996f$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $24f87a6f86a8996f$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$24f87a6f86a8996f$var$Buffer.prototype.readBigUInt64BE = $24f87a6f86a8996f$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $24f87a6f86a8996f$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $24f87a6f86a8996f$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$24f87a6f86a8996f$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$24f87a6f86a8996f$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$24f87a6f86a8996f$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$24f87a6f86a8996f$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$24f87a6f86a8996f$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$24f87a6f86a8996f$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$24f87a6f86a8996f$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$24f87a6f86a8996f$var$Buffer.prototype.readBigInt64LE = $24f87a6f86a8996f$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $24f87a6f86a8996f$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $24f87a6f86a8996f$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$24f87a6f86a8996f$var$Buffer.prototype.readBigInt64BE = $24f87a6f86a8996f$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $24f87a6f86a8996f$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $24f87a6f86a8996f$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$24f87a6f86a8996f$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 4, this.length);
    return $7rddL.read(this, offset, true, 23, 4);
};
$24f87a6f86a8996f$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 4, this.length);
    return $7rddL.read(this, offset, false, 23, 4);
};
$24f87a6f86a8996f$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 8, this.length);
    return $7rddL.read(this, offset, true, 52, 8);
};
$24f87a6f86a8996f$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 8, this.length);
    return $7rddL.read(this, offset, false, 52, 8);
};
function $24f87a6f86a8996f$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$24f87a6f86a8996f$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$24f87a6f86a8996f$var$Buffer.prototype.writeUintLE = $24f87a6f86a8996f$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $24f87a6f86a8996f$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeUintBE = $24f87a6f86a8996f$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $24f87a6f86a8996f$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeUint8 = $24f87a6f86a8996f$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeUint16LE = $24f87a6f86a8996f$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeUint16BE = $24f87a6f86a8996f$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeUint32LE = $24f87a6f86a8996f$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeUint32BE = $24f87a6f86a8996f$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $24f87a6f86a8996f$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $24f87a6f86a8996f$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $24f87a6f86a8996f$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $24f87a6f86a8996f$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$24f87a6f86a8996f$var$Buffer.prototype.writeBigUInt64LE = $24f87a6f86a8996f$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $24f87a6f86a8996f$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$24f87a6f86a8996f$var$Buffer.prototype.writeBigUInt64BE = $24f87a6f86a8996f$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $24f87a6f86a8996f$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$24f87a6f86a8996f$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $24f87a6f86a8996f$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $24f87a6f86a8996f$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeBigInt64LE = $24f87a6f86a8996f$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $24f87a6f86a8996f$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$24f87a6f86a8996f$var$Buffer.prototype.writeBigInt64BE = $24f87a6f86a8996f$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $24f87a6f86a8996f$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $24f87a6f86a8996f$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $24f87a6f86a8996f$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $7rddL.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$24f87a6f86a8996f$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $24f87a6f86a8996f$var$writeFloat(this, value, offset, true, noAssert);
};
$24f87a6f86a8996f$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $24f87a6f86a8996f$var$writeFloat(this, value, offset, false, noAssert);
};
function $24f87a6f86a8996f$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $7rddL.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$24f87a6f86a8996f$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $24f87a6f86a8996f$var$writeDouble(this, value, offset, true, noAssert);
};
$24f87a6f86a8996f$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $24f87a6f86a8996f$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$24f87a6f86a8996f$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$24f87a6f86a8996f$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$24f87a6f86a8996f$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$24f87a6f86a8996f$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $24f87a6f86a8996f$var$Buffer.isBuffer(val) ? val : $24f87a6f86a8996f$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $24f87a6f86a8996f$var$errors = {};
function $24f87a6f86a8996f$var$E(sym, getMessage, Base) {
    $24f87a6f86a8996f$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$24f87a6f86a8996f$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$24f87a6f86a8996f$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$24f87a6f86a8996f$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $24f87a6f86a8996f$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $24f87a6f86a8996f$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $24f87a6f86a8996f$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $24f87a6f86a8996f$var$checkBounds(buf, offset, byteLength) {
    $24f87a6f86a8996f$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $24f87a6f86a8996f$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $24f87a6f86a8996f$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $24f87a6f86a8996f$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $24f87a6f86a8996f$var$checkBounds(buf, offset, byteLength);
}
function $24f87a6f86a8996f$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $24f87a6f86a8996f$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $24f87a6f86a8996f$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $24f87a6f86a8996f$var$validateNumber(value, type);
        throw new $24f87a6f86a8996f$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $24f87a6f86a8996f$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $24f87a6f86a8996f$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $24f87a6f86a8996f$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $24f87a6f86a8996f$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($24f87a6f86a8996f$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $24f87a6f86a8996f$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $24f87a6f86a8996f$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $24f87a6f86a8996f$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $24f87a6f86a8996f$var$base64ToBytes(str) {
    return $5d11t.toByteArray($24f87a6f86a8996f$var$base64clean(str));
}
function $24f87a6f86a8996f$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $24f87a6f86a8996f$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $24f87a6f86a8996f$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $24f87a6f86a8996f$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $24f87a6f86a8996f$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $24f87a6f86a8996f$var$BufferBigIntNotDefined : fn;
}
function $24f87a6f86a8996f$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});
parcelRegister("5d11t", function(module, exports) {

$parcel$export(module.exports, "toByteArray", function () { return $3caef5c332c7293f$export$d622b2ad8d90c771; }, function (v) { return $3caef5c332c7293f$export$d622b2ad8d90c771 = v; });
$parcel$export(module.exports, "fromByteArray", function () { return $3caef5c332c7293f$export$6100ba28696e12de; }, function (v) { return $3caef5c332c7293f$export$6100ba28696e12de = v; });
var $3caef5c332c7293f$export$a48f0734ac7c2329;
var $3caef5c332c7293f$export$d622b2ad8d90c771;
var $3caef5c332c7293f$export$6100ba28696e12de;
'use strict';
$3caef5c332c7293f$export$a48f0734ac7c2329 = $3caef5c332c7293f$var$byteLength;
$3caef5c332c7293f$export$d622b2ad8d90c771 = $3caef5c332c7293f$var$toByteArray;
$3caef5c332c7293f$export$6100ba28696e12de = $3caef5c332c7293f$var$fromByteArray;
var $3caef5c332c7293f$var$lookup = [];
var $3caef5c332c7293f$var$revLookup = [];
var $3caef5c332c7293f$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $3caef5c332c7293f$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $3caef5c332c7293f$var$i = 0, $3caef5c332c7293f$var$len = $3caef5c332c7293f$var$code.length; $3caef5c332c7293f$var$i < $3caef5c332c7293f$var$len; ++$3caef5c332c7293f$var$i){
    $3caef5c332c7293f$var$lookup[$3caef5c332c7293f$var$i] = $3caef5c332c7293f$var$code[$3caef5c332c7293f$var$i];
    $3caef5c332c7293f$var$revLookup[$3caef5c332c7293f$var$code.charCodeAt($3caef5c332c7293f$var$i)] = $3caef5c332c7293f$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$3caef5c332c7293f$var$revLookup['-'.charCodeAt(0)] = 62;
$3caef5c332c7293f$var$revLookup['_'.charCodeAt(0)] = 63;
function $3caef5c332c7293f$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $3caef5c332c7293f$var$byteLength(b64) {
    var lens = $3caef5c332c7293f$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $3caef5c332c7293f$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $3caef5c332c7293f$var$toByteArray(b64) {
    var tmp;
    var lens = $3caef5c332c7293f$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $3caef5c332c7293f$var$Arr($3caef5c332c7293f$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $3caef5c332c7293f$var$revLookup[b64.charCodeAt(i)] << 18 | $3caef5c332c7293f$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $3caef5c332c7293f$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $3caef5c332c7293f$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $3caef5c332c7293f$var$revLookup[b64.charCodeAt(i)] << 2 | $3caef5c332c7293f$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $3caef5c332c7293f$var$revLookup[b64.charCodeAt(i)] << 10 | $3caef5c332c7293f$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $3caef5c332c7293f$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $3caef5c332c7293f$var$tripletToBase64(num) {
    return $3caef5c332c7293f$var$lookup[num >> 18 & 0x3F] + $3caef5c332c7293f$var$lookup[num >> 12 & 0x3F] + $3caef5c332c7293f$var$lookup[num >> 6 & 0x3F] + $3caef5c332c7293f$var$lookup[num & 0x3F];
}
function $3caef5c332c7293f$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($3caef5c332c7293f$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $3caef5c332c7293f$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($3caef5c332c7293f$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($3caef5c332c7293f$var$lookup[tmp >> 2] + $3caef5c332c7293f$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($3caef5c332c7293f$var$lookup[tmp >> 10] + $3caef5c332c7293f$var$lookup[tmp >> 4 & 0x3F] + $3caef5c332c7293f$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}

});

parcelRegister("7rddL", function(module, exports) {

$parcel$export(module.exports, "read", function () { return $56a54f6ebabce67d$export$aafa59e2e03f2942; }, function (v) { return $56a54f6ebabce67d$export$aafa59e2e03f2942 = v; });
$parcel$export(module.exports, "write", function () { return $56a54f6ebabce67d$export$68d8715fc104d294; }, function (v) { return $56a54f6ebabce67d$export$68d8715fc104d294 = v; });
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $56a54f6ebabce67d$export$aafa59e2e03f2942;
var $56a54f6ebabce67d$export$68d8715fc104d294;
$56a54f6ebabce67d$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$56a54f6ebabce67d$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});



var $6697e6e436eb0e32$exports = {};
$parcel$extendImportMap({
    "clwvD": "tinymce.min.dd3239f8.js"
});

class $8f658dda969a7982$export$2e2bcd8739ae039 extends HTMLElement {
    constructor(){
        super();
        this.listeners = [];
    }
    connectedCallback() {}
    /**
     * If the custom element is getting removed of the dom, all listeners
     * are getting removed of the element.
     */ disconnectedCallback() {
        this.listeners.forEach((item)=>{
            item.element.removeEventListener(item.event, item.action);
        });
    }
    /**
     * Here you can push a listener object directly to the listener array
     *
     * @param {Listener} {}
     */ pushListener({ event: event, element: element, action: action }) {
        this.listeners.push({
            event: event,
            element: element,
            action: action
        });
        element.addEventListener(event, action);
    }
    /**
     * Removes the given element from the listener array and removes the
     * EventListener from the element and returns the listener object.
     * If the element was not found, undefined is returned.
     *
     * @param {Element} element
     * @returns {Listener | undefined}
     */ removeListener(element) {
        const foundElement = this.listeners.find((item)=>item.element === element);
        if (!foundElement) return;
        foundElement?.element.removeEventListener(foundElement.event, foundElement.action);
        const newList = this.listeners.filter((item)=>item.element !== element);
        this.listeners = newList;
        return foundElement;
    }
    /**
     * Retrieves a data attribute from the element with the specified name.
     * If the attribute is not present, the provided default value is returned.
     *
     * @protected
     * @param {string} name - The name of the data attribute (without the `data-tk-` prefix).
     * @param {string} defaultValue - The default value to return if the attribute is not found.
     * @returns {string} - The value of the data attribute or the default value.
     */ getDataAttribute(name, defaultValue) {
        return this.getAttribute(`data-tk-${name}`) || defaultValue;
    }
}


var $588d148f2c9ac202$export$4120f82005ec4b2d = /*#__PURE__*/ function(TrackerPushTypes) {
    TrackerPushTypes["BASKET_UPDATE"] = "basket-update";
    TrackerPushTypes["FAVORITE_UPDATE"] = "favorite-update";
    return TrackerPushTypes;
}({});
class $588d148f2c9ac202$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    static{
        this.registry = {};
    }
    constructor(){
        super(), this.trackers = [];
        this.ready = new CustomEvent('tk-tracker-ready');
    }
    static registerTracker(name, factory) {
        this.registry[name] = factory;
    }
    async connectedCallback() {
        this.getTrackingIds();
        if (!this.trackerIds || this.trackerIds.length === 0) throw new Error('Trackier is not defined');
        await this.initTrackers();
        this.registerTrackingListener();
        this.dispatchEvent(this.ready);
    }
    registerTrackingListener() {
        const onTracking = this.handleTracking.bind(this);
        this.pushListener({
            event: 'tk-tracking-push',
            element: this,
            action: onTracking
        });
    }
    getTrackingIds() {
        try {
            this.trackerIds = JSON.parse(this.getAttribute('data-tk-trackers') || '[]');
        } catch (error) {
            console.error('Error parsing json', error);
        }
    }
    async initTrackers() {
        if (!this.trackerIds) return;
        for (const item of this.trackerIds)try {
            const createTracker = $588d148f2c9ac202$export$2e2bcd8739ae039.registry[item.name];
            if (createTracker) {
                const instance = await createTracker(item.key);
                await instance.init();
                this.trackers.push({
                    name: item.name,
                    instance: instance
                });
            } else console.warn(`Tracker "${item.name}" nicht gefunden.`);
        } catch (error) {
            console.error(`This tracker ${item.name} could not be initialized:` + error);
        }
    }
    handleTracking(event) {
        const { trackerType: trackerType, type: type, item: item } = event.detail;
        this.trackers.filter((trackerItem)=>!trackerType || trackerItem.name.toLowerCase() === trackerType.toLowerCase()).forEach((trackerItem)=>{
            if (type === "basket-update") trackerItem.instance.pushBasket(item);
            else if (type === "favorite-update") trackerItem.instance.pushFavorite(item);
            else trackerItem.instance.push(item);
        });
    }
}


class $26efcff9bda53fd7$export$2e2bcd8739ae039 {
    constructor(trackingId, tracker, defaultEndpoint, options){
        this.trackingId = trackingId;
        this.tracker = tracker;
        this.endpoint = options?.endpoint || defaultEndpoint;
        this.url = this.endpoint.replace(/%KEY/g, trackingId);
        this.basketEventMap = options?.basketEventMap || {
            added: 'add_to_cart',
            deleted: 'remove_from_cart',
            changed: 'update_cart'
        };
        this.favoriteEventMap = options?.favoriteEventMap || {
            added: 'add_from_wishlist',
            deleted: 'remove_from_wishlist'
        };
        this.favoriteActionMap = options?.favoriteActionMap || {
            added: 'add',
            deleted: 'delete'
        };
    }
    loadScript() {
        return new Promise((resolve, reject)=>{
            const script = document.createElement('script');
            script.async = true;
            script.src = this.url;
            script.onload = ()=>resolve(script);
            script.onerror = ()=>reject(new Error(`Failed to load script: ${this.url}`));
            document.head.appendChild(script);
        });
    }
}


class $4fa2285174eed561$export$2e2bcd8739ae039 extends (0, $26efcff9bda53fd7$export$2e2bcd8739ae039) {
    constructor(trackingId, options){
        super(trackingId, window.dataLayer || [], `https://www.googletagmanager.com/gtm.js?id=%KEY`, options);
        this.basketEventMap = options?.basketEventMap || {
            added: 'add_to_cart',
            deleted: 'remove_from_cart',
            changed: 'update_cart'
        };
        this.favoriteEventMap = options?.favoriteEventMap || {
            added: 'add_from_wishlist',
            deleted: 'remove_from_wishlist'
        };
    }
    init() {
        return new Promise((resolve, reject)=>{
            try {
                this.initGTM();
                this.loadScript().then(()=>{
                    console.log('Google Tag Manager successfully loaded');
                    resolve();
                }).catch((error)=>{
                    console.error('Error loading Google Tag Manager', error);
                    reject(error);
                });
            } catch (error) {
                console.error('Google Tag Manager initialization failed', error);
                reject(error);
            }
        });
    }
    initGTM() {
        this.tracker.push({
            'gtm.start': new Date().getTime(),
            event: 'gtm.js'
        });
    }
    push(item) {
        const { event: event, ...rest } = item;
        this.tracker.push({
            event: event,
            ecommerce: {
                ...rest
            }
        });
    }
    pushBasket(item) {
        this.tracker.push({
            event: this.basketEventMap[item.event],
            ecommerce: {
                currencyCode: item.currency,
                value: item.value,
                items: item.items.map((item)=>({
                        item_id: item.sku,
                        item_name: item.name,
                        price: item.price,
                        quantity: item.quantity
                    }))
            }
        });
    }
    pushFavorite(item) {
        this.tracker.push({
            event: this.favoriteEventMap[item.action],
            ecommerce: {
                category: item.category,
                action: this.favoriteActionMap[item.action],
                name: item.name,
                value: item.value
            }
        });
    }
}



class $30ee64c4b301d5a8$export$2e2bcd8739ae039 extends (0, $26efcff9bda53fd7$export$2e2bcd8739ae039) {
    constructor(trackingId, options){
        super(trackingId, window._mtm || [], `https://matomo01.opacc.net/js/container_%KEY.js`, options);
        this.basketEventMap = options?.basketEventMap || {
            added: 'opc_cart_add',
            deleted: 'opc_cart_remove',
            changed: 'opc_cart_update'
        };
        this.favoriteEventMap = options?.favoriteEventMap || {
            added: 'opc_wishlist_add',
            deleted: 'opc_wishlist_remove'
        };
    }
    async init() {
        await this.loadScript();
        this.initMatomo();
        console.log('Matomo Tag Manager successfully loaded');
    }
    initMatomo() {
        this.tracker.push({
            'mtm.startTime': new Date().getTime(),
            event: 'mtm.Start'
        });
    }
    push(item) {
        this.tracker.push(item);
    }
    pushBasket(item) {
        this.tracker.push({
            event: this.basketEventMap[item.event],
            location: item.location,
            currency: item.currency,
            value: item.value,
            items: item.items
        });
    }
    pushFavorite(item) {
        this.tracker.push({
            event: this.favoriteEventMap[item.action],
            location: window.location.href,
            category: item.category,
            action: this.favoriteActionMap[item.action],
            name: item.name,
            value: item.value
        });
    }
}


// Registry of tracker
(0, $588d148f2c9ac202$export$2e2bcd8739ae039).registerTracker('google', async (trackingId, options)=>new (0, $4fa2285174eed561$export$2e2bcd8739ae039)(trackingId, options));
(0, $588d148f2c9ac202$export$2e2bcd8739ae039).registerTracker('matomo', async (trackingId, options)=>new (0, $30ee64c4b301d5a8$export$2e2bcd8739ae039)(trackingId, options));


class $e31d2de11bbf216d$export$2e2bcd8739ae039 {
    constructor(list){
        this.customElementList = list;
        this.init();
    }
    init() {
        this.customElementList.forEach((item)=>{
            !customElements.get(item.name) && customElements.define(item.name, item.constructor);
        });
    }
}



const $86b3c5b6d66bd808$var$globalFormErrorMessages = {
    badInput: 'Please enter a number.',
    patternMismatch: 'Please match the requested format.',
    rangeOverflow: 'Please select a value that is no more than {max}.',
    rangeUnderflow: 'Please select a value that is no less than {min}.',
    stepMismatch: 'Please select a value that is a multiple from {step}.',
    tooLong: 'Please shorten this text to no more than {maxLength} characters. You are currently using {length} characters.',
    tooShort: 'Please lengthen this text to {minLength} characters or more. You are currently using {length} characters.',
    typeMismatch: 'The value you have entered for this field is invalid.',
    valueMissing: 'Please fill out this field.',
    // These properties must be empty.
    valid: '',
    customError: ''
};
const $86b3c5b6d66bd808$var$globalFormPasswordValidityMessages = {
    passwordNotMatching: 'The password does not match the one above.'
};
const $86b3c5b6d66bd808$var$globalFormExpandErrorMessages = {
    stepAdjust: 'The value you entered for this field is invalid. The value has been changed from {currentValue} to {newValue}',
    existigName: 'This name {currentValue} already exists.'
};
const $86b3c5b6d66bd808$var$globalBasketMessages = {
    messageEmptyBasket: {
        code: '1-6-6220',
        text: 'Shopping cart is empty'
    },
    messageAddedToBasket: {
        code: '1-6-6221',
        text: 'added to the shopping cart'
    },
    quickOrderMessageTooShort: {
        code: '1-6-6222',
        text: 'At least %1 characters are required for a search.'
    }
};
const $86b3c5b6d66bd808$var$globalDeliveryMessages = {
    messageDeliveryTypeGeneral: {
        code: '1-6-6226',
        text: 'Delivery method changed'
    }
};
const $86b3c5b6d66bd808$var$globalPaymentMessages = {
    messagePaymentTypeCreditCard: {
        code: '1-6-6227',
        text: 'Payment type credit card'
    },
    messagePaymentTypeInvoice: {
        code: '1-6-6227',
        text: 'Payment type invoice'
    },
    messagePaymentTypeInAdvance: {
        code: '1-6-6227',
        text: 'Payment type advance payment'
    },
    messagePaymentTypeOnDelivery: {
        code: '1-6-6227',
        text: 'Payment type cash on delivery'
    },
    messagePaymentTypeGeneral: {
        code: '1-6-6227',
        text: 'Payment type changed'
    }
};
const $86b3c5b6d66bd808$var$globalCompareMessages = {
    messageHint: {
        code: '1-6-6240',
        text: ''
    },
    allRemoved: {
        code: '1-6-6240',
        text: 'All items removed'
    },
    empty: {
        code: '1-6-6240',
        text: 'Your article comparison is empty.'
    },
    importantTitle: {
        code: '1-6-6240',
        text: 'The most important information'
    },
    removed: {
        code: '1-6-6240',
        text: 'The article was successfully removed.'
    },
    added: {
        code: '1-6-6240',
        text: 'The article was successfully added.'
    },
    noAttributesFound: {
        code: '1-6-6240',
        text: 'No comparison attributes were found.'
    }
};
const $86b3c5b6d66bd808$var$globalFavoriteMessages = {
    messageInvalidName: {
        code: '2-6-6270',
        text: 'Unable to create the wish list; the name is invalid.'
    },
    messageMaxLists: {
        code: '2-6-6277',
        text: 'Max. number of wish lists reached!'
    },
    messageMaxPositions: {
        code: '2-6-6278',
        text: 'Max. number of positions reached!'
    },
    messageDeleteConfirmation: {
        code: '2-6-6273',
        text: 'Do you really want to delete the wish list?'
    }
};
const $86b3c5b6d66bd808$var$globalAutocompleteMessages = {
    messageNoValueFound: {
        code: '1-6-6290',
        text: 'No match found!'
    }
};
const $86b3c5b6d66bd808$var$globalAccountMessages = {
    messageDelete: {
        code: '1-6-6200',
        text: 'Do you really want to delete this address?'
    },
    messageChangeSuccess: {
        code: '1-6-6200',
        text: 'Address successfully modified.'
    }
};
const $86b3c5b6d66bd808$var$globalGeneralMessages = {
    messageEmptyText: {
        code: '1-6-6290',
        text: 'The output was suppressed due to an empty text.'
    },
    messageOk: {
        code: '1-6-6290',
        text: 'Yes'
    },
    messageCancel: {
        code: '1-6-6290',
        text: 'No'
    },
    messageChange: {
        code: '1-6-6290',
        text: 'The selection was changed'
    },
    messageDefault: {
        code: '1-6-0000',
        text: ''
    },
    messageDefaultInfo: {
        code: '1-6-0000',
        text: ''
    },
    messageDefaultWarning: {
        code: '2-6-0000',
        text: ''
    },
    messageDefaultError: {
        code: '3-6-0000',
        text: ''
    },
    messageDefaultDebug: {
        code: '4-6-0000',
        text: ''
    },
    messageClipboard: {
        code: '1-6-6290',
        text: 'The text has been successfully saved to the clipboard.'
    }
};
const $86b3c5b6d66bd808$var$globalDirectSearchSuggestMessages = {
    messageTooShort: {
        code: '1-6-6260',
        text: 'At least 3 characters!'
    },
    messageResultEmpty: {
        code: '1-6-6260',
        text: 'No items found!'
    },
    messageDangerousString: {
        code: '1-6-6260',
        text: 'invalid character <.'
    },
    messageDisallowedCharacter: {
        code: '1-6-6260',
        text: 'Invalid character: %1'
    }
};
const $86b3c5b6d66bd808$var$globalFileuploadAreaMessages = {
    defaultMessage: {
        code: '1-6-2002',
        text: 'Store the files here to upload them'
    },
    fallbackMessage: {
        code: '2-6-2002',
        text: 'Your browser does not support drag&drop file uploads'
    },
    fallbackText: {
        code: '2-6-2002',
        text: 'Use the form to upload your files'
    },
    fileTooBig: {
        code: '2-6-2002',
        text: 'The file is too large. The maximum file size is {{maxFileSize}} MB'
    },
    invalidFileType: {
        code: '2-6-2002',
        text: 'Unable to upload files of this type'
    },
    responseError: {
        code: '3-6-2002',
        text: 'The server rejected your request with status {{statusCode}}'
    },
    cancelUpload: {
        code: '1-6-2002',
        text: 'Cancel upload'
    },
    cancelUploadConfirmation: {
        code: '1-6-2002',
        text: 'Cancel upload?'
    },
    removeFile: {
        code: '1-6-2002',
        text: 'Remove file'
    },
    maxFilesExceeded: {
        code: '2-6-2002',
        text: 'You are not allowed to upload any more files'
    },
    buttonBrowse: {
        code: '1-6-2002',
        text: 'Select files to upload'
    },
    uploadHint: {
        code: '1-6-2002',
        text: 'Drag files and folders here'
    }
};
const $86b3c5b6d66bd808$var$globalFilterMessages = {
    emptyResult: {
        code: '1-1-6280',
        text: 'Keine Ergebnisse gefunden.'
    }
};
const $86b3c5b6d66bd808$var$globalCheckoutMessages = {
    missingTerms: {
        code: '3-6-6230',
        text: 'Please accept the General terms and conditions.'
    },
    loadingCheckoutTitle: {
        code: '1-6-6260',
        text: 'Almost done!'
    },
    loadingCheckoutText: {
        code: '1-6-6261',
        text: 'The order is carried out. This can take a moment!'
    }
};
const $86b3c5b6d66bd808$var$globalHtmlErrorCodeMessages = {
    htmlErrorGeneral: {
        code: '3-6-6000',
        text: 'Something has gone wrong!'
    },
    htmlError401: {
        code: '3-6-6000',
        text: 'A valid authentication is required to process the request.'
    },
    htmlError403: {
        code: '3-6-6000',
        text: 'The request could not be processed due to missing authorization of the client.'
    },
    htmlError404: {
        code: '3-6-6000',
        text: 'The requested site does not exist.'
    },
    htmlError413: {
        code: '3-6-6000',
        text: 'The file is too large.'
    },
    htmlError415: {
        code: '3-6-6000',
        text: 'This media type is not supported.'
    },
    htmlError422: {
        code: '3-6-6000',
        text: 'Unable to display the requested site correctly.'
    },
    htmlError500: {
        code: '3-6-6000',
        text: 'Internal server error'
    },
    htmlError503: {
        code: '3-6-6000',
        text: 'The server is temporarily unavailable.'
    }
};
if (!window.opacc) window.opacc = {};
const $86b3c5b6d66bd808$export$7ea287b8bcd34b91 = {
    ...$86b3c5b6d66bd808$var$globalFormErrorMessages,
    ...$86b3c5b6d66bd808$var$globalFormPasswordValidityMessages,
    ...$86b3c5b6d66bd808$var$globalFormExpandErrorMessages,
    ...window.opacc.tkFormValidityMessages,
    ...window.opacc.tkFormPasswordValidityMessages,
    ...window.opacc.tkFormExpandErrorMessages,
    ...window.opacc.projectFormValidityMessages,
    ...window.opacc.projectFormPasswordValidityMessages,
    ...window.opacc.projectFormExpandErrorMessages
};
const $86b3c5b6d66bd808$export$35e6ad2b040b8403 = {
    ...$86b3c5b6d66bd808$var$globalFormExpandErrorMessages,
    ...window.opacc.tkFormExpandErrorMessages,
    ...window.opacc.projectFormExpandErrorMessages
};
const $86b3c5b6d66bd808$export$287bafa924522a4d = {
    ...$86b3c5b6d66bd808$var$globalBasketMessages,
    ...window.opacc.tkBasketMessages,
    ...window.opacc.projectBasketMessages
};
const $86b3c5b6d66bd808$export$ad480231e1cfb49 = {
    ...$86b3c5b6d66bd808$var$globalCompareMessages,
    ...window.opacc.tkCompareMessages,
    ...window.opacc.projectCompareMessages
};
const $86b3c5b6d66bd808$export$329e838a9ba51357 = {
    ...$86b3c5b6d66bd808$var$globalFavoriteMessages,
    ...window.opacc.tkFavoriteMessages,
    ...window.opacc.projectFavoriteMessages
};
const $86b3c5b6d66bd808$export$39227038979f1988 = {
    ...$86b3c5b6d66bd808$var$globalGeneralMessages,
    ...window.opacc.tkGeneralMessages,
    ...window.opacc.projectGeneralMessages
};
const $86b3c5b6d66bd808$export$f625b980042672da = {
    ...$86b3c5b6d66bd808$var$globalDirectSearchSuggestMessages,
    ...window.opacc.tkDirectSearchSuggestMessages,
    ...window.opacc.projectDirectSearchSuggestMessages
};
const $86b3c5b6d66bd808$export$fe24ead06f0313ff = {
    ...$86b3c5b6d66bd808$var$globalFileuploadAreaMessages,
    ...window.opacc.tkFileUploadAreaMessages,
    ...window.opacc.projectFileUploadAreaMessages
};
const $86b3c5b6d66bd808$export$1c7f7f3bbe522ebc = {
    ...$86b3c5b6d66bd808$var$globalFilterMessages,
    ...window.opacc.tkFilterMessages,
    ...window.opacc.projectFilterMessages
};
const $86b3c5b6d66bd808$export$fbedd73e1269236f = {
    ...$86b3c5b6d66bd808$var$globalAutocompleteMessages,
    ...window.opacc.tkAutocompleteMessages,
    ...window.opacc.projectAutocompleteMessages
};
const $86b3c5b6d66bd808$export$389a1ce21906c656 = {
    ...$86b3c5b6d66bd808$var$globalPaymentMessages,
    ...window.opacc.tkPaymentMessages,
    ...window.opacc.projectPaymentMessages
};
const $86b3c5b6d66bd808$export$36d5448025feaaa9 = {
    ...$86b3c5b6d66bd808$var$globalDeliveryMessages,
    ...window.opacc.tkDeliveryMessages,
    ...window.opacc.projectDeliveryMessages
};
const $86b3c5b6d66bd808$export$efd88ea7bc399322 = {
    ...$86b3c5b6d66bd808$var$globalAccountMessages,
    ...window.opacc.tkAccountMessages,
    ...window.opacc.projectAccountMessages
};
const $86b3c5b6d66bd808$export$4705307fe5270e12 = {
    ...$86b3c5b6d66bd808$var$globalCheckoutMessages,
    ...window.opacc.tkCheckoutMessages,
    ...window.opacc.projectCheckoutMessages
};
const $86b3c5b6d66bd808$export$6e7e78d2cde281b0 = {
    ...$86b3c5b6d66bd808$var$globalHtmlErrorCodeMessages,
    ...window.opacc.tkHtmlErrorCodeMessages,
    ...window.opacc.projectHtmlErrorCodeMessages
};
const $86b3c5b6d66bd808$export$97a703132b664051 = {
    ...window.opacc.tkZipCityMessages
};


/**
 * @param {string} html representing any number of sibling elements
 * @return {NodeListOf<ChildNode>}
 */ const $2d540709c75492d4$var$render = (html, isBody = false, shouldDecode = false)=>{
    if (!html) $2d540709c75492d4$var$render('<div></div>');
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    if (shouldDecode) return $2d540709c75492d4$var$render(doc.documentElement.textContent || '');
    return isBody ? doc.body : doc.body.children.item(0);
};
var $2d540709c75492d4$export$2e2bcd8739ae039 = $2d540709c75492d4$var$render;


var $1221feb2184dfefe$export$9130146a86a85749 = /*#__PURE__*/ function(NotificationType) {
    NotificationType["SUCCESS"] = "Success";
    NotificationType["WARNING"] = "Warning";
    NotificationType["ERROR"] = "Error";
    NotificationType["INFO"] = "Info";
    return NotificationType;
}({});
const $1221feb2184dfefe$var$mapMessageCodeToText = (response, messages)=>{
    let textMessage;
    if (!response.pluginId) return '';
    if (response.pluginId === 'paymentType') {
        const paymentMessages = {
            0: messages.messagePaymentTypeGeneral.text,
            1: messages.messagePaymentTypeCreditCard.text,
            2: messages.messagePaymentTypeInvoice.text,
            5: messages.messagePaymentTypeInAdvance.text,
            6: messages.messagePaymentTypeOnDelivery.text
        };
        textMessage = paymentMessages[Number(response.paymentType) || 0];
    } else if (response.pluginId === 'deliveryType') textMessage = messages.messageDeliveryTypeGeneral.text;
    else if (response.pluginId === 'checkoutAdressChange') textMessage = messages.messageChangeSuccess.text;
    return textMessage;
};
const $1221feb2184dfefe$var$getConsoleStyle = (backgroundColor, textColor = 'white')=>[
        `background: ${backgroundColor}`,
        `color: ${textColor}`,
        'display: block'
    ].join(';');
const $1221feb2184dfefe$var$logToConsole = (message, type)=>{
    const consoleHandler = {
        ["Success"] () {
            console.info(`%c ${message}`, $1221feb2184dfefe$var$getConsoleStyle('green'));
        },
        ["Warning"] () {
            console.warn(`%c ${message}`, $1221feb2184dfefe$var$getConsoleStyle('yellow', 'black'));
        },
        ["Error"] () {
            console.log(`%c ${message}`, $1221feb2184dfefe$var$getConsoleStyle('red'));
        },
        ["Info"] () {
            console.debug(`%c ${message}`, $1221feb2184dfefe$var$getConsoleStyle('blue'));
        }
    };
    consoleHandler[type]();
};
const $1221feb2184dfefe$var$renderMessageContainer = (parentElement)=>{
    let messageContainer = parentElement.querySelector('[data-tk-message-container]');
    if (!messageContainer) {
        messageContainer = (0, $2d540709c75492d4$export$2e2bcd8739ae039)('<div class="tk-message__container" data-tk-message-container></div>');
        parentElement.insertAdjacentElement('beforeend', messageContainer);
    }
    return messageContainer;
};
const $1221feb2184dfefe$export$3a57e165650c636f = (type, message, wait = 2.5, options = {})=>{
    if (!message) return;
    const dialogs = document.querySelectorAll('dialog[open]');
    let messageContainer;
    if (dialogs.length === 0) messageContainer = $1221feb2184dfefe$var$renderMessageContainer(document.body);
    else {
        const lastDialog = Array.from(dialogs).at(-1);
        if (!lastDialog) messageContainer = $1221feb2184dfefe$var$renderMessageContainer(document.body);
        else messageContainer = $1221feb2184dfefe$var$renderMessageContainer(lastDialog);
    }
    const toast = (0, $2d540709c75492d4$export$2e2bcd8739ae039)(`
        <div class="tk-message tk-message--toast tk-message--${type.toLowerCase()}">
            <span class="tk-message__icon"><i class="tk-icon-${type.toLowerCase()}"></i></span>
            <span class="tk-message__label">${message}</span>
        </div>
    `);
    toast.style.animation = `fadein .5s, fadeout .5s ${wait}s`;
    toast.classList.add('tk-message--show');
    messageContainer.appendChild(toast);
    toast.addEventListener('animationend', (event)=>{
        if (event.animationName !== 'fadeout') return;
        messageContainer.removeChild(toast);
    });
    options.consoleMessage ? $1221feb2184dfefe$var$logToConsole(options.consoleMessage, type) : $1221feb2184dfefe$var$logToConsole(message, type);
};
const $1221feb2184dfefe$export$146c7c7e50ed1bd2 = (item, messageOverride)=>{
    const type = item.code.substring(0, 1);
    const message = messageOverride || item.text;
    const typeHandler = {
        1: ()=>$1221feb2184dfefe$export$3a57e165650c636f("Success", message, item.wait),
        2: ()=>$1221feb2184dfefe$export$3a57e165650c636f("Warning", message, item.wait),
        3: ()=>$1221feb2184dfefe$export$3a57e165650c636f("Error", message, item.wait),
        4: ()=>$1221feb2184dfefe$export$3a57e165650c636f("Info", message, item.wait)
    };
    typeHandler[type]();
};
const $1221feb2184dfefe$export$5b256beea4c7e9b5 = (items, response)=>{
    const messages = {
        ...(0, $86b3c5b6d66bd808$export$39227038979f1988),
        ...(0, $86b3c5b6d66bd808$export$efd88ea7bc399322),
        ...(0, $86b3c5b6d66bd808$export$389a1ce21906c656),
        ...(0, $86b3c5b6d66bd808$export$36d5448025feaaa9)
    };
    items.forEach((item)=>{
        $1221feb2184dfefe$export$146c7c7e50ed1bd2(item, $1221feb2184dfefe$var$mapMessageCodeToText(response, messages));
    });
};


class $aa35ef9547ba682e$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.eventName = this.getAttribute('data-tk-event-name') || 'event-purchase';
        this.basketId = this.querySelector('[data-tk-otm-basket-id]') || undefined;
        this.messageContainerSelector = this.getAttribute('data-tk-message-container-selector') || '[id^="wp_messages_container_"]';
        this.sessionTimeoutWrapper = this.querySelector('[data-tk-session-timeout-wrapper]') || undefined;
        this.sessionTime = Number(this.sessionTimeoutWrapper?.getAttribute('data-tk-session-time') || 0);
        this.firstItemToScrollInto = this.querySelector('[data-tk-scroll-into]') || undefined;
    }
    connectedCallback() {
        this.processNotification();
        this.sessionTimeoutWrapper && this.showSessionTimeout();
        this.firstItemToScrollInto && this.scrollToElement();
        if (!this.basketId || !window.dataLayer) return;
        const data = this.getPurchaseData();
        data && window.dataLayer.push(data);
    }
    processNotification() {
        const messageContainer = document.querySelector(this.messageContainerSelector);
        if (!messageContainer || !messageContainer.hasChildNodes()) return;
        const infoMessage = messageContainer.querySelectorAll('.Info');
        const errorMessage = messageContainer.querySelectorAll('.Error');
        const warningMessage = messageContainer.querySelectorAll('.Warning');
        const debugMessage = messageContainer.querySelectorAll('.Debug');
        const messageList = Array.from([
            ...infoMessage,
            ...errorMessage,
            ...warningMessage,
            ...debugMessage
        ]);
        const types = {
            Info: (0, $1221feb2184dfefe$export$9130146a86a85749).SUCCESS,
            Error: (0, $1221feb2184dfefe$export$9130146a86a85749).ERROR,
            Warning: (0, $1221feb2184dfefe$export$9130146a86a85749).WARNING,
            Debug: (0, $1221feb2184dfefe$export$9130146a86a85749).INFO
        };
        messageList.forEach((item)=>{
            const type = types[item.className];
            const childList = Array.from(item.firstChild?.childNodes || []);
            const message = childList.find((item)=>item instanceof Text)?.textContent || '';
            const code = item.querySelector('.was-message-code')?.textContent || '';
            const addition = item.querySelector('.was-message-addition')?.textContent || '';
            const wait = Number(item.querySelector('.was-message-wait')?.textContent) || undefined;
            const consoleMessage = `${code}: ${message}} (wait: ${wait} sec.${addition})`;
            (0, $1221feb2184dfefe$export$3a57e165650c636f)(type, message, wait, {
                consoleMessage: consoleMessage
            });
        });
        messageContainer.remove();
    }
    showSessionTimeout() {
        setTimeout(()=>{
            this.sessionTimeoutWrapper.hidden = false;
        }, this.sessionTime);
    }
    getPurchaseData() {
        return {
            event: 'event-purchase',
            ecommerce: {
                purchase: {
                    actionField: this.getActionData(),
                    products: this.getProductData()
                }
            }
        };
    }
    getActionData() {
        const affiliation = this.querySelector('[data-tk-otm-affiliation]');
        const revenue = this.querySelector('[data-tk-otm-revenue]');
        const tax = this.querySelector('[data-tk-otm-tax]');
        const shipping = this.querySelector('[data-tk-otm-shipping]');
        return {
            id: this.basketId.innerText,
            affiliation: affiliation ? affiliation.innerText : '',
            revenue: revenue ? revenue.innerText : '',
            tax: tax ? tax.innerText : '',
            shipping: shipping ? shipping.innerText : ''
        };
    }
    getProductData() {
        const data = [];
        const items = this.querySelectorAll('[data-tk-otm-item]');
        Array.from(items).forEach((item)=>{
            const id = item.querySelector('.otm-id');
            const name = item.querySelector('.otm-name');
            const brand = item.querySelector('.otm-brand');
            const category = item.querySelector('.otm-category');
            const price = item.querySelector('.otm-price');
            const quantity = item.querySelector('.otm-quantity');
            const position = item.querySelector('.otm-position');
            data.push({
                id: id ? id.innerText : '',
                name: name ? name.innerText : '',
                brand: brand ? brand.innerText : '',
                category: category ? category.innerText : '',
                price: price ? price.innerText : '',
                quantity: quantity ? quantity.innerText : '',
                position: position ? position.innerText : ''
            });
        });
        return data;
    }
    scrollToElement() {
        const { top: top } = this.firstItemToScrollInto.getBoundingClientRect();
        const offset = Number(this.firstItemToScrollInto?.getAttribute('data-tk-scroll-into-offset')) || 16;
        const mainContainer = this.querySelector('main');
        const mainRect = mainContainer?.getBoundingClientRect();
        const mainRectTop = mainRect?.top || 0;
        const scrollY = top - mainRectTop - offset;
        setTimeout(()=>{
            window.scrollTo({
                top: scrollY,
                behavior: 'smooth'
            });
        }, 0);
    }
}


function $7e8cc8975b3fe464$export$60d21ef256fe91e0(point, rectangle, offset) {
    return point.x < rectangle.left + (offset?.left || 0) || point.x > rectangle.right + (offset?.right || 0) || point.y < rectangle.top + (offset?.top || 0) || point.y > rectangle.bottom + (offset?.bottom || 0);
}
function $7e8cc8975b3fe464$export$dcbd32acb1a13bc6(event, rectangles) {
    const point = {
        x: event.clientX,
        y: event.clientY
    };
    return rectangles.every((item)=>$7e8cc8975b3fe464$export$60d21ef256fe91e0(point, item.rectangle, item.offset));
}


class $9d20cb2aef3a6ec2$export$2e2bcd8739ae039 extends HTMLElement {
    constructor(){
        super();
        this.dialog = this.querySelector('dialog') || undefined;
        this.button = this.querySelector('button') || undefined;
        this.selectedClassName = this.getAttribute('data-selected-class-name') || 'tk-button__account--selected';
        this.alignedRightClassName = this.getAttribute('data-aligned-right-class-name') || 'tk-button__account--right';
        this.onShowEvent = ()=>{};
        this.onCloseEvent = ()=>{};
    }
    disconnectedCallback() {
        this.removeEventListener('mouseenter', this.onShowEvent);
        this.dialog?.removeEventListener('mouseleave', this.onCloseEvent);
    }
    connectedCallback() {
        this.registerOpenListener();
    }
    registerOpenListener() {
        this.onShowEvent = this.show.bind(this);
        this.addEventListener('mouseenter', this.onShowEvent);
    }
    registerCloseListener() {
        this.onCloseEvent = this.close.bind(this);
        this.addEventListener('mouseleave', this.onCloseEvent);
        this.dialog?.addEventListener('mouseleave', this.onCloseEvent);
    }
    show() {
        if (!this.dialog || !this.button) return;
        this.dialog.show();
        this.button.classList.add(this.selectedClassName);
        const { left: left } = this.button.getBoundingClientRect();
        const leftPosition = left + window.scrollX;
        if (window.outerWidth <= this.dialog.clientWidth + leftPosition) this.dialog.classList.add(this.alignedRightClassName);
        setTimeout(()=>{
            this.registerCloseListener();
        });
    }
    close(event) {
        if (!this.dialog || !this.button) return;
        const dialogDimensions = this.dialog.getBoundingClientRect();
        const buttonDimensions = this.button.getBoundingClientRect();
        const rectangles = [
            {
                rectangle: dialogDimensions
            },
            {
                rectangle: buttonDimensions,
                offset: {
                    bottom: dialogDimensions.top - buttonDimensions.bottom
                }
            }
        ];
        if ((0, $7e8cc8975b3fe464$export$dcbd32acb1a13bc6)(event, rectangles)) {
            this.button.classList.remove(this.selectedClassName);
            this.dialog.close();
        }
    }
}





const $1653b55d89a7adce$var$getDefaultErrorFnc = (error)=>{
    throw new Error(`Request failed: ${error}`);
};
const $1653b55d89a7adce$export$a4101276b4831ec4 = (checkForReadOnlyContext = false)=>{
    const asyncUrl = '/WebPortal/async.aspx';
    if (!window.opacc || !window.opacc.systemUrls || !checkForReadOnlyContext || !window.opacc.systemUrls.asyncReadOnly) return asyncUrl;
    return window.opacc.systemUrls.asyncReadOnly;
};
const $1653b55d89a7adce$var$prepareJsonResponse = (response, showMessages)=>{
    const data = window.atob(response.data);
    const html = document.createElement('div');
    html.innerHTML = data;
    const json = response.contentType === 'application/json' && html.innerText !== '' ? JSON.parse(html.innerText) : {};
    showMessages && (0, $1221feb2184dfefe$export$5b256beea4c7e9b5)(response.messages, json);
    return {
        status: response.status,
        messages: response.messages,
        dataAsBase64: response.data,
        contentType: response,
        success: response.status === 'ok',
        dataAsHtml: response.contentType === 'text/html' ? html.innerText : '',
        dataAsJson: json,
        data: data
    };
};
const $1653b55d89a7adce$var$recordToURLSearchParams = (data)=>{
    const searchParams = new URLSearchParams();
    Object.entries(data).forEach(([key, value])=>{
        searchParams.append(key, value || '');
    });
    return searchParams;
};
const $1653b55d89a7adce$var$formDataToURLSearchParams = (formData)=>{
    const searchParams = new URLSearchParams();
    formData.forEach((value, key)=>{
        searchParams.append(key, value);
    });
    return searchParams;
};
const $1653b55d89a7adce$export$d5a8517da06db2d = async ({ requestURL: requestURL, resolveHandler: resolveHandler, rejectHandler: rejectHandler = $1653b55d89a7adce$var$getDefaultErrorFnc, payload: payload, decodeJSONResponse: decodeJSONResponse = true, cache: cache = 'default', showMessages: showMessages = true })=>{
    const headers = new Headers({
        'x-requested-with': 'XMLHttpRequest',
        'response-type': 'json'
    });
    let body;
    if (payload) {
        headers.set('content-type', 'application/x-www-form-urlencoded; charset=UTF-8');
        if (payload instanceof URLSearchParams) body = payload;
        else if (payload instanceof FormData) body = $1653b55d89a7adce$var$formDataToURLSearchParams(payload);
        else if (payload instanceof Object) body = $1653b55d89a7adce$var$recordToURLSearchParams(payload);
    }
    const init = {
        method: payload ? 'POST' : 'GET',
        headers: headers,
        cache: cache,
        credentials: 'include',
        body: body
    };
    try {
        const response = await fetch(requestURL, init);
        const contentType = response.headers.get('content-type');
        const data = contentType?.includes('application/json') ? await response.json() : await response.text();
        const preparedData = decodeJSONResponse ? $1653b55d89a7adce$var$prepareJsonResponse(data, showMessages) : data;
        resolveHandler(preparedData);
    } catch (error) {
        rejectHandler(error);
    }
};
const $1653b55d89a7adce$export$24835cb787452b46 = async (params)=>{
    const requestManager = document.querySelector('[data-tk-request-manager]');
    if (requestManager) return requestManager.addRequest(params);
    return $1653b55d89a7adce$export$d5a8517da06db2d(params);
};


class $40898dd22403025f$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super(), this.pages = [];
        this.navigationWrapper = document.querySelector('[data-tk-nav-wrapper]') || undefined;
        this.wrapper = this.querySelector('[data-tk-wrapper]') || undefined;
        this.openButton = document.querySelector(`[data-tk-nav-open="${this.id}"]`) || undefined;
        this.closeButton = document.querySelector(`[data-tk-nav-close="${this.id}"]`) || undefined;
        this.openClassName = this.getAttribute('data-tk-open-class-name') || 'viewport__navigation--open';
        this.currentMenuId = this.getAttribute('data-tk-current-menu-id') || undefined;
        this.hasChildrenClassName = this.getAttribute('data-tk-has-children-class-name') || 'tk-nav-burger-item--has-children';
        this.asyncTemplateName = this.getAttribute('data-tk-nav-async-template-name') || 'tk-navigation-burgerlist';
        this.desktopMinWidth = Number(this.getAttribute('data-tk-desktop-min-width')) || 1200;
        this.overlayClassName = this.getAttribute('data-tk-overlay-class-name') || 'viewport__overlay';
        this.isMobile = window.viewport.clientWidth < this.desktopMinWidth;
        this.isMobileActive = false;
        this.overlay = (0, $2d540709c75492d4$export$2e2bcd8739ae039)(`<div class="${this.overlayClassName}"></div>`);
    }
    connectedCallback() {
        if (!this.currentMenuId) throw new Error('Current menu id is missing!');
        this.registerViewportListener();
        this.registerButtonListener();
        this.registerClickListener();
        this.isMobile && this.switchToMobile();
    }
    registerViewportListener() {
        const onViewportResize = this.handleViewportResize.bind(this);
        this.pushListener({
            event: 'tk-viewport-resize',
            element: window.viewport,
            action: onViewportResize
        });
    }
    handleViewportResize(event) {
        const customEvent = event;
        this.isMobile = customEvent.detail.width < this.desktopMinWidth;
        this.isMobile ? this.switchToMobile() : this.switchToDesktop();
    }
    registerButtonListener() {
        this.openButton?.addEventListener('click', this.openNavigation.bind(this));
        this.closeButton?.addEventListener('click', this.closeNavigation.bind(this));
    }
    registerClickListener() {
        this.addEventListener('click', this.handleClickLink.bind(this));
    }
    openNavigation() {
        this.navigationWrapper ? this.navigationWrapper.classList.add(this.openClassName) : this.classList.add(this.openClassName);
        document.body.insertAdjacentElement('beforeend', this.overlay);
    }
    closeNavigation() {
        this.navigationWrapper ? this.navigationWrapper.classList.remove(this.openClassName) : this.classList.remove(this.openClassName);
        const overlay = document.querySelector(`.${this.overlayClassName}`);
        overlay?.remove();
    }
    async handleClickLink(event) {
        if (!this.isMobile) return;
        event.preventDefault();
        const target = event.target;
        let element;
        if (target.hasAttribute('data-tk-nav-id')) element = target;
        else element = target.closest('[data-tk-nav-id]');
        if (!element) return;
        if (!element.parentElement?.classList.contains(this.hasChildrenClassName) && !element.parentElement?.hasAttribute('data-tk-nav-page')) {
            window.location.href = element.href;
            this.closeNavigation();
            return;
        }
        const id = element.getAttribute('data-tk-nav-id');
        if (!id) return;
        if (this.existPage(id)) {
            const page = this.getPage(id);
            if (!page) return;
            this.insertPage(page.element);
            $40898dd22403025f$export$2e2bcd8739ae039.jumpToPage(page.element);
            this.removeLastPageFromDOM();
        } else {
            const response = await this.getTemplate(id);
            this.responseNextLevel(response);
        }
    }
    getTemplate(id) {
        const url = window.opacc.systemUrls?.async || '/WebPortal/async.aspx';
        const data = {
            type: 'navigation',
            navigationid: id,
            template: this.asyncTemplateName
        };
        return new Promise((resolve, reject)=>{
            (0, $1653b55d89a7adce$export$24835cb787452b46)({
                requestURL: url,
                resolveHandler: (response)=>resolve(response),
                rejectHandler: (error)=>reject(error),
                payload: data
            });
        });
    }
    responseNextLevel(response) {
        if (!response.success) return;
        const html = (0, $2d540709c75492d4$export$2e2bcd8739ae039)(response.dataAsJson.showItems);
        if (!html) return;
        const navigation = html.querySelector('[data-tk-nav-page]');
        if (!navigation) return;
        this.addPage(navigation);
        this.insertPage(navigation);
        $40898dd22403025f$export$2e2bcd8739ae039.jumpToPage(navigation);
        this.removeLastPageFromDOM();
    }
    insertPage(element) {
        const pages = this.querySelector('[data-tk-nav-pages]');
        if (!pages) return;
        pages.insertAdjacentElement('afterbegin', element);
    }
    addPage(element) {
        const id = element.getAttribute('data-tk-nav-page') || '';
        !this.existPage(id) && this.pages.push({
            id: id,
            element: element
        });
    }
    getPage(id) {
        return this.pages.find((page)=>page.id === id);
    }
    existPage(id) {
        if (id === '') return false;
        const foundPage = this.pages.filter((page)=>page.id === id);
        return foundPage.length > 0;
    }
    removeLastPageFromDOM() {
        const pages = this.querySelector('[data-tk-nav-pages]');
        if (!pages) return;
        const pageList = Array.from(pages.children);
        const oldPages = pageList.filter((element)=>element !== pages.firstElementChild);
        oldPages.forEach((element)=>element.remove());
    }
    async switchToMobile() {
        if (this.isMobileActive) return;
        this.isMobileActive = true;
        this.closeButton && (this.closeButton.hidden = false);
        if (!this.wrapper) return;
        this.desktopView = this.wrapper.innerHTML;
        if (!this.mobileView) {
            const response = await this.getTemplate(this.currentMenuId);
            const html = (0, $2d540709c75492d4$export$2e2bcd8739ae039)(response.dataAsJson.showItems);
            if (!html) throw new Error('Burgerlist: Root Element is missing!');
            this.wrapper.replaceChildren(html);
            const navigation = html.querySelector('[data-tk-nav-page]');
            navigation && this.addPage(navigation);
        } else {
            this.wrapper.innerHTML = '';
            this.wrapper.insertAdjacentHTML('afterbegin', this.mobileView);
        }
    }
    async switchToDesktop() {
        if (!this.isMobileActive) return;
        this.isMobileActive = false;
        this.closeButton && (this.closeButton.hidden = true);
        if (!this.wrapper) return;
        this.mobileView = this.wrapper.innerHTML;
        if (!this.desktopView) return;
        this.wrapper.innerHTML = '';
        this.wrapper.insertAdjacentHTML('afterbegin', this.desktopView);
    }
    static jumpToPage(element) {
        element.scrollIntoView(false);
    }
}



class $1352bbad447b1dc9$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super(), this.lastScrollPosY = 0, this.scrollWay = 0;
        this.header = this.querySelector('header') || undefined;
        if (!this.header) throw new Error('Header: Header is missing!');
        this.disableScrolldownBreakpoint = this.getAttribute('data-tk-disable-scrolldown-breakpoint') || 's';
        this.minWidthBreakpoint = window.viewport.breakpoints.get(this.disableScrolldownBreakpoint) || 0;
        this.elementToScrollWith = this.querySelector('[data-tk-to-scroll-with]') || undefined;
        if (!this.elementToScrollWith) throw new Error('Header: Element to scroll with is missing! Use the [data-tk-to-scroll-with] selector.');
        this.maxHeightScrollWith = this.getMaxHeight();
        this.scrollDeltaY = Number(this.getAttribute('data-tk-scroll-delta-y')) || 1;
    }
    connectedCallback() {
        this.registerViewportListener();
        window.viewport.clientWidth < this.minWidthBreakpoint && this.registerScrollListener();
    }
    registerScrollListener() {
        if (!this.elementToScrollWith) return;
        const onScrolldown = this.handleScrolldown.bind(this);
        this.maxHeightScrollWith = this.getMaxHeight();
        this.pushListener({
            event: 'scroll',
            element: window,
            action: onScrolldown
        });
    }
    registerViewportListener() {
        const onViewportResize = this.handleViewportResize.bind(this);
        this.pushListener({
            event: 'tk-viewport-resize',
            element: window.viewport,
            action: onViewportResize
        });
    }
    handleViewportResize(event) {
        const customEvent = event;
        if (customEvent.detail.width < this.minWidthBreakpoint) this.registerScrollListener();
        else this.removeListener(window);
    }
    handleScrolldown(event) {
        if (!(this.header && this.elementToScrollWith)) return;
        const { scrollY: scrollY } = event.currentTarget;
        if (scrollY > this.lastScrollPosY) {
            if (scrollY <= this.maxHeightScrollWith) this.scrollWay = scrollY;
            else this.scrollWay = this.maxHeightScrollWith;
        } else if (this.scrollWay > this.scrollDeltaY) this.scrollWay = this.lastScrollPosY - scrollY >= this.maxHeightScrollWith ? 0 : this.lastScrollPosY - scrollY;
        else this.scrollWay = 0;
        this.elementToScrollWith.style.transform = `translateY(-${this.scrollWay}px)`;
        this.lastScrollPosY = scrollY;
    }
    getMaxHeight() {
        if (!this.elementToScrollWith) return 0;
        const { paddingBottom: paddingBottom } = window.getComputedStyle(this.elementToScrollWith);
        const { height: height } = this.elementToScrollWith.getBoundingClientRect();
        return height - parseInt(paddingBottom, 10);
    }
}



class $49fab39bf1404505$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.resizeEventName = this.getAttribute('data-tk-resize-event-name') || 'tk-viewport-resize';
        this.resizeObserver = new ResizeObserver(this.checkSize.bind(this));
        // * These breakpoints must match the CSS breakpoints, otherwise conflicts may occur.
        this.breakpoints = new Map([
            [
                'xs',
                576
            ],
            [
                's',
                768
            ],
            [
                'm',
                992
            ],
            [
                'l',
                1200
            ],
            [
                'xl',
                1440
            ]
        ]);
        this.currentBreakpoint = this.getCurrentBreakpoint(this.clientWidth);
    }
    connectedCallback() {
        this.resizeObserver.observe(this);
        window.viewport = this;
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        this.resizeObserver.unobserve(this);
    }
    checkSize(entries) {
        entries.forEach(()=>{
            const currentWidth = window.innerWidth;
            const currentBreakpoint = this.getCurrentBreakpoint(currentWidth);
            if (this.currentBreakpoint !== currentBreakpoint) {
                const event = new CustomEvent(this.resizeEventName, {
                    bubbles: true,
                    detail: {
                        width: currentWidth,
                        breakpoint: currentBreakpoint
                    }
                });
                this.currentBreakpoint = currentBreakpoint;
                this.dispatchEvent(event);
            }
        });
    }
    getCurrentBreakpoint(width) {
        let currentBreakpoint = 'xs';
        this.breakpoints.forEach((value, key)=>{
            if (width >= value) currentBreakpoint = key;
        });
        return currentBreakpoint;
    }
}






var $011e7dbf949e9361$var$MessageType = /*#__PURE__*/ function(MessageType) {
    MessageType[MessageType["tooShort"] = 1] = "tooShort";
    MessageType[MessageType["dangerousString"] = 2] = "dangerousString";
    MessageType[MessageType["disallowedCharacters"] = 3] = "disallowedCharacters";
    return MessageType;
}($011e7dbf949e9361$var$MessageType || {});
const $011e7dbf949e9361$var$ALLOWED_CHARACTERS = /[^a-zA-Z0-9 äÄãÃåÅáÁàÀâÂéÉèÈêÊëËöÖóÓòÒôÔõÕüÜúÚùÙûÛìÌíÍîÎïÏñÑøØçÇß',-_.]+/;
class $011e7dbf949e9361$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super(), this.selectorSearch = '[data-tk-search]', this.selectorSearchBackButton = '[data-tk-search-back]', this.selectorSearchResetButton = '[data-tk-search-reset]', this.selectorSearchSubmitButton = '[data-tk-search-submit]', this.selectorSearchFilterElement = '[data-tk-search-filter]', this.selectorSearchResult = '[data-tk-search-result]', this.attributeSearchMinLength = '[data-tk-search-min-input-length]', this.directSearchInputObj = {}, this.timerID = 0, this.searchTermAsUrlParam = true, this.disallowedCharacters = '';
        this.directSearchForm = this.querySelector(this.selectorSearch) || undefined;
        this.directSearchBackButton = this.querySelector(this.selectorSearchBackButton) || undefined;
        this.directSearchResetButton = this.querySelector(this.selectorSearchResetButton) || undefined;
        this.directSearchSubmitButton = this.querySelector(this.selectorSearchSubmitButton) || undefined;
        this.directSearchFilterElement = this.querySelector(this.selectorSearchFilterElement) || undefined;
        this.directSearchResult = this.querySelector(this.selectorSearchResult) || undefined;
        this.directSearchMinLength = Number(this.getAttribute(this.attributeSearchMinLength)) || 3;
        this.activeClassName = this.getAttribute('data-tk-active-class-name') || 'tk-search--active';
        this.activeResultClassName = this.getAttribute('data-tk-active-result-class-name') || 'tk-search--has-data';
        this.tooShortClassName = this.getAttribute('data-tk-too-short-class-name') || 'tk-search__result--too-short';
        this.loadingClassName = this.getAttribute('data-tk-loading-class-name') || 'tk-search__result--loading';
        this.allowedCharactersRegex = RegExp(this.getAttribute('data-tk-allowed-characters') || $011e7dbf949e9361$var$ALLOWED_CHARACTERS);
        if (!this.directSearchForm) throw new Error('TK: Missing Direct-Search');
        this.directSearchInputElement = this.directSearchForm.querySelector('input') || undefined;
        if (!this.directSearchInputElement) throw new Error('TK: Missing Direct-Search-Input');
        if (!this.directSearchResult) throw new Error('TK: Missing Direct-Search Result Wrapper');
        $011e7dbf949e9361$export$2e2bcd8739ae039.replaceToActionUrl();
    }
    connectedCallback() {
        this.registerListener();
    }
    registerListener() {
        if (this.directSearchInputElement) {
            const keyUpEventHandler = this.getSuggest.bind(this);
            const setClassEventHandler = this.setActiveClass.bind(this);
            const submitEventHandler = this.submitSearch.bind(this);
            const focusOutEventHandler = this.focusOut.bind(this);
            this.pushListener({
                event: 'submit',
                element: this.directSearchForm,
                action: submitEventHandler
            });
            this.pushListener({
                event: 'input',
                element: this.directSearchInputElement,
                action: keyUpEventHandler
            });
            this.pushListener({
                event: 'focusin',
                element: this.directSearchInputElement,
                action: setClassEventHandler
            });
            this.pushListener({
                event: 'click',
                element: window,
                action: focusOutEventHandler
            });
        }
        if (this.directSearchBackButton) {
            const navigateBackEventHandler = this.navigateBack.bind(this);
            this.pushListener({
                event: 'click',
                element: this.directSearchBackButton,
                action: navigateBackEventHandler
            });
        }
        if (this.directSearchResetButton) {
            const resetEventHandler = this.resetSearch.bind(this);
            this.pushListener({
                event: 'click',
                element: this.directSearchResetButton,
                action: resetEventHandler
            });
        }
        if (this.directSearchFilterElement) {
            const selectboxEventHandler = this.getSuggest.bind(this);
            this.pushListener({
                event: 'change',
                element: this.directSearchFilterElement,
                action: selectboxEventHandler
            });
        }
    }
    setActiveClass() {
        this.classList.add(this.activeClassName);
    }
    submitSearch(event) {
        if (!this.directSearchForm) return;
        event.preventDefault();
        this.directSearchInputObj = this.validateSearchInput();
        this.modifyDOM();
        if (!this.directSearchInputObj.valid) {
            this.classList.add(this.activeResultClassName);
            if (this.directSearchInputObj.hasDangerousString) this.setErrorMessage(2);
            else if (this.directSearchInputObj.hasDisallowedChars) this.setErrorMessage(3);
            else this.setErrorMessage(1);
            return;
        }
        this.directSearchForm.submit();
    }
    focusOut(event) {
        if (event.pointerId === -1) return;
        const fieldElement = this.directSearchInputElement;
        const resultElement = this.directSearchResult;
        if (!fieldElement || !resultElement) return;
        const fieldElementRect = fieldElement.getBoundingClientRect();
        const resultRect = resultElement.getBoundingClientRect();
        const rectangles = [
            {
                rectangle: fieldElementRect
            },
            {
                rectangle: resultRect
            }
        ];
        if ((0, $7e8cc8975b3fe464$export$dcbd32acb1a13bc6)(event, rectangles)) {
            this.classList.remove(this.activeClassName);
            this.resetSearch();
        }
    }
    setProgressBar() {
        const progressBarTpl = `
        <div class="tk-progress tk-progress--infinite tk-progress--breakout">
            <div class="tk-progress__bar"></div>
        </div>`;
        this.directSearchResult?.insertAdjacentHTML('beforeend', progressBarTpl);
    }
    setErrorMessage(msgType) {
        let message = '';
        switch(msgType){
            case 1:
                message = (0, $86b3c5b6d66bd808$export$f625b980042672da).messageTooShort.text.replace('%1', String(this.directSearchMinLength));
                break;
            case 2:
                message = (0, $86b3c5b6d66bd808$export$f625b980042672da).messageDangerousString.text;
                break;
            case 3:
                message = (0, $86b3c5b6d66bd808$export$f625b980042672da).messageDisallowedCharacter.text.replace('%1', String(this.disallowedCharacters));
                break;
            default:
                break;
        }
        const msgTpl = `
        <div class="tk-message tk-message--info tk-message--breakout">
            <span class="tk-message__icon">
                <i class="tk-icon-info"></i>
            </span>
            <span class="tk-message__label">
                ${message}
            </span>
        </div>`;
        this.directSearchResult?.insertAdjacentHTML('beforeend', msgTpl);
    }
    setMessageTooShort() {
        const msgTpl = `
        <div class="tk-message tk-message--info tk-message--breakout">
            <span class="tk-message__icon">
                <i class="tk-icon-info"></i>
            </span>
            <span class="tk-message__label">
                ${(0, $86b3c5b6d66bd808$export$f625b980042672da).messageTooShort.text.replace('%1', String(this.directSearchMinLength))}
            </span>
        </div>`;
        this.directSearchResult?.insertAdjacentHTML('beforeend', msgTpl);
    }
    getSuggest() {
        if (!this.directSearchResult) return;
        this.directSearchInputObj = this.validateSearchInput();
        this.modifyDOM();
        if (!this.directSearchInputObj.valid) {
            this.classList.add(this.activeResultClassName);
            if (this.directSearchInputObj.hasDangerousString) this.setErrorMessage(2);
            else if (this.directSearchInputObj.hasDisallowedChars) this.setErrorMessage(3);
            else this.setErrorMessage(1);
            return;
        }
        this.resetResultList();
        this.timerID && clearTimeout(this.timerID);
        this.timerID = window.setTimeout(()=>{
            // append Progress-Bar
            this.setProgressBar();
            const searchData = this.setDataForRequest();
            const data = Object.fromEntries(Object.entries(searchData));
            const url = (0, $1653b55d89a7adce$export$a4101276b4831ec4)();
            (0, $1653b55d89a7adce$export$24835cb787452b46)({
                requestURL: url,
                resolveHandler: this.getDirectSearchSuggestDataFromResult.bind(this),
                payload: data
            });
        }, 500);
    }
    setDataForRequest() {
        const retVal = {
            type: 'directsearchsuggest',
            inputValue: encodeURIComponent(this.directSearchInputObj.value),
            filterAttribute: this.directSearchFilterElement?.dataset.tkSearchFilterAttribute,
            filterValue: this.directSearchFilterElement?.value
        };
        if (!this.directSearchFilterElement) {
            delete retVal.filterAttribute;
            delete retVal.filterValue;
        }
        return retVal;
    }
    getDirectSearchSuggestDataFromResult(response) {
        if (!this.directSearchResult) return;
        this.classList.add(this.activeResultClassName);
        this.directSearchResult.innerHTML = response.dataAsJson.html;
    }
    modifyDOM() {
        const classListObj = $011e7dbf949e9361$export$2e2bcd8739ae039.clearClassListObj();
        classListObj.push({
            element: this,
            className: this.activeClassName
        }, {
            element: this,
            className: this.activeResultClassName
        });
        if (this.directSearchInputObj.valid) $011e7dbf949e9361$export$2e2bcd8739ae039.addClassList(classListObj);
        else this.resetResultList();
    }
    static clearClassListObj() {
        const classListObj = [];
        return classListObj;
    }
    static addClassList(items) {
        items.forEach((item)=>{
            item.element?.classList.add(item.className);
        });
    }
    static removeClassList(items) {
        items.forEach((item)=>{
            item.element?.classList.remove(item.className);
        });
    }
    resetResultList() {
        this.directSearchResult?.replaceChildren();
    }
    navigateBack() {
        const classListObj = $011e7dbf949e9361$export$2e2bcd8739ae039.clearClassListObj();
        classListObj.push({
            element: this,
            className: this.activeClassName
        });
        $011e7dbf949e9361$export$2e2bcd8739ae039.removeClassList(classListObj);
    }
    resetSearch() {
        const classListObj = $011e7dbf949e9361$export$2e2bcd8739ae039.clearClassListObj();
        classListObj.push({
            element: this,
            className: this.activeClassName
        }, {
            element: this,
            className: this.activeResultClassName
        });
        this.resetResultList();
        $011e7dbf949e9361$export$2e2bcd8739ae039.removeClassList(classListObj);
        this.directSearchForm?.reset();
    }
    static replaceToActionUrl() {
        const actionUrl = localStorage.getItem('searchActionUrl') ? new URL(localStorage.getItem('searchActionUrl')) : undefined;
        if (actionUrl && actionUrl.pathname === window.location.pathname) window.history.replaceState(null, 'searchActionUrl', actionUrl);
        if (actionUrl) localStorage.removeItem('searchActionUrl');
    }
    validateSearchInput() {
        const value = this.directSearchInputElement?.value.trim() || '';
        const minLength = Number(this.getAttribute('data-tk-search-min-input-length') || 3);
        const hasDangerousString = value?.includes('<');
        const hasDisallowedChars = this.hasDisallowedCharacters(value);
        return {
            minimum: minLength,
            value: value,
            valid: value.length >= minLength && !hasDangerousString && !hasDisallowedChars,
            hasDangerousString: hasDangerousString,
            hasDisallowedChars: hasDisallowedChars
        };
    }
    hasDisallowedCharacters(value) {
        if (!value) {
            this.disallowedCharacters = '';
            return false;
        }
        const character = value.match(this.allowedCharactersRegex)?.at(0) ?? '';
        this.disallowedCharacters = character;
        return Boolean(character);
    }
}








var $fd4fdaa8be3050bd$export$eb1b84084436143e = /*#__PURE__*/ function(BasketAction) {
    BasketAction["FETCHING"] = "fetching";
    BasketAction["REFRESHED_LIST"] = "refreshed-list";
    BasketAction["REFRESHED_BASKET"] = "refreshed-basket";
    return BasketAction;
}({});
class $fd4fdaa8be3050bd$export$2e2bcd8739ae039 {
    constructor(component){
        this.listeners = [];
        this.component = component;
        this.componentSelector = `.${this.component.classList.value}`;
        this.basketList = document.querySelector('[data-tk-basket-list]') || undefined;
        this.totalAmount = document.querySelector('[data-tk-basket-total-amount]') || undefined;
        this.miniBasket = document.querySelector('[data-tk-minibasket]') || undefined;
        this.emptyClassName = this.basketList?.getAttribute('data-tk-basket-empty-class-name') || 'module-basket--empty';
    }
    subscribe(listener) {
        this.listeners.push(listener);
    }
    emit(data) {
        this.listeners.forEach((listener)=>{
            listener(data);
        });
    }
    fetch(checkForReadonlyContext = false) {
        const url = (0, $1653b55d89a7adce$export$a4101276b4831ec4)(checkForReadonlyContext);
        this.emit({
            action: "fetching"
        });
        (0, $1653b55d89a7adce$export$24835cb787452b46)({
            requestURL: url,
            resolveHandler: this.refreshResultList.bind(this),
            payload: this.prepareDataSubmission()
        });
    }
    prepareDataSubmission() {
        const { tkAction: tkAction, tkModule: tkModule, tkArtInternalno: tkArtInternalno, tkSalDocItemBoId: tkSalDocItemBoId, tkSalDocBoId: tkSalDocBoId, tkAddAllOptions: tkAddAllOptions, tkVariant: tkVariant, tkQuantityId1: tkQuantityId1, tkQuantityId2: tkQuantityId2, tkQuantityId3: tkQuantityId3, tkAsyncTemplate: tkAsyncTemplate, tkRequest: tkRequest, tkEncrypted: tkEncrypted } = this.component.dataset;
        const data = {
            type: 'basket',
            action: tkAction,
            module: tkModule,
            originalUrl: window.location.href
        };
        tkArtInternalno && (data.artInternalNo = tkArtInternalno);
        tkSalDocItemBoId && (data.salDocItemBoId = tkSalDocItemBoId);
        tkSalDocBoId && (data.salDocBoId = tkSalDocBoId);
        tkAddAllOptions && (data.addalloptions = tkAddAllOptions);
        tkVariant && (data.artDimVariantNo = tkVariant);
        tkQuantityId1 && (data.catItemQuantityDim1 = this.getButtonDimValue(tkQuantityId1));
        tkQuantityId2 && (data.catItemQuantityDim2 = this.getButtonDimValue(tkQuantityId2));
        tkQuantityId3 && (data.catItemQuantityDim3 = this.getButtonDimValue(tkQuantityId3));
        tkAsyncTemplate && (data.template = tkAsyncTemplate);
        tkRequest && (data.request = tkRequest);
        tkEncrypted && (data.encrypted = tkEncrypted);
        Object.keys(this.component.dataset).filter((key)=>key.startsWith('tkSaldocitem.')).forEach((key)=>{
            data[key.substring(2).toLowerCase()] = this.component.dataset[key];
        });
        if (tkAction === 'addall') {
            const quantities = $fd4fdaa8be3050bd$export$2e2bcd8739ae039.getQuantitiesFromPositions();
            quantities !== '{}' && (data.addall = quantities);
        }
        return data;
    }
    static getQuantitiesFromPositions() {
        const quantities = {};
        const articleList = document.querySelector('[data-tk-basket-add-all-wrapper]');
        const articles = articleList?.querySelectorAll('article');
        articles?.forEach((article)=>{
            const id = article.getAttribute('data-tk-item-number');
            if (!id) return;
            const basketButton = article.querySelector('[data-tk-basket-button]');
            if (!basketButton) return;
            const dimensions = basketButton.querySelectorAll('[data-tk-dimension]:not([hidden])');
            dimensions.forEach((dimension)=>{
                const dimensionNumber = dimension.getAttribute('data-tk-dimension') || '';
                const fieldElement = dimension.querySelector('[data-tk-input-quantity]');
                quantities[`position${id}${dimensionNumber}`] = fieldElement?.value || '0';
            });
        });
        return JSON.stringify(quantities);
    }
    getButtonDimValue(dimNumIdVal) {
        let retVal = '';
        const dim = this.component.querySelector(`[data-tk-dim-id="${dimNumIdVal}"]`);
        if (!dim) return retVal;
        const input = dim.querySelector('[data-tk-input-quantity]');
        if (!input) return retVal;
        let value = Number(input.value);
        const defaultValue = Number(input.min) || 1;
        if (dim.hidden) return retVal;
        if (Number.isNaN(value) || value <= 0) {
            value = defaultValue;
            retVal = String(defaultValue);
        } else retVal = String(value);
        return retVal;
    }
    getButtonDimUnit(dimNumIdVal) {
        let unit = '';
        const dim = this.component.querySelector(`[data-tk-dim-id="${dimNumIdVal}"]`);
        if (!dim) return unit;
        if (dim.hidden) return unit;
        const unitElement = dim.querySelector('[data-tk-basket-dim-unit]');
        if (!unitElement) return unit;
        unit = unitElement.innerText;
        return unit;
    }
    refreshResultList(response) {
        this.emit({
            action: "refreshed-list",
            data: response.dataAsJson
        });
        if (!response.success) return;
        this.updateMiniBasket(response.dataAsJson);
        this.updateBasket(response.dataAsJson);
        if (response.dataAsJson.action === 'added') (0, $1221feb2184dfefe$export$146c7c7e50ed1bd2)(this.getQuantityMessage());
        const { action: action } = response.dataAsJson;
        this.updateCartTracker(action);
    }
    updateMiniBasket(data) {
        this.miniBasket?.dispatchEvent(this.miniBasket.updateEvent);
        this.miniBasket?.setAttribute('data-count', `${data.quantity}`);
    }
    updateBasket(data) {
        if (!this.basketList) return;
        const { tkAction: tkAction } = this.component.dataset;
        if (tkAction === 'delete' || tkAction === 'deleteall') {
            if (data.quantity === 0) window.location.reload();
            else {
                const basketPos = this.basketList.querySelector(`[data-tk-internalno="${this.component.dataset.tkInternalno}"]`) || this.component.closest('[data-tk-basket-item]');
                if (basketPos) basketPos.remove();
            }
        } else if (tkAction === 'change') {
            // update item price and amount
            const price = this.component.closest('[data-tk-basket-item]')?.querySelector('[data-tk-basket-item-price]');
            if (price) price.innerHTML = `${data.currency} ${data.itemPrice}`;
            const amount = this.component.closest('[data-tk-basket-item]')?.querySelector('[data-tk-basket-item-amount]');
            if (!amount) return;
            amount.innerHTML = `${data.currency} ${data.itemAmount}`;
        } else if (this.component.closest('tk-quick-order')) {
            // update after quickorder
            const quickorder = this.component.closest('tk-quick-order');
            if (!quickorder) return;
            (0, $1653b55d89a7adce$export$24835cb787452b46)({
                requestURL: quickorder.dataset.tkUrlRefresh || window.location.href,
                resolveHandler: this.refreshBasketList.bind(this)
            });
        }
        // update total amount and VAT
        if (this.totalAmount) this.totalAmount.innerHTML = `${data.currency} ${data.totalAmount}`;
        const totalVat = this.basketList.querySelector('[data-tk-basket-total-vat]');
        if (totalVat) totalVat.innerHTML = `${data.currency} ${data.totalVat}`;
        this.emit({
            action: "refreshed-basket"
        });
    }
    refreshBasketList(response) {
        if (!response || !response.success || !this.basketList) return;
        const html = (0, $2d540709c75492d4$export$2e2bcd8739ae039)(response.dataAsHtml);
        const basketListWrapper = html.querySelector('[data-tk-basket-list]');
        basketListWrapper && (this.basketList.innerHTML = basketListWrapper.innerHTML);
        this.basketList.classList.remove(this.emptyClassName);
        const existDeleteAllButton = document.querySelector('[data-tk-basket-list-actions] > tk-basket-button');
        if (!existDeleteAllButton) {
            const basketHeaderActionWrapper = document.querySelector('[data-tk-basket-list-actions]');
            const deleteAllButton = html.querySelector('[data-tk-basket-list-actions] > tk-basket-button');
            deleteAllButton && basketHeaderActionWrapper?.insertAdjacentElement('beforeend', deleteAllButton);
        }
        const footer = document.querySelector('[data-tk-basket-list-footer]');
        if (!footer) {
            const footerWrapper = html.querySelector('[data-tk-basket-list-footer]');
            footerWrapper && this.basketList.insertAdjacentElement('afterend', footerWrapper);
        }
    }
    static quantityChanger(event) {
        const target = event.target;
        const currentTarget = event.currentTarget;
        if (!target || !target.parentElement) return;
        let wrapper = null;
        wrapper = target.closest('[data-tk-counter]');
        if (!wrapper) wrapper = target.closest('[data-tk-dimension]');
        if (!wrapper) return;
        const decrementButton = wrapper.querySelector('[data-tk-counter-decreaser]');
        const incrementButton = wrapper.querySelector('[data-tk-counter-increaser]');
        const inputField = wrapper.querySelector('[data-tk-input-quantity]');
        if (!inputField) return;
        const step = Number(inputField.getAttribute('step') || 1);
        const min = Number(inputField.getAttribute('min') || step);
        const max = Number(inputField.getAttribute('max') || 0);
        const isMaxSet = max > 0;
        const { tkArtDimCheckCd: tkArtDimCheckCd } = inputField.dataset;
        const artDimCheck = tkArtDimCheckCd ? Number(tkArtDimCheckCd) : 0;
        const oldValue = Number(inputField.value || 0);
        let hasChanged = false;
        let operator = '+';
        if (incrementButton && target === incrementButton) {
            operator = '+';
            if (oldValue < min) operator = '-';
        } else if (decrementButton && target === decrementButton) {
            operator = '-';
            if (oldValue > max && isMaxSet) operator = '+';
        }
        if (event.key === 'ENTER') {
            if (oldValue > max) operator = '+';
            else if (oldValue < min) operator = '-';
        }
        if (artDimCheck > 0) {
            const multiplikator = $fd4fdaa8be3050bd$export$2e2bcd8739ae039.countDecimals(step);
            const currentValPow = oldValue * 10 ** multiplikator;
            const stepPow = step * 10 ** multiplikator;
            if ((currentValPow === 0 || currentValPow % stepPow !== 0) && oldValue >= min) {
                const result = (currentValPow + stepPow - currentValPow % stepPow) / 10 ** multiplikator;
                (0, $1221feb2184dfefe$export$3a57e165650c636f)((0, $1221feb2184dfefe$export$9130146a86a85749).ERROR, (0, $86b3c5b6d66bd808$export$7ea287b8bcd34b91).stepMismatch.replace('{currentValue}', String(oldValue)).replace('{newValue}', String(result)).replace('{step}', String(step)));
                operator = '+';
            }
        }
        if (currentTarget === decrementButton || currentTarget === incrementButton) hasChanged = $fd4fdaa8be3050bd$export$2e2bcd8739ae039.setCalculatedQuantityField(oldValue, inputField, step, min, max, operator);
        return hasChanged;
    }
    getQuantityMessage() {
        const message = {
            ...(0, $86b3c5b6d66bd808$export$287bafa924522a4d).messageAddedToBasket
        };
        const { tkQuantityId1: tkQuantityId1, tkQuantityId2: tkQuantityId2, tkQuantityId3: tkQuantityId3 } = this.component.dataset;
        const dim1Value = this.getButtonDimValue(tkQuantityId1 || '');
        const dim1Unit = this.getButtonDimUnit(tkQuantityId1 || '');
        const dim2Value = this.getButtonDimValue(tkQuantityId2 || '');
        const dim2Unit = this.getButtonDimUnit(tkQuantityId2 || '');
        const dim3Value = this.getButtonDimValue(tkQuantityId3 || '');
        const dim3Unit = this.getButtonDimUnit(tkQuantityId3 || '');
        let quantity = `${dim1Value} ${dim1Unit} `;
        if (dim2Value) quantity = `${quantity}x ${dim2Value} ${dim2Unit} `;
        if (dim3Value) quantity = `${quantity}x ${dim3Value} ${dim3Unit} `;
        message.text = quantity + (0, $86b3c5b6d66bd808$export$287bafa924522a4d).messageAddedToBasket.text;
        return message;
    }
    updateCartTracker(action) {
        const urlElement = document.querySelector('[data-tk-basket-tracker]');
        const url = urlElement?.getAttribute('data-tk-url');
        if (!url) return;
        (0, $1653b55d89a7adce$export$24835cb787452b46)({
            requestURL: url,
            resolveHandler: this.handleCartTracker.bind(this, action)
        });
    }
    handleCartTracker(action, response) {
        if (!response || !response.dataAsJson) return;
        const { items: items, data: data } = response.dataAsJson;
        const trackerElement = document.querySelector('[data-tk-tracker-wrapper]');
        trackerElement?.dispatchEvent(new CustomEvent('tk-tracking-push', {
            detail: {
                type: (0, $588d148f2c9ac202$export$4120f82005ec4b2d).BASKET_UPDATE,
                item: {
                    event: action,
                    location: window.location.href,
                    currency: data.currency,
                    value: data.totalAmount,
                    items: items
                }
            }
        }));
    }
    static setCalculatedQuantityField(currentVal, fieldElement, step, min, max = 0, operator = '+') {
        const multiplikator = $fd4fdaa8be3050bd$export$2e2bcd8739ae039.countDecimals(step);
        const currentValPow = currentVal * 10 ** multiplikator;
        const stepPow = step * 10 ** multiplikator;
        const minPow = min * 10 ** multiplikator;
        const maxPow = max * 10 ** multiplikator;
        let newValuePow = currentValPow;
        const { tkArtDimCheckCd: tkArtDimCheckCd } = fieldElement.dataset;
        const artDimCheck = Number(tkArtDimCheckCd);
        const operatorHandler = {
            '-': ()=>$fd4fdaa8be3050bd$export$2e2bcd8739ae039.calcMinus(currentVal, newValuePow, stepPow, minPow, min, Number(artDimCheck)),
            '+': ()=>$fd4fdaa8be3050bd$export$2e2bcd8739ae039.calcPlus(currentVal, newValuePow, stepPow, maxPow, max, Number(artDimCheck))
        };
        newValuePow = operatorHandler[operator]();
        // Wert veraendert und Step beruecksichtigt?
        if (newValuePow !== currentValPow) {
            if (newValuePow % stepPow === 0 || artDimCheck === 0) {
                fieldElement.value = String(newValuePow / 10 ** multiplikator);
                return true;
            }
            newValuePow = currentValPow;
            (0, $1221feb2184dfefe$export$3a57e165650c636f)((0, $1221feb2184dfefe$export$9130146a86a85749).ERROR, (0, $86b3c5b6d66bd808$export$7ea287b8bcd34b91).stepMismatch.replace('{step}', String(step)));
        }
        return false;
    }
    static calcPlus(currentValPow, newValuePow, stepPow, maxPow, max, artDimCheck) {
        if (maxPow > 0 && newValuePow > maxPow) {
            (0, $1221feb2184dfefe$export$3a57e165650c636f)((0, $1221feb2184dfefe$export$9130146a86a85749).ERROR, (0, $86b3c5b6d66bd808$export$7ea287b8bcd34b91).rangeOverflow.replace('{max}', String(max)));
            return maxPow;
        }
        return currentValPow + stepPow - (artDimCheck > 0 ? currentValPow % stepPow : 0);
    }
    static calcMinus(currentValPow, newValuePow, stepPow, minPow, min, artDimCheck) {
        if (newValuePow < minPow) {
            (0, $1221feb2184dfefe$export$3a57e165650c636f)((0, $1221feb2184dfefe$export$9130146a86a85749).ERROR, (0, $86b3c5b6d66bd808$export$7ea287b8bcd34b91).rangeOverflow.replace('{min}', String(min)));
            return minPow;
        }
        const adjustment = artDimCheck === 0 || currentValPow % stepPow === 0 ? stepPow : currentValPow % stepPow;
        return currentValPow - adjustment;
    }
    static countDecimals(value) {
        if (Math.floor(value) === value) return 0;
        return value.toString().split('.')[1].length || 0;
    }
}




var $127c03b03da38c7a$export$416096e8140b15df = /*#__PURE__*/ function(BasketActionTypes) {
    BasketActionTypes["ADD"] = "add";
    BasketActionTypes["CHANGE"] = "change";
    BasketActionTypes["DELETE"] = "delete";
    BasketActionTypes["ADD_ALL"] = "addall";
    BasketActionTypes["DELETE_ALL"] = "deleteall";
    return BasketActionTypes;
}({});
class $127c03b03da38c7a$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.basketAction = new (0, $fd4fdaa8be3050bd$export$2e2bcd8739ae039)(this);
        this.action = this.getAttribute('data-tk-action') || "add";
        this.button = this.querySelector('[data-tk-basket-button]') || undefined;
        this.counterWrapper = this.querySelector('[data-tk-counter]') || undefined;
        this.variantWrapper = this.querySelector('[data-tk-basket-variants]') || undefined;
        if (this.counterWrapper) {
            this.decreaser = this.querySelector('[data-tk-counter-decreaser]') || undefined;
            this.increaser = this.querySelector('[data-tk-counter-increaser]') || undefined;
            this.counter = this.querySelector('[data-tk-input-quantity]') || undefined;
            this.counters = this.querySelectorAll('[data-tk-input-quantity]');
        }
    }
    connectedCallback() {
        if (!this.button) throw new Error('Basket: Button is missing!');
        this.registerClickListener();
        this.counterWrapper && this.registerCounter();
        this.registerBasketListener();
        this.variantWrapper && this.registerVariantListener();
    }
    registerClickListener() {
        const onClick = this.handleBasketClick.bind(this);
        this.pushListener({
            event: 'click',
            element: this.button,
            action: onClick
        });
    }
    registerVariantListener() {
        const onInput = this.updateDimensions.bind(this);
        const fieldElement = this.variantWrapper?.querySelector('input[type="hidden"]');
        fieldElement && this.pushListener({
            event: 'change',
            element: fieldElement,
            action: onInput
        });
    }
    registerCounter() {
        if (!this.decreaser || !this.increaser) return;
        if (this.action === "change") {
            const onChange = this.change.bind(this);
            this.pushListener({
                event: 'click',
                element: this.decreaser,
                action: onChange
            });
            this.pushListener({
                event: 'click',
                element: this.increaser,
                action: onChange
            });
            this.counters?.forEach((counter)=>{
                this.pushListener({
                    event: 'change',
                    element: counter,
                    action: onChange
                });
            });
        } else {
            const onDecrease = this.decrease.bind(this);
            this.pushListener({
                event: 'click',
                element: this.decreaser,
                action: onDecrease
            });
            const onIncrease = this.increase.bind(this);
            this.pushListener({
                event: 'click',
                element: this.increaser,
                action: onIncrease
            });
        }
    }
    registerBasketListener() {
        this.basketAction.subscribe((event)=>{
            const basketActionHandler = {
                fetching: ()=>{},
                'refreshed-list': ()=>event.data && this.closeDialog(event.data),
                'refreshed-basket': ()=>{}
            };
            basketActionHandler[event.action]();
        });
    }
    closeDialog(data) {
        this.button.disabled = false;
        if (!data.success) return;
        const dialog = this.closest('dialog');
        if (!dialog) return;
        dialog.close();
    }
    handleBasketClick() {
        this.button.disabled = true;
        this.validateQuantity();
        this.basketAction.fetch(false);
    }
    increase() {
        if (!this.counter || !this.increaser) return;
        const { step: step, max: max, value: value } = this.counter;
        const valueNumber = Number(value);
        if (Number(max) !== 0 && valueNumber >= Number(max)) return;
        this.counter.value = String(valueNumber + (Number(step) || 1));
    }
    decrease() {
        if (!this.counter || !this.decreaser) return;
        const { step: step, min: min, value: value } = this.counter;
        const valueNumber = Number(value);
        if (valueNumber <= (Number(min) || 1)) return;
        this.counter.value = String(valueNumber - (Number(step) || 1));
    }
    change(event) {
        (0, $fd4fdaa8be3050bd$export$2e2bcd8739ae039).quantityChanger(event);
        this.timer && clearTimeout(this.timer);
        this.timer = setTimeout(()=>{
            this.button?.click();
        }, 500);
    }
    validateQuantity() {
        const shouldCheckDimension = this.counter?.getAttribute('data-tk-art-dim-check-cd') === '1';
        if (!shouldCheckDimension || !this.counter) return;
        const step = Number(this.counter.step) || 1;
        const currentValue = Number(this.counter.value) || 1;
        const max = Number(this.counter.max);
        const min = Number(this.counter.min);
        if (currentValue % step === 0) return;
        let result = Math.ceil(currentValue / step) * step;
        if (min > 0 && result < min) result += step;
        if (max > 0 && result > max) result -= step;
        this.counter.value = String(result);
        (0, $1221feb2184dfefe$export$3a57e165650c636f)((0, $1221feb2184dfefe$export$9130146a86a85749).WARNING, (0, $86b3c5b6d66bd808$export$7ea287b8bcd34b91).stepAdjust.replace('{currentValue}', String(currentValue)).replace('{newValue}', String(result)).replace('{step}', String(step)));
    }
    updateDimensions(event) {
        const selectedVariant = event.target;
        const getDimensionValue = (dimension)=>selectedVariant.getAttribute(`data-tk-${dimension}-value`) || '0';
        const getDimensionName = (dimension)=>selectedVariant.getAttribute(`data-tk-${dimension}-name`) || '';
        const getDimensionUnit = (dimension)=>selectedVariant.getAttribute(`data-tk-${dimension}-unit`) || '';
        const getDimensionMin = ()=>Number(selectedVariant.getAttribute('data-tk-min'));
        const getDimensionMax = ()=>Number(selectedVariant.getAttribute('data-tk-max'));
        const getDimensionStep = ()=>Number(selectedVariant.getAttribute('data-tk-step'));
        const getDimensionCheckCd = ()=>selectedVariant.getAttribute('data-tk-art-dim-check-cd') || '';
        const setDimension = (wrapper, dimension)=>{
            const value = getDimensionValue(dimension);
            const fieldElement = wrapper.querySelector('[data-tk-input-quantity]');
            const nameElement = wrapper.querySelector('[data-tk-basket-dim-unit-name]');
            const unitElements = wrapper.querySelectorAll('[data-tk-basket-dim-unit]');
            if (!fieldElement) return;
            fieldElement.value = value !== '0' ? value : '';
            fieldElement.setAttribute('data-tk-art-dim-check-cd', getDimensionCheckCd());
            if (getDimensionMin() > 0) fieldElement.setAttribute('min', String(getDimensionMin()));
            else fieldElement.removeAttribute('min');
            if (getDimensionMax() > 0) fieldElement.setAttribute('max', String(getDimensionMax()));
            else fieldElement.removeAttribute('max');
            if (getDimensionStep() > 0) fieldElement.setAttribute('step', String(getDimensionStep()));
            else fieldElement.removeAttribute('step');
            nameElement && (nameElement.textContent = getDimensionName(dimension));
            unitElements.forEach((element)=>{
                element.textContent = getDimensionUnit(dimension);
            });
        };
        const dimensionWrappers = this.querySelectorAll('[data-tk-dimension]:not([hidden])');
        dimensionWrappers.forEach((wrapper)=>{
            const dimension = wrapper.getAttribute('data-tk-dimension');
            dimension && setDimension(wrapper, dimension);
        });
        this.setAttribute('data-tk-variant', selectedVariant.value);
    }
}


function $f844812df082fc15$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $f844812df082fc15$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $f844812df082fc15$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $f844812df082fc15$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
/*!
 * Splide.js
 * Version  : 4.1.4
 * License  : MIT
 * Copyright: 2022 Naotoshi Fujita
 */ var $f844812df082fc15$var$MEDIA_PREFERS_REDUCED_MOTION = "(prefers-reduced-motion: reduce)";
var $f844812df082fc15$var$CREATED = 1;
var $f844812df082fc15$var$MOUNTED = 2;
var $f844812df082fc15$var$IDLE = 3;
var $f844812df082fc15$var$MOVING = 4;
var $f844812df082fc15$var$SCROLLING = 5;
var $f844812df082fc15$var$DRAGGING = 6;
var $f844812df082fc15$var$DESTROYED = 7;
var $f844812df082fc15$var$STATES = {
    CREATED: $f844812df082fc15$var$CREATED,
    MOUNTED: $f844812df082fc15$var$MOUNTED,
    IDLE: $f844812df082fc15$var$IDLE,
    MOVING: $f844812df082fc15$var$MOVING,
    SCROLLING: $f844812df082fc15$var$SCROLLING,
    DRAGGING: $f844812df082fc15$var$DRAGGING,
    DESTROYED: $f844812df082fc15$var$DESTROYED
};
function $f844812df082fc15$var$empty(array) {
    array.length = 0;
}
function $f844812df082fc15$var$slice(arrayLike, start, end) {
    return Array.prototype.slice.call(arrayLike, start, end);
}
function $f844812df082fc15$var$apply(func) {
    return func.bind.apply(func, [
        null
    ].concat($f844812df082fc15$var$slice(arguments, 1)));
}
var $f844812df082fc15$var$nextTick = setTimeout;
var $f844812df082fc15$var$noop = function noop() {};
function $f844812df082fc15$var$raf(func) {
    return requestAnimationFrame(func);
}
function $f844812df082fc15$var$typeOf(type, subject) {
    return typeof subject === type;
}
function $f844812df082fc15$var$isObject(subject) {
    return !$f844812df082fc15$var$isNull(subject) && $f844812df082fc15$var$typeOf("object", subject);
}
var $f844812df082fc15$var$isArray = Array.isArray;
var $f844812df082fc15$var$isFunction = $f844812df082fc15$var$apply($f844812df082fc15$var$typeOf, "function");
var $f844812df082fc15$var$isString = $f844812df082fc15$var$apply($f844812df082fc15$var$typeOf, "string");
var $f844812df082fc15$var$isUndefined = $f844812df082fc15$var$apply($f844812df082fc15$var$typeOf, "undefined");
function $f844812df082fc15$var$isNull(subject) {
    return subject === null;
}
function $f844812df082fc15$var$isHTMLElement(subject) {
    try {
        return subject instanceof (subject.ownerDocument.defaultView || window).HTMLElement;
    } catch (e) {
        return false;
    }
}
function $f844812df082fc15$var$toArray(value) {
    return $f844812df082fc15$var$isArray(value) ? value : [
        value
    ];
}
function $f844812df082fc15$var$forEach(values, iteratee) {
    $f844812df082fc15$var$toArray(values).forEach(iteratee);
}
function $f844812df082fc15$var$includes(array, value) {
    return array.indexOf(value) > -1;
}
function $f844812df082fc15$var$push(array, items) {
    array.push.apply(array, $f844812df082fc15$var$toArray(items));
    return array;
}
function $f844812df082fc15$var$toggleClass(elm, classes, add) {
    if (elm) $f844812df082fc15$var$forEach(classes, function(name) {
        if (name) elm.classList[add ? "add" : "remove"](name);
    });
}
function $f844812df082fc15$var$addClass(elm, classes) {
    $f844812df082fc15$var$toggleClass(elm, $f844812df082fc15$var$isString(classes) ? classes.split(" ") : classes, true);
}
function $f844812df082fc15$var$append(parent, children) {
    $f844812df082fc15$var$forEach(children, parent.appendChild.bind(parent));
}
function $f844812df082fc15$var$before(nodes, ref) {
    $f844812df082fc15$var$forEach(nodes, function(node) {
        var parent = (ref || node).parentNode;
        if (parent) parent.insertBefore(node, ref);
    });
}
function $f844812df082fc15$var$matches(elm, selector) {
    return $f844812df082fc15$var$isHTMLElement(elm) && (elm["msMatchesSelector"] || elm.matches).call(elm, selector);
}
function $f844812df082fc15$var$children(parent, selector) {
    var children2 = parent ? $f844812df082fc15$var$slice(parent.children) : [];
    return selector ? children2.filter(function(child) {
        return $f844812df082fc15$var$matches(child, selector);
    }) : children2;
}
function $f844812df082fc15$var$child(parent, selector) {
    return selector ? $f844812df082fc15$var$children(parent, selector)[0] : parent.firstElementChild;
}
var $f844812df082fc15$var$ownKeys = Object.keys;
function $f844812df082fc15$var$forOwn(object, iteratee, right) {
    if (object) (right ? $f844812df082fc15$var$ownKeys(object).reverse() : $f844812df082fc15$var$ownKeys(object)).forEach(function(key) {
        key !== "__proto__" && iteratee(object[key], key);
    });
    return object;
}
function $f844812df082fc15$var$assign(object) {
    $f844812df082fc15$var$slice(arguments, 1).forEach(function(source) {
        $f844812df082fc15$var$forOwn(source, function(value, key) {
            object[key] = source[key];
        });
    });
    return object;
}
function $f844812df082fc15$var$merge(object) {
    $f844812df082fc15$var$slice(arguments, 1).forEach(function(source) {
        $f844812df082fc15$var$forOwn(source, function(value, key) {
            if ($f844812df082fc15$var$isArray(value)) object[key] = value.slice();
            else if ($f844812df082fc15$var$isObject(value)) object[key] = $f844812df082fc15$var$merge({}, $f844812df082fc15$var$isObject(object[key]) ? object[key] : {}, value);
            else object[key] = value;
        });
    });
    return object;
}
function $f844812df082fc15$var$omit(object, keys) {
    $f844812df082fc15$var$forEach(keys || $f844812df082fc15$var$ownKeys(object), function(key) {
        delete object[key];
    });
}
function $f844812df082fc15$var$removeAttribute(elms, attrs) {
    $f844812df082fc15$var$forEach(elms, function(elm) {
        $f844812df082fc15$var$forEach(attrs, function(attr) {
            elm && elm.removeAttribute(attr);
        });
    });
}
function $f844812df082fc15$var$setAttribute(elms, attrs, value) {
    if ($f844812df082fc15$var$isObject(attrs)) $f844812df082fc15$var$forOwn(attrs, function(value2, name) {
        $f844812df082fc15$var$setAttribute(elms, name, value2);
    });
    else $f844812df082fc15$var$forEach(elms, function(elm) {
        $f844812df082fc15$var$isNull(value) || value === "" ? $f844812df082fc15$var$removeAttribute(elm, attrs) : elm.setAttribute(attrs, String(value));
    });
}
function $f844812df082fc15$var$create(tag, attrs, parent) {
    var elm = document.createElement(tag);
    if (attrs) $f844812df082fc15$var$isString(attrs) ? $f844812df082fc15$var$addClass(elm, attrs) : $f844812df082fc15$var$setAttribute(elm, attrs);
    parent && $f844812df082fc15$var$append(parent, elm);
    return elm;
}
function $f844812df082fc15$var$style(elm, prop, value) {
    if ($f844812df082fc15$var$isUndefined(value)) return getComputedStyle(elm)[prop];
    if (!$f844812df082fc15$var$isNull(value)) elm.style[prop] = "" + value;
}
function $f844812df082fc15$var$display(elm, display2) {
    $f844812df082fc15$var$style(elm, "display", display2);
}
function $f844812df082fc15$var$focus(elm) {
    elm["setActive"] && elm["setActive"]() || elm.focus({
        preventScroll: true
    });
}
function $f844812df082fc15$var$getAttribute(elm, attr) {
    return elm.getAttribute(attr);
}
function $f844812df082fc15$var$hasClass(elm, className) {
    return elm && elm.classList.contains(className);
}
function $f844812df082fc15$var$rect(target) {
    return target.getBoundingClientRect();
}
function $f844812df082fc15$var$remove(nodes) {
    $f844812df082fc15$var$forEach(nodes, function(node) {
        if (node && node.parentNode) node.parentNode.removeChild(node);
    });
}
function $f844812df082fc15$var$parseHtml(html) {
    return $f844812df082fc15$var$child(new DOMParser().parseFromString(html, "text/html").body);
}
function $f844812df082fc15$var$prevent(e, stopPropagation) {
    e.preventDefault();
    if (stopPropagation) {
        e.stopPropagation();
        e.stopImmediatePropagation();
    }
}
function $f844812df082fc15$var$query(parent, selector) {
    return parent && parent.querySelector(selector);
}
function $f844812df082fc15$var$queryAll(parent, selector) {
    return selector ? $f844812df082fc15$var$slice(parent.querySelectorAll(selector)) : [];
}
function $f844812df082fc15$var$removeClass(elm, classes) {
    $f844812df082fc15$var$toggleClass(elm, classes, false);
}
function $f844812df082fc15$var$timeOf(e) {
    return e.timeStamp;
}
function $f844812df082fc15$var$unit(value) {
    return $f844812df082fc15$var$isString(value) ? value : value ? value + "px" : "";
}
var $f844812df082fc15$var$PROJECT_CODE = "splide";
var $f844812df082fc15$var$DATA_ATTRIBUTE = "data-" + $f844812df082fc15$var$PROJECT_CODE;
function $f844812df082fc15$var$assert(condition, message) {
    if (!condition) throw new Error("[" + $f844812df082fc15$var$PROJECT_CODE + "] " + (message || ""));
}
var $f844812df082fc15$var$min = Math.min, $f844812df082fc15$var$max = Math.max, $f844812df082fc15$var$floor = Math.floor, $f844812df082fc15$var$ceil = Math.ceil, $f844812df082fc15$var$abs = Math.abs;
function $f844812df082fc15$var$approximatelyEqual(x, y, epsilon) {
    return $f844812df082fc15$var$abs(x - y) < epsilon;
}
function $f844812df082fc15$var$between(number, x, y, exclusive) {
    var minimum = $f844812df082fc15$var$min(x, y);
    var maximum = $f844812df082fc15$var$max(x, y);
    return exclusive ? minimum < number && number < maximum : minimum <= number && number <= maximum;
}
function $f844812df082fc15$var$clamp(number, x, y) {
    var minimum = $f844812df082fc15$var$min(x, y);
    var maximum = $f844812df082fc15$var$max(x, y);
    return $f844812df082fc15$var$min($f844812df082fc15$var$max(minimum, number), maximum);
}
function $f844812df082fc15$var$sign(x) {
    return +(x > 0) - +(x < 0);
}
function $f844812df082fc15$var$camelToKebab(string) {
    return string.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();
}
function $f844812df082fc15$var$format(string, replacements) {
    $f844812df082fc15$var$forEach(replacements, function(replacement) {
        string = string.replace("%s", "" + replacement);
    });
    return string;
}
function $f844812df082fc15$var$pad(number) {
    return number < 10 ? "0" + number : "" + number;
}
var $f844812df082fc15$var$ids = {};
function $f844812df082fc15$var$uniqueId(prefix) {
    return "" + prefix + $f844812df082fc15$var$pad($f844812df082fc15$var$ids[prefix] = ($f844812df082fc15$var$ids[prefix] || 0) + 1);
}
function $f844812df082fc15$export$c473e36ef1bda729() {
    var listeners = [];
    function bind(targets, events, callback, options) {
        forEachEvent(targets, events, function(target, event, namespace) {
            var isEventTarget = "addEventListener" in target;
            var remover = isEventTarget ? target.removeEventListener.bind(target, event, callback, options) : target["removeListener"].bind(target, callback);
            isEventTarget ? target.addEventListener(event, callback, options) : target["addListener"](callback);
            listeners.push([
                target,
                event,
                namespace,
                callback,
                remover
            ]);
        });
    }
    function unbind(targets, events, callback) {
        forEachEvent(targets, events, function(target, event, namespace) {
            listeners = listeners.filter(function(listener) {
                if (listener[0] === target && listener[1] === event && listener[2] === namespace && (!callback || listener[3] === callback)) {
                    listener[4]();
                    return false;
                }
                return true;
            });
        });
    }
    function dispatch(target, type, detail) {
        var e;
        var bubbles = true;
        if (typeof CustomEvent === "function") e = new CustomEvent(type, {
            bubbles: bubbles,
            detail: detail
        });
        else {
            e = document.createEvent("CustomEvent");
            e.initCustomEvent(type, bubbles, false, detail);
        }
        target.dispatchEvent(e);
        return e;
    }
    function forEachEvent(targets, events, iteratee) {
        $f844812df082fc15$var$forEach(targets, function(target) {
            target && $f844812df082fc15$var$forEach(events, function(events2) {
                events2.split(" ").forEach(function(eventNS) {
                    var fragment = eventNS.split(".");
                    iteratee(target, fragment[0], fragment[1]);
                });
            });
        });
    }
    function destroy() {
        listeners.forEach(function(data) {
            data[4]();
        });
        $f844812df082fc15$var$empty(listeners);
    }
    return {
        bind: bind,
        unbind: unbind,
        dispatch: dispatch,
        destroy: destroy
    };
}
var $f844812df082fc15$export$d300dc1a2634364b = "mounted";
var $f844812df082fc15$export$d8dac49b4532735a = "ready";
var $f844812df082fc15$export$2aa493d7c3275167 = "move";
var $f844812df082fc15$export$fe5802204b967f0d = "moved";
var $f844812df082fc15$export$5adb665701eda1ce = "click";
var $f844812df082fc15$export$92e3eae133acac4c = "active";
var $f844812df082fc15$export$6bcbb81035c12cea = "inactive";
var $f844812df082fc15$export$6a5b3445e4066a53 = "visible";
var $f844812df082fc15$export$8c5c7a21d54563e9 = "hidden";
var $f844812df082fc15$export$7f4701ac5e05e39f = "refresh";
var $f844812df082fc15$export$db40ab7c0855fa5c = "updated";
var $f844812df082fc15$export$7e019dae5103a285 = "resize";
var $f844812df082fc15$export$d637eba1e9e28482 = "resized";
var $f844812df082fc15$export$e84bf5065c9087ac = "drag";
var $f844812df082fc15$export$8e9f636d2c722196 = "dragging";
var $f844812df082fc15$export$90ea576bd3fdeb60 = "dragged";
var $f844812df082fc15$export$49801896908b5e33 = "scroll";
var $f844812df082fc15$export$ff8164bff3202b9 = "scrolled";
var $f844812df082fc15$export$6cbac5b662a31e1b = "overflow";
var $f844812df082fc15$export$88c4cf7419e470cd = "destroy";
var $f844812df082fc15$export$8647f6b043e04e9d = "arrows:mounted";
var $f844812df082fc15$export$d467f9343b961f75 = "arrows:updated";
var $f844812df082fc15$export$bf89a4e4349c9778 = "pagination:mounted";
var $f844812df082fc15$export$eb2019082ed6de0b = "pagination:updated";
var $f844812df082fc15$export$84015c33508f94ec = "navigation:mounted";
var $f844812df082fc15$export$23663268a31b79e2 = "autoplay:play";
var $f844812df082fc15$export$185723258309b608 = "autoplay:playing";
var $f844812df082fc15$export$16a1e4f3d0368265 = "autoplay:pause";
var $f844812df082fc15$export$9f64346e17f0ec8e = "lazyload:loaded";
var $f844812df082fc15$export$6d5af59619d10e6a = "sk";
var $f844812df082fc15$export$f0af896383d5adff = "sh";
var $f844812df082fc15$export$28dea85f216954dc = "ei";
function $f844812df082fc15$export$f188226459c8a3ff(Splide2) {
    var bus = Splide2 ? Splide2.event.bus : document.createDocumentFragment();
    var binder = $f844812df082fc15$export$c473e36ef1bda729();
    function on(events, callback) {
        binder.bind(bus, $f844812df082fc15$var$toArray(events).join(" "), function(e) {
            callback.apply(callback, $f844812df082fc15$var$isArray(e.detail) ? e.detail : []);
        });
    }
    function emit(event) {
        binder.dispatch(bus, event, $f844812df082fc15$var$slice(arguments, 1));
    }
    if (Splide2) Splide2.event.on($f844812df082fc15$export$88c4cf7419e470cd, binder.destroy);
    return $f844812df082fc15$var$assign(binder, {
        bus: bus,
        on: on,
        off: $f844812df082fc15$var$apply(binder.unbind, bus),
        emit: emit
    });
}
function $f844812df082fc15$export$46ad21b25b6dccf0(interval, onInterval, onUpdate, limit) {
    var now = Date.now;
    var startTime;
    var rate = 0;
    var id;
    var paused = true;
    var count = 0;
    function update() {
        if (!paused) {
            rate = interval ? $f844812df082fc15$var$min((now() - startTime) / interval, 1) : 1;
            onUpdate && onUpdate(rate);
            if (rate >= 1) {
                onInterval();
                startTime = now();
                if (limit && ++count >= limit) return pause();
            }
            id = $f844812df082fc15$var$raf(update);
        }
    }
    function start(resume) {
        resume || cancel();
        startTime = now() - (resume ? rate * interval : 0);
        paused = false;
        id = $f844812df082fc15$var$raf(update);
    }
    function pause() {
        paused = true;
    }
    function rewind() {
        startTime = now();
        rate = 0;
        if (onUpdate) onUpdate(rate);
    }
    function cancel() {
        id && cancelAnimationFrame(id);
        rate = 0;
        id = 0;
        paused = true;
    }
    function set(time) {
        interval = time;
    }
    function isPaused() {
        return paused;
    }
    return {
        start: start,
        rewind: rewind,
        pause: pause,
        cancel: cancel,
        set: set,
        isPaused: isPaused
    };
}
function $f844812df082fc15$export$7254cc27399e90bd(initialState) {
    var state = initialState;
    function set(value) {
        state = value;
    }
    function is(states) {
        return $f844812df082fc15$var$includes($f844812df082fc15$var$toArray(states), state);
    }
    return {
        set: set,
        is: is
    };
}
function $f844812df082fc15$export$efff0f5979573c99(func, duration) {
    var interval = $f844812df082fc15$export$46ad21b25b6dccf0(duration || 0, func, null, 1);
    return function() {
        interval.isPaused() && interval.start();
    };
}
function $f844812df082fc15$var$Media(Splide2, Components2, options) {
    var state = Splide2.state;
    var breakpoints = options.breakpoints || {};
    var reducedMotion = options.reducedMotion || {};
    var binder = $f844812df082fc15$export$c473e36ef1bda729();
    var queries = [];
    function setup() {
        var isMin = options.mediaQuery === "min";
        $f844812df082fc15$var$ownKeys(breakpoints).sort(function(n, m) {
            return isMin ? +n - +m : +m - +n;
        }).forEach(function(key) {
            register(breakpoints[key], "(" + (isMin ? "min" : "max") + "-width:" + key + "px)");
        });
        register(reducedMotion, $f844812df082fc15$var$MEDIA_PREFERS_REDUCED_MOTION);
        update();
    }
    function destroy(completely) {
        if (completely) binder.destroy();
    }
    function register(options2, query) {
        var queryList = matchMedia(query);
        binder.bind(queryList, "change", update);
        queries.push([
            options2,
            queryList
        ]);
    }
    function update() {
        var destroyed = state.is($f844812df082fc15$var$DESTROYED);
        var direction = options.direction;
        var merged = queries.reduce(function(merged2, entry) {
            return $f844812df082fc15$var$merge(merged2, entry[1].matches ? entry[0] : {});
        }, {});
        $f844812df082fc15$var$omit(options);
        set(merged);
        if (options.destroy) Splide2.destroy(options.destroy === "completely");
        else if (destroyed) {
            destroy(true);
            Splide2.mount();
        } else direction !== options.direction && Splide2.refresh();
    }
    function reduce(enable) {
        if (matchMedia($f844812df082fc15$var$MEDIA_PREFERS_REDUCED_MOTION).matches) enable ? $f844812df082fc15$var$merge(options, reducedMotion) : $f844812df082fc15$var$omit(options, $f844812df082fc15$var$ownKeys(reducedMotion));
    }
    function set(opts, base, notify) {
        $f844812df082fc15$var$merge(options, opts);
        base && $f844812df082fc15$var$merge(Object.getPrototypeOf(options), opts);
        if (notify || !state.is($f844812df082fc15$var$CREATED)) Splide2.emit($f844812df082fc15$export$db40ab7c0855fa5c, options);
    }
    return {
        setup: setup,
        destroy: destroy,
        reduce: reduce,
        set: set
    };
}
var $f844812df082fc15$var$ARROW = "Arrow";
var $f844812df082fc15$var$ARROW_LEFT = $f844812df082fc15$var$ARROW + "Left";
var $f844812df082fc15$var$ARROW_RIGHT = $f844812df082fc15$var$ARROW + "Right";
var $f844812df082fc15$var$ARROW_UP = $f844812df082fc15$var$ARROW + "Up";
var $f844812df082fc15$var$ARROW_DOWN = $f844812df082fc15$var$ARROW + "Down";
var $f844812df082fc15$export$373e92e0788ff06e = "ltr";
var $f844812df082fc15$export$850f7749a2909601 = "rtl";
var $f844812df082fc15$export$97170d9824b89709 = "ttb";
var $f844812df082fc15$var$ORIENTATION_MAP = {
    width: [
        "height"
    ],
    left: [
        "top",
        "right"
    ],
    right: [
        "bottom",
        "left"
    ],
    x: [
        "y"
    ],
    X: [
        "Y"
    ],
    Y: [
        "X"
    ],
    ArrowLeft: [
        $f844812df082fc15$var$ARROW_UP,
        $f844812df082fc15$var$ARROW_RIGHT
    ],
    ArrowRight: [
        $f844812df082fc15$var$ARROW_DOWN,
        $f844812df082fc15$var$ARROW_LEFT
    ]
};
function $f844812df082fc15$var$Direction(Splide2, Components2, options) {
    function resolve(prop, axisOnly, direction) {
        direction = direction || options.direction;
        var index = direction === $f844812df082fc15$export$850f7749a2909601 && !axisOnly ? 1 : direction === $f844812df082fc15$export$97170d9824b89709 ? 0 : -1;
        return $f844812df082fc15$var$ORIENTATION_MAP[prop] && $f844812df082fc15$var$ORIENTATION_MAP[prop][index] || prop.replace(/width|left|right/i, function(match, offset) {
            var replacement = $f844812df082fc15$var$ORIENTATION_MAP[match.toLowerCase()][index] || match;
            return offset > 0 ? replacement.charAt(0).toUpperCase() + replacement.slice(1) : replacement;
        });
    }
    function orient(value) {
        return value * (options.direction === $f844812df082fc15$export$850f7749a2909601 ? 1 : -1);
    }
    return {
        resolve: resolve,
        orient: orient
    };
}
var $f844812df082fc15$var$ROLE = "role";
var $f844812df082fc15$var$TAB_INDEX = "tabindex";
var $f844812df082fc15$var$DISABLED = "disabled";
var $f844812df082fc15$var$ARIA_PREFIX = "aria-";
var $f844812df082fc15$var$ARIA_CONTROLS = $f844812df082fc15$var$ARIA_PREFIX + "controls";
var $f844812df082fc15$var$ARIA_CURRENT = $f844812df082fc15$var$ARIA_PREFIX + "current";
var $f844812df082fc15$var$ARIA_SELECTED = $f844812df082fc15$var$ARIA_PREFIX + "selected";
var $f844812df082fc15$var$ARIA_LABEL = $f844812df082fc15$var$ARIA_PREFIX + "label";
var $f844812df082fc15$var$ARIA_LABELLEDBY = $f844812df082fc15$var$ARIA_PREFIX + "labelledby";
var $f844812df082fc15$var$ARIA_HIDDEN = $f844812df082fc15$var$ARIA_PREFIX + "hidden";
var $f844812df082fc15$var$ARIA_ORIENTATION = $f844812df082fc15$var$ARIA_PREFIX + "orientation";
var $f844812df082fc15$var$ARIA_ROLEDESCRIPTION = $f844812df082fc15$var$ARIA_PREFIX + "roledescription";
var $f844812df082fc15$var$ARIA_LIVE = $f844812df082fc15$var$ARIA_PREFIX + "live";
var $f844812df082fc15$var$ARIA_BUSY = $f844812df082fc15$var$ARIA_PREFIX + "busy";
var $f844812df082fc15$var$ARIA_ATOMIC = $f844812df082fc15$var$ARIA_PREFIX + "atomic";
var $f844812df082fc15$var$ALL_ATTRIBUTES = [
    $f844812df082fc15$var$ROLE,
    $f844812df082fc15$var$TAB_INDEX,
    $f844812df082fc15$var$DISABLED,
    $f844812df082fc15$var$ARIA_CONTROLS,
    $f844812df082fc15$var$ARIA_CURRENT,
    $f844812df082fc15$var$ARIA_LABEL,
    $f844812df082fc15$var$ARIA_LABELLEDBY,
    $f844812df082fc15$var$ARIA_HIDDEN,
    $f844812df082fc15$var$ARIA_ORIENTATION,
    $f844812df082fc15$var$ARIA_ROLEDESCRIPTION
];
var $f844812df082fc15$var$CLASS_PREFIX = $f844812df082fc15$var$PROJECT_CODE + "__";
var $f844812df082fc15$var$STATUS_CLASS_PREFIX = "is-";
var $f844812df082fc15$export$93b21159ad85c843 = $f844812df082fc15$var$PROJECT_CODE;
var $f844812df082fc15$export$7738b09ac0a98952 = $f844812df082fc15$var$CLASS_PREFIX + "track";
var $f844812df082fc15$export$19cc2a5451235cae = $f844812df082fc15$var$CLASS_PREFIX + "list";
var $f844812df082fc15$export$8d922915837a38d3 = $f844812df082fc15$var$CLASS_PREFIX + "slide";
var $f844812df082fc15$export$2c1ba4a4f1aa4947 = $f844812df082fc15$export$8d922915837a38d3 + "--clone";
var $f844812df082fc15$export$e9ba7e444ba60a12 = $f844812df082fc15$export$8d922915837a38d3 + "__container";
var $f844812df082fc15$export$a26cbd955fecf11e = $f844812df082fc15$var$CLASS_PREFIX + "arrows";
var $f844812df082fc15$export$516e7d18e13a2dca = $f844812df082fc15$var$CLASS_PREFIX + "arrow";
var $f844812df082fc15$export$58ea3db24c33b76 = $f844812df082fc15$export$516e7d18e13a2dca + "--prev";
var $f844812df082fc15$export$4885afd7098a65c2 = $f844812df082fc15$export$516e7d18e13a2dca + "--next";
var $f844812df082fc15$export$cbf8e5a0ab95eda3 = $f844812df082fc15$var$CLASS_PREFIX + "pagination";
var $f844812df082fc15$export$52f2cca6a5eee805 = $f844812df082fc15$export$cbf8e5a0ab95eda3 + "__page";
var $f844812df082fc15$export$4c82dc32b1c4ace5 = $f844812df082fc15$var$CLASS_PREFIX + "progress";
var $f844812df082fc15$export$2c9b091c749f4409 = $f844812df082fc15$export$4c82dc32b1c4ace5 + "__bar";
var $f844812df082fc15$export$a29701deef84b825 = $f844812df082fc15$var$CLASS_PREFIX + "toggle";
var $f844812df082fc15$export$d9d247d51b430dbb = $f844812df082fc15$export$a29701deef84b825 + "__play";
var $f844812df082fc15$export$3529f201a419925b = $f844812df082fc15$export$a29701deef84b825 + "__pause";
var $f844812df082fc15$export$3e5381ee3fab8374 = $f844812df082fc15$var$CLASS_PREFIX + "spinner";
var $f844812df082fc15$export$bb78d7c200da8960 = $f844812df082fc15$var$CLASS_PREFIX + "sr";
var $f844812df082fc15$export$7761661e2d5b9388 = $f844812df082fc15$var$STATUS_CLASS_PREFIX + "initialized";
var $f844812df082fc15$export$72d36ecf3758cb4b = $f844812df082fc15$var$STATUS_CLASS_PREFIX + "active";
var $f844812df082fc15$export$e423ac4972f5e196 = $f844812df082fc15$var$STATUS_CLASS_PREFIX + "prev";
var $f844812df082fc15$export$457a2d20827a2779 = $f844812df082fc15$var$STATUS_CLASS_PREFIX + "next";
var $f844812df082fc15$export$53ca4621bbab9a = $f844812df082fc15$var$STATUS_CLASS_PREFIX + "visible";
var $f844812df082fc15$export$d22ec4ccb7996ba2 = $f844812df082fc15$var$STATUS_CLASS_PREFIX + "loading";
var $f844812df082fc15$export$b6f202a162a09100 = $f844812df082fc15$var$STATUS_CLASS_PREFIX + "focus-in";
var $f844812df082fc15$export$cd908cd1dd625e29 = $f844812df082fc15$var$STATUS_CLASS_PREFIX + "overflow";
var $f844812df082fc15$export$49f9eaea10ebf193 = [
    $f844812df082fc15$export$72d36ecf3758cb4b,
    $f844812df082fc15$export$53ca4621bbab9a,
    $f844812df082fc15$export$e423ac4972f5e196,
    $f844812df082fc15$export$457a2d20827a2779,
    $f844812df082fc15$export$d22ec4ccb7996ba2,
    $f844812df082fc15$export$b6f202a162a09100,
    $f844812df082fc15$export$cd908cd1dd625e29
];
var $f844812df082fc15$export$ba41d43e4a419565 = {
    slide: $f844812df082fc15$export$8d922915837a38d3,
    clone: $f844812df082fc15$export$2c1ba4a4f1aa4947,
    arrows: $f844812df082fc15$export$a26cbd955fecf11e,
    arrow: $f844812df082fc15$export$516e7d18e13a2dca,
    prev: $f844812df082fc15$export$58ea3db24c33b76,
    next: $f844812df082fc15$export$4885afd7098a65c2,
    pagination: $f844812df082fc15$export$cbf8e5a0ab95eda3,
    page: $f844812df082fc15$export$52f2cca6a5eee805,
    spinner: $f844812df082fc15$export$3e5381ee3fab8374
};
function $f844812df082fc15$var$closest(from, selector) {
    if ($f844812df082fc15$var$isFunction(from.closest)) return from.closest(selector);
    var elm = from;
    while(elm && elm.nodeType === 1){
        if ($f844812df082fc15$var$matches(elm, selector)) break;
        elm = elm.parentElement;
    }
    return elm;
}
var $f844812df082fc15$var$FRICTION = 5;
var $f844812df082fc15$var$LOG_INTERVAL = 200;
var $f844812df082fc15$var$POINTER_DOWN_EVENTS = "touchstart mousedown";
var $f844812df082fc15$var$POINTER_MOVE_EVENTS = "touchmove mousemove";
var $f844812df082fc15$var$POINTER_UP_EVENTS = "touchend touchcancel mouseup click";
function $f844812df082fc15$var$Elements(Splide2, Components2, options) {
    var _EventInterface = $f844812df082fc15$export$f188226459c8a3ff(Splide2), on = _EventInterface.on, bind = _EventInterface.bind;
    var root = Splide2.root;
    var i18n = options.i18n;
    var elements = {};
    var slides = [];
    var rootClasses = [];
    var trackClasses = [];
    var track;
    var list;
    var isUsingKey;
    function setup() {
        collect();
        init();
        update();
    }
    function mount() {
        on($f844812df082fc15$export$7f4701ac5e05e39f, destroy);
        on($f844812df082fc15$export$7f4701ac5e05e39f, setup);
        on($f844812df082fc15$export$db40ab7c0855fa5c, update);
        bind(document, $f844812df082fc15$var$POINTER_DOWN_EVENTS + " keydown", function(e) {
            isUsingKey = e.type === "keydown";
        }, {
            capture: true
        });
        bind(root, "focusin", function() {
            $f844812df082fc15$var$toggleClass(root, $f844812df082fc15$export$b6f202a162a09100, !!isUsingKey);
        });
    }
    function destroy(completely) {
        var attrs = $f844812df082fc15$var$ALL_ATTRIBUTES.concat("style");
        $f844812df082fc15$var$empty(slides);
        $f844812df082fc15$var$removeClass(root, rootClasses);
        $f844812df082fc15$var$removeClass(track, trackClasses);
        $f844812df082fc15$var$removeAttribute([
            track,
            list
        ], attrs);
        $f844812df082fc15$var$removeAttribute(root, completely ? attrs : [
            "style",
            $f844812df082fc15$var$ARIA_ROLEDESCRIPTION
        ]);
    }
    function update() {
        $f844812df082fc15$var$removeClass(root, rootClasses);
        $f844812df082fc15$var$removeClass(track, trackClasses);
        rootClasses = getClasses($f844812df082fc15$export$93b21159ad85c843);
        trackClasses = getClasses($f844812df082fc15$export$7738b09ac0a98952);
        $f844812df082fc15$var$addClass(root, rootClasses);
        $f844812df082fc15$var$addClass(track, trackClasses);
        $f844812df082fc15$var$setAttribute(root, $f844812df082fc15$var$ARIA_LABEL, options.label);
        $f844812df082fc15$var$setAttribute(root, $f844812df082fc15$var$ARIA_LABELLEDBY, options.labelledby);
    }
    function collect() {
        track = find("." + $f844812df082fc15$export$7738b09ac0a98952);
        list = $f844812df082fc15$var$child(track, "." + $f844812df082fc15$export$19cc2a5451235cae);
        $f844812df082fc15$var$assert(track && list, "A track/list element is missing.");
        $f844812df082fc15$var$push(slides, $f844812df082fc15$var$children(list, "." + $f844812df082fc15$export$8d922915837a38d3 + ":not(." + $f844812df082fc15$export$2c1ba4a4f1aa4947 + ")"));
        $f844812df082fc15$var$forOwn({
            arrows: $f844812df082fc15$export$a26cbd955fecf11e,
            pagination: $f844812df082fc15$export$cbf8e5a0ab95eda3,
            prev: $f844812df082fc15$export$58ea3db24c33b76,
            next: $f844812df082fc15$export$4885afd7098a65c2,
            bar: $f844812df082fc15$export$2c9b091c749f4409,
            toggle: $f844812df082fc15$export$a29701deef84b825
        }, function(className, key) {
            elements[key] = find("." + className);
        });
        $f844812df082fc15$var$assign(elements, {
            root: root,
            track: track,
            list: list,
            slides: slides
        });
    }
    function init() {
        var id = root.id || $f844812df082fc15$var$uniqueId($f844812df082fc15$var$PROJECT_CODE);
        var role = options.role;
        root.id = id;
        track.id = track.id || id + "-track";
        list.id = list.id || id + "-list";
        if (!$f844812df082fc15$var$getAttribute(root, $f844812df082fc15$var$ROLE) && root.tagName !== "SECTION" && role) $f844812df082fc15$var$setAttribute(root, $f844812df082fc15$var$ROLE, role);
        $f844812df082fc15$var$setAttribute(root, $f844812df082fc15$var$ARIA_ROLEDESCRIPTION, i18n.carousel);
        $f844812df082fc15$var$setAttribute(list, $f844812df082fc15$var$ROLE, "presentation");
    }
    function find(selector) {
        var elm = $f844812df082fc15$var$query(root, selector);
        return elm && $f844812df082fc15$var$closest(elm, "." + $f844812df082fc15$export$93b21159ad85c843) === root ? elm : void 0;
    }
    function getClasses(base) {
        return [
            base + "--" + options.type,
            base + "--" + options.direction,
            options.drag && base + "--draggable",
            options.isNavigation && base + "--nav",
            base === $f844812df082fc15$export$93b21159ad85c843 && $f844812df082fc15$export$72d36ecf3758cb4b
        ];
    }
    return $f844812df082fc15$var$assign(elements, {
        setup: setup,
        mount: mount,
        destroy: destroy
    });
}
var $f844812df082fc15$export$e5a58a5ee5b54c22 = "slide";
var $f844812df082fc15$export$f42383286ed1223d = "loop";
var $f844812df082fc15$export$742b62a5690c060 = "fade";
function $f844812df082fc15$var$Slide$1(Splide2, index, slideIndex, slide) {
    var event = $f844812df082fc15$export$f188226459c8a3ff(Splide2);
    var on = event.on, emit = event.emit, bind = event.bind;
    var Components = Splide2.Components, root = Splide2.root, options = Splide2.options;
    var isNavigation = options.isNavigation, updateOnMove = options.updateOnMove, i18n = options.i18n, pagination = options.pagination, slideFocus = options.slideFocus;
    var resolve = Components.Direction.resolve;
    var styles = $f844812df082fc15$var$getAttribute(slide, "style");
    var label = $f844812df082fc15$var$getAttribute(slide, $f844812df082fc15$var$ARIA_LABEL);
    var isClone = slideIndex > -1;
    var container = $f844812df082fc15$var$child(slide, "." + $f844812df082fc15$export$e9ba7e444ba60a12);
    var destroyed;
    function mount() {
        if (!isClone) {
            slide.id = root.id + "-slide" + $f844812df082fc15$var$pad(index + 1);
            $f844812df082fc15$var$setAttribute(slide, $f844812df082fc15$var$ROLE, pagination ? "tabpanel" : "group");
            $f844812df082fc15$var$setAttribute(slide, $f844812df082fc15$var$ARIA_ROLEDESCRIPTION, i18n.slide);
            $f844812df082fc15$var$setAttribute(slide, $f844812df082fc15$var$ARIA_LABEL, label || $f844812df082fc15$var$format(i18n.slideLabel, [
                index + 1,
                Splide2.length
            ]));
        }
        listen();
    }
    function listen() {
        bind(slide, "click", $f844812df082fc15$var$apply(emit, $f844812df082fc15$export$5adb665701eda1ce, self));
        bind(slide, "keydown", $f844812df082fc15$var$apply(emit, $f844812df082fc15$export$6d5af59619d10e6a, self));
        on([
            $f844812df082fc15$export$fe5802204b967f0d,
            $f844812df082fc15$export$f0af896383d5adff,
            $f844812df082fc15$export$ff8164bff3202b9
        ], update);
        on($f844812df082fc15$export$84015c33508f94ec, initNavigation);
        if (updateOnMove) on($f844812df082fc15$export$2aa493d7c3275167, onMove);
    }
    function destroy() {
        destroyed = true;
        event.destroy();
        $f844812df082fc15$var$removeClass(slide, $f844812df082fc15$export$49f9eaea10ebf193);
        $f844812df082fc15$var$removeAttribute(slide, $f844812df082fc15$var$ALL_ATTRIBUTES);
        $f844812df082fc15$var$setAttribute(slide, "style", styles);
        $f844812df082fc15$var$setAttribute(slide, $f844812df082fc15$var$ARIA_LABEL, label || "");
    }
    function initNavigation() {
        var controls = Splide2.splides.map(function(target) {
            var Slide2 = target.splide.Components.Slides.getAt(index);
            return Slide2 ? Slide2.slide.id : "";
        }).join(" ");
        $f844812df082fc15$var$setAttribute(slide, $f844812df082fc15$var$ARIA_LABEL, $f844812df082fc15$var$format(i18n.slideX, (isClone ? slideIndex : index) + 1));
        $f844812df082fc15$var$setAttribute(slide, $f844812df082fc15$var$ARIA_CONTROLS, controls);
        $f844812df082fc15$var$setAttribute(slide, $f844812df082fc15$var$ROLE, slideFocus ? "button" : "");
        slideFocus && $f844812df082fc15$var$removeAttribute(slide, $f844812df082fc15$var$ARIA_ROLEDESCRIPTION);
    }
    function onMove() {
        if (!destroyed) update();
    }
    function update() {
        if (!destroyed) {
            var curr = Splide2.index;
            updateActivity();
            updateVisibility();
            $f844812df082fc15$var$toggleClass(slide, $f844812df082fc15$export$e423ac4972f5e196, index === curr - 1);
            $f844812df082fc15$var$toggleClass(slide, $f844812df082fc15$export$457a2d20827a2779, index === curr + 1);
        }
    }
    function updateActivity() {
        var active = isActive();
        if (active !== $f844812df082fc15$var$hasClass(slide, $f844812df082fc15$export$72d36ecf3758cb4b)) {
            $f844812df082fc15$var$toggleClass(slide, $f844812df082fc15$export$72d36ecf3758cb4b, active);
            $f844812df082fc15$var$setAttribute(slide, $f844812df082fc15$var$ARIA_CURRENT, isNavigation && active || "");
            emit(active ? $f844812df082fc15$export$92e3eae133acac4c : $f844812df082fc15$export$6bcbb81035c12cea, self);
        }
    }
    function updateVisibility() {
        var visible = isVisible();
        var hidden = !visible && (!isActive() || isClone);
        if (!Splide2.state.is([
            $f844812df082fc15$var$MOVING,
            $f844812df082fc15$var$SCROLLING
        ])) $f844812df082fc15$var$setAttribute(slide, $f844812df082fc15$var$ARIA_HIDDEN, hidden || "");
        $f844812df082fc15$var$setAttribute($f844812df082fc15$var$queryAll(slide, options.focusableNodes || ""), $f844812df082fc15$var$TAB_INDEX, hidden ? -1 : "");
        if (slideFocus) $f844812df082fc15$var$setAttribute(slide, $f844812df082fc15$var$TAB_INDEX, hidden ? -1 : 0);
        if (visible !== $f844812df082fc15$var$hasClass(slide, $f844812df082fc15$export$53ca4621bbab9a)) {
            $f844812df082fc15$var$toggleClass(slide, $f844812df082fc15$export$53ca4621bbab9a, visible);
            emit(visible ? $f844812df082fc15$export$6a5b3445e4066a53 : $f844812df082fc15$export$8c5c7a21d54563e9, self);
        }
        if (!visible && document.activeElement === slide) {
            var Slide2 = Components.Slides.getAt(Splide2.index);
            Slide2 && $f844812df082fc15$var$focus(Slide2.slide);
        }
    }
    function style$1(prop, value, useContainer) {
        $f844812df082fc15$var$style(useContainer && container || slide, prop, value);
    }
    function isActive() {
        var curr = Splide2.index;
        return curr === index || options.cloneStatus && curr === slideIndex;
    }
    function isVisible() {
        if (Splide2.is($f844812df082fc15$export$742b62a5690c060)) return isActive();
        var trackRect = $f844812df082fc15$var$rect(Components.Elements.track);
        var slideRect = $f844812df082fc15$var$rect(slide);
        var left = resolve("left", true);
        var right = resolve("right", true);
        return $f844812df082fc15$var$floor(trackRect[left]) <= $f844812df082fc15$var$ceil(slideRect[left]) && $f844812df082fc15$var$floor(slideRect[right]) <= $f844812df082fc15$var$ceil(trackRect[right]);
    }
    function isWithin(from, distance) {
        var diff = $f844812df082fc15$var$abs(from - index);
        if (!isClone && (options.rewind || Splide2.is($f844812df082fc15$export$f42383286ed1223d))) diff = $f844812df082fc15$var$min(diff, Splide2.length - diff);
        return diff <= distance;
    }
    var self = {
        index: index,
        slideIndex: slideIndex,
        slide: slide,
        container: container,
        isClone: isClone,
        mount: mount,
        destroy: destroy,
        update: update,
        style: style$1,
        isWithin: isWithin
    };
    return self;
}
function $f844812df082fc15$var$Slides(Splide2, Components2, options) {
    var _EventInterface2 = $f844812df082fc15$export$f188226459c8a3ff(Splide2), on = _EventInterface2.on, emit = _EventInterface2.emit, bind = _EventInterface2.bind;
    var _Components2$Elements = Components2.Elements, slides = _Components2$Elements.slides, list = _Components2$Elements.list;
    var Slides2 = [];
    function mount() {
        init();
        on($f844812df082fc15$export$7f4701ac5e05e39f, destroy);
        on($f844812df082fc15$export$7f4701ac5e05e39f, init);
    }
    function init() {
        slides.forEach(function(slide, index) {
            register(slide, index, -1);
        });
    }
    function destroy() {
        forEach$1(function(Slide2) {
            Slide2.destroy();
        });
        $f844812df082fc15$var$empty(Slides2);
    }
    function update() {
        forEach$1(function(Slide2) {
            Slide2.update();
        });
    }
    function register(slide, index, slideIndex) {
        var object = $f844812df082fc15$var$Slide$1(Splide2, index, slideIndex, slide);
        object.mount();
        Slides2.push(object);
        Slides2.sort(function(Slide1, Slide2) {
            return Slide1.index - Slide2.index;
        });
    }
    function get(excludeClones) {
        return excludeClones ? filter(function(Slide2) {
            return !Slide2.isClone;
        }) : Slides2;
    }
    function getIn(page) {
        var Controller = Components2.Controller;
        var index = Controller.toIndex(page);
        var max = Controller.hasFocus() ? 1 : options.perPage;
        return filter(function(Slide2) {
            return $f844812df082fc15$var$between(Slide2.index, index, index + max - 1);
        });
    }
    function getAt(index) {
        return filter(index)[0];
    }
    function add(items, index) {
        $f844812df082fc15$var$forEach(items, function(slide) {
            if ($f844812df082fc15$var$isString(slide)) slide = $f844812df082fc15$var$parseHtml(slide);
            if ($f844812df082fc15$var$isHTMLElement(slide)) {
                var ref = slides[index];
                ref ? $f844812df082fc15$var$before(slide, ref) : $f844812df082fc15$var$append(list, slide);
                $f844812df082fc15$var$addClass(slide, options.classes.slide);
                observeImages(slide, $f844812df082fc15$var$apply(emit, $f844812df082fc15$export$7e019dae5103a285));
            }
        });
        emit($f844812df082fc15$export$7f4701ac5e05e39f);
    }
    function remove$1(matcher) {
        $f844812df082fc15$var$remove(filter(matcher).map(function(Slide2) {
            return Slide2.slide;
        }));
        emit($f844812df082fc15$export$7f4701ac5e05e39f);
    }
    function forEach$1(iteratee, excludeClones) {
        get(excludeClones).forEach(iteratee);
    }
    function filter(matcher) {
        return Slides2.filter($f844812df082fc15$var$isFunction(matcher) ? matcher : function(Slide2) {
            return $f844812df082fc15$var$isString(matcher) ? $f844812df082fc15$var$matches(Slide2.slide, matcher) : $f844812df082fc15$var$includes($f844812df082fc15$var$toArray(matcher), Slide2.index);
        });
    }
    function style(prop, value, useContainer) {
        forEach$1(function(Slide2) {
            Slide2.style(prop, value, useContainer);
        });
    }
    function observeImages(elm, callback) {
        var images = $f844812df082fc15$var$queryAll(elm, "img");
        var length = images.length;
        if (length) images.forEach(function(img) {
            bind(img, "load error", function() {
                if (!--length) callback();
            });
        });
        else callback();
    }
    function getLength(excludeClones) {
        return excludeClones ? slides.length : Slides2.length;
    }
    function isEnough() {
        return Slides2.length > options.perPage;
    }
    return {
        mount: mount,
        destroy: destroy,
        update: update,
        register: register,
        get: get,
        getIn: getIn,
        getAt: getAt,
        add: add,
        remove: remove$1,
        forEach: forEach$1,
        filter: filter,
        style: style,
        getLength: getLength,
        isEnough: isEnough
    };
}
function $f844812df082fc15$var$Layout(Splide2, Components2, options) {
    var _EventInterface3 = $f844812df082fc15$export$f188226459c8a3ff(Splide2), on = _EventInterface3.on, bind = _EventInterface3.bind, emit = _EventInterface3.emit;
    var Slides = Components2.Slides;
    var resolve = Components2.Direction.resolve;
    var _Components2$Elements2 = Components2.Elements, root = _Components2$Elements2.root, track = _Components2$Elements2.track, list = _Components2$Elements2.list;
    var getAt = Slides.getAt, styleSlides = Slides.style;
    var vertical;
    var rootRect;
    var overflow;
    function mount() {
        init();
        bind(window, "resize load", $f844812df082fc15$export$efff0f5979573c99($f844812df082fc15$var$apply(emit, $f844812df082fc15$export$7e019dae5103a285)));
        on([
            $f844812df082fc15$export$db40ab7c0855fa5c,
            $f844812df082fc15$export$7f4701ac5e05e39f
        ], init);
        on($f844812df082fc15$export$7e019dae5103a285, resize);
    }
    function init() {
        vertical = options.direction === $f844812df082fc15$export$97170d9824b89709;
        $f844812df082fc15$var$style(root, "maxWidth", $f844812df082fc15$var$unit(options.width));
        $f844812df082fc15$var$style(track, resolve("paddingLeft"), cssPadding(false));
        $f844812df082fc15$var$style(track, resolve("paddingRight"), cssPadding(true));
        resize(true);
    }
    function resize(force) {
        var newRect = $f844812df082fc15$var$rect(root);
        if (force || rootRect.width !== newRect.width || rootRect.height !== newRect.height) {
            $f844812df082fc15$var$style(track, "height", cssTrackHeight());
            styleSlides(resolve("marginRight"), $f844812df082fc15$var$unit(options.gap));
            styleSlides("width", cssSlideWidth());
            styleSlides("height", cssSlideHeight(), true);
            rootRect = newRect;
            emit($f844812df082fc15$export$d637eba1e9e28482);
            if (overflow !== (overflow = isOverflow())) {
                $f844812df082fc15$var$toggleClass(root, $f844812df082fc15$export$cd908cd1dd625e29, overflow);
                emit($f844812df082fc15$export$6cbac5b662a31e1b, overflow);
            }
        }
    }
    function cssPadding(right) {
        var padding = options.padding;
        var prop = resolve(right ? "right" : "left");
        return padding && $f844812df082fc15$var$unit(padding[prop] || ($f844812df082fc15$var$isObject(padding) ? 0 : padding)) || "0px";
    }
    function cssTrackHeight() {
        var height = "";
        if (vertical) {
            height = cssHeight();
            $f844812df082fc15$var$assert(height, "height or heightRatio is missing.");
            height = "calc(" + height + " - " + cssPadding(false) + " - " + cssPadding(true) + ")";
        }
        return height;
    }
    function cssHeight() {
        return $f844812df082fc15$var$unit(options.height || $f844812df082fc15$var$rect(list).width * options.heightRatio);
    }
    function cssSlideWidth() {
        return options.autoWidth ? null : $f844812df082fc15$var$unit(options.fixedWidth) || (vertical ? "" : cssSlideSize());
    }
    function cssSlideHeight() {
        return $f844812df082fc15$var$unit(options.fixedHeight) || (vertical ? options.autoHeight ? null : cssSlideSize() : cssHeight());
    }
    function cssSlideSize() {
        var gap = $f844812df082fc15$var$unit(options.gap);
        return "calc((100%" + (gap && " + " + gap) + ")/" + (options.perPage || 1) + (gap && " - " + gap) + ")";
    }
    function listSize() {
        return $f844812df082fc15$var$rect(list)[resolve("width")];
    }
    function slideSize(index, withoutGap) {
        var Slide = getAt(index || 0);
        return Slide ? $f844812df082fc15$var$rect(Slide.slide)[resolve("width")] + (withoutGap ? 0 : getGap()) : 0;
    }
    function totalSize(index, withoutGap) {
        var Slide = getAt(index);
        if (Slide) {
            var right = $f844812df082fc15$var$rect(Slide.slide)[resolve("right")];
            var left = $f844812df082fc15$var$rect(list)[resolve("left")];
            return $f844812df082fc15$var$abs(right - left) + (withoutGap ? 0 : getGap());
        }
        return 0;
    }
    function sliderSize(withoutGap) {
        return totalSize(Splide2.length - 1) - totalSize(0) + slideSize(0, withoutGap);
    }
    function getGap() {
        var Slide = getAt(0);
        return Slide && parseFloat($f844812df082fc15$var$style(Slide.slide, resolve("marginRight"))) || 0;
    }
    function getPadding(right) {
        return parseFloat($f844812df082fc15$var$style(track, resolve("padding" + (right ? "Right" : "Left")))) || 0;
    }
    function isOverflow() {
        return Splide2.is($f844812df082fc15$export$742b62a5690c060) || sliderSize(true) > listSize();
    }
    return {
        mount: mount,
        resize: resize,
        listSize: listSize,
        slideSize: slideSize,
        sliderSize: sliderSize,
        totalSize: totalSize,
        getPadding: getPadding,
        isOverflow: isOverflow
    };
}
var $f844812df082fc15$var$MULTIPLIER = 2;
function $f844812df082fc15$var$Clones(Splide2, Components2, options) {
    var event = $f844812df082fc15$export$f188226459c8a3ff(Splide2);
    var on = event.on;
    var Elements = Components2.Elements, Slides = Components2.Slides;
    var resolve = Components2.Direction.resolve;
    var clones = [];
    var cloneCount;
    function mount() {
        on($f844812df082fc15$export$7f4701ac5e05e39f, remount);
        on([
            $f844812df082fc15$export$db40ab7c0855fa5c,
            $f844812df082fc15$export$7e019dae5103a285
        ], observe);
        if (cloneCount = computeCloneCount()) {
            generate(cloneCount);
            Components2.Layout.resize(true);
        }
    }
    function remount() {
        destroy();
        mount();
    }
    function destroy() {
        $f844812df082fc15$var$remove(clones);
        $f844812df082fc15$var$empty(clones);
        event.destroy();
    }
    function observe() {
        var count = computeCloneCount();
        if (cloneCount !== count) {
            if (cloneCount < count || !count) event.emit($f844812df082fc15$export$7f4701ac5e05e39f);
        }
    }
    function generate(count) {
        var slides = Slides.get().slice();
        var length = slides.length;
        if (length) {
            while(slides.length < count)$f844812df082fc15$var$push(slides, slides);
            $f844812df082fc15$var$push(slides.slice(-count), slides.slice(0, count)).forEach(function(Slide, index) {
                var isHead = index < count;
                var clone = cloneDeep(Slide.slide, index);
                isHead ? $f844812df082fc15$var$before(clone, slides[0].slide) : $f844812df082fc15$var$append(Elements.list, clone);
                $f844812df082fc15$var$push(clones, clone);
                Slides.register(clone, index - count + (isHead ? 0 : length), Slide.index);
            });
        }
    }
    function cloneDeep(elm, index) {
        var clone = elm.cloneNode(true);
        $f844812df082fc15$var$addClass(clone, options.classes.clone);
        clone.id = Splide2.root.id + "-clone" + $f844812df082fc15$var$pad(index + 1);
        return clone;
    }
    function computeCloneCount() {
        var clones2 = options.clones;
        if (!Splide2.is($f844812df082fc15$export$f42383286ed1223d)) clones2 = 0;
        else if ($f844812df082fc15$var$isUndefined(clones2)) {
            var fixedSize = options[resolve("fixedWidth")] && Components2.Layout.slideSize(0);
            var fixedCount = fixedSize && $f844812df082fc15$var$ceil($f844812df082fc15$var$rect(Elements.track)[resolve("width")] / fixedSize);
            clones2 = fixedCount || options[resolve("autoWidth")] && Splide2.length || options.perPage * $f844812df082fc15$var$MULTIPLIER;
        }
        return clones2;
    }
    return {
        mount: mount,
        destroy: destroy
    };
}
function $f844812df082fc15$var$Move(Splide2, Components2, options) {
    var _EventInterface4 = $f844812df082fc15$export$f188226459c8a3ff(Splide2), on = _EventInterface4.on, emit = _EventInterface4.emit;
    var set = Splide2.state.set;
    var _Components2$Layout = Components2.Layout, slideSize = _Components2$Layout.slideSize, getPadding = _Components2$Layout.getPadding, totalSize = _Components2$Layout.totalSize, listSize = _Components2$Layout.listSize, sliderSize = _Components2$Layout.sliderSize;
    var _Components2$Directio = Components2.Direction, resolve = _Components2$Directio.resolve, orient = _Components2$Directio.orient;
    var _Components2$Elements3 = Components2.Elements, list = _Components2$Elements3.list, track = _Components2$Elements3.track;
    var Transition;
    function mount() {
        Transition = Components2.Transition;
        on([
            $f844812df082fc15$export$d300dc1a2634364b,
            $f844812df082fc15$export$d637eba1e9e28482,
            $f844812df082fc15$export$db40ab7c0855fa5c,
            $f844812df082fc15$export$7f4701ac5e05e39f
        ], reposition);
    }
    function reposition() {
        if (!Components2.Controller.isBusy()) {
            Components2.Scroll.cancel();
            jump(Splide2.index);
            Components2.Slides.update();
        }
    }
    function move(dest, index, prev, callback) {
        if (dest !== index && canShift(dest > prev)) {
            cancel();
            translate(shift(getPosition(), dest > prev), true);
        }
        set($f844812df082fc15$var$MOVING);
        emit($f844812df082fc15$export$2aa493d7c3275167, index, prev, dest);
        Transition.start(index, function() {
            set($f844812df082fc15$var$IDLE);
            emit($f844812df082fc15$export$fe5802204b967f0d, index, prev, dest);
            callback && callback();
        });
    }
    function jump(index) {
        translate(toPosition(index, true));
    }
    function translate(position, preventLoop) {
        if (!Splide2.is($f844812df082fc15$export$742b62a5690c060)) {
            var destination = preventLoop ? position : loop(position);
            $f844812df082fc15$var$style(list, "transform", "translate" + resolve("X") + "(" + destination + "px)");
            position !== destination && emit($f844812df082fc15$export$f0af896383d5adff);
        }
    }
    function loop(position) {
        if (Splide2.is($f844812df082fc15$export$f42383286ed1223d)) {
            var index = toIndex(position);
            var exceededMax = index > Components2.Controller.getEnd();
            var exceededMin = index < 0;
            if (exceededMin || exceededMax) position = shift(position, exceededMax);
        }
        return position;
    }
    function shift(position, backwards) {
        var excess = position - getLimit(backwards);
        var size = sliderSize();
        position -= orient(size * ($f844812df082fc15$var$ceil($f844812df082fc15$var$abs(excess) / size) || 1)) * (backwards ? 1 : -1);
        return position;
    }
    function cancel() {
        translate(getPosition(), true);
        Transition.cancel();
    }
    function toIndex(position) {
        var Slides = Components2.Slides.get();
        var index = 0;
        var minDistance = Infinity;
        for(var i = 0; i < Slides.length; i++){
            var slideIndex = Slides[i].index;
            var distance = $f844812df082fc15$var$abs(toPosition(slideIndex, true) - position);
            if (distance <= minDistance) {
                minDistance = distance;
                index = slideIndex;
            } else break;
        }
        return index;
    }
    function toPosition(index, trimming) {
        var position = orient(totalSize(index - 1) - offset(index));
        return trimming ? trim(position) : position;
    }
    function getPosition() {
        var left = resolve("left");
        return $f844812df082fc15$var$rect(list)[left] - $f844812df082fc15$var$rect(track)[left] + orient(getPadding(false));
    }
    function trim(position) {
        if (options.trimSpace && Splide2.is($f844812df082fc15$export$e5a58a5ee5b54c22)) position = $f844812df082fc15$var$clamp(position, 0, orient(sliderSize(true) - listSize()));
        return position;
    }
    function offset(index) {
        var focus = options.focus;
        return focus === "center" ? (listSize() - slideSize(index, true)) / 2 : +focus * slideSize(index) || 0;
    }
    function getLimit(max) {
        return toPosition(max ? Components2.Controller.getEnd() : 0, !!options.trimSpace);
    }
    function canShift(backwards) {
        var shifted = orient(shift(getPosition(), backwards));
        return backwards ? shifted >= 0 : shifted <= list[resolve("scrollWidth")] - $f844812df082fc15$var$rect(track)[resolve("width")];
    }
    function exceededLimit(max, position) {
        position = $f844812df082fc15$var$isUndefined(position) ? getPosition() : position;
        var exceededMin = max !== true && orient(position) < orient(getLimit(false));
        var exceededMax = max !== false && orient(position) > orient(getLimit(true));
        return exceededMin || exceededMax;
    }
    return {
        mount: mount,
        move: move,
        jump: jump,
        translate: translate,
        shift: shift,
        cancel: cancel,
        toIndex: toIndex,
        toPosition: toPosition,
        getPosition: getPosition,
        getLimit: getLimit,
        exceededLimit: exceededLimit,
        reposition: reposition
    };
}
function $f844812df082fc15$var$Controller(Splide2, Components2, options) {
    var _EventInterface5 = $f844812df082fc15$export$f188226459c8a3ff(Splide2), on = _EventInterface5.on, emit = _EventInterface5.emit;
    var Move = Components2.Move;
    var getPosition = Move.getPosition, getLimit = Move.getLimit, toPosition = Move.toPosition;
    var _Components2$Slides = Components2.Slides, isEnough = _Components2$Slides.isEnough, getLength = _Components2$Slides.getLength;
    var omitEnd = options.omitEnd;
    var isLoop = Splide2.is($f844812df082fc15$export$f42383286ed1223d);
    var isSlide = Splide2.is($f844812df082fc15$export$e5a58a5ee5b54c22);
    var getNext = $f844812df082fc15$var$apply(getAdjacent, false);
    var getPrev = $f844812df082fc15$var$apply(getAdjacent, true);
    var currIndex = options.start || 0;
    var endIndex;
    var prevIndex = currIndex;
    var slideCount;
    var perMove;
    var perPage;
    function mount() {
        init();
        on([
            $f844812df082fc15$export$db40ab7c0855fa5c,
            $f844812df082fc15$export$7f4701ac5e05e39f,
            $f844812df082fc15$export$28dea85f216954dc
        ], init);
        on($f844812df082fc15$export$d637eba1e9e28482, onResized);
    }
    function init() {
        slideCount = getLength(true);
        perMove = options.perMove;
        perPage = options.perPage;
        endIndex = getEnd();
        var index = $f844812df082fc15$var$clamp(currIndex, 0, omitEnd ? endIndex : slideCount - 1);
        if (index !== currIndex) {
            currIndex = index;
            Move.reposition();
        }
    }
    function onResized() {
        if (endIndex !== getEnd()) emit($f844812df082fc15$export$28dea85f216954dc);
    }
    function go(control, allowSameIndex, callback) {
        if (!isBusy()) {
            var dest = parse(control);
            var index = loop(dest);
            if (index > -1 && (allowSameIndex || index !== currIndex)) {
                setIndex(index);
                Move.move(dest, index, prevIndex, callback);
            }
        }
    }
    function scroll(destination, duration, snap, callback) {
        Components2.Scroll.scroll(destination, duration, snap, function() {
            var index = loop(Move.toIndex(getPosition()));
            setIndex(omitEnd ? $f844812df082fc15$var$min(index, endIndex) : index);
            callback && callback();
        });
    }
    function parse(control) {
        var index = currIndex;
        if ($f844812df082fc15$var$isString(control)) {
            var _ref = control.match(/([+\-<>])(\d+)?/) || [], indicator = _ref[1], number = _ref[2];
            if (indicator === "+" || indicator === "-") index = computeDestIndex(currIndex + +("" + indicator + (+number || 1)), currIndex);
            else if (indicator === ">") index = number ? toIndex(+number) : getNext(true);
            else if (indicator === "<") index = getPrev(true);
        } else index = isLoop ? control : $f844812df082fc15$var$clamp(control, 0, endIndex);
        return index;
    }
    function getAdjacent(prev, destination) {
        var number = perMove || (hasFocus() ? 1 : perPage);
        var dest = computeDestIndex(currIndex + number * (prev ? -1 : 1), currIndex, !(perMove || hasFocus()));
        if (dest === -1 && isSlide) {
            if (!$f844812df082fc15$var$approximatelyEqual(getPosition(), getLimit(!prev), 1)) return prev ? 0 : endIndex;
        }
        return destination ? dest : loop(dest);
    }
    function computeDestIndex(dest, from, snapPage) {
        if (isEnough() || hasFocus()) {
            var index = computeMovableDestIndex(dest);
            if (index !== dest) {
                from = dest;
                dest = index;
                snapPage = false;
            }
            if (dest < 0 || dest > endIndex) {
                if (!perMove && ($f844812df082fc15$var$between(0, dest, from, true) || $f844812df082fc15$var$between(endIndex, from, dest, true))) dest = toIndex(toPage(dest));
                else {
                    if (isLoop) dest = snapPage ? dest < 0 ? -(slideCount % perPage || perPage) : slideCount : dest;
                    else if (options.rewind) dest = dest < 0 ? endIndex : 0;
                    else dest = -1;
                }
            } else if (snapPage && dest !== from) dest = toIndex(toPage(from) + (dest < from ? -1 : 1));
        } else dest = -1;
        return dest;
    }
    function computeMovableDestIndex(dest) {
        if (isSlide && options.trimSpace === "move" && dest !== currIndex) {
            var position = getPosition();
            while(position === toPosition(dest, true) && $f844812df082fc15$var$between(dest, 0, Splide2.length - 1, !options.rewind))dest < currIndex ? --dest : ++dest;
        }
        return dest;
    }
    function loop(index) {
        return isLoop ? (index + slideCount) % slideCount || 0 : index;
    }
    function getEnd() {
        var end = slideCount - (hasFocus() || isLoop && perMove ? 1 : perPage);
        while(omitEnd && end-- > 0)if (toPosition(slideCount - 1, true) !== toPosition(end, true)) {
            end++;
            break;
        }
        return $f844812df082fc15$var$clamp(end, 0, slideCount - 1);
    }
    function toIndex(page) {
        return $f844812df082fc15$var$clamp(hasFocus() ? page : perPage * page, 0, endIndex);
    }
    function toPage(index) {
        return hasFocus() ? $f844812df082fc15$var$min(index, endIndex) : $f844812df082fc15$var$floor((index >= endIndex ? slideCount - 1 : index) / perPage);
    }
    function toDest(destination) {
        var closest = Move.toIndex(destination);
        return isSlide ? $f844812df082fc15$var$clamp(closest, 0, endIndex) : closest;
    }
    function setIndex(index) {
        if (index !== currIndex) {
            prevIndex = currIndex;
            currIndex = index;
        }
    }
    function getIndex(prev) {
        return prev ? prevIndex : currIndex;
    }
    function hasFocus() {
        return !$f844812df082fc15$var$isUndefined(options.focus) || options.isNavigation;
    }
    function isBusy() {
        return Splide2.state.is([
            $f844812df082fc15$var$MOVING,
            $f844812df082fc15$var$SCROLLING
        ]) && !!options.waitForTransition;
    }
    return {
        mount: mount,
        go: go,
        scroll: scroll,
        getNext: getNext,
        getPrev: getPrev,
        getAdjacent: getAdjacent,
        getEnd: getEnd,
        setIndex: setIndex,
        getIndex: getIndex,
        toIndex: toIndex,
        toPage: toPage,
        toDest: toDest,
        hasFocus: hasFocus,
        isBusy: isBusy
    };
}
var $f844812df082fc15$var$XML_NAME_SPACE = "http://www.w3.org/2000/svg";
var $f844812df082fc15$var$PATH = "m15.5 0.932-4.3 4.38 14.5 14.6-14.5 14.5 4.3 4.4 14.6-14.6 4.4-4.3-4.4-4.4-14.6-14.6z";
var $f844812df082fc15$var$SIZE = 40;
function $f844812df082fc15$var$Arrows(Splide2, Components2, options) {
    var event = $f844812df082fc15$export$f188226459c8a3ff(Splide2);
    var on = event.on, bind = event.bind, emit = event.emit;
    var classes = options.classes, i18n = options.i18n;
    var Elements = Components2.Elements, Controller = Components2.Controller;
    var placeholder = Elements.arrows, track = Elements.track;
    var wrapper = placeholder;
    var prev = Elements.prev;
    var next = Elements.next;
    var created;
    var wrapperClasses;
    var arrows = {};
    function mount() {
        init();
        on($f844812df082fc15$export$db40ab7c0855fa5c, remount);
    }
    function remount() {
        destroy();
        mount();
    }
    function init() {
        var enabled = options.arrows;
        if (enabled && !(prev && next)) createArrows();
        if (prev && next) {
            $f844812df082fc15$var$assign(arrows, {
                prev: prev,
                next: next
            });
            $f844812df082fc15$var$display(wrapper, enabled ? "" : "none");
            $f844812df082fc15$var$addClass(wrapper, wrapperClasses = $f844812df082fc15$export$a26cbd955fecf11e + "--" + options.direction);
            if (enabled) {
                listen();
                update();
                $f844812df082fc15$var$setAttribute([
                    prev,
                    next
                ], $f844812df082fc15$var$ARIA_CONTROLS, track.id);
                emit($f844812df082fc15$export$8647f6b043e04e9d, prev, next);
            }
        }
    }
    function destroy() {
        event.destroy();
        $f844812df082fc15$var$removeClass(wrapper, wrapperClasses);
        if (created) {
            $f844812df082fc15$var$remove(placeholder ? [
                prev,
                next
            ] : wrapper);
            prev = next = null;
        } else $f844812df082fc15$var$removeAttribute([
            prev,
            next
        ], $f844812df082fc15$var$ALL_ATTRIBUTES);
    }
    function listen() {
        on([
            $f844812df082fc15$export$d300dc1a2634364b,
            $f844812df082fc15$export$fe5802204b967f0d,
            $f844812df082fc15$export$7f4701ac5e05e39f,
            $f844812df082fc15$export$ff8164bff3202b9,
            $f844812df082fc15$export$28dea85f216954dc
        ], update);
        bind(next, "click", $f844812df082fc15$var$apply(go, ">"));
        bind(prev, "click", $f844812df082fc15$var$apply(go, "<"));
    }
    function go(control) {
        Controller.go(control, true);
    }
    function createArrows() {
        wrapper = placeholder || $f844812df082fc15$var$create("div", classes.arrows);
        prev = createArrow(true);
        next = createArrow(false);
        created = true;
        $f844812df082fc15$var$append(wrapper, [
            prev,
            next
        ]);
        !placeholder && $f844812df082fc15$var$before(wrapper, track);
    }
    function createArrow(prev2) {
        var arrow = "<button class=\"" + classes.arrow + " " + (prev2 ? classes.prev : classes.next) + "\" type=\"button\"><svg xmlns=\"" + $f844812df082fc15$var$XML_NAME_SPACE + "\" viewBox=\"0 0 " + $f844812df082fc15$var$SIZE + " " + $f844812df082fc15$var$SIZE + "\" width=\"" + $f844812df082fc15$var$SIZE + "\" height=\"" + $f844812df082fc15$var$SIZE + "\" focusable=\"false\"><path d=\"" + (options.arrowPath || $f844812df082fc15$var$PATH) + "\" />";
        return $f844812df082fc15$var$parseHtml(arrow);
    }
    function update() {
        if (prev && next) {
            var index = Splide2.index;
            var prevIndex = Controller.getPrev();
            var nextIndex = Controller.getNext();
            var prevLabel = prevIndex > -1 && index < prevIndex ? i18n.last : i18n.prev;
            var nextLabel = nextIndex > -1 && index > nextIndex ? i18n.first : i18n.next;
            prev.disabled = prevIndex < 0;
            next.disabled = nextIndex < 0;
            $f844812df082fc15$var$setAttribute(prev, $f844812df082fc15$var$ARIA_LABEL, prevLabel);
            $f844812df082fc15$var$setAttribute(next, $f844812df082fc15$var$ARIA_LABEL, nextLabel);
            emit($f844812df082fc15$export$d467f9343b961f75, prev, next, prevIndex, nextIndex);
        }
    }
    return {
        arrows: arrows,
        mount: mount,
        destroy: destroy,
        update: update
    };
}
var $f844812df082fc15$var$INTERVAL_DATA_ATTRIBUTE = $f844812df082fc15$var$DATA_ATTRIBUTE + "-interval";
function $f844812df082fc15$var$Autoplay(Splide2, Components2, options) {
    var _EventInterface6 = $f844812df082fc15$export$f188226459c8a3ff(Splide2), on = _EventInterface6.on, bind = _EventInterface6.bind, emit = _EventInterface6.emit;
    var interval = $f844812df082fc15$export$46ad21b25b6dccf0(options.interval, Splide2.go.bind(Splide2, ">"), onAnimationFrame);
    var isPaused = interval.isPaused;
    var Elements = Components2.Elements, _Components2$Elements4 = Components2.Elements, root = _Components2$Elements4.root, toggle = _Components2$Elements4.toggle;
    var autoplay = options.autoplay;
    var hovered;
    var focused;
    var stopped = autoplay === "pause";
    function mount() {
        if (autoplay) {
            listen();
            toggle && $f844812df082fc15$var$setAttribute(toggle, $f844812df082fc15$var$ARIA_CONTROLS, Elements.track.id);
            stopped || play();
            update();
        }
    }
    function listen() {
        if (options.pauseOnHover) bind(root, "mouseenter mouseleave", function(e) {
            hovered = e.type === "mouseenter";
            autoToggle();
        });
        if (options.pauseOnFocus) bind(root, "focusin focusout", function(e) {
            focused = e.type === "focusin";
            autoToggle();
        });
        if (toggle) bind(toggle, "click", function() {
            stopped ? play() : pause(true);
        });
        on([
            $f844812df082fc15$export$2aa493d7c3275167,
            $f844812df082fc15$export$49801896908b5e33,
            $f844812df082fc15$export$7f4701ac5e05e39f
        ], interval.rewind);
        on($f844812df082fc15$export$2aa493d7c3275167, onMove);
    }
    function play() {
        if (isPaused() && Components2.Slides.isEnough()) {
            interval.start(!options.resetProgress);
            focused = hovered = stopped = false;
            update();
            emit($f844812df082fc15$export$23663268a31b79e2);
        }
    }
    function pause(stop) {
        if (stop === void 0) stop = true;
        stopped = !!stop;
        update();
        if (!isPaused()) {
            interval.pause();
            emit($f844812df082fc15$export$16a1e4f3d0368265);
        }
    }
    function autoToggle() {
        if (!stopped) hovered || focused ? pause(false) : play();
    }
    function update() {
        if (toggle) {
            $f844812df082fc15$var$toggleClass(toggle, $f844812df082fc15$export$72d36ecf3758cb4b, !stopped);
            $f844812df082fc15$var$setAttribute(toggle, $f844812df082fc15$var$ARIA_LABEL, options.i18n[stopped ? "play" : "pause"]);
        }
    }
    function onAnimationFrame(rate) {
        var bar = Elements.bar;
        bar && $f844812df082fc15$var$style(bar, "width", rate * 100 + "%");
        emit($f844812df082fc15$export$185723258309b608, rate);
    }
    function onMove(index) {
        var Slide = Components2.Slides.getAt(index);
        interval.set(Slide && +$f844812df082fc15$var$getAttribute(Slide.slide, $f844812df082fc15$var$INTERVAL_DATA_ATTRIBUTE) || options.interval);
    }
    return {
        mount: mount,
        destroy: interval.cancel,
        play: play,
        pause: pause,
        isPaused: isPaused
    };
}
function $f844812df082fc15$var$Cover(Splide2, Components2, options) {
    var _EventInterface7 = $f844812df082fc15$export$f188226459c8a3ff(Splide2), on = _EventInterface7.on;
    function mount() {
        if (options.cover) {
            on($f844812df082fc15$export$9f64346e17f0ec8e, $f844812df082fc15$var$apply(toggle, true));
            on([
                $f844812df082fc15$export$d300dc1a2634364b,
                $f844812df082fc15$export$db40ab7c0855fa5c,
                $f844812df082fc15$export$7f4701ac5e05e39f
            ], $f844812df082fc15$var$apply(cover, true));
        }
    }
    function cover(cover2) {
        Components2.Slides.forEach(function(Slide) {
            var img = $f844812df082fc15$var$child(Slide.container || Slide.slide, "img");
            if (img && img.src) toggle(cover2, img, Slide);
        });
    }
    function toggle(cover2, img, Slide) {
        Slide.style("background", cover2 ? "center/cover no-repeat url(\"" + img.src + "\")" : "", true);
        $f844812df082fc15$var$display(img, cover2 ? "none" : "");
    }
    return {
        mount: mount,
        destroy: $f844812df082fc15$var$apply(cover, false)
    };
}
var $f844812df082fc15$var$BOUNCE_DIFF_THRESHOLD = 10;
var $f844812df082fc15$var$BOUNCE_DURATION = 600;
var $f844812df082fc15$var$FRICTION_FACTOR = 0.6;
var $f844812df082fc15$var$BASE_VELOCITY = 1.5;
var $f844812df082fc15$var$MIN_DURATION = 800;
function $f844812df082fc15$var$Scroll(Splide2, Components2, options) {
    var _EventInterface8 = $f844812df082fc15$export$f188226459c8a3ff(Splide2), on = _EventInterface8.on, emit = _EventInterface8.emit;
    var set = Splide2.state.set;
    var Move = Components2.Move;
    var getPosition = Move.getPosition, getLimit = Move.getLimit, exceededLimit = Move.exceededLimit, translate = Move.translate;
    var isSlide = Splide2.is($f844812df082fc15$export$e5a58a5ee5b54c22);
    var interval;
    var callback;
    var friction = 1;
    function mount() {
        on($f844812df082fc15$export$2aa493d7c3275167, clear);
        on([
            $f844812df082fc15$export$db40ab7c0855fa5c,
            $f844812df082fc15$export$7f4701ac5e05e39f
        ], cancel);
    }
    function scroll(destination, duration, snap, onScrolled, noConstrain) {
        var from = getPosition();
        clear();
        if (snap && (!isSlide || !exceededLimit())) {
            var size = Components2.Layout.sliderSize();
            var offset = $f844812df082fc15$var$sign(destination) * size * $f844812df082fc15$var$floor($f844812df082fc15$var$abs(destination) / size) || 0;
            destination = Move.toPosition(Components2.Controller.toDest(destination % size)) + offset;
        }
        var noDistance = $f844812df082fc15$var$approximatelyEqual(from, destination, 1);
        friction = 1;
        duration = noDistance ? 0 : duration || $f844812df082fc15$var$max($f844812df082fc15$var$abs(destination - from) / $f844812df082fc15$var$BASE_VELOCITY, $f844812df082fc15$var$MIN_DURATION);
        callback = onScrolled;
        interval = $f844812df082fc15$export$46ad21b25b6dccf0(duration, onEnd, $f844812df082fc15$var$apply(update, from, destination, noConstrain), 1);
        set($f844812df082fc15$var$SCROLLING);
        emit($f844812df082fc15$export$49801896908b5e33);
        interval.start();
    }
    function onEnd() {
        set($f844812df082fc15$var$IDLE);
        callback && callback();
        emit($f844812df082fc15$export$ff8164bff3202b9);
    }
    function update(from, to, noConstrain, rate) {
        var position = getPosition();
        var target = from + (to - from) * easing(rate);
        var diff = (target - position) * friction;
        translate(position + diff);
        if (isSlide && !noConstrain && exceededLimit()) {
            friction *= $f844812df082fc15$var$FRICTION_FACTOR;
            if ($f844812df082fc15$var$abs(diff) < $f844812df082fc15$var$BOUNCE_DIFF_THRESHOLD) scroll(getLimit(exceededLimit(true)), $f844812df082fc15$var$BOUNCE_DURATION, false, callback, true);
        }
    }
    function clear() {
        if (interval) interval.cancel();
    }
    function cancel() {
        if (interval && !interval.isPaused()) {
            clear();
            onEnd();
        }
    }
    function easing(t) {
        var easingFunc = options.easingFunc;
        return easingFunc ? easingFunc(t) : 1 - Math.pow(1 - t, 4);
    }
    return {
        mount: mount,
        destroy: clear,
        scroll: scroll,
        cancel: cancel
    };
}
var $f844812df082fc15$var$SCROLL_LISTENER_OPTIONS = {
    passive: false,
    capture: true
};
function $f844812df082fc15$var$Drag(Splide2, Components2, options) {
    var _EventInterface9 = $f844812df082fc15$export$f188226459c8a3ff(Splide2), on = _EventInterface9.on, emit = _EventInterface9.emit, bind = _EventInterface9.bind, unbind = _EventInterface9.unbind;
    var state = Splide2.state;
    var Move = Components2.Move, Scroll = Components2.Scroll, Controller = Components2.Controller, track = Components2.Elements.track, reduce = Components2.Media.reduce;
    var _Components2$Directio2 = Components2.Direction, resolve = _Components2$Directio2.resolve, orient = _Components2$Directio2.orient;
    var getPosition = Move.getPosition, exceededLimit = Move.exceededLimit;
    var basePosition;
    var baseEvent;
    var prevBaseEvent;
    var isFree;
    var dragging;
    var exceeded = false;
    var clickPrevented;
    var disabled;
    var target;
    function mount() {
        bind(track, $f844812df082fc15$var$POINTER_MOVE_EVENTS, $f844812df082fc15$var$noop, $f844812df082fc15$var$SCROLL_LISTENER_OPTIONS);
        bind(track, $f844812df082fc15$var$POINTER_UP_EVENTS, $f844812df082fc15$var$noop, $f844812df082fc15$var$SCROLL_LISTENER_OPTIONS);
        bind(track, $f844812df082fc15$var$POINTER_DOWN_EVENTS, onPointerDown, $f844812df082fc15$var$SCROLL_LISTENER_OPTIONS);
        bind(track, "click", onClick, {
            capture: true
        });
        bind(track, "dragstart", $f844812df082fc15$var$prevent);
        on([
            $f844812df082fc15$export$d300dc1a2634364b,
            $f844812df082fc15$export$db40ab7c0855fa5c
        ], init);
    }
    function init() {
        var drag = options.drag;
        disable(!drag);
        isFree = drag === "free";
    }
    function onPointerDown(e) {
        clickPrevented = false;
        if (!disabled) {
            var isTouch = isTouchEvent(e);
            if (isDraggable(e.target) && (isTouch || !e.button)) {
                if (!Controller.isBusy()) {
                    target = isTouch ? track : window;
                    dragging = state.is([
                        $f844812df082fc15$var$MOVING,
                        $f844812df082fc15$var$SCROLLING
                    ]);
                    prevBaseEvent = null;
                    bind(target, $f844812df082fc15$var$POINTER_MOVE_EVENTS, onPointerMove, $f844812df082fc15$var$SCROLL_LISTENER_OPTIONS);
                    bind(target, $f844812df082fc15$var$POINTER_UP_EVENTS, onPointerUp, $f844812df082fc15$var$SCROLL_LISTENER_OPTIONS);
                    Move.cancel();
                    Scroll.cancel();
                    save(e);
                } else $f844812df082fc15$var$prevent(e, true);
            }
        }
    }
    function onPointerMove(e) {
        if (!state.is($f844812df082fc15$var$DRAGGING)) {
            state.set($f844812df082fc15$var$DRAGGING);
            emit($f844812df082fc15$export$e84bf5065c9087ac);
        }
        if (e.cancelable) {
            if (dragging) {
                Move.translate(basePosition + constrain(diffCoord(e)));
                var expired = diffTime(e) > $f844812df082fc15$var$LOG_INTERVAL;
                var hasExceeded = exceeded !== (exceeded = exceededLimit());
                if (expired || hasExceeded) save(e);
                clickPrevented = true;
                emit($f844812df082fc15$export$8e9f636d2c722196);
                $f844812df082fc15$var$prevent(e);
            } else if (isSliderDirection(e)) {
                dragging = shouldStart(e);
                $f844812df082fc15$var$prevent(e);
            }
        }
    }
    function onPointerUp(e) {
        if (state.is($f844812df082fc15$var$DRAGGING)) {
            state.set($f844812df082fc15$var$IDLE);
            emit($f844812df082fc15$export$90ea576bd3fdeb60);
        }
        if (dragging) {
            move(e);
            $f844812df082fc15$var$prevent(e);
        }
        unbind(target, $f844812df082fc15$var$POINTER_MOVE_EVENTS, onPointerMove);
        unbind(target, $f844812df082fc15$var$POINTER_UP_EVENTS, onPointerUp);
        dragging = false;
    }
    function onClick(e) {
        if (!disabled && clickPrevented) $f844812df082fc15$var$prevent(e, true);
    }
    function save(e) {
        prevBaseEvent = baseEvent;
        baseEvent = e;
        basePosition = getPosition();
    }
    function move(e) {
        var velocity = computeVelocity(e);
        var destination = computeDestination(velocity);
        var rewind = options.rewind && options.rewindByDrag;
        reduce(false);
        if (isFree) Controller.scroll(destination, 0, options.snap);
        else if (Splide2.is($f844812df082fc15$export$742b62a5690c060)) Controller.go(orient($f844812df082fc15$var$sign(velocity)) < 0 ? rewind ? "<" : "-" : rewind ? ">" : "+");
        else if (Splide2.is($f844812df082fc15$export$e5a58a5ee5b54c22) && exceeded && rewind) Controller.go(exceededLimit(true) ? ">" : "<");
        else Controller.go(Controller.toDest(destination), true);
        reduce(true);
    }
    function shouldStart(e) {
        var thresholds = options.dragMinThreshold;
        var isObj = $f844812df082fc15$var$isObject(thresholds);
        var mouse = isObj && thresholds.mouse || 0;
        var touch = (isObj ? thresholds.touch : +thresholds) || 10;
        return $f844812df082fc15$var$abs(diffCoord(e)) > (isTouchEvent(e) ? touch : mouse);
    }
    function isSliderDirection(e) {
        return $f844812df082fc15$var$abs(diffCoord(e)) > $f844812df082fc15$var$abs(diffCoord(e, true));
    }
    function computeVelocity(e) {
        if (Splide2.is($f844812df082fc15$export$f42383286ed1223d) || !exceeded) {
            var time = diffTime(e);
            if (time && time < $f844812df082fc15$var$LOG_INTERVAL) return diffCoord(e) / time;
        }
        return 0;
    }
    function computeDestination(velocity) {
        return getPosition() + $f844812df082fc15$var$sign(velocity) * $f844812df082fc15$var$min($f844812df082fc15$var$abs(velocity) * (options.flickPower || 600), isFree ? Infinity : Components2.Layout.listSize() * (options.flickMaxPages || 1));
    }
    function diffCoord(e, orthogonal) {
        return coordOf(e, orthogonal) - coordOf(getBaseEvent(e), orthogonal);
    }
    function diffTime(e) {
        return $f844812df082fc15$var$timeOf(e) - $f844812df082fc15$var$timeOf(getBaseEvent(e));
    }
    function getBaseEvent(e) {
        return baseEvent === e && prevBaseEvent || baseEvent;
    }
    function coordOf(e, orthogonal) {
        return (isTouchEvent(e) ? e.changedTouches[0] : e)["page" + resolve(orthogonal ? "Y" : "X")];
    }
    function constrain(diff) {
        return diff / (exceeded && Splide2.is($f844812df082fc15$export$e5a58a5ee5b54c22) ? $f844812df082fc15$var$FRICTION : 1);
    }
    function isDraggable(target2) {
        var noDrag = options.noDrag;
        return !$f844812df082fc15$var$matches(target2, "." + $f844812df082fc15$export$52f2cca6a5eee805 + ", ." + $f844812df082fc15$export$516e7d18e13a2dca) && (!noDrag || !$f844812df082fc15$var$matches(target2, noDrag));
    }
    function isTouchEvent(e) {
        return typeof TouchEvent !== "undefined" && e instanceof TouchEvent;
    }
    function isDragging() {
        return dragging;
    }
    function disable(value) {
        disabled = value;
    }
    return {
        mount: mount,
        disable: disable,
        isDragging: isDragging
    };
}
var $f844812df082fc15$var$NORMALIZATION_MAP = {
    Spacebar: " ",
    Right: $f844812df082fc15$var$ARROW_RIGHT,
    Left: $f844812df082fc15$var$ARROW_LEFT,
    Up: $f844812df082fc15$var$ARROW_UP,
    Down: $f844812df082fc15$var$ARROW_DOWN
};
function $f844812df082fc15$var$normalizeKey(key) {
    key = $f844812df082fc15$var$isString(key) ? key : key.key;
    return $f844812df082fc15$var$NORMALIZATION_MAP[key] || key;
}
var $f844812df082fc15$var$KEYBOARD_EVENT = "keydown";
function $f844812df082fc15$var$Keyboard(Splide2, Components2, options) {
    var _EventInterface10 = $f844812df082fc15$export$f188226459c8a3ff(Splide2), on = _EventInterface10.on, bind = _EventInterface10.bind, unbind = _EventInterface10.unbind;
    var root = Splide2.root;
    var resolve = Components2.Direction.resolve;
    var target;
    var disabled;
    function mount() {
        init();
        on($f844812df082fc15$export$db40ab7c0855fa5c, destroy);
        on($f844812df082fc15$export$db40ab7c0855fa5c, init);
        on($f844812df082fc15$export$2aa493d7c3275167, onMove);
    }
    function init() {
        var keyboard = options.keyboard;
        if (keyboard) {
            target = keyboard === "global" ? window : root;
            bind(target, $f844812df082fc15$var$KEYBOARD_EVENT, onKeydown);
        }
    }
    function destroy() {
        unbind(target, $f844812df082fc15$var$KEYBOARD_EVENT);
    }
    function disable(value) {
        disabled = value;
    }
    function onMove() {
        var _disabled = disabled;
        disabled = true;
        $f844812df082fc15$var$nextTick(function() {
            disabled = _disabled;
        });
    }
    function onKeydown(e) {
        if (!disabled) {
            var key = $f844812df082fc15$var$normalizeKey(e);
            if (key === resolve($f844812df082fc15$var$ARROW_LEFT)) Splide2.go("<");
            else if (key === resolve($f844812df082fc15$var$ARROW_RIGHT)) Splide2.go(">");
        }
    }
    return {
        mount: mount,
        destroy: destroy,
        disable: disable
    };
}
var $f844812df082fc15$var$SRC_DATA_ATTRIBUTE = $f844812df082fc15$var$DATA_ATTRIBUTE + "-lazy";
var $f844812df082fc15$var$SRCSET_DATA_ATTRIBUTE = $f844812df082fc15$var$SRC_DATA_ATTRIBUTE + "-srcset";
var $f844812df082fc15$var$IMAGE_SELECTOR = "[" + $f844812df082fc15$var$SRC_DATA_ATTRIBUTE + "], [" + $f844812df082fc15$var$SRCSET_DATA_ATTRIBUTE + "]";
function $f844812df082fc15$var$LazyLoad(Splide2, Components2, options) {
    var _EventInterface11 = $f844812df082fc15$export$f188226459c8a3ff(Splide2), on = _EventInterface11.on, off = _EventInterface11.off, bind = _EventInterface11.bind, emit = _EventInterface11.emit;
    var isSequential = options.lazyLoad === "sequential";
    var events = [
        $f844812df082fc15$export$fe5802204b967f0d,
        $f844812df082fc15$export$ff8164bff3202b9
    ];
    var entries = [];
    function mount() {
        if (options.lazyLoad) {
            init();
            on($f844812df082fc15$export$7f4701ac5e05e39f, init);
        }
    }
    function init() {
        $f844812df082fc15$var$empty(entries);
        register();
        if (isSequential) loadNext();
        else {
            off(events);
            on(events, check);
            check();
        }
    }
    function register() {
        Components2.Slides.forEach(function(Slide) {
            $f844812df082fc15$var$queryAll(Slide.slide, $f844812df082fc15$var$IMAGE_SELECTOR).forEach(function(img) {
                var src = $f844812df082fc15$var$getAttribute(img, $f844812df082fc15$var$SRC_DATA_ATTRIBUTE);
                var srcset = $f844812df082fc15$var$getAttribute(img, $f844812df082fc15$var$SRCSET_DATA_ATTRIBUTE);
                if (src !== img.src || srcset !== img.srcset) {
                    var className = options.classes.spinner;
                    var parent = img.parentElement;
                    var spinner = $f844812df082fc15$var$child(parent, "." + className) || $f844812df082fc15$var$create("span", className, parent);
                    entries.push([
                        img,
                        Slide,
                        spinner
                    ]);
                    img.src || $f844812df082fc15$var$display(img, "none");
                }
            });
        });
    }
    function check() {
        entries = entries.filter(function(data) {
            var distance = options.perPage * ((options.preloadPages || 1) + 1) - 1;
            return data[1].isWithin(Splide2.index, distance) ? load(data) : true;
        });
        entries.length || off(events);
    }
    function load(data) {
        var img = data[0];
        $f844812df082fc15$var$addClass(data[1].slide, $f844812df082fc15$export$d22ec4ccb7996ba2);
        bind(img, "load error", $f844812df082fc15$var$apply(onLoad, data));
        $f844812df082fc15$var$setAttribute(img, "src", $f844812df082fc15$var$getAttribute(img, $f844812df082fc15$var$SRC_DATA_ATTRIBUTE));
        $f844812df082fc15$var$setAttribute(img, "srcset", $f844812df082fc15$var$getAttribute(img, $f844812df082fc15$var$SRCSET_DATA_ATTRIBUTE));
        $f844812df082fc15$var$removeAttribute(img, $f844812df082fc15$var$SRC_DATA_ATTRIBUTE);
        $f844812df082fc15$var$removeAttribute(img, $f844812df082fc15$var$SRCSET_DATA_ATTRIBUTE);
    }
    function onLoad(data, e) {
        var img = data[0], Slide = data[1];
        $f844812df082fc15$var$removeClass(Slide.slide, $f844812df082fc15$export$d22ec4ccb7996ba2);
        if (e.type !== "error") {
            $f844812df082fc15$var$remove(data[2]);
            $f844812df082fc15$var$display(img, "");
            emit($f844812df082fc15$export$9f64346e17f0ec8e, img, Slide);
            emit($f844812df082fc15$export$7e019dae5103a285);
        }
        isSequential && loadNext();
    }
    function loadNext() {
        entries.length && load(entries.shift());
    }
    return {
        mount: mount,
        destroy: $f844812df082fc15$var$apply($f844812df082fc15$var$empty, entries),
        check: check
    };
}
function $f844812df082fc15$var$Pagination(Splide2, Components2, options) {
    var event = $f844812df082fc15$export$f188226459c8a3ff(Splide2);
    var on = event.on, emit = event.emit, bind = event.bind;
    var Slides = Components2.Slides, Elements = Components2.Elements, Controller = Components2.Controller;
    var hasFocus = Controller.hasFocus, getIndex = Controller.getIndex, go = Controller.go;
    var resolve = Components2.Direction.resolve;
    var placeholder = Elements.pagination;
    var items = [];
    var list;
    var paginationClasses;
    function mount() {
        destroy();
        on([
            $f844812df082fc15$export$db40ab7c0855fa5c,
            $f844812df082fc15$export$7f4701ac5e05e39f,
            $f844812df082fc15$export$28dea85f216954dc
        ], mount);
        var enabled = options.pagination;
        placeholder && $f844812df082fc15$var$display(placeholder, enabled ? "" : "none");
        if (enabled) {
            on([
                $f844812df082fc15$export$2aa493d7c3275167,
                $f844812df082fc15$export$49801896908b5e33,
                $f844812df082fc15$export$ff8164bff3202b9
            ], update);
            createPagination();
            update();
            emit($f844812df082fc15$export$bf89a4e4349c9778, {
                list: list,
                items: items
            }, getAt(Splide2.index));
        }
    }
    function destroy() {
        if (list) {
            $f844812df082fc15$var$remove(placeholder ? $f844812df082fc15$var$slice(list.children) : list);
            $f844812df082fc15$var$removeClass(list, paginationClasses);
            $f844812df082fc15$var$empty(items);
            list = null;
        }
        event.destroy();
    }
    function createPagination() {
        var length = Splide2.length;
        var classes = options.classes, i18n = options.i18n, perPage = options.perPage;
        var max = hasFocus() ? Controller.getEnd() + 1 : $f844812df082fc15$var$ceil(length / perPage);
        list = placeholder || $f844812df082fc15$var$create("ul", classes.pagination, Elements.track.parentElement);
        $f844812df082fc15$var$addClass(list, paginationClasses = $f844812df082fc15$export$cbf8e5a0ab95eda3 + "--" + getDirection());
        $f844812df082fc15$var$setAttribute(list, $f844812df082fc15$var$ROLE, "tablist");
        $f844812df082fc15$var$setAttribute(list, $f844812df082fc15$var$ARIA_LABEL, i18n.select);
        $f844812df082fc15$var$setAttribute(list, $f844812df082fc15$var$ARIA_ORIENTATION, getDirection() === $f844812df082fc15$export$97170d9824b89709 ? "vertical" : "");
        for(var i = 0; i < max; i++){
            var li = $f844812df082fc15$var$create("li", null, list);
            var button = $f844812df082fc15$var$create("button", {
                class: classes.page,
                type: "button"
            }, li);
            var controls = Slides.getIn(i).map(function(Slide) {
                return Slide.slide.id;
            });
            var text = !hasFocus() && perPage > 1 ? i18n.pageX : i18n.slideX;
            bind(button, "click", $f844812df082fc15$var$apply(onClick, i));
            if (options.paginationKeyboard) bind(button, "keydown", $f844812df082fc15$var$apply(onKeydown, i));
            $f844812df082fc15$var$setAttribute(li, $f844812df082fc15$var$ROLE, "presentation");
            $f844812df082fc15$var$setAttribute(button, $f844812df082fc15$var$ROLE, "tab");
            $f844812df082fc15$var$setAttribute(button, $f844812df082fc15$var$ARIA_CONTROLS, controls.join(" "));
            $f844812df082fc15$var$setAttribute(button, $f844812df082fc15$var$ARIA_LABEL, $f844812df082fc15$var$format(text, i + 1));
            $f844812df082fc15$var$setAttribute(button, $f844812df082fc15$var$TAB_INDEX, -1);
            items.push({
                li: li,
                button: button,
                page: i
            });
        }
    }
    function onClick(page) {
        go(">" + page, true);
    }
    function onKeydown(page, e) {
        var length = items.length;
        var key = $f844812df082fc15$var$normalizeKey(e);
        var dir = getDirection();
        var nextPage = -1;
        if (key === resolve($f844812df082fc15$var$ARROW_RIGHT, false, dir)) nextPage = ++page % length;
        else if (key === resolve($f844812df082fc15$var$ARROW_LEFT, false, dir)) nextPage = (--page + length) % length;
        else if (key === "Home") nextPage = 0;
        else if (key === "End") nextPage = length - 1;
        var item = items[nextPage];
        if (item) {
            $f844812df082fc15$var$focus(item.button);
            go(">" + nextPage);
            $f844812df082fc15$var$prevent(e, true);
        }
    }
    function getDirection() {
        return options.paginationDirection || options.direction;
    }
    function getAt(index) {
        return items[Controller.toPage(index)];
    }
    function update() {
        var prev = getAt(getIndex(true));
        var curr = getAt(getIndex());
        if (prev) {
            var button = prev.button;
            $f844812df082fc15$var$removeClass(button, $f844812df082fc15$export$72d36ecf3758cb4b);
            $f844812df082fc15$var$removeAttribute(button, $f844812df082fc15$var$ARIA_SELECTED);
            $f844812df082fc15$var$setAttribute(button, $f844812df082fc15$var$TAB_INDEX, -1);
        }
        if (curr) {
            var _button = curr.button;
            $f844812df082fc15$var$addClass(_button, $f844812df082fc15$export$72d36ecf3758cb4b);
            $f844812df082fc15$var$setAttribute(_button, $f844812df082fc15$var$ARIA_SELECTED, true);
            $f844812df082fc15$var$setAttribute(_button, $f844812df082fc15$var$TAB_INDEX, "");
        }
        emit($f844812df082fc15$export$eb2019082ed6de0b, {
            list: list,
            items: items
        }, prev, curr);
    }
    return {
        items: items,
        mount: mount,
        destroy: destroy,
        getAt: getAt,
        update: update
    };
}
var $f844812df082fc15$var$TRIGGER_KEYS = [
    " ",
    "Enter"
];
function $f844812df082fc15$var$Sync(Splide2, Components2, options) {
    var isNavigation = options.isNavigation, slideFocus = options.slideFocus;
    var events = [];
    function mount() {
        Splide2.splides.forEach(function(target) {
            if (!target.isParent) {
                sync(Splide2, target.splide);
                sync(target.splide, Splide2);
            }
        });
        if (isNavigation) navigate();
    }
    function destroy() {
        events.forEach(function(event) {
            event.destroy();
        });
        $f844812df082fc15$var$empty(events);
    }
    function remount() {
        destroy();
        mount();
    }
    function sync(splide, target) {
        var event = $f844812df082fc15$export$f188226459c8a3ff(splide);
        event.on($f844812df082fc15$export$2aa493d7c3275167, function(index, prev, dest) {
            target.go(target.is($f844812df082fc15$export$f42383286ed1223d) ? dest : index);
        });
        events.push(event);
    }
    function navigate() {
        var event = $f844812df082fc15$export$f188226459c8a3ff(Splide2);
        var on = event.on;
        on($f844812df082fc15$export$5adb665701eda1ce, onClick);
        on($f844812df082fc15$export$6d5af59619d10e6a, onKeydown);
        on([
            $f844812df082fc15$export$d300dc1a2634364b,
            $f844812df082fc15$export$db40ab7c0855fa5c
        ], update);
        events.push(event);
        event.emit($f844812df082fc15$export$84015c33508f94ec, Splide2.splides);
    }
    function update() {
        $f844812df082fc15$var$setAttribute(Components2.Elements.list, $f844812df082fc15$var$ARIA_ORIENTATION, options.direction === $f844812df082fc15$export$97170d9824b89709 ? "vertical" : "");
    }
    function onClick(Slide) {
        Splide2.go(Slide.index);
    }
    function onKeydown(Slide, e) {
        if ($f844812df082fc15$var$includes($f844812df082fc15$var$TRIGGER_KEYS, $f844812df082fc15$var$normalizeKey(e))) {
            onClick(Slide);
            $f844812df082fc15$var$prevent(e);
        }
    }
    return {
        setup: $f844812df082fc15$var$apply(Components2.Media.set, {
            slideFocus: $f844812df082fc15$var$isUndefined(slideFocus) ? isNavigation : slideFocus
        }, true),
        mount: mount,
        destroy: destroy,
        remount: remount
    };
}
function $f844812df082fc15$var$Wheel(Splide2, Components2, options) {
    var _EventInterface12 = $f844812df082fc15$export$f188226459c8a3ff(Splide2), bind = _EventInterface12.bind;
    var lastTime = 0;
    function mount() {
        if (options.wheel) bind(Components2.Elements.track, "wheel", onWheel, $f844812df082fc15$var$SCROLL_LISTENER_OPTIONS);
    }
    function onWheel(e) {
        if (e.cancelable) {
            var deltaY = e.deltaY;
            var backwards = deltaY < 0;
            var timeStamp = $f844812df082fc15$var$timeOf(e);
            var _min = options.wheelMinThreshold || 0;
            var sleep = options.wheelSleep || 0;
            if ($f844812df082fc15$var$abs(deltaY) > _min && timeStamp - lastTime > sleep) {
                Splide2.go(backwards ? "<" : ">");
                lastTime = timeStamp;
            }
            shouldPrevent(backwards) && $f844812df082fc15$var$prevent(e);
        }
    }
    function shouldPrevent(backwards) {
        return !options.releaseWheel || Splide2.state.is($f844812df082fc15$var$MOVING) || Components2.Controller.getAdjacent(backwards) !== -1;
    }
    return {
        mount: mount
    };
}
var $f844812df082fc15$var$SR_REMOVAL_DELAY = 90;
function $f844812df082fc15$var$Live(Splide2, Components2, options) {
    var _EventInterface13 = $f844812df082fc15$export$f188226459c8a3ff(Splide2), on = _EventInterface13.on;
    var track = Components2.Elements.track;
    var enabled = options.live && !options.isNavigation;
    var sr = $f844812df082fc15$var$create("span", $f844812df082fc15$export$bb78d7c200da8960);
    var interval = $f844812df082fc15$export$46ad21b25b6dccf0($f844812df082fc15$var$SR_REMOVAL_DELAY, $f844812df082fc15$var$apply(toggle, false));
    function mount() {
        if (enabled) {
            disable(!Components2.Autoplay.isPaused());
            $f844812df082fc15$var$setAttribute(track, $f844812df082fc15$var$ARIA_ATOMIC, true);
            sr.textContent = "\u2026";
            on($f844812df082fc15$export$23663268a31b79e2, $f844812df082fc15$var$apply(disable, true));
            on($f844812df082fc15$export$16a1e4f3d0368265, $f844812df082fc15$var$apply(disable, false));
            on([
                $f844812df082fc15$export$fe5802204b967f0d,
                $f844812df082fc15$export$ff8164bff3202b9
            ], $f844812df082fc15$var$apply(toggle, true));
        }
    }
    function toggle(active) {
        $f844812df082fc15$var$setAttribute(track, $f844812df082fc15$var$ARIA_BUSY, active);
        if (active) {
            $f844812df082fc15$var$append(track, sr);
            interval.start();
        } else {
            $f844812df082fc15$var$remove(sr);
            interval.cancel();
        }
    }
    function destroy() {
        $f844812df082fc15$var$removeAttribute(track, [
            $f844812df082fc15$var$ARIA_LIVE,
            $f844812df082fc15$var$ARIA_ATOMIC,
            $f844812df082fc15$var$ARIA_BUSY
        ]);
        $f844812df082fc15$var$remove(sr);
    }
    function disable(disabled) {
        if (enabled) $f844812df082fc15$var$setAttribute(track, $f844812df082fc15$var$ARIA_LIVE, disabled ? "off" : "polite");
    }
    return {
        mount: mount,
        disable: disable,
        destroy: destroy
    };
}
var $f844812df082fc15$var$ComponentConstructors = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    Media: $f844812df082fc15$var$Media,
    Direction: $f844812df082fc15$var$Direction,
    Elements: $f844812df082fc15$var$Elements,
    Slides: $f844812df082fc15$var$Slides,
    Layout: $f844812df082fc15$var$Layout,
    Clones: $f844812df082fc15$var$Clones,
    Move: $f844812df082fc15$var$Move,
    Controller: $f844812df082fc15$var$Controller,
    Arrows: $f844812df082fc15$var$Arrows,
    Autoplay: $f844812df082fc15$var$Autoplay,
    Cover: $f844812df082fc15$var$Cover,
    Scroll: $f844812df082fc15$var$Scroll,
    Drag: $f844812df082fc15$var$Drag,
    Keyboard: $f844812df082fc15$var$Keyboard,
    LazyLoad: $f844812df082fc15$var$LazyLoad,
    Pagination: $f844812df082fc15$var$Pagination,
    Sync: $f844812df082fc15$var$Sync,
    Wheel: $f844812df082fc15$var$Wheel,
    Live: $f844812df082fc15$var$Live
});
var $f844812df082fc15$var$I18N = {
    prev: "Previous slide",
    next: "Next slide",
    first: "Go to first slide",
    last: "Go to last slide",
    slideX: "Go to slide %s",
    pageX: "Go to page %s",
    play: "Start autoplay",
    pause: "Pause autoplay",
    carousel: "carousel",
    slide: "slide",
    select: "Select a slide to show",
    slideLabel: "%s of %s"
};
var $f844812df082fc15$export$f484e977a69c6ba6 = {
    type: "slide",
    role: "region",
    speed: 400,
    perPage: 1,
    cloneStatus: true,
    arrows: true,
    pagination: true,
    paginationKeyboard: true,
    interval: 5e3,
    pauseOnHover: true,
    pauseOnFocus: true,
    resetProgress: true,
    easing: "cubic-bezier(0.25, 1, 0.5, 1)",
    drag: true,
    direction: "ltr",
    trimSpace: true,
    focusableNodes: "a, button, textarea, input, select, iframe",
    live: true,
    classes: $f844812df082fc15$export$ba41d43e4a419565,
    i18n: $f844812df082fc15$var$I18N,
    reducedMotion: {
        speed: 0,
        rewindSpeed: 0,
        autoplay: "pause"
    }
};
function $f844812df082fc15$var$Fade(Splide2, Components2, options) {
    var Slides = Components2.Slides;
    function mount() {
        $f844812df082fc15$export$f188226459c8a3ff(Splide2).on([
            $f844812df082fc15$export$d300dc1a2634364b,
            $f844812df082fc15$export$7f4701ac5e05e39f
        ], init);
    }
    function init() {
        Slides.forEach(function(Slide) {
            Slide.style("transform", "translateX(-" + 100 * Slide.index + "%)");
        });
    }
    function start(index, done) {
        Slides.style("transition", "opacity " + options.speed + "ms " + options.easing);
        $f844812df082fc15$var$nextTick(done);
    }
    return {
        mount: mount,
        start: start,
        cancel: $f844812df082fc15$var$noop
    };
}
function $f844812df082fc15$var$Slide(Splide2, Components2, options) {
    var Move = Components2.Move, Controller = Components2.Controller, Scroll = Components2.Scroll;
    var list = Components2.Elements.list;
    var transition = $f844812df082fc15$var$apply($f844812df082fc15$var$style, list, "transition");
    var endCallback;
    function mount() {
        $f844812df082fc15$export$f188226459c8a3ff(Splide2).bind(list, "transitionend", function(e) {
            if (e.target === list && endCallback) {
                cancel();
                endCallback();
            }
        });
    }
    function start(index, done) {
        var destination = Move.toPosition(index, true);
        var position = Move.getPosition();
        var speed = getSpeed(index);
        if ($f844812df082fc15$var$abs(destination - position) >= 1 && speed >= 1) {
            if (options.useScroll) Scroll.scroll(destination, speed, false, done);
            else {
                transition("transform " + speed + "ms " + options.easing);
                Move.translate(destination, true);
                endCallback = done;
            }
        } else {
            Move.jump(index);
            done();
        }
    }
    function cancel() {
        transition("");
        Scroll.cancel();
    }
    function getSpeed(index) {
        var rewindSpeed = options.rewindSpeed;
        if (Splide2.is($f844812df082fc15$export$e5a58a5ee5b54c22) && rewindSpeed) {
            var prev = Controller.getIndex(true);
            var end = Controller.getEnd();
            if (prev === 0 && index >= end || prev >= end && index === 0) return rewindSpeed;
        }
        return options.speed;
    }
    return {
        mount: mount,
        start: start,
        cancel: cancel
    };
}
var $f844812df082fc15$var$_Splide = /*#__PURE__*/ function() {
    function _Splide(target, options) {
        this.event = $f844812df082fc15$export$f188226459c8a3ff();
        this.Components = {};
        this.state = $f844812df082fc15$export$7254cc27399e90bd($f844812df082fc15$var$CREATED);
        this.splides = [];
        this._o = {};
        this._E = {};
        var root = $f844812df082fc15$var$isString(target) ? $f844812df082fc15$var$query(document, target) : target;
        $f844812df082fc15$var$assert(root, root + " is invalid.");
        this.root = root;
        options = $f844812df082fc15$var$merge({
            label: $f844812df082fc15$var$getAttribute(root, $f844812df082fc15$var$ARIA_LABEL) || "",
            labelledby: $f844812df082fc15$var$getAttribute(root, $f844812df082fc15$var$ARIA_LABELLEDBY) || ""
        }, $f844812df082fc15$export$f484e977a69c6ba6, _Splide.defaults, options || {});
        try {
            $f844812df082fc15$var$merge(options, JSON.parse($f844812df082fc15$var$getAttribute(root, $f844812df082fc15$var$DATA_ATTRIBUTE)));
        } catch (e) {
            $f844812df082fc15$var$assert(false, "Invalid JSON");
        }
        this._o = Object.create($f844812df082fc15$var$merge({}, options));
    }
    var _proto = _Splide.prototype;
    _proto.mount = function mount(Extensions, Transition) {
        var _this = this;
        var state = this.state, Components2 = this.Components;
        $f844812df082fc15$var$assert(state.is([
            $f844812df082fc15$var$CREATED,
            $f844812df082fc15$var$DESTROYED
        ]), "Already mounted!");
        state.set($f844812df082fc15$var$CREATED);
        this._C = Components2;
        this._T = Transition || this._T || (this.is($f844812df082fc15$export$742b62a5690c060) ? $f844812df082fc15$var$Fade : $f844812df082fc15$var$Slide);
        this._E = Extensions || this._E;
        var Constructors = $f844812df082fc15$var$assign({}, $f844812df082fc15$var$ComponentConstructors, this._E, {
            Transition: this._T
        });
        $f844812df082fc15$var$forOwn(Constructors, function(Component, key) {
            var component = Component(_this, Components2, _this._o);
            Components2[key] = component;
            component.setup && component.setup();
        });
        $f844812df082fc15$var$forOwn(Components2, function(component) {
            component.mount && component.mount();
        });
        this.emit($f844812df082fc15$export$d300dc1a2634364b);
        $f844812df082fc15$var$addClass(this.root, $f844812df082fc15$export$7761661e2d5b9388);
        state.set($f844812df082fc15$var$IDLE);
        this.emit($f844812df082fc15$export$d8dac49b4532735a);
        return this;
    };
    _proto.sync = function sync(splide) {
        this.splides.push({
            splide: splide
        });
        splide.splides.push({
            splide: this,
            isParent: true
        });
        if (this.state.is($f844812df082fc15$var$IDLE)) {
            this._C.Sync.remount();
            splide.Components.Sync.remount();
        }
        return this;
    };
    _proto.go = function go(control) {
        this._C.Controller.go(control);
        return this;
    };
    _proto.on = function on(events, callback) {
        this.event.on(events, callback);
        return this;
    };
    _proto.off = function off(events) {
        this.event.off(events);
        return this;
    };
    _proto.emit = function emit(event) {
        var _this$event;
        (_this$event = this.event).emit.apply(_this$event, [
            event
        ].concat($f844812df082fc15$var$slice(arguments, 1)));
        return this;
    };
    _proto.add = function add(slides, index) {
        this._C.Slides.add(slides, index);
        return this;
    };
    _proto.remove = function remove(matcher) {
        this._C.Slides.remove(matcher);
        return this;
    };
    _proto.is = function is(type) {
        return this._o.type === type;
    };
    _proto.refresh = function refresh() {
        this.emit($f844812df082fc15$export$7f4701ac5e05e39f);
        return this;
    };
    _proto.destroy = function destroy(completely) {
        if (completely === void 0) completely = true;
        var event = this.event, state = this.state;
        if (state.is($f844812df082fc15$var$CREATED)) $f844812df082fc15$export$f188226459c8a3ff(this).on($f844812df082fc15$export$d8dac49b4532735a, this.destroy.bind(this, completely));
        else {
            $f844812df082fc15$var$forOwn(this._C, function(component) {
                component.destroy && component.destroy(completely);
            }, true);
            event.emit($f844812df082fc15$export$88c4cf7419e470cd);
            event.destroy();
            completely && $f844812df082fc15$var$empty(this.splides);
            state.set($f844812df082fc15$var$DESTROYED);
        }
        return this;
    };
    $f844812df082fc15$var$_createClass(_Splide, [
        {
            key: "options",
            get: function get() {
                return this._o;
            },
            set: function set(options) {
                this._C.Media.set(options, true, true);
            }
        },
        {
            key: "length",
            get: function get() {
                return this._C.Slides.getLength(true);
            }
        },
        {
            key: "index",
            get: function get() {
                return this._C.Controller.getIndex();
            }
        }
    ]);
    return _Splide;
}();
var $f844812df082fc15$export$24494c7438c070bf = $f844812df082fc15$var$_Splide;
$f844812df082fc15$export$24494c7438c070bf.defaults = {};
$f844812df082fc15$export$24494c7438c070bf.STATES = $f844812df082fc15$var$STATES;
var $f844812df082fc15$var$CLASS_RENDERED = "is-rendered";
var $f844812df082fc15$var$RENDERER_DEFAULT_CONFIG = {
    listTag: "ul",
    slideTag: "li"
};
var $f844812df082fc15$var$Style = /*#__PURE__*/ function() {
    function Style(id, options) {
        this.styles = {};
        this.id = id;
        this.options = options;
    }
    var _proto2 = Style.prototype;
    _proto2.rule = function rule(selector, prop, value, breakpoint) {
        breakpoint = breakpoint || "default";
        var selectors = this.styles[breakpoint] = this.styles[breakpoint] || {};
        var styles = selectors[selector] = selectors[selector] || {};
        styles[prop] = value;
    };
    _proto2.build = function build() {
        var _this2 = this;
        var css = "";
        if (this.styles.default) css += this.buildSelectors(this.styles.default);
        Object.keys(this.styles).sort(function(n, m) {
            return _this2.options.mediaQuery === "min" ? +n - +m : +m - +n;
        }).forEach(function(breakpoint) {
            if (breakpoint !== "default") {
                css += "@media screen and (max-width: " + breakpoint + "px) {";
                css += _this2.buildSelectors(_this2.styles[breakpoint]);
                css += "}";
            }
        });
        return css;
    };
    _proto2.buildSelectors = function buildSelectors(selectors) {
        var _this3 = this;
        var css = "";
        $f844812df082fc15$var$forOwn(selectors, function(styles, selector) {
            selector = ("#" + _this3.id + " " + selector).trim();
            css += selector + " {";
            $f844812df082fc15$var$forOwn(styles, function(value, prop) {
                if (value || value === 0) css += prop + ": " + value + ";";
            });
            css += "}";
        });
        return css;
    };
    return Style;
}();
var $f844812df082fc15$export$c0daaea79e41d7df = /*#__PURE__*/ function() {
    function SplideRenderer(contents, options, config, defaults) {
        this.slides = [];
        this.options = {};
        this.breakpoints = [];
        $f844812df082fc15$var$merge($f844812df082fc15$export$f484e977a69c6ba6, defaults || {});
        $f844812df082fc15$var$merge($f844812df082fc15$var$merge(this.options, $f844812df082fc15$export$f484e977a69c6ba6), options || {});
        this.contents = contents;
        this.config = $f844812df082fc15$var$assign({}, $f844812df082fc15$var$RENDERER_DEFAULT_CONFIG, config || {});
        this.id = this.config.id || $f844812df082fc15$var$uniqueId("splide");
        this.Style = new $f844812df082fc15$var$Style(this.id, this.options);
        this.Direction = $f844812df082fc15$var$Direction(null, null, this.options);
        $f844812df082fc15$var$assert(this.contents.length, "Provide at least 1 content.");
        this.init();
    }
    SplideRenderer.clean = function clean(splide) {
        var _EventInterface14 = $f844812df082fc15$export$f188226459c8a3ff(splide), on = _EventInterface14.on;
        var root = splide.root;
        var clones = $f844812df082fc15$var$queryAll(root, "." + $f844812df082fc15$export$2c1ba4a4f1aa4947);
        on($f844812df082fc15$export$d300dc1a2634364b, function() {
            $f844812df082fc15$var$remove($f844812df082fc15$var$child(root, "style"));
        });
        $f844812df082fc15$var$remove(clones);
    };
    var _proto3 = SplideRenderer.prototype;
    _proto3.init = function init() {
        this.parseBreakpoints();
        this.initSlides();
        this.registerRootStyles();
        this.registerTrackStyles();
        this.registerSlideStyles();
        this.registerListStyles();
    };
    _proto3.initSlides = function initSlides() {
        var _this4 = this;
        $f844812df082fc15$var$push(this.slides, this.contents.map(function(content, index) {
            content = $f844812df082fc15$var$isString(content) ? {
                html: content
            } : content;
            content.styles = content.styles || {};
            content.attrs = content.attrs || {};
            _this4.cover(content);
            var classes = _this4.options.classes.slide + " " + (index === 0 ? $f844812df082fc15$export$72d36ecf3758cb4b : "");
            $f844812df082fc15$var$assign(content.attrs, {
                class: (classes + " " + (content.attrs.class || "")).trim(),
                style: _this4.buildStyles(content.styles)
            });
            return content;
        }));
        if (this.isLoop()) this.generateClones(this.slides);
    };
    _proto3.registerRootStyles = function registerRootStyles() {
        var _this5 = this;
        this.breakpoints.forEach(function(_ref2) {
            var width = _ref2[0], options = _ref2[1];
            _this5.Style.rule(" ", "max-width", $f844812df082fc15$var$unit(options.width), width);
        });
    };
    _proto3.registerTrackStyles = function registerTrackStyles() {
        var _this6 = this;
        var Style2 = this.Style;
        var selector = "." + $f844812df082fc15$export$7738b09ac0a98952;
        this.breakpoints.forEach(function(_ref3) {
            var width = _ref3[0], options = _ref3[1];
            Style2.rule(selector, _this6.resolve("paddingLeft"), _this6.cssPadding(options, false), width);
            Style2.rule(selector, _this6.resolve("paddingRight"), _this6.cssPadding(options, true), width);
            Style2.rule(selector, "height", _this6.cssTrackHeight(options), width);
        });
    };
    _proto3.registerListStyles = function registerListStyles() {
        var _this7 = this;
        var Style2 = this.Style;
        var selector = "." + $f844812df082fc15$export$19cc2a5451235cae;
        this.breakpoints.forEach(function(_ref4) {
            var width = _ref4[0], options = _ref4[1];
            Style2.rule(selector, "transform", _this7.buildTranslate(options), width);
            if (!_this7.cssSlideHeight(options)) Style2.rule(selector, "aspect-ratio", _this7.cssAspectRatio(options), width);
        });
    };
    _proto3.registerSlideStyles = function registerSlideStyles() {
        var _this8 = this;
        var Style2 = this.Style;
        var selector = "." + $f844812df082fc15$export$8d922915837a38d3;
        this.breakpoints.forEach(function(_ref5) {
            var width = _ref5[0], options = _ref5[1];
            Style2.rule(selector, "width", _this8.cssSlideWidth(options), width);
            Style2.rule(selector, "height", _this8.cssSlideHeight(options) || "100%", width);
            Style2.rule(selector, _this8.resolve("marginRight"), $f844812df082fc15$var$unit(options.gap) || "0px", width);
            Style2.rule(selector + " > img", "display", options.cover ? "none" : "inline", width);
        });
    };
    _proto3.buildTranslate = function buildTranslate(options) {
        var _this$Direction = this.Direction, resolve = _this$Direction.resolve, orient = _this$Direction.orient;
        var values = [];
        values.push(this.cssOffsetClones(options));
        values.push(this.cssOffsetGaps(options));
        if (this.isCenter(options)) {
            values.push(this.buildCssValue(orient(-50), "%"));
            values.push.apply(values, this.cssOffsetCenter(options));
        }
        return values.filter(Boolean).map(function(value) {
            return "translate" + resolve("X") + "(" + value + ")";
        }).join(" ");
    };
    _proto3.cssOffsetClones = function cssOffsetClones(options) {
        var _this$Direction2 = this.Direction, resolve = _this$Direction2.resolve, orient = _this$Direction2.orient;
        var cloneCount = this.getCloneCount();
        if (this.isFixedWidth(options)) {
            var _this$parseCssValue = this.parseCssValue(options[resolve("fixedWidth")]), value = _this$parseCssValue.value, unit2 = _this$parseCssValue.unit;
            return this.buildCssValue(orient(value) * cloneCount, unit2);
        }
        var percent = 100 * cloneCount / options.perPage;
        return orient(percent) + "%";
    };
    _proto3.cssOffsetCenter = function cssOffsetCenter(options) {
        var _this$Direction3 = this.Direction, resolve = _this$Direction3.resolve, orient = _this$Direction3.orient;
        if (this.isFixedWidth(options)) {
            var _this$parseCssValue2 = this.parseCssValue(options[resolve("fixedWidth")]), value = _this$parseCssValue2.value, unit2 = _this$parseCssValue2.unit;
            return [
                this.buildCssValue(orient(value / 2), unit2)
            ];
        }
        var values = [];
        var perPage = options.perPage, gap = options.gap;
        values.push(orient(50 / perPage) + "%");
        if (gap) {
            var _this$parseCssValue3 = this.parseCssValue(gap), _value = _this$parseCssValue3.value, _unit = _this$parseCssValue3.unit;
            var gapOffset = (_value / perPage - _value) / 2;
            values.push(this.buildCssValue(orient(gapOffset), _unit));
        }
        return values;
    };
    _proto3.cssOffsetGaps = function cssOffsetGaps(options) {
        var cloneCount = this.getCloneCount();
        if (cloneCount && options.gap) {
            var orient = this.Direction.orient;
            var _this$parseCssValue4 = this.parseCssValue(options.gap), value = _this$parseCssValue4.value, unit2 = _this$parseCssValue4.unit;
            if (this.isFixedWidth(options)) return this.buildCssValue(orient(value * cloneCount), unit2);
            var perPage = options.perPage;
            var gaps = cloneCount / perPage;
            return this.buildCssValue(orient(gaps * value), unit2);
        }
        return "";
    };
    _proto3.resolve = function resolve(prop) {
        return $f844812df082fc15$var$camelToKebab(this.Direction.resolve(prop));
    };
    _proto3.cssPadding = function cssPadding(options, right) {
        var padding = options.padding;
        var prop = this.Direction.resolve(right ? "right" : "left", true);
        return padding && $f844812df082fc15$var$unit(padding[prop] || ($f844812df082fc15$var$isObject(padding) ? 0 : padding)) || "0px";
    };
    _proto3.cssTrackHeight = function cssTrackHeight(options) {
        var height = "";
        if (this.isVertical()) {
            height = this.cssHeight(options);
            $f844812df082fc15$var$assert(height, '"height" is missing.');
            height = "calc(" + height + " - " + this.cssPadding(options, false) + " - " + this.cssPadding(options, true) + ")";
        }
        return height;
    };
    _proto3.cssHeight = function cssHeight(options) {
        return $f844812df082fc15$var$unit(options.height);
    };
    _proto3.cssSlideWidth = function cssSlideWidth(options) {
        return options.autoWidth ? "" : $f844812df082fc15$var$unit(options.fixedWidth) || (this.isVertical() ? "" : this.cssSlideSize(options));
    };
    _proto3.cssSlideHeight = function cssSlideHeight(options) {
        return $f844812df082fc15$var$unit(options.fixedHeight) || (this.isVertical() ? options.autoHeight ? "" : this.cssSlideSize(options) : this.cssHeight(options));
    };
    _proto3.cssSlideSize = function cssSlideSize(options) {
        var gap = $f844812df082fc15$var$unit(options.gap);
        return "calc((100%" + (gap && " + " + gap) + ")/" + (options.perPage || 1) + (gap && " - " + gap) + ")";
    };
    _proto3.cssAspectRatio = function cssAspectRatio(options) {
        var heightRatio = options.heightRatio;
        return heightRatio ? "" + 1 / heightRatio : "";
    };
    _proto3.buildCssValue = function buildCssValue(value, unit2) {
        return "" + value + unit2;
    };
    _proto3.parseCssValue = function parseCssValue(value) {
        if ($f844812df082fc15$var$isString(value)) {
            var number = parseFloat(value) || 0;
            var unit2 = value.replace(/\d*(\.\d*)?/, "") || "px";
            return {
                value: number,
                unit: unit2
            };
        }
        return {
            value: value,
            unit: "px"
        };
    };
    _proto3.parseBreakpoints = function parseBreakpoints() {
        var _this9 = this;
        var breakpoints = this.options.breakpoints;
        this.breakpoints.push([
            "default",
            this.options
        ]);
        if (breakpoints) $f844812df082fc15$var$forOwn(breakpoints, function(options, width) {
            _this9.breakpoints.push([
                width,
                $f844812df082fc15$var$merge($f844812df082fc15$var$merge({}, _this9.options), options)
            ]);
        });
    };
    _proto3.isFixedWidth = function isFixedWidth(options) {
        return !!options[this.Direction.resolve("fixedWidth")];
    };
    _proto3.isLoop = function isLoop() {
        return this.options.type === $f844812df082fc15$export$f42383286ed1223d;
    };
    _proto3.isCenter = function isCenter(options) {
        if (options.focus === "center") {
            if (this.isLoop()) return true;
            if (this.options.type === $f844812df082fc15$export$e5a58a5ee5b54c22) return !this.options.trimSpace;
        }
        return false;
    };
    _proto3.isVertical = function isVertical() {
        return this.options.direction === $f844812df082fc15$export$97170d9824b89709;
    };
    _proto3.buildClasses = function buildClasses() {
        var options = this.options;
        return [
            $f844812df082fc15$export$93b21159ad85c843,
            $f844812df082fc15$export$93b21159ad85c843 + "--" + options.type,
            $f844812df082fc15$export$93b21159ad85c843 + "--" + options.direction,
            options.drag && $f844812df082fc15$export$93b21159ad85c843 + "--draggable",
            options.isNavigation && $f844812df082fc15$export$93b21159ad85c843 + "--nav",
            $f844812df082fc15$export$72d36ecf3758cb4b,
            !this.config.hidden && $f844812df082fc15$var$CLASS_RENDERED
        ].filter(Boolean).join(" ");
    };
    _proto3.buildAttrs = function buildAttrs(attrs) {
        var attr = "";
        $f844812df082fc15$var$forOwn(attrs, function(value, key) {
            attr += value ? " " + $f844812df082fc15$var$camelToKebab(key) + "=\"" + value + "\"" : "";
        });
        return attr.trim();
    };
    _proto3.buildStyles = function buildStyles(styles) {
        var style = "";
        $f844812df082fc15$var$forOwn(styles, function(value, key) {
            style += " " + $f844812df082fc15$var$camelToKebab(key) + ":" + value + ";";
        });
        return style.trim();
    };
    _proto3.renderSlides = function renderSlides() {
        var _this10 = this;
        var tag = this.config.slideTag;
        return this.slides.map(function(content) {
            return "<" + tag + " " + _this10.buildAttrs(content.attrs) + ">" + (content.html || "") + "</" + tag + ">";
        }).join("");
    };
    _proto3.cover = function cover(content) {
        var styles = content.styles, _content$html = content.html, html = _content$html === void 0 ? "" : _content$html;
        if (this.options.cover && !this.options.lazyLoad) {
            var src = html.match(/<img.*?src\s*=\s*(['"])(.+?)\1.*?>/);
            if (src && src[2]) styles.background = "center/cover no-repeat url('" + src[2] + "')";
        }
    };
    _proto3.generateClones = function generateClones(contents) {
        var classes = this.options.classes;
        var count = this.getCloneCount();
        var slides = contents.slice();
        while(slides.length < count)$f844812df082fc15$var$push(slides, slides);
        $f844812df082fc15$var$push(slides.slice(-count).reverse(), slides.slice(0, count)).forEach(function(content, index) {
            var attrs = $f844812df082fc15$var$assign({}, content.attrs, {
                class: content.attrs.class + " " + classes.clone
            });
            var clone = $f844812df082fc15$var$assign({}, content, {
                attrs: attrs
            });
            index < count ? contents.unshift(clone) : contents.push(clone);
        });
    };
    _proto3.getCloneCount = function getCloneCount() {
        if (this.isLoop()) {
            var options = this.options;
            if (options.clones) return options.clones;
            var perPage = $f844812df082fc15$var$max.apply(void 0, this.breakpoints.map(function(_ref6) {
                var options2 = _ref6[1];
                return options2.perPage;
            }));
            return perPage * ((options.flickMaxPages || 1) + 1);
        }
        return 0;
    };
    _proto3.renderArrows = function renderArrows() {
        var html = "";
        html += "<div class=\"" + this.options.classes.arrows + "\">";
        html += this.renderArrow(true);
        html += this.renderArrow(false);
        html += "</div>";
        return html;
    };
    _proto3.renderArrow = function renderArrow(prev) {
        var _this$options = this.options, classes = _this$options.classes, i18n = _this$options.i18n;
        var attrs = {
            class: classes.arrow + " " + (prev ? classes.prev : classes.next),
            type: "button",
            ariaLabel: prev ? i18n.prev : i18n.next
        };
        return "<button " + this.buildAttrs(attrs) + "><svg xmlns=\"" + $f844812df082fc15$var$XML_NAME_SPACE + "\" viewBox=\"0 0 " + $f844812df082fc15$var$SIZE + " " + $f844812df082fc15$var$SIZE + "\" width=\"" + $f844812df082fc15$var$SIZE + "\" height=\"" + $f844812df082fc15$var$SIZE + "\"><path d=\"" + (this.options.arrowPath || $f844812df082fc15$var$PATH) + "\" /></svg></button>";
    };
    _proto3.html = function html() {
        var _this$config = this.config, rootClass = _this$config.rootClass, listTag = _this$config.listTag, arrows = _this$config.arrows, beforeTrack = _this$config.beforeTrack, afterTrack = _this$config.afterTrack, slider = _this$config.slider, beforeSlider = _this$config.beforeSlider, afterSlider = _this$config.afterSlider;
        var html = "";
        html += "<div id=\"" + this.id + "\" class=\"" + this.buildClasses() + " " + (rootClass || "") + "\">";
        html += "<style>" + this.Style.build() + "</style>";
        if (slider) {
            html += beforeSlider || "";
            html += "<div class=\"splide__slider\">";
        }
        html += beforeTrack || "";
        if (arrows) html += this.renderArrows();
        html += "<div class=\"splide__track\">";
        html += "<" + listTag + " class=\"splide__list\">";
        html += this.renderSlides();
        html += "</" + listTag + ">";
        html += "</div>";
        html += afterTrack || "";
        if (slider) {
            html += "</div>";
            html += afterSlider || "";
        }
        html += "</div>";
        return html;
    };
    return SplideRenderer;
}();



class $1e52ca8fdbe257bc$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super(), this.customOptions = {};
        this.root = this.querySelector('[data-tk-carousel-root]') || undefined;
        this.options = this.getAttribute('data-tk-carousel-options') || undefined;
        this.paginationClassName = this.getAttribute('data-tk-pagination-class-name') || 'tk-carousel__pagination';
        this.paginationPageClassName = this.getAttribute('data-tk-pagination-page-class-name') || 'tk-carousel__pagination-page';
        this.arrowsClassName = this.getAttribute('data-tk-arrows-class-name') || 'tk-carousel__arrows';
        this.arrowClassName = this.getAttribute('data-tk-arrow-class-name') || 'tk-carousel__arrow';
        this.prevClassName = this.getAttribute('data-tk-prev-class-name') || 'tk-carousel__arrow--prev';
        this.nextClassName = this.getAttribute('data-tk-next-class-name') || 'tk-carousel__arrow--next';
        this.loadedClassName = this.getAttribute('data-tk-loaded-class-name') || 'tk-carousel--loaded';
        if (this.options) this.customOptions = JSON.parse(this.options);
    }
    connectedCallback() {
        this.mountCarousel();
    }
    mountCarousel() {
        const carouselBreakpoints = {};
        carouselBreakpoints[window.viewport.breakpoints.get('l') || 1200] = {
            perPage: 3,
            arrows: true,
            pagination: true
        };
        const defaultOptions = {
            type: 'slide',
            arrows: false,
            pagination: false,
            perMove: 1,
            padding: {
                left: '4px',
                right: '4px'
            },
            gap: 24,
            mediaQuery: 'min',
            classes: {
                pagination: `splide__pagination ${this.paginationClassName}`,
                page: `splide__pagination__page ${this.paginationPageClassName}`,
                arrows: `splide__arrows ${this.arrowsClassName}`,
                arrow: `splide__arrow ${this.arrowClassName}`,
                prev: `splide__arrow--prev ${this.prevClassName}`,
                next: `splide__arrow--next ${this.nextClassName}`
            },
            breakpoints: carouselBreakpoints,
            width: '100%'
        };
        if (!this.root) return;
        this.slider = new (0, $f844812df082fc15$export$24494c7438c070bf)(this.root, Object.assign(defaultOptions, this.customOptions));
        this.slider.on('ready', this.movePaginationToArrows.bind(this));
        this.slider.on('resized', this.movePaginationToArrows.bind(this));
        this.slider.mount();
    }
    movePaginationToArrows() {
        const arrows = this.querySelector(`.${this.arrowsClassName}`);
        const pagination = this.querySelector(`.${this.paginationClassName}`);
        if (arrows?.querySelector(`.${this.paginationClassName}`)) return;
        if (!arrows || !pagination) return;
        arrows?.insertAdjacentElement('beforeend', pagination);
        this.root?.classList.add(this.loadedClassName);
    }
}




class $d9484b764f1a944d$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.buttons = this.querySelectorAll('[data-tk-context-button]');
        this.items = this.querySelector('[data-tk-context-items]') || undefined;
        this.openClassName = this.getAttribute('data-tk-open-class-name') || 'tk-context-menu--open';
        this.responsiveClassName = this.getAttribute('data-tk-responsive-class-name') || 'tk-context-menu--responsive';
        this.dropDownClassName = this.getAttribute('data-tk-dropdown-class-name') || 'tk-context-menu__dropdown';
        this.showAlways = this.hasAttribute('data-tk-show-always');
        this.disableScrolldownBreakpoint = this.getAttribute('data-tk-disable-scrolldown-breakpoint') || 's';
        this.minWidthBreakpoint = window.viewport.breakpoints.get(this.disableScrolldownBreakpoint) || 0;
        this.offset = Number(this.getAttribute('data-tk-context-offset')) || 4;
        this.resizeObserver = new ResizeObserver(this.handleResize.bind(this));
    }
    connectedCallback() {
        if (this.buttons.length === 0 || !this.items) throw new Error('Context Menu: Elements are missing!');
        this.registerViewportListener();
        (window.viewport.clientWidth < this.minWidthBreakpoint || this.showAlways) && this.switchToMobile();
        this.registerClickListener();
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        this.resizeObserver.unobserve(this);
    }
    registerClickListener() {
        const onClick = this.open.bind(this);
        this.buttons.forEach((button)=>{
            this.pushListener({
                event: 'click',
                element: button,
                action: onClick
            });
        });
    }
    registerCloseListener() {
        const handleClose = this.close.bind(this);
        this.pushListener({
            event: 'click',
            element: window,
            action: handleClose
        });
    }
    registerViewportListener() {
        const onViewportResize = this.handleViewportResize.bind(this);
        this.pushListener({
            event: 'tk-viewport-resize',
            element: window.viewport,
            action: onViewportResize
        });
    }
    handleResize(entries) {
        entries.forEach(()=>{
            if (!this.copiedItems) return;
            this.setPosition(this.copiedItems);
        });
    }
    handleViewportResize(event) {
        event.detail.width < this.minWidthBreakpoint || this.showAlways ? this.switchToMobile() : this.switchToDesktop();
    }
    getVisibleButton(visibility) {
        const buttonList = Array.from(this.buttons);
        return buttonList.find((button)=>visibility === button.checkVisibility());
    }
    switchToDesktop() {
        const button = this.getVisibleButton(true);
        if (!button) return;
        button.hidden = true;
        this.classList.remove(this.responsiveClassName);
    }
    switchToMobile() {
        const button = this.getVisibleButton(false);
        if (!button) return;
        button.hidden = false;
        this.classList.add(this.responsiveClassName);
    }
    copyItemsIfNotExists() {
        const copiedItems = this.items.cloneNode(true);
        copiedItems.classList.add(this.dropDownClassName);
        this.copiedItems = copiedItems;
        document.body.insertAdjacentElement('beforeend', copiedItems);
    }
    open() {
        !this.copiedItems && this.copyItemsIfNotExists();
        if (!this.copiedItems) return;
        this.setPosition(this.copiedItems);
        this.resizeObserver.observe(document.body);
        setTimeout(()=>{
            this.registerCloseListener();
        }, 0);
    }
    setPosition(element) {
        const button = this.getVisibleButton(true);
        if (!button) return;
        element.classList.add(this.openClassName);
        const { top: top, height: height, left: left, right: right } = button.getBoundingClientRect();
        const leftPosition = left + window.scrollX;
        const rightPosition = right + window.scrollX;
        element.style.top = `${top + height + window.scrollY + this.offset}px`;
        if (window.innerWidth <= element.clientWidth + leftPosition) element.style.left = `${rightPosition - element.clientWidth}px`;
        else element.style.left = `${leftPosition}px`;
    }
    close(event) {
        const button = this.getVisibleButton(true);
        if (!this.copiedItems || !button) return;
        const buttonRect = button.getBoundingClientRect();
        const dropdownRect = this.copiedItems.getBoundingClientRect();
        const rectangles = [
            {
                rectangle: buttonRect
            },
            {
                rectangle: dropdownRect
            }
        ];
        if ((0, $7e8cc8975b3fe464$export$dcbd32acb1a13bc6)(event, rectangles)) {
            this.copiedItems.classList.remove(this.openClassName);
            this.removeListener(window);
            this.resizeObserver.unobserve(document.body);
        }
    }
}



class $0d07f57cc5d15afe$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super(), this.selectorFlagItem = '[data-tk-flag-item]', this.selectorFlagIcon = '[data-tk-flag-icon]', this.selectorFlagLabel = '[data-tk-flag-label]', this.flagItems = [], this.removedFlagElements = [];
    }
    connectedCallback() {
        this.getAllFlags();
        if (this.flagItems.length < 1) return;
        this.appendSummarizedFlag();
    }
    getAllFlags() {
        const allFlagElements = this.querySelectorAll(this.selectorFlagItem) || undefined;
        // convert NodeList to Array
        const allFlags = Array.from(allFlagElements);
        // remove last Element (not needed for Tooltip-Flag)
        allFlags.pop();
        if (allFlags.length < 1) return;
        allFlags.forEach((item)=>{
            const iconElem = item.querySelector(this.selectorFlagIcon);
            const labelElem = item.querySelector(this.selectorFlagLabel);
            const singleFlagItem = {
                icon: iconElem?.outerHTML,
                label: labelElem?.getAttribute(this.selectorFlagLabel.slice(1, -1)) === 'true' ? labelElem.innerHTML : '',
                showIcon: iconElem?.getAttribute(this.selectorFlagIcon.slice(1, -1)) === 'true',
                showLabel: labelElem?.getAttribute(this.selectorFlagLabel.slice(1, -1)) === 'true'
            };
            this.flagItems.push(singleFlagItem);
            this.removedFlagElements.push(item);
            item.remove();
        });
    }
    getFlagDetails() {
        const returnVal = [];
        this.flagItems.forEach((elem)=>{
            let tooltipString;
            if (elem.showLabel) tooltipString = elem.showIcon ? `${elem.icon} ${elem.label}` : `${elem.label}`;
            else {
                const removedElement = this.removedFlagElements.shift();
                const removedElementLabel = removedElement?.querySelector('[data-tk-flag-label]')?.innerHTML;
                const tmpTooltipString = removedElementLabel || '';
                tooltipString = elem.showIcon ? `${elem.icon}` : tmpTooltipString;
            }
            returnVal.push(tooltipString);
        });
        return returnVal.join(', ').trim();
    }
    appendSummarizedFlag() {
        const tooltipTemplate = this.querySelector('[data-tk-flag-merged]');
        if (!tooltipTemplate) return;
        const clone = tooltipTemplate.content.cloneNode(true);
        const tooltipElement = clone.querySelector('[data-tk-tooltip-content]');
        if (!tooltipElement) return;
        tooltipElement.innerHTML = `+${this.flagItems.length}`;
        tooltipElement.setAttribute('data-tk-tooltip-content', this.getFlagDetails());
        this.prepend(clone);
    }
}






class $8b05e2474621c644$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    static{
        this.observedAttributes = [
            'data-count'
        ];
    }
    constructor(){
        super(), this.isDataFetched = false;
        this.headerButton = this.querySelector('[data-tk-header-button]') || undefined;
        this.overlay = this.querySelector('[data-tk-minibasket-overlay]') || undefined;
        this.contentWrapper = this.querySelector('[data-tk-minibasket-content]') || undefined;
        this.countItemsRequestURL = this.getAttribute('data-tk-count-items-request-url') || undefined;
        this.getContentRequestURL = this.getAttribute('data-tk-get-content-request-url') || undefined;
        this.headerButtonEmptyClassName = this.getAttribute('data-tk-header-button-empty-class-name') || 'tk-button__header--empty';
        this.offset = Number(this.getAttribute('data-tk-minibasket-offset')) || 4;
        this.openClassName = this.getAttribute('data-tk-open-class-name') || 'tk-minibasket--open';
        this.minDistanceToBorder = Number(this.getAttribute('data-tk-min-distance-to-border')) || 5;
        // Custom Events
        this.openedEventName = this.getAttribute('data-tk-event-opened-name') || 'tk-minibasket-opened';
        this.openedEvent = new CustomEvent(this.openedEventName);
        this.closedEventName = this.getAttribute('data-tk-event-closed-name') || 'tk-minibasket-closed';
        this.closedEvent = new CustomEvent(this.closedEventName);
        this.updateEventName = this.getAttribute('data-tk-event-update-name') || 'tk-minibasket-update';
        this.updateEvent = new CustomEvent(this.updateEventName);
    }
    connectedCallback() {
        if (!this.headerButton) throw new Error('Minibasket: Header Button is missing!');
        if (!this.countItemsRequestURL || !this.getContentRequestURL) throw new Error('Minibasket: Request URLs are missing!');
        this.registerInitializeListener();
        this.fetchQuantity();
    }
    attributeChangedCallback(name, oldValue, newValue) {
        if (name === 'data-count') this.setCounter(Number(newValue));
    }
    registerInitializeListener() {
        const handleOpen = this.open.bind(this);
        this.pushListener({
            event: 'click',
            element: this.headerButton,
            action: handleOpen
        });
        const handleOpened = this.opened.bind(this);
        this.pushListener({
            event: this.openedEventName,
            element: this,
            action: handleOpened
        });
        const handleUpdate = this.update.bind(this);
        this.pushListener({
            event: this.updateEventName,
            element: this,
            action: handleUpdate
        });
    }
    registerCloseListener() {
        const handleClose = this.close.bind(this);
        this.pushListener({
            event: 'click',
            element: window,
            action: handleClose
        });
    }
    registerScrollListener() {
        const handleScroll = this.alignOverlayToButton.bind(this);
        this.pushListener({
            event: 'scroll',
            element: window,
            action: handleScroll
        });
    }
    open() {
        document.body.insertAdjacentElement('beforeend', this.overlay);
        this.overlay.classList.add(this.openClassName);
        this.alignOverlayToButton();
        !this.isDataFetched && this.fetchAll();
        this.dispatchEvent(this.openedEvent);
    }
    opened() {
        // This method would be used to execute code in a non-blocking way to prevent potential delays.
        setTimeout(()=>{
            this.registerCloseListener();
            this.registerScrollListener();
        }, 0);
    }
    update() {
        this.fetchQuantity();
        this.fetchAll();
    }
    close(event) {
        if (!this.overlay) return;
        const headerButtonRect = this.headerButton.getBoundingClientRect();
        const overlayRect = this.overlay.getBoundingClientRect();
        const rectangles = [
            {
                rectangle: headerButtonRect
            },
            {
                rectangle: overlayRect
            }
        ];
        if ((0, $7e8cc8975b3fe464$export$dcbd32acb1a13bc6)(event, rectangles)) {
            this.overlay.classList.remove(this.openClassName);
            this.dispatchEvent(this.closedEvent);
            this.removeListener(window);
        }
    }
    fetchAll() {
        Promise.all([
            $8b05e2474621c644$export$2e2bcd8739ae039.fetchData(this.getContentRequestURL)
        ]).then((responses)=>{
            this.isDataFetched = true;
            this.placeContent(responses[0]);
        }).catch(()=>{
            this.isDataFetched = false;
        });
    }
    fetchQuantity() {
        (0, $1653b55d89a7adce$export$24835cb787452b46)({
            requestURL: this.countItemsRequestURL,
            resolveHandler: this.getQuantity.bind(this)
        });
    }
    static fetchData(url) {
        return new Promise((resolve)=>{
            (0, $1653b55d89a7adce$export$24835cb787452b46)({
                requestURL: url,
                resolveHandler: (response)=>{
                    resolve(response);
                }
            });
        });
    }
    getQuantity(response) {
        if (!response || !response.success) return;
        const { quantity: quantity } = response.dataAsJson;
        this.setCounter(quantity);
    }
    setCounter(quantity) {
        if (quantity === 0) this.headerButton?.classList.add(this.headerButtonEmptyClassName);
        else {
            this.headerButton?.setAttribute('data-count', `${quantity || 0}`);
            this.headerButton?.classList.remove(this.headerButtonEmptyClassName);
        }
    }
    placeContent(response) {
        if (!response || !response.success) return;
        if (!this.contentWrapper) return;
        const items = (0, $2d540709c75492d4$export$2e2bcd8739ae039)(response.dataAsHtml);
        this.contentWrapper.innerHTML = '';
        this.contentWrapper.insertAdjacentHTML('beforeend', items.innerHTML);
    }
    alignOverlayToButton() {
        const { bottom: bottom, right: right } = this.headerButton.getBoundingClientRect();
        const { width: width } = this.overlay.getBoundingClientRect();
        const distanceToBorder = right - width;
        this.overlay.style.top = `${bottom + this.offset}px`;
        if (distanceToBorder >= this.minDistanceToBorder) this.overlay.style.left = `${right - width}px`;
        else {
            this.overlay.style.left = '50%';
            this.overlay.style.transform = 'translateX(-50%)';
        }
    }
}




class $21ae20c5af7baedb$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.url = this.getAttribute('data-tk-url') || undefined;
        this.productVariants = this.querySelector('[data-tk-product-variants]') || undefined;
    }
    connectedCallback() {
        if (!this.url) throw new Error('Product-Tile: No URL defined!');
        this.registerListener();
    }
    registerListener() {
        if (!this.productVariants) return;
        const switchProductVariantHandler = this.changeVariant.bind(this);
        this.pushListener({
            event: 'change',
            element: this.productVariants,
            action: switchProductVariantHandler
        });
    }
    changeVariant() {
        this.getProductVariant(this.productVariants.value);
    }
    getProductVariant(id) {
        const data = {
            article: id
        };
        (0, $1653b55d89a7adce$export$24835cb787452b46)({
            requestURL: this.url,
            resolveHandler: this.switchProductVariant.bind(this),
            payload: data
        });
    }
    switchProductVariant(response) {
        if (!response || !response.success) return;
        this.insertAdjacentHTML('afterend', response.dataAsHtml);
        this.remove();
    }
}




class $21611c672b0d32ce$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super(), this.selectorProductVariant = '[data-tk-product-variant]', this.selectorproductVariantFilters = '[data-tk-product-variant-filter]', this.selectorProductVariantList = '[data-tk-product-variant-list]', this.selectorProductVariantAttribute = '[data-tk-product-variant-attribute]', this.selectorProductVariantValue = '[data-tk-product-variant-value]', this.filteredOptions = [], this.selectionHistory = [];
        this.productVariantList = this.querySelector(this.selectorProductVariantList) || undefined;
        this.productVariantFilters = this.querySelectorAll(this.selectorproductVariantFilters) || undefined;
        this.productVariantsCollection = [];
        this.filteredCollection = [];
        this.noVariantFound = this.getAttribute('data-tk-product-variant-none') || 'NONE';
        this.disableSelectingFirst = this.hasAttribute('data-tk-disable-selecting-first');
        this.resetButton = this.querySelector('[data-tk-product-variants-reset]') || undefined;
        this.enableFilterInURL = this.hasAttribute('data-tk-enable-filter-in-url');
    }
    connectedCallback() {
        this.collectProductVariants();
        this.prepareVariantFilters();
        !this.disableSelectingFirst && this.selectFirstVariantInCollection(this.productVariantsCollection);
        this.registerListener();
    }
    registerListener() {
        if (this.productVariantFilters) this.productVariantFilters.forEach((filter)=>{
            const filterListEventHandler = this.filterList.bind(this);
            this.pushListener({
                event: 'change',
                element: filter,
                action: filterListEventHandler
            });
        });
        if (this.productVariantsCollection.length > 0) this.productVariantsCollection.forEach((variant)=>{
            const getSelectedVariantValueHandler = this.getSelectedVariantValue.bind(this, variant.element);
            this.pushListener({
                event: 'change',
                element: variant.element,
                action: getSelectedVariantValueHandler
            });
        });
        const handleReset = this.handleReset.bind(this);
        this.resetButton && this.pushListener({
            event: 'click',
            element: this.resetButton,
            action: handleReset
        });
    }
    getSelectedVariantValue(variant) {
        this.setSelectedVariant(variant.getAttribute('data-tk-product-variant') || '');
    }
    filterList(event) {
        const selectedValues = this.getSelectedFilterValues();
        this.filteredCollection = this.productVariantsCollection.filter((element)=>{
            return Object.keys(selectedValues).every((key)=>{
                return selectedValues[key] === element.spec[key];
            });
        }) || [];
        this.updateProductVariantList();
        this.enableFilterInURL && this.setFilterInURL();
        event && this.filterOptions(event.currentTarget);
    }
    setFilterInURL() {
        const url = new URL(window.location.href);
        const selectedValues = this.getSelectedFilterValues();
        Object.keys(selectedValues).forEach((key)=>{
            url.searchParams.set(key, selectedValues[key]);
        });
        window.history.pushState(null, '', url.href);
    }
    handleReset() {
        this.productVariantsCollection.filter((item)=>item.id !== 'NONE').forEach((item)=>{
            item.element.hidden = false;
        });
        this.filteredOptions.forEach((item)=>{
            const { element: element } = item;
            if (!element) return;
            const optionList = Array.from(element.options);
            optionList.forEach((option)=>{
                option.hidden = false;
                option.selected = false;
            });
            element.disabled = item.options.size < 2;
            const firstOption = element.options.item(0);
            if (!firstOption) return;
            firstOption.selected = true;
        });
        if (!this.enableFilterInURL) return;
        const url = new URL(window.location.href);
        const { searchParams: searchParams } = url;
        this.filteredOptions.forEach((option)=>{
            const { attr: attr } = option;
            searchParams.has(attr) && searchParams.delete(attr);
        });
        window.history.pushState(null, '', url.href);
    }
    filterOptions(target) {
        const filteredList = this.filteredOptions.filter((item)=>item.element !== target);
        const currentValues = filteredList.map((filterOption)=>{
            const values = new Set();
            this.filteredCollection.forEach((item)=>{
                values.add(item.spec[filterOption.attr]);
            });
            return {
                attr: filterOption.attr,
                values: values
            };
        });
        filteredList.forEach((filterOption)=>{
            if (!filterOption.element) return;
            const { options: options } = filterOption.element;
            const optionList = Array.from(options);
            const values = currentValues.find((item)=>item.attr === filterOption.attr)?.values;
            if (!values) return;
            optionList.forEach((option)=>{
                option.hidden = false;
            });
            optionList.filter((option)=>option.value !== '').forEach((option)=>{
                option.hidden = !values.has(option.value);
            });
            filterOption.element.disabled = optionList.filter((item)=>!item.hidden && item.value !== '').length < 2;
        });
        const selectedOption = target.options.item(target.selectedIndex);
        if (!selectedOption) return;
        if (selectedOption.value === '') {
            this.enableLastSelection(target);
            return;
        }
        if (this.selectionHistory.at(-1) !== target) this.selectionHistory.push(target);
    }
    enableLastSelection(target) {
        if (this.selectionHistory.length < 1) return;
        const lastSelection = this.selectionHistory.at(-2);
        if (lastSelection === target) return;
        const index = this.filteredOptions.findIndex((item)=>item.element === lastSelection);
        const lastItem = this.filteredOptions.at(index);
        const lastElement = lastItem?.element;
        if (!lastElement) return;
        Array.from(lastElement.options).forEach((option)=>{
            option.hidden = false;
        });
        lastElement.disabled = false;
        lastElement.dispatchEvent(new Event('change'));
    }
    updateProductVariantList() {
        this.productVariantsCollection.forEach((variant)=>{
            variant.element.hidden = true;
        });
        this.filteredCollection.forEach((variant)=>{
            variant.element.hidden = false;
            if (variant.id === this.noVariantFound) variant.element.hidden = true;
        });
        if (this.filteredCollection.length > 0) !this.disableSelectingFirst && this.selectFirstVariantInCollection(this.filteredCollection);
        else this.showNoVariantsFoundMessage();
    }
    selectFirstVariantInCollection(collection) {
        const hasSelectedElement = collection.some($21611c672b0d32ce$export$2e2bcd8739ae039.findFirstSelectedElement);
        if (hasSelectedElement) return;
        const input = collection.at(0)?.element.querySelector('input[type="radio"]');
        if (!input) return;
        input.checked = true;
        this.setSelectedVariant(input.value);
    }
    static findFirstSelectedElement(variant) {
        const input = variant.element.querySelector('input');
        if (!input) return false;
        return !input.hidden && input.checked;
    }
    setSelectedVariant(selectedValue) {
        this.selectedVariant = selectedValue;
    }
    showNoVariantsFoundMessage() {
        const noVariantFound = this.productVariantsCollection.filter((variant)=>variant.id === this.noVariantFound);
        if (noVariantFound) noVariantFound[0].element.hidden = false;
        this.setSelectedVariant('');
    }
    getSelectedFilterValues() {
        const selectedValues = {};
        this.productVariantFilters.forEach((filter)=>{
            if (filter.value !== '') {
                const selected = {
                    attr: filter.getAttribute('data-tk-product-variant-filter') || '',
                    value: filter.value
                };
                selectedValues[selected.attr] = selected.value;
            }
        });
        return selectedValues;
    }
    collectProductVariants() {
        const variants = this.productVariantList?.querySelectorAll(this.selectorProductVariant);
        variants?.forEach((element)=>{
            const variant = {
                id: element.getAttribute('data-tk-product-variant') || '',
                element: element,
                spec: this.getVariantSpecs(element)
            };
            this.productVariantsCollection.push(variant);
        });
    }
    prepareVariantFilters() {
        const filterAttribute = new Set();
        this.productVariantsCollection.forEach((variant)=>{
            Object.keys(variant.spec).forEach((key)=>filterAttribute.add(key));
        });
        filterAttribute.forEach((attr)=>{
            // filter undefined or null values
            const distinctOptions = new Set(this.productVariantsCollection.map((variant)=>variant.spec[attr]).filter(Boolean));
            const sortedOptions = new Set([
                ...distinctOptions
            ].sort());
            const selectElement = this.querySelector(`[data-tk-product-variant-filter="${attr}"]`) || undefined;
            this.filteredOptions.push({
                element: selectElement,
                attr: attr,
                options: sortedOptions
            });
        });
        this.filteredOptions.forEach((item)=>{
            if (!item.element) return;
            item.element.disabled = item.options.size < 2;
            const optionsHTML = [
                ...item.options
            ].map((option)=>{
                const urlParams = new URLSearchParams(window.location.search);
                const isSelected = urlParams.get(item.attr) === option;
                return `<option value="${option}" ${isSelected ? 'selected' : ''}>${option}</option>`;
            }).join('');
            let resultHTML = '';
            item.options.size > 1 ? resultHTML = `<option value="">${(0, $86b3c5b6d66bd808$export$1c7f7f3bbe522ebc).all.text}</option>${optionsHTML}` : resultHTML = optionsHTML;
            item.element.insertAdjacentHTML('beforeend', resultHTML);
        });
        this.enableFilterInURL && this.filterList();
    }
    getVariantSpecs(variant) {
        const specs = variant.querySelectorAll(this.selectorProductVariantAttribute);
        const specCollection = {};
        specs.forEach((elem)=>{
            const spec = {
                attr: elem.getAttribute('data-tk-product-variant-attribute') || '',
                value: elem.getAttribute('data-tk-product-variant-value') || ''
            };
            specCollection[spec.attr] = spec.value;
        });
        return specCollection;
    }
}


/**!
* tippy.js v6.3.7
* (c) 2017-2021 atomiks
* MIT License
*/ function $13064aa41dd611dc$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}


function $2835f189066da699$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}


function $6be351e83d6bf643$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $2835f189066da699$export$2e2bcd8739ae039)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $6be351e83d6bf643$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $2835f189066da699$export$2e2bcd8739ae039)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $6be351e83d6bf643$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $2835f189066da699$export$2e2bcd8739ae039)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}


// and applies them to the HTMLElements such as popper and arrow
function $312913fa2edc14b2$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $6be351e83d6bf643$export$1b3bfaa9684536aa)(element) || !(0, $13064aa41dd611dc$export$2e2bcd8739ae039)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? '' : value);
        });
    });
}
function $312913fa2edc14b2$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: '0',
            top: '0',
            margin: '0'
        },
        arrow: {
            position: 'absolute'
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = '';
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $6be351e83d6bf643$export$1b3bfaa9684536aa)(element) || !(0, $13064aa41dd611dc$export$2e2bcd8739ae039)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $312913fa2edc14b2$export$2e2bcd8739ae039 = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: $312913fa2edc14b2$var$applyStyles,
    effect: $312913fa2edc14b2$var$effect,
    requires: [
        'computeStyles'
    ]
};


var $8d1d6c453d67c9ab$export$8960430cfd85939f = Math.max;
var $8d1d6c453d67c9ab$export$96ec731ed4dcb222 = Math.min;
var $8d1d6c453d67c9ab$export$2077e0241d6afd3c = Math.round;



function $9641053f99441231$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}


function $b49248e188a52b8b$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $9641053f99441231$export$2e2bcd8739ae039)());
}


function $1b9ce20ada6267ed$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $6be351e83d6bf643$export$1b3bfaa9684536aa)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $8d1d6c453d67c9ab$export$2077e0241d6afd3c)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $8d1d6c453d67c9ab$export$2077e0241d6afd3c)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $6be351e83d6bf643$export$45a5e7f76e0caa8d)(element) ? (0, $2835f189066da699$export$2e2bcd8739ae039)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $b49248e188a52b8b$export$2e2bcd8739ae039)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}



function $0acc17feb41c51bd$export$2e2bcd8739ae039(node) {
    var win = (0, $2835f189066da699$export$2e2bcd8739ae039)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}




function $c829ab0279467772$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}


function $b71097fc0b0e5f5c$export$2e2bcd8739ae039(node) {
    if (node === (0, $2835f189066da699$export$2e2bcd8739ae039)(node) || !(0, $6be351e83d6bf643$export$1b3bfaa9684536aa)(node)) return (0, $0acc17feb41c51bd$export$2e2bcd8739ae039)(node);
    else return (0, $c829ab0279467772$export$2e2bcd8739ae039)(node);
}






function $37f38c85c1edad4d$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $6be351e83d6bf643$export$45a5e7f76e0caa8d)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}



function $e951d80a0194865c$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $1b9ce20ada6267ed$export$2e2bcd8739ae039)((0, $37f38c85c1edad4d$export$2e2bcd8739ae039)(element)).left + (0, $0acc17feb41c51bd$export$2e2bcd8739ae039)(element).scrollLeft;
}




function $270edfbc2bfbd22f$export$2e2bcd8739ae039(element) {
    return (0, $2835f189066da699$export$2e2bcd8739ae039)(element).getComputedStyle(element);
}


function $9873d63ab8539814$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $270edfbc2bfbd22f$export$2e2bcd8739ae039)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}



function $b01cf64433a5b37b$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $8d1d6c453d67c9ab$export$2077e0241d6afd3c)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $8d1d6c453d67c9ab$export$2077e0241d6afd3c)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $b01cf64433a5b37b$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $6be351e83d6bf643$export$1b3bfaa9684536aa)(offsetParent);
    var offsetParentIsScaled = (0, $6be351e83d6bf643$export$1b3bfaa9684536aa)(offsetParent) && $b01cf64433a5b37b$var$isElementScaled(offsetParent);
    var documentElement = (0, $37f38c85c1edad4d$export$2e2bcd8739ae039)(offsetParent);
    var rect = (0, $1b9ce20ada6267ed$export$2e2bcd8739ae039)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $13064aa41dd611dc$export$2e2bcd8739ae039)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $9873d63ab8539814$export$2e2bcd8739ae039)(documentElement)) scroll = (0, $b71097fc0b0e5f5c$export$2e2bcd8739ae039)(offsetParent);
        if ((0, $6be351e83d6bf643$export$1b3bfaa9684536aa)(offsetParent)) {
            offsets = (0, $1b9ce20ada6267ed$export$2e2bcd8739ae039)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $e951d80a0194865c$export$2e2bcd8739ae039)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}



function $ad01075005a54bff$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $1b9ce20ada6267ed$export$2e2bcd8739ae039)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}





function $c16bae6800ecc025$export$2e2bcd8739ae039(element) {
    if ((0, $13064aa41dd611dc$export$2e2bcd8739ae039)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $6be351e83d6bf643$export$af51f0f06c0f328a)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $37f38c85c1edad4d$export$2e2bcd8739ae039)(element) // fallback
    );
}





function $c48b941fd834c962$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $13064aa41dd611dc$export$2e2bcd8739ae039)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $6be351e83d6bf643$export$1b3bfaa9684536aa)(node) && (0, $9873d63ab8539814$export$2e2bcd8739ae039)(node)) return node;
    return $c48b941fd834c962$export$2e2bcd8739ae039((0, $c16bae6800ecc025$export$2e2bcd8739ae039)(node));
}





function $295d0ca7e8ef250a$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $c48b941fd834c962$export$2e2bcd8739ae039)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $2835f189066da699$export$2e2bcd8739ae039)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $9873d63ab8539814$export$2e2bcd8739ae039)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($295d0ca7e8ef250a$export$2e2bcd8739ae039((0, $c16bae6800ecc025$export$2e2bcd8739ae039)(target)));
}







function $27c48183f07ddbe8$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $13064aa41dd611dc$export$2e2bcd8739ae039)(element)) >= 0;
}




function $3df2d470c30a409e$var$getTrueOffsetParent(element) {
    if (!(0, $6be351e83d6bf643$export$1b3bfaa9684536aa)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $270edfbc2bfbd22f$export$2e2bcd8739ae039)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $3df2d470c30a409e$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $9641053f99441231$export$2e2bcd8739ae039)());
    var isIE = /Trident/i.test((0, $9641053f99441231$export$2e2bcd8739ae039)());
    if (isIE && (0, $6be351e83d6bf643$export$1b3bfaa9684536aa)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $270edfbc2bfbd22f$export$2e2bcd8739ae039)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $c16bae6800ecc025$export$2e2bcd8739ae039)(element);
    if ((0, $6be351e83d6bf643$export$af51f0f06c0f328a)(currentNode)) currentNode = currentNode.host;
    while((0, $6be351e83d6bf643$export$1b3bfaa9684536aa)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $13064aa41dd611dc$export$2e2bcd8739ae039)(currentNode)) < 0){
        var css = (0, $270edfbc2bfbd22f$export$2e2bcd8739ae039)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $3df2d470c30a409e$export$2e2bcd8739ae039(element) {
    var window = (0, $2835f189066da699$export$2e2bcd8739ae039)(element);
    var offsetParent = $3df2d470c30a409e$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $27c48183f07ddbe8$export$2e2bcd8739ae039)(offsetParent) && (0, $270edfbc2bfbd22f$export$2e2bcd8739ae039)(offsetParent).position === 'static')offsetParent = $3df2d470c30a409e$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $13064aa41dd611dc$export$2e2bcd8739ae039)(offsetParent) === 'html' || (0, $13064aa41dd611dc$export$2e2bcd8739ae039)(offsetParent) === 'body' && (0, $270edfbc2bfbd22f$export$2e2bcd8739ae039)(offsetParent).position === 'static')) return window;
    return offsetParent || $3df2d470c30a409e$var$getContainingBlock(element) || window;
}


var $935c50c8659545b7$export$1e95b668f3b82d = 'top';
var $935c50c8659545b7$export$40e543e69a8b3fbb = 'bottom';
var $935c50c8659545b7$export$79ffe56a765070d2 = 'right';
var $935c50c8659545b7$export$eabcd2c8791e7bf4 = 'left';
var $935c50c8659545b7$export$dfb5619354ba860 = 'auto';
var $935c50c8659545b7$export$aec2ce47c367b8c3 = [
    $935c50c8659545b7$export$1e95b668f3b82d,
    $935c50c8659545b7$export$40e543e69a8b3fbb,
    $935c50c8659545b7$export$79ffe56a765070d2,
    $935c50c8659545b7$export$eabcd2c8791e7bf4
];
var $935c50c8659545b7$export$b3571188c770cc5a = 'start';
var $935c50c8659545b7$export$bd5df0f255a350f8 = 'end';
var $935c50c8659545b7$export$390fd549c5303b4d = 'clippingParents';
var $935c50c8659545b7$export$d7b7311ec04a3e8f = 'viewport';
var $935c50c8659545b7$export$ae5ab1c730825774 = 'popper';
var $935c50c8659545b7$export$ca50aac9f3ba507f = 'reference';
var $935c50c8659545b7$export$368f9a87e87fa4e1 = /*#__PURE__*/ $935c50c8659545b7$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $935c50c8659545b7$export$b3571188c770cc5a,
        placement + "-" + $935c50c8659545b7$export$bd5df0f255a350f8
    ]);
}, []);
var $935c50c8659545b7$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($935c50c8659545b7$export$aec2ce47c367b8c3, [
    $935c50c8659545b7$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $935c50c8659545b7$export$b3571188c770cc5a,
        placement + "-" + $935c50c8659545b7$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $935c50c8659545b7$export$421679a7c3d56e = 'beforeRead';
var $935c50c8659545b7$export$aafa59e2e03f2942 = 'read';
var $935c50c8659545b7$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $935c50c8659545b7$export$c65e99957a05207c = 'beforeMain';
var $935c50c8659545b7$export$f22da7240b7add18 = 'main';
var $935c50c8659545b7$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $935c50c8659545b7$export$8d4d2d70e7d46032 = 'beforeWrite';
var $935c50c8659545b7$export$68d8715fc104d294 = 'write';
var $935c50c8659545b7$export$70a6e5159acce2e6 = 'afterWrite';
var $935c50c8659545b7$export$d087d3878fdf71d5 = [
    $935c50c8659545b7$export$421679a7c3d56e,
    $935c50c8659545b7$export$aafa59e2e03f2942,
    $935c50c8659545b7$export$6964f6c886723980,
    $935c50c8659545b7$export$c65e99957a05207c,
    $935c50c8659545b7$export$f22da7240b7add18,
    $935c50c8659545b7$export$bab79516f2d662fe,
    $935c50c8659545b7$export$8d4d2d70e7d46032,
    $935c50c8659545b7$export$68d8715fc104d294,
    $935c50c8659545b7$export$70a6e5159acce2e6
];


function $455dca0e08f2a815$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $455dca0e08f2a815$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $455dca0e08f2a815$var$order(modifiers); // order based on phase
    return (0, $935c50c8659545b7$export$d087d3878fdf71d5).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}


function $6d2b77c34ff005f5$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}


function $81912adbd60ec5c0$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}




var $1839837374f95732$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $1839837374f95732$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $1839837374f95732$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $1839837374f95732$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $1839837374f95732$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $6be351e83d6bf643$export$45a5e7f76e0caa8d)(reference) ? (0, $295d0ca7e8ef250a$export$2e2bcd8739ae039)(reference) : reference.contextElement ? (0, $295d0ca7e8ef250a$export$2e2bcd8739ae039)(reference.contextElement) : [],
                    popper: (0, $295d0ca7e8ef250a$export$2e2bcd8739ae039)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $455dca0e08f2a815$export$2e2bcd8739ae039)((0, $81912adbd60ec5c0$export$2e2bcd8739ae039)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$1839837374f95732$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $b01cf64433a5b37b$export$2e2bcd8739ae039)(reference, (0, $3df2d470c30a409e$export$2e2bcd8739ae039)(popper), state.options.strategy === 'fixed'),
                    popper: (0, $ad01075005a54bff$export$2e2bcd8739ae039)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $6d2b77c34ff005f5$export$2e2bcd8739ae039)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$1839837374f95732$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $1839837374f95732$export$8f7491d57c8f97a9 = /*#__PURE__*/ $1839837374f95732$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules



var $fa02e10eb4995658$var$passive = {
    passive: true
};
function $fa02e10eb4995658$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $2835f189066da699$export$2e2bcd8739ae039)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $fa02e10eb4995658$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $fa02e10eb4995658$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $fa02e10eb4995658$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $fa02e10eb4995658$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $fa02e10eb4995658$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $fa02e10eb4995658$var$effect,
    data: {}
};



function $6653967f933aaf29$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}


function $66a6b9b7896d6ec4$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}


function $271a905a3adf884c$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}



function $4f7414566eeea71a$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $6653967f933aaf29$export$2e2bcd8739ae039)(placement) : null;
    var variation = placement ? (0, $66a6b9b7896d6ec4$export$2e2bcd8739ae039)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $935c50c8659545b7$export$1e95b668f3b82d:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $935c50c8659545b7$export$40e543e69a8b3fbb:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $935c50c8659545b7$export$79ffe56a765070d2:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $935c50c8659545b7$export$eabcd2c8791e7bf4:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $271a905a3adf884c$export$2e2bcd8739ae039)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $935c50c8659545b7$export$b3571188c770cc5a:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $935c50c8659545b7$export$bd5df0f255a350f8:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}


function $ee48a1861d343976$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $4f7414566eeea71a$export$2e2bcd8739ae039)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $ee48a1861d343976$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $ee48a1861d343976$var$popperOffsets,
    data: {}
};










var $063d2297888fea12$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $063d2297888fea12$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $8d1d6c453d67c9ab$export$2077e0241d6afd3c)(x * dpr) / dpr || 0,
        y: (0, $8d1d6c453d67c9ab$export$2077e0241d6afd3c)(y * dpr) / dpr || 0
    };
}
function $063d2297888fea12$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $935c50c8659545b7$export$eabcd2c8791e7bf4);
    var sideY = (0, $935c50c8659545b7$export$1e95b668f3b82d);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $3df2d470c30a409e$export$2e2bcd8739ae039)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $2835f189066da699$export$2e2bcd8739ae039)(popper)) {
            offsetParent = (0, $37f38c85c1edad4d$export$2e2bcd8739ae039)(popper);
            if ((0, $270edfbc2bfbd22f$export$2e2bcd8739ae039)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $935c50c8659545b7$export$1e95b668f3b82d) || (placement === (0, $935c50c8659545b7$export$eabcd2c8791e7bf4) || placement === (0, $935c50c8659545b7$export$79ffe56a765070d2)) && variation === (0, $935c50c8659545b7$export$bd5df0f255a350f8)) {
            sideY = (0, $935c50c8659545b7$export$40e543e69a8b3fbb);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $935c50c8659545b7$export$eabcd2c8791e7bf4) || (placement === (0, $935c50c8659545b7$export$1e95b668f3b82d) || placement === (0, $935c50c8659545b7$export$40e543e69a8b3fbb)) && variation === (0, $935c50c8659545b7$export$bd5df0f255a350f8)) {
            sideX = (0, $935c50c8659545b7$export$79ffe56a765070d2);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $063d2297888fea12$var$unsetSides);
    var _ref4 = roundOffsets === true ? $063d2297888fea12$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $2835f189066da699$export$2e2bcd8739ae039)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $063d2297888fea12$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $6653967f933aaf29$export$2e2bcd8739ae039)(state.placement),
        variation: (0, $66a6b9b7896d6ec4$export$2e2bcd8739ae039)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $063d2297888fea12$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $063d2297888fea12$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $063d2297888fea12$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $063d2297888fea12$var$computeStyles,
    data: {}
};





function $8d644778f0e020f0$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $6653967f933aaf29$export$2e2bcd8739ae039)(placement);
    var invertDistance = [
        (0, $935c50c8659545b7$export$eabcd2c8791e7bf4),
        (0, $935c50c8659545b7$export$1e95b668f3b82d)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $935c50c8659545b7$export$eabcd2c8791e7bf4),
        (0, $935c50c8659545b7$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $8d644778f0e020f0$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $935c50c8659545b7$export$803cd8101b6c182b).reduce(function(acc, placement) {
        acc[placement] = $8d644778f0e020f0$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $8d644778f0e020f0$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $8d644778f0e020f0$var$offset
};


var $d79ddf39683d3f91$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $d79ddf39683d3f91$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $d79ddf39683d3f91$var$hash[matched];
    });
}



var $5887002dcefa0743$var$hash = {
    start: 'end',
    end: 'start'
};
function $5887002dcefa0743$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $5887002dcefa0743$var$hash[matched];
    });
}







function $7da9d5689cacb0a6$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $2835f189066da699$export$2e2bcd8739ae039)(element);
    var html = (0, $37f38c85c1edad4d$export$2e2bcd8739ae039)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $b49248e188a52b8b$export$2e2bcd8739ae039)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $e951d80a0194865c$export$2e2bcd8739ae039)(element),
        y: y
    };
}







function $ab4ea6dd03061fae$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $37f38c85c1edad4d$export$2e2bcd8739ae039)(element);
    var winScroll = (0, $0acc17feb41c51bd$export$2e2bcd8739ae039)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $8d1d6c453d67c9ab$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $8d1d6c453d67c9ab$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $e951d80a0194865c$export$2e2bcd8739ae039)(element);
    var y = -winScroll.scrollTop;
    if ((0, $270edfbc2bfbd22f$export$2e2bcd8739ae039)(body || html).direction === 'rtl') x += (0, $8d1d6c453d67c9ab$export$8960430cfd85939f)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}










function $122a9b90bb37fc73$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $6be351e83d6bf643$export$af51f0f06c0f328a)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}



function $1cd357ee33805adc$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}



function $93ee5964b4e9d426$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $1b9ce20ada6267ed$export$2e2bcd8739ae039)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $93ee5964b4e9d426$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $935c50c8659545b7$export$d7b7311ec04a3e8f) ? (0, $1cd357ee33805adc$export$2e2bcd8739ae039)((0, $7da9d5689cacb0a6$export$2e2bcd8739ae039)(element, strategy)) : (0, $6be351e83d6bf643$export$45a5e7f76e0caa8d)(clippingParent) ? $93ee5964b4e9d426$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $1cd357ee33805adc$export$2e2bcd8739ae039)((0, $ab4ea6dd03061fae$export$2e2bcd8739ae039)((0, $37f38c85c1edad4d$export$2e2bcd8739ae039)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $93ee5964b4e9d426$var$getClippingParents(element) {
    var clippingParents = (0, $295d0ca7e8ef250a$export$2e2bcd8739ae039)((0, $c16bae6800ecc025$export$2e2bcd8739ae039)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $270edfbc2bfbd22f$export$2e2bcd8739ae039)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $6be351e83d6bf643$export$1b3bfaa9684536aa)(element) ? (0, $3df2d470c30a409e$export$2e2bcd8739ae039)(element) : element;
    if (!(0, $6be351e83d6bf643$export$45a5e7f76e0caa8d)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $6be351e83d6bf643$export$45a5e7f76e0caa8d)(clippingParent) && (0, $122a9b90bb37fc73$export$2e2bcd8739ae039)(clippingParent, clipperElement) && (0, $13064aa41dd611dc$export$2e2bcd8739ae039)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $93ee5964b4e9d426$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? $93ee5964b4e9d426$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $93ee5964b4e9d426$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $8d1d6c453d67c9ab$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $8d1d6c453d67c9ab$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $8d1d6c453d67c9ab$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $8d1d6c453d67c9ab$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $93ee5964b4e9d426$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}








function $5dd4eac14cb3a9cb$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}


function $0ad6ec2b432662d8$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $5dd4eac14cb3a9cb$export$2e2bcd8739ae039)(), paddingObject);
}


function $e3a5d8ce75f76756$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}


function $70321b611e132ecc$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $935c50c8659545b7$export$390fd549c5303b4d) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $935c50c8659545b7$export$d7b7311ec04a3e8f) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $935c50c8659545b7$export$ae5ab1c730825774) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $0ad6ec2b432662d8$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $e3a5d8ce75f76756$export$2e2bcd8739ae039)(padding, (0, $935c50c8659545b7$export$aec2ce47c367b8c3)));
    var altContext = elementContext === (0, $935c50c8659545b7$export$ae5ab1c730825774) ? (0, $935c50c8659545b7$export$ca50aac9f3ba507f) : (0, $935c50c8659545b7$export$ae5ab1c730825774);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $93ee5964b4e9d426$export$2e2bcd8739ae039)((0, $6be351e83d6bf643$export$45a5e7f76e0caa8d)(element) ? element : element.contextElement || (0, $37f38c85c1edad4d$export$2e2bcd8739ae039)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $1b9ce20ada6267ed$export$2e2bcd8739ae039)(state.elements.reference);
    var popperOffsets = (0, $4f7414566eeea71a$export$2e2bcd8739ae039)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $1cd357ee33805adc$export$2e2bcd8739ae039)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $935c50c8659545b7$export$ae5ab1c730825774) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $935c50c8659545b7$export$ae5ab1c730825774) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $935c50c8659545b7$export$79ffe56a765070d2),
                (0, $935c50c8659545b7$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $935c50c8659545b7$export$1e95b668f3b82d),
                (0, $935c50c8659545b7$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}






function $bec6b628c79c2a3d$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $935c50c8659545b7$export$803cd8101b6c182b) : _options$allowedAutoP;
    var variation = (0, $66a6b9b7896d6ec4$export$2e2bcd8739ae039)(placement);
    var placements = variation ? flipVariations ? (0, $935c50c8659545b7$export$368f9a87e87fa4e1) : (0, $935c50c8659545b7$export$368f9a87e87fa4e1).filter(function(placement) {
        return (0, $66a6b9b7896d6ec4$export$2e2bcd8739ae039)(placement) === variation;
    }) : (0, $935c50c8659545b7$export$aec2ce47c367b8c3);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $70321b611e132ecc$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $6653967f933aaf29$export$2e2bcd8739ae039)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}




function $dabd09962ff7b702$var$getExpandedFallbackPlacements(placement) {
    if ((0, $6653967f933aaf29$export$2e2bcd8739ae039)(placement) === (0, $935c50c8659545b7$export$dfb5619354ba860)) return [];
    var oppositePlacement = (0, $d79ddf39683d3f91$export$2e2bcd8739ae039)(placement);
    return [
        (0, $5887002dcefa0743$export$2e2bcd8739ae039)(placement),
        oppositePlacement,
        (0, $5887002dcefa0743$export$2e2bcd8739ae039)(oppositePlacement)
    ];
}
function $dabd09962ff7b702$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $6653967f933aaf29$export$2e2bcd8739ae039)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $d79ddf39683d3f91$export$2e2bcd8739ae039)(preferredPlacement)
    ] : $dabd09962ff7b702$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $6653967f933aaf29$export$2e2bcd8739ae039)(placement) === (0, $935c50c8659545b7$export$dfb5619354ba860) ? (0, $bec6b628c79c2a3d$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $6653967f933aaf29$export$2e2bcd8739ae039)(placement);
        var isStartVariation = (0, $66a6b9b7896d6ec4$export$2e2bcd8739ae039)(placement) === (0, $935c50c8659545b7$export$b3571188c770cc5a);
        var isVertical = [
            (0, $935c50c8659545b7$export$1e95b668f3b82d),
            (0, $935c50c8659545b7$export$40e543e69a8b3fbb)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $70321b611e132ecc$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $935c50c8659545b7$export$79ffe56a765070d2) : (0, $935c50c8659545b7$export$eabcd2c8791e7bf4) : isStartVariation ? (0, $935c50c8659545b7$export$40e543e69a8b3fbb) : (0, $935c50c8659545b7$export$1e95b668f3b82d);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $d79ddf39683d3f91$export$2e2bcd8739ae039)(mainVariationSide);
        var altVariationSide = (0, $d79ddf39683d3f91$export$2e2bcd8739ae039)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $dabd09962ff7b702$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $dabd09962ff7b702$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};





function $e82c9e5baaa8e9af$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}



function $4faf3481d1df2f95$export$f28d906d67a997f3(min, value, max) {
    return (0, $8d1d6c453d67c9ab$export$8960430cfd85939f)(min, (0, $8d1d6c453d67c9ab$export$96ec731ed4dcb222)(value, max));
}
function $4faf3481d1df2f95$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $4faf3481d1df2f95$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}








function $4804c92787f86449$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $70321b611e132ecc$export$2e2bcd8739ae039)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $6653967f933aaf29$export$2e2bcd8739ae039)(state.placement);
    var variation = (0, $66a6b9b7896d6ec4$export$2e2bcd8739ae039)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $271a905a3adf884c$export$2e2bcd8739ae039)(basePlacement);
    var altAxis = (0, $e82c9e5baaa8e9af$export$2e2bcd8739ae039)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, $935c50c8659545b7$export$1e95b668f3b82d) : (0, $935c50c8659545b7$export$eabcd2c8791e7bf4);
        var altSide = mainAxis === 'y' ? (0, $935c50c8659545b7$export$40e543e69a8b3fbb) : (0, $935c50c8659545b7$export$79ffe56a765070d2);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $935c50c8659545b7$export$b3571188c770cc5a) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $935c50c8659545b7$export$b3571188c770cc5a) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $ad01075005a54bff$export$2e2bcd8739ae039)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $5dd4eac14cb3a9cb$export$2e2bcd8739ae039)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $4faf3481d1df2f95$export$f28d906d67a997f3)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $3df2d470c30a409e$export$2e2bcd8739ae039)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $4faf3481d1df2f95$export$f28d906d67a997f3)(tether ? (0, $8d1d6c453d67c9ab$export$96ec731ed4dcb222)(min, tetherMin) : min, offset, tether ? (0, $8d1d6c453d67c9ab$export$8960430cfd85939f)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, $935c50c8659545b7$export$1e95b668f3b82d) : (0, $935c50c8659545b7$export$eabcd2c8791e7bf4);
        var _altSide = mainAxis === 'x' ? (0, $935c50c8659545b7$export$40e543e69a8b3fbb) : (0, $935c50c8659545b7$export$79ffe56a765070d2);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $935c50c8659545b7$export$1e95b668f3b82d),
            (0, $935c50c8659545b7$export$eabcd2c8791e7bf4)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $4faf3481d1df2f95$export$86c8af6d3ef0b4a)(_tetherMin, _offset, _tetherMax) : (0, $4faf3481d1df2f95$export$f28d906d67a997f3)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $4804c92787f86449$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $4804c92787f86449$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};











var $20e743289f291887$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $0ad6ec2b432662d8$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $e3a5d8ce75f76756$export$2e2bcd8739ae039)(padding, (0, $935c50c8659545b7$export$aec2ce47c367b8c3)));
};
function $20e743289f291887$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $6653967f933aaf29$export$2e2bcd8739ae039)(state.placement);
    var axis = (0, $271a905a3adf884c$export$2e2bcd8739ae039)(basePlacement);
    var isVertical = [
        (0, $935c50c8659545b7$export$eabcd2c8791e7bf4),
        (0, $935c50c8659545b7$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $20e743289f291887$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $ad01075005a54bff$export$2e2bcd8739ae039)(arrowElement);
    var minProp = axis === 'y' ? (0, $935c50c8659545b7$export$1e95b668f3b82d) : (0, $935c50c8659545b7$export$eabcd2c8791e7bf4);
    var maxProp = axis === 'y' ? (0, $935c50c8659545b7$export$40e543e69a8b3fbb) : (0, $935c50c8659545b7$export$79ffe56a765070d2);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $3df2d470c30a409e$export$2e2bcd8739ae039)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $4faf3481d1df2f95$export$f28d906d67a997f3)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $20e743289f291887$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $122a9b90bb37fc73$export$2e2bcd8739ae039)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $20e743289f291887$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $20e743289f291887$var$arrow,
    effect: $20e743289f291887$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};




function $7d3d400f3b7c97f3$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $7d3d400f3b7c97f3$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $935c50c8659545b7$export$1e95b668f3b82d),
        (0, $935c50c8659545b7$export$79ffe56a765070d2),
        (0, $935c50c8659545b7$export$40e543e69a8b3fbb),
        (0, $935c50c8659545b7$export$eabcd2c8791e7bf4)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $7d3d400f3b7c97f3$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $70321b611e132ecc$export$2e2bcd8739ae039)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $70321b611e132ecc$export$2e2bcd8739ae039)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $7d3d400f3b7c97f3$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $7d3d400f3b7c97f3$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $7d3d400f3b7c97f3$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $7d3d400f3b7c97f3$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $7d3d400f3b7c97f3$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $7d3d400f3b7c97f3$var$hide
};




var $98a9ef6d31ff03cd$export$d34966752335dd47 = [
    (0, $fa02e10eb4995658$export$2e2bcd8739ae039),
    (0, $ee48a1861d343976$export$2e2bcd8739ae039),
    (0, $063d2297888fea12$export$2e2bcd8739ae039),
    (0, $312913fa2edc14b2$export$2e2bcd8739ae039),
    (0, $8d644778f0e020f0$export$2e2bcd8739ae039),
    (0, $dabd09962ff7b702$export$2e2bcd8739ae039),
    (0, $4804c92787f86449$export$2e2bcd8739ae039),
    (0, $20e743289f291887$export$2e2bcd8739ae039),
    (0, $7d3d400f3b7c97f3$export$2e2bcd8739ae039)
];
var $98a9ef6d31ff03cd$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $1839837374f95732$export$ed5e13716264f202)({
    defaultModifiers: $98a9ef6d31ff03cd$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules


var $c55de979aca75bc6$export$c96c811c44a42da5 = '<svg width="16" height="6" xmlns="http://www.w3.org/2000/svg"><path d="M0 6s1.796-.013 4.67-3.615C5.851.9 6.93.006 8 0c1.07-.006 2.148.887 3.343 2.385C14.233 6.005 16 6 16 6H0z"></svg>';
var $c55de979aca75bc6$var$BOX_CLASS = "tippy-box";
var $c55de979aca75bc6$var$CONTENT_CLASS = "tippy-content";
var $c55de979aca75bc6$var$BACKDROP_CLASS = "tippy-backdrop";
var $c55de979aca75bc6$var$ARROW_CLASS = "tippy-arrow";
var $c55de979aca75bc6$var$SVG_ARROW_CLASS = "tippy-svg-arrow";
var $c55de979aca75bc6$var$TOUCH_OPTIONS = {
    passive: true,
    capture: true
};
var $c55de979aca75bc6$var$TIPPY_DEFAULT_APPEND_TO = function TIPPY_DEFAULT_APPEND_TO() {
    return document.body;
};
function $c55de979aca75bc6$var$hasOwnProperty(obj, key) {
    return ({}).hasOwnProperty.call(obj, key);
}
function $c55de979aca75bc6$var$getValueAtIndexOrReturn(value, index, defaultValue) {
    if (Array.isArray(value)) {
        var v = value[index];
        return v == null ? Array.isArray(defaultValue) ? defaultValue[index] : defaultValue : v;
    }
    return value;
}
function $c55de979aca75bc6$var$isType(value, type) {
    var str = ({}).toString.call(value);
    return str.indexOf('[object') === 0 && str.indexOf(type + "]") > -1;
}
function $c55de979aca75bc6$var$invokeWithArgsOrReturn(value, args) {
    return typeof value === 'function' ? value.apply(void 0, args) : value;
}
function $c55de979aca75bc6$var$debounce(fn, ms) {
    // Avoid wrapping in `setTimeout` if ms is 0 anyway
    if (ms === 0) return fn;
    var timeout;
    return function(arg) {
        clearTimeout(timeout);
        timeout = setTimeout(function() {
            fn(arg);
        }, ms);
    };
}
function $c55de979aca75bc6$var$removeProperties(obj, keys) {
    var clone = Object.assign({}, obj);
    keys.forEach(function(key) {
        delete clone[key];
    });
    return clone;
}
function $c55de979aca75bc6$var$splitBySpaces(value) {
    return value.split(/\s+/).filter(Boolean);
}
function $c55de979aca75bc6$var$normalizeToArray(value) {
    return [].concat(value);
}
function $c55de979aca75bc6$var$pushIfUnique(arr, value) {
    if (arr.indexOf(value) === -1) arr.push(value);
}
function $c55de979aca75bc6$var$unique(arr) {
    return arr.filter(function(item, index) {
        return arr.indexOf(item) === index;
    });
}
function $c55de979aca75bc6$var$getBasePlacement(placement) {
    return placement.split('-')[0];
}
function $c55de979aca75bc6$var$arrayFrom(value) {
    return [].slice.call(value);
}
function $c55de979aca75bc6$var$removeUndefinedProps(obj) {
    return Object.keys(obj).reduce(function(acc, key) {
        if (obj[key] !== undefined) acc[key] = obj[key];
        return acc;
    }, {});
}
function $c55de979aca75bc6$var$div() {
    return document.createElement('div');
}
function $c55de979aca75bc6$var$isElement(value) {
    return [
        'Element',
        'Fragment'
    ].some(function(type) {
        return $c55de979aca75bc6$var$isType(value, type);
    });
}
function $c55de979aca75bc6$var$isNodeList(value) {
    return $c55de979aca75bc6$var$isType(value, 'NodeList');
}
function $c55de979aca75bc6$var$isMouseEvent(value) {
    return $c55de979aca75bc6$var$isType(value, 'MouseEvent');
}
function $c55de979aca75bc6$var$isReferenceElement(value) {
    return !!(value && value._tippy && value._tippy.reference === value);
}
function $c55de979aca75bc6$var$getArrayOfElements(value) {
    if ($c55de979aca75bc6$var$isElement(value)) return [
        value
    ];
    if ($c55de979aca75bc6$var$isNodeList(value)) return $c55de979aca75bc6$var$arrayFrom(value);
    if (Array.isArray(value)) return value;
    return $c55de979aca75bc6$var$arrayFrom(document.querySelectorAll(value));
}
function $c55de979aca75bc6$var$setTransitionDuration(els, value) {
    els.forEach(function(el) {
        if (el) el.style.transitionDuration = value + "ms";
    });
}
function $c55de979aca75bc6$var$setVisibilityState(els, state) {
    els.forEach(function(el) {
        if (el) el.setAttribute('data-state', state);
    });
}
function $c55de979aca75bc6$var$getOwnerDocument(elementOrElements) {
    var _element$ownerDocumen;
    var _normalizeToArray = $c55de979aca75bc6$var$normalizeToArray(elementOrElements), element = _normalizeToArray[0]; // Elements created via a <template> have an ownerDocument with no reference to the body
    return element != null && (_element$ownerDocumen = element.ownerDocument) != null && _element$ownerDocumen.body ? element.ownerDocument : document;
}
function $c55de979aca75bc6$var$isCursorOutsideInteractiveBorder(popperTreeData, event) {
    var clientX = event.clientX, clientY = event.clientY;
    return popperTreeData.every(function(_ref) {
        var popperRect = _ref.popperRect, popperState = _ref.popperState, props = _ref.props;
        var interactiveBorder = props.interactiveBorder;
        var basePlacement = $c55de979aca75bc6$var$getBasePlacement(popperState.placement);
        var offsetData = popperState.modifiersData.offset;
        if (!offsetData) return true;
        var topDistance = basePlacement === 'bottom' ? offsetData.top.y : 0;
        var bottomDistance = basePlacement === 'top' ? offsetData.bottom.y : 0;
        var leftDistance = basePlacement === 'right' ? offsetData.left.x : 0;
        var rightDistance = basePlacement === 'left' ? offsetData.right.x : 0;
        var exceedsTop = popperRect.top - clientY + topDistance > interactiveBorder;
        var exceedsBottom = clientY - popperRect.bottom - bottomDistance > interactiveBorder;
        var exceedsLeft = popperRect.left - clientX + leftDistance > interactiveBorder;
        var exceedsRight = clientX - popperRect.right - rightDistance > interactiveBorder;
        return exceedsTop || exceedsBottom || exceedsLeft || exceedsRight;
    });
}
function $c55de979aca75bc6$var$updateTransitionEndListener(box, action, listener) {
    var method = action + "EventListener"; // some browsers apparently support `transition` (unprefixed) but only fire
    // `webkitTransitionEnd`...
    [
        'transitionend',
        'webkitTransitionEnd'
    ].forEach(function(event) {
        box[method](event, listener);
    });
}
/**
 * Compared to xxx.contains, this function works for dom structures with shadow
 * dom
 */ function $c55de979aca75bc6$var$actualContains(parent, child) {
    var target = child;
    while(target){
        var _target$getRootNode;
        if (parent.contains(target)) return true;
        target = target.getRootNode == null ? void 0 : (_target$getRootNode = target.getRootNode()) == null ? void 0 : _target$getRootNode.host;
    }
    return false;
}
var $c55de979aca75bc6$var$currentInput = {
    isTouch: false
};
var $c55de979aca75bc6$var$lastMouseMoveTime = 0;
/**
 * When a `touchstart` event is fired, it's assumed the user is using touch
 * input. We'll bind a `mousemove` event listener to listen for mouse input in
 * the future. This way, the `isTouch` property is fully dynamic and will handle
 * hybrid devices that use a mix of touch + mouse input.
 */ function $c55de979aca75bc6$var$onDocumentTouchStart() {
    if ($c55de979aca75bc6$var$currentInput.isTouch) return;
    $c55de979aca75bc6$var$currentInput.isTouch = true;
    if (window.performance) document.addEventListener('mousemove', $c55de979aca75bc6$var$onDocumentMouseMove);
}
/**
 * When two `mousemove` event are fired consecutively within 20ms, it's assumed
 * the user is using mouse input again. `mousemove` can fire on touch devices as
 * well, but very rarely that quickly.
 */ function $c55de979aca75bc6$var$onDocumentMouseMove() {
    var now = performance.now();
    if (now - $c55de979aca75bc6$var$lastMouseMoveTime < 20) {
        $c55de979aca75bc6$var$currentInput.isTouch = false;
        document.removeEventListener('mousemove', $c55de979aca75bc6$var$onDocumentMouseMove);
    }
    $c55de979aca75bc6$var$lastMouseMoveTime = now;
}
/**
 * When an element is in focus and has a tippy, leaving the tab/window and
 * returning causes it to show again. For mouse users this is unexpected, but
 * for keyboard use it makes sense.
 * TODO: find a better technique to solve this problem
 */ function $c55de979aca75bc6$var$onWindowBlur() {
    var activeElement = document.activeElement;
    if ($c55de979aca75bc6$var$isReferenceElement(activeElement)) {
        var instance = activeElement._tippy;
        if (activeElement.blur && !instance.state.isVisible) activeElement.blur();
    }
}
function $c55de979aca75bc6$var$bindGlobalEventListeners() {
    document.addEventListener('touchstart', $c55de979aca75bc6$var$onDocumentTouchStart, $c55de979aca75bc6$var$TOUCH_OPTIONS);
    window.addEventListener('blur', $c55de979aca75bc6$var$onWindowBlur);
}
var $c55de979aca75bc6$var$isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined';
var $c55de979aca75bc6$var$isIE11 = $c55de979aca75bc6$var$isBrowser ? !!window.msCrypto : false;
function $c55de979aca75bc6$var$createMemoryLeakWarning(method) {
    var txt = method === 'destroy' ? 'n already-' : ' ';
    return [
        method + "() was called on a" + txt + "destroyed instance. This is a no-op but",
        'indicates a potential memory leak.'
    ].join(' ');
}
function $c55de979aca75bc6$var$clean(value) {
    var spacesAndTabs = /[ \t]{2,}/g;
    var lineStartWithSpaces = /^[ \t]*/gm;
    return value.replace(spacesAndTabs, ' ').replace(lineStartWithSpaces, '').trim();
}
function $c55de979aca75bc6$var$getDevMessage(message) {
    return $c55de979aca75bc6$var$clean("\n  %ctippy.js\n\n  %c" + $c55de979aca75bc6$var$clean(message) + "\n\n  %c\uD83D\uDC77\u200D This is a development-only message. It will be removed in production.\n  ");
}
function $c55de979aca75bc6$var$getFormattedMessage(message) {
    return [
        $c55de979aca75bc6$var$getDevMessage(message),
        'color: #00C584; font-size: 1.3em; font-weight: bold;',
        'line-height: 1.5',
        'color: #a6a095;'
    ];
} // Assume warnings and errors never have the same message
var $c55de979aca75bc6$var$visitedMessages;
function $c55de979aca75bc6$var$resetVisitedMessages() {
    $c55de979aca75bc6$var$visitedMessages = new Set();
}
function $c55de979aca75bc6$var$warnWhen(condition, message) {
    if (condition && !$c55de979aca75bc6$var$visitedMessages.has(message)) {
        var _console;
        $c55de979aca75bc6$var$visitedMessages.add(message);
        (_console = console).warn.apply(_console, $c55de979aca75bc6$var$getFormattedMessage(message));
    }
}
function $c55de979aca75bc6$var$errorWhen(condition, message) {
    if (condition && !$c55de979aca75bc6$var$visitedMessages.has(message)) {
        var _console2;
        $c55de979aca75bc6$var$visitedMessages.add(message);
        (_console2 = console).error.apply(_console2, $c55de979aca75bc6$var$getFormattedMessage(message));
    }
}
function $c55de979aca75bc6$var$validateTargets(targets) {
    var didPassFalsyValue = !targets;
    var didPassPlainObject = Object.prototype.toString.call(targets) === '[object Object]' && !targets.addEventListener;
    $c55de979aca75bc6$var$errorWhen(didPassFalsyValue, [
        'tippy() was passed',
        '`' + String(targets) + '`',
        'as its targets (first) argument. Valid types are: String, Element,',
        'Element[], or NodeList.'
    ].join(' '));
    $c55de979aca75bc6$var$errorWhen(didPassPlainObject, [
        'tippy() was passed a plain object which is not supported as an argument',
        'for virtual positioning. Use props.getReferenceClientRect instead.'
    ].join(' '));
}
var $c55de979aca75bc6$var$pluginProps = {
    animateFill: false,
    followCursor: false,
    inlinePositioning: false,
    sticky: false
};
var $c55de979aca75bc6$var$renderProps = {
    allowHTML: false,
    animation: 'fade',
    arrow: true,
    content: '',
    inertia: false,
    maxWidth: 350,
    role: 'tooltip',
    theme: '',
    zIndex: 9999
};
var $c55de979aca75bc6$var$defaultProps = Object.assign({
    appendTo: $c55de979aca75bc6$var$TIPPY_DEFAULT_APPEND_TO,
    aria: {
        content: 'auto',
        expanded: 'auto'
    },
    delay: 0,
    duration: [
        300,
        250
    ],
    getReferenceClientRect: null,
    hideOnClick: true,
    ignoreAttributes: false,
    interactive: false,
    interactiveBorder: 2,
    interactiveDebounce: 0,
    moveTransition: '',
    offset: [
        0,
        10
    ],
    onAfterUpdate: function onAfterUpdate() {},
    onBeforeUpdate: function onBeforeUpdate() {},
    onCreate: function onCreate() {},
    onDestroy: function onDestroy() {},
    onHidden: function onHidden() {},
    onHide: function onHide() {},
    onMount: function onMount() {},
    onShow: function onShow() {},
    onShown: function onShown() {},
    onTrigger: function onTrigger() {},
    onUntrigger: function onUntrigger() {},
    onClickOutside: function onClickOutside() {},
    placement: 'top',
    plugins: [],
    popperOptions: {},
    render: null,
    showOnCreate: false,
    touch: true,
    trigger: 'mouseenter focus',
    triggerTarget: null
}, $c55de979aca75bc6$var$pluginProps, $c55de979aca75bc6$var$renderProps);
var $c55de979aca75bc6$var$defaultKeys = Object.keys($c55de979aca75bc6$var$defaultProps);
var $c55de979aca75bc6$var$setDefaultProps = function setDefaultProps(partialProps) {
    var keys = Object.keys(partialProps);
    keys.forEach(function(key) {
        $c55de979aca75bc6$var$defaultProps[key] = partialProps[key];
    });
};
function $c55de979aca75bc6$var$getExtendedPassedProps(passedProps) {
    var plugins = passedProps.plugins || [];
    var pluginProps = plugins.reduce(function(acc, plugin) {
        var name = plugin.name, defaultValue = plugin.defaultValue;
        if (name) {
            var _name;
            acc[name] = passedProps[name] !== undefined ? passedProps[name] : (_name = $c55de979aca75bc6$var$defaultProps[name]) != null ? _name : defaultValue;
        }
        return acc;
    }, {});
    return Object.assign({}, passedProps, pluginProps);
}
function $c55de979aca75bc6$var$getDataAttributeProps(reference, plugins) {
    var propKeys = plugins ? Object.keys($c55de979aca75bc6$var$getExtendedPassedProps(Object.assign({}, $c55de979aca75bc6$var$defaultProps, {
        plugins: plugins
    }))) : $c55de979aca75bc6$var$defaultKeys;
    var props = propKeys.reduce(function(acc, key) {
        var valueAsString = (reference.getAttribute("data-tippy-" + key) || '').trim();
        if (!valueAsString) return acc;
        if (key === 'content') acc[key] = valueAsString;
        else try {
            acc[key] = JSON.parse(valueAsString);
        } catch (e) {
            acc[key] = valueAsString;
        }
        return acc;
    }, {});
    return props;
}
function $c55de979aca75bc6$var$evaluateProps(reference, props) {
    var out = Object.assign({}, props, {
        content: $c55de979aca75bc6$var$invokeWithArgsOrReturn(props.content, [
            reference
        ])
    }, props.ignoreAttributes ? {} : $c55de979aca75bc6$var$getDataAttributeProps(reference, props.plugins));
    out.aria = Object.assign({}, $c55de979aca75bc6$var$defaultProps.aria, out.aria);
    out.aria = {
        expanded: out.aria.expanded === 'auto' ? props.interactive : out.aria.expanded,
        content: out.aria.content === 'auto' ? props.interactive ? null : 'describedby' : out.aria.content
    };
    return out;
}
function $c55de979aca75bc6$var$validateProps(partialProps, plugins) {
    if (partialProps === void 0) partialProps = {};
    if (plugins === void 0) plugins = [];
    var keys = Object.keys(partialProps);
    keys.forEach(function(prop) {
        var nonPluginProps = $c55de979aca75bc6$var$removeProperties($c55de979aca75bc6$var$defaultProps, Object.keys($c55de979aca75bc6$var$pluginProps));
        var didPassUnknownProp = !$c55de979aca75bc6$var$hasOwnProperty(nonPluginProps, prop); // Check if the prop exists in `plugins`
        if (didPassUnknownProp) didPassUnknownProp = plugins.filter(function(plugin) {
            return plugin.name === prop;
        }).length === 0;
        $c55de979aca75bc6$var$warnWhen(didPassUnknownProp, [
            "`" + prop + "`",
            "is not a valid prop. You may have spelled it incorrectly, or if it's",
            'a plugin, forgot to pass it in an array as props.plugins.',
            '\n\n',
            'All props: https://atomiks.github.io/tippyjs/v6/all-props/\n',
            'Plugins: https://atomiks.github.io/tippyjs/v6/plugins/'
        ].join(' '));
    });
}
var $c55de979aca75bc6$var$innerHTML = function innerHTML() {
    return 'innerHTML';
};
function $c55de979aca75bc6$var$dangerouslySetInnerHTML(element, html) {
    element[$c55de979aca75bc6$var$innerHTML()] = html;
}
function $c55de979aca75bc6$var$createArrowElement(value) {
    var arrow = $c55de979aca75bc6$var$div();
    if (value === true) arrow.className = $c55de979aca75bc6$var$ARROW_CLASS;
    else {
        arrow.className = $c55de979aca75bc6$var$SVG_ARROW_CLASS;
        if ($c55de979aca75bc6$var$isElement(value)) arrow.appendChild(value);
        else $c55de979aca75bc6$var$dangerouslySetInnerHTML(arrow, value);
    }
    return arrow;
}
function $c55de979aca75bc6$var$setContent(content, props) {
    if ($c55de979aca75bc6$var$isElement(props.content)) {
        $c55de979aca75bc6$var$dangerouslySetInnerHTML(content, '');
        content.appendChild(props.content);
    } else if (typeof props.content !== 'function') {
        if (props.allowHTML) $c55de979aca75bc6$var$dangerouslySetInnerHTML(content, props.content);
        else content.textContent = props.content;
    }
}
function $c55de979aca75bc6$var$getChildren(popper) {
    var box = popper.firstElementChild;
    var boxChildren = $c55de979aca75bc6$var$arrayFrom(box.children);
    return {
        box: box,
        content: boxChildren.find(function(node) {
            return node.classList.contains($c55de979aca75bc6$var$CONTENT_CLASS);
        }),
        arrow: boxChildren.find(function(node) {
            return node.classList.contains($c55de979aca75bc6$var$ARROW_CLASS) || node.classList.contains($c55de979aca75bc6$var$SVG_ARROW_CLASS);
        }),
        backdrop: boxChildren.find(function(node) {
            return node.classList.contains($c55de979aca75bc6$var$BACKDROP_CLASS);
        })
    };
}
function $c55de979aca75bc6$var$render(instance) {
    var popper = $c55de979aca75bc6$var$div();
    var box = $c55de979aca75bc6$var$div();
    box.className = $c55de979aca75bc6$var$BOX_CLASS;
    box.setAttribute('data-state', 'hidden');
    box.setAttribute('tabindex', '-1');
    var content = $c55de979aca75bc6$var$div();
    content.className = $c55de979aca75bc6$var$CONTENT_CLASS;
    content.setAttribute('data-state', 'hidden');
    $c55de979aca75bc6$var$setContent(content, instance.props);
    popper.appendChild(box);
    box.appendChild(content);
    onUpdate(instance.props, instance.props);
    function onUpdate(prevProps, nextProps) {
        var _getChildren = $c55de979aca75bc6$var$getChildren(popper), box = _getChildren.box, content = _getChildren.content, arrow = _getChildren.arrow;
        if (nextProps.theme) box.setAttribute('data-theme', nextProps.theme);
        else box.removeAttribute('data-theme');
        if (typeof nextProps.animation === 'string') box.setAttribute('data-animation', nextProps.animation);
        else box.removeAttribute('data-animation');
        if (nextProps.inertia) box.setAttribute('data-inertia', '');
        else box.removeAttribute('data-inertia');
        box.style.maxWidth = typeof nextProps.maxWidth === 'number' ? nextProps.maxWidth + "px" : nextProps.maxWidth;
        if (nextProps.role) box.setAttribute('role', nextProps.role);
        else box.removeAttribute('role');
        if (prevProps.content !== nextProps.content || prevProps.allowHTML !== nextProps.allowHTML) $c55de979aca75bc6$var$setContent(content, instance.props);
        if (nextProps.arrow) {
            if (!arrow) box.appendChild($c55de979aca75bc6$var$createArrowElement(nextProps.arrow));
            else if (prevProps.arrow !== nextProps.arrow) {
                box.removeChild(arrow);
                box.appendChild($c55de979aca75bc6$var$createArrowElement(nextProps.arrow));
            }
        } else if (arrow) box.removeChild(arrow);
    }
    return {
        popper: popper,
        onUpdate: onUpdate
    };
} // Runtime check to identify if the render function is the default one; this
// way we can apply default CSS transitions logic and it can be tree-shaken away
$c55de979aca75bc6$var$render.$$tippy = true;
var $c55de979aca75bc6$var$idCounter = 1;
var $c55de979aca75bc6$var$mouseMoveListeners = []; // Used by `hideAll()`
var $c55de979aca75bc6$var$mountedInstances = [];
function $c55de979aca75bc6$var$createTippy(reference, passedProps) {
    var props = $c55de979aca75bc6$var$evaluateProps(reference, Object.assign({}, $c55de979aca75bc6$var$defaultProps, $c55de979aca75bc6$var$getExtendedPassedProps($c55de979aca75bc6$var$removeUndefinedProps(passedProps)))); // ===========================================================================
    // 🔒 Private members
    // ===========================================================================
    var showTimeout;
    var hideTimeout;
    var scheduleHideAnimationFrame;
    var isVisibleFromClick = false;
    var didHideDueToDocumentMouseDown = false;
    var didTouchMove = false;
    var ignoreOnFirstUpdate = false;
    var lastTriggerEvent;
    var currentTransitionEndListener;
    var onFirstUpdate;
    var listeners = [];
    var debouncedOnMouseMove = $c55de979aca75bc6$var$debounce(onMouseMove, props.interactiveDebounce);
    var currentTarget; // ===========================================================================
    // 🔑 Public members
    // ===========================================================================
    var id = $c55de979aca75bc6$var$idCounter++;
    var popperInstance = null;
    var plugins = $c55de979aca75bc6$var$unique(props.plugins);
    var state = {
        // Is the instance currently enabled?
        isEnabled: true,
        // Is the tippy currently showing and not transitioning out?
        isVisible: false,
        // Has the instance been destroyed?
        isDestroyed: false,
        // Is the tippy currently mounted to the DOM?
        isMounted: false,
        // Has the tippy finished transitioning in?
        isShown: false
    };
    var instance = {
        // properties
        id: id,
        reference: reference,
        popper: $c55de979aca75bc6$var$div(),
        popperInstance: popperInstance,
        props: props,
        state: state,
        plugins: plugins,
        // methods
        clearDelayTimeouts: clearDelayTimeouts,
        setProps: setProps,
        setContent: setContent,
        show: show,
        hide: hide,
        hideWithInteractivity: hideWithInteractivity,
        enable: enable,
        disable: disable,
        unmount: unmount,
        destroy: destroy
    }; // TODO: Investigate why this early return causes a TDZ error in the tests —
    // it doesn't seem to happen in the browser
    /* istanbul ignore if */ if (!props.render) return instance;
     // ===========================================================================
    // Initial mutations
    // ===========================================================================
    var _props$render = props.render(instance), popper = _props$render.popper, onUpdate = _props$render.onUpdate;
    popper.setAttribute('data-tippy-root', '');
    popper.id = "tippy-" + instance.id;
    instance.popper = popper;
    reference._tippy = instance;
    popper._tippy = instance;
    var pluginsHooks = plugins.map(function(plugin) {
        return plugin.fn(instance);
    });
    var hasAriaExpanded = reference.hasAttribute('aria-expanded');
    addListeners();
    handleAriaExpandedAttribute();
    handleStyles();
    invokeHook('onCreate', [
        instance
    ]);
    if (props.showOnCreate) scheduleShow();
     // Prevent a tippy with a delay from hiding if the cursor left then returned
    // before it started hiding
    popper.addEventListener('mouseenter', function() {
        if (instance.props.interactive && instance.state.isVisible) instance.clearDelayTimeouts();
    });
    popper.addEventListener('mouseleave', function() {
        if (instance.props.interactive && instance.props.trigger.indexOf('mouseenter') >= 0) getDocument().addEventListener('mousemove', debouncedOnMouseMove);
    });
    return instance; // ===========================================================================
    // 🔒 Private methods
    // ===========================================================================
    function getNormalizedTouchSettings() {
        var touch = instance.props.touch;
        return Array.isArray(touch) ? touch : [
            touch,
            0
        ];
    }
    function getIsCustomTouchBehavior() {
        return getNormalizedTouchSettings()[0] === 'hold';
    }
    function getIsDefaultRenderFn() {
        var _instance$props$rende;
        // @ts-ignore
        return !!((_instance$props$rende = instance.props.render) != null && _instance$props$rende.$$tippy);
    }
    function getCurrentTarget() {
        return currentTarget || reference;
    }
    function getDocument() {
        var parent = getCurrentTarget().parentNode;
        return parent ? $c55de979aca75bc6$var$getOwnerDocument(parent) : document;
    }
    function getDefaultTemplateChildren() {
        return $c55de979aca75bc6$var$getChildren(popper);
    }
    function getDelay(isShow) {
        // For touch or keyboard input, force `0` delay for UX reasons
        // Also if the instance is mounted but not visible (transitioning out),
        // ignore delay
        if (instance.state.isMounted && !instance.state.isVisible || $c55de979aca75bc6$var$currentInput.isTouch || lastTriggerEvent && lastTriggerEvent.type === 'focus') return 0;
        return $c55de979aca75bc6$var$getValueAtIndexOrReturn(instance.props.delay, isShow ? 0 : 1, $c55de979aca75bc6$var$defaultProps.delay);
    }
    function handleStyles(fromHide) {
        if (fromHide === void 0) fromHide = false;
        popper.style.pointerEvents = instance.props.interactive && !fromHide ? '' : 'none';
        popper.style.zIndex = "" + instance.props.zIndex;
    }
    function invokeHook(hook, args, shouldInvokePropsHook) {
        if (shouldInvokePropsHook === void 0) shouldInvokePropsHook = true;
        pluginsHooks.forEach(function(pluginHooks) {
            if (pluginHooks[hook]) pluginHooks[hook].apply(pluginHooks, args);
        });
        if (shouldInvokePropsHook) {
            var _instance$props;
            (_instance$props = instance.props)[hook].apply(_instance$props, args);
        }
    }
    function handleAriaContentAttribute() {
        var aria = instance.props.aria;
        if (!aria.content) return;
        var attr = "aria-" + aria.content;
        var id = popper.id;
        var nodes = $c55de979aca75bc6$var$normalizeToArray(instance.props.triggerTarget || reference);
        nodes.forEach(function(node) {
            var currentValue = node.getAttribute(attr);
            if (instance.state.isVisible) node.setAttribute(attr, currentValue ? currentValue + " " + id : id);
            else {
                var nextValue = currentValue && currentValue.replace(id, '').trim();
                if (nextValue) node.setAttribute(attr, nextValue);
                else node.removeAttribute(attr);
            }
        });
    }
    function handleAriaExpandedAttribute() {
        if (hasAriaExpanded || !instance.props.aria.expanded) return;
        var nodes = $c55de979aca75bc6$var$normalizeToArray(instance.props.triggerTarget || reference);
        nodes.forEach(function(node) {
            if (instance.props.interactive) node.setAttribute('aria-expanded', instance.state.isVisible && node === getCurrentTarget() ? 'true' : 'false');
            else node.removeAttribute('aria-expanded');
        });
    }
    function cleanupInteractiveMouseListeners() {
        getDocument().removeEventListener('mousemove', debouncedOnMouseMove);
        $c55de979aca75bc6$var$mouseMoveListeners = $c55de979aca75bc6$var$mouseMoveListeners.filter(function(listener) {
            return listener !== debouncedOnMouseMove;
        });
    }
    function onDocumentPress(event) {
        // Moved finger to scroll instead of an intentional tap outside
        if ($c55de979aca75bc6$var$currentInput.isTouch) {
            if (didTouchMove || event.type === 'mousedown') return;
        }
        var actualTarget = event.composedPath && event.composedPath()[0] || event.target; // Clicked on interactive popper
        if (instance.props.interactive && $c55de979aca75bc6$var$actualContains(popper, actualTarget)) return;
         // Clicked on the event listeners target
        if ($c55de979aca75bc6$var$normalizeToArray(instance.props.triggerTarget || reference).some(function(el) {
            return $c55de979aca75bc6$var$actualContains(el, actualTarget);
        })) {
            if ($c55de979aca75bc6$var$currentInput.isTouch) return;
            if (instance.state.isVisible && instance.props.trigger.indexOf('click') >= 0) return;
        } else invokeHook('onClickOutside', [
            instance,
            event
        ]);
        if (instance.props.hideOnClick === true) {
            instance.clearDelayTimeouts();
            instance.hide(); // `mousedown` event is fired right before `focus` if pressing the
            // currentTarget. This lets a tippy with `focus` trigger know that it
            // should not show
            didHideDueToDocumentMouseDown = true;
            setTimeout(function() {
                didHideDueToDocumentMouseDown = false;
            }); // The listener gets added in `scheduleShow()`, but this may be hiding it
            // before it shows, and hide()'s early bail-out behavior can prevent it
            // from being cleaned up
            if (!instance.state.isMounted) removeDocumentPress();
        }
    }
    function onTouchMove() {
        didTouchMove = true;
    }
    function onTouchStart() {
        didTouchMove = false;
    }
    function addDocumentPress() {
        var doc = getDocument();
        doc.addEventListener('mousedown', onDocumentPress, true);
        doc.addEventListener('touchend', onDocumentPress, $c55de979aca75bc6$var$TOUCH_OPTIONS);
        doc.addEventListener('touchstart', onTouchStart, $c55de979aca75bc6$var$TOUCH_OPTIONS);
        doc.addEventListener('touchmove', onTouchMove, $c55de979aca75bc6$var$TOUCH_OPTIONS);
    }
    function removeDocumentPress() {
        var doc = getDocument();
        doc.removeEventListener('mousedown', onDocumentPress, true);
        doc.removeEventListener('touchend', onDocumentPress, $c55de979aca75bc6$var$TOUCH_OPTIONS);
        doc.removeEventListener('touchstart', onTouchStart, $c55de979aca75bc6$var$TOUCH_OPTIONS);
        doc.removeEventListener('touchmove', onTouchMove, $c55de979aca75bc6$var$TOUCH_OPTIONS);
    }
    function onTransitionedOut(duration, callback) {
        onTransitionEnd(duration, function() {
            if (!instance.state.isVisible && popper.parentNode && popper.parentNode.contains(popper)) callback();
        });
    }
    function onTransitionedIn(duration, callback) {
        onTransitionEnd(duration, callback);
    }
    function onTransitionEnd(duration, callback) {
        var box = getDefaultTemplateChildren().box;
        function listener(event) {
            if (event.target === box) {
                $c55de979aca75bc6$var$updateTransitionEndListener(box, 'remove', listener);
                callback();
            }
        } // Make callback synchronous if duration is 0
        // `transitionend` won't fire otherwise
        if (duration === 0) return callback();
        $c55de979aca75bc6$var$updateTransitionEndListener(box, 'remove', currentTransitionEndListener);
        $c55de979aca75bc6$var$updateTransitionEndListener(box, 'add', listener);
        currentTransitionEndListener = listener;
    }
    function on(eventType, handler, options) {
        if (options === void 0) options = false;
        var nodes = $c55de979aca75bc6$var$normalizeToArray(instance.props.triggerTarget || reference);
        nodes.forEach(function(node) {
            node.addEventListener(eventType, handler, options);
            listeners.push({
                node: node,
                eventType: eventType,
                handler: handler,
                options: options
            });
        });
    }
    function addListeners() {
        if (getIsCustomTouchBehavior()) {
            on('touchstart', onTrigger, {
                passive: true
            });
            on('touchend', onMouseLeave, {
                passive: true
            });
        }
        $c55de979aca75bc6$var$splitBySpaces(instance.props.trigger).forEach(function(eventType) {
            if (eventType === 'manual') return;
            on(eventType, onTrigger);
            switch(eventType){
                case 'mouseenter':
                    on('mouseleave', onMouseLeave);
                    break;
                case 'focus':
                    on($c55de979aca75bc6$var$isIE11 ? 'focusout' : 'blur', onBlurOrFocusOut);
                    break;
                case 'focusin':
                    on('focusout', onBlurOrFocusOut);
                    break;
            }
        });
    }
    function removeListeners() {
        listeners.forEach(function(_ref) {
            var node = _ref.node, eventType = _ref.eventType, handler = _ref.handler, options = _ref.options;
            node.removeEventListener(eventType, handler, options);
        });
        listeners = [];
    }
    function onTrigger(event) {
        var _lastTriggerEvent;
        var shouldScheduleClickHide = false;
        if (!instance.state.isEnabled || isEventListenerStopped(event) || didHideDueToDocumentMouseDown) return;
        var wasFocused = ((_lastTriggerEvent = lastTriggerEvent) == null ? void 0 : _lastTriggerEvent.type) === 'focus';
        lastTriggerEvent = event;
        currentTarget = event.currentTarget;
        handleAriaExpandedAttribute();
        if (!instance.state.isVisible && $c55de979aca75bc6$var$isMouseEvent(event)) // If scrolling, `mouseenter` events can be fired if the cursor lands
        // over a new target, but `mousemove` events don't get fired. This
        // causes interactive tooltips to get stuck open until the cursor is
        // moved
        $c55de979aca75bc6$var$mouseMoveListeners.forEach(function(listener) {
            return listener(event);
        });
         // Toggle show/hide when clicking click-triggered tooltips
        if (event.type === 'click' && (instance.props.trigger.indexOf('mouseenter') < 0 || isVisibleFromClick) && instance.props.hideOnClick !== false && instance.state.isVisible) shouldScheduleClickHide = true;
        else scheduleShow(event);
        if (event.type === 'click') isVisibleFromClick = !shouldScheduleClickHide;
        if (shouldScheduleClickHide && !wasFocused) scheduleHide(event);
    }
    function onMouseMove(event) {
        var target = event.target;
        var isCursorOverReferenceOrPopper = getCurrentTarget().contains(target) || popper.contains(target);
        if (event.type === 'mousemove' && isCursorOverReferenceOrPopper) return;
        var popperTreeData = getNestedPopperTree().concat(popper).map(function(popper) {
            var _instance$popperInsta;
            var instance = popper._tippy;
            var state = (_instance$popperInsta = instance.popperInstance) == null ? void 0 : _instance$popperInsta.state;
            if (state) return {
                popperRect: popper.getBoundingClientRect(),
                popperState: state,
                props: props
            };
            return null;
        }).filter(Boolean);
        if ($c55de979aca75bc6$var$isCursorOutsideInteractiveBorder(popperTreeData, event)) {
            cleanupInteractiveMouseListeners();
            scheduleHide(event);
        }
    }
    function onMouseLeave(event) {
        var shouldBail = isEventListenerStopped(event) || instance.props.trigger.indexOf('click') >= 0 && isVisibleFromClick;
        if (shouldBail) return;
        if (instance.props.interactive) {
            instance.hideWithInteractivity(event);
            return;
        }
        scheduleHide(event);
    }
    function onBlurOrFocusOut(event) {
        if (instance.props.trigger.indexOf('focusin') < 0 && event.target !== getCurrentTarget()) return;
         // If focus was moved to within the popper
        if (instance.props.interactive && event.relatedTarget && popper.contains(event.relatedTarget)) return;
        scheduleHide(event);
    }
    function isEventListenerStopped(event) {
        return $c55de979aca75bc6$var$currentInput.isTouch ? getIsCustomTouchBehavior() !== event.type.indexOf('touch') >= 0 : false;
    }
    function createPopperInstance() {
        destroyPopperInstance();
        var _instance$props2 = instance.props, popperOptions = _instance$props2.popperOptions, placement = _instance$props2.placement, offset = _instance$props2.offset, getReferenceClientRect = _instance$props2.getReferenceClientRect, moveTransition = _instance$props2.moveTransition;
        var arrow = getIsDefaultRenderFn() ? $c55de979aca75bc6$var$getChildren(popper).arrow : null;
        var computedReference = getReferenceClientRect ? {
            getBoundingClientRect: getReferenceClientRect,
            contextElement: getReferenceClientRect.contextElement || getCurrentTarget()
        } : reference;
        var tippyModifier = {
            name: '$$tippy',
            enabled: true,
            phase: 'beforeWrite',
            requires: [
                'computeStyles'
            ],
            fn: function fn(_ref2) {
                var state = _ref2.state;
                if (getIsDefaultRenderFn()) {
                    var _getDefaultTemplateCh = getDefaultTemplateChildren(), box = _getDefaultTemplateCh.box;
                    [
                        'placement',
                        'reference-hidden',
                        'escaped'
                    ].forEach(function(attr) {
                        if (attr === 'placement') box.setAttribute('data-placement', state.placement);
                        else if (state.attributes.popper["data-popper-" + attr]) box.setAttribute("data-" + attr, '');
                        else box.removeAttribute("data-" + attr);
                    });
                    state.attributes.popper = {};
                }
            }
        };
        var modifiers = [
            {
                name: 'offset',
                options: {
                    offset: offset
                }
            },
            {
                name: 'preventOverflow',
                options: {
                    padding: {
                        top: 2,
                        bottom: 2,
                        left: 5,
                        right: 5
                    }
                }
            },
            {
                name: 'flip',
                options: {
                    padding: 5
                }
            },
            {
                name: 'computeStyles',
                options: {
                    adaptive: !moveTransition
                }
            },
            tippyModifier
        ];
        if (getIsDefaultRenderFn() && arrow) modifiers.push({
            name: 'arrow',
            options: {
                element: arrow,
                padding: 3
            }
        });
        modifiers.push.apply(modifiers, (popperOptions == null ? void 0 : popperOptions.modifiers) || []);
        instance.popperInstance = (0, $98a9ef6d31ff03cd$export$8f7491d57c8f97a9)(computedReference, popper, Object.assign({}, popperOptions, {
            placement: placement,
            onFirstUpdate: onFirstUpdate,
            modifiers: modifiers
        }));
    }
    function destroyPopperInstance() {
        if (instance.popperInstance) {
            instance.popperInstance.destroy();
            instance.popperInstance = null;
        }
    }
    function mount() {
        var appendTo = instance.props.appendTo;
        var parentNode; // By default, we'll append the popper to the triggerTargets's parentNode so
        // it's directly after the reference element so the elements inside the
        // tippy can be tabbed to
        // If there are clipping issues, the user can specify a different appendTo
        // and ensure focus management is handled correctly manually
        var node = getCurrentTarget();
        if (instance.props.interactive && appendTo === $c55de979aca75bc6$var$TIPPY_DEFAULT_APPEND_TO || appendTo === 'parent') parentNode = node.parentNode;
        else parentNode = $c55de979aca75bc6$var$invokeWithArgsOrReturn(appendTo, [
            node
        ]);
         // The popper element needs to exist on the DOM before its position can be
        // updated as Popper needs to read its dimensions
        if (!parentNode.contains(popper)) parentNode.appendChild(popper);
        instance.state.isMounted = true;
        createPopperInstance();
    }
    function getNestedPopperTree() {
        return $c55de979aca75bc6$var$arrayFrom(popper.querySelectorAll('[data-tippy-root]'));
    }
    function scheduleShow(event) {
        instance.clearDelayTimeouts();
        if (event) invokeHook('onTrigger', [
            instance,
            event
        ]);
        addDocumentPress();
        var delay = getDelay(true);
        var _getNormalizedTouchSe = getNormalizedTouchSettings(), touchValue = _getNormalizedTouchSe[0], touchDelay = _getNormalizedTouchSe[1];
        if ($c55de979aca75bc6$var$currentInput.isTouch && touchValue === 'hold' && touchDelay) delay = touchDelay;
        if (delay) showTimeout = setTimeout(function() {
            instance.show();
        }, delay);
        else instance.show();
    }
    function scheduleHide(event) {
        instance.clearDelayTimeouts();
        invokeHook('onUntrigger', [
            instance,
            event
        ]);
        if (!instance.state.isVisible) {
            removeDocumentPress();
            return;
        } // For interactive tippies, scheduleHide is added to a document.body handler
        // from onMouseLeave so must intercept scheduled hides from mousemove/leave
        // events when trigger contains mouseenter and click, and the tip is
        // currently shown as a result of a click.
        if (instance.props.trigger.indexOf('mouseenter') >= 0 && instance.props.trigger.indexOf('click') >= 0 && [
            'mouseleave',
            'mousemove'
        ].indexOf(event.type) >= 0 && isVisibleFromClick) return;
        var delay = getDelay(false);
        if (delay) hideTimeout = setTimeout(function() {
            if (instance.state.isVisible) instance.hide();
        }, delay);
        else // Fixes a `transitionend` problem when it fires 1 frame too
        // late sometimes, we don't want hide() to be called.
        scheduleHideAnimationFrame = requestAnimationFrame(function() {
            instance.hide();
        });
    } // ===========================================================================
    // 🔑 Public methods
    // ===========================================================================
    function enable() {
        instance.state.isEnabled = true;
    }
    function disable() {
        // Disabling the instance should also hide it
        // https://github.com/atomiks/tippy.js-react/issues/106
        instance.hide();
        instance.state.isEnabled = false;
    }
    function clearDelayTimeouts() {
        clearTimeout(showTimeout);
        clearTimeout(hideTimeout);
        cancelAnimationFrame(scheduleHideAnimationFrame);
    }
    function setProps(partialProps) {
        if (instance.state.isDestroyed) return;
        invokeHook('onBeforeUpdate', [
            instance,
            partialProps
        ]);
        removeListeners();
        var prevProps = instance.props;
        var nextProps = $c55de979aca75bc6$var$evaluateProps(reference, Object.assign({}, prevProps, $c55de979aca75bc6$var$removeUndefinedProps(partialProps), {
            ignoreAttributes: true
        }));
        instance.props = nextProps;
        addListeners();
        if (prevProps.interactiveDebounce !== nextProps.interactiveDebounce) {
            cleanupInteractiveMouseListeners();
            debouncedOnMouseMove = $c55de979aca75bc6$var$debounce(onMouseMove, nextProps.interactiveDebounce);
        } // Ensure stale aria-expanded attributes are removed
        if (prevProps.triggerTarget && !nextProps.triggerTarget) $c55de979aca75bc6$var$normalizeToArray(prevProps.triggerTarget).forEach(function(node) {
            node.removeAttribute('aria-expanded');
        });
        else if (nextProps.triggerTarget) reference.removeAttribute('aria-expanded');
        handleAriaExpandedAttribute();
        handleStyles();
        if (onUpdate) onUpdate(prevProps, nextProps);
        if (instance.popperInstance) {
            createPopperInstance(); // Fixes an issue with nested tippies if they are all getting re-rendered,
            // and the nested ones get re-rendered first.
            // https://github.com/atomiks/tippyjs-react/issues/177
            // TODO: find a cleaner / more efficient solution(!)
            getNestedPopperTree().forEach(function(nestedPopper) {
                // React (and other UI libs likely) requires a rAF wrapper as it flushes
                // its work in one
                requestAnimationFrame(nestedPopper._tippy.popperInstance.forceUpdate);
            });
        }
        invokeHook('onAfterUpdate', [
            instance,
            partialProps
        ]);
    }
    function setContent(content) {
        instance.setProps({
            content: content
        });
    }
    function show() {
        var isAlreadyVisible = instance.state.isVisible;
        var isDestroyed = instance.state.isDestroyed;
        var isDisabled = !instance.state.isEnabled;
        var isTouchAndTouchDisabled = $c55de979aca75bc6$var$currentInput.isTouch && !instance.props.touch;
        var duration = $c55de979aca75bc6$var$getValueAtIndexOrReturn(instance.props.duration, 0, $c55de979aca75bc6$var$defaultProps.duration);
        if (isAlreadyVisible || isDestroyed || isDisabled || isTouchAndTouchDisabled) return;
         // Normalize `disabled` behavior across browsers.
        // Firefox allows events on disabled elements, but Chrome doesn't.
        // Using a wrapper element (i.e. <span>) is recommended.
        if (getCurrentTarget().hasAttribute('disabled')) return;
        invokeHook('onShow', [
            instance
        ], false);
        if (instance.props.onShow(instance) === false) return;
        instance.state.isVisible = true;
        if (getIsDefaultRenderFn()) popper.style.visibility = 'visible';
        handleStyles();
        addDocumentPress();
        if (!instance.state.isMounted) popper.style.transition = 'none';
         // If flipping to the opposite side after hiding at least once, the
        // animation will use the wrong placement without resetting the duration
        if (getIsDefaultRenderFn()) {
            var _getDefaultTemplateCh2 = getDefaultTemplateChildren(), box = _getDefaultTemplateCh2.box, content = _getDefaultTemplateCh2.content;
            $c55de979aca75bc6$var$setTransitionDuration([
                box,
                content
            ], 0);
        }
        onFirstUpdate = function onFirstUpdate() {
            var _instance$popperInsta2;
            if (!instance.state.isVisible || ignoreOnFirstUpdate) return;
            ignoreOnFirstUpdate = true; // reflow
            popper.offsetHeight;
            popper.style.transition = instance.props.moveTransition;
            if (getIsDefaultRenderFn() && instance.props.animation) {
                var _getDefaultTemplateCh3 = getDefaultTemplateChildren(), _box = _getDefaultTemplateCh3.box, _content = _getDefaultTemplateCh3.content;
                $c55de979aca75bc6$var$setTransitionDuration([
                    _box,
                    _content
                ], duration);
                $c55de979aca75bc6$var$setVisibilityState([
                    _box,
                    _content
                ], 'visible');
            }
            handleAriaContentAttribute();
            handleAriaExpandedAttribute();
            $c55de979aca75bc6$var$pushIfUnique($c55de979aca75bc6$var$mountedInstances, instance); // certain modifiers (e.g. `maxSize`) require a second update after the
            // popper has been positioned for the first time
            (_instance$popperInsta2 = instance.popperInstance) == null || _instance$popperInsta2.forceUpdate();
            invokeHook('onMount', [
                instance
            ]);
            if (instance.props.animation && getIsDefaultRenderFn()) onTransitionedIn(duration, function() {
                instance.state.isShown = true;
                invokeHook('onShown', [
                    instance
                ]);
            });
        };
        mount();
    }
    function hide() {
        var isAlreadyHidden = !instance.state.isVisible;
        var isDestroyed = instance.state.isDestroyed;
        var isDisabled = !instance.state.isEnabled;
        var duration = $c55de979aca75bc6$var$getValueAtIndexOrReturn(instance.props.duration, 1, $c55de979aca75bc6$var$defaultProps.duration);
        if (isAlreadyHidden || isDestroyed || isDisabled) return;
        invokeHook('onHide', [
            instance
        ], false);
        if (instance.props.onHide(instance) === false) return;
        instance.state.isVisible = false;
        instance.state.isShown = false;
        ignoreOnFirstUpdate = false;
        isVisibleFromClick = false;
        if (getIsDefaultRenderFn()) popper.style.visibility = 'hidden';
        cleanupInteractiveMouseListeners();
        removeDocumentPress();
        handleStyles(true);
        if (getIsDefaultRenderFn()) {
            var _getDefaultTemplateCh4 = getDefaultTemplateChildren(), box = _getDefaultTemplateCh4.box, content = _getDefaultTemplateCh4.content;
            if (instance.props.animation) {
                $c55de979aca75bc6$var$setTransitionDuration([
                    box,
                    content
                ], duration);
                $c55de979aca75bc6$var$setVisibilityState([
                    box,
                    content
                ], 'hidden');
            }
        }
        handleAriaContentAttribute();
        handleAriaExpandedAttribute();
        if (instance.props.animation) {
            if (getIsDefaultRenderFn()) onTransitionedOut(duration, instance.unmount);
        } else instance.unmount();
    }
    function hideWithInteractivity(event) {
        getDocument().addEventListener('mousemove', debouncedOnMouseMove);
        $c55de979aca75bc6$var$pushIfUnique($c55de979aca75bc6$var$mouseMoveListeners, debouncedOnMouseMove);
        debouncedOnMouseMove(event);
    }
    function unmount() {
        if (instance.state.isVisible) instance.hide();
        if (!instance.state.isMounted) return;
        destroyPopperInstance(); // If a popper is not interactive, it will be appended outside the popper
        // tree by default. This seems mainly for interactive tippies, but we should
        // find a workaround if possible
        getNestedPopperTree().forEach(function(nestedPopper) {
            nestedPopper._tippy.unmount();
        });
        if (popper.parentNode) popper.parentNode.removeChild(popper);
        $c55de979aca75bc6$var$mountedInstances = $c55de979aca75bc6$var$mountedInstances.filter(function(i) {
            return i !== instance;
        });
        instance.state.isMounted = false;
        invokeHook('onHidden', [
            instance
        ]);
    }
    function destroy() {
        if (instance.state.isDestroyed) return;
        instance.clearDelayTimeouts();
        instance.unmount();
        removeListeners();
        delete reference._tippy;
        instance.state.isDestroyed = true;
        invokeHook('onDestroy', [
            instance
        ]);
    }
}
function $c55de979aca75bc6$var$tippy(targets, optionalProps) {
    if (optionalProps === void 0) optionalProps = {};
    var plugins = $c55de979aca75bc6$var$defaultProps.plugins.concat(optionalProps.plugins || []);
    $c55de979aca75bc6$var$bindGlobalEventListeners();
    var passedProps = Object.assign({}, optionalProps, {
        plugins: plugins
    });
    var elements = $c55de979aca75bc6$var$getArrayOfElements(targets);
    var isSingleContentElement, isMoreThanOneReferenceElement;
    var instances = elements.reduce(function(acc, reference) {
        var instance = reference && $c55de979aca75bc6$var$createTippy(reference, passedProps);
        if (instance) acc.push(instance);
        return acc;
    }, []);
    return $c55de979aca75bc6$var$isElement(targets) ? instances[0] : instances;
}
$c55de979aca75bc6$var$tippy.defaultProps = $c55de979aca75bc6$var$defaultProps;
$c55de979aca75bc6$var$tippy.setDefaultProps = $c55de979aca75bc6$var$setDefaultProps;
$c55de979aca75bc6$var$tippy.currentInput = $c55de979aca75bc6$var$currentInput;
var $c55de979aca75bc6$export$a9608aab345f7e75 = function hideAll(_temp) {
    var _ref = _temp === void 0 ? {} : _temp, excludedReferenceOrInstance = _ref.exclude, duration = _ref.duration;
    $c55de979aca75bc6$var$mountedInstances.forEach(function(instance) {
        var isExcluded = false;
        if (excludedReferenceOrInstance) isExcluded = $c55de979aca75bc6$var$isReferenceElement(excludedReferenceOrInstance) ? instance.reference === excludedReferenceOrInstance : instance.popper === excludedReferenceOrInstance.popper;
        if (!isExcluded) {
            var originalDuration = instance.props.duration;
            instance.setProps({
                duration: duration
            });
            instance.hide();
            if (!instance.state.isDestroyed) instance.setProps({
                duration: originalDuration
            });
        }
    });
};
// every time the popper is destroyed (i.e. a new target), removing the styles
// and causing transitions to break for singletons when the console is open, but
// most notably for non-transform styles being used, `gpuAcceleration: false`.
var $c55de979aca75bc6$var$applyStylesModifier = Object.assign({}, (0, $312913fa2edc14b2$export$2e2bcd8739ae039), {
    effect: function effect(_ref) {
        var state = _ref.state;
        var initialStyles = {
            popper: {
                position: state.options.strategy,
                left: '0',
                top: '0',
                margin: '0'
            },
            arrow: {
                position: 'absolute'
            },
            reference: {}
        };
        Object.assign(state.elements.popper.style, initialStyles.popper);
        state.styles = initialStyles;
        if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
         // intentionally return no cleanup function
    // return () => { ... }
    }
});
var $c55de979aca75bc6$export$374c483667c1ea9b = function createSingleton(tippyInstances, optionalProps) {
    var _optionalProps$popper;
    if (optionalProps === void 0) optionalProps = {};
    var individualInstances = tippyInstances;
    var references = [];
    var triggerTargets = [];
    var currentTarget;
    var overrides = optionalProps.overrides;
    var interceptSetPropsCleanups = [];
    var shownOnCreate = false;
    function setTriggerTargets() {
        triggerTargets = individualInstances.map(function(instance) {
            return $c55de979aca75bc6$var$normalizeToArray(instance.props.triggerTarget || instance.reference);
        }).reduce(function(acc, item) {
            return acc.concat(item);
        }, []);
    }
    function setReferences() {
        references = individualInstances.map(function(instance) {
            return instance.reference;
        });
    }
    function enableInstances(isEnabled) {
        individualInstances.forEach(function(instance) {
            if (isEnabled) instance.enable();
            else instance.disable();
        });
    }
    function interceptSetProps(singleton) {
        return individualInstances.map(function(instance) {
            var originalSetProps = instance.setProps;
            instance.setProps = function(props) {
                originalSetProps(props);
                if (instance.reference === currentTarget) singleton.setProps(props);
            };
            return function() {
                instance.setProps = originalSetProps;
            };
        });
    } // have to pass singleton, as it maybe undefined on first call
    function prepareInstance(singleton, target) {
        var index = triggerTargets.indexOf(target); // bail-out
        if (target === currentTarget) return;
        currentTarget = target;
        var overrideProps = (overrides || []).concat('content').reduce(function(acc, prop) {
            acc[prop] = individualInstances[index].props[prop];
            return acc;
        }, {});
        singleton.setProps(Object.assign({}, overrideProps, {
            getReferenceClientRect: typeof overrideProps.getReferenceClientRect === 'function' ? overrideProps.getReferenceClientRect : function() {
                var _references$index;
                return (_references$index = references[index]) == null ? void 0 : _references$index.getBoundingClientRect();
            }
        }));
    }
    enableInstances(false);
    setReferences();
    setTriggerTargets();
    var plugin = {
        fn: function fn() {
            return {
                onDestroy: function onDestroy() {
                    enableInstances(true);
                },
                onHidden: function onHidden() {
                    currentTarget = null;
                },
                onClickOutside: function onClickOutside(instance) {
                    if (instance.props.showOnCreate && !shownOnCreate) {
                        shownOnCreate = true;
                        currentTarget = null;
                    }
                },
                onShow: function onShow(instance) {
                    if (instance.props.showOnCreate && !shownOnCreate) {
                        shownOnCreate = true;
                        prepareInstance(instance, references[0]);
                    }
                },
                onTrigger: function onTrigger(instance, event) {
                    prepareInstance(instance, event.currentTarget);
                }
            };
        }
    };
    var singleton = $c55de979aca75bc6$var$tippy($c55de979aca75bc6$var$div(), Object.assign({}, $c55de979aca75bc6$var$removeProperties(optionalProps, [
        'overrides'
    ]), {
        plugins: [
            plugin
        ].concat(optionalProps.plugins || []),
        triggerTarget: triggerTargets,
        popperOptions: Object.assign({}, optionalProps.popperOptions, {
            modifiers: [].concat(((_optionalProps$popper = optionalProps.popperOptions) == null ? void 0 : _optionalProps$popper.modifiers) || [], [
                $c55de979aca75bc6$var$applyStylesModifier
            ])
        })
    }));
    var originalShow = singleton.show;
    singleton.show = function(target) {
        originalShow(); // first time, showOnCreate or programmatic call with no params
        // default to showing first instance
        if (!currentTarget && target == null) return prepareInstance(singleton, references[0]);
         // triggered from event (do nothing as prepareInstance already called by onTrigger)
        // programmatic call with no params when already visible (do nothing again)
        if (currentTarget && target == null) return;
         // target is index of instance
        if (typeof target === 'number') return references[target] && prepareInstance(singleton, references[target]);
         // target is a child tippy instance
        if (individualInstances.indexOf(target) >= 0) {
            var ref = target.reference;
            return prepareInstance(singleton, ref);
        } // target is a ReferenceElement
        if (references.indexOf(target) >= 0) return prepareInstance(singleton, target);
    };
    singleton.showNext = function() {
        var first = references[0];
        if (!currentTarget) return singleton.show(0);
        var index = references.indexOf(currentTarget);
        singleton.show(references[index + 1] || first);
    };
    singleton.showPrevious = function() {
        var last = references[references.length - 1];
        if (!currentTarget) return singleton.show(last);
        var index = references.indexOf(currentTarget);
        var target = references[index - 1] || last;
        singleton.show(target);
    };
    var originalSetProps = singleton.setProps;
    singleton.setProps = function(props) {
        overrides = props.overrides || overrides;
        originalSetProps(props);
    };
    singleton.setInstances = function(nextInstances) {
        enableInstances(true);
        interceptSetPropsCleanups.forEach(function(fn) {
            return fn();
        });
        individualInstances = nextInstances;
        enableInstances(false);
        setReferences();
        setTriggerTargets();
        interceptSetPropsCleanups = interceptSetProps(singleton);
        singleton.setProps({
            triggerTarget: triggerTargets
        });
    };
    interceptSetPropsCleanups = interceptSetProps(singleton);
    return singleton;
};
var $c55de979aca75bc6$var$BUBBLING_EVENTS_MAP = {
    mouseover: 'mouseenter',
    focusin: 'focus',
    click: 'click'
};
/**
 * Creates a delegate instance that controls the creation of tippy instances
 * for child elements (`target` CSS selector).
 */ function $c55de979aca75bc6$export$10b1921597150314(targets, props) {
    var listeners = [];
    var childTippyInstances = [];
    var disabled = false;
    var target = props.target;
    var nativeProps = $c55de979aca75bc6$var$removeProperties(props, [
        'target'
    ]);
    var parentProps = Object.assign({}, nativeProps, {
        trigger: 'manual',
        touch: false
    });
    var childProps = Object.assign({
        touch: $c55de979aca75bc6$var$defaultProps.touch
    }, nativeProps, {
        showOnCreate: true
    });
    var returnValue = $c55de979aca75bc6$var$tippy(targets, parentProps);
    var normalizedReturnValue = $c55de979aca75bc6$var$normalizeToArray(returnValue);
    function onTrigger(event) {
        if (!event.target || disabled) return;
        var targetNode = event.target.closest(target);
        if (!targetNode) return;
         // Get relevant trigger with fallbacks:
        // 1. Check `data-tippy-trigger` attribute on target node
        // 2. Fallback to `trigger` passed to `delegate()`
        // 3. Fallback to `defaultProps.trigger`
        var trigger = targetNode.getAttribute('data-tippy-trigger') || props.trigger || $c55de979aca75bc6$var$defaultProps.trigger; // @ts-ignore
        if (targetNode._tippy) return;
        if (event.type === 'touchstart' && typeof childProps.touch === 'boolean') return;
        if (event.type !== 'touchstart' && trigger.indexOf($c55de979aca75bc6$var$BUBBLING_EVENTS_MAP[event.type]) < 0) return;
        var instance = $c55de979aca75bc6$var$tippy(targetNode, childProps);
        if (instance) childTippyInstances = childTippyInstances.concat(instance);
    }
    function on(node, eventType, handler, options) {
        if (options === void 0) options = false;
        node.addEventListener(eventType, handler, options);
        listeners.push({
            node: node,
            eventType: eventType,
            handler: handler,
            options: options
        });
    }
    function addEventListeners(instance) {
        var reference = instance.reference;
        on(reference, 'touchstart', onTrigger, $c55de979aca75bc6$var$TOUCH_OPTIONS);
        on(reference, 'mouseover', onTrigger);
        on(reference, 'focusin', onTrigger);
        on(reference, 'click', onTrigger);
    }
    function removeEventListeners() {
        listeners.forEach(function(_ref) {
            var node = _ref.node, eventType = _ref.eventType, handler = _ref.handler, options = _ref.options;
            node.removeEventListener(eventType, handler, options);
        });
        listeners = [];
    }
    function applyMutations(instance) {
        var originalDestroy = instance.destroy;
        var originalEnable = instance.enable;
        var originalDisable = instance.disable;
        instance.destroy = function(shouldDestroyChildInstances) {
            if (shouldDestroyChildInstances === void 0) shouldDestroyChildInstances = true;
            if (shouldDestroyChildInstances) childTippyInstances.forEach(function(instance) {
                instance.destroy();
            });
            childTippyInstances = [];
            removeEventListeners();
            originalDestroy();
        };
        instance.enable = function() {
            originalEnable();
            childTippyInstances.forEach(function(instance) {
                return instance.enable();
            });
            disabled = false;
        };
        instance.disable = function() {
            originalDisable();
            childTippyInstances.forEach(function(instance) {
                return instance.disable();
            });
            disabled = true;
        };
        addEventListeners(instance);
    }
    normalizedReturnValue.forEach(applyMutations);
    return returnValue;
}
var $c55de979aca75bc6$export$dd8ded329c01db79 = {
    name: 'animateFill',
    defaultValue: false,
    fn: function fn(instance) {
        var _instance$props$rende;
        // @ts-ignore
        if (!((_instance$props$rende = instance.props.render) != null && _instance$props$rende.$$tippy)) return {};
        var _getChildren = $c55de979aca75bc6$var$getChildren(instance.popper), box = _getChildren.box, content = _getChildren.content;
        var backdrop = instance.props.animateFill ? $c55de979aca75bc6$var$createBackdropElement() : null;
        return {
            onCreate: function onCreate() {
                if (backdrop) {
                    box.insertBefore(backdrop, box.firstElementChild);
                    box.setAttribute('data-animatefill', '');
                    box.style.overflow = 'hidden';
                    instance.setProps({
                        arrow: false,
                        animation: 'shift-away'
                    });
                }
            },
            onMount: function onMount() {
                if (backdrop) {
                    var transitionDuration = box.style.transitionDuration;
                    var duration = Number(transitionDuration.replace('ms', '')); // The content should fade in after the backdrop has mostly filled the
                    // tooltip element. `clip-path` is the other alternative but is not
                    // well-supported and is buggy on some devices.
                    content.style.transitionDelay = Math.round(duration / 10) + "ms";
                    backdrop.style.transitionDuration = transitionDuration;
                    $c55de979aca75bc6$var$setVisibilityState([
                        backdrop
                    ], 'visible');
                }
            },
            onShow: function onShow() {
                if (backdrop) backdrop.style.transitionDuration = '0ms';
            },
            onHide: function onHide() {
                if (backdrop) $c55de979aca75bc6$var$setVisibilityState([
                    backdrop
                ], 'hidden');
            }
        };
    }
};
function $c55de979aca75bc6$var$createBackdropElement() {
    var backdrop = $c55de979aca75bc6$var$div();
    backdrop.className = $c55de979aca75bc6$var$BACKDROP_CLASS;
    $c55de979aca75bc6$var$setVisibilityState([
        backdrop
    ], 'hidden');
    return backdrop;
}
var $c55de979aca75bc6$var$mouseCoords = {
    clientX: 0,
    clientY: 0
};
var $c55de979aca75bc6$var$activeInstances = [];
function $c55de979aca75bc6$var$storeMouseCoords(_ref) {
    var clientX = _ref.clientX, clientY = _ref.clientY;
    $c55de979aca75bc6$var$mouseCoords = {
        clientX: clientX,
        clientY: clientY
    };
}
function $c55de979aca75bc6$var$addMouseCoordsListener(doc) {
    doc.addEventListener('mousemove', $c55de979aca75bc6$var$storeMouseCoords);
}
function $c55de979aca75bc6$var$removeMouseCoordsListener(doc) {
    doc.removeEventListener('mousemove', $c55de979aca75bc6$var$storeMouseCoords);
}
var $c55de979aca75bc6$export$ac81526b64504ab6 = {
    name: 'followCursor',
    defaultValue: false,
    fn: function fn(instance) {
        var reference = instance.reference;
        var doc = $c55de979aca75bc6$var$getOwnerDocument(instance.props.triggerTarget || reference);
        var isInternalUpdate = false;
        var wasFocusEvent = false;
        var isUnmounted = true;
        var prevProps = instance.props;
        function getIsInitialBehavior() {
            return instance.props.followCursor === 'initial' && instance.state.isVisible;
        }
        function addListener() {
            doc.addEventListener('mousemove', onMouseMove);
        }
        function removeListener() {
            doc.removeEventListener('mousemove', onMouseMove);
        }
        function unsetGetReferenceClientRect() {
            isInternalUpdate = true;
            instance.setProps({
                getReferenceClientRect: null
            });
            isInternalUpdate = false;
        }
        function onMouseMove(event) {
            // If the instance is interactive, avoid updating the position unless it's
            // over the reference element
            var isCursorOverReference = event.target ? reference.contains(event.target) : true;
            var followCursor = instance.props.followCursor;
            var clientX = event.clientX, clientY = event.clientY;
            var rect = reference.getBoundingClientRect();
            var relativeX = clientX - rect.left;
            var relativeY = clientY - rect.top;
            if (isCursorOverReference || !instance.props.interactive) instance.setProps({
                // @ts-ignore - unneeded DOMRect properties
                getReferenceClientRect: function getReferenceClientRect() {
                    var rect = reference.getBoundingClientRect();
                    var x = clientX;
                    var y = clientY;
                    if (followCursor === 'initial') {
                        x = rect.left + relativeX;
                        y = rect.top + relativeY;
                    }
                    var top = followCursor === 'horizontal' ? rect.top : y;
                    var right = followCursor === 'vertical' ? rect.right : x;
                    var bottom = followCursor === 'horizontal' ? rect.bottom : y;
                    var left = followCursor === 'vertical' ? rect.left : x;
                    return {
                        width: right - left,
                        height: bottom - top,
                        top: top,
                        right: right,
                        bottom: bottom,
                        left: left
                    };
                }
            });
        }
        function create() {
            if (instance.props.followCursor) {
                $c55de979aca75bc6$var$activeInstances.push({
                    instance: instance,
                    doc: doc
                });
                $c55de979aca75bc6$var$addMouseCoordsListener(doc);
            }
        }
        function destroy() {
            $c55de979aca75bc6$var$activeInstances = $c55de979aca75bc6$var$activeInstances.filter(function(data) {
                return data.instance !== instance;
            });
            if ($c55de979aca75bc6$var$activeInstances.filter(function(data) {
                return data.doc === doc;
            }).length === 0) $c55de979aca75bc6$var$removeMouseCoordsListener(doc);
        }
        return {
            onCreate: create,
            onDestroy: destroy,
            onBeforeUpdate: function onBeforeUpdate() {
                prevProps = instance.props;
            },
            onAfterUpdate: function onAfterUpdate(_, _ref2) {
                var followCursor = _ref2.followCursor;
                if (isInternalUpdate) return;
                if (followCursor !== undefined && prevProps.followCursor !== followCursor) {
                    destroy();
                    if (followCursor) {
                        create();
                        if (instance.state.isMounted && !wasFocusEvent && !getIsInitialBehavior()) addListener();
                    } else {
                        removeListener();
                        unsetGetReferenceClientRect();
                    }
                }
            },
            onMount: function onMount() {
                if (instance.props.followCursor && !wasFocusEvent) {
                    if (isUnmounted) {
                        onMouseMove($c55de979aca75bc6$var$mouseCoords);
                        isUnmounted = false;
                    }
                    if (!getIsInitialBehavior()) addListener();
                }
            },
            onTrigger: function onTrigger(_, event) {
                if ($c55de979aca75bc6$var$isMouseEvent(event)) $c55de979aca75bc6$var$mouseCoords = {
                    clientX: event.clientX,
                    clientY: event.clientY
                };
                wasFocusEvent = event.type === 'focus';
            },
            onHidden: function onHidden() {
                if (instance.props.followCursor) {
                    unsetGetReferenceClientRect();
                    removeListener();
                    isUnmounted = true;
                }
            }
        };
    }
};
function $c55de979aca75bc6$var$getProps(props, modifier) {
    var _props$popperOptions;
    return {
        popperOptions: Object.assign({}, props.popperOptions, {
            modifiers: [].concat((((_props$popperOptions = props.popperOptions) == null ? void 0 : _props$popperOptions.modifiers) || []).filter(function(_ref) {
                var name = _ref.name;
                return name !== modifier.name;
            }), [
                modifier
            ])
        })
    };
}
var $c55de979aca75bc6$export$e2b668424a9c728 = {
    name: 'inlinePositioning',
    defaultValue: false,
    fn: function fn(instance) {
        var reference = instance.reference;
        function isEnabled() {
            return !!instance.props.inlinePositioning;
        }
        var placement;
        var cursorRectIndex = -1;
        var isInternalUpdate = false;
        var triedPlacements = [];
        var modifier = {
            name: 'tippyInlinePositioning',
            enabled: true,
            phase: 'afterWrite',
            fn: function fn(_ref2) {
                var state = _ref2.state;
                if (isEnabled()) {
                    if (triedPlacements.indexOf(state.placement) !== -1) triedPlacements = [];
                    if (placement !== state.placement && triedPlacements.indexOf(state.placement) === -1) {
                        triedPlacements.push(state.placement);
                        instance.setProps({
                            // @ts-ignore - unneeded DOMRect properties
                            getReferenceClientRect: function getReferenceClientRect() {
                                return _getReferenceClientRect(state.placement);
                            }
                        });
                    }
                    placement = state.placement;
                }
            }
        };
        function _getReferenceClientRect(placement) {
            return $c55de979aca75bc6$var$getInlineBoundingClientRect($c55de979aca75bc6$var$getBasePlacement(placement), reference.getBoundingClientRect(), $c55de979aca75bc6$var$arrayFrom(reference.getClientRects()), cursorRectIndex);
        }
        function setInternalProps(partialProps) {
            isInternalUpdate = true;
            instance.setProps(partialProps);
            isInternalUpdate = false;
        }
        function addModifier() {
            if (!isInternalUpdate) setInternalProps($c55de979aca75bc6$var$getProps(instance.props, modifier));
        }
        return {
            onCreate: addModifier,
            onAfterUpdate: addModifier,
            onTrigger: function onTrigger(_, event) {
                if ($c55de979aca75bc6$var$isMouseEvent(event)) {
                    var rects = $c55de979aca75bc6$var$arrayFrom(instance.reference.getClientRects());
                    var cursorRect = rects.find(function(rect) {
                        return rect.left - 2 <= event.clientX && rect.right + 2 >= event.clientX && rect.top - 2 <= event.clientY && rect.bottom + 2 >= event.clientY;
                    });
                    var index = rects.indexOf(cursorRect);
                    cursorRectIndex = index > -1 ? index : cursorRectIndex;
                }
            },
            onHidden: function onHidden() {
                cursorRectIndex = -1;
            }
        };
    }
};
function $c55de979aca75bc6$var$getInlineBoundingClientRect(currentBasePlacement, boundingRect, clientRects, cursorRectIndex) {
    // Not an inline element, or placement is not yet known
    if (clientRects.length < 2 || currentBasePlacement === null) return boundingRect;
     // There are two rects and they are disjoined
    if (clientRects.length === 2 && cursorRectIndex >= 0 && clientRects[0].left > clientRects[1].right) return clientRects[cursorRectIndex] || boundingRect;
    switch(currentBasePlacement){
        case 'top':
        case 'bottom':
            var firstRect = clientRects[0];
            var lastRect = clientRects[clientRects.length - 1];
            var isTop = currentBasePlacement === 'top';
            var top = firstRect.top;
            var bottom = lastRect.bottom;
            var left = isTop ? firstRect.left : lastRect.left;
            var right = isTop ? firstRect.right : lastRect.right;
            var width = right - left;
            var height = bottom - top;
            return {
                top: top,
                bottom: bottom,
                left: left,
                right: right,
                width: width,
                height: height
            };
        case 'left':
        case 'right':
            var minLeft = Math.min.apply(Math, clientRects.map(function(rects) {
                return rects.left;
            }));
            var maxRight = Math.max.apply(Math, clientRects.map(function(rects) {
                return rects.right;
            }));
            var measureRects = clientRects.filter(function(rect) {
                return currentBasePlacement === 'left' ? rect.left === minLeft : rect.right === maxRight;
            });
            var _top = measureRects[0].top;
            var _bottom = measureRects[measureRects.length - 1].bottom;
            var _left = minLeft;
            var _right = maxRight;
            var _width = _right - _left;
            var _height = _bottom - _top;
            return {
                top: _top,
                bottom: _bottom,
                left: _left,
                right: _right,
                width: _width,
                height: _height
            };
        default:
            return boundingRect;
    }
}
var $c55de979aca75bc6$export$4bd4b47501432316 = {
    name: 'sticky',
    defaultValue: false,
    fn: function fn(instance) {
        var reference = instance.reference, popper = instance.popper;
        function getReference() {
            return instance.popperInstance ? instance.popperInstance.state.elements.reference : reference;
        }
        function shouldCheck(value) {
            return instance.props.sticky === true || instance.props.sticky === value;
        }
        var prevRefRect = null;
        var prevPopRect = null;
        function updatePosition() {
            var currentRefRect = shouldCheck('reference') ? getReference().getBoundingClientRect() : null;
            var currentPopRect = shouldCheck('popper') ? popper.getBoundingClientRect() : null;
            if (currentRefRect && $c55de979aca75bc6$var$areRectsDifferent(prevRefRect, currentRefRect) || currentPopRect && $c55de979aca75bc6$var$areRectsDifferent(prevPopRect, currentPopRect)) {
                if (instance.popperInstance) instance.popperInstance.update();
            }
            prevRefRect = currentRefRect;
            prevPopRect = currentPopRect;
            if (instance.state.isMounted) requestAnimationFrame(updatePosition);
        }
        return {
            onMount: function onMount() {
                if (instance.props.sticky) updatePosition();
            }
        };
    }
};
function $c55de979aca75bc6$var$areRectsDifferent(rectA, rectB) {
    if (rectA && rectB) return rectA.top !== rectB.top || rectA.right !== rectB.right || rectA.bottom !== rectB.bottom || rectA.left !== rectB.left;
    return true;
}
$c55de979aca75bc6$var$tippy.setDefaultProps({
    render: $c55de979aca75bc6$var$render
});
var $c55de979aca75bc6$export$2e2bcd8739ae039 = $c55de979aca75bc6$var$tippy;



class $b4b8cee06c4cfcc8$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super(), this.selectorTooltipContent = 'data-tk-tooltip-content', this.selectorTooltipOptions = 'data-tk-tooltip-options';
        this.tooltipContent = this.getAttribute(this.selectorTooltipContent) || undefined;
        this.customOptions = this.getAttribute(this.selectorTooltipOptions) || '{}';
        if (!this.tooltipContent) throw new Error('TK: Missing tooltip content');
    }
    connectedCallback() {
        this.initTooltip();
    }
    initTooltip() {
        this.customOptions = this.customOptions.replace(/'/g, '"');
        const tooltipOptions = {
            content: this.tooltipContent,
            ...this.defaultTooltipOptions(),
            ...JSON.parse(this.customOptions)
        };
        (0, $c55de979aca75bc6$export$2e2bcd8739ae039)(this, tooltipOptions);
    }
    defaultTooltipOptions() {
        return {
            arrow: false,
            theme: 'tk-tooltip',
            allowHTML: true,
            offset: [
                0,
                8
            ]
        };
    }
}





/**
 * data-tk-dialog-jump-forward
 * data-tk-dialog-jump-backward
 * data-tk-dialog-jump-to
 * data-tk-dialog-close
 * data-tk-dialog-close-and-reset
 * data-tk-close-on-backdrop-click
 */ var $2215c02a950e9fbf$var$DialogActions = /*#__PURE__*/ function(DialogActions) {
    DialogActions["JUMP_FORWARD"] = "jump_forward";
    DialogActions["JUMP_BACKWARD"] = "jump_backward";
    DialogActions["JUMP_TO"] = "jump_to";
    DialogActions["RESET_FORM"] = "reset_form";
    return DialogActions;
}($2215c02a950e9fbf$var$DialogActions || {});
class $2215c02a950e9fbf$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super(), this.dialogs = [], this.currentDialog = 0, this.shouldOpen = false, this.closeOnBackdropClick = true;
        this.tag = this.getAttribute('data-tk-tag') || 'dialog';
        this.url = this.getAttribute('data-tk-url') || undefined;
        this.button = this.querySelector('button') || undefined;
        this.shouldOpen = this.hasAttribute('data-tk-open');
        this.closeOnBackdropClick = this.hasAttribute('data-tk-close-on-backdrop-click') ? JSON.parse(this.getAttribute('data-tk-close-on-backdrop-click')) : true;
        this.shouldMaxWidth = this.hasAttribute('data-tk-should-max-width');
        this.dialogClassName = this.getAttribute('data-tk-dialog-class-name') || 'tk-dialog';
        this.dialogInnerClassName = this.getAttribute('data-tk-dialog-inner-class-name') || 'tk-dialog__inner';
        this.dialogCloseClassName = this.getAttribute('data-tk-dialog-close-class-name') || 'tk-button tk-button--tertiary tk-button--only-icon tk-dialog__close';
        this.maxWidthClassName = this.getAttribute('data-tk-max-width-class-name') || 'tk-dialog--max-width';
        this.formDataString = this.getAttribute('data-tk-form-data') || undefined;
        this.isPopup = this.hasAttribute('data-tk-is-popup');
        this.isConfirm = this.hasAttribute('data-tk-is-confirm');
        this.confirmTitle = this.getAttribute('data-tk-confirm-title') || undefined;
        this.confirmDescription = this.getAttribute('data-tk-confirm-description') || undefined;
        this.confirmCancelIcon = this.getAttribute('data-tk-confirm-cancel-icon') || 'cross';
        this.confirmCancelLabel = this.getAttribute('data-tk-confirm-cancel-label') || undefined;
        this.confirmSubmitIcon = this.getAttribute('data-tk-confirm-submit-icon') || 'check';
        this.confirmSubmitLabel = this.getAttribute('data-tk-confirm-submit-label') || undefined;
        this.forceReloadContent = this.hasAttribute('data-tk-force-reload-content');
    }
    connectedCallback() {
        if (!this.url) throw new Error('Dialog: URL is missing!');
        this.registerClickListener();
        this.checkAutoOpen();
    }
    registerClickListener() {
        if (!this.button) return;
        const onClick = this.openDialog.bind(this, this.url);
        this.pushListener({
            event: 'click',
            element: this.button,
            action: onClick
        });
    }
    registerFormListener(form) {
        const onSubmit = this.handleForm.bind(this, form);
        this.pushListener({
            event: 'submit',
            element: form,
            action: onSubmit
        });
    }
    registerCloseListener() {
        const onClick = this.closeDialog.bind(this);
        this.pushListener({
            event: 'click',
            element: window,
            action: onClick
        });
    }
    createDialog(url) {
        const dialog = $2215c02a950e9fbf$export$2e2bcd8739ae039.renderDialog({
            className: `${this.dialogClassName} ${this.shouldMaxWidth ? this.maxWidthClassName : ''}`,
            closeClassName: this.dialogCloseClassName,
            innerClassName: this.dialogInnerClassName,
            tag: this.tag,
            isConfirm: this.isConfirm,
            confirmURL: url,
            confirmTitle: this.confirmTitle,
            confirmDescription: this.confirmDescription,
            confirmCancelIcon: this.confirmCancelIcon,
            confirmCancelLabel: this.confirmCancelLabel,
            confirmSubmitIcon: this.confirmSubmitIcon,
            confirmSubmitLabel: this.confirmSubmitLabel
        });
        const onClosed = this.closedDialog.bind(this);
        this.pushListener({
            event: 'close',
            element: dialog,
            action: onClosed
        });
        this.currentDialog = this.dialogs.push({
            url: url,
            dialog: dialog
        }) - 1;
        return dialog;
    }
    getContent(url) {
        if (this.isConfirm) {
            this.closeCurrentDialog();
            const dialog = this.createDialog(url);
            $2215c02a950e9fbf$export$2e2bcd8739ae039.open(dialog, this.isPopup);
            this.hookAfterShowModal(dialog);
        } else (0, $1653b55d89a7adce$export$24835cb787452b46)({
            requestURL: url,
            resolveHandler: this.handleResponseSuccess.bind(this, url)
        });
    }
    getContentWithData(url, payload) {
        (0, $1653b55d89a7adce$export$24835cb787452b46)({
            requestURL: url,
            resolveHandler: this.handleResponseSuccess.bind(this, url),
            payload: payload
        });
    }
    handleResponseSuccess(url, response) {
        if (!response || !response.success) return;
        this.closeCurrentDialog();
        const dialog = this.createDialog(url);
        const content = dialog.querySelector('[data-tk-dialog-content]');
        if (!content) return;
        content.innerHTML = response.dataAsHtml;
        $2215c02a950e9fbf$export$2e2bcd8739ae039.open(dialog, this.isPopup);
        this.hookAfterShowModal(dialog);
        const form = content.querySelector('form');
        form && this.registerFormListener(form);
    }
    openDialog(url) {
        this.handleUrlAndDialogs(url);
        // This method would be used to execute code in a non-blocking way to prevent potential delays.
        setTimeout(()=>{
            this.registerCloseListener();
        });
    }
    closeDialog(event) {
        const dialogItem = this.dialogs.at(this.currentDialog);
        // Used to check if the event isn't triggered by the enter key
        const isRealClickEvent = event.pointerId !== -1;
        if (!dialogItem || !isRealClickEvent) return;
        const { dialog: dialog } = dialogItem;
        if (this.closeOnBackdropClick) $2215c02a950e9fbf$export$2e2bcd8739ae039.closeDialogIfOutside(dialog, event);
    }
    hookAfterShowModal(dialog) {
        $2215c02a950e9fbf$export$2e2bcd8739ae039.attachButtonClickHandler(dialog, '[data-tk-dialog-close]', ()=>$2215c02a950e9fbf$export$2e2bcd8739ae039.close(dialog));
        $2215c02a950e9fbf$export$2e2bcd8739ae039.attachButtonClickHandler(dialog, '[data-tk-dialog-close-and-reset]', (button)=>this.handleActions("reset_form", button));
        $2215c02a950e9fbf$export$2e2bcd8739ae039.attachButtonClickHandler(dialog, '[data-tk-dialog-jump-forward]', (button)=>this.handleActions("jump_forward", button));
        $2215c02a950e9fbf$export$2e2bcd8739ae039.attachButtonClickHandler(dialog, '[data-tk-dialog-jump-backward]', (button)=>this.handleActions("jump_backward", button));
        $2215c02a950e9fbf$export$2e2bcd8739ae039.attachButtonClickHandler(dialog, '[data-tk-dialog-jump-to]', (button)=>this.handleActions("jump_to", button));
    }
    static attachButtonClickHandler(dialog, selector, callback) {
        const buttons = dialog.querySelectorAll(selector);
        buttons.forEach((button)=>{
            button.addEventListener('click', ()=>callback(button));
        });
    }
    handleActions(action, button) {
        const handler = {
            jump_forward: ()=>this.forward(button),
            jump_backward: ()=>this.backward(),
            jump_to: ()=>this.jumpTo(button),
            reset_form: ()=>this.resetForm(button)
        };
        handler[action]();
    }
    closeCurrentDialog() {
        const dialogItem = this.dialogs.at(this.currentDialog);
        if (!dialogItem) return;
        $2215c02a950e9fbf$export$2e2bcd8739ae039.close(dialogItem.dialog);
    }
    handleUrlAndDialogs(url) {
        const existsURL = this.dialogs.some((dialogItem)=>dialogItem.url === url);
        if (existsURL) {
            const nextDialog = this.getDialogByURL(url);
            if (!nextDialog) return;
            const waitForContent = this.forceReloadContent;
            if (this.forceReloadContent) this.renewDialogContent(nextDialog, url);
            if (waitForContent) return;
            $2215c02a950e9fbf$export$2e2bcd8739ae039.open(nextDialog);
        } else try {
            const payload = JSON.parse(this.formDataString || '{}');
            Object.keys(payload).length > 0 ? this.getContentWithData(url, payload) : this.getContent(url);
        } catch (error) {
            throw new Error(`Dialog: ${error}`);
        }
    }
    forward(button) {
        // Check if already exists
        const url = button.getAttribute('data-tk-url');
        if (!url) throw new Error('Dialog: URL is missing!');
        this.closeCurrentDialog();
        this.handleUrlAndDialogs(url);
        this.currentDialog += 1;
    }
    backward() {
        const nextDialogItem = this.dialogs.at(this.currentDialog - 1);
        if (!nextDialogItem) return;
        this.closeCurrentDialog();
        $2215c02a950e9fbf$export$2e2bcd8739ae039.open(nextDialogItem.dialog);
        this.currentDialog -= 1;
    }
    jumpTo(button) {
        const index = Number(button.getAttribute('data-tk-dialog-jump-to'));
        const nextDialogItem = this.dialogs.at(index);
        if (!nextDialogItem) return;
        this.closeCurrentDialog();
        $2215c02a950e9fbf$export$2e2bcd8739ae039.open(nextDialogItem.dialog);
        this.currentDialog = index;
    }
    resetForm(button) {
        button.form?.reset();
        this.closeCurrentDialog();
    }
    handleForm(form, event) {
        const shouldSwitchToNext = form.hasAttribute('data-tk-switch-to-next');
        if (!shouldSwitchToNext) return;
        event.preventDefault();
        const formData = new FormData(form);
        const url = form.action;
        (0, $1653b55d89a7adce$export$24835cb787452b46)({
            requestURL: url,
            resolveHandler: this.handleResponseSuccess.bind(this, url),
            payload: formData
        });
    }
    getDialogByURL(url) {
        const dialogItem = this.dialogs.find((item)=>item.url === url);
        return dialogItem?.dialog;
    }
    closedDialog() {
        const allDialogClosed = this.dialogs.every((item)=>!item.dialog.open);
        if (!allDialogClosed) return;
        this.currentDialog = 0;
        this.removeListener(window);
    }
    static renderDialog(options) {
        const { tag: tag, className: className = 'tk-dialog', closeClassName: closeClassName = 'tk-button tk-button--tertiary tk-button--only-icon tk-dialog__close', innerClassName: innerClassName = 'tk-dialog__inner', content: content, isConfirm: isConfirm = false, confirmURL: confirmURL, confirmTitle: confirmTitle, confirmDescription: confirmDescription, confirmCancelIcon: confirmCancelIcon, confirmCancelLabel: confirmCancelLabel, confirmSubmitIcon: confirmSubmitIcon, confirmSubmitLabel: confirmSubmitLabel } = options;
        const dialog = (0, $2d540709c75492d4$export$2e2bcd8739ae039)(`
            ${isConfirm ? `
                    <${tag} class="${className}">
                        <button
                            type="button"
                            class="${closeClassName}"
                            data-tk-dialog-close
                        ></button>
                        <div class="${innerClassName}" data-tk-dialog-content>
                            <form action="${confirmURL}" method="post">
                                <h3>${confirmTitle}</h3>
                                <p>${confirmDescription}</p>
                                <div class="flex flex--gap-x-2 flex--justify-end spacer-mt-9">
                                    <button type="button" class="tk-button tk-button--secondary" data-tk-dialog-close>
                                        <span class="tk-button__icon">
                                            <i class="tk-icon-${confirmCancelIcon}"></i>
                                        </span>
                                        <span class="tk-button__label">${confirmCancelLabel}</span>
                                    </button>
                                    <button type="submit" class="tk-button tk-button--primary">
                                        <span class="tk-button__icon">
                                            <i class="tk-icon-${confirmSubmitIcon}"></i>
                                        </span>
                                        <span class="tk-button__label">${confirmSubmitLabel}</span>
                                    </button>
                                </div>
                            </form>
                        </div>
                    </${tag}>
                ` : `
                    <${tag} class="${className}">
                        <button
                            type="button"
                            class="${closeClassName}"
                            data-tk-dialog-close
                        ></button>
                        <div class="${innerClassName}" data-tk-dialog-content>
                            ${content}
                        </div>
                    </${tag}>
                `}
        `);
        document.body.insertAdjacentElement('beforeend', dialog);
        $2215c02a950e9fbf$export$2e2bcd8739ae039.attachButtonClickHandler(dialog, '[data-tk-dialog-close]', ()=>$2215c02a950e9fbf$export$2e2bcd8739ae039.close(dialog));
        return dialog;
    }
    static open(element, isPopup = false) {
        if (element instanceof HTMLDialogElement) isPopup ? element.show() : element.showModal();
        else element.classList.add('tk-dialog--open');
    }
    static close(element) {
        if (element instanceof HTMLDialogElement) element.close();
        else {
            element.classList.remove('tk-dialog--open');
            element.dispatchEvent(new Event('close'));
        }
    }
    static closeDialogIfOutside(element, event) {
        /**
         * Checking the coordinates of the client for the value 0 and the
         * HTMLSelectElement or HTMLOptionElement element ensures that the
         * dialogue does not close in Mozilla. This is a bug in Firefox
         * that has not yet been fixed.
         */ if (event.clientX === 0 && event.clientY === 0 && (event.target instanceof HTMLSelectElement || event.target instanceof HTMLOptionElement)) return;
        const dialogDimensions = element.getBoundingClientRect();
        if (event.clientX < dialogDimensions.left || event.clientX > dialogDimensions.right || event.clientY < dialogDimensions.top || event.clientY > dialogDimensions.bottom) $2215c02a950e9fbf$export$2e2bcd8739ae039.close(element);
    }
    checkAutoOpen() {
        if (!this.shouldOpen) return;
        this.openDialog(this.url);
    }
    renewDialogContent(dialog, url) {
        (0, $1653b55d89a7adce$export$24835cb787452b46)({
            requestURL: url,
            resolveHandler: this.getRenewDialogContent.bind(this, dialog)
        });
    }
    getRenewDialogContent(openDialog, response) {
        const dialogInner = openDialog.querySelector('[data-tk-dialog-content]');
        dialogInner.innerHTML = response.dataAsHtml;
        openDialog.showModal();
        this.hookAfterShowModal(openDialog);
    }
}




const $fbcf93c2a0aa5bcb$var$isBase64 = (value)=>{
    try {
        return btoa(atob(value)) === value;
    } catch  {
        return false;
    }
};
var $fbcf93c2a0aa5bcb$export$2e2bcd8739ae039 = $fbcf93c2a0aa5bcb$var$isBase64;


class $1ccb7c18f671f1de$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super(), this.hasStartedSync = false;
        this.isAsyncTile = Boolean(this.closest('[data-tk-product-tile][data-tk-url]'));
        this.articleList = this.closest('[data-tk-article-list]') || undefined;
        this.asyncURL = this.getAttribute('data-tk-async-url') || (0, $1653b55d89a7adce$export$a4101276b4831ec4)(true);
        this.source = this.getAttribute('data-tk-source') || '';
        this.service = this.getAttribute('data-tk-service') || '';
        this.catItemId = this.getAttribute('data-tk-cat-item-id') || '';
        this.articleId = this.getAttribute('data-tk-article-id') || '';
        this.loadingType = this.getAttribute('data-tk-loading-type') || '';
        this.sort = this.getAttribute('data-tk-sort') || '';
        this.key = this.getAttribute('data-tk-key') || '';
        this.asyncTemplate = this.getAttribute('data-tk-async-template') || '';
        this.isServiceClassName = this.getAttribute('data-tk-is-service-class-name') || 'tk-price--has-service';
        this.isPromotionClassName = this.getAttribute('data-tk-is-promotion-class-name') || 'tk-price--has-promotion';
    }
    connectedCallback() {
        this.item = {
            source: this.source,
            service: this.service,
            catItemId: this.catItemId,
            articleId: this.articleId,
            loadingType: this.loadingType,
            sort: this.sort,
            key: this.key,
            asyncTemplate: this.asyncTemplate,
            element: this
        };
        if (this.articleList && this.loadingType !== '2' && !this.isAsyncTile) this.sendDataToArticleList();
        else this.loadingType === '2' ? this.registerHoverListener() : this.handlePrice();
    }
    registerHoverListener() {
        const onHover = this.handlePrice.bind(this);
        this.pushListener({
            event: 'mouseover',
            element: this,
            action: onHover
        });
    }
    hover() {
        this.hasStartedSync = true;
        this.handlePrice();
    }
    sendDataToArticleList() {
        this.item && this.articleList.addPrice(this.item);
    }
    handlePrice() {
        if (!this.item) return;
        const items = this.asyncURL === (0, $1653b55d89a7adce$export$a4101276b4831ec4)(true) ? $1ccb7c18f671f1de$export$2e2bcd8739ae039.getItemsAsJSONString([
            this.item
        ]) : $1ccb7c18f671f1de$export$2e2bcd8739ae039.getItemsAsEntrypoint([
            this.item
        ]);
        const data = {
            type: 'price',
            ...items
        };
        (0, $1653b55d89a7adce$export$24835cb787452b46)({
            requestURL: this.asyncURL,
            resolveHandler: this.handleResponse.bind(this),
            payload: data
        });
    }
    static getItemsAsEntrypoint(data) {
        const articles = [];
        data.forEach((item)=>{
            articles.push(item.articleId);
        });
        return {
            articles: articles.join(',')
        };
    }
    static getItemsAsJSONString(data) {
        const items = [];
        data.forEach((item)=>{
            items.push({
                source: item.source,
                service: item.service,
                catitemboid: item.catItemId,
                catitemartinternalno: item.articleId,
                loadingtype: item.loadingType,
                sort: item.sort,
                key: item.key,
                template: item.asyncTemplate
            });
        });
        return {
            catitems: JSON.stringify({
                items: items
            })
        };
    }
    handleResponse(response) {
        if (!response || !response.success) return;
        if (response.dataAsJson.items?.length !== 1) return;
        const list = response.dataAsJson.items;
        const responseItem = list[0];
        const item = {
            source: this.source,
            service: this.service,
            catItemId: this.catItemId,
            articleId: this.articleId,
            loadingType: this.loadingType,
            sort: this.sort,
            key: this.key,
            asyncTemplate: this.asyncTemplate,
            element: undefined
        };
        this.refreshPrice(item, responseItem);
    }
    handleError(error) {
        this.hasStartedSync = false;
        throw new Error(error);
    }
    refreshPrice(item, responseItem) {
        const conditions = [
            {
                condition: responseItem.basispriceisset,
                selector: '[data-tk-price-basic]',
                className: undefined
            },
            {
                condition: responseItem.servicepriceisset,
                selector: '[data-tk-price-service]',
                className: this.isServiceClassName
            },
            {
                condition: responseItem.promopriceisset,
                selector: '[data-tk-price-promotion]',
                className: this.isPromotionClassName
            }
        ];
        const { selector: selector, className: className } = conditions.find(({ condition: condition })=>condition) || {};
        if (!selector) return;
        const element = this.querySelector(selector);
        const { html: html } = responseItem;
        if (!html) return;
        const htmlString = (0, $fbcf93c2a0aa5bcb$export$2e2bcd8739ae039)(html) ? atob(html) : html;
        if (element) element.innerHTML = htmlString;
        else this.innerHTML = htmlString;
        className && this.classList.add(className);
    }
}





class $ad2181492f474118$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.isAsyncTile = Boolean(this.closest('[data-tk-product-tile][data-tk-url]'));
        this.articleList = this.closest('[data-tk-article-list]') || undefined;
        this.asyncURL = this.getAttribute('data-tk-async-url') || (0, $1653b55d89a7adce$export$a4101276b4831ec4)(true);
        this.source = this.getAttribute('data-tk-source') || '';
        this.catItemId = this.getAttribute('data-tk-cat-item-id') || '';
        this.articleId = this.getAttribute('data-tk-article-id') || '';
        this.stockType = this.getAttribute('data-tk-stock-type') || '';
        this.stockLocation = this.getAttribute('data-tk-stock-location') || '';
        this.dispo = this.getAttribute('data-tk-dispo') || '';
        this.dispoDate = this.getAttribute('data-tk-dispo-date') || '';
        this.loadingType = this.getAttribute('data-tk-loading-type') || '';
        this.asyncTemplate = this.getAttribute('data-tk-async-template') || '';
        this.stockPeriodType = this.getAttribute('data-tk-stock-period-type') || '1';
        this.artUnitType = this.getAttribute('data-tk-art-unit-type') || '3';
    }
    connectedCallback() {
        const item = {
            source: this.source,
            catItemId: this.catItemId,
            articleId: this.articleId,
            stockType: this.stockType,
            stockLocation: this.stockLocation,
            dispo: this.dispo,
            dispoDate: this.dispoDate,
            loadingType: this.loadingType,
            asyncTemplate: this.asyncTemplate,
            stockPeriodType: this.stockPeriodType,
            artUnitType: this.artUnitType,
            element: this
        };
        if (this.articleList && !this.isAsyncTile) this.sendDataToArticleList(item);
        else this.handleStock(item);
    }
    sendDataToArticleList(item) {
        this.articleList.addStock(item);
    }
    handleStock(item) {
        const items = this.asyncURL === (0, $1653b55d89a7adce$export$a4101276b4831ec4)(true) ? $ad2181492f474118$export$2e2bcd8739ae039.getItemsAsJSONString([
            item
        ]) : $ad2181492f474118$export$2e2bcd8739ae039.getItemsAsEntrypoint([
            item
        ]);
        const data = {
            type: 'stock',
            ...items
        };
        (0, $1653b55d89a7adce$export$24835cb787452b46)({
            requestURL: this.asyncURL,
            payload: data,
            resolveHandler: this.handleResponse.bind(this)
        });
    }
    static getItemsAsEntrypoint(data) {
        const items = [];
        const articles = [];
        data.forEach((item)=>{
            items.push([
                item.articleId,
                item.stockType,
                item.stockLocation,
                item.stockPeriodType,
                item.dispoDate,
                item.artUnitType
            ].join(','));
            articles.push(item.articleId);
        });
        return {
            items: items.join(','),
            articles: articles.join(',')
        };
    }
    static getItemsAsJSONString(data) {
        const items = [];
        data.forEach((item)=>{
            items.push({
                source: item.source,
                catitemboid: item.catItemId,
                catitemartinternalno: item.articleId,
                stocktype: item.stockType,
                stockloc: item.stockLocation,
                dispo: item.dispo,
                dispodate: item.dispoDate,
                loadingtype: item.loadingType,
                template: item.asyncTemplate
            });
        });
        return {
            catitems: JSON.stringify({
                items: items
            })
        };
    }
    handleResponse(response) {
        if (!response || !response.success) return;
        if (response.dataAsJson.items?.length !== 1) return;
        const list = response.dataAsJson.items;
        const responseItem = list[0];
        const item = {
            source: this.source,
            catItemId: this.catItemId,
            articleId: this.articleId,
            stockType: this.stockType,
            stockLocation: this.stockLocation,
            dispo: this.dispo,
            dispoDate: this.dispoDate,
            loadingType: this.loadingType,
            asyncTemplate: this.asyncTemplate,
            element: undefined
        };
        this.refreshStock(item, responseItem);
    }
    refreshStock(item, responseItem) {
        const { html: html } = responseItem;
        if (!html) return;
        const htmlString = (0, $fbcf93c2a0aa5bcb$export$2e2bcd8739ae039)(html) ? atob(html) : html;
        const tooltip = this.querySelector('tk-tooltip');
        tooltip && tooltip.remove();
        this.insertAdjacentHTML('beforeend', htmlString);
    }
}






class $edcef81612fbf4b7$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.button = this.querySelector('[data-tk-static-content-edit]') || undefined;
        this.target = this.getAttribute('data-tk-target') || '#tk-static-content-editor';
        this.boId = this.getAttribute('data-tk-bo-id') || undefined;
        this.boNumber = this.getAttribute('data-tk-bo-number') || undefined;
        this.artTextNumber = this.getAttribute('data-tk-art-text-number') || undefined;
        this.bo = this.getAttribute('data-tk-bo') || undefined;
        this.attr = this.getAttribute('data-tk-attr') || undefined;
        this.itemId = this.getAttribute('data-tk-id') || undefined;
        this.langNumber = this.getAttribute('data-tk-lang-number') || undefined;
        this.dataPer = this.getAttribute('data-tk-data-per') || undefined;
        this.asyncTemplate = this.getAttribute('data-tk-async-template') || undefined;
        this.urlTemplate = [];
        this.templateContentPromiseArray = [];
        this.templatesLoaded = false;
        this.fileUploadIFrameURL = this.getAttribute('data-tk-file-upload-iframe-url') || '';
    }
    async connectedCallback() {
        if (!this.button || !this.boId || !this.dataPer || !this.asyncTemplate) return;
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        await (parcelRequire("cnCS2"));
        this.registerClickListener();
    }
    registerClickListener() {
        const onClick = this.sendAjaxRequest.bind(this);
        this.pushListener({
            event: 'click',
            element: this.button,
            action: onClick
        });
    }
    registerModalListener(modal) {
        const saveButton = modal.querySelector('[data-tk-static-content-save]') || undefined;
        const onSave = this.save.bind(this, saveButton);
        saveButton && this.pushListener({
            event: 'click',
            element: saveButton,
            action: onSave
        });
        const cancelButton = modal.querySelector('[data-tk-static-content-cancel]');
        const onCancel = this.cancel.bind(this);
        cancelButton && this.pushListener({
            event: 'click',
            element: cancelButton,
            action: onCancel
        });
    }
    sendAjaxRequest() {
        this.requestData = {
            type: 'staticcontent',
            boid: this.boId,
            bonumber: this.boNumber,
            arttextno: this.artTextNumber,
            per: this.dataPer,
            template: this.asyncTemplate,
            modalid: this.target,
            bo: this.bo,
            id: this.itemId,
            attr: this.attr
        };
        const url = (0, $1653b55d89a7adce$export$a4101276b4831ec4)(true);
        (0, $1653b55d89a7adce$export$24835cb787452b46)({
            requestURL: url,
            resolveHandler: this.showContentInEditMode.bind(this),
            payload: this.requestData
        });
    }
    save(button) {
        if (!button) return;
        const htmlEncoded = $edcef81612fbf4b7$export$2e2bcd8739ae039.htmlEncode($edcef81612fbf4b7$export$2e2bcd8739ae039.getContentFromEditMode());
        this.requestData = {
            type: 'staticcontent',
            boid: this.boId,
            bonumber: this.boNumber,
            arttextno: this.artTextNumber,
            bo: this.bo,
            id: this.itemId,
            attr: this.attr,
            html: htmlEncoded
        };
        const url = (0, $1653b55d89a7adce$export$a4101276b4831ec4)();
        (0, $1653b55d89a7adce$export$24835cb787452b46)({
            requestURL: url,
            resolveHandler: this.refreshContent.bind(this),
            payload: this.requestData
        });
        this.cancel();
    }
    cancel() {
        (0, $2215c02a950e9fbf$export$2e2bcd8739ae039).close(this.dialog);
    }
    showContentInEditMode(response) {
        if (!response.success || !this.requestData) return;
        this.dialog = (0, $2215c02a950e9fbf$export$2e2bcd8739ae039).renderDialog({
            content: response.dataAsHtml,
            className: 'tk-dialog tk-dialog--fullscreen',
            tag: 'div'
        });
        (0, $2215c02a950e9fbf$export$2e2bcd8739ae039).open(this.dialog);
        this.pushListener({
            event: 'close',
            element: this.dialog,
            action: ()=>this.dialog?.remove()
        });
        this.initEditor();
        const modal = document.querySelector(this.target);
        if (!modal) return;
        this.registerModalListener(modal);
    }
    static getContentFromEditMode() {
        return window.tinymce.activeEditor?.getContent({
            format: 'raw'
        }) || '';
    }
    refreshContent(response) {
        if (!response.success || !this.requestData) return;
        let contentContainer = document.getElementById(`staticcontent-${this.requestData.boid}-${this.requestData.arttextno}`);
        if (!contentContainer) this.requestData.id !== undefined && (contentContainer = document.getElementById(this.requestData.id));
        else contentContainer.innerHTML = response.dataAsHtml;
    }
    initEditor() {
        if (!this.requestData) return;
        const selector = `${this.requestData.modalid} [data-tk-static-content-textarea]`;
        // Editor must be removed before initialisation
        window.tinymce.remove(selector);
        const options = {
            selector: selector,
            language: $edcef81612fbf4b7$export$2e2bcd8739ae039.getLanguage(),
            plugins: [
                'advlist',
                'autolink',
                'lists',
                'link',
                'image',
                'charmap',
                'preview',
                'anchor',
                'pagebreak',
                'searchreplace',
                'wordcount',
                'visualblocks',
                'visualchars',
                'code',
                'fullscreen',
                'insertdatetime',
                'media',
                'nonbreaking',
                'save',
                'table',
                'directionality',
                'emoticons',
                'template',
                'quickbars'
            ],
            insertdatetime_formats: [
                '%d.%m.%Y',
                '%H:%M'
            ],
            contextmenu: 'link image table',
            tools: 'inserttable',
            toolbar: "undo redo | styleselect | bold italic | forecolor backcolor | alignleft aligncenteralignright alignjustify | bullist numlist outdent indent | image media link | preview print | filemanager",
            width: '100%',
            base_url: '/webportal/config/layout/themes/tk/vendor/tinymce/',
            language_url: `/webportal/config/layout/themes/tk/translations/tinymce/${$edcef81612fbf4b7$export$2e2bcd8739ae039.getLanguage()}.js`,
            promotion: false,
            content_css: [
                'default',
                `/webportal/config/layout/themes/project/generated/css/staticcontent.css?${new Date().getTime()}`
            ],
            templates: this.urlTemplate,
            extended_valid_elements: 'tk-tabs-accordion,tk-tabs-accordion[class],i[data-tk-accordion-icon]',
            custom_elements: 'tk-tabs-accordion,tk-tabs-accordion',
            setup: (editor)=>{
                editor.on('SaveContent', (event)=>{
                    event.content = $edcef81612fbf4b7$export$2e2bcd8739ae039.htmlEncode($edcef81612fbf4b7$export$2e2bcd8739ae039.htmlDecode(event.content));
                });
                const openmanager = ()=>{
                    editor.windowManager.openUrl({
                        title: 'File Manager',
                        url: $edcef81612fbf4b7$export$2e2bcd8739ae039.getFileManagerURL(editor),
                        width: 900,
                        height: 440
                    });
                };
                editor.ui.registry.addButton('filemanager', {
                    icon: 'browse',
                    tooltip: 'Insert file',
                    onAction: openmanager
                });
                editor.ui.registry.addMenuItem('filemanager', {
                    icon: 'browse',
                    text: 'Insert file',
                    onAction: openmanager
                });
                const templateURLElement = document.querySelector('[data-tk-staticcontent-templates-url]');
                const templateURL = templateURLElement && templateURLElement.getAttribute('data-op-url');
                if (templateURL) this.getTemplates(templateURL);
            }
        };
        if (this.fileUploadIFrameURL) options.file_picker_callback = this.handleFilePicker.bind(this);
        window.tinymce.init(options);
    }
    handleFilePicker(callback) {
        window.tinymce.activeEditor?.windowManager.openUrl({
            title: 'Fileupload Area',
            url: this.fileUploadIFrameURL,
            width: 800,
            height: 600
        });
        window.addEventListener('message', (event)=>{
            const { data: data } = event;
            if (window.location.origin !== event.origin) return;
            callback(data.content);
        });
    }
    static getFileManagerURL(editor) {
        return `/webportal/filemanager.aspx?editor=${editor.id}&lang=${$edcef81612fbf4b7$export$2e2bcd8739ae039.getLanguage()}`;
    }
    static htmlEncode(content) {
        return content.toString().replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    }
    static htmlDecode(content) {
        return content.toString().replace(/&gt;/g, '>').replace(/&lt;/g, '<').replace(/&quot;/g, '"').replace(/&amp;/g, '&');
    }
    static getLanguage() {
        if (window.location.href.indexOf('/en/') !== -1) return 'en_GB';
        if (window.location.href.indexOf('/fr/') !== -1) return 'fr_FR';
        if (window.location.href.indexOf('/it/') !== -1) return 'it';
        return 'de';
    }
    async getTemplates(templateURL) {
        if (this.templatesLoaded) return;
        // get url content
        return new Promise((resolve)=>{
            (0, $1653b55d89a7adce$export$24835cb787452b46)({
                requestURL: templateURL,
                resolveHandler: (response)=>{
                    this.getTemplateContent(response, resolve);
                }
            });
        });
    }
    getTemplateContent(response, resolveFunction) {
        response.dataAsJson.forEach((element)=>{
            this.templateContentPromiseArray = [];
            this.templateContentPromiseArray.push(new Promise((resolve)=>{
                (0, $1653b55d89a7adce$export$24835cb787452b46)({
                    requestURL: element.url,
                    resolveHandler: (response)=>{
                        this.saveTemplateContent(response, element, resolveFunction, resolve);
                    }
                });
            }));
        });
    }
    saveTemplateContent(response, element, resolvedAllFunction, resolveArrayElementFunction) {
        const templateContent = response.dataAsHtml;
        const newTemplateEntry = {
            title: element.title,
            description: element.description,
            content: templateContent
        };
        this.urlTemplate.push(newTemplateEntry);
        resolveArrayElementFunction();
        Promise.allSettled(this.templateContentPromiseArray).then(()=>{
            resolvedAllFunction();
            this.templatesLoaded = true;
        });
    }
}



class $237e800aa488702c$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super(), this.selectorTabsHead = '[data-tk-tab-head]', this.selectorTabsBody = '[data-tk-tab-body]';
        const tabHead = this.querySelector(this.selectorTabsHead);
        const tabBody = this.querySelector(this.selectorTabsBody);
        this.activeClassName = this.getAttribute('data-tk-active-class-name') || 'tk-tabs-tab--active';
        this.initialTabIndex = Number(this.getAttribute('data-tk-initial-tab')) || 1;
        this.enableLinks = this.hasAttribute('data-tk-enable-links');
        if (!tabHead) throw new Error('TK: Missing Tab-Header');
        if (!tabBody) throw new Error('TK: Missing Tab-Body');
        this.tabList = tabHead.childElementCount > 0 ? tabHead.children : undefined;
        this.tabContentList = tabBody.childElementCount > 0 ? tabBody.children : undefined;
        if (!this.tabList) throw new Error('TK: Empty Tab-Header');
        if (!this.tabContentList) throw new Error('TK: Empty Tab-Content');
        if (this.tabList.length !== this.tabContentList.length && !this.enableLinks) throw new Error('TK: Tab-Header Elements and Tab-Content Elements must be equal');
    }
    connectedCallback() {
        this.registerListener();
        if (this.tabList && +this.initialTabIndex > 0) {
            const button = this.tabList.item(this.initialTabIndex - 1);
            this.setTabActive(button, this.initialTabIndex - 1);
        }
    }
    registerListener() {
        if (this.tabList) [
            ...this.tabList
        ].forEach((element, index)=>{
            const button = element;
            const eventHandler = this.setTabActive.bind(this, button, index);
            this.pushListener({
                event: 'click',
                element: button,
                action: eventHandler
            });
        });
    }
    setTabActive(button, index) {
        const input = button.querySelector('input');
        if (input && input.disabled || button.disabled) return;
        const item = this.tabContentList?.item(index);
        if (!item) {
            const url = button.getAttribute('data-tk-url');
            const target = button.getAttribute('target') || undefined;
            if (!url) return;
            window.open(url, target);
        } else {
            this.setTabInactive();
            button.classList.add(this.activeClassName);
            item.classList.add(this.activeClassName);
        }
        this.toggleRequiredAttribute(index);
    }
    setTabInactive() {
        if (!this.tabContentList) return;
        [
            ...this.tabContentList
        ].forEach((element, index)=>{
            const button = element;
            button.classList.remove(this.activeClassName);
            const item = this.tabList?.item(index);
            if (!item) return;
            item.classList.remove(this.activeClassName);
        });
    }
    toggleRequiredAttribute(index) {
        if (!this.tabContentList) return;
        const currentElement = this.tabContentList.item(index);
        const contentList = Array.from(this.tabContentList);
        const filteredList = contentList.filter((element)=>element !== currentElement);
        filteredList.forEach((element)=>{
            const fieldElements = element.querySelectorAll('input[required]');
            fieldElements.forEach((fieldElement)=>{
                fieldElement.required = false;
                fieldElement.setAttribute('data-tk-is-required', '');
            });
        });
        const fieldElements = currentElement?.querySelectorAll('input[data-tk-is-required]');
        fieldElements?.forEach((fieldElement)=>{
            fieldElement.required = true;
            fieldElement.removeAttribute('data-tk-is-required');
        });
    }
}






var $6406837936bc2cfc$var$ArticleDataType = /*#__PURE__*/ function(ArticleDataType) {
    ArticleDataType["PRICE"] = "price";
    ArticleDataType["STOCK"] = "stock";
    return ArticleDataType;
}($6406837936bc2cfc$var$ArticleDataType || {});
class $6406837936bc2cfc$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super(), this.prices = [], this.stocks = [], this.isCustomPriceURL = false, this.isCustomStockURL = false;
    }
    addPrice(item) {
        this.prices.push(item);
        this.handlePrice();
    }
    addStock(item) {
        this.stocks.push(item);
        this.handleStock();
    }
    handlePrice() {
        const elements = this.querySelectorAll('[data-tk-price-wrapper]');
        const filteredList = Array.from(elements).filter((element)=>!element.closest('[data-tk-product-tile][data-tk-url]'));
        if (filteredList.length !== this.prices.length) return;
        const url = filteredList.at(0)?.getAttribute('data-tk-async-url') || (0, $1653b55d89a7adce$export$a4101276b4831ec4)(true);
        this.isCustomPriceURL = url !== (0, $1653b55d89a7adce$export$a4101276b4831ec4)(true);
        (0, $1653b55d89a7adce$export$24835cb787452b46)({
            requestURL: url,
            resolveHandler: this.refreshPriceData.bind(this),
            payload: this.getPreparedData("price")
        });
    }
    handleStock() {
        const elements = this.querySelectorAll('[data-tk-stock-wrapper]');
        const filteredList = Array.from(elements).filter((element)=>!element.closest('[data-tk-product-tile][data-tk-url]'));
        if (filteredList.length !== this.stocks.length) return;
        const url = filteredList.at(0)?.getAttribute('data-tk-async-url') || (0, $1653b55d89a7adce$export$a4101276b4831ec4)(true);
        this.isCustomStockURL = url !== (0, $1653b55d89a7adce$export$a4101276b4831ec4)(true);
        (0, $1653b55d89a7adce$export$24835cb787452b46)({
            requestURL: url,
            resolveHandler: this.refreshStockData.bind(this),
            payload: this.getPreparedData("stock")
        });
    }
    getPreparedData(type) {
        return {
            type: type,
            ...this.getListByType(type)
        };
    }
    getListByType(type) {
        const handler = {
            price: ()=>this.getPriceData(),
            stock: ()=>this.getStockData()
        };
        return handler[type]();
    }
    getPriceData() {
        const items = this.isCustomPriceURL ? (0, $1ccb7c18f671f1de$export$2e2bcd8739ae039).getItemsAsEntrypoint(this.prices) : (0, $1ccb7c18f671f1de$export$2e2bcd8739ae039).getItemsAsJSONString(this.prices);
        return items;
    }
    getStockData() {
        const items = this.isCustomStockURL ? (0, $ad2181492f474118$export$2e2bcd8739ae039).getItemsAsEntrypoint(this.stocks) : (0, $ad2181492f474118$export$2e2bcd8739ae039).getItemsAsJSONString(this.stocks);
        return items;
    }
    refreshPriceData(response) {
        if (!response || !response.success) return;
        if (response.dataAsJson.items?.length !== this.prices.length) return;
        const list = response.dataAsJson.items;
        this.prices.forEach((item, index)=>{
            const responseItem = list[index];
            const { element: element } = item;
            element && element.refreshPrice(item, responseItem);
        });
    }
    refreshStockData(response) {
        if (!response || !response.success) return;
        if (response.dataAsJson.items?.length !== this.stocks.length) return;
        const list = response.dataAsJson.items;
        this.stocks.forEach((item, index)=>{
            const responseItem = list[index];
            const { element: element } = item;
            element && element.refreshStock(item, responseItem);
        });
    }
}







var $2c226fea39ede692$var$Actions = /*#__PURE__*/ function(Actions) {
    Actions["ADD"] = "add";
    Actions["ADDED"] = "added";
    Actions["DELETED"] = "deleted";
    Actions["MOVED"] = "moved";
    Actions["MOVE"] = "move";
    return Actions;
}($2c226fea39ede692$var$Actions || {});
class $2c226fea39ede692$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.button = this.querySelector('button') || undefined;
        this.artBoId = this.getAttribute('data-tk-art-bo-id') || '';
        this.type = this.getAttribute('data-tk-type') || '';
        this.artNumber = this.getAttribute('data-tk-art-number') || '';
        this.asyncCountId = this.getAttribute('data-tk-async-count-id') || '';
        this.multiFavoritesAction = this.getAttribute('data-tk-multi-favorites-action') || '';
        this.onList = this.getAttribute('data-tk-on-list') || '';
        this.saldocBoIdTarget = this.getAttribute('data-tk-saldoc-bo-id-target') || '';
        this.saldocBoIdSource = this.getAttribute('data-tk-saldoc-bo-id-source') || '';
        this.maxList = Number(this.getAttribute('data-tk-max-list'));
        this.maxPosition = Number(this.getAttribute('data-tk-max-position'));
        this.activeClassName = this.getAttribute('data-tk-active-class-name') || 'tk-button--selected';
        this.listName = this.getAttribute('data-tk-list-name') || '';
        this.selectedOption = Number(this.getAttribute('data-tk-selected-option')) || 1;
        this.isGuestUser = this.hasAttribute('data-tk-guest-user');
    }
    connectedCallback() {
        if (!this.button) throw new Error('Favorite: Button is missing!');
        this.registerClickListener();
    }
    registerClickListener() {
        const onClick = this.send.bind(this);
        this.pushListener({
            event: 'click',
            element: this.button,
            action: onClick
        });
    }
    async send(event) {
        const formValidator = this.closest('[data-tk-form-validator]');
        const formElement = formValidator?.form;
        if (formElement) {
            const formData = new FormData(formElement);
            const optionElements = formElement.querySelectorAll('input[name="favorite-option"]');
            const optionElementList = Array.from(optionElements);
            const selectedOptionIndex = optionElementList.findIndex((element)=>element.checked);
            // if the selected option is `existing`, then take the `saldocBoIdTarget`
            if (selectedOptionIndex === this.selectedOption) {
                const selectElement = formElement.querySelector('select');
                const selectedOption = selectElement?.selectedOptions.item(0);
                this.saldocBoIdTarget = selectedOption?.getAttribute('data-tk-saldoc-bo-id-target') || '';
            }
            if (this.listName === '') {
                const { length: length } = formData.getAll('field-name');
                this.listName = length > 1 ? formData.getAll('field-name')?.at(selectedOptionIndex)?.toString() || '' : formData.get('field-name')?.toString() || '';
            } else this.listName = formData.get('field-name')?.toString() || '';
            if (this.multiFavoritesAction === "added" || this.multiFavoritesAction === "moved") this.checkMaximum(formElement, selectedOptionIndex);
        }
        const isFormValid = await formValidator?.isFormValid();
        if (formValidator && !isFormValid) return;
        const data = {
            Type: 'favorite',
            ArtFavorite_ArtNo: this.artNumber,
            ArtFavorite_ArtBoId: this.artBoId,
            ArtFavorite_ListName: this.listName,
            ArtFavorite_MultiAction: this.multiFavoritesAction,
            ArtFavorite_OnList: this.onList,
            ArtFavorite_SalDocBoIdSource: this.saldocBoIdSource,
            ArtFavorite_SalDocBoIdTarget: this.saldocBoIdTarget,
            maxLists: String(this.maxList),
            maxPositions: String(this.maxPosition)
        };
        Object.keys(this.dataset).filter((key)=>key.startsWith('opSaldocitem.')).forEach((key)=>{
            data[key.substring(2).toLowerCase()] = this.dataset[key];
        });
        const url = (0, $1653b55d89a7adce$export$a4101276b4831ec4)();
        (0, $1653b55d89a7adce$export$24835cb787452b46)({
            requestURL: url,
            resolveHandler: this.refreshContent.bind(this, event),
            payload: data,
            showMessages: false
        });
    }
    refreshContent(event, response) {
        if (!response) return;
        if (response.success && response.messages?.length === 0 && (response.dataAsJson.action === "add" || response.dataAsJson.action === "move")) {
            if (response.dataAsJson.isGuest && this.listName !== '') {
                const html = document.createElement('div');
                html.innerHTML = response.dataAsJson.message;
                const favoriteButton = html.querySelector('[data-tk-saldoc-bo-id-target]');
                const saldocBoIdTarget = favoriteButton?.getAttribute('data-tk-saldoc-bo-id-target');
                const saldocBoId = favoriteButton?.getAttribute('data-tk-saldoc-bo-id');
                saldocBoIdTarget && (this.saldocBoIdTarget = saldocBoIdTarget);
                this.multiFavoritesAction = "added";
                this.setAttribute('data-tk-on-list', `#${saldocBoId}#`);
                this.setAttribute('data-tk-saldoc-bo-id-target', this.saldocBoIdTarget);
                this.send(event);
            } else {
                const { message: message } = response.dataAsJson;
                const dialog = (0, $2215c02a950e9fbf$export$2e2bcd8739ae039).renderDialog({
                    content: message,
                    className: 'tk-dialog tk-dialog--max-width',
                    tag: 'dialog'
                });
                const favoriteButton = dialog.querySelector('tk-favorite-button');
                if (favoriteButton) favoriteButton.addButton = this;
                dialog.showModal();
                this.pushListener({
                    event: 'close',
                    element: dialog,
                    action: ()=>dialog.remove()
                });
            }
        } else {
            const dialog = this.closest('dialog');
            const { action: action, artBoId: artBoId, favoriteCount: favoriteCount } = response.dataAsJson;
            action !== "added" && dialog?.close();
            const actionHandler = {
                added: ()=>this.addedItem(response),
                deleted: ()=>this.deleteArticle(artBoId, response),
                moved: ()=>this.deleteArticle(artBoId, response),
                ["add"] () {
                    throw new Error('Function not implemented.');
                },
                ["move"] () {
                    throw new Error('Function not implemented.');
                }
            };
            actionHandler[action]();
            if (response.dataAsJson.isGuest) return;
            $2c226fea39ede692$export$2e2bcd8739ae039.syncInfo(favoriteCount);
        }
    }
    addedItem(response) {
        const { messages: messages } = response;
        const dialog = this.closest('dialog');
        // check for empty value
        if (!response.dataAsJson.salDocName) return;
        dialog?.close();
        messages?.forEach((message)=>{
            (0, $1221feb2184dfefe$export$146c7c7e50ed1bd2)(message);
        });
        if (this.addButton) {
            this.addButton.setAttribute('data-tk-on-list', response.dataAsJson.onList);
            this.addButton.button.classList.add(this.activeClassName);
            this.addButton.onList = response.dataAsJson.onList;
        }
        this.button.setAttribute('data-tk-on-list', response.dataAsJson.onList);
        this.button.classList.add(this.activeClassName);
        this.onList = response.dataAsJson.onList;
        this.saldocBoIdTarget = response.dataAsJson.salDocBoIdTarget;
        this.setAttribute('data-tk-multi-favorites-action', 'added');
        $2c226fea39ede692$export$2e2bcd8739ae039.updateItemsCount(this.multiFavoritesAction);
        if (this.isGuestUser) {
            this.setAttribute('data-tk-multi-favorites-action', 'deleted');
            this.multiFavoritesAction = "deleted";
        }
        this.pushTrackItem(response.dataAsJson);
    }
    deleteArticle(id, response) {
        const article = document.querySelector(`[data-tk-article-id="${id}"]`);
        if (!article) return;
        if (article.getAttribute('data-tk-item-number')) {
            article.remove();
            const contextMenu = this.closest('[data-tk-context-items]');
            if (!contextMenu) return;
            contextMenu.remove();
            $2c226fea39ede692$export$2e2bcd8739ae039.syncCounter();
        }
        $2c226fea39ede692$export$2e2bcd8739ae039.updateItemsCount(this.multiFavoritesAction);
        this.button?.removeAttribute('data-tk-on-list');
        this.button?.classList.remove(this.activeClassName);
        this.removeAttribute('data-tk-on-list');
        this.setAttribute('data-tk-multi-favorites-action', 'add');
        this.multiFavoritesAction = "add";
        this.saldocBoIdTarget = '';
        const { messages: messages } = response;
        messages?.forEach((message)=>{
            (0, $1221feb2184dfefe$export$146c7c7e50ed1bd2)(message);
        });
    }
    checkMaximum(formElement, selectedOptionIndex) {
        // if the selected option is `existing`, check positions
        const selectElement = formElement.querySelector('select');
        const selectedOption = selectElement?.selectedOptions.item(0);
        const countPositions = Number(selectedOption?.getAttribute('data-tk-saldoc-count-positions'));
        if (selectedOptionIndex === 0 && countPositions > this.maxPosition) {
            (0, $1221feb2184dfefe$export$3a57e165650c636f)((0, $1221feb2184dfefe$export$9130146a86a85749).ERROR, 'Maximum erreicht an Positionen.');
            throw new Error('Rechead maximum of positions in this list');
        } else if ((selectElement?.options.length || 0) > this.maxList) {
            (0, $1221feb2184dfefe$export$3a57e165650c636f)((0, $1221feb2184dfefe$export$9130146a86a85749).ERROR, 'Maximum erreicht an Listen.');
            throw new Error('Rechead maximum of lists');
        }
    }
    pushTrackItem(data) {
        const { action: action, artNo: artNo } = data;
        const trackerElement = document.querySelector('[data-tk-tracker-wrapper]');
        trackerElement?.dispatchEvent(new CustomEvent('tk-tracking-push', {
            detail: {
                type: (0, $588d148f2c9ac202$export$4120f82005ec4b2d).FAVORITE_UPDATE,
                item: {
                    action: action,
                    location: window.location.href,
                    category: 'Wishlist',
                    name: artNo,
                    value: '1'
                }
            }
        }));
    }
    static syncCounter() {
        const counterElement = document.querySelector('[data-tk-favorite-counter]');
        const listElement = document.querySelector('[data-tk-article-list-grid]');
        if (!counterElement || !listElement) return;
        counterElement.textContent = String(listElement.childElementCount);
    }
    static syncInfo(quantity) {
        const infoElement = document.querySelector('[data-tk-favorite-info]');
        if (!infoElement) return;
        infoElement.setAttribute('data-tk-quantity', String(quantity));
    }
    static updateItemsCount(action) {
        // TODO: After the next WAS update, the item count should be included in the response when not logged in. Until then workaround with + 1
        const favoriteInfoElement = document.querySelector('[data-tk-favorite-info]');
        if (!favoriteInfoElement) return;
        const previousItemscount = favoriteInfoElement.getAttribute('data-tk-quantity') ? parseInt(favoriteInfoElement.getAttribute('data-tk-quantity'), 10) : 0;
        favoriteInfoElement.setAttribute('data-tk-quantity', (action === "deleted" ? previousItemscount - 1 : previousItemscount + 1).toString());
    }
}



class $38c77688df6cd108$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    static{
        this.observedAttributes = [
            'data-tk-quantity'
        ];
    }
    constructor(){
        super();
        this.anchor = this.querySelector('a') || undefined;
        this.quantity = Number(this.getAttribute('data-tk-quantity'));
        this.isMulti = this.hasAttribute('data-tk-is-multi');
        this.href = this.getAttribute('data-tk-href') || '';
        this.emptyClassName = this.getAttribute('data-tk-empty-class-name') || 'tk-button__header--empty';
        this.disabledClassName = this.getAttribute('data-tk-disabled-class-name') || 'tk-button__header--disabled';
    }
    attributeChangedCallback(name, oldValue, newValue) {
        if (name === 'data-tk-quantity') {
            if (!this.anchor) return;
            this.anchor.setAttribute('data-count', newValue);
            this.anchor.classList.toggle(this.emptyClassName, Number(newValue) === 0);
            this.anchor.classList.toggle(this.disabledClassName, Number(newValue) === 0);
            this.anchor.href = Number(newValue) === 0 ? 'javascript:void(0)' : this.href;
        }
    }
}



var $9a3403e3213d867d$var$HoverState = /*#__PURE__*/ function(HoverState) {
    HoverState["ACTIVE"] = "active";
    HoverState["INACTIVE"] = "inactive";
    return HoverState;
}($9a3403e3213d867d$var$HoverState || {});
class $9a3403e3213d867d$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.fieldElement = this.querySelector('input, select, textarea');
        this.labelElement = this.querySelector('label') || undefined;
        this.isMaterial = this.hasAttribute('data-tk-is-material');
        this.materialClass = this.getAttribute('data-tk-material-class') || 'tk-form-material';
        this.materialNumberInputClass = this.getAttribute('data-tk-material-number-input-class') || 'tk-form-material--number';
        this.materialLabelInsideClass = this.getAttribute('data-tk-material-label-inside-class') || 'tk-form-material--label-inside';
        this.materialSelectFocussedClass = this.getAttribute('data-tk-material-select-focussed-class') || 'tk-form-select--focussed';
        this.materialLoadedClass = this.getAttribute('data-tk-material-loaded-class') || 'tk-form-material--loaded';
        this.isPasswordInput = this.hasAttribute('data-tk-toggle-password');
        this.disableOnAddonClick = this.hasAttribute('data-tk-disable-on-addon-click');
        this.addonElement = this.querySelector('[data-tk-addon]') || undefined;
        this.waitForSurroundingContent = this.closest('[data-wait-for-surrounding-content]') || undefined;
        this.addonSuffixDistance = 0;
        this.addonPrefixDistance = 0;
        this.addonDefaultPadding = parseInt(this.getAttribute('data-tk-addon-default-padding') || '0', 10) || 4;
        this.onTransitionEnd = ()=>{};
        this.isBoolean = this.hasAttribute('data-tk-boolean');
        this.checkboxElement = this.querySelector('input[type="checkbox"]') || undefined;
        this.hiddenElement = this.querySelector('input[type="hidden"]') || undefined;
        this.defaultValue = this.hiddenElement?.value || '0';
    }
    connectedCallback() {
        if (this.isNumberInput() || this.waitForSurroundingContent) {
            this.onDomContentLoaded();
            return;
        }
        this.checkRequiredAttribute();
        this.registerAddonClickedListener();
        this.registerAddonHoverListener();
        this.registerShowPasswordClickedListener();
        this.initMaterialInput();
        this.observeDisabledAttribute();
        if (!this.isBoolean) return;
        this.registerBooleanListener();
        this.checkboxElement && this.toggleBoolean(this.checkboxElement);
    }
    /**
     * For the Material Number Input or forms inside of tables, it is necessary that all surrounding elements have been
     * fullyloaded before the Material Number Element itself is displayed.
     * This is because the position of the label in the collapsed state
     * needs to be calculated for the Material Number Input. This calculation depends on the surrounding elements
     */ onDomContentLoaded() {
        document.addEventListener('DOMContentLoaded', ()=>{
            this.checkRequiredAttribute();
            this.registerAddonClickedListener();
            this.registerAddonHoverListener();
            this.registerShowPasswordClickedListener();
            this.initMaterialInput();
            this.observeDisabledAttribute();
        });
    }
    // #region Required
    checkRequiredAttribute() {
        if (!this.labelElement || !this.fieldElement || !this.fieldElement.hasAttribute('required')) return;
        this.labelElement.textContent = `${this.labelElement.textContent} *`;
    }
    // #endregion
    // #region disabled
    observeDisabledAttribute() {
        if (!this.fieldElement || !this.labelElement) return;
        // inital check
        this.checkDisabledAttribute();
        const observerConfig = {
            attributes: true,
            attributeFilter: [
                'disabled'
            ]
        };
        const onCheckDiabledAttribute = this.checkDisabledAttribute.bind(this);
        const observer = new MutationObserver(onCheckDiabledAttribute);
        observer.observe(this.fieldElement, observerConfig);
    }
    checkDisabledAttribute() {
        const addDisabledClass = this.fieldElement.hasAttribute('disabled');
        this.classList.toggle('tk-form-input--disabled', addDisabledClass);
    }
    // #endregion
    // #region Addon
    registerAddonClickedListener() {
        if (!this.addonElement || this.disableOnAddonClick) return;
        const addonClickHandler = this.onAddonClicked.bind(this);
        this.pushListener({
            event: 'click',
            element: this.addonElement,
            action: addonClickHandler
        });
    }
    registerAddonHoverListener() {
        if (!this.addonElement) return;
        const onHoverStartHandler = this.onAddonHover.bind(this, "active");
        this.pushListener({
            event: 'mouseenter',
            element: this.addonElement,
            action: onHoverStartHandler
        });
        const onHoverEndHandler = this.onAddonHover.bind(this, "inactive");
        this.pushListener({
            event: 'mouseleave',
            element: this.addonElement,
            action: onHoverEndHandler
        });
    }
    registerBooleanListener() {
        if (!this.checkboxElement || !this.hiddenElement) return;
        const onInput = this.handleBoolean.bind(this);
        this.pushListener({
            event: 'input',
            element: this.checkboxElement,
            action: onInput
        });
    }
    handleBoolean(event) {
        const target = event.target;
        this.toggleBoolean(target);
    }
    toggleBoolean(element) {
        if (element.checked) this.hiddenElement.value = element.value;
        else this.hiddenElement.value = this.defaultValue;
    }
    onAddonHover(hoverState) {
        if (!this.fieldElement || !(this.fieldElement instanceof HTMLInputElement) && !(this.fieldElement instanceof HTMLTextAreaElement)) throw new Error('No Input element found');
        this.classList.toggle('tk-form--addon-hover', hoverState === "active" && !this.fieldElement.disabled);
    }
    onAddonClicked() {
        if (!this.fieldElement || !(this.fieldElement instanceof HTMLInputElement) && !(this.fieldElement instanceof HTMLTextAreaElement)) throw new Error('No Input element found');
        if (this.isPasswordInput) return;
        this.fieldElement.focus();
        const lastCharPosition = this.fieldElement.value.length;
        const isNumberInput = this.fieldElement.type === 'number';
        if (isNumberInput) this.fieldElement.setAttribute('type', 'text');
        this.fieldElement.setSelectionRange(lastCharPosition, lastCharPosition);
        if (isNumberInput) this.fieldElement.setAttribute('type', 'number');
    }
    registerShowPasswordClickedListener() {
        if (!this.isPasswordInput || !this.addonElement) return;
        const passwordShowClickHandler = this.onPasswordShowClicked.bind(this);
        this.pushListener({
            event: 'mousedown',
            element: this.addonElement,
            action: passwordShowClickHandler
        });
        this.pushListener({
            event: 'mouseup',
            element: this.addonElement,
            action: passwordShowClickHandler
        });
        this.pushListener({
            event: 'touchstart',
            element: this.addonElement,
            action: passwordShowClickHandler
        });
        this.pushListener({
            event: 'touchend',
            element: this.addonElement,
            action: passwordShowClickHandler
        });
    }
    onPasswordShowClicked(event) {
        if (!this.fieldElement || !(this.fieldElement instanceof HTMLInputElement)) throw new Error('Missing input element');
        if (event.type === 'mousedown' || event.type === 'touchstart') this.fieldElement.type = 'text';
        else this.fieldElement.type = 'password';
    }
    // #endregion
    // #region Material
    initMaterialInput() {
        if (!this.isMaterial) return;
        if (!this.fieldElement) throw new Error('No element found');
        this.classList.add(this.materialClass);
        if (this.isNumberInput()) this.classList.add(this.materialNumberInputClass);
        this.registerLabelTransitionEndListener();
        this.calculateAddonWidth();
        this.setMaterialLabelState();
        this.registerMaterialValueChangeListener();
        this.registerMaterialSelectFocusChangeListener();
    }
    /**
     * This function is mainly used to check whether a valid value has been
     * set for the data-tk-addon attribute
     * @returns addonType: string representing the addon type
     */ getAddonType() {
        if (!this.addonElement) throw new Error('Missing addon');
        const addonType = this.addonElement.getAttribute('data-tk-addon');
        if (addonType !== 'prefix' && addonType !== 'suffix') throw new Error('Wrong addon type');
        return addonType;
    }
    /**
     * Checks whether the element contains a value or not. This information is required
     * to determine whether the label should be displayed inside or outside the element.
     * @returns isEmptyElement: boolean
     */ checkForValue() {
        let isEmptyElement;
        if (this.fieldElement instanceof HTMLSelectElement) {
            const selectedOption = this.querySelector('option:checked');
            const isPlaceholderOption = selectedOption?.hasAttribute('data-tk-empty-option');
            isEmptyElement = isPlaceholderOption;
        } else isEmptyElement = this.fieldElement?.value === '';
        return isEmptyElement;
    }
    /**
     * This function implements the material functionality by displaying the label either
     * inside or outside the control, depending on the content
     */ setMaterialLabelState() {
        // check input value
        const isEmptyMaterialInput = this.checkForValue();
        if (isEmptyMaterialInput) {
            this.classList.add(this.materialLabelInsideClass);
            if (!this.labelElement) throw new Error('Missing label element');
            if (this.isNumberInput()) this.setupMaterialNumberLabelStyle();
            if (!this.isNumberInput()) this.setupMaterialDefaultLabelStyle();
        } else {
            this.classList.remove(this.materialLabelInsideClass);
            if (!this.labelElement) throw new Error('Missing label element');
            this.labelElement.removeAttribute('style');
        }
    }
    /**
     * This function calculates the label position for a material input that is not of type
     * number and where the label is located within the input
     */ setupMaterialDefaultLabelStyle() {
        if (this.addonPrefixDistance === 0 && this.addonSuffixDistance === 0) return;
        this.labelElement.style.marginLeft = this.addonPrefixDistance > 0 ? `${this.addonPrefixDistance + this.addonDefaultPadding}px` : '0px';
        this.labelElement.style.marginRight = this.addonSuffixDistance > 0 ? `${this.addonSuffixDistance + this.addonDefaultPadding}px` : '0px';
        this.labelElement.style.paddingInline = '0';
    }
    /**
     * This function calculates the label position for a material input of type Number where
     *  the label is located within the input
     */ setupMaterialNumberLabelStyle() {
        this.labelElement.style.paddingInline = '0';
        const labelWidthWithPadding = this.labelElement.getBoundingClientRect().width;
        const computedLabelStyle = window.getComputedStyle(this.labelElement);
        const labelPaddingLeft = parseFloat(computedLabelStyle.paddingLeft);
        const labelPaddingRight = parseFloat(computedLabelStyle.paddingRight);
        const labelWidth = labelWidthWithPadding - labelPaddingLeft - labelPaddingRight;
        const formControlWidth = this.getBoundingClientRect().width;
        const computetInputStyle = window.getComputedStyle(this.fieldElement);
        const inputPaddingRight = parseFloat(computetInputStyle.paddingRight);
        const addonWidth = this.addonElement && this.getAddonType() === 'suffix' ? this.addonElement.getBoundingClientRect().width : 0;
        const xOffset = Math.round(formControlWidth - labelWidth - addonWidth - inputPaddingRight);
        this.labelElement.style.paddingLeft = `${xOffset}px`;
    }
    /**
     * This function checks whether the current control has an addon. If so, depending
     * on the type of control, it checks whether the material label requires additional
     * spacing in the folded state
     */ calculateAddonWidth() {
        if (!this.addonElement) return;
        if (this.fieldElement instanceof HTMLSelectElement) return;
        /* The text is displayed right-aligned for the number inputs.
        They must therefore be treated separately */ const isNumberInput = this.isNumberInput();
        const addonType = this.getAddonType();
        if (!isNumberInput && addonType === 'prefix') this.addonPrefixDistance = this.addonElement.offsetWidth;
        else if (isNumberInput && addonType === 'suffix') this.addonSuffixDistance = this.addonElement.offsetWidth;
    }
    /**
     * Checks whether the input is of type Number. This information is required because
     * the text does not start on the left when the number input is collapsed
     * @returns boolean: representing is input of type number
     */ isNumberInput() {
        if (!(this.fieldElement instanceof HTMLInputElement)) return false;
        return this.fieldElement && this.fieldElement.type === 'number';
    }
    /**
     * Listener for material control value changes
     */ registerMaterialValueChangeListener() {
        const onValueChanged = this.setMaterialLabelState.bind(this);
        this.pushListener({
            event: 'input',
            element: this.fieldElement,
            action: onValueChanged
        });
    }
    /**
     * Is required so that a class can be added to the focused material select
     * element that colors the text of the select white
     */ registerMaterialSelectFocusChangeListener() {
        if (!(this.fieldElement instanceof HTMLSelectElement)) return;
        const onFocusChanged = this.onMaterialSelectFocusChanged.bind(this);
        this.pushListener({
            event: 'focusin',
            element: this.fieldElement,
            action: onFocusChanged
        });
        this.pushListener({
            event: 'focusout',
            element: this.fieldElement,
            action: onFocusChanged
        });
    }
    /**
     * This function is used to add a class to the focused material select, which sets
     * the font to white if no option has been selected
     * @param event: Used to determin if focus has been set or removed
     */ onMaterialSelectFocusChanged(event) {
        const { type: type } = event;
        if (type === 'focusin') this.classList.add(this.materialSelectFocussedClass);
        else this.classList.remove(this.materialSelectFocussedClass);
    }
    /**
     * This function fades in the material element as soon as the label is in
     * the correct position
     */ registerLabelTransitionEndListener() {
        if (!this.labelElement) throw new Error('Missing label element');
        this.onTransitionEnd = this.addMaterialLoadedModifier.bind(this);
        this.pushListener({
            event: 'transitionend',
            element: this.labelElement,
            action: this.onTransitionEnd
        });
    }
    addMaterialLoadedModifier() {
        this.classList.add(this.materialLoadedClass);
        this.labelElement.removeEventListener('transitionend', this.onTransitionEnd);
    }
}








class $cb17fd7e698c018c$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.listWrapperClassName = this.getAttribute('data-tk-zip-list-class') || 'tk-form-zipcity__list';
        this.fieldCountry = this.querySelector('[data-tk-zip-country]') || undefined;
        this.fieldZip = this.querySelector('[data-tk-zip-zip]') || undefined;
        this.fieldCity = this.querySelector('[data-tk-zip-city]') || undefined;
        this.lastSearchTerm = '';
        this.selectedField = undefined;
        this.listWrapper = document.createElement('div');
        this.listWrapper.classList.add(this.listWrapperClassName);
        this.listWrapper.hidden = true;
        this.loadingSpinnerTimeout = null;
        this.clearDataTimeout = null;
        this.inputObject = {
            inputField: undefined,
            dropdown: this.listWrapper,
            listItemSelected: undefined,
            data: []
        };
    }
    connectedCallback() {
        this.registerListener();
    }
    registerListener() {
        if (!this.fieldZip && !this.fieldCity) return;
        const onInputHandler = this.searchZipCity.bind(this);
        const onClickHandler = this.toggleDropdown.bind(this);
        const onSelectHandler = this.selectItem.bind(this);
        const onChangeHandler = this.clearFormFields.bind(this);
        const onInputKeyNavigationHandler = this.inputKeyNavigation.bind(this);
        const onDropdownKeyNavigationHandler = this.dropdownKeyNavigation.bind(this);
        this.pushListener({
            event: 'click',
            element: this.fieldZip,
            action: onClickHandler
        });
        this.pushListener({
            event: 'click',
            element: this.fieldCity,
            action: onClickHandler
        });
        this.pushListener({
            event: 'click',
            element: this.inputObject.dropdown,
            action: onSelectHandler
        });
        this.pushListener({
            event: 'input',
            element: this.fieldZip,
            action: onInputHandler
        });
        this.pushListener({
            event: 'input',
            element: this.fieldCity,
            action: onInputHandler
        });
        this.pushListener({
            event: 'keydown',
            element: this.fieldZip,
            action: onInputKeyNavigationHandler
        });
        this.pushListener({
            event: 'keydown',
            element: this.fieldCity,
            action: onInputKeyNavigationHandler
        });
        this.pushListener({
            event: 'keydown',
            element: this.inputObject.dropdown,
            action: onDropdownKeyNavigationHandler
        });
        if (this.fieldCountry) this.pushListener({
            event: 'change',
            element: this.fieldCountry,
            action: onChangeHandler
        });
    }
    inputKeyNavigation(event) {
        if (!(event.code === 'Tab' || event.code === 'Enter' || event.code === 'ArrowDown')) return;
        this.inputObject.listItemSelected = this.inputObject.dropdown?.firstElementChild;
        if (!this.inputObject.listItemSelected) return;
        this.inputObject.dropdown?.classList.remove('hide');
        this.inputObject.listItemSelected.focus();
        event.preventDefault();
    }
    dropdownKeyNavigation(event) {
        const keyActions = {
            ArrowDown: ()=>this.handleArrowKey(true),
            ArrowUp: ()=>this.handleArrowKey(false),
            Enter: ()=>this.selectItem(event),
            Space: ()=>this.selectItem(event),
            Tab: ()=>this.hideDropdown(true),
            Escape: ()=>this.hideDropdown(true)
        };
        const action = keyActions[event.code];
        if (!action) return;
        action();
        event.preventDefault();
    }
    handleArrowKey(isDown) {
        if (this.inputObject.listItemSelected) {
            const nextElement = isDown ? this.inputObject.listItemSelected.nextElementSibling : this.inputObject.listItemSelected.previousElementSibling;
            if (nextElement instanceof HTMLElement) this.inputObject.listItemSelected = nextElement;
        } else this.inputObject.listItemSelected = this.inputObject.dropdown?.firstElementChild;
        if (!this.inputObject.listItemSelected) return;
        this.inputObject.listItemSelected.focus();
        this.setScroller();
    }
    hideDropdown(isHidden = false) {
        if (this.inputObject.dropdown) {
            if (!isHidden) {
                this.showLoadingAnimation();
                this.listWrapper.style.border = 'unset';
            }
            this.inputObject.dropdown.hidden = isHidden;
        }
    }
    toggleDropdown() {
        if (this.inputObject.dropdown && this.inputObject.dropdown.hasChildNodes()) this.inputObject.dropdown.hidden = !this.inputObject.dropdown.hidden;
    }
    setScroller() {
        const { dropdown: dropdown, listItemSelected: listItemSelected } = this.inputObject;
        if (!dropdown || !listItemSelected) return;
        const index = Array.from(dropdown.children).indexOf(listItemSelected);
        const elHeight = listItemSelected.offsetHeight;
        const { scrollTop: scrollTop } = dropdown;
        const viewport = scrollTop + dropdown.offsetHeight;
        const elOffset = elHeight * index;
        if (elOffset >= scrollTop && elOffset + elHeight <= viewport) return;
        dropdown.scrollTop = elOffset;
    }
    setInputObject() {
        if (!this.selectedField?.parentElement?.querySelector(`.${this.listWrapperClassName}`)) this.selectedField?.insertAdjacentElement('afterend', this.listWrapper);
        this.inputObject.inputField = this.selectedField;
    }
    searchZipCity(event) {
        this.selectedField = event.target;
        const value = this.selectedField.value.trim();
        if (value.length < 2) {
            this.clearDataTimeout && clearTimeout(this.clearDataTimeout);
            this.clearDataTimeout = setTimeout(()=>{
                this.clearData();
            }, 300);
            return;
        }
        this.lastSearchTerm = value;
        this.setInputObject();
        this.timer && clearTimeout(this.timer);
        this.timer = setTimeout(()=>{
            this.callApi(value);
        }, 300);
    }
    callApi(value) {
        if (!this.inputObject.dropdown) return;
        this.hideDropdown(false);
        if (this.lastSearchTerm !== value) return;
        const zipCity = this.parseZipCity(value);
        const apiUrl = `${window.location.origin}/api/portal/v1/zipsearch`;
        const urlObject = new URL(apiUrl);
        const { searchParams: searchParams } = urlObject;
        Object.entries(zipCity).forEach(([key, value])=>{
            searchParams.set(key, value);
        });
        (0, $1653b55d89a7adce$export$24835cb787452b46)({
            requestURL: urlObject.toString(),
            resolveHandler: this.refreshResultList.bind(this),
            decodeJSONResponse: false
        });
    }
    parseZipCity(value) {
        let zip;
        let city;
        const country = this.fieldCountry?.value?.toLowerCase() || 'ch';
        const arr = value.split(' ');
        const numberRegex = /^[0-9]+$/;
        const regexTest = arr.find((elem)=>numberRegex.test(elem));
        if (regexTest === undefined) zip = '';
        else zip = regexTest;
        if (!zip) {
            if (arr.length > 1) zip = +arr[1] || '';
        }
        zip = zip.toString();
        city = value.replace(zip, '').trim();
        if (city === 'undefined') city = '';
        return {
            zip: zip,
            city: city,
            country: country
        };
    }
    refreshResultList(response) {
        if (!response) return;
        this.clearData();
        if (Array.isArray(response)) response.forEach((element)=>{
            const listItemTpl = `
                <button type="button" class="tk-form-list-item"
                    data-tk-country="${element.country}"
                    data-tk-zip="${element.zip}"
                    data-tk-city="${element.city}"
                    tabindex="-1"
                >
                    <span class="tk-form__label">
                        ${element.zip} ${element.city}
                    </span>
                </button>`;
            this.inputObject.dropdown.insertAdjacentHTML('beforeend', listItemTpl);
            this.inputObject.data?.push({
                zip: element.zip,
                city: element.city,
                country: element.country
            });
        });
        if (this.inputObject.data.length === 0) {
            const listItemTpl = `
                <div class="spacer-p-2">
                    <div class="tk-message tk-message--info tk-message--fullwidth">
                        <span class="tk-message__icon">
                            <i class="tk-icon-warning"></i>
                        </span>
                        <span class="tk-message__label">${(0, $86b3c5b6d66bd808$export$97a703132b664051).noMatchFound}</span>
                    </div>
                </div>`;
            this.inputObject.dropdown.insertAdjacentHTML('beforeend', listItemTpl);
        }
        this.listWrapper.style.border = '';
        this.loadingSpinnerTimeout && clearTimeout(this.loadingSpinnerTimeout);
        this.inputObject.dropdown.hidden = false;
    }
    selectItem(event) {
        let selectedItem = event.target;
        selectedItem = selectedItem.closest('[data-tk-zip]');
        if (!selectedItem) return;
        const zip = selectedItem.getAttribute('data-tk-zip');
        const city = selectedItem.getAttribute('data-tk-city');
        const country = selectedItem.getAttribute('data-tk-country');
        if (this.fieldZip) this.fieldZip.value = zip;
        if (this.fieldCity) this.fieldCity.value = city;
        if (this.fieldCountry) this.fieldCountry.value = country;
        this.inputObject.inputField.focus();
        this.clearData();
    }
    clearFormFields() {
        this.clearData();
        this.fieldCity.value = '';
        this.fieldZip.value = '';
    }
    clearData() {
        if (this.inputObject.dropdown) {
            this.hideDropdown(true);
            this.inputObject.dropdown.replaceChildren();
        }
        this.inputObject.data = [];
    }
    showLoadingAnimation() {
        this.loadingSpinnerTimeout && clearTimeout(this.loadingSpinnerTimeout);
        this.loadingSpinnerTimeout = setTimeout(()=>{
            this.listWrapper.innerHTML = `
                <div class="tk-progress tk-progress--infinite tk-progress--breakout">
                    <div class="tk-progress__bar"></div>
                </div>`;
        }, 300);
    }
    static async isValidZipCity(form) {
        const apiUrl = `${window.location.origin}/api/portal/v1/zipsearch`;
        const zipCityElem = {
            country: form.querySelector('[data-tk-zip-country]') || '',
            zip: form.querySelector('[data-tk-zip-zip]') || '',
            city: form.querySelector('[data-tk-zip-city]') || ''
        };
        const zipCityValue = {
            country: zipCityElem.country.value,
            zip: zipCityElem.zip.value,
            city: zipCityElem.city.value
        };
        const urlObject = new URL(apiUrl);
        const { searchParams: searchParams } = urlObject;
        Object.entries(zipCityValue).forEach(([key, value])=>{
            searchParams.set(key, value);
        });
        return new Promise((resolve)=>{
            (0, $1653b55d89a7adce$export$24835cb787452b46)({
                requestURL: urlObject.toString(),
                decodeJSONResponse: false,
                resolveHandler: (response)=>{
                    let isValid = false;
                    if (Array.isArray(response)) response.some((item)=>{
                        isValid = $cb17fd7e698c018c$export$2e2bcd8739ae039.shallowObjectEquality(zipCityValue, item);
                        return isValid;
                    });
                    resolve(isValid);
                }
            });
        });
    }
    static shallowObjectEquality(object1, object2) {
        const keys1 = Object.keys(object1);
        const keys2 = Object.keys(object2);
        let isEqual = true;
        if (keys1.length !== keys2.length) {
            isEqual = false;
            return isEqual;
        }
        keys1.forEach((key)=>{
            if (object1[key] !== object2[key]) {
                isEqual = false;
                return isEqual;
            }
        });
        return isEqual;
    }
}


var $21a7ddce6a8de4e2$var$matchType = /*#__PURE__*/ function(matchType) {
    matchType["Some"] = "SOME";
    matchType["Full"] = "FULLMATCH";
    return matchType;
}($21a7ddce6a8de4e2$var$matchType || {});
class $21a7ddce6a8de4e2$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super(), this.validationList = [];
        this.form = this.querySelector('form') || undefined;
        this.fieldWrapperSelector = this.getAttribute('data-tk-field-wrapper-selector') || '[data-tk-field-wrapper]';
        this.formErrorClassName = this.getAttribute('data-tk-form-error-class-name') || 'tk-form--error';
        this.fieldHintClassName = this.getAttribute('data-tk-field-hint-class-name') || 'tk-form__hint';
        this.shouldValidateInline = this.hasAttribute('data-tk-should-validate-inline');
        this.passwordStrengthMeter = this.querySelector('[data-tk-password-strength-meter]') || undefined;
        this.passwordNewElement = this.querySelector('[data-tk-password-new]') || undefined;
        this.passwordRepeatElement = this.querySelector('[data-tk-password-repeat]') || undefined;
        this.passwordValidClassName = this.getAttribute('data-tk-password-valid-class-name') || 'tk-form--valid';
        this.passwordInvalidClassName = this.getAttribute('data-tk-password-valid-class-name') || 'tk-form--invalid';
        this.googleRecaptcha = this.querySelector('[data-tk-google-recaptcha]') || undefined;
        // Selects an element that is clicked when the enter key is pressed
        this.preventEnterDefaultAction = this.getAttribute('data-tk-enter-data-attribute-selector') || undefined;
    }
    connectedCallback() {
        if (!this.form) return;
        this.validationList = [];
        this.setNoValidateForm();
        this.searchFieldElements();
        this.registerSubmitListener();
        this.registerPasswordListener();
        this.shouldValidateInline && this.registerFieldValidationListener();
    }
    setNoValidateForm() {
        if (!this.form) return;
        this.form.noValidate = true;
    }
    searchFieldElements() {
        const formElements = this.querySelectorAll('input, select, textarea');
        const formElementList = Array.from(formElements);
        const filteredFormElements = formElementList.filter((element)=>!element.disabled);
        filteredFormElements.forEach((element)=>{
            const wrapper = element.closest(this.fieldWrapperSelector);
            wrapper && this.validationList.push({
                element: element,
                wrapper: wrapper,
                messages: $21a7ddce6a8de4e2$export$2e2bcd8739ae039.generateValidityMessages(element)
            });
        });
    }
    registerSubmitListener() {
        if (!this.form) return;
        const onSubmitHandler = this.validateForm.bind(this);
        this.pushListener({
            event: 'submit',
            element: this.form,
            action: onSubmitHandler
        });
    }
    registerPasswordListener() {
        if (!(this.passwordStrengthMeter && this.passwordNewElement && this.passwordRepeatElement)) return;
        const onValidatePassword = this.validatePassword.bind(this);
        this.pushListener({
            event: 'input',
            element: this.passwordNewElement,
            action: onValidatePassword
        });
        this.pushListener({
            event: 'input',
            element: this.passwordRepeatElement,
            action: onValidatePassword
        });
    }
    registerFieldValidationListener() {
        this.validationList.forEach((item)=>{
            const onValidation = this.validateField.bind(this, item);
            this.pushListener({
                event: 'blur',
                element: item.element,
                action: onValidation
            });
            this.pushListener({
                event: 'input',
                element: item.element,
                action: onValidation
            });
        });
    }
    async validateRecaptcha() {
        if (!this.googleRecaptcha) return true;
        return new Promise((resolve)=>{
            grecaptcha.ready(async ()=>{
                const siteKey = this.googleRecaptcha.getAttribute('data-tk-site-key');
                if (!siteKey) return resolve(false);
                const token = await grecaptcha.execute(siteKey, {
                    action: 'submit'
                });
                if (!token) return resolve(false);
                this.googleRecaptcha.value = token;
                resolve(true);
            });
        });
    }
    async validateZipCity() {
        const validationList = [];
        const fieldElements = this.querySelectorAll('[data-tk-field-check-zip-city]');
        if (fieldElements.length === 0) return true;
        const apiPromises = Array.from(fieldElements).map(async (element)=>{
            const input = element.querySelector('input');
            if (!input) return true;
            const isValid = await (0, $cb17fd7e698c018c$export$2e2bcd8739ae039).isValidZipCity(this.form);
            const validationItem = this.validationList.find((item)=>item.wrapper === element);
            if (!isValid && validationItem) {
                this.removeMessage(validationItem);
                this.createElementMessage(validationItem, (0, $86b3c5b6d66bd808$export$7ea287b8bcd34b91).typeMismatch);
            }
            return isValid;
        });
        const results = await Promise.all(apiPromises);
        validationList.push(...results);
        return validationList.every((item)=>item);
    }
    async validateByAPI() {
        const validationList = [];
        const fieldElements = this.querySelectorAll('[data-tk-field-check-api]');
        if (fieldElements.length === 0) return true;
        const apiPromises = Array.from(fieldElements).map(async (element)=>{
            const apiURL = element.getAttribute('data-tk-field-check-api');
            const input = element.querySelector('input');
            if (!input || !apiURL || input.value === '') return true;
            const response = await $21a7ddce6a8de4e2$export$2e2bcd8739ae039.fetchExistAPI(apiURL, input.value);
            const { isValid: isValid } = response.dataAsJson;
            const validationItem = this.validationList.find((item)=>item.wrapper === element);
            if (!isValid && validationItem) {
                this.removeMessage(validationItem);
                this.createElementMessage(validationItem, (0, $86b3c5b6d66bd808$export$35e6ad2b040b8403).existigName);
            }
            return isValid;
        });
        const results = await Promise.all(apiPromises);
        validationList.push(...results);
        return validationList.every((item)=>item);
    }
    static async fetchExistAPI(url, value) {
        return new Promise((resolve)=>{
            (0, $1653b55d89a7adce$export$24835cb787452b46)({
                requestURL: url,
                payload: {
                    value: value
                },
                resolveHandler: (response)=>{
                    resolve(response);
                }
            });
        });
    }
    async validateForm(event) {
        event.preventDefault();
        const isFormValid = await this.isFormValid();
        if (!isFormValid) return;
        if (this.preventEnterDefaultAction) {
            const elemntToClick = document.querySelector(`[${this.preventEnterDefaultAction}]`);
            elemntToClick?.querySelector('button')?.click();
            return;
        }
        this.form?.submit();
    }
    async isFormValid() {
        await this.validateFields();
        const areFieldsValid = this.validationList.every((item)=>item.element.validity.valid);
        if (!areFieldsValid) return false;
        const isValid = await this.validateByAPI() && await this.validateZipCity();
        const isRecaptchaValid = await this.validateRecaptcha();
        return (!this.passwordStrengthMeter || this.checkPasswordStengthMeter()) && this.checkPasswordMatching() && isValid && isRecaptchaValid;
    }
    async validateFields() {
        this.validationList.forEach((item)=>{
            this.validateField(item);
        });
        this.firstElementToScrollTo = undefined;
    }
    validateField(item) {
        this.removeMessage(item);
        if (!item.element.validity.valid) this.showMessage(item);
    }
    showMessage(item) {
        const validityList = $21a7ddce6a8de4e2$export$2e2bcd8739ae039.createValidityDictionary(item.element);
        const invalidMessage = validityList.find((validity)=>validity.value);
        const message = invalidMessage ? item.messages.find((message)=>message.key === invalidMessage.key)?.value || '' : item.element.validationMessage;
        this.createElementMessage(item, message);
    }
    createElementMessage(item, message) {
        const spanElement = document.createElement('span');
        spanElement.classList.add(this.fieldHintClassName);
        spanElement.textContent = $21a7ddce6a8de4e2$export$2e2bcd8739ae039.replacePlaceholders(message, item.element);
        item.messageElement = spanElement;
        item.wrapper.classList.add(this.formErrorClassName);
        item.wrapper.insertAdjacentElement('beforeend', spanElement);
        if (this.firstElementToScrollTo) return;
        this.firstElementToScrollTo = item.messageElement;
        this.firstElementToScrollTo.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
        });
    }
    removeMessage(item) {
        const spanElement = item.messageElement;
        if (!spanElement) return;
        spanElement.remove();
        item.wrapper.classList.remove(this.formErrorClassName);
    }
    static createValidityDictionary(element) {
        const { validity: validity } = element;
        const validityList = [];
        for(const key in validity){
            const validityItem = {
                key: key,
                value: Boolean(validity[key])
            };
            validityList.push(validityItem);
        }
        return validityList;
    }
    static generateValidityMessages(element) {
        const list = [];
        const customErrorPrefix = 'data-tk-error-msg-';
        const attributeList = element.getAttributeNames().filter((name)=>name.startsWith(customErrorPrefix));
        attributeList.forEach((key)=>{
            const keyFormatted = key.replace(customErrorPrefix, '').replace(/-./g, (x)=>x[1].toUpperCase());
            const value = element.getAttribute(key);
            value && list.push({
                key: keyFormatted,
                value: value
            });
        });
        if (0, $86b3c5b6d66bd808$export$7ea287b8bcd34b91) {
            const messages = (0, $86b3c5b6d66bd808$export$7ea287b8bcd34b91);
            Object.entries(messages).forEach((entry)=>{
                const [key, value] = entry;
                const foundMessage = list.filter((item)=>item.key === key);
                !foundMessage.length && list.push({
                    key: key,
                    value: value
                });
            });
        }
        return list;
    }
    static replacePlaceholders(value, element) {
        const dictionary = {
            '{minLength}': element.getAttribute('minlength') || '',
            '{maxLength}': element.getAttribute('maxlength') || '',
            '{length}': element.value.length.toString() || '',
            '{step}': element.getAttribute('step') || '',
            '{min}': element.getAttribute('min') || '',
            '{max}': element.getAttribute('max') || '',
            '{currentValue}': element.value
        };
        const re = new RegExp(Object.keys(dictionary).join('|'), 'gi');
        return value.replace(re, (matched)=>dictionary[matched]);
    }
    checkPasswordStengthMeter() {
        const patterns = this.getPasswordPatterns();
        return patterns.every((item)=>item.element?.classList.contains(this.passwordValidClassName));
    }
    checkPasswordMatching() {
        let isValid;
        const newPasswordItem = this.validationList.find((item)=>item.element === this.passwordNewElement);
        const repeatPasswordItem = this.validationList.find((item)=>item.element === this.passwordRepeatElement);
        if (!newPasswordItem || !repeatPasswordItem) return true;
        if (newPasswordItem.element.value !== repeatPasswordItem.element.value) {
            this.removeMessage(repeatPasswordItem);
            this.createElementMessage(repeatPasswordItem, (0, $86b3c5b6d66bd808$export$7ea287b8bcd34b91).passwordNotMatching);
            isValid = false;
        } else isValid = true;
        return isValid;
    }
    validatePassword(event) {
        const target = event.currentTarget;
        const patterns = this.getPasswordPatterns();
        patterns.forEach((item)=>{
            const regex = new RegExp(item.pattern || '', item.matchtype === "FULLMATCH" ? 'g' : '');
            const regexpMatch = target.value.match(regex);
            if (item.matchtype === "SOME") {
                if (regexpMatch) {
                    item.element?.classList.remove(this.passwordInvalidClassName);
                    item.element?.classList.add(this.passwordValidClassName);
                } else {
                    item.element?.classList.remove(this.passwordValidClassName);
                    item.element?.classList.add(this.passwordInvalidClassName);
                }
            }
            if (item.matchtype === "FULLMATCH") {
                if (regexpMatch?.length === target.value.length) {
                    item.element?.classList.remove(this.passwordInvalidClassName);
                    item.element?.classList.add(this.passwordValidClassName);
                } else {
                    item.element?.classList.remove(this.passwordValidClassName);
                    item.element?.classList.add(this.passwordInvalidClassName);
                }
            }
        });
    }
    getPasswordPatterns() {
        const characterPatternElement = this.passwordStrengthMeter?.querySelector('[data-tk-pwd-character-pattern]');
        const upperPatternElement = this.passwordStrengthMeter?.querySelector('[data-tk-pwd-upper-pattern]');
        const numberPatternElement = this.passwordStrengthMeter?.querySelector('[data-tk-pwd-number-pattern]');
        const allowedSymbolPatternElement = this.passwordStrengthMeter?.querySelector('[data-tk-pwd-allowed-symbols-pattern]');
        const characterPattern = characterPatternElement?.getAttribute('data-tk-pwd-character-pattern');
        const upperPattern = upperPatternElement?.getAttribute('data-tk-pwd-upper-pattern');
        const numberPattern = numberPatternElement?.getAttribute('data-tk-pwd-number-pattern');
        const allowedSymbolPattern = allowedSymbolPatternElement?.getAttribute('data-tk-pwd-allowed-symbols-pattern');
        return [
            {
                pattern: characterPattern,
                element: characterPatternElement,
                matchtype: "SOME"
            },
            {
                pattern: upperPattern,
                element: upperPatternElement,
                matchtype: "SOME"
            },
            {
                pattern: numberPattern,
                element: numberPatternElement,
                matchtype: "SOME"
            },
            {
                pattern: allowedSymbolPattern,
                element: allowedSymbolPatternElement,
                matchtype: "FULLMATCH"
            }
        ];
    }
}



class $59575c6d2ba9e740$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.accordionHead = this.querySelector('[data-tk-accordion-head]') || undefined;
        this.accordionBody = this.querySelector('[data-tk-accordion-body]') || undefined;
        this.accordionIcon = this.querySelector('[data-tk-accordion-icon]') || undefined;
        this.accordionIcons = {
            iconAdd: this.getAttribute('data-tk-icon-open') || 'tk-icon-add',
            iconRemove: this.getAttribute('data-tk-icon-collapse') || 'tk-icon-remove'
        };
        this.isActive = this.hasAttribute('data-tk-accordion-is-active');
        this.isHeaderLink = this.accordionHead && this.accordionHead.hasAttribute('data-tk-accordion-link');
        this.activeClassName = this.getAttribute('data-tk-active-class-name') || 'tk-tabs-accordion--active';
    }
    connectedCallback() {
        if ((!this.accordionHead || !this.accordionBody || !this.accordionIcon) && !this.isHeaderLink) throw new Error('Accordion: Elements are missing!');
        this.setAccordionState(this.isActive);
        this.registerListener();
    }
    registerListener() {
        const eventHandler = this.toggleEvent.bind(this);
        this.pushListener({
            event: 'click',
            element: this.accordionHead,
            action: eventHandler
        });
    }
    toggleEvent() {
        this.toggleMarkupElements();
    }
    toggleMarkupElements() {
        this.classList.toggle(this.activeClassName);
        this.accordionIcon?.classList.toggle(this.accordionIcons.iconAdd);
        this.accordionIcon?.classList.toggle(this.accordionIcons.iconRemove);
    }
    setAccordionState(isActive) {
        if (isActive) {
            this.classList.toggle(this.activeClassName);
            this.accordionIcon?.classList.add(this.accordionIcons.iconRemove);
        } else this.accordionIcon?.classList.add(this.accordionIcons.iconAdd);
    }
}





const $f8125d35cd9a4f7a$var$storeRegistry = {};
async function $f8125d35cd9a4f7a$export$7d8a5b498da695ac(stores) {
    Object.keys(stores).forEach((key)=>{
        $f8125d35cd9a4f7a$var$storeRegistry[key] = stores[key];
    });
    await Promise.all(Object.values(stores).map((store)=>store.startInitialization()));
}
function $f8125d35cd9a4f7a$export$6ccbb43953eebf8(storeName) {
    const store = $f8125d35cd9a4f7a$var$storeRegistry[storeName];
    if (!store) throw new Error(`Store not found: ${storeName}`);
    return store;
}
async function $f8125d35cd9a4f7a$export$be9343d232c38cbb(key) {
    const store = $f8125d35cd9a4f7a$var$storeRegistry[key];
    if (store) return store.isInitialized;
    return Promise.reject(`Store ${key} not found`);
}


var $cc14b9b65c9c652e$export$7df56cf357be2b81 = /*#__PURE__*/ function(CompareButtonType) {
    CompareButtonType["ADD"] = "add";
    CompareButtonType["REMOVE"] = "remove";
    CompareButtonType["REMOVE_ALL"] = "removeAll";
    return CompareButtonType;
}({});
class $cc14b9b65c9c652e$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.button = this.querySelector('button') || undefined;
        this.activeClass = this.getAttribute('data-tk-compare-active-class') || 'tk-compare-button--active';
        this.articleId = Number(this.getAttribute('data-tk-article-id') || 0);
        this.categoryId = Number(this.getAttribute('data-tk-category-id') || 0);
        this.categoryName = this.getAttribute('data-tk-category-name') || undefined;
        this.type = this.getAttribute('data-tk-type') || "add";
    }
    async connectedCallback() {
        if (!this.button) throw new Error('Compare: Button is missing!');
        await (0, $f8125d35cd9a4f7a$export$be9343d232c38cbb)('compareStore');
        this.store = (0, $f8125d35cd9a4f7a$export$6ccbb43953eebf8)('compareStore');
        this.initializeDatabase();
        this.registerClickListener();
    }
    disconnectedCallback() {
        this.unsubscribe && this.unsubscribe();
    }
    registerClickListener() {
        this.pushListener({
            event: 'click',
            element: this,
            action: this.runActionByType.bind(this)
        });
    }
    async runActionByType() {
        if (!this.store) return;
        const handler = {
            add: this.toggle.bind(this),
            remove: this.remove.bind(this),
            removeAll: this.clearAll.bind(this)
        };
        handler[this.type]();
    }
    initializeDatabase() {
        if (!this.store) return;
        this.unsubscribe = this.store.subscribe(()=>this.render());
        this.render();
    }
    clearAll() {
        if (!this.store) return;
        this.button.disabled = true;
        this.store.clearAll().then(()=>{
            (0, $1221feb2184dfefe$export$3a57e165650c636f)((0, $1221feb2184dfefe$export$9130146a86a85749).SUCCESS, (0, $86b3c5b6d66bd808$export$ad480231e1cfb49).allRemoved.text);
            this.button.disabled = false;
        });
    }
    async remove() {
        if (!this.categoryId || !this.articleId || !this.store) throw new Error('Category or article id is missing!');
        const category = this.store.getCategoryById(this.categoryId);
        if (!category) return;
        const filteredArticles = category.articleIds.filter((id)=>id !== this.articleId);
        if (filteredArticles.length === 0) {
            await this.store.removeCategoryById(this.categoryId);
            const categories = this.store?.getState().categories;
            this.store?.switchCategory(categories?.at(0)?.id || 0);
        } else {
            category.articleIds = filteredArticles;
            await this.store.patchCategoryById(this.categoryId, category);
        }
    }
    async toggle() {
        if (!this.categoryId || !this.articleId || !this.store) throw new Error('Category or article id is missing!');
        const category = this.store.getCategoryById(this.categoryId);
        if (category) await this.updateExistingCategory(category);
        else await this.createNewCategory();
    }
    async updateExistingCategory(category) {
        const articleExists = category.articleIds.includes(this.articleId);
        if (articleExists) {
            category.articleIds = category.articleIds.filter((id)=>id !== this.articleId);
            const articleCount = this.store?.getArticleCountByCategoryId(category.id);
            if (articleCount === 0) await this.store?.removeCategoryById(this.categoryId);
            else await this.store?.patchCategoryById(this.categoryId, category);
            (0, $1221feb2184dfefe$export$3a57e165650c636f)((0, $1221feb2184dfefe$export$9130146a86a85749).SUCCESS, (0, $86b3c5b6d66bd808$export$ad480231e1cfb49).removed.text);
        } else {
            category.articleIds.push(this.articleId);
            await this.store?.patchCategoryById(this.categoryId, category);
            (0, $1221feb2184dfefe$export$3a57e165650c636f)((0, $1221feb2184dfefe$export$9130146a86a85749).SUCCESS, (0, $86b3c5b6d66bd808$export$ad480231e1cfb49).added.text);
        }
    }
    async createNewCategory() {
        const newCategory = {
            id: this.categoryId,
            name: this.categoryName || '',
            articleIds: [
                this.articleId
            ]
        };
        await this.store?.patchCategoryById(this.categoryId, newCategory);
        (0, $1221feb2184dfefe$export$3a57e165650c636f)((0, $1221feb2184dfefe$export$9130146a86a85749).SUCCESS, (0, $86b3c5b6d66bd808$export$ad480231e1cfb49).added.text);
    }
    checkAvailability() {
        if (!this.store) return;
        const { currentCategoryId: currentCategoryId } = this.store.getState();
        const currentCategory = this.store.getCategoryById(currentCategoryId);
        this.button.hidden = !currentCategory;
    }
    render() {
        if (this.type === "add") {
            const category = this.store?.getCategoryById(this.categoryId);
            if (!category) {
                this.classList.remove(this.activeClass);
                return;
            }
            this.classList.toggle(this.activeClass, category.articleIds.includes(this.articleId));
        } else if (this.type === "removeAll") this.checkAvailability();
    }
}



class $407d2fd9d876caa3$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.targetElement = this.querySelector('input[type="hidden"]') || undefined;
        this.toggleWrapper = this.querySelector('[data-tk-selection-toggles]') || undefined;
        this.selectWrapper = this.querySelector('[data-tk-selection-select]') || undefined;
        this.maxVisible = Number(this.getAttribute('data-tk-max-visible')) || 3;
        this.loadedClassName = this.getAttribute('data-tk-loaded-class-name') || 'tk-selection--loaded';
    }
    connectedCallback() {
        if (!this.targetElement || !this.toggleWrapper || !this.selectWrapper) throw new Error('Selection: Elements are missing!');
        this.registerInputListener();
        this.switchView();
        this.classList.add(this.loadedClassName);
    }
    registerInputListener() {
        const fieldElements = this.toggleWrapper.querySelectorAll('input');
        const selectElement = this.selectWrapper.querySelector('select');
        const onInput = this.syncTargetElement.bind(this);
        fieldElements.forEach((fieldElement)=>{
            this.pushListener({
                event: 'input',
                element: fieldElement,
                action: onInput
            });
        });
        selectElement && this.pushListener({
            event: 'input',
            element: selectElement,
            action: onInput
        });
    }
    syncTargetElement(event) {
        const target = event.target;
        const selectedTarget = target instanceof HTMLInputElement ? target : target.options[target.selectedIndex];
        const { dataset: dataset } = selectedTarget;
        this.targetElement.value = selectedTarget.value;
        Object.keys(this.targetElement.dataset).forEach((key)=>{
            delete this.targetElement.dataset[key];
        });
        Object.keys(dataset).forEach((key)=>{
            this.targetElement.dataset[key] = dataset[key];
        });
        this.targetElement?.dispatchEvent(new Event('change'));
    }
    switchView() {
        if (this.toggleWrapper.childElementCount > this.maxVisible) {
            this.toggleWrapper.hidden = true;
            this.selectWrapper.hidden = false;
        } else {
            this.toggleWrapper.hidden = false;
            this.selectWrapper.hidden = true;
        }
    }
}



function $a85fd1efd23057e0$var$_classPrivateFieldLooseBase(receiver, privateKey) {
    if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) throw new TypeError("attempted to use private field on non-instance");
    return receiver;
}
var $a85fd1efd23057e0$var$id = 0;
function $a85fd1efd23057e0$var$_classPrivateFieldLooseKey(name) {
    return "__private_" + $a85fd1efd23057e0$var$id++ + "_" + name;
}
// We're using a generic because languages have different plural rules.
// eslint-disable-next-line no-use-before-define
function $a85fd1efd23057e0$var$insertReplacement(source, rx, replacement) {
    const newParts = [];
    source.forEach((chunk)=>{
        // When the source contains multiple placeholders for interpolation,
        // we should ignore chunks that are not strings, because those
        // can be JSX objects and will be otherwise incorrectly turned into strings.
        // Without this condition we’d get this: [object Object] hello [object Object] my <button>
        if (typeof chunk !== 'string') return newParts.push(chunk);
        return rx[Symbol.split](chunk).forEach((raw, i, list)=>{
            if (raw !== '') newParts.push(raw);
            // Interlace with the `replacement` value
            if (i < list.length - 1) newParts.push(replacement);
        });
    });
    return newParts;
}
/**
 * Takes a string with placeholder variables like `%{smart_count} file selected`
 * and replaces it with values from options `{smart_count: 5}`
 *
 * @license https://github.com/airbnb/polyglot.js/blob/master/LICENSE
 * taken from https://github.com/airbnb/polyglot.js/blob/master/lib/polyglot.js#L299
 *
 * @param phrase that needs interpolation, with placeholders
 * @param options with values that will be used to replace placeholders
 */ function $a85fd1efd23057e0$var$interpolate(phrase, options) {
    const dollarRegex = /\$/g;
    const dollarBillsYall = '$$$$';
    let interpolated = [
        phrase
    ];
    if (options == null) return interpolated;
    for (const arg of Object.keys(options))if (arg !== '_') {
        // Ensure replacement value is escaped to prevent special $-prefixed
        // regex replace tokens. the "$$$$" is needed because each "$" needs to
        // be escaped with "$" itself, and we need two in the resulting output.
        let replacement = options[arg];
        if (typeof replacement === 'string') replacement = dollarRegex[Symbol.replace](replacement, dollarBillsYall);
        // We create a new `RegExp` each time instead of using a more-efficient
        // string replace so that the same argument can be replaced multiple times
        // in the same phrase.
        interpolated = $a85fd1efd23057e0$var$insertReplacement(interpolated, new RegExp(`%\\{${arg}\\}`, 'g'), replacement);
    }
    return interpolated;
}
const $a85fd1efd23057e0$var$defaultOnMissingKey = (key)=>{
    throw new Error(`missing string: ${key}`);
};
/**
 * Translates strings with interpolation & pluralization support.
 * Extensible with custom dictionaries and pluralization functions.
 *
 * Borrows heavily from and inspired by Polyglot https://github.com/airbnb/polyglot.js,
 * basically a stripped-down version of it. Differences: pluralization functions are not hardcoded
 * and can be easily added among with dictionaries, nested objects are used for pluralization
 * as opposed to `||||` delimeter
 *
 * Usage example: `translator.translate('files_chosen', {smart_count: 3})`
 */ var $a85fd1efd23057e0$var$_onMissingKey = /*#__PURE__*/ $a85fd1efd23057e0$var$_classPrivateFieldLooseKey("onMissingKey");
var $a85fd1efd23057e0$var$_apply = /*#__PURE__*/ $a85fd1efd23057e0$var$_classPrivateFieldLooseKey("apply");
class $a85fd1efd23057e0$export$2e2bcd8739ae039 {
    constructor(locales, _temp){
        let { onMissingKey: onMissingKey = $a85fd1efd23057e0$var$defaultOnMissingKey } = _temp === void 0 ? {} : _temp;
        Object.defineProperty(this, $a85fd1efd23057e0$var$_apply, {
            value: $a85fd1efd23057e0$var$_apply2
        });
        Object.defineProperty(this, $a85fd1efd23057e0$var$_onMissingKey, {
            writable: true,
            value: void 0
        });
        this.locale = {
            strings: {},
            pluralize (n) {
                if (n === 1) return 0;
                return 1;
            }
        };
        if (Array.isArray(locales)) locales.forEach($a85fd1efd23057e0$var$_classPrivateFieldLooseBase(this, $a85fd1efd23057e0$var$_apply)[$a85fd1efd23057e0$var$_apply], this);
        else $a85fd1efd23057e0$var$_classPrivateFieldLooseBase(this, $a85fd1efd23057e0$var$_apply)[$a85fd1efd23057e0$var$_apply](locales);
        $a85fd1efd23057e0$var$_classPrivateFieldLooseBase(this, $a85fd1efd23057e0$var$_onMissingKey)[$a85fd1efd23057e0$var$_onMissingKey] = onMissingKey;
    }
    /**
   * Public translate method
   *
   * @param key
   * @param options with values that will be used later to replace placeholders in string
   * @returns string translated (and interpolated)
   */ translate(key, options) {
        return this.translateArray(key, options).join('');
    }
    /**
   * Get a translation and return the translated and interpolated parts as an array.
   *
   * @returns The translated and interpolated parts, in order.
   */ translateArray(key, options) {
        let string = this.locale.strings[key];
        if (string == null) {
            $a85fd1efd23057e0$var$_classPrivateFieldLooseBase(this, $a85fd1efd23057e0$var$_onMissingKey)[$a85fd1efd23057e0$var$_onMissingKey](key);
            string = key;
        }
        const hasPluralForms = typeof string === 'object';
        if (hasPluralForms) {
            if (options && typeof options.smart_count !== 'undefined') {
                const plural = this.locale.pluralize(options.smart_count);
                return $a85fd1efd23057e0$var$interpolate(string[plural], options);
            }
            throw new Error('Attempted to use a string with plural forms, but no value was given for %{smart_count}');
        }
        if (typeof string !== 'string') throw new Error(`string was not a string`);
        return $a85fd1efd23057e0$var$interpolate(string, options);
    }
}
function $a85fd1efd23057e0$var$_apply2(locale) {
    if (!(locale != null && locale.strings)) return;
    const prevLocale = this.locale;
    Object.assign(this.locale, {
        strings: {
            ...prevLocale.strings,
            ...locale.strings
        },
        pluralize: locale.pluralize || prevLocale.pluralize
    });
}


var $1713863f3a962559$exports = {};
/**
* Create an event emitter with namespaces
* @name createNamespaceEmitter
* @example
* var emitter = require('./index')()
*
* emitter.on('*', function () {
*   console.log('all events emitted', this.event)
* })
*
* emitter.on('example', function () {
*   console.log('example event emitted')
* })
*/ $1713863f3a962559$exports = function createNamespaceEmitter() {
    var emitter = {};
    var _fns = emitter._fns = {};
    /**
  * Emit an event. Optionally namespace the event. Handlers are fired in the order in which they were added with exact matches taking precedence. Separate the namespace and event with a `:`
  * @name emit
  * @param {String} event – the name of the event, with optional namespace
  * @param {...*} data – up to 6 arguments that are passed to the event listener
  * @example
  * emitter.emit('example')
  * emitter.emit('demo:test')
  * emitter.emit('data', { example: true}, 'a string', 1)
  */ emitter.emit = function emit(event, arg1, arg2, arg3, arg4, arg5, arg6) {
        var toEmit = getListeners(event);
        if (toEmit.length) emitAll(event, toEmit, [
            arg1,
            arg2,
            arg3,
            arg4,
            arg5,
            arg6
        ]);
    };
    /**
  * Create en event listener.
  * @name on
  * @param {String} event
  * @param {Function} fn
  * @example
  * emitter.on('example', function () {})
  * emitter.on('demo', function () {})
  */ emitter.on = function on(event, fn) {
        if (!_fns[event]) _fns[event] = [];
        _fns[event].push(fn);
    };
    /**
  * Create en event listener that fires once.
  * @name once
  * @param {String} event
  * @param {Function} fn
  * @example
  * emitter.once('example', function () {})
  * emitter.once('demo', function () {})
  */ emitter.once = function once(event, fn) {
        function one() {
            fn.apply(this, arguments);
            emitter.off(event, one);
        }
        this.on(event, one);
    };
    /**
  * Stop listening to an event. Stop all listeners on an event by only passing the event name. Stop a single listener by passing that event handler as a callback.
  * You must be explicit about what will be unsubscribed: `emitter.off('demo')` will unsubscribe an `emitter.on('demo')` listener,
  * `emitter.off('demo:example')` will unsubscribe an `emitter.on('demo:example')` listener
  * @name off
  * @param {String} event
  * @param {Function} [fn] – the specific handler
  * @example
  * emitter.off('example')
  * emitter.off('demo', function () {})
  */ emitter.off = function off(event, fn) {
        var keep = [];
        if (event && fn) {
            var fns = this._fns[event];
            var i = 0;
            var l = fns ? fns.length : 0;
            for(i; i < l; i++)if (fns[i] !== fn) keep.push(fns[i]);
        }
        keep.length ? this._fns[event] = keep : delete this._fns[event];
    };
    function getListeners(e) {
        var out = _fns[e] ? _fns[e] : [];
        var idx = e.indexOf(':');
        var args = idx === -1 ? [
            e
        ] : [
            e.substring(0, idx),
            e.substring(idx + 1)
        ];
        var keys = Object.keys(_fns);
        var i = 0;
        var l = keys.length;
        for(i; i < l; i++){
            var key = keys[i];
            if (key === '*') out = out.concat(_fns[key]);
            if (args.length === 2 && args[0] === key) {
                out = out.concat(_fns[key]);
                break;
            }
        }
        return out;
    }
    function emitAll(e, fns, args) {
        var i = 0;
        var l = fns.length;
        for(i; i < l; i++){
            if (!fns[i]) break;
            fns[i].event = e;
            fns[i].apply(fns[i], args);
        }
    }
    return emitter;
};


let $3c82c89e950acc97$var$urlAlphabet = 'useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict';
let $3c82c89e950acc97$export$62e99e5c9f473d7f = (alphabet, defaultSize = 21)=>{
    return (size = defaultSize)=>{
        let id = '';
        let i = size | 0;
        while(i--)id += alphabet[Math.random() * alphabet.length | 0];
        return id;
    };
};
let $3c82c89e950acc97$export$ac4959f4f1338dfc = (size = 21)=>{
    let id = '';
    let i = size | 0;
    while(i--)id += $3c82c89e950acc97$var$urlAlphabet[Math.random() * 64 | 0];
    return id;
};


var $a50c1ad1c2867517$exports = {};
var $8284bc2b60dc4bc4$exports = {};
var $db5dfd0661742a1a$exports = {};
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $db5dfd0661742a1a$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
$db5dfd0661742a1a$exports = $db5dfd0661742a1a$var$isObject;


var $1c50bd4ee78fb504$exports = {};
var $67910ad3df1b1086$exports = {};
var $fb170ba8a9c2191f$exports = {};
/** Detect free variable `global` from Node.js. */ var $fb170ba8a9c2191f$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
$fb170ba8a9c2191f$exports = $fb170ba8a9c2191f$var$freeGlobal;


/** Detect free variable `self`. */ var $67910ad3df1b1086$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $67910ad3df1b1086$var$root = $fb170ba8a9c2191f$exports || $67910ad3df1b1086$var$freeSelf || Function('return this')();
$67910ad3df1b1086$exports = $67910ad3df1b1086$var$root;


/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $1c50bd4ee78fb504$var$now = function() {
    return $67910ad3df1b1086$exports.Date.now();
};
$1c50bd4ee78fb504$exports = $1c50bd4ee78fb504$var$now;


var $e588870a06e690e1$exports = {};
var $3b7784db2f170e31$exports = {};
var $85eafef3a7f213a3$exports = {};
/** Used to match a single whitespace character. */ var $85eafef3a7f213a3$var$reWhitespace = /\s/;
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */ function $85eafef3a7f213a3$var$trimmedEndIndex(string) {
    var index = string.length;
    while(index-- && $85eafef3a7f213a3$var$reWhitespace.test(string.charAt(index)));
    return index;
}
$85eafef3a7f213a3$exports = $85eafef3a7f213a3$var$trimmedEndIndex;


/** Used to match leading whitespace. */ var $3b7784db2f170e31$var$reTrimStart = /^\s+/;
/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */ function $3b7784db2f170e31$var$baseTrim(string) {
    return string ? string.slice(0, $85eafef3a7f213a3$exports(string) + 1).replace($3b7784db2f170e31$var$reTrimStart, '') : string;
}
$3b7784db2f170e31$exports = $3b7784db2f170e31$var$baseTrim;



var $b7350b23d035986b$exports = {};
var $852d1f971b259156$exports = {};
var $a090581360ce8173$exports = {};

/** Built-in value references. */ var $a090581360ce8173$var$Symbol = $67910ad3df1b1086$exports.Symbol;
$a090581360ce8173$exports = $a090581360ce8173$var$Symbol;


var $f2cc4cee927d37c7$exports = {};

/** Used for built-in method references. */ var $f2cc4cee927d37c7$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $f2cc4cee927d37c7$var$hasOwnProperty = $f2cc4cee927d37c7$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $f2cc4cee927d37c7$var$nativeObjectToString = $f2cc4cee927d37c7$var$objectProto.toString;
/** Built-in value references. */ var $f2cc4cee927d37c7$var$symToStringTag = $a090581360ce8173$exports ? $a090581360ce8173$exports.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $f2cc4cee927d37c7$var$getRawTag(value) {
    var isOwn = $f2cc4cee927d37c7$var$hasOwnProperty.call(value, $f2cc4cee927d37c7$var$symToStringTag), tag = value[$f2cc4cee927d37c7$var$symToStringTag];
    try {
        value[$f2cc4cee927d37c7$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $f2cc4cee927d37c7$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$f2cc4cee927d37c7$var$symToStringTag] = tag;
        else delete value[$f2cc4cee927d37c7$var$symToStringTag];
    }
    return result;
}
$f2cc4cee927d37c7$exports = $f2cc4cee927d37c7$var$getRawTag;


var $934b51efa189f09c$exports = {};
/** Used for built-in method references. */ var $934b51efa189f09c$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $934b51efa189f09c$var$nativeObjectToString = $934b51efa189f09c$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $934b51efa189f09c$var$objectToString(value) {
    return $934b51efa189f09c$var$nativeObjectToString.call(value);
}
$934b51efa189f09c$exports = $934b51efa189f09c$var$objectToString;


/** `Object#toString` result references. */ var $852d1f971b259156$var$nullTag = '[object Null]', $852d1f971b259156$var$undefinedTag = '[object Undefined]';
/** Built-in value references. */ var $852d1f971b259156$var$symToStringTag = $a090581360ce8173$exports ? $a090581360ce8173$exports.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $852d1f971b259156$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $852d1f971b259156$var$undefinedTag : $852d1f971b259156$var$nullTag;
    return $852d1f971b259156$var$symToStringTag && $852d1f971b259156$var$symToStringTag in Object(value) ? $f2cc4cee927d37c7$exports(value) : $934b51efa189f09c$exports(value);
}
$852d1f971b259156$exports = $852d1f971b259156$var$baseGetTag;


var $5475ba594a8bdf91$exports = {};
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $5475ba594a8bdf91$var$isObjectLike(value) {
    return value != null && typeof value == 'object';
}
$5475ba594a8bdf91$exports = $5475ba594a8bdf91$var$isObjectLike;


/** `Object#toString` result references. */ var $b7350b23d035986b$var$symbolTag = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $b7350b23d035986b$var$isSymbol(value) {
    return typeof value == 'symbol' || $5475ba594a8bdf91$exports(value) && $852d1f971b259156$exports(value) == $b7350b23d035986b$var$symbolTag;
}
$b7350b23d035986b$exports = $b7350b23d035986b$var$isSymbol;


/** Used as references for various `Number` constants. */ var $e588870a06e690e1$var$NAN = 0 / 0;
/** Used to detect bad signed hexadecimal string values. */ var $e588870a06e690e1$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $e588870a06e690e1$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $e588870a06e690e1$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $e588870a06e690e1$var$freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $e588870a06e690e1$var$toNumber(value) {
    if (typeof value == 'number') return value;
    if ($b7350b23d035986b$exports(value)) return $e588870a06e690e1$var$NAN;
    if ($db5dfd0661742a1a$exports(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = $db5dfd0661742a1a$exports(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = $3b7784db2f170e31$exports(value);
    var isBinary = $e588870a06e690e1$var$reIsBinary.test(value);
    return isBinary || $e588870a06e690e1$var$reIsOctal.test(value) ? $e588870a06e690e1$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $e588870a06e690e1$var$reIsBadHex.test(value) ? $e588870a06e690e1$var$NAN : +value;
}
$e588870a06e690e1$exports = $e588870a06e690e1$var$toNumber;


/** Error message constants. */ var $8284bc2b60dc4bc4$var$FUNC_ERROR_TEXT = 'Expected a function';
/* Built-in method references for those with the same name as other `lodash` methods. */ var $8284bc2b60dc4bc4$var$nativeMax = Math.max, $8284bc2b60dc4bc4$var$nativeMin = Math.min;
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $8284bc2b60dc4bc4$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != 'function') throw new TypeError($8284bc2b60dc4bc4$var$FUNC_ERROR_TEXT);
    wait = $e588870a06e690e1$exports(wait) || 0;
    if ($db5dfd0661742a1a$exports(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? $8284bc2b60dc4bc4$var$nativeMax($e588870a06e690e1$exports(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
        return maxing ? $8284bc2b60dc4bc4$var$nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $1c50bd4ee78fb504$exports();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($1c50bd4ee78fb504$exports());
    }
    function debounced() {
        var time = $1c50bd4ee78fb504$exports(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                clearTimeout(timerId);
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
$8284bc2b60dc4bc4$exports = $8284bc2b60dc4bc4$var$debounce;



/** Error message constants. */ var $a50c1ad1c2867517$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */ function $a50c1ad1c2867517$var$throttle(func, wait, options) {
    var leading = true, trailing = true;
    if (typeof func != 'function') throw new TypeError($a50c1ad1c2867517$var$FUNC_ERROR_TEXT);
    if ($db5dfd0661742a1a$exports(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    return $8284bc2b60dc4bc4$exports(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
    });
}
$a50c1ad1c2867517$exports = $a50c1ad1c2867517$var$throttle;


function $f790bad313c52a0f$var$_classPrivateFieldLooseBase(receiver, privateKey) {
    if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) throw new TypeError("attempted to use private field on non-instance");
    return receiver;
}
var $f790bad313c52a0f$var$id = 0;
function $f790bad313c52a0f$var$_classPrivateFieldLooseKey(name) {
    return "__private_" + $f790bad313c52a0f$var$id++ + "_" + name;
}
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore We don't want TS to generate types for the package.json
const $f790bad313c52a0f$var$packageJson = {
    "version": "3.2.2"
};
var $f790bad313c52a0f$var$_callbacks = /*#__PURE__*/ $f790bad313c52a0f$var$_classPrivateFieldLooseKey("callbacks");
var $f790bad313c52a0f$var$_publish = /*#__PURE__*/ $f790bad313c52a0f$var$_classPrivateFieldLooseKey("publish");
/**
 * Default store that keeps state in a simple object.
 */ class $f790bad313c52a0f$var$DefaultStore {
    constructor(){
        Object.defineProperty(this, $f790bad313c52a0f$var$_publish, {
            value: $f790bad313c52a0f$var$_publish2
        });
        this.state = {};
        Object.defineProperty(this, $f790bad313c52a0f$var$_callbacks, {
            writable: true,
            value: new Set()
        });
    }
    getState() {
        return this.state;
    }
    setState(patch) {
        const prevState = {
            ...this.state
        };
        const nextState = {
            ...this.state,
            ...patch
        };
        this.state = nextState;
        $f790bad313c52a0f$var$_classPrivateFieldLooseBase(this, $f790bad313c52a0f$var$_publish)[$f790bad313c52a0f$var$_publish](prevState, nextState, patch);
    }
    subscribe(listener) {
        $f790bad313c52a0f$var$_classPrivateFieldLooseBase(this, $f790bad313c52a0f$var$_callbacks)[$f790bad313c52a0f$var$_callbacks].add(listener);
        return ()=>{
            $f790bad313c52a0f$var$_classPrivateFieldLooseBase(this, $f790bad313c52a0f$var$_callbacks)[$f790bad313c52a0f$var$_callbacks].delete(listener);
        };
    }
}
function $f790bad313c52a0f$var$_publish2() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    $f790bad313c52a0f$var$_classPrivateFieldLooseBase(this, $f790bad313c52a0f$var$_callbacks)[$f790bad313c52a0f$var$_callbacks].forEach((listener)=>{
        listener(...args);
    });
}
$f790bad313c52a0f$var$DefaultStore.VERSION = $f790bad313c52a0f$var$packageJson.version;
var $f790bad313c52a0f$export$2e2bcd8739ae039 = $f790bad313c52a0f$var$DefaultStore;


/**
 * Takes a full filename string and returns an object {name, extension}
 */ function $09afbe8d004816d5$export$2e2bcd8739ae039(fullFileName) {
    const lastDot = fullFileName.lastIndexOf('.');
    // these count as no extension: "no-dot", "trailing-dot."
    if (lastDot === -1 || lastDot === fullFileName.length - 1) return {
        name: fullFileName,
        extension: undefined
    };
    return {
        name: fullFileName.slice(0, lastDot),
        extension: fullFileName.slice(lastDot + 1)
    };
}


// ___Why not add the mime-types package?
//    It's 19.7kB gzipped, and we only need mime types for well-known extensions (for file previews).
// ___Where to take new extensions from?
//    https://github.com/jshttp/mime-db/blob/master/db.json
var $92507ee89880573c$export$2e2bcd8739ae039 = {
    __proto__: null,
    md: 'text/markdown',
    markdown: 'text/markdown',
    mp4: 'video/mp4',
    mp3: 'audio/mp3',
    svg: 'image/svg+xml',
    jpg: 'image/jpeg',
    png: 'image/png',
    webp: 'image/webp',
    gif: 'image/gif',
    heic: 'image/heic',
    heif: 'image/heif',
    yaml: 'text/yaml',
    yml: 'text/yaml',
    csv: 'text/csv',
    tsv: 'text/tab-separated-values',
    tab: 'text/tab-separated-values',
    avi: 'video/x-msvideo',
    mks: 'video/x-matroska',
    mkv: 'video/x-matroska',
    mov: 'video/quicktime',
    dicom: 'application/dicom',
    doc: 'application/msword',
    docm: 'application/vnd.ms-word.document.macroenabled.12',
    docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    dot: 'application/msword',
    dotm: 'application/vnd.ms-word.template.macroenabled.12',
    dotx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.template',
    xla: 'application/vnd.ms-excel',
    xlam: 'application/vnd.ms-excel.addin.macroenabled.12',
    xlc: 'application/vnd.ms-excel',
    xlf: 'application/x-xliff+xml',
    xlm: 'application/vnd.ms-excel',
    xls: 'application/vnd.ms-excel',
    xlsb: 'application/vnd.ms-excel.sheet.binary.macroenabled.12',
    xlsm: 'application/vnd.ms-excel.sheet.macroenabled.12',
    xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    xlt: 'application/vnd.ms-excel',
    xltm: 'application/vnd.ms-excel.template.macroenabled.12',
    xltx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.template',
    xlw: 'application/vnd.ms-excel',
    txt: 'text/plain',
    text: 'text/plain',
    conf: 'text/plain',
    log: 'text/plain',
    pdf: 'application/pdf',
    zip: 'application/zip',
    '7z': 'application/x-7z-compressed',
    rar: 'application/x-rar-compressed',
    tar: 'application/x-tar',
    gz: 'application/gzip',
    dmg: 'application/x-apple-diskimage'
};


function $d70a5ddc0e61f36b$export$2e2bcd8739ae039(file) {
    var _getFileNameAndExtens;
    if (file.type) return file.type;
    const fileExtension = file.name ? (_getFileNameAndExtens = (0, $09afbe8d004816d5$export$2e2bcd8739ae039)(file.name).extension) == null ? void 0 : _getFileNameAndExtens.toLowerCase() : null;
    if (fileExtension && fileExtension in (0, $92507ee89880573c$export$2e2bcd8739ae039)) // else, see if we can map extension to a mime type
    return (0, $92507ee89880573c$export$2e2bcd8739ae039)[fileExtension];
    // if all fails, fall back to a generic byte stream type
    return 'application/octet-stream';
}




function $d67267bb9859462b$var$encodeCharacter(character) {
    return character.charCodeAt(0).toString(32);
}
function $d67267bb9859462b$var$encodeFilename(name) {
    let suffix = '';
    return name.replace(/[^A-Z0-9]/gi, (character)=>{
        suffix += `-${$d67267bb9859462b$var$encodeCharacter(character)}`;
        return '/';
    }) + suffix;
}
function $d67267bb9859462b$export$2e2bcd8739ae039(file, instanceId) {
    // It's tempting to do `[items].filter(Boolean).join('-')` here, but that
    // is slower! simple string concatenation is fast
    let id = instanceId || 'uppy';
    if (typeof file.name === 'string') id += `-${$d67267bb9859462b$var$encodeFilename(file.name.toLowerCase())}`;
    if (file.type !== undefined) id += `-${file.type}`;
    if (file.meta && typeof file.meta.relativePath === 'string') id += `-${$d67267bb9859462b$var$encodeFilename(file.meta.relativePath.toLowerCase())}`;
    if (file.data.size !== undefined) id += `-${file.data.size}`;
    if (file.data.lastModified !== undefined) id += `-${file.data.lastModified}`;
    return id;
}
// If the provider has a stable, unique ID, then we can use that to identify the file.
// Then we don't have to generate our own ID, and we can add the same file many times if needed (different path)
function $d67267bb9859462b$var$hasFileStableId(file) {
    if (!file.isRemote || !file.remote) return false;
    // These are the providers that it seems like have stable IDs for their files. The other's I haven't checked yet.
    const stableIdProviders = new Set([
        'box',
        'dropbox',
        'drive',
        'facebook',
        'unsplash'
    ]);
    return stableIdProviders.has(file.remote.provider);
}
function $d67267bb9859462b$export$2ff5b23440673856(file, instanceId) {
    if ($d67267bb9859462b$var$hasFileStableId(file)) return file.id;
    const fileType = (0, $d70a5ddc0e61f36b$export$2e2bcd8739ae039)(file);
    return $d67267bb9859462b$export$2e2bcd8739ae039({
        ...file,
        type: fileType
    }, instanceId);
}


// Edge 15.x does not fire 'progress' events on uploads.
// See https://github.com/transloadit/uppy/issues/945
// And https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/12224510/
function $d0281443a9bf1cf1$export$2e2bcd8739ae039(userAgent) {
    // Allow passing in userAgent for tests
    if (userAgent == null && typeof navigator !== 'undefined') // eslint-disable-next-line no-param-reassign
    userAgent = navigator.userAgent;
    // Assume it works because basically everything supports progress events.
    if (!userAgent) return true;
    const m = /Edge\/(\d+\.\d+)/.exec(userAgent);
    if (!m) return true;
    const edgeVersion = m[1];
    const version = edgeVersion.split('.', 2);
    const major = parseInt(version[0], 10);
    const minor = parseInt(version[1], 10);
    // Worked before:
    // Edge 40.15063.0.0
    // Microsoft EdgeHTML 15.15063
    if (major < 15 || major === 15 && minor < 15063) return true;
    // Fixed in:
    // Microsoft EdgeHTML 18.18218
    if (major > 18 || major === 18 && minor >= 18218) return true;
    // other versions don't work.
    return false;
}


function $77bbd1edc6b4e0f3$export$2e2bcd8739ae039(fileType, fileDescriptor) {
    if (fileDescriptor.name) return fileDescriptor.name;
    if (fileType.split('/')[0] === 'image') return `${fileType.split('/')[0]}.${fileType.split('/')[1]}`;
    return 'noname';
}


/* eslint-disable no-console */ /**
 * Adds zero to strings shorter than two characters.
 */ function $cd89119ba1e2ad9d$var$pad(number) {
    return number < 10 ? `0${number}` : number.toString();
}
function $cd89119ba1e2ad9d$export$2e2bcd8739ae039() {
    const date = new Date();
    const hours = $cd89119ba1e2ad9d$var$pad(date.getHours());
    const minutes = $cd89119ba1e2ad9d$var$pad(date.getMinutes());
    const seconds = $cd89119ba1e2ad9d$var$pad(date.getSeconds());
    return `${hours}:${minutes}:${seconds}`;
}


// Swallow all logs, except errors.
// default if logger is not set or debug: false
const $b03b26a8a191c595$export$51086a57eba987c9 = {
    debug: ()=>{},
    warn: ()=>{},
    error: function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return console.error(`[Uppy] [${(0, $cd89119ba1e2ad9d$export$2e2bcd8739ae039)()}]`, ...args);
    }
};
// Print logs to console with namespace + timestamp,
// set by logger: Uppy.debugLogger or debug: true
const $b03b26a8a191c595$export$e6a390ea6399b7d8 = {
    debug: function() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return console.debug(`[Uppy] [${(0, $cd89119ba1e2ad9d$export$2e2bcd8739ae039)()}]`, ...args);
    },
    warn: function() {
        for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
        return console.warn(`[Uppy] [${(0, $cd89119ba1e2ad9d$export$2e2bcd8739ae039)()}]`, ...args);
    },
    error: function() {
        for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
        return console.error(`[Uppy] [${(0, $cd89119ba1e2ad9d$export$2e2bcd8739ae039)()}]`, ...args);
    }
};


/* eslint-disable @typescript-eslint/ban-ts-comment */ /* eslint-disable max-classes-per-file, class-methods-use-this */ var $06e80194017bcce5$exports = {};
"use strict";
$06e80194017bcce5$exports = function prettierBytes(input) {
    if (typeof input !== 'number' || Number.isNaN(input)) throw new TypeError(`Expected a number, got ${typeof input}`);
    const neg = input < 0;
    let num = Math.abs(input);
    if (neg) num = -num;
    if (num === 0) return '0 B';
    const units = [
        'B',
        'KB',
        'MB',
        'GB',
        'TB',
        'PB',
        'EB',
        'ZB',
        'YB'
    ];
    const exponent = Math.min(Math.floor(Math.log(num) / Math.log(1024)), units.length - 1);
    const value = Number(num / 1024 ** exponent);
    const unit = units[exponent];
    return `${value >= 10 || value % 1 === 0 ? Math.round(value) : value.toFixed(1)} ${unit}`;
};


var $34b5d77a3aae6147$exports = {};
var $bf27c8b296b096af$exports = {};
/* jshint node: true */ 'use strict';
/**
  # wildcard

  Very simple wildcard matching, which is designed to provide the same
  functionality that is found in the
  [eve](https://github.com/adobe-webplatform/eve) eventing library.

  ## Usage

  It works with strings:

  <<< examples/strings.js

  Arrays:

  <<< examples/arrays.js

  Objects (matching against keys):

  <<< examples/objects.js

  While the library works in Node, if you are are looking for file-based
  wildcard matching then you should have a look at:

  <https://github.com/isaacs/node-glob>
**/ function $bf27c8b296b096af$var$WildcardMatcher(text, separator) {
    this.text = text = text || '';
    this.hasWild = ~text.indexOf('*');
    this.separator = separator;
    this.parts = text.split(separator);
}
$bf27c8b296b096af$var$WildcardMatcher.prototype.match = function(input) {
    var matches = true;
    var parts = this.parts;
    var ii;
    var partsCount = parts.length;
    var testParts;
    if (typeof input == 'string' || input instanceof String) {
        if (!this.hasWild && this.text != input) matches = false;
        else {
            testParts = (input || '').split(this.separator);
            for(ii = 0; matches && ii < partsCount; ii++){
                if (parts[ii] === '*') continue;
                else if (ii < testParts.length) matches = parts[ii] === testParts[ii];
                else matches = false;
            }
            // If matches, then return the component parts
            matches = matches && testParts;
        }
    } else if (typeof input.splice == 'function') {
        matches = [];
        for(ii = input.length; ii--;)if (this.match(input[ii])) matches[matches.length] = input[ii];
    } else if (typeof input == 'object') {
        matches = {};
        for(var key in input)if (this.match(key)) matches[key] = input[key];
    }
    return matches;
};
$bf27c8b296b096af$exports = function(text, test, separator) {
    var matcher = new $bf27c8b296b096af$var$WildcardMatcher(text, separator || /[\/\.]/);
    if (typeof test != 'undefined') return matcher.match(test);
    return matcher;
};


var $34b5d77a3aae6147$var$reMimePartSplit = /[\/\+\.]/;
/**
  # mime-match

  A simple function to checker whether a target mime type matches a mime-type
  pattern (e.g. image/jpeg matches image/jpeg OR image/*).

  ## Example Usage

  <<< example.js

**/ $34b5d77a3aae6147$exports = function(target, pattern) {
    function test(pattern) {
        var result = $bf27c8b296b096af$exports(pattern, target, $34b5d77a3aae6147$var$reMimePartSplit);
        // ensure that we have a valid mime type (should have two parts)
        return result && result.length >= 2;
    }
    return pattern ? test(pattern.split(';')[0]) : test;
};


/**
 * The minimal required properties to be present from UppyFile in order to validate it.
 */ const $3044940369c0f03d$export$ba43bf67f3d48107 = {
    maxFileSize: null,
    minFileSize: null,
    maxTotalFileSize: null,
    maxNumberOfFiles: null,
    minNumberOfFiles: null,
    allowedFileTypes: null,
    requiredMetaFields: []
};
class $3044940369c0f03d$export$e4d147272ce048a7 extends Error {
    constructor(message, opts){
        var _opts$isUserFacing;
        super(message);
        this.isRestriction = true;
        this.isUserFacing = (_opts$isUserFacing = opts == null ? void 0 : opts.isUserFacing) != null ? _opts$isUserFacing : true;
        if (opts != null && opts.file) this.file = opts.file; // only some restriction errors are related to a particular file
    }
}
class $3044940369c0f03d$export$c464a380a24dd3b8 {
    constructor(getOpts, getI18n){
        this.getI18n = getI18n;
        this.getOpts = ()=>{
            var _opts$restrictions;
            const opts = getOpts();
            if (((_opts$restrictions = opts.restrictions) == null ? void 0 : _opts$restrictions.allowedFileTypes) != null && !Array.isArray(opts.restrictions.allowedFileTypes)) throw new TypeError('`restrictions.allowedFileTypes` must be an array');
            return opts;
        };
    }
    // Because these operations are slow, we cannot run them for every file (if we are adding multiple files)
    validateAggregateRestrictions(existingFiles, addingFiles) {
        const { maxTotalFileSize: maxTotalFileSize, maxNumberOfFiles: maxNumberOfFiles } = this.getOpts().restrictions;
        if (maxNumberOfFiles) {
            const nonGhostFiles = existingFiles.filter((f)=>!f.isGhost);
            if (nonGhostFiles.length + addingFiles.length > maxNumberOfFiles) throw new $3044940369c0f03d$export$e4d147272ce048a7(`${this.getI18n()('youCanOnlyUploadX', {
                smart_count: maxNumberOfFiles
            })}`);
        }
        if (maxTotalFileSize) {
            const totalFilesSize = [
                ...existingFiles,
                ...addingFiles
            ].reduce((total, f)=>{
                var _f$size;
                return total + ((_f$size = f.size) != null ? _f$size : 0);
            }, 0);
            if (totalFilesSize > maxTotalFileSize) throw new $3044940369c0f03d$export$e4d147272ce048a7(this.getI18n()('aggregateExceedsSize', {
                sizeAllowed: (0, (/*@__PURE__*/$parcel$interopDefault($06e80194017bcce5$exports)))(maxTotalFileSize),
                size: (0, (/*@__PURE__*/$parcel$interopDefault($06e80194017bcce5$exports)))(totalFilesSize)
            }));
        }
    }
    validateSingleFile(file) {
        const { maxFileSize: maxFileSize, minFileSize: minFileSize, allowedFileTypes: allowedFileTypes } = this.getOpts().restrictions;
        if (allowedFileTypes) {
            const isCorrectFileType = allowedFileTypes.some((type)=>{
                // check if this is a mime-type
                if (type.includes('/')) {
                    if (!file.type) return false;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($34b5d77a3aae6147$exports)))(file.type.replace(/;.*?$/, ''), type);
                }
                // otherwise this is likely an extension
                if (type[0] === '.' && file.extension) return file.extension.toLowerCase() === type.slice(1).toLowerCase();
                return false;
            });
            if (!isCorrectFileType) {
                const allowedFileTypesString = allowedFileTypes.join(', ');
                throw new $3044940369c0f03d$export$e4d147272ce048a7(this.getI18n()('youCanOnlyUploadFileTypes', {
                    types: allowedFileTypesString
                }), {
                    file: file
                });
            }
        }
        // We can't check maxFileSize if the size is unknown.
        if (maxFileSize && file.size != null && file.size > maxFileSize) throw new $3044940369c0f03d$export$e4d147272ce048a7(this.getI18n()('exceedsSize', {
            size: (0, (/*@__PURE__*/$parcel$interopDefault($06e80194017bcce5$exports)))(maxFileSize),
            file: file.name
        }), {
            file: file
        });
        // We can't check minFileSize if the size is unknown.
        if (minFileSize && file.size != null && file.size < minFileSize) throw new $3044940369c0f03d$export$e4d147272ce048a7(this.getI18n()('inferiorSize', {
            size: (0, (/*@__PURE__*/$parcel$interopDefault($06e80194017bcce5$exports)))(minFileSize)
        }), {
            file: file
        });
    }
    validate(existingFiles, addingFiles) {
        addingFiles.forEach((addingFile)=>{
            this.validateSingleFile(addingFile);
        });
        this.validateAggregateRestrictions(existingFiles, addingFiles);
    }
    validateMinNumberOfFiles(files) {
        const { minNumberOfFiles: minNumberOfFiles } = this.getOpts().restrictions;
        if (minNumberOfFiles && Object.keys(files).length < minNumberOfFiles) throw new $3044940369c0f03d$export$e4d147272ce048a7(this.getI18n()('youHaveToAtLeastSelectX', {
            smart_count: minNumberOfFiles
        }));
    }
    getMissingRequiredMetaFields(file) {
        const error = new $3044940369c0f03d$export$e4d147272ce048a7(this.getI18n()('missingRequiredMetaFieldOnFile', {
            fileName: file.name
        }));
        const { requiredMetaFields: requiredMetaFields } = this.getOpts().restrictions;
        const missingFields = [];
        for (const field of requiredMetaFields)if (!Object.hasOwn(file.meta, field) || file.meta[field] === '') missingFields.push(field);
        return {
            missingFields: missingFields,
            error: error
        };
    }
}


var $721644b39e57ffe9$export$2e2bcd8739ae039 = {
    strings: {
        addBulkFilesFailed: {
            0: 'Failed to add %{smart_count} file due to an internal error',
            1: 'Failed to add %{smart_count} files due to internal errors'
        },
        youCanOnlyUploadX: {
            0: 'You can only upload %{smart_count} file',
            1: 'You can only upload %{smart_count} files'
        },
        youHaveToAtLeastSelectX: {
            0: 'You have to select at least %{smart_count} file',
            1: 'You have to select at least %{smart_count} files'
        },
        aggregateExceedsSize: 'You selected %{size} of files, but maximum allowed size is %{sizeAllowed}',
        exceedsSize: '%{file} exceeds maximum allowed size of %{size}',
        missingRequiredMetaField: 'Missing required meta fields',
        missingRequiredMetaFieldOnFile: 'Missing required meta fields in %{fileName}',
        inferiorSize: 'This file is smaller than the allowed size of %{size}',
        youCanOnlyUploadFileTypes: 'You can only upload: %{types}',
        noMoreFilesAllowed: 'Cannot add more files',
        noDuplicates: "Cannot add the duplicate file '%{fileName}', it already exists",
        companionError: 'Connection with Companion failed',
        authAborted: 'Authentication aborted',
        companionUnauthorizeHint: 'To unauthorize to your %{provider} account, please go to %{url}',
        failedToUpload: 'Failed to upload %{file}',
        noInternetConnection: 'No Internet connection',
        connectedToInternet: 'Connected to the Internet',
        // Strings for remote providers
        noFilesFound: 'You have no files or folders here',
        noSearchResults: 'Unfortunately, there are no results for this search',
        selectX: {
            0: 'Select %{smart_count}',
            1: 'Select %{smart_count}'
        },
        allFilesFromFolderNamed: 'All files from folder %{name}',
        openFolderNamed: 'Open folder %{name}',
        cancel: 'Cancel',
        logOut: 'Log out',
        filter: 'Filter',
        resetFilter: 'Reset filter',
        loading: 'Loading...',
        loadedXFiles: 'Loaded %{numFiles} files',
        authenticateWithTitle: 'Please authenticate with %{pluginName} to select files',
        authenticateWith: 'Connect to %{pluginName}',
        signInWithGoogle: 'Sign in with Google',
        searchImages: 'Search for images',
        enterTextToSearch: 'Enter text to search for images',
        search: 'Search',
        resetSearch: 'Reset search',
        emptyFolderAdded: 'No files were added from empty folder',
        addedNumFiles: 'Added %{numFiles} file(s)',
        folderAlreadyAdded: 'The folder "%{folder}" was already added',
        folderAdded: {
            0: 'Added %{smart_count} file from %{folder}',
            1: 'Added %{smart_count} files from %{folder}'
        },
        additionalRestrictionsFailed: '%{count} additional restrictions were not fulfilled',
        unnamed: 'Unnamed'
    }
};


let $b16b91c7840d3bff$var$_Symbol$for, $b16b91c7840d3bff$var$_Symbol$for2;
function $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(receiver, privateKey) {
    if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) throw new TypeError("attempted to use private field on non-instance");
    return receiver;
}
var $b16b91c7840d3bff$var$id = 0;
function $b16b91c7840d3bff$var$_classPrivateFieldLooseKey(name) {
    return "__private_" + $b16b91c7840d3bff$var$id++ + "_" + name;
}
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore We don't want TS to generate types for the package.json
const $b16b91c7840d3bff$var$packageJson = {
    "version": "3.13.1"
};
/*
 * UnknownProviderPlugin can be any Companion plugin (such as Google Drive).
 * As the plugins are passed around throughout Uppy we need a generic type for this.
 * It may seems like duplication, but this type safe. Changing the type of `storage`
 * will error in the `Provider` class of @uppy/companion-client and vice versa.
 *
 * Note that this is the *plugin* class, not a version of the `Provider` class.
 * `Provider` does operate on Companion plugins with `uppy.getPlugin()`.
 */ /*
 * UnknownSearchProviderPlugin can be any search Companion plugin (such as Unsplash).
 * As the plugins are passed around throughout Uppy we need a generic type for this.
 * It may seems like duplication, but this type safe. Changing the type of `title`
 * will error in the `SearchProvider` class of @uppy/companion-client and vice versa.
 *
 * Note that this is the *plugin* class, not a version of the `SearchProvider` class.
 * `SearchProvider` does operate on Companion plugins with `uppy.getPlugin()`.
 */ // TODO: can we use namespaces in other plugins to populate this?
// eslint-disable-next-line @typescript-eslint/no-empty-interface
// The user facing type for UppyOptions used in uppy.setOptions()
/** @deprecated */ const $b16b91c7840d3bff$var$defaultUploadState = {
    totalProgress: 0,
    allowNewUpload: true,
    error: null,
    recoveredState: null
};
/**
 * Uppy Core module.
 * Manages plugins, state updates, acts as an event bus,
 * adds/removes files and metadata.
 */ var $b16b91c7840d3bff$var$_plugins = /*#__PURE__*/ $b16b91c7840d3bff$var$_classPrivateFieldLooseKey("plugins");
var $b16b91c7840d3bff$var$_restricter = /*#__PURE__*/ $b16b91c7840d3bff$var$_classPrivateFieldLooseKey("restricter");
var $b16b91c7840d3bff$var$_storeUnsubscribe = /*#__PURE__*/ $b16b91c7840d3bff$var$_classPrivateFieldLooseKey("storeUnsubscribe");
var $b16b91c7840d3bff$var$_emitter = /*#__PURE__*/ $b16b91c7840d3bff$var$_classPrivateFieldLooseKey("emitter");
var $b16b91c7840d3bff$var$_preProcessors = /*#__PURE__*/ $b16b91c7840d3bff$var$_classPrivateFieldLooseKey("preProcessors");
var $b16b91c7840d3bff$var$_uploaders = /*#__PURE__*/ $b16b91c7840d3bff$var$_classPrivateFieldLooseKey("uploaders");
var $b16b91c7840d3bff$var$_postProcessors = /*#__PURE__*/ $b16b91c7840d3bff$var$_classPrivateFieldLooseKey("postProcessors");
var $b16b91c7840d3bff$var$_informAndEmit = /*#__PURE__*/ $b16b91c7840d3bff$var$_classPrivateFieldLooseKey("informAndEmit");
var $b16b91c7840d3bff$var$_checkRequiredMetaFieldsOnFile = /*#__PURE__*/ $b16b91c7840d3bff$var$_classPrivateFieldLooseKey("checkRequiredMetaFieldsOnFile");
var $b16b91c7840d3bff$var$_checkRequiredMetaFields = /*#__PURE__*/ $b16b91c7840d3bff$var$_classPrivateFieldLooseKey("checkRequiredMetaFields");
var $b16b91c7840d3bff$var$_assertNewUploadAllowed = /*#__PURE__*/ $b16b91c7840d3bff$var$_classPrivateFieldLooseKey("assertNewUploadAllowed");
var $b16b91c7840d3bff$var$_transformFile = /*#__PURE__*/ $b16b91c7840d3bff$var$_classPrivateFieldLooseKey("transformFile");
var $b16b91c7840d3bff$var$_startIfAutoProceed = /*#__PURE__*/ $b16b91c7840d3bff$var$_classPrivateFieldLooseKey("startIfAutoProceed");
var $b16b91c7840d3bff$var$_checkAndUpdateFileState = /*#__PURE__*/ $b16b91c7840d3bff$var$_classPrivateFieldLooseKey("checkAndUpdateFileState");
var $b16b91c7840d3bff$var$_addListeners = /*#__PURE__*/ $b16b91c7840d3bff$var$_classPrivateFieldLooseKey("addListeners");
var $b16b91c7840d3bff$var$_updateOnlineStatus = /*#__PURE__*/ $b16b91c7840d3bff$var$_classPrivateFieldLooseKey("updateOnlineStatus");
var $b16b91c7840d3bff$var$_requestClientById = /*#__PURE__*/ $b16b91c7840d3bff$var$_classPrivateFieldLooseKey("requestClientById");
var $b16b91c7840d3bff$var$_createUpload = /*#__PURE__*/ $b16b91c7840d3bff$var$_classPrivateFieldLooseKey("createUpload");
var $b16b91c7840d3bff$var$_getUpload = /*#__PURE__*/ $b16b91c7840d3bff$var$_classPrivateFieldLooseKey("getUpload");
var $b16b91c7840d3bff$var$_removeUpload = /*#__PURE__*/ $b16b91c7840d3bff$var$_classPrivateFieldLooseKey("removeUpload");
var $b16b91c7840d3bff$var$_runUpload = /*#__PURE__*/ $b16b91c7840d3bff$var$_classPrivateFieldLooseKey("runUpload");
$b16b91c7840d3bff$var$_Symbol$for = Symbol.for('uppy test: getPlugins');
$b16b91c7840d3bff$var$_Symbol$for2 = Symbol.for('uppy test: createUpload');
class $b16b91c7840d3bff$export$1c95bea2669f592b {
    /**
   * Instantiate Uppy
   */ constructor(_opts){
        /**
     * Run an upload. This picks up where it left off in case the upload is being restored.
     */ Object.defineProperty(this, $b16b91c7840d3bff$var$_runUpload, {
            value: $b16b91c7840d3bff$var$_runUpload2
        });
        /**
     * Remove an upload, eg. if it has been canceled or completed.
     *
     */ Object.defineProperty(this, $b16b91c7840d3bff$var$_removeUpload, {
            value: $b16b91c7840d3bff$var$_removeUpload2
        });
        Object.defineProperty(this, $b16b91c7840d3bff$var$_getUpload, {
            value: $b16b91c7840d3bff$var$_getUpload2
        });
        /**
     * Create an upload for a bunch of files.
     *
     */ Object.defineProperty(this, $b16b91c7840d3bff$var$_createUpload, {
            value: $b16b91c7840d3bff$var$_createUpload2
        });
        /**
     * Registers listeners for all global actions, like:
     * `error`, `file-removed`, `upload-progress`
     */ Object.defineProperty(this, $b16b91c7840d3bff$var$_addListeners, {
            value: $b16b91c7840d3bff$var$_addListeners2
        });
        Object.defineProperty(this, $b16b91c7840d3bff$var$_checkAndUpdateFileState, {
            value: $b16b91c7840d3bff$var$_checkAndUpdateFileState2
        });
        // Schedule an upload if `autoProceed` is enabled.
        Object.defineProperty(this, $b16b91c7840d3bff$var$_startIfAutoProceed, {
            value: $b16b91c7840d3bff$var$_startIfAutoProceed2
        });
        /**
     * Create a file state object based on user-provided `addFile()` options.
     */ Object.defineProperty(this, $b16b91c7840d3bff$var$_transformFile, {
            value: $b16b91c7840d3bff$var$_transformFile2
        });
        Object.defineProperty(this, $b16b91c7840d3bff$var$_assertNewUploadAllowed, {
            value: $b16b91c7840d3bff$var$_assertNewUploadAllowed2
        });
        Object.defineProperty(this, $b16b91c7840d3bff$var$_checkRequiredMetaFields, {
            value: $b16b91c7840d3bff$var$_checkRequiredMetaFields2
        });
        Object.defineProperty(this, $b16b91c7840d3bff$var$_checkRequiredMetaFieldsOnFile, {
            value: $b16b91c7840d3bff$var$_checkRequiredMetaFieldsOnFile2
        });
        Object.defineProperty(this, $b16b91c7840d3bff$var$_informAndEmit, {
            value: $b16b91c7840d3bff$var$_informAndEmit2
        });
        Object.defineProperty(this, $b16b91c7840d3bff$var$_plugins, {
            writable: true,
            value: Object.create(null)
        });
        Object.defineProperty(this, $b16b91c7840d3bff$var$_restricter, {
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, $b16b91c7840d3bff$var$_storeUnsubscribe, {
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, $b16b91c7840d3bff$var$_emitter, {
            writable: true,
            value: (0, (/*@__PURE__*/$parcel$interopDefault($1713863f3a962559$exports)))()
        });
        Object.defineProperty(this, $b16b91c7840d3bff$var$_preProcessors, {
            writable: true,
            value: new Set()
        });
        Object.defineProperty(this, $b16b91c7840d3bff$var$_uploaders, {
            writable: true,
            value: new Set()
        });
        Object.defineProperty(this, $b16b91c7840d3bff$var$_postProcessors, {
            writable: true,
            value: new Set()
        });
        this.scheduledAutoProceed = null;
        this.wasOffline = false;
        // ___Why throttle at 500ms?
        //    - We must throttle at >250ms for superfocus in Dashboard to work well
        //    (because animation takes 0.25s, and we want to wait for all animations to be over before refocusing).
        //    [Practical Check]: if thottle is at 100ms, then if you are uploading a file,
        //    and click 'ADD MORE FILES', - focus won't activate in Firefox.
        //    - We must throttle at around >500ms to avoid performance lags.
        //    [Practical Check] Firefox, try to upload a big file for a prolonged period of time. Laptop will start to heat up.
        // todo when uploading multiple files, this will cause problems because they share the same throttle,
        // meaning some files might never get their progress reported (eaten up by progress events from other files)
        this.calculateProgress = (0, (/*@__PURE__*/$parcel$interopDefault($a50c1ad1c2867517$exports)))((file, data)=>{
            const fileInState = this.getFile(file == null ? void 0 : file.id);
            if (file == null || !fileInState) {
                this.log(`Not setting progress for a file that has been removed: ${file == null ? void 0 : file.id}`);
                return;
            }
            if (fileInState.progress.percentage === 100) {
                this.log(`Not setting progress for a file that has been already uploaded: ${file.id}`);
                return;
            }
            // bytesTotal may be null or zero; in that case we can't divide by it
            const canHavePercentage = Number.isFinite(data.bytesTotal) && data.bytesTotal > 0;
            this.setFileState(file.id, {
                progress: {
                    ...fileInState.progress,
                    bytesUploaded: data.bytesUploaded,
                    bytesTotal: data.bytesTotal,
                    percentage: canHavePercentage ? Math.round(data.bytesUploaded / data.bytesTotal * 100) : 0
                }
            });
            this.calculateTotalProgress();
        }, 500, {
            leading: true,
            trailing: true
        });
        Object.defineProperty(this, $b16b91c7840d3bff$var$_updateOnlineStatus, {
            writable: true,
            value: this.updateOnlineStatus.bind(this)
        });
        // We need to store request clients by a unique ID, so we can share RequestClient instances across files
        // this allows us to do rate limiting and synchronous operations like refreshing provider tokens
        // example: refreshing tokens: if each file has their own requestclient,
        // we don't have any way to synchronize all requests in order to
        // - block all requests
        // - refresh the token
        // - unblock all requests and allow them to run with a the new access token
        // back when we had a requestclient per file, once an access token expired,
        // all 6 files would go ahead and refresh the token at the same time
        // (calling /refresh-token up to 6 times), which will probably fail for some providers
        Object.defineProperty(this, $b16b91c7840d3bff$var$_requestClientById, {
            writable: true,
            value: new Map()
        });
        this.defaultLocale = (0, $721644b39e57ffe9$export$2e2bcd8739ae039);
        const defaultOptions = {
            id: 'uppy',
            autoProceed: false,
            allowMultipleUploadBatches: true,
            debug: false,
            restrictions: (0, $3044940369c0f03d$export$ba43bf67f3d48107),
            meta: {},
            onBeforeFileAdded: (file, files)=>!Object.hasOwn(files, file.id),
            onBeforeUpload: (files)=>files,
            store: new (0, $f790bad313c52a0f$export$2e2bcd8739ae039)(),
            logger: (0, $b03b26a8a191c595$export$51086a57eba987c9),
            infoTimeout: 5000
        };
        const merged = {
            ...defaultOptions,
            ..._opts
        };
        // Merge default options with the ones set by user,
        // making sure to merge restrictions too
        this.opts = {
            ...merged,
            restrictions: {
                ...defaultOptions.restrictions,
                ..._opts && _opts.restrictions
            }
        };
        // Support debug: true for backwards-compatability, unless logger is set in opts
        // opts instead of this.opts to avoid comparing objects — we set logger: justErrorsLogger in defaultOptions
        if (_opts && _opts.logger && _opts.debug) this.log('You are using a custom `logger`, but also set `debug: true`, which uses built-in logger to output logs to console. Ignoring `debug: true` and using your custom `logger`.', 'warning');
        else if (_opts && _opts.debug) this.opts.logger = (0, $b03b26a8a191c595$export$e6a390ea6399b7d8);
        this.log(`Using Core v${$b16b91c7840d3bff$export$1c95bea2669f592b.VERSION}`);
        this.i18nInit();
        this.store = this.opts.store;
        this.setState({
            ...$b16b91c7840d3bff$var$defaultUploadState,
            plugins: {},
            files: {},
            currentUploads: {},
            capabilities: {
                uploadProgress: (0, $d0281443a9bf1cf1$export$2e2bcd8739ae039)(),
                individualCancellation: true,
                resumableUploads: false
            },
            meta: {
                ...this.opts.meta
            },
            info: []
        });
        $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_restricter)[$b16b91c7840d3bff$var$_restricter] = new (0, $3044940369c0f03d$export$c464a380a24dd3b8)(()=>this.opts, ()=>this.i18n);
        $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_storeUnsubscribe)[$b16b91c7840d3bff$var$_storeUnsubscribe] = this.store.subscribe(// eslint-disable-next-line
        // @ts-ignore Store is incorrectly typed
        (prevState, nextState, patch)=>{
            // eslint-disable-next-line
            // @ts-ignore Store is incorrectly typed
            this.emit('state-update', prevState, nextState, patch);
            this.updateAll(nextState);
        });
        // Exposing uppy object on window for debugging and testing
        if (this.opts.debug && typeof window !== 'undefined') // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore Mutating the global object for debug purposes
        window[this.opts.id] = this;
        $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_addListeners)[$b16b91c7840d3bff$var$_addListeners]();
    }
    emit(event) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_emitter)[$b16b91c7840d3bff$var$_emitter].emit(event, ...args);
    }
    on(event, callback) {
        $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_emitter)[$b16b91c7840d3bff$var$_emitter].on(event, callback);
        return this;
    }
    once(event, callback) {
        $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_emitter)[$b16b91c7840d3bff$var$_emitter].once(event, callback);
        return this;
    }
    off(event, callback) {
        $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_emitter)[$b16b91c7840d3bff$var$_emitter].off(event, callback);
        return this;
    }
    /**
   * Iterate on all plugins and run `update` on them.
   * Called each time state changes.
   *
   */ updateAll(state) {
        this.iteratePlugins((plugin)=>{
            plugin.update(state);
        });
    }
    /**
   * Updates state with a patch
   */ setState(patch) {
        // eslint-disable-next-line
        // @ts-ignore Store is incorrectly typed
        this.store.setState(patch);
    }
    /**
   * Returns current state.
   */ getState() {
        // eslint-disable-next-line
        // @ts-ignore Store is incorrectly typed
        return this.store.getState();
    }
    patchFilesState(filesWithNewState) {
        const existingFilesState = this.getState().files;
        this.setState({
            files: {
                ...existingFilesState,
                ...Object.fromEntries(Object.entries(filesWithNewState).map((_ref)=>{
                    let [fileID, newFileState] = _ref;
                    return [
                        fileID,
                        {
                            ...existingFilesState[fileID],
                            ...newFileState
                        }
                    ];
                }))
            }
        });
    }
    /**
   * Shorthand to set state for a specific file.
   */ setFileState(fileID, state) {
        if (!this.getState().files[fileID]) throw new Error(`Can\u{2019}t set state for ${fileID} (the file could have been removed)`);
        this.patchFilesState({
            [fileID]: state
        });
    }
    i18nInit() {
        const onMissingKey = (key)=>this.log(`Missing i18n string: ${key}`, 'error');
        const translator = new (0, $a85fd1efd23057e0$export$2e2bcd8739ae039)([
            this.defaultLocale,
            this.opts.locale
        ], {
            onMissingKey: onMissingKey
        });
        this.i18n = translator.translate.bind(translator);
        this.i18nArray = translator.translateArray.bind(translator);
        this.locale = translator.locale;
    }
    setOptions(newOpts) {
        this.opts = {
            ...this.opts,
            ...newOpts,
            restrictions: {
                ...this.opts.restrictions,
                ...newOpts == null ? void 0 : newOpts.restrictions
            }
        };
        if (newOpts.meta) this.setMeta(newOpts.meta);
        this.i18nInit();
        if (newOpts.locale) this.iteratePlugins((plugin)=>{
            plugin.setOptions(newOpts);
        });
        // Note: this is not the preact `setState`, it's an internal function that has the same name.
        this.setState(undefined); // so that UI re-renders with new options
    }
    // todo next major: remove
    resetProgress() {
        const defaultProgress = {
            percentage: 0,
            bytesUploaded: 0,
            uploadComplete: false,
            uploadStarted: null
        };
        const files = {
            ...this.getState().files
        };
        const updatedFiles = {};
        Object.keys(files).forEach((fileID)=>{
            updatedFiles[fileID] = {
                ...files[fileID],
                progress: {
                    ...files[fileID].progress,
                    ...defaultProgress
                }
            };
        });
        this.setState({
            files: updatedFiles,
            ...$b16b91c7840d3bff$var$defaultUploadState
        });
        this.emit('reset-progress');
    }
    // @todo next major: rename to `clear()`, make it also cancel ongoing uploads
    // or throw and say you need to cancel manually
    clearUploadedFiles() {
        const { capabilities: capabilities, currentUploads: currentUploads } = this.getState();
        if (Object.keys(currentUploads).length > 0 && !capabilities.individualCancellation) throw new Error('The installed uploader plugin does not allow removing files during an upload.');
        this.setState({
            ...$b16b91c7840d3bff$var$defaultUploadState,
            files: {}
        });
    }
    addPreProcessor(fn) {
        $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_preProcessors)[$b16b91c7840d3bff$var$_preProcessors].add(fn);
    }
    removePreProcessor(fn) {
        return $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_preProcessors)[$b16b91c7840d3bff$var$_preProcessors].delete(fn);
    }
    addPostProcessor(fn) {
        $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_postProcessors)[$b16b91c7840d3bff$var$_postProcessors].add(fn);
    }
    removePostProcessor(fn) {
        return $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_postProcessors)[$b16b91c7840d3bff$var$_postProcessors].delete(fn);
    }
    addUploader(fn) {
        $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_uploaders)[$b16b91c7840d3bff$var$_uploaders].add(fn);
    }
    removeUploader(fn) {
        return $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_uploaders)[$b16b91c7840d3bff$var$_uploaders].delete(fn);
    }
    setMeta(data) {
        const updatedMeta = {
            ...this.getState().meta,
            ...data
        };
        const updatedFiles = {
            ...this.getState().files
        };
        Object.keys(updatedFiles).forEach((fileID)=>{
            updatedFiles[fileID] = {
                ...updatedFiles[fileID],
                meta: {
                    ...updatedFiles[fileID].meta,
                    ...data
                }
            };
        });
        this.log('Adding metadata:');
        this.log(data);
        this.setState({
            meta: updatedMeta,
            files: updatedFiles
        });
    }
    setFileMeta(fileID, data) {
        const updatedFiles = {
            ...this.getState().files
        };
        if (!updatedFiles[fileID]) {
            this.log('Was trying to set metadata for a file that has been removed: ', fileID);
            return;
        }
        const newMeta = {
            ...updatedFiles[fileID].meta,
            ...data
        };
        updatedFiles[fileID] = {
            ...updatedFiles[fileID],
            meta: newMeta
        };
        this.setState({
            files: updatedFiles
        });
    }
    /**
   * Get a file object.
   */ getFile(fileID) {
        return this.getState().files[fileID];
    }
    /**
   * Get all files in an array.
   */ getFiles() {
        const { files: files } = this.getState();
        return Object.values(files);
    }
    getFilesByIds(ids) {
        return ids.map((id)=>this.getFile(id));
    }
    getObjectOfFilesPerState() {
        const { files: filesObject, totalProgress: totalProgress, error: error } = this.getState();
        const files = Object.values(filesObject);
        const inProgressFiles = [];
        const newFiles = [];
        const startedFiles = [];
        const uploadStartedFiles = [];
        const pausedFiles = [];
        const completeFiles = [];
        const erroredFiles = [];
        const inProgressNotPausedFiles = [];
        const processingFiles = [];
        for (const file of files){
            const { progress: progress } = file;
            if (!progress.uploadComplete && progress.uploadStarted) {
                inProgressFiles.push(file);
                if (!file.isPaused) inProgressNotPausedFiles.push(file);
            }
            if (!progress.uploadStarted) newFiles.push(file);
            if (progress.uploadStarted || progress.preprocess || progress.postprocess) startedFiles.push(file);
            if (progress.uploadStarted) uploadStartedFiles.push(file);
            if (file.isPaused) pausedFiles.push(file);
            if (progress.uploadComplete) completeFiles.push(file);
            if (file.error) erroredFiles.push(file);
            if (progress.preprocess || progress.postprocess) processingFiles.push(file);
        }
        return {
            newFiles: newFiles,
            startedFiles: startedFiles,
            uploadStartedFiles: uploadStartedFiles,
            pausedFiles: pausedFiles,
            completeFiles: completeFiles,
            erroredFiles: erroredFiles,
            inProgressFiles: inProgressFiles,
            inProgressNotPausedFiles: inProgressNotPausedFiles,
            processingFiles: processingFiles,
            isUploadStarted: uploadStartedFiles.length > 0,
            isAllComplete: totalProgress === 100 && completeFiles.length === files.length && processingFiles.length === 0,
            isAllErrored: !!error && erroredFiles.length === files.length,
            isAllPaused: inProgressFiles.length !== 0 && pausedFiles.length === inProgressFiles.length,
            isUploadInProgress: inProgressFiles.length > 0,
            isSomeGhost: files.some((file)=>file.isGhost)
        };
    }
    validateRestrictions(file, files) {
        if (files === void 0) files = this.getFiles();
        try {
            $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_restricter)[$b16b91c7840d3bff$var$_restricter].validate(files, [
                file
            ]);
        } catch (err) {
            return err;
        }
        return null;
    }
    checkIfFileAlreadyExists(fileID) {
        const { files: files } = this.getState();
        if (files[fileID] && !files[fileID].isGhost) return true;
        return false;
    }
    /**
   * Add a new file to `state.files`. This will run `onBeforeFileAdded`,
   * try to guess file type in a clever way, check file against restrictions,
   * and start an upload if `autoProceed === true`.
   */ addFile(file) {
        $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_assertNewUploadAllowed)[$b16b91c7840d3bff$var$_assertNewUploadAllowed](file);
        const { nextFilesState: nextFilesState, validFilesToAdd: validFilesToAdd, errors: errors } = $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_checkAndUpdateFileState)[$b16b91c7840d3bff$var$_checkAndUpdateFileState]([
            file
        ]);
        const restrictionErrors = errors.filter((error)=>error.isRestriction);
        $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_informAndEmit)[$b16b91c7840d3bff$var$_informAndEmit](restrictionErrors);
        if (errors.length > 0) throw errors[0];
        this.setState({
            files: nextFilesState
        });
        const [firstValidFileToAdd] = validFilesToAdd;
        this.emit('file-added', firstValidFileToAdd);
        this.emit('files-added', validFilesToAdd);
        this.log(`Added file: ${firstValidFileToAdd.name}, ${firstValidFileToAdd.id}, mime type: ${firstValidFileToAdd.type}`);
        $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_startIfAutoProceed)[$b16b91c7840d3bff$var$_startIfAutoProceed]();
        return firstValidFileToAdd.id;
    }
    /**
   * Add multiple files to `state.files`. See the `addFile()` documentation.
   *
   * If an error occurs while adding a file, it is logged and the user is notified.
   * This is good for UI plugins, but not for programmatic use.
   * Programmatic users should usually still use `addFile()` on individual files.
   */ addFiles(fileDescriptors) {
        $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_assertNewUploadAllowed)[$b16b91c7840d3bff$var$_assertNewUploadAllowed]();
        const { nextFilesState: nextFilesState, validFilesToAdd: validFilesToAdd, errors: errors } = $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_checkAndUpdateFileState)[$b16b91c7840d3bff$var$_checkAndUpdateFileState](fileDescriptors);
        const restrictionErrors = errors.filter((error)=>error.isRestriction);
        $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_informAndEmit)[$b16b91c7840d3bff$var$_informAndEmit](restrictionErrors);
        const nonRestrictionErrors = errors.filter((error)=>!error.isRestriction);
        if (nonRestrictionErrors.length > 0) {
            let message = 'Multiple errors occurred while adding files:\n';
            nonRestrictionErrors.forEach((subError)=>{
                message += `\n * ${subError.message}`;
            });
            this.info({
                message: this.i18n('addBulkFilesFailed', {
                    smart_count: nonRestrictionErrors.length
                }),
                details: message
            }, 'error', this.opts.infoTimeout);
            if (typeof AggregateError === 'function') throw new AggregateError(nonRestrictionErrors, message);
            else {
                const err = new Error(message);
                // @ts-expect-error fallback when AggregateError is not available
                err.errors = nonRestrictionErrors;
                throw err;
            }
        }
        // OK, we haven't thrown an error, we can start updating state and emitting events now:
        this.setState({
            files: nextFilesState
        });
        validFilesToAdd.forEach((file)=>{
            this.emit('file-added', file);
        });
        this.emit('files-added', validFilesToAdd);
        if (validFilesToAdd.length > 5) this.log(`Added batch of ${validFilesToAdd.length} files`);
        else Object.values(validFilesToAdd).forEach((file)=>{
            this.log(`Added file: ${file.name}\n id: ${file.id}\n type: ${file.type}`);
        });
        if (validFilesToAdd.length > 0) $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_startIfAutoProceed)[$b16b91c7840d3bff$var$_startIfAutoProceed]();
    }
    removeFiles(fileIDs, reason) {
        const { files: files, currentUploads: currentUploads } = this.getState();
        const updatedFiles = {
            ...files
        };
        const updatedUploads = {
            ...currentUploads
        };
        const removedFiles = Object.create(null);
        fileIDs.forEach((fileID)=>{
            if (files[fileID]) {
                removedFiles[fileID] = files[fileID];
                delete updatedFiles[fileID];
            }
        });
        // Remove files from the `fileIDs` list in each upload.
        function fileIsNotRemoved(uploadFileID) {
            return removedFiles[uploadFileID] === undefined;
        }
        Object.keys(updatedUploads).forEach((uploadID)=>{
            const newFileIDs = currentUploads[uploadID].fileIDs.filter(fileIsNotRemoved);
            // Remove the upload if no files are associated with it anymore.
            if (newFileIDs.length === 0) {
                delete updatedUploads[uploadID];
                return;
            }
            const { capabilities: capabilities } = this.getState();
            if (newFileIDs.length !== currentUploads[uploadID].fileIDs.length && !capabilities.individualCancellation) throw new Error('The installed uploader plugin does not allow removing files during an upload.');
            updatedUploads[uploadID] = {
                ...currentUploads[uploadID],
                fileIDs: newFileIDs
            };
        });
        const stateUpdate = {
            currentUploads: updatedUploads,
            files: updatedFiles
        };
        // If all files were removed - allow new uploads,
        // and clear recoveredState
        if (Object.keys(updatedFiles).length === 0) {
            stateUpdate.allowNewUpload = true;
            stateUpdate.error = null;
            stateUpdate.recoveredState = null;
        }
        this.setState(stateUpdate);
        this.calculateTotalProgress();
        const removedFileIDs = Object.keys(removedFiles);
        removedFileIDs.forEach((fileID)=>{
            this.emit('file-removed', removedFiles[fileID], reason);
        });
        if (removedFileIDs.length > 5) this.log(`Removed ${removedFileIDs.length} files`);
        else this.log(`Removed files: ${removedFileIDs.join(', ')}`);
    }
    removeFile(fileID, reason) {
        this.removeFiles([
            fileID
        ], reason);
    }
    pauseResume(fileID) {
        if (!this.getState().capabilities.resumableUploads || this.getFile(fileID).progress.uploadComplete) return undefined;
        const wasPaused = this.getFile(fileID).isPaused || false;
        const isPaused = !wasPaused;
        this.setFileState(fileID, {
            isPaused: isPaused
        });
        this.emit('upload-pause', fileID, isPaused);
        return isPaused;
    }
    pauseAll() {
        const updatedFiles = {
            ...this.getState().files
        };
        const inProgressUpdatedFiles = Object.keys(updatedFiles).filter((file)=>{
            return !updatedFiles[file].progress.uploadComplete && updatedFiles[file].progress.uploadStarted;
        });
        inProgressUpdatedFiles.forEach((file)=>{
            const updatedFile = {
                ...updatedFiles[file],
                isPaused: true
            };
            updatedFiles[file] = updatedFile;
        });
        this.setState({
            files: updatedFiles
        });
        this.emit('pause-all');
    }
    resumeAll() {
        const updatedFiles = {
            ...this.getState().files
        };
        const inProgressUpdatedFiles = Object.keys(updatedFiles).filter((file)=>{
            return !updatedFiles[file].progress.uploadComplete && updatedFiles[file].progress.uploadStarted;
        });
        inProgressUpdatedFiles.forEach((file)=>{
            const updatedFile = {
                ...updatedFiles[file],
                isPaused: false,
                error: null
            };
            updatedFiles[file] = updatedFile;
        });
        this.setState({
            files: updatedFiles
        });
        this.emit('resume-all');
    }
    retryAll() {
        const updatedFiles = {
            ...this.getState().files
        };
        const filesToRetry = Object.keys(updatedFiles).filter((file)=>{
            return updatedFiles[file].error;
        });
        filesToRetry.forEach((file)=>{
            const updatedFile = {
                ...updatedFiles[file],
                isPaused: false,
                error: null
            };
            updatedFiles[file] = updatedFile;
        });
        this.setState({
            files: updatedFiles,
            error: null
        });
        this.emit('retry-all', filesToRetry);
        if (filesToRetry.length === 0) return Promise.resolve({
            successful: [],
            failed: []
        });
        const uploadID = $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_createUpload)[$b16b91c7840d3bff$var$_createUpload](filesToRetry, {
            forceAllowNewUpload: true // create new upload even if allowNewUpload: false
        });
        return $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_runUpload)[$b16b91c7840d3bff$var$_runUpload](uploadID);
    }
    cancelAll(_temp) {
        let { reason: reason = 'user' } = _temp === void 0 ? {} : _temp;
        this.emit('cancel-all', {
            reason: reason
        });
        // Only remove existing uploads if user is canceling
        if (reason === 'user') {
            const { files: files } = this.getState();
            const fileIDs = Object.keys(files);
            if (fileIDs.length) this.removeFiles(fileIDs, 'cancel-all');
            this.setState($b16b91c7840d3bff$var$defaultUploadState);
        // todo should we call this.emit('reset-progress') like we do for resetProgress?
        }
    }
    retryUpload(fileID) {
        this.setFileState(fileID, {
            error: null,
            isPaused: false
        });
        this.emit('upload-retry', fileID);
        const uploadID = $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_createUpload)[$b16b91c7840d3bff$var$_createUpload]([
            fileID
        ], {
            forceAllowNewUpload: true // create new upload even if allowNewUpload: false
        });
        return $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_runUpload)[$b16b91c7840d3bff$var$_runUpload](uploadID);
    }
    logout() {
        this.iteratePlugins((plugin)=>{
            var _provider;
            (_provider = plugin.provider) == null || _provider.logout == null || _provider.logout();
        });
    }
    calculateTotalProgress() {
        // calculate total progress, using the number of files currently uploading,
        // multiplied by 100 and the summ of individual progress of each file
        const files = this.getFiles();
        const inProgress = files.filter((file)=>{
            return file.progress.uploadStarted || file.progress.preprocess || file.progress.postprocess;
        });
        if (inProgress.length === 0) {
            this.emit('progress', 0);
            this.setState({
                totalProgress: 0
            });
            return;
        }
        const sizedFiles = inProgress.filter((file)=>file.progress.bytesTotal != null);
        const unsizedFiles = inProgress.filter((file)=>file.progress.bytesTotal == null);
        if (sizedFiles.length === 0) {
            const progressMax = inProgress.length * 100;
            const currentProgress = unsizedFiles.reduce((acc, file)=>{
                return acc + file.progress.percentage;
            }, 0);
            const totalProgress = Math.round(currentProgress / progressMax * 100);
            this.setState({
                totalProgress: totalProgress
            });
            return;
        }
        let totalSize = sizedFiles.reduce((acc, file)=>{
            var _file$progress$bytesT;
            return acc + ((_file$progress$bytesT = file.progress.bytesTotal) != null ? _file$progress$bytesT : 0);
        }, 0);
        const averageSize = totalSize / sizedFiles.length;
        totalSize += averageSize * unsizedFiles.length;
        let uploadedSize = 0;
        sizedFiles.forEach((file)=>{
            uploadedSize += file.progress.bytesUploaded;
        });
        unsizedFiles.forEach((file)=>{
            uploadedSize += averageSize * (file.progress.percentage || 0) / 100;
        });
        let totalProgress = totalSize === 0 ? 0 : Math.round(uploadedSize / totalSize * 100);
        // hot fix, because:
        // uploadedSize ended up larger than totalSize, resulting in 1325% total
        if (totalProgress > 100) totalProgress = 100;
        this.setState({
            totalProgress: totalProgress
        });
        this.emit('progress', totalProgress);
    }
    updateOnlineStatus() {
        var _window$navigator$onL;
        const online = (_window$navigator$onL = window.navigator.onLine) != null ? _window$navigator$onL : true;
        if (!online) {
            this.emit('is-offline');
            this.info(this.i18n('noInternetConnection'), 'error', 0);
            this.wasOffline = true;
        } else {
            this.emit('is-online');
            if (this.wasOffline) {
                this.emit('back-online');
                this.info(this.i18n('connectedToInternet'), 'success', 3000);
                this.wasOffline = false;
            }
        }
    }
    getID() {
        return this.opts.id;
    }
    /**
   * Registers a plugin with Core.
   */ use(Plugin, opts) {
        if (typeof Plugin !== 'function') {
            const msg = `Expected a plugin class, but got ${Plugin === null ? 'null' : typeof Plugin}.` + ' Please verify that the plugin was imported and spelled correctly.';
            throw new TypeError(msg);
        }
        // Instantiate
        const plugin = new Plugin(this, opts);
        const pluginId = plugin.id;
        if (!pluginId) throw new Error('Your plugin must have an id');
        if (!plugin.type) throw new Error('Your plugin must have a type');
        const existsPluginAlready = this.getPlugin(pluginId);
        if (existsPluginAlready) {
            const msg = `Already found a plugin named '${existsPluginAlready.id}'. ` + `Tried to use: '${pluginId}'.\n` + 'Uppy plugins must have unique `id` options. See https://uppy.io/docs/plugins/#id.';
            throw new Error(msg);
        }
        // @ts-expect-error does exist
        if (Plugin.VERSION) // @ts-expect-error does exist
        this.log(`Using ${pluginId} v${Plugin.VERSION}`);
        if (plugin.type in $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_plugins)[$b16b91c7840d3bff$var$_plugins]) $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_plugins)[$b16b91c7840d3bff$var$_plugins][plugin.type].push(plugin);
        else $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_plugins)[$b16b91c7840d3bff$var$_plugins][plugin.type] = [
            plugin
        ];
        plugin.install();
        this.emit('plugin-added', plugin);
        return this;
    }
    /**
   * Find one Plugin by name.
   */ getPlugin(id) {
        for (const plugins of Object.values($b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_plugins)[$b16b91c7840d3bff$var$_plugins])){
            const foundPlugin = plugins.find((plugin)=>plugin.id === id);
            if (foundPlugin != null) return foundPlugin;
        }
        return undefined;
    }
    [$b16b91c7840d3bff$var$_Symbol$for](type) {
        return $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_plugins)[$b16b91c7840d3bff$var$_plugins][type];
    }
    /**
   * Iterate through all `use`d plugins.
   *
   */ iteratePlugins(method) {
        Object.values($b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_plugins)[$b16b91c7840d3bff$var$_plugins]).flat(1).forEach(method);
    }
    /**
   * Uninstall and remove a plugin.
   *
   * @param {object} instance The plugin instance to remove.
   */ removePlugin(instance) {
        this.log(`Removing plugin ${instance.id}`);
        this.emit('plugin-remove', instance);
        if (instance.uninstall) instance.uninstall();
        const list = $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_plugins)[$b16b91c7840d3bff$var$_plugins][instance.type];
        // list.indexOf failed here, because Vue3 converted the plugin instance
        // to a Proxy object, which failed the strict comparison test:
        // obj !== objProxy
        const index = list.findIndex((item)=>item.id === instance.id);
        if (index !== -1) list.splice(index, 1);
        const state = this.getState();
        const updatedState = {
            plugins: {
                ...state.plugins,
                [instance.id]: undefined
            }
        };
        this.setState(updatedState);
    }
    /**
   * Uninstall all plugins and close down this Uppy instance.
   */ // @todo next major: rename to `destroy`.
    // Cancel local uploads, cancel remote uploads, DON'T cancel assemblies
    // document that if you do want to cancel assemblies, you need to call smth manually.
    // Potentially remove reason, as it’s confusing, just come up with a default behaviour.
    close(_temp2) {
        let { reason: reason } = _temp2 === void 0 ? {} : _temp2;
        this.log(`Closing Uppy instance ${this.opts.id}: removing all files and uninstalling plugins`);
        this.cancelAll({
            reason: reason
        });
        $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_storeUnsubscribe)[$b16b91c7840d3bff$var$_storeUnsubscribe]();
        this.iteratePlugins((plugin)=>{
            this.removePlugin(plugin);
        });
        if (typeof window !== 'undefined' && window.removeEventListener) {
            window.removeEventListener('online', $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_updateOnlineStatus)[$b16b91c7840d3bff$var$_updateOnlineStatus]);
            window.removeEventListener('offline', $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_updateOnlineStatus)[$b16b91c7840d3bff$var$_updateOnlineStatus]);
        }
    }
    hideInfo() {
        const { info: info } = this.getState();
        this.setState({
            info: info.slice(1)
        });
        this.emit('info-hidden');
    }
    /**
   * Set info message in `state.info`, so that UI plugins like `Informer`
   * can display the message.
   */ info(message, type, duration) {
        if (type === void 0) type = 'info';
        if (duration === void 0) duration = 3000;
        const isComplexMessage = typeof message === 'object';
        this.setState({
            info: [
                ...this.getState().info,
                {
                    type: type,
                    message: isComplexMessage ? message.message : message,
                    details: isComplexMessage ? message.details : null
                }
            ]
        });
        setTimeout(()=>this.hideInfo(), duration);
        this.emit('info-visible');
    }
    /**
   * Passes messages to a function, provided in `opts.logger`.
   * If `opts.logger: Uppy.debugLogger` or `opts.debug: true`, logs to the browser console.
   */ log(message, type) {
        const { logger: logger } = this.opts;
        switch(type){
            case 'error':
                logger.error(message);
                break;
            case 'warning':
                logger.warn(message);
                break;
            default:
                logger.debug(message);
                break;
        }
    }
    registerRequestClient(id, client) {
        $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_requestClientById)[$b16b91c7840d3bff$var$_requestClientById].set(id, client);
    }
    /** @protected */ getRequestClientForFile(file) {
        if (!file.remote) throw new Error(`Tried to get RequestClient for a non-remote file ${file.id}`);
        const requestClient = $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_requestClientById)[$b16b91c7840d3bff$var$_requestClientById].get(file.remote.requestClientId);
        if (requestClient == null) throw new Error(`requestClientId "${file.remote.requestClientId}" not registered for file "${file.id}"`);
        return requestClient;
    }
    /**
   * Restore an upload by its ID.
   */ restore(uploadID) {
        this.log(`Core: attempting to restore upload "${uploadID}"`);
        if (!this.getState().currentUploads[uploadID]) {
            $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_removeUpload)[$b16b91c7840d3bff$var$_removeUpload](uploadID);
            return Promise.reject(new Error('Nonexistent upload'));
        }
        return $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_runUpload)[$b16b91c7840d3bff$var$_runUpload](uploadID);
    }
    [$b16b91c7840d3bff$var$_Symbol$for2]() {
        // @ts-expect-error https://github.com/microsoft/TypeScript/issues/47595
        return $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_createUpload)[$b16b91c7840d3bff$var$_createUpload](...arguments);
    }
    /**
   * Add data to an upload's result object.
   */ addResultData(uploadID, data) {
        if (!$b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_getUpload)[$b16b91c7840d3bff$var$_getUpload](uploadID)) {
            this.log(`Not setting result for an upload that has been removed: ${uploadID}`);
            return;
        }
        const { currentUploads: currentUploads } = this.getState();
        const currentUpload = {
            ...currentUploads[uploadID],
            result: {
                ...currentUploads[uploadID].result,
                ...data
            }
        };
        this.setState({
            currentUploads: {
                ...currentUploads,
                [uploadID]: currentUpload
            }
        });
    }
    /**
   * Start an upload for all the files that are not currently being uploaded.
   */ upload() {
        var _classPrivateFieldLoo;
        if (!((_classPrivateFieldLoo = $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_plugins)[$b16b91c7840d3bff$var$_plugins]['uploader']) != null && _classPrivateFieldLoo.length)) this.log('No uploader type plugins are used', 'warning');
        let { files: files } = this.getState();
        const onBeforeUploadResult = this.opts.onBeforeUpload(files);
        if (onBeforeUploadResult === false) return Promise.reject(new Error('Not starting the upload because onBeforeUpload returned false'));
        if (onBeforeUploadResult && typeof onBeforeUploadResult === 'object') {
            files = onBeforeUploadResult;
            // Updating files in state, because uploader plugins receive file IDs,
            // and then fetch the actual file object from state
            this.setState({
                files: files
            });
        }
        return Promise.resolve().then(()=>$b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_restricter)[$b16b91c7840d3bff$var$_restricter].validateMinNumberOfFiles(files)).catch((err)=>{
            $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_informAndEmit)[$b16b91c7840d3bff$var$_informAndEmit]([
                err
            ]);
            throw err;
        }).then(()=>{
            if (!$b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_checkRequiredMetaFields)[$b16b91c7840d3bff$var$_checkRequiredMetaFields](files)) throw new (0, $3044940369c0f03d$export$e4d147272ce048a7)(this.i18n('missingRequiredMetaField'));
        }).catch((err)=>{
            // Doing this in a separate catch because we already emited and logged
            // all the errors in `checkRequiredMetaFields` so we only throw a generic
            // missing fields error here.
            throw err;
        }).then(()=>{
            const { currentUploads: currentUploads } = this.getState();
            // get a list of files that are currently assigned to uploads
            const currentlyUploadingFiles = Object.values(currentUploads).flatMap((curr)=>curr.fileIDs);
            const waitingFileIDs = [];
            Object.keys(files).forEach((fileID)=>{
                const file = this.getFile(fileID);
                // if the file hasn't started uploading and hasn't already been assigned to an upload..
                if (!file.progress.uploadStarted && currentlyUploadingFiles.indexOf(fileID) === -1) waitingFileIDs.push(file.id);
            });
            const uploadID = $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_createUpload)[$b16b91c7840d3bff$var$_createUpload](waitingFileIDs);
            return $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_runUpload)[$b16b91c7840d3bff$var$_runUpload](uploadID);
        }).catch((err)=>{
            this.emit('error', err);
            this.log(err, 'error');
            throw err;
        });
    }
}
function $b16b91c7840d3bff$var$_informAndEmit2(errors) {
    for (const error of errors){
        if (error.isRestriction) this.emit('restriction-failed', error.file, error);
        else this.emit('error', error, error.file);
        this.log(error, 'warning');
    }
    const userFacingErrors = errors.filter((error)=>error.isUserFacing);
    // don't flood the user: only show the first 4 toasts
    const maxNumToShow = 4;
    const firstErrors = userFacingErrors.slice(0, maxNumToShow);
    const additionalErrors = userFacingErrors.slice(maxNumToShow);
    firstErrors.forEach((_ref2)=>{
        let { message: message, details: details = '' } = _ref2;
        this.info({
            message: message,
            details: details
        }, 'error', this.opts.infoTimeout);
    });
    if (additionalErrors.length > 0) this.info({
        message: this.i18n('additionalRestrictionsFailed', {
            count: additionalErrors.length
        })
    });
}
function $b16b91c7840d3bff$var$_checkRequiredMetaFieldsOnFile2(file) {
    const { missingFields: missingFields, error: error } = $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_restricter)[$b16b91c7840d3bff$var$_restricter].getMissingRequiredMetaFields(file);
    if (missingFields.length > 0) {
        this.setFileState(file.id, {
            missingRequiredMetaFields: missingFields
        });
        this.log(error.message);
        this.emit('restriction-failed', file, error);
        return false;
    }
    return true;
}
function $b16b91c7840d3bff$var$_checkRequiredMetaFields2(files) {
    let success = true;
    for (const file of Object.values(files))if (!$b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_checkRequiredMetaFieldsOnFile)[$b16b91c7840d3bff$var$_checkRequiredMetaFieldsOnFile](file)) success = false;
    return success;
}
function $b16b91c7840d3bff$var$_assertNewUploadAllowed2(file) {
    const { allowNewUpload: allowNewUpload } = this.getState();
    if (allowNewUpload === false) {
        const error = new (0, $3044940369c0f03d$export$e4d147272ce048a7)(this.i18n('noMoreFilesAllowed'), {
            file: file
        });
        $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_informAndEmit)[$b16b91c7840d3bff$var$_informAndEmit]([
            error
        ]);
        throw error;
    }
}
function $b16b91c7840d3bff$var$_transformFile2(fileDescriptorOrFile) {
    // Uppy expects files in { name, type, size, data } format.
    // If the actual File object is passed from input[type=file] or drag-drop,
    // we normalize it to match Uppy file object
    const file = fileDescriptorOrFile instanceof File ? {
        name: fileDescriptorOrFile.name,
        type: fileDescriptorOrFile.type,
        size: fileDescriptorOrFile.size,
        data: fileDescriptorOrFile
    } : fileDescriptorOrFile;
    const fileType = (0, $d70a5ddc0e61f36b$export$2e2bcd8739ae039)(file);
    const fileName = (0, $77bbd1edc6b4e0f3$export$2e2bcd8739ae039)(fileType, file);
    const fileExtension = (0, $09afbe8d004816d5$export$2e2bcd8739ae039)(fileName).extension;
    const id = (0, $d67267bb9859462b$export$2ff5b23440673856)(file, this.getID());
    const meta = file.meta || {};
    meta.name = fileName;
    meta.type = fileType;
    // `null` means the size is unknown.
    const size = Number.isFinite(file.data.size) ? file.data.size : null;
    return {
        source: file.source || '',
        id: id,
        name: fileName,
        extension: fileExtension || '',
        meta: {
            ...this.getState().meta,
            ...meta
        },
        type: fileType,
        data: file.data,
        progress: {
            percentage: 0,
            bytesUploaded: 0,
            bytesTotal: size,
            uploadComplete: false,
            uploadStarted: null
        },
        size: size,
        isGhost: false,
        isRemote: file.isRemote || false,
        // TODO: this should not be a string
        // @ts-expect-error wrong
        remote: file.remote || '',
        preview: file.preview
    };
}
function $b16b91c7840d3bff$var$_startIfAutoProceed2() {
    if (this.opts.autoProceed && !this.scheduledAutoProceed) this.scheduledAutoProceed = setTimeout(()=>{
        this.scheduledAutoProceed = null;
        this.upload().catch((err)=>{
            if (!err.isRestriction) this.log(err.stack || err.message || err);
        });
    }, 4);
}
function $b16b91c7840d3bff$var$_checkAndUpdateFileState2(filesToAdd) {
    const { files: existingFiles } = this.getState();
    // create a copy of the files object only once
    const nextFilesState = {
        ...existingFiles
    };
    const validFilesToAdd = [];
    const errors = [];
    for (const fileToAdd of filesToAdd)try {
        var _existingFiles$newFil;
        let newFile = $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_transformFile)[$b16b91c7840d3bff$var$_transformFile](fileToAdd);
        // If a file has been recovered (Golden Retriever), but we were unable to recover its data (probably too large),
        // users are asked to re-select these half-recovered files and then this method will be called again.
        // In order to keep the progress, meta and everything else, we keep the existing file,
        // but we replace `data`, and we remove `isGhost`, because the file is no longer a ghost now
        const isGhost = (_existingFiles$newFil = existingFiles[newFile.id]) == null ? void 0 : _existingFiles$newFil.isGhost;
        if (isGhost) {
            const existingFileState = existingFiles[newFile.id];
            newFile = {
                ...existingFileState,
                isGhost: false,
                data: fileToAdd.data
            };
            this.log(`Replaced the blob in the restored ghost file: ${newFile.name}, ${newFile.id}`);
        }
        const onBeforeFileAddedResult = this.opts.onBeforeFileAdded(newFile, nextFilesState);
        if (!onBeforeFileAddedResult && this.checkIfFileAlreadyExists(newFile.id)) throw new (0, $3044940369c0f03d$export$e4d147272ce048a7)(this.i18n('noDuplicates', {
            fileName: newFile.name
        }), {
            file: fileToAdd
        });
        // Pass through reselected files from Golden Retriever
        if (onBeforeFileAddedResult === false && !isGhost) // Don’t show UI info for this error, as it should be done by the developer
        throw new (0, $3044940369c0f03d$export$e4d147272ce048a7)('Cannot add the file because onBeforeFileAdded returned false.', {
            isUserFacing: false,
            file: fileToAdd
        });
        else if (typeof onBeforeFileAddedResult === 'object' && onBeforeFileAddedResult !== null) newFile = onBeforeFileAddedResult;
        $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_restricter)[$b16b91c7840d3bff$var$_restricter].validateSingleFile(newFile);
        // need to add it to the new local state immediately, so we can use the state to validate the next files too
        nextFilesState[newFile.id] = newFile;
        validFilesToAdd.push(newFile);
    } catch (err) {
        errors.push(err);
    }
    try {
        // need to run this separately because it's much more slow, so if we run it inside the for-loop it will be very slow
        // when many files are added
        $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_restricter)[$b16b91c7840d3bff$var$_restricter].validateAggregateRestrictions(Object.values(existingFiles), validFilesToAdd);
    } catch (err) {
        errors.push(err);
        // If we have any aggregate error, don't allow adding this batch
        return {
            nextFilesState: existingFiles,
            validFilesToAdd: [],
            errors: errors
        };
    }
    return {
        nextFilesState: nextFilesState,
        validFilesToAdd: validFilesToAdd,
        errors: errors
    };
}
function $b16b91c7840d3bff$var$_addListeners2() {
    // Type inference only works for inline functions so we have to type it again
    const errorHandler = (error, file, response)=>{
        let errorMsg = error.message || 'Unknown error';
        if (error.details) errorMsg += ` ${error.details}`;
        this.setState({
            error: errorMsg
        });
        if (file != null && file.id in this.getState().files) this.setFileState(file.id, {
            error: errorMsg,
            response: response
        });
    };
    this.on('error', errorHandler);
    this.on('upload-error', (file, error, response)=>{
        errorHandler(error, file, response);
        if (typeof error === 'object' && error.message) {
            var _file$name;
            this.log(error.message, 'error');
            const newError = new Error(this.i18n('failedToUpload', {
                file: (_file$name = file == null ? void 0 : file.name) != null ? _file$name : ''
            })); // we may want a new custom error here
            newError.isUserFacing = true; // todo maybe don't do this with all errors?
            newError.details = error.message;
            if (error.details) newError.details += ` ${error.details}`;
            $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_informAndEmit)[$b16b91c7840d3bff$var$_informAndEmit]([
                newError
            ]);
        } else $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_informAndEmit)[$b16b91c7840d3bff$var$_informAndEmit]([
            error
        ]);
    });
    let uploadStalledWarningRecentlyEmitted = null;
    this.on('upload-stalled', (error, files)=>{
        const { message: message } = error;
        const details = files.map((file)=>file.meta.name).join(', ');
        if (!uploadStalledWarningRecentlyEmitted) {
            this.info({
                message: message,
                details: details
            }, 'warning', this.opts.infoTimeout);
            uploadStalledWarningRecentlyEmitted = setTimeout(()=>{
                uploadStalledWarningRecentlyEmitted = null;
            }, this.opts.infoTimeout);
        }
        this.log(`${message} ${details}`.trim(), 'warning');
    });
    this.on('upload', ()=>{
        this.setState({
            error: null
        });
    });
    const onUploadStarted = (files)=>{
        const filesFiltered = files.filter((file)=>{
            const exists = file != null && this.getFile(file.id);
            if (!exists) this.log(`Not setting progress for a file that has been removed: ${file == null ? void 0 : file.id}`);
            return exists;
        });
        const filesState = Object.fromEntries(filesFiltered.map((file)=>[
                file.id,
                {
                    progress: {
                        uploadStarted: Date.now(),
                        uploadComplete: false,
                        percentage: 0,
                        bytesUploaded: 0,
                        bytesTotal: file.size
                    }
                }
            ]));
        this.patchFilesState(filesState);
    };
    this.on('upload-start', (files)=>{
        files.forEach((file)=>{
            // todo backward compat, remove this event in a next major
            this.emit('upload-started', file);
        });
        onUploadStarted(files);
    });
    this.on('upload-progress', this.calculateProgress);
    this.on('upload-success', (file, uploadResp)=>{
        if (file == null || !this.getFile(file.id)) {
            this.log(`Not setting progress for a file that has been removed: ${file == null ? void 0 : file.id}`);
            return;
        }
        const currentProgress = this.getFile(file.id).progress;
        this.setFileState(file.id, {
            progress: {
                ...currentProgress,
                postprocess: $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_postProcessors)[$b16b91c7840d3bff$var$_postProcessors].size > 0 ? {
                    mode: 'indeterminate'
                } : undefined,
                uploadComplete: true,
                percentage: 100,
                bytesUploaded: currentProgress.bytesTotal
            },
            response: uploadResp,
            uploadURL: uploadResp.uploadURL,
            isPaused: false
        });
        // Remote providers sometimes don't tell us the file size,
        // but we can know how many bytes we uploaded once the upload is complete.
        if (file.size == null) this.setFileState(file.id, {
            size: uploadResp.bytesUploaded || currentProgress.bytesTotal
        });
        this.calculateTotalProgress();
    });
    this.on('preprocess-progress', (file, progress)=>{
        if (file == null || !this.getFile(file.id)) {
            this.log(`Not setting progress for a file that has been removed: ${file == null ? void 0 : file.id}`);
            return;
        }
        this.setFileState(file.id, {
            progress: {
                ...this.getFile(file.id).progress,
                preprocess: progress
            }
        });
    });
    this.on('preprocess-complete', (file)=>{
        if (file == null || !this.getFile(file.id)) {
            this.log(`Not setting progress for a file that has been removed: ${file == null ? void 0 : file.id}`);
            return;
        }
        const files = {
            ...this.getState().files
        };
        files[file.id] = {
            ...files[file.id],
            progress: {
                ...files[file.id].progress
            }
        };
        delete files[file.id].progress.preprocess;
        this.setState({
            files: files
        });
    });
    this.on('postprocess-progress', (file, progress)=>{
        if (file == null || !this.getFile(file.id)) {
            this.log(`Not setting progress for a file that has been removed: ${file == null ? void 0 : file.id}`);
            return;
        }
        this.setFileState(file.id, {
            progress: {
                ...this.getState().files[file.id].progress,
                postprocess: progress
            }
        });
    });
    this.on('postprocess-complete', (file)=>{
        if (file == null || !this.getFile(file.id)) {
            this.log(`Not setting progress for a file that has been removed: ${file == null ? void 0 : file.id}`);
            return;
        }
        const files = {
            ...this.getState().files
        };
        files[file.id] = {
            ...files[file.id],
            progress: {
                ...files[file.id].progress
            }
        };
        delete files[file.id].progress.postprocess;
        this.setState({
            files: files
        });
    });
    this.on('restored', ()=>{
        // Files may have changed--ensure progress is still accurate.
        this.calculateTotalProgress();
    });
    // @ts-expect-error should fix itself when dashboard it typed (also this doesn't belong here)
    this.on('dashboard:file-edit-complete', (file)=>{
        if (file) $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_checkRequiredMetaFieldsOnFile)[$b16b91c7840d3bff$var$_checkRequiredMetaFieldsOnFile](file);
    });
    // show informer if offline
    if (typeof window !== 'undefined' && window.addEventListener) {
        window.addEventListener('online', $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_updateOnlineStatus)[$b16b91c7840d3bff$var$_updateOnlineStatus]);
        window.addEventListener('offline', $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_updateOnlineStatus)[$b16b91c7840d3bff$var$_updateOnlineStatus]);
        setTimeout($b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_updateOnlineStatus)[$b16b91c7840d3bff$var$_updateOnlineStatus], 3000);
    }
}
function $b16b91c7840d3bff$var$_createUpload2(fileIDs, opts) {
    if (opts === void 0) opts = {};
    // uppy.retryAll sets this to true — when retrying we want to ignore `allowNewUpload: false`
    const { forceAllowNewUpload: forceAllowNewUpload = false } = opts;
    const { allowNewUpload: allowNewUpload, currentUploads: currentUploads } = this.getState();
    if (!allowNewUpload && !forceAllowNewUpload) throw new Error('Cannot create a new upload: already uploading.');
    const uploadID = (0, $3c82c89e950acc97$export$ac4959f4f1338dfc)();
    this.emit('upload', {
        id: uploadID,
        fileIDs: fileIDs
    });
    this.setState({
        allowNewUpload: this.opts.allowMultipleUploadBatches !== false && this.opts.allowMultipleUploads !== false,
        currentUploads: {
            ...currentUploads,
            [uploadID]: {
                fileIDs: fileIDs,
                step: 0,
                result: {}
            }
        }
    });
    return uploadID;
}
function $b16b91c7840d3bff$var$_getUpload2(uploadID) {
    const { currentUploads: currentUploads } = this.getState();
    return currentUploads[uploadID];
}
function $b16b91c7840d3bff$var$_removeUpload2(uploadID) {
    const currentUploads = {
        ...this.getState().currentUploads
    };
    delete currentUploads[uploadID];
    this.setState({
        currentUploads: currentUploads
    });
}
async function $b16b91c7840d3bff$var$_runUpload2(uploadID) {
    const getCurrentUpload = ()=>{
        const { currentUploads: currentUploads } = this.getState();
        return currentUploads[uploadID];
    };
    let currentUpload = getCurrentUpload();
    const steps = [
        ...$b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_preProcessors)[$b16b91c7840d3bff$var$_preProcessors],
        ...$b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_uploaders)[$b16b91c7840d3bff$var$_uploaders],
        ...$b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_postProcessors)[$b16b91c7840d3bff$var$_postProcessors]
    ];
    try {
        for(let step = currentUpload.step || 0; step < steps.length; step++){
            if (!currentUpload) break;
            const fn = steps[step];
            this.setState({
                currentUploads: {
                    ...this.getState().currentUploads,
                    [uploadID]: {
                        ...currentUpload,
                        step: step
                    }
                }
            });
            const { fileIDs: fileIDs } = currentUpload;
            // TODO give this the `updatedUpload` object as its only parameter maybe?
            // Otherwise when more metadata may be added to the upload this would keep getting more parameters
            await fn(fileIDs, uploadID);
            // Update currentUpload value in case it was modified asynchronously.
            currentUpload = getCurrentUpload();
        }
    } catch (err) {
        $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_removeUpload)[$b16b91c7840d3bff$var$_removeUpload](uploadID);
        throw err;
    }
    // Set result data.
    if (currentUpload) {
        // Mark postprocessing step as complete if necessary; this addresses a case where we might get
        // stuck in the postprocessing UI while the upload is fully complete.
        // If the postprocessing steps do not do any work, they may not emit postprocessing events at
        // all, and never mark the postprocessing as complete. This is fine on its own but we
        // introduced code in the @uppy/core upload-success handler to prepare postprocessing progress
        // state if any postprocessors are registered. That is to avoid a "flash of completed state"
        // before the postprocessing plugins can emit events.
        //
        // So, just in case an upload with postprocessing plugins *has* completed *without* emitting
        // postprocessing completion, we do it instead.
        currentUpload.fileIDs.forEach((fileID)=>{
            const file = this.getFile(fileID);
            if (file && file.progress.postprocess) this.emit('postprocess-complete', file);
        });
        const files = currentUpload.fileIDs.map((fileID)=>this.getFile(fileID));
        const successful = files.filter((file)=>!file.error);
        const failed = files.filter((file)=>file.error);
        this.addResultData(uploadID, {
            successful: successful,
            failed: failed,
            uploadID: uploadID
        });
        // Update currentUpload value in case it was modified asynchronously.
        currentUpload = getCurrentUpload();
    }
    // Emit completion events.
    // This is in a separate function so that the `currentUploads` variable
    // always refers to the latest state. In the handler right above it refers
    // to an outdated object without the `.result` property.
    let result;
    if (currentUpload) {
        result = currentUpload.result;
        this.emit('complete', result);
        $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_removeUpload)[$b16b91c7840d3bff$var$_removeUpload](uploadID);
    }
    if (result == null) this.log(`Not setting result for an upload that has been removed: ${uploadID}`);
    return result;
}
$b16b91c7840d3bff$export$1c95bea2669f592b.VERSION = $b16b91c7840d3bff$var$packageJson.version;
var $b16b91c7840d3bff$export$2e2bcd8739ae039 = $b16b91c7840d3bff$export$1c95bea2669f592b;


var $4d2e93495e50cc85$var$n, $4d2e93495e50cc85$export$41c562ebe57d11e2, $4d2e93495e50cc85$var$u, $4d2e93495e50cc85$export$a8257692ac88316c, $4d2e93495e50cc85$var$i, $4d2e93495e50cc85$var$o, $4d2e93495e50cc85$var$r, $4d2e93495e50cc85$var$f, $4d2e93495e50cc85$var$e, $4d2e93495e50cc85$var$c = {}, $4d2e93495e50cc85$var$s = [], $4d2e93495e50cc85$var$a = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i, $4d2e93495e50cc85$var$h = Array.isArray;
function $4d2e93495e50cc85$var$v(n, l) {
    for(var u in l)n[u] = l[u];
    return n;
}
function $4d2e93495e50cc85$var$p(n) {
    var l = n.parentNode;
    l && l.removeChild(n);
}
function $4d2e93495e50cc85$export$c8a8987d4410bf2d(l, u, t) {
    var i, o, r, f = {};
    for(r in u)"key" == r ? i = u[r] : "ref" == r ? o = u[r] : f[r] = u[r];
    if (arguments.length > 2 && (f.children = arguments.length > 3 ? $4d2e93495e50cc85$var$n.call(arguments, 2) : t), "function" == typeof l && null != l.defaultProps) for(r in l.defaultProps)void 0 === f[r] && (f[r] = l.defaultProps[r]);
    return $4d2e93495e50cc85$var$d(l, f, i, o, null);
}
function $4d2e93495e50cc85$var$d(n, t, i, o, r) {
    var f = {
        type: n,
        props: t,
        key: i,
        ref: o,
        __k: null,
        __: null,
        __b: 0,
        __e: null,
        __d: void 0,
        __c: null,
        constructor: void 0,
        __v: null == r ? ++$4d2e93495e50cc85$var$u : r,
        __i: -1,
        __u: 0
    };
    return null == r && null != $4d2e93495e50cc85$export$41c562ebe57d11e2.vnode && $4d2e93495e50cc85$export$41c562ebe57d11e2.vnode(f), f;
}
function $4d2e93495e50cc85$export$7d1e3a5e95ceca43() {
    return {
        current: null
    };
}
function $4d2e93495e50cc85$export$ffb0004e005737fa(n) {
    return n.children;
}
function $4d2e93495e50cc85$export$16fa2f45be04daa8(n, l) {
    this.props = n, this.context = l;
}
function $4d2e93495e50cc85$var$m(n, l) {
    if (null == l) return n.__ ? $4d2e93495e50cc85$var$m(n.__, n.__i + 1) : null;
    for(var u; l < n.__k.length; l++)if (null != (u = n.__k[l]) && null != u.__e) return u.__e;
    return "function" == typeof n.type ? $4d2e93495e50cc85$var$m(n) : null;
}
function $4d2e93495e50cc85$var$w(n, u, t) {
    var i, o = n.__v, r = o.__e, f = n.__P;
    if (f) return (i = $4d2e93495e50cc85$var$v({}, o)).__v = o.__v + 1, $4d2e93495e50cc85$export$41c562ebe57d11e2.vnode && $4d2e93495e50cc85$export$41c562ebe57d11e2.vnode(i), $4d2e93495e50cc85$var$M(f, i, o, n.__n, void 0 !== f.ownerSVGElement, 32 & o.__u ? [
        r
    ] : null, u, null == r ? $4d2e93495e50cc85$var$m(o) : r, !!(32 & o.__u), t), i.__v = o.__v, i.__.__k[i.__i] = i, i.__d = void 0, i.__e != r && $4d2e93495e50cc85$var$k(i), i;
}
function $4d2e93495e50cc85$var$k(n) {
    var l, u;
    if (null != (n = n.__) && null != n.__c) {
        for(n.__e = n.__c.base = null, l = 0; l < n.__k.length; l++)if (null != (u = n.__k[l]) && null != u.__e) {
            n.__e = n.__c.base = u.__e;
            break;
        }
        return $4d2e93495e50cc85$var$k(n);
    }
}
function $4d2e93495e50cc85$var$x(n) {
    (!n.__d && (n.__d = !0) && $4d2e93495e50cc85$var$i.push(n) && !$4d2e93495e50cc85$var$C.__r++ || $4d2e93495e50cc85$var$o !== $4d2e93495e50cc85$export$41c562ebe57d11e2.debounceRendering) && (($4d2e93495e50cc85$var$o = $4d2e93495e50cc85$export$41c562ebe57d11e2.debounceRendering) || $4d2e93495e50cc85$var$r)($4d2e93495e50cc85$var$C);
}
function $4d2e93495e50cc85$var$C() {
    var n, u, t, o = [], r = [];
    for($4d2e93495e50cc85$var$i.sort($4d2e93495e50cc85$var$f); n = $4d2e93495e50cc85$var$i.shift();)n.__d && (t = $4d2e93495e50cc85$var$i.length, u = $4d2e93495e50cc85$var$w(n, o, r) || u, 0 === t || $4d2e93495e50cc85$var$i.length > t ? ($4d2e93495e50cc85$var$j(o, u, r), r.length = o.length = 0, u = void 0, $4d2e93495e50cc85$var$i.sort($4d2e93495e50cc85$var$f)) : u && $4d2e93495e50cc85$export$41c562ebe57d11e2.__c && $4d2e93495e50cc85$export$41c562ebe57d11e2.__c(u, $4d2e93495e50cc85$var$s));
    u && $4d2e93495e50cc85$var$j(o, u, r), $4d2e93495e50cc85$var$C.__r = 0;
}
function $4d2e93495e50cc85$var$P(n, l, u, t, i, o, r, f, e, a, h) {
    var v, p, y, d, _, g = t && t.__k || $4d2e93495e50cc85$var$s, b = l.length;
    for(u.__d = e, $4d2e93495e50cc85$var$S(u, l, g), e = u.__d, v = 0; v < b; v++)null != (y = u.__k[v]) && "boolean" != typeof y && "function" != typeof y && (p = -1 === y.__i ? $4d2e93495e50cc85$var$c : g[y.__i] || $4d2e93495e50cc85$var$c, y.__i = v, $4d2e93495e50cc85$var$M(n, y, p, i, o, r, f, e, a, h), d = y.__e, y.ref && p.ref != y.ref && (p.ref && $4d2e93495e50cc85$var$N(p.ref, null, y), h.push(y.ref, y.__c || d, y)), null == _ && null != d && (_ = d), 65536 & y.__u || p.__k === y.__k ? e = $4d2e93495e50cc85$var$$(y, e, n) : "function" == typeof y.type && void 0 !== y.__d ? e = y.__d : d && (e = d.nextSibling), y.__d = void 0, y.__u &= -196609);
    u.__d = e, u.__e = _;
}
function $4d2e93495e50cc85$var$S(n, l, u) {
    var t, i, o, r, f, e = l.length, c = u.length, s = c, a = 0;
    for(n.__k = [], t = 0; t < e; t++)null != (i = n.__k[t] = null == (i = l[t]) || "boolean" == typeof i || "function" == typeof i ? null : "string" == typeof i || "number" == typeof i || "bigint" == typeof i || i.constructor == String ? $4d2e93495e50cc85$var$d(null, i, null, null, i) : $4d2e93495e50cc85$var$h(i) ? $4d2e93495e50cc85$var$d($4d2e93495e50cc85$export$ffb0004e005737fa, {
        children: i
    }, null, null, null) : void 0 === i.constructor && i.__b > 0 ? $4d2e93495e50cc85$var$d(i.type, i.props, i.key, i.ref ? i.ref : null, i.__v) : i) ? (i.__ = n, i.__b = n.__b + 1, f = $4d2e93495e50cc85$var$I(i, u, r = t + a, s), i.__i = f, o = null, -1 !== f && (s--, (o = u[f]) && (o.__u |= 131072)), null == o || null === o.__v ? (-1 == f && a--, "function" != typeof i.type && (i.__u |= 65536)) : f !== r && (f === r + 1 ? a++ : f > r ? s > e - r ? a += f - r : a-- : a = f < r && f == r - 1 ? f - r : 0, f !== t + a && (i.__u |= 65536))) : (o = u[t]) && null == o.key && o.__e && 0 == (131072 & o.__u) && (o.__e == n.__d && (n.__d = $4d2e93495e50cc85$var$m(o)), $4d2e93495e50cc85$var$O(o, o, !1), u[t] = null, s--);
    if (s) for(t = 0; t < c; t++)null != (o = u[t]) && 0 == (131072 & o.__u) && (o.__e == n.__d && (n.__d = $4d2e93495e50cc85$var$m(o)), $4d2e93495e50cc85$var$O(o, o));
}
function $4d2e93495e50cc85$var$$(n, l, u) {
    var t, i;
    if ("function" == typeof n.type) {
        for(t = n.__k, i = 0; t && i < t.length; i++)t[i] && (t[i].__ = n, l = $4d2e93495e50cc85$var$$(t[i], l, u));
        return l;
    }
    n.__e != l && (u.insertBefore(n.__e, l || null), l = n.__e);
    do l = l && l.nextSibling;
    while (null != l && 8 === l.nodeType);
    return l;
}
function $4d2e93495e50cc85$export$47e4c5b300681277(n, l) {
    return l = l || [], null == n || "boolean" == typeof n || ($4d2e93495e50cc85$var$h(n) ? n.some(function(n) {
        $4d2e93495e50cc85$export$47e4c5b300681277(n, l);
    }) : l.push(n)), l;
}
function $4d2e93495e50cc85$var$I(n, l, u, t) {
    var i = n.key, o = n.type, r = u - 1, f = u + 1, e = l[u];
    if (null === e || e && i == e.key && o === e.type) return u;
    if (t > (null != e && 0 == (131072 & e.__u) ? 1 : 0)) for(; r >= 0 || f < l.length;){
        if (r >= 0) {
            if ((e = l[r]) && 0 == (131072 & e.__u) && i == e.key && o === e.type) return r;
            r--;
        }
        if (f < l.length) {
            if ((e = l[f]) && 0 == (131072 & e.__u) && i == e.key && o === e.type) return f;
            f++;
        }
    }
    return -1;
}
function $4d2e93495e50cc85$var$T(n, l, u) {
    "-" === l[0] ? n.setProperty(l, null == u ? "" : u) : n[l] = null == u ? "" : "number" != typeof u || $4d2e93495e50cc85$var$a.test(l) ? u : u + "px";
}
function $4d2e93495e50cc85$var$A(n, l, u, t, i) {
    var o;
    n: if ("style" === l) {
        if ("string" == typeof u) n.style.cssText = u;
        else {
            if ("string" == typeof t && (n.style.cssText = t = ""), t) for(l in t)u && l in u || $4d2e93495e50cc85$var$T(n.style, l, "");
            if (u) for(l in u)t && u[l] === t[l] || $4d2e93495e50cc85$var$T(n.style, l, u[l]);
        }
    } else if ("o" === l[0] && "n" === l[1]) o = l !== (l = l.replace(/(PointerCapture)$|Capture$/i, "$1")), l = l.toLowerCase() in n ? l.toLowerCase().slice(2) : l.slice(2), n.l || (n.l = {}), n.l[l + o] = u, u ? t ? u.u = t.u : (u.u = Date.now(), n.addEventListener(l, o ? $4d2e93495e50cc85$var$L : $4d2e93495e50cc85$var$D, o)) : n.removeEventListener(l, o ? $4d2e93495e50cc85$var$L : $4d2e93495e50cc85$var$D, o);
    else {
        if (i) l = l.replace(/xlink(H|:h)/, "h").replace(/sName$/, "s");
        else if ("width" !== l && "height" !== l && "href" !== l && "list" !== l && "form" !== l && "tabIndex" !== l && "download" !== l && "rowSpan" !== l && "colSpan" !== l && "role" !== l && l in n) try {
            n[l] = null == u ? "" : u;
            break n;
        } catch (n) {}
        "function" == typeof u || (null == u || !1 === u && "-" !== l[4] ? n.removeAttribute(l) : n.setAttribute(l, u));
    }
}
function $4d2e93495e50cc85$var$D(n) {
    if (this.l) {
        var u = this.l[n.type + !1];
        if (n.t) {
            if (n.t <= u.u) return;
        } else n.t = Date.now();
        return u($4d2e93495e50cc85$export$41c562ebe57d11e2.event ? $4d2e93495e50cc85$export$41c562ebe57d11e2.event(n) : n);
    }
}
function $4d2e93495e50cc85$var$L(n) {
    if (this.l) return this.l[n.type + !0]($4d2e93495e50cc85$export$41c562ebe57d11e2.event ? $4d2e93495e50cc85$export$41c562ebe57d11e2.event(n) : n);
}
function $4d2e93495e50cc85$var$M(n, u, t, i, o, r, f, e, c, s) {
    var a, p, y, d, _, m, w, k, x, C, S, $, H, I, T, A = u.type;
    if (void 0 !== u.constructor) return null;
    128 & t.__u && (c = !!(32 & t.__u), r = [
        e = u.__e = t.__e
    ]), (a = $4d2e93495e50cc85$export$41c562ebe57d11e2.__b) && a(u);
    n: if ("function" == typeof A) try {
        if (k = u.props, x = (a = A.contextType) && i[a.__c], C = a ? x ? x.props.value : a.__ : i, t.__c ? w = (p = u.__c = t.__c).__ = p.__E : ("prototype" in A && A.prototype.render ? u.__c = p = new A(k, C) : (u.__c = p = new $4d2e93495e50cc85$export$16fa2f45be04daa8(k, C), p.constructor = A, p.render = $4d2e93495e50cc85$var$q), x && x.sub(p), p.props = k, p.state || (p.state = {}), p.context = C, p.__n = i, y = p.__d = !0, p.__h = [], p._sb = []), null == p.__s && (p.__s = p.state), null != A.getDerivedStateFromProps && (p.__s == p.state && (p.__s = $4d2e93495e50cc85$var$v({}, p.__s)), $4d2e93495e50cc85$var$v(p.__s, A.getDerivedStateFromProps(k, p.__s))), d = p.props, _ = p.state, p.__v = u, y) null == A.getDerivedStateFromProps && null != p.componentWillMount && p.componentWillMount(), null != p.componentDidMount && p.__h.push(p.componentDidMount);
        else {
            if (null == A.getDerivedStateFromProps && k !== d && null != p.componentWillReceiveProps && p.componentWillReceiveProps(k, C), !p.__e && (null != p.shouldComponentUpdate && !1 === p.shouldComponentUpdate(k, p.__s, C) || u.__v === t.__v)) {
                for(u.__v !== t.__v && (p.props = k, p.state = p.__s, p.__d = !1), u.__e = t.__e, u.__k = t.__k, u.__k.forEach(function(n) {
                    n && (n.__ = u);
                }), S = 0; S < p._sb.length; S++)p.__h.push(p._sb[S]);
                p._sb = [], p.__h.length && f.push(p);
                break n;
            }
            null != p.componentWillUpdate && p.componentWillUpdate(k, p.__s, C), null != p.componentDidUpdate && p.__h.push(function() {
                p.componentDidUpdate(d, _, m);
            });
        }
        if (p.context = C, p.props = k, p.__P = n, p.__e = !1, $ = $4d2e93495e50cc85$export$41c562ebe57d11e2.__r, H = 0, "prototype" in A && A.prototype.render) {
            for(p.state = p.__s, p.__d = !1, $ && $(u), a = p.render(p.props, p.state, p.context), I = 0; I < p._sb.length; I++)p.__h.push(p._sb[I]);
            p._sb = [];
        } else do p.__d = !1, $ && $(u), a = p.render(p.props, p.state, p.context), p.state = p.__s;
        while (p.__d && ++H < 25);
        p.state = p.__s, null != p.getChildContext && (i = $4d2e93495e50cc85$var$v($4d2e93495e50cc85$var$v({}, i), p.getChildContext())), y || null == p.getSnapshotBeforeUpdate || (m = p.getSnapshotBeforeUpdate(d, _)), $4d2e93495e50cc85$var$P(n, $4d2e93495e50cc85$var$h(T = null != a && a.type === $4d2e93495e50cc85$export$ffb0004e005737fa && null == a.key ? a.props.children : a) ? T : [
            T
        ], u, t, i, o, r, f, e, c, s), p.base = u.__e, u.__u &= -161, p.__h.length && f.push(p), w && (p.__E = p.__ = null);
    } catch (n) {
        u.__v = null, c || null != r ? (u.__e = e, u.__u |= c ? 160 : 32, r[r.indexOf(e)] = null) : (u.__e = t.__e, u.__k = t.__k), $4d2e93495e50cc85$export$41c562ebe57d11e2.__e(n, u, t);
    }
    else null == r && u.__v === t.__v ? (u.__k = t.__k, u.__e = t.__e) : u.__e = $4d2e93495e50cc85$var$z(t.__e, u, t, i, o, r, f, c, s);
    (a = $4d2e93495e50cc85$export$41c562ebe57d11e2.diffed) && a(u);
}
function $4d2e93495e50cc85$var$j(n, u, t) {
    for(var i = 0; i < t.length; i++)$4d2e93495e50cc85$var$N(t[i], t[++i], t[++i]);
    $4d2e93495e50cc85$export$41c562ebe57d11e2.__c && $4d2e93495e50cc85$export$41c562ebe57d11e2.__c(u, n), n.some(function(u) {
        try {
            n = u.__h, u.__h = [], n.some(function(n) {
                n.call(u);
            });
        } catch (n) {
            $4d2e93495e50cc85$export$41c562ebe57d11e2.__e(n, u.__v);
        }
    });
}
function $4d2e93495e50cc85$var$z(l, u, t, i, o, r, f, e, s) {
    var a, v, y, d, _, g, b, w = t.props, k = u.props, x = u.type;
    if ("svg" === x && (o = !0), null != r) {
        for(a = 0; a < r.length; a++)if ((_ = r[a]) && "setAttribute" in _ == !!x && (x ? _.localName === x : 3 === _.nodeType)) {
            l = _, r[a] = null;
            break;
        }
    }
    if (null == l) {
        if (null === x) return document.createTextNode(k);
        l = o ? document.createElementNS("http://www.w3.org/2000/svg", x) : document.createElement(x, k.is && k), r = null, e = !1;
    }
    if (null === x) w === k || e && l.data === k || (l.data = k);
    else {
        if (r = r && $4d2e93495e50cc85$var$n.call(l.childNodes), w = t.props || $4d2e93495e50cc85$var$c, !e && null != r) for(w = {}, a = 0; a < l.attributes.length; a++)w[(_ = l.attributes[a]).name] = _.value;
        for(a in w)_ = w[a], "children" == a || ("dangerouslySetInnerHTML" == a ? y = _ : "key" === a || a in k || $4d2e93495e50cc85$var$A(l, a, null, _, o));
        for(a in k)_ = k[a], "children" == a ? d = _ : "dangerouslySetInnerHTML" == a ? v = _ : "value" == a ? g = _ : "checked" == a ? b = _ : "key" === a || e && "function" != typeof _ || w[a] === _ || $4d2e93495e50cc85$var$A(l, a, _, w[a], o);
        if (v) e || y && (v.__html === y.__html || v.__html === l.innerHTML) || (l.innerHTML = v.__html), u.__k = [];
        else if (y && (l.innerHTML = ""), $4d2e93495e50cc85$var$P(l, $4d2e93495e50cc85$var$h(d) ? d : [
            d
        ], u, t, i, o && "foreignObject" !== x, r, f, r ? r[0] : t.__k && $4d2e93495e50cc85$var$m(t, 0), e, s), null != r) for(a = r.length; a--;)null != r[a] && $4d2e93495e50cc85$var$p(r[a]);
        e || (a = "value", void 0 !== g && (g !== l[a] || "progress" === x && !g || "option" === x && g !== w[a]) && $4d2e93495e50cc85$var$A(l, a, g, w[a], !1), a = "checked", void 0 !== b && b !== l[a] && $4d2e93495e50cc85$var$A(l, a, b, w[a], !1));
    }
    return l;
}
function $4d2e93495e50cc85$var$N(n, u, t) {
    try {
        "function" == typeof n ? n(u) : n.current = u;
    } catch (n) {
        $4d2e93495e50cc85$export$41c562ebe57d11e2.__e(n, t);
    }
}
function $4d2e93495e50cc85$var$O(n, u, t) {
    var i, o;
    if ($4d2e93495e50cc85$export$41c562ebe57d11e2.unmount && $4d2e93495e50cc85$export$41c562ebe57d11e2.unmount(n), (i = n.ref) && (i.current && i.current !== n.__e || $4d2e93495e50cc85$var$N(i, null, u)), null != (i = n.__c)) {
        if (i.componentWillUnmount) try {
            i.componentWillUnmount();
        } catch (n) {
            $4d2e93495e50cc85$export$41c562ebe57d11e2.__e(n, u);
        }
        i.base = i.__P = null, n.__c = void 0;
    }
    if (i = n.__k) for(o = 0; o < i.length; o++)i[o] && $4d2e93495e50cc85$var$O(i[o], u, t || "function" != typeof n.type);
    t || null == n.__e || $4d2e93495e50cc85$var$p(n.__e), n.__ = n.__e = n.__d = void 0;
}
function $4d2e93495e50cc85$var$q(n, l, u) {
    return this.constructor(n, u);
}
function $4d2e93495e50cc85$export$b3890eb0ae9dca99(u, t, i) {
    var o, r, f, e;
    $4d2e93495e50cc85$export$41c562ebe57d11e2.__ && $4d2e93495e50cc85$export$41c562ebe57d11e2.__(u, t), r = (o = "function" == typeof i) ? null : i && i.__k || t.__k, f = [], e = [], $4d2e93495e50cc85$var$M(t, u = (!o && i || t).__k = $4d2e93495e50cc85$export$c8a8987d4410bf2d($4d2e93495e50cc85$export$ffb0004e005737fa, null, [
        u
    ]), r || $4d2e93495e50cc85$var$c, $4d2e93495e50cc85$var$c, void 0 !== t.ownerSVGElement, !o && i ? [
        i
    ] : r ? null : t.firstChild ? $4d2e93495e50cc85$var$n.call(t.childNodes) : null, f, !o && i ? i : r ? r.__e : t.firstChild, o, e), u.__d = void 0, $4d2e93495e50cc85$var$j(f, u, e);
}
function $4d2e93495e50cc85$export$fa8d919ba61d84db(n, l) {
    $4d2e93495e50cc85$export$b3890eb0ae9dca99(n, l, $4d2e93495e50cc85$export$fa8d919ba61d84db);
}
function $4d2e93495e50cc85$export$e530037191fcd5d7(l, u, t) {
    var i, o, r, f, e = $4d2e93495e50cc85$var$v({}, l.props);
    for(r in l.type && l.type.defaultProps && (f = l.type.defaultProps), u)"key" == r ? i = u[r] : "ref" == r ? o = u[r] : e[r] = void 0 === u[r] && void 0 !== f ? f[r] : u[r];
    return arguments.length > 2 && (e.children = arguments.length > 3 ? $4d2e93495e50cc85$var$n.call(arguments, 2) : t), $4d2e93495e50cc85$var$d(l.type, e, i || l.key, o || l.ref, null);
}
function $4d2e93495e50cc85$export$fd42f52fd3ae1109(n, l) {
    var u = {
        __c: l = "__cC" + $4d2e93495e50cc85$var$e++,
        __: n,
        Consumer: function(n, l) {
            return n.children(l);
        },
        Provider: function(n) {
            var u, t;
            return this.getChildContext || (u = [], (t = {})[l] = this, this.getChildContext = function() {
                return t;
            }, this.shouldComponentUpdate = function(n) {
                this.props.value !== n.value && u.some(function(n) {
                    n.__e = !0, $4d2e93495e50cc85$var$x(n);
                });
            }, this.sub = function(n) {
                u.push(n);
                var l = n.componentWillUnmount;
                n.componentWillUnmount = function() {
                    u.splice(u.indexOf(n), 1), l && l.call(n);
                };
            }), n.children;
        }
    };
    return u.Provider.__ = u.Consumer.contextType = u;
}
$4d2e93495e50cc85$var$n = $4d2e93495e50cc85$var$s.slice, $4d2e93495e50cc85$export$41c562ebe57d11e2 = {
    __e: function(n, l, u, t) {
        for(var i, o, r; l = l.__;)if ((i = l.__c) && !i.__) try {
            if ((o = i.constructor) && null != o.getDerivedStateFromError && (i.setState(o.getDerivedStateFromError(n)), r = i.__d), null != i.componentDidCatch && (i.componentDidCatch(n, t || {}), r = i.__d), r) return i.__E = i;
        } catch (l) {
            n = l;
        }
        throw n;
    }
}, $4d2e93495e50cc85$var$u = 0, $4d2e93495e50cc85$export$a8257692ac88316c = function(n) {
    return null != n && null == n.constructor;
}, $4d2e93495e50cc85$export$16fa2f45be04daa8.prototype.setState = function(n, l) {
    var u;
    u = null != this.__s && this.__s !== this.state ? this.__s : this.__s = $4d2e93495e50cc85$var$v({}, this.state), "function" == typeof n && (n = n($4d2e93495e50cc85$var$v({}, u), this.props)), n && $4d2e93495e50cc85$var$v(u, n), null != n && this.__v && (l && this._sb.push(l), $4d2e93495e50cc85$var$x(this));
}, $4d2e93495e50cc85$export$16fa2f45be04daa8.prototype.forceUpdate = function(n) {
    this.__v && (this.__e = !0, n && this.__h.push(n), $4d2e93495e50cc85$var$x(this));
}, $4d2e93495e50cc85$export$16fa2f45be04daa8.prototype.render = $4d2e93495e50cc85$export$ffb0004e005737fa, $4d2e93495e50cc85$var$i = [], $4d2e93495e50cc85$var$r = "function" == typeof Promise ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, $4d2e93495e50cc85$var$f = function(n, l) {
    return n.__v.__b - l.__v.__b;
}, $4d2e93495e50cc85$var$C.__r = 0, $4d2e93495e50cc85$var$e = 0;


/**
 * Check if an object is a DOM element. Duck-typing based on `nodeType`.
 */ function $dcdea5a9bf8353ff$export$2e2bcd8739ae039(obj) {
    if (typeof obj !== 'object' || obj === null) return false;
    if (!('nodeType' in obj)) return false;
    return obj.nodeType === Node.ELEMENT_NODE;
}


function $1866f8238923bb5d$var$findDOMElement(element, context) {
    if (context === void 0) context = document;
    if (typeof element === 'string') return context.querySelector(element);
    if ((0, $dcdea5a9bf8353ff$export$2e2bcd8739ae039)(element)) return element;
    return null;
}
var $1866f8238923bb5d$export$2e2bcd8739ae039 = $1866f8238923bb5d$var$findDOMElement;


/**
 * Get the declared text direction for an element.
 */ function $82cce0c04a5d7a26$var$getTextDirection(element) {
    var _element;
    // There is another way to determine text direction using getComputedStyle(), as done here:
    // https://github.com/pencil-js/text-direction/blob/2a235ce95089b3185acec3b51313cbba921b3811/text-direction.js
    //
    // We do not use that approach because we are interested specifically in the _declared_ text direction.
    // If no text direction is declared, we have to provide our own explicit text direction so our
    // bidirectional CSS style sheets work.
    while(element && !element.dir)// eslint-disable-next-line no-param-reassign
    element = element.parentNode;
    return (_element = element) == null ? void 0 : _element.dir;
}
var $82cce0c04a5d7a26$export$2e2bcd8739ae039 = $82cce0c04a5d7a26$var$getTextDirection;


/* eslint-disable class-methods-use-this */ /**
 * Core plugin logic that all plugins share.
 *
 * BasePlugin does not contain DOM rendering so it can be used for plugins
 * without a user interface.
 *
 * See `Plugin` for the extended version with Preact rendering for interfaces.
 */ 
class $336df15d01030489$export$2e2bcd8739ae039 {
    constructor(uppy, opts){
        this.uppy = uppy;
        this.opts = opts != null ? opts : {};
    }
    getPluginState() {
        const { plugins: plugins } = this.uppy.getState();
        return (plugins == null ? void 0 : plugins[this.id]) || {};
    }
    setPluginState(update) {
        const { plugins: plugins } = this.uppy.getState();
        this.uppy.setState({
            plugins: {
                ...plugins,
                [this.id]: {
                    ...plugins[this.id],
                    ...update
                }
            }
        });
    }
    setOptions(newOpts) {
        this.opts = {
            ...this.opts,
            ...newOpts
        };
        this.setPluginState(undefined); // so that UI re-renders with new options
        this.i18nInit();
    }
    i18nInit() {
        const translator = new (0, $a85fd1efd23057e0$export$2e2bcd8739ae039)([
            this.defaultLocale,
            this.uppy.locale,
            this.opts.locale
        ]);
        this.i18n = translator.translate.bind(translator);
        this.i18nArray = translator.translateArray.bind(translator);
        this.setPluginState(undefined); // so that UI re-renders and we see the updated locale
    }
    /**
   * Extendable methods
   * ==================
   * These methods are here to serve as an overview of the extendable methods as well as
   * making them not conditional in use, such as `if (this.afterUpdate)`.
   */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    addTarget(plugin) {
        throw new Error("Extend the addTarget method to add your plugin to another plugin's target");
    }
    install() {}
    uninstall() {}
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    update(state) {}
    // Called after every state update, after everything's mounted. Debounced.
    afterUpdate() {}
}


function $5d08dd66a9cc6899$var$_classPrivateFieldLooseBase(receiver, privateKey) {
    if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) throw new TypeError("attempted to use private field on non-instance");
    return receiver;
}
var $5d08dd66a9cc6899$var$id = 0;
function $5d08dd66a9cc6899$var$_classPrivateFieldLooseKey(name) {
    return "__private_" + $5d08dd66a9cc6899$var$id++ + "_" + name;
}
/**
 * Defer a frequent call to the microtask queue.
 */ function $5d08dd66a9cc6899$var$debounce(fn) {
    let calling = null;
    let latestArgs;
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        latestArgs = args;
        if (!calling) calling = Promise.resolve().then(()=>{
            calling = null;
            // At this point `args` may be different from the most
            // recent state, if multiple calls happened since this task
            // was queued. So we use the `latestArgs`, which definitely
            // is the most recent call.
            return fn(...latestArgs);
        });
        return calling;
    };
}
/**
 * UIPlugin is the extended version of BasePlugin to incorporate rendering with Preact.
 * Use this for plugins that need a user interface.
 *
 * For plugins without an user interface, see BasePlugin.
 */ var $5d08dd66a9cc6899$var$_updateUI = /*#__PURE__*/ $5d08dd66a9cc6899$var$_classPrivateFieldLooseKey("updateUI");
class $5d08dd66a9cc6899$var$UIPlugin extends (0, $336df15d01030489$export$2e2bcd8739ae039) {
    constructor(){
        super(...arguments);
        Object.defineProperty(this, $5d08dd66a9cc6899$var$_updateUI, {
            writable: true,
            value: void 0
        });
    }
    getTargetPlugin(target // eslint-disable-line no-use-before-define
    ) {
        let targetPlugin;
        if (typeof (target == null ? void 0 : target.addTarget) === 'function') {
            // Targeting a plugin *instance*
            targetPlugin = target;
            if (!(targetPlugin instanceof $5d08dd66a9cc6899$var$UIPlugin)) // eslint-disable-next-line no-console
            console.warn(new Error('The provided plugin is not an instance of UIPlugin. This is an indication of a bug with the way Uppy is bundled.', {
                cause: {
                    targetPlugin: targetPlugin,
                    UIPlugin: $5d08dd66a9cc6899$var$UIPlugin
                }
            }));
        } else if (typeof target === 'function') {
            // Targeting a plugin type
            const Target = target;
            // Find the target plugin instance.
            this.uppy.iteratePlugins((p)=>{
                if (p instanceof Target) targetPlugin = p;
            });
        }
        return targetPlugin;
    }
    /**
   * Check if supplied `target` is a DOM element or an `object`.
   * If it’s an object — target is a plugin, and we search `plugins`
   * for a plugin with same name and return its target.
   */ mount(target, // eslint-disable-line no-use-before-define
    plugin) {
        const callerPluginName = plugin.id;
        const targetElement = (0, $1866f8238923bb5d$export$2e2bcd8739ae039)(target);
        if (targetElement) {
            this.isTargetDOMEl = true;
            // When target is <body> with a single <div> element,
            // Preact thinks it’s the Uppy root element in there when doing a diff,
            // and destroys it. So we are creating a fragment (could be empty div)
            const uppyRootElement = document.createElement('div');
            uppyRootElement.classList.add('uppy-Root');
            // API for plugins that require a synchronous rerender.
            $5d08dd66a9cc6899$var$_classPrivateFieldLooseBase(this, $5d08dd66a9cc6899$var$_updateUI)[$5d08dd66a9cc6899$var$_updateUI] = $5d08dd66a9cc6899$var$debounce((state)=>{
                // plugin could be removed, but this.rerender is debounced below,
                // so it could still be called even after uppy.removePlugin or uppy.close
                // hence the check
                if (!this.uppy.getPlugin(this.id)) return;
                (0, $4d2e93495e50cc85$export$b3890eb0ae9dca99)(this.render(state), uppyRootElement);
                this.afterUpdate();
            });
            this.uppy.log(`Installing ${callerPluginName} to a DOM element '${target}'`);
            if (this.opts.replaceTargetContent) // Doing render(h(null), targetElement), which should have been
            // a better way, since because the component might need to do additional cleanup when it is removed,
            // stopped working — Preact just adds null into target, not replacing
            targetElement.innerHTML = '';
            (0, $4d2e93495e50cc85$export$b3890eb0ae9dca99)(this.render(this.uppy.getState()), uppyRootElement);
            this.el = uppyRootElement;
            targetElement.appendChild(uppyRootElement);
            // Set the text direction if the page has not defined one.
            uppyRootElement.dir = this.opts.direction || (0, $82cce0c04a5d7a26$export$2e2bcd8739ae039)(uppyRootElement) || 'ltr';
            this.onMount();
            return this.el;
        }
        const targetPlugin = this.getTargetPlugin(target);
        if (targetPlugin) {
            this.uppy.log(`Installing ${callerPluginName} to ${targetPlugin.id}`);
            this.parent = targetPlugin;
            this.el = targetPlugin.addTarget(plugin);
            this.onMount();
            return this.el;
        }
        this.uppy.log(`Not installing ${callerPluginName}`);
        let message = `Invalid target option given to ${callerPluginName}.`;
        if (typeof target === 'function') message += " The given target is not a Plugin class. Please check that you're not specifying a React Component instead of a plugin. If you are using @uppy/* packages directly, make sure you have only 1 version of @uppy/core installed: run `npm ls @uppy/core` on the command line and verify that all the versions match and are deduped correctly.";
        else message += "If you meant to target an HTML element, please make sure that the element exists. Check that the <script> tag initializing Uppy is right before the closing </body> tag at the end of the page. (see https://github.com/transloadit/uppy/issues/1042)\n\nIf you meant to target a plugin, please confirm that your `import` statements or `require` calls are correct.";
        throw new Error(message);
    }
    /**
   * Called when plugin is mounted, whether in DOM or into another plugin.
   * Needed because sometimes plugins are mounted separately/after `install`,
   * so this.el and this.parent might not be available in `install`.
   * This is the case with @uppy/react plugins, for example.
   */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    render(state) {
        throw new Error('Extend the render method to add your plugin to a DOM element');
    }
    update(state) {
        if (this.el != null) {
            var _classPrivateFieldLoo, _classPrivateFieldLoo2;
            (_classPrivateFieldLoo = (_classPrivateFieldLoo2 = $5d08dd66a9cc6899$var$_classPrivateFieldLooseBase(this, $5d08dd66a9cc6899$var$_updateUI))[$5d08dd66a9cc6899$var$_updateUI]) == null || _classPrivateFieldLoo.call(_classPrivateFieldLoo2, state);
        }
    }
    unmount() {
        if (this.isTargetDOMEl) {
            var _this$el;
            (_this$el = this.el) == null || _this$el.remove();
        }
        this.onUnmount();
    }
    onMount() {}
    onUnmount() {}
}
var $5d08dd66a9cc6899$export$2e2bcd8739ae039 = $5d08dd66a9cc6899$var$UIPlugin;



/**
 * Low-pass filter using Exponential Moving Averages (aka exponential smoothing)
 * Filters a sequence of values by updating the mixing the previous output value
 * with the new input using the exponential window function
 *
 * @param newValue the n-th value of the sequence
 * @param previousSmoothedValue the exponential average of the first n-1 values
 * @param halfLife value of `dt` to move the smoothed value halfway between `previousFilteredValue` and `newValue`
 * @param dt time elapsed between adding the (n-1)th and the n-th values
 * @returns the exponential average of the first n values
 */ function $4e5b770b58150a1e$export$2e2bcd8739ae039(newValue, previousSmoothedValue, halfLife, dt) {
    if (halfLife === 0 || newValue === previousSmoothedValue) return newValue;
    if (dt === 0) return previousSmoothedValue;
    return newValue + (previousSmoothedValue - newValue) * 2 ** (-dt / halfLife);
}



var $5278b2bb79ab63f5$export$2e2bcd8739ae039 = {
    STATE_ERROR: 'error',
    STATE_WAITING: 'waiting',
    STATE_PREPROCESSING: 'preprocessing',
    STATE_UPLOADING: 'uploading',
    STATE_POSTPROCESSING: 'postprocessing',
    STATE_COMPLETE: 'complete'
};



var $02c2aab7657be691$exports = {};
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    'use strict';
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = '';
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (arg) classes = appendClass(classes, parseValue(arg));
        }
        return classes;
    }
    function parseValue(arg) {
        if (typeof arg === 'string' || typeof arg === 'number') return arg;
        if (typeof arg !== 'object') return '';
        if (Array.isArray(arg)) return classNames.apply(null, arg);
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) return arg.toString();
        var classes = '';
        for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes = appendClass(classes, key);
        return classes;
    }
    function appendClass(value, newClass) {
        if (!newClass) return value;
        if (value) return value + ' ' + newClass;
        return value + newClass;
    }
    if ($02c2aab7657be691$exports) {
        classNames.default = classNames;
        $02c2aab7657be691$exports = classNames;
    } else if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) // register as 'classnames', consistent with npm package name
    define('classnames', [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();



function $3d16a6a6f033a885$export$2e2bcd8739ae039(files) {
    const values = [];
    let mode = 'indeterminate';
    let message;
    for (const { progress: progress } of Object.values(files)){
        const { preprocess: preprocess, postprocess: postprocess } = progress;
        // In the future we should probably do this differently. For now we'll take the
        // mode and message from the first file…
        if (message == null && (preprocess || postprocess)) ({ mode: mode, message: message } = preprocess || postprocess);
        if ((preprocess == null ? void 0 : preprocess.mode) === 'determinate') values.push(preprocess.value);
        if ((postprocess == null ? void 0 : postprocess.mode) === 'determinate') values.push(postprocess.value);
    }
    const value = values.reduce((total, progressValue)=>{
        return total + progressValue / values.length;
    }, 0);
    return {
        mode: mode,
        message: message,
        value: value
    };
}





function $1bd6564471caa0d9$export$2e2bcd8739ae039(rawSeconds) {
    const hours = Math.floor(rawSeconds / 3600) % 24;
    const minutes = Math.floor(rawSeconds / 60) % 60;
    const seconds = Math.floor(rawSeconds % 60);
    return {
        hours: hours,
        minutes: minutes,
        seconds: seconds
    };
}


function $cf4f21df8a3b103f$export$2e2bcd8739ae039(seconds) {
    const time = (0, $1bd6564471caa0d9$export$2e2bcd8739ae039)(seconds);
    // Only display hours and minutes if they are greater than 0 but always
    // display minutes if hours is being displayed
    // Display a leading zero if the there is a preceding unit: 1m 05s, but 5s
    const hoursStr = time.hours === 0 ? '' : `${time.hours}h`;
    const minutesStr = time.minutes === 0 ? '' : `${time.hours === 0 ? time.minutes : ` ${time.minutes.toString(10).padStart(2, '0')}`}m`;
    const secondsStr = time.hours !== 0 ? '' : `${time.minutes === 0 ? time.seconds : ` ${time.seconds.toString(10).padStart(2, '0')}`}s`;
    return `${hoursStr}${minutesStr}${secondsStr}`;
}



const $c0c4f933fc4ac9a2$var$DOT = `\u00B7`;
const $c0c4f933fc4ac9a2$var$renderDot = ()=>` ${$c0c4f933fc4ac9a2$var$DOT} `;
function $c0c4f933fc4ac9a2$export$8fd979504d9f59d1(props) {
    const { newFiles: newFiles, isUploadStarted: isUploadStarted, recoveredState: recoveredState, i18n: i18n, uploadState: uploadState, isSomeGhost: isSomeGhost, startUpload: startUpload } = props;
    const uploadBtnClassNames = (0, (/*@__PURE__*/$parcel$interopDefault($02c2aab7657be691$exports)))('uppy-u-reset', 'uppy-c-btn', 'uppy-StatusBar-actionBtn', 'uppy-StatusBar-actionBtn--upload', {
        'uppy-c-btn-primary': uploadState === (0, $5278b2bb79ab63f5$export$2e2bcd8739ae039).STATE_WAITING
    }, {
        'uppy-StatusBar-actionBtn--disabled': isSomeGhost
    });
    const uploadBtnText = newFiles && isUploadStarted && !recoveredState ? i18n('uploadXNewFiles', {
        smart_count: newFiles
    }) : i18n('uploadXFiles', {
        smart_count: newFiles
    });
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("button", {
        type: "button",
        className: uploadBtnClassNames,
        "aria-label": i18n('uploadXFiles', {
            smart_count: newFiles
        }),
        onClick: startUpload,
        disabled: isSomeGhost,
        "data-uppy-super-focusable": true
    }, uploadBtnText);
}
function $c0c4f933fc4ac9a2$export$d0263dca13d9e524(props) {
    const { i18n: i18n, uppy: uppy } = props;
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("button", {
        type: "button",
        className: "uppy-u-reset uppy-c-btn uppy-StatusBar-actionBtn uppy-StatusBar-actionBtn--retry",
        "aria-label": i18n('retryUpload'),
        onClick: ()=>uppy.retryAll().catch(()=>{
            /* Error reported and handled via an event */ }),
        "data-uppy-super-focusable": true,
        "data-cy": "retry"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("svg", {
        "aria-hidden": "true",
        focusable: "false",
        className: "uppy-c-icon",
        width: "8",
        height: "10",
        viewBox: "0 0 8 10"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        d: "M4 2.408a2.75 2.75 0 1 0 2.75 2.75.626.626 0 0 1 1.25.018v.023a4 4 0 1 1-4-4.041V.25a.25.25 0 0 1 .389-.208l2.299 1.533a.25.25 0 0 1 0 .416l-2.3 1.533A.25.25 0 0 1 4 3.316v-.908z"
    })), i18n('retry'));
}
function $c0c4f933fc4ac9a2$export$bda6e5e4654fa168(props) {
    const { i18n: i18n, uppy: uppy } = props;
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("button", {
        type: "button",
        className: "uppy-u-reset uppy-StatusBar-actionCircleBtn",
        title: i18n('cancel'),
        "aria-label": i18n('cancel'),
        onClick: ()=>uppy.cancelAll(),
        "data-cy": "cancel",
        "data-uppy-super-focusable": true
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("svg", {
        "aria-hidden": "true",
        focusable: "false",
        className: "uppy-c-icon",
        width: "16",
        height: "16",
        viewBox: "0 0 16 16"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("g", {
        fill: "none",
        fillRule: "evenodd"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("circle", {
        fill: "#888",
        cx: "8",
        cy: "8",
        r: "8"
    }), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        fill: "#FFF",
        d: "M9.283 8l2.567 2.567-1.283 1.283L8 9.283 5.433 11.85 4.15 10.567 6.717 8 4.15 5.433 5.433 4.15 8 6.717l2.567-2.567 1.283 1.283z"
    }))));
}
function $c0c4f933fc4ac9a2$export$f8fda1be68e432db(props) {
    const { isAllPaused: isAllPaused, i18n: i18n, isAllComplete: isAllComplete, resumableUploads: resumableUploads, uppy: uppy } = props;
    const title = isAllPaused ? i18n('resume') : i18n('pause');
    function togglePauseResume() {
        if (isAllComplete) return;
        if (!resumableUploads) {
            uppy.cancelAll();
            return;
        }
        if (isAllPaused) {
            uppy.resumeAll();
            return;
        }
        uppy.pauseAll();
    }
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("button", {
        title: title,
        "aria-label": title,
        className: "uppy-u-reset uppy-StatusBar-actionCircleBtn",
        type: "button",
        onClick: togglePauseResume,
        "data-cy": "togglePauseResume",
        "data-uppy-super-focusable": true
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("svg", {
        "aria-hidden": "true",
        focusable: "false",
        className: "uppy-c-icon",
        width: "16",
        height: "16",
        viewBox: "0 0 16 16"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("g", {
        fill: "none",
        fillRule: "evenodd"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("circle", {
        fill: "#888",
        cx: "8",
        cy: "8",
        r: "8"
    }), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        fill: "#FFF",
        d: isAllPaused ? 'M6 4.25L11.5 8 6 11.75z' : 'M5 4.5h2v7H5v-7zm4 0h2v7H9v-7z'
    }))));
}
function $c0c4f933fc4ac9a2$export$c5b3ad0eb3665a4a(props) {
    const { i18n: i18n, doneButtonHandler: doneButtonHandler } = props;
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("button", {
        type: "button",
        className: "uppy-u-reset uppy-c-btn uppy-StatusBar-actionBtn uppy-StatusBar-actionBtn--done",
        onClick: doneButtonHandler,
        "data-uppy-super-focusable": true
    }, i18n('done'));
}
function $c0c4f933fc4ac9a2$export$b08b517936747730() {
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("svg", {
        className: "uppy-StatusBar-spinner",
        "aria-hidden": "true",
        focusable: "false",
        width: "14",
        height: "14"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        d: "M13.983 6.547c-.12-2.509-1.64-4.893-3.939-5.936-2.48-1.127-5.488-.656-7.556 1.094C.524 3.367-.398 6.048.162 8.562c.556 2.495 2.46 4.52 4.94 5.183 2.932.784 5.61-.602 7.256-3.015-1.493 1.993-3.745 3.309-6.298 2.868-2.514-.434-4.578-2.349-5.153-4.84a6.226 6.226 0 0 1 2.98-6.778C6.34.586 9.74 1.1 11.373 3.493c.407.596.693 1.282.842 1.988.127.598.073 1.197.161 1.794.078.525.543 1.257 1.15.864.525-.341.49-1.05.456-1.592-.007-.15.02.3 0 0",
        fillRule: "evenodd"
    }));
}
function $c0c4f933fc4ac9a2$export$f10e066f2fffa2e8(props) {
    const { progress: progress } = props;
    const { value: value, mode: mode, message: message } = progress;
    const dot = `\u00B7`;
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-StatusBar-content"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)($c0c4f933fc4ac9a2$export$b08b517936747730, null), mode === 'determinate' ? `${Math.round(value * 100)}% ${dot} ` : '', message);
}
function $c0c4f933fc4ac9a2$export$511da99642518663(props) {
    const { numUploads: numUploads, complete: complete, totalUploadedSize: totalUploadedSize, totalSize: totalSize, totalETA: totalETA, i18n: i18n } = props;
    const ifShowFilesUploadedOfTotal = numUploads > 1;
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-StatusBar-statusSecondary"
    }, ifShowFilesUploadedOfTotal && i18n('filesUploadedOfTotal', {
        complete: complete,
        smart_count: numUploads
    }), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("span", {
        className: "uppy-StatusBar-additionalInfo"
    }, ifShowFilesUploadedOfTotal && $c0c4f933fc4ac9a2$var$renderDot(), i18n('dataUploadedOfTotal', {
        complete: (0, (/*@__PURE__*/$parcel$interopDefault($06e80194017bcce5$exports)))(totalUploadedSize),
        total: (0, (/*@__PURE__*/$parcel$interopDefault($06e80194017bcce5$exports)))(totalSize)
    }), $c0c4f933fc4ac9a2$var$renderDot(), i18n('xTimeLeft', {
        time: (0, $cf4f21df8a3b103f$export$2e2bcd8739ae039)(totalETA)
    })));
}
function $c0c4f933fc4ac9a2$var$FileUploadCount(props) {
    const { i18n: i18n, complete: complete, numUploads: numUploads } = props;
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-StatusBar-statusSecondary"
    }, i18n('filesUploadedOfTotal', {
        complete: complete,
        smart_count: numUploads
    }));
}
function $c0c4f933fc4ac9a2$var$UploadNewlyAddedFiles(props) {
    const { i18n: i18n, newFiles: newFiles, startUpload: startUpload } = props;
    const uploadBtnClassNames = (0, (/*@__PURE__*/$parcel$interopDefault($02c2aab7657be691$exports)))('uppy-u-reset', 'uppy-c-btn', 'uppy-StatusBar-actionBtn', 'uppy-StatusBar-actionBtn--uploadNewlyAdded');
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-StatusBar-statusSecondary"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-StatusBar-statusSecondaryHint"
    }, i18n('xMoreFilesAdded', {
        smart_count: newFiles
    })), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("button", {
        type: "button",
        className: uploadBtnClassNames,
        "aria-label": i18n('uploadXFiles', {
            smart_count: newFiles
        }),
        onClick: startUpload
    }, i18n('upload')));
}
function $c0c4f933fc4ac9a2$export$2d75d7371a967988(props) {
    const { i18n: i18n, supportsUploadProgress: supportsUploadProgress, totalProgress: totalProgress, showProgressDetails: showProgressDetails, isUploadStarted: isUploadStarted, isAllComplete: isAllComplete, isAllPaused: isAllPaused, newFiles: newFiles, numUploads: numUploads, complete: complete, totalUploadedSize: totalUploadedSize, totalSize: totalSize, totalETA: totalETA, startUpload: startUpload } = props;
    const showUploadNewlyAddedFiles = newFiles && isUploadStarted;
    if (!isUploadStarted || isAllComplete) return null;
    const title = isAllPaused ? i18n('paused') : i18n('uploading');
    function renderProgressDetails() {
        if (!isAllPaused && !showUploadNewlyAddedFiles && showProgressDetails) {
            if (supportsUploadProgress) return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)($c0c4f933fc4ac9a2$export$511da99642518663, {
                numUploads: numUploads,
                complete: complete,
                totalUploadedSize: totalUploadedSize,
                totalSize: totalSize,
                totalETA: totalETA,
                i18n: i18n
            });
            return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)($c0c4f933fc4ac9a2$var$FileUploadCount, {
                i18n: i18n,
                complete: complete,
                numUploads: numUploads
            });
        }
        return null;
    }
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-StatusBar-content",
        "aria-label": title,
        title: title
    }, !isAllPaused ? (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)($c0c4f933fc4ac9a2$export$b08b517936747730, null) : null, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-StatusBar-status"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-StatusBar-statusPrimary"
    }, supportsUploadProgress ? `${title}: ${totalProgress}%` : title), renderProgressDetails(), showUploadNewlyAddedFiles ? (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)($c0c4f933fc4ac9a2$var$UploadNewlyAddedFiles, {
        i18n: i18n,
        newFiles: newFiles,
        startUpload: startUpload
    }) : null));
}
function $c0c4f933fc4ac9a2$export$8dc84f0e764ad25e(props) {
    const { i18n: i18n } = props;
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-StatusBar-content",
        role: "status",
        title: i18n('complete')
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-StatusBar-status"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-StatusBar-statusPrimary"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("svg", {
        "aria-hidden": "true",
        focusable: "false",
        className: "uppy-StatusBar-statusIndicator uppy-c-icon",
        width: "15",
        height: "11",
        viewBox: "0 0 15 11"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        d: "M.414 5.843L1.627 4.63l3.472 3.472L13.202 0l1.212 1.213L5.1 10.528z"
    })), i18n('complete'))));
}
function $c0c4f933fc4ac9a2$export$7331502eb9534bdb(props) {
    const { error: error, i18n: i18n, complete: complete, numUploads: numUploads } = props;
    function displayErrorAlert() {
        const errorMessage = `${i18n('uploadFailed')} \n\n ${error}`;
        // eslint-disable-next-line no-alert
        alert(errorMessage); // TODO: move to custom alert implementation
    }
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-StatusBar-content",
        title: i18n('uploadFailed')
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("svg", {
        "aria-hidden": "true",
        focusable: "false",
        className: "uppy-StatusBar-statusIndicator uppy-c-icon",
        width: "11",
        height: "11",
        viewBox: "0 0 11 11"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        d: "M4.278 5.5L0 1.222 1.222 0 5.5 4.278 9.778 0 11 1.222 6.722 5.5 11 9.778 9.778 11 5.5 6.722 1.222 11 0 9.778z"
    })), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-StatusBar-status"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-StatusBar-statusPrimary"
    }, i18n('uploadFailed'), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("button", {
        className: "uppy-u-reset uppy-StatusBar-details",
        "aria-label": i18n('showErrorDetails'),
        "data-microtip-position": "top-right",
        "data-microtip-size": "medium",
        onClick: displayErrorAlert,
        type: "button"
    }, "?")), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)($c0c4f933fc4ac9a2$var$FileUploadCount, {
        i18n: i18n,
        complete: complete,
        numUploads: numUploads
    })));
}


const { STATE_ERROR: $4af84b49d740c94f$var$STATE_ERROR, STATE_WAITING: $4af84b49d740c94f$var$STATE_WAITING, STATE_PREPROCESSING: $4af84b49d740c94f$var$STATE_PREPROCESSING, STATE_UPLOADING: $4af84b49d740c94f$var$STATE_UPLOADING, STATE_POSTPROCESSING: $4af84b49d740c94f$var$STATE_POSTPROCESSING, STATE_COMPLETE: $4af84b49d740c94f$var$STATE_COMPLETE } = (0, $5278b2bb79ab63f5$export$2e2bcd8739ae039);
function $4af84b49d740c94f$export$2e2bcd8739ae039(props) {
    const { newFiles: newFiles, allowNewUpload: allowNewUpload, isUploadInProgress: isUploadInProgress, isAllPaused: isAllPaused, resumableUploads: resumableUploads, error: error, hideUploadButton: hideUploadButton, hidePauseResumeButton: hidePauseResumeButton, hideCancelButton: hideCancelButton, hideRetryButton: hideRetryButton, recoveredState: recoveredState, uploadState: uploadState, totalProgress: totalProgress, files: files, supportsUploadProgress: supportsUploadProgress, hideAfterFinish: hideAfterFinish, isSomeGhost: isSomeGhost, doneButtonHandler: doneButtonHandler, isUploadStarted: isUploadStarted, i18n: i18n, startUpload: startUpload, uppy: uppy, isAllComplete: isAllComplete, showProgressDetails: showProgressDetails, numUploads: numUploads, complete: complete, totalSize: totalSize, totalETA: totalETA, totalUploadedSize: totalUploadedSize } = props;
    function getProgressValue() {
        switch(uploadState){
            case $4af84b49d740c94f$var$STATE_POSTPROCESSING:
            case $4af84b49d740c94f$var$STATE_PREPROCESSING:
                {
                    const progress = (0, $3d16a6a6f033a885$export$2e2bcd8739ae039)(files);
                    if (progress.mode === 'determinate') return progress.value * 100;
                    return totalProgress;
                }
            case $4af84b49d740c94f$var$STATE_ERROR:
                return null;
            case $4af84b49d740c94f$var$STATE_UPLOADING:
                if (!supportsUploadProgress) return null;
                return totalProgress;
            default:
                return totalProgress;
        }
    }
    function getIsIndeterminate() {
        switch(uploadState){
            case $4af84b49d740c94f$var$STATE_POSTPROCESSING:
            case $4af84b49d740c94f$var$STATE_PREPROCESSING:
                {
                    const { mode: mode } = (0, $3d16a6a6f033a885$export$2e2bcd8739ae039)(files);
                    return mode === 'indeterminate';
                }
            case $4af84b49d740c94f$var$STATE_UPLOADING:
                if (!supportsUploadProgress) return true;
                return false;
            default:
                return false;
        }
    }
    function getIsHidden() {
        if (recoveredState) return false;
        switch(uploadState){
            case $4af84b49d740c94f$var$STATE_WAITING:
                return hideUploadButton || newFiles === 0;
            case $4af84b49d740c94f$var$STATE_COMPLETE:
                return hideAfterFinish;
            default:
                return false;
        }
    }
    const progressValue = getProgressValue();
    const isHidden = getIsHidden();
    const width = progressValue != null ? progressValue : 100;
    const showUploadBtn = !error && newFiles && !isUploadInProgress && !isAllPaused && allowNewUpload && !hideUploadButton;
    const showCancelBtn = !hideCancelButton && uploadState !== $4af84b49d740c94f$var$STATE_WAITING && uploadState !== $4af84b49d740c94f$var$STATE_COMPLETE;
    const showPauseResumeBtn = resumableUploads && !hidePauseResumeButton && uploadState === $4af84b49d740c94f$var$STATE_UPLOADING;
    const showRetryBtn = error && !isAllComplete && !hideRetryButton;
    const showDoneBtn = doneButtonHandler && uploadState === $4af84b49d740c94f$var$STATE_COMPLETE;
    const progressClassNames = (0, (/*@__PURE__*/$parcel$interopDefault($02c2aab7657be691$exports)))('uppy-StatusBar-progress', {
        'is-indeterminate': getIsIndeterminate()
    });
    const statusBarClassNames = (0, (/*@__PURE__*/$parcel$interopDefault($02c2aab7657be691$exports)))('uppy-StatusBar', `is-${uploadState}`, {
        'has-ghosts': isSomeGhost
    });
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: statusBarClassNames,
        "aria-hidden": isHidden
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: progressClassNames,
        style: {
            width: `${width}%`
        },
        role: "progressbar",
        "aria-label": `${width}%`,
        "aria-valuetext": `${width}%`,
        "aria-valuemin": 0,
        "aria-valuemax": 100,
        "aria-valuenow": progressValue
    }), (()=>{
        switch(uploadState){
            case $4af84b49d740c94f$var$STATE_PREPROCESSING:
            case $4af84b49d740c94f$var$STATE_POSTPROCESSING:
                return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $c0c4f933fc4ac9a2$export$f10e066f2fffa2e8), {
                    progress: (0, $3d16a6a6f033a885$export$2e2bcd8739ae039)(files)
                });
            case $4af84b49d740c94f$var$STATE_COMPLETE:
                return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $c0c4f933fc4ac9a2$export$8dc84f0e764ad25e), {
                    i18n: i18n
                });
            case $4af84b49d740c94f$var$STATE_ERROR:
                return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $c0c4f933fc4ac9a2$export$7331502eb9534bdb), {
                    error: error,
                    i18n: i18n,
                    numUploads: numUploads,
                    complete: complete
                });
            case $4af84b49d740c94f$var$STATE_UPLOADING:
                return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $c0c4f933fc4ac9a2$export$2d75d7371a967988), {
                    i18n: i18n,
                    supportsUploadProgress: supportsUploadProgress,
                    totalProgress: totalProgress,
                    showProgressDetails: showProgressDetails,
                    isUploadStarted: isUploadStarted,
                    isAllComplete: isAllComplete,
                    isAllPaused: isAllPaused,
                    newFiles: newFiles,
                    numUploads: numUploads,
                    complete: complete,
                    totalUploadedSize: totalUploadedSize,
                    totalSize: totalSize,
                    totalETA: totalETA,
                    startUpload: startUpload
                });
            default:
                return null;
        }
    })(), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-StatusBar-actions"
    }, recoveredState || showUploadBtn ? (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $c0c4f933fc4ac9a2$export$8fd979504d9f59d1), {
        newFiles: newFiles,
        isUploadStarted: isUploadStarted,
        recoveredState: recoveredState,
        i18n: i18n,
        isSomeGhost: isSomeGhost,
        startUpload: startUpload,
        uploadState: uploadState
    }) : null, showRetryBtn ? (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $c0c4f933fc4ac9a2$export$d0263dca13d9e524), {
        i18n: i18n,
        uppy: uppy
    }) : null, showPauseResumeBtn ? (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $c0c4f933fc4ac9a2$export$f8fda1be68e432db), {
        isAllPaused: isAllPaused,
        i18n: i18n,
        isAllComplete: isAllComplete,
        resumableUploads: resumableUploads,
        uppy: uppy
    }) : null, showCancelBtn ? (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $c0c4f933fc4ac9a2$export$bda6e5e4654fa168), {
        i18n: i18n,
        uppy: uppy
    }) : null, showDoneBtn ? (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $c0c4f933fc4ac9a2$export$c5b3ad0eb3665a4a), {
        i18n: i18n,
        doneButtonHandler: doneButtonHandler
    }) : null));
}
$4af84b49d740c94f$export$2e2bcd8739ae039.defaultProps = {
    doneButtonHandler: undefined,
    hideAfterFinish: false,
    hideCancelButton: false,
    hidePauseResumeButton: false,
    hideRetryButton: false,
    hideUploadButton: undefined,
    showProgressDetails: undefined
};


var $f9ab456b3e2aaacb$export$2e2bcd8739ae039 = {
    strings: {
        // Shown in the status bar while files are being uploaded.
        uploading: 'Uploading',
        // Shown in the status bar once all files have been uploaded.
        complete: 'Complete',
        // Shown in the status bar if an upload failed.
        uploadFailed: 'Upload failed',
        // Shown in the status bar while the upload is paused.
        paused: 'Paused',
        // Used as the label for the button that retries an upload.
        retry: 'Retry',
        // Used as the label for the button that cancels an upload.
        cancel: 'Cancel',
        // Used as the label for the button that pauses an upload.
        pause: 'Pause',
        // Used as the label for the button that resumes an upload.
        resume: 'Resume',
        // Used as the label for the button that resets the upload state after an upload
        done: 'Done',
        // When `showProgressDetails` is set, shows the number of files that have been fully uploaded so far.
        filesUploadedOfTotal: {
            0: '%{complete} of %{smart_count} file uploaded',
            1: '%{complete} of %{smart_count} files uploaded'
        },
        // When `showProgressDetails` is set, shows the amount of bytes that have been uploaded so far.
        dataUploadedOfTotal: '%{complete} of %{total}',
        // When `showProgressDetails` is set, shows an estimation of how long the upload will take to complete.
        xTimeLeft: '%{time} left',
        // Used as the label for the button that starts an upload.
        uploadXFiles: {
            0: 'Upload %{smart_count} file',
            1: 'Upload %{smart_count} files'
        },
        // Used as the label for the button that starts an upload, if another upload has been started in the past
        // and new files were added later.
        uploadXNewFiles: {
            0: 'Upload +%{smart_count} file',
            1: 'Upload +%{smart_count} files'
        },
        upload: 'Upload',
        retryUpload: 'Retry upload',
        xMoreFilesAdded: {
            0: '%{smart_count} more file added',
            1: '%{smart_count} more files added'
        },
        showErrorDetails: 'Show error details'
    }
};


function $f22a72e7b80fdb1a$var$_classPrivateFieldLooseBase(receiver, privateKey) {
    if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) throw new TypeError("attempted to use private field on non-instance");
    return receiver;
}
var $f22a72e7b80fdb1a$var$id = 0;
function $f22a72e7b80fdb1a$var$_classPrivateFieldLooseKey(name) {
    return "__private_" + $f22a72e7b80fdb1a$var$id++ + "_" + name;
}
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore We don't want TS to generate types for the package.json
const $f22a72e7b80fdb1a$var$packageJson = {
    "version": "3.3.3"
};
const $f22a72e7b80fdb1a$var$speedFilterHalfLife = 2000;
const $f22a72e7b80fdb1a$var$ETAFilterHalfLife = 2000;
function $f22a72e7b80fdb1a$var$getUploadingState(error, isAllComplete, recoveredState, files) {
    if (error) return (0, $5278b2bb79ab63f5$export$2e2bcd8739ae039).STATE_ERROR;
    if (isAllComplete) return (0, $5278b2bb79ab63f5$export$2e2bcd8739ae039).STATE_COMPLETE;
    if (recoveredState) return (0, $5278b2bb79ab63f5$export$2e2bcd8739ae039).STATE_WAITING;
    let state = (0, $5278b2bb79ab63f5$export$2e2bcd8739ae039).STATE_WAITING;
    const fileIDs = Object.keys(files);
    for(let i = 0; i < fileIDs.length; i++){
        const { progress: progress } = files[fileIDs[i]];
        // If ANY files are being uploaded right now, show the uploading state.
        if (progress.uploadStarted && !progress.uploadComplete) return (0, $5278b2bb79ab63f5$export$2e2bcd8739ae039).STATE_UPLOADING;
        // If files are being preprocessed AND postprocessed at this time, we show the
        // preprocess state. If any files are being uploaded we show uploading.
        if (progress.preprocess) state = (0, $5278b2bb79ab63f5$export$2e2bcd8739ae039).STATE_PREPROCESSING;
        // If NO files are being preprocessed or uploaded right now, but some files are
        // being postprocessed, show the postprocess state.
        if (progress.postprocess && state !== (0, $5278b2bb79ab63f5$export$2e2bcd8739ae039).STATE_PREPROCESSING) state = (0, $5278b2bb79ab63f5$export$2e2bcd8739ae039).STATE_POSTPROCESSING;
    }
    return state;
}
// set default options, must be kept in sync with @uppy/react/src/StatusBar.js
const $f22a72e7b80fdb1a$var$defaultOptions = {
    target: 'body',
    hideUploadButton: false,
    hideRetryButton: false,
    hidePauseResumeButton: false,
    hideCancelButton: false,
    showProgressDetails: false,
    hideAfterFinish: true,
    doneButtonHandler: null
};
/**
 * StatusBar: renders a status bar with upload/pause/resume/cancel/retry buttons,
 * progress percentage and time remaining.
 */ var $f22a72e7b80fdb1a$var$_lastUpdateTime = /*#__PURE__*/ $f22a72e7b80fdb1a$var$_classPrivateFieldLooseKey("lastUpdateTime");
var $f22a72e7b80fdb1a$var$_previousUploadedBytes = /*#__PURE__*/ $f22a72e7b80fdb1a$var$_classPrivateFieldLooseKey("previousUploadedBytes");
var $f22a72e7b80fdb1a$var$_previousSpeed = /*#__PURE__*/ $f22a72e7b80fdb1a$var$_classPrivateFieldLooseKey("previousSpeed");
var $f22a72e7b80fdb1a$var$_previousETA = /*#__PURE__*/ $f22a72e7b80fdb1a$var$_classPrivateFieldLooseKey("previousETA");
var $f22a72e7b80fdb1a$var$_computeSmoothETA = /*#__PURE__*/ $f22a72e7b80fdb1a$var$_classPrivateFieldLooseKey("computeSmoothETA");
var $f22a72e7b80fdb1a$var$_onUploadStart = /*#__PURE__*/ $f22a72e7b80fdb1a$var$_classPrivateFieldLooseKey("onUploadStart");
class $f22a72e7b80fdb1a$export$2e2bcd8739ae039 extends (0, $5d08dd66a9cc6899$export$2e2bcd8739ae039) {
    constructor(uppy, opts){
        super(uppy, {
            ...$f22a72e7b80fdb1a$var$defaultOptions,
            ...opts
        });
        Object.defineProperty(this, $f22a72e7b80fdb1a$var$_computeSmoothETA, {
            value: $f22a72e7b80fdb1a$var$_computeSmoothETA2
        });
        Object.defineProperty(this, $f22a72e7b80fdb1a$var$_lastUpdateTime, {
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, $f22a72e7b80fdb1a$var$_previousUploadedBytes, {
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, $f22a72e7b80fdb1a$var$_previousSpeed, {
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, $f22a72e7b80fdb1a$var$_previousETA, {
            writable: true,
            value: void 0
        });
        this.startUpload = ()=>{
            return this.uppy.upload().catch(()=>{
            // Error logged in Core
            });
        };
        Object.defineProperty(this, $f22a72e7b80fdb1a$var$_onUploadStart, {
            writable: true,
            value: ()=>{
                const { recoveredState: recoveredState } = this.uppy.getState();
                $f22a72e7b80fdb1a$var$_classPrivateFieldLooseBase(this, $f22a72e7b80fdb1a$var$_previousSpeed)[$f22a72e7b80fdb1a$var$_previousSpeed] = null;
                $f22a72e7b80fdb1a$var$_classPrivateFieldLooseBase(this, $f22a72e7b80fdb1a$var$_previousETA)[$f22a72e7b80fdb1a$var$_previousETA] = null;
                if (recoveredState) {
                    $f22a72e7b80fdb1a$var$_classPrivateFieldLooseBase(this, $f22a72e7b80fdb1a$var$_previousUploadedBytes)[$f22a72e7b80fdb1a$var$_previousUploadedBytes] = Object.values(recoveredState.files).reduce((pv, _ref)=>{
                        let { progress: progress } = _ref;
                        return pv + progress.bytesUploaded;
                    }, 0);
                    // We don't set `#lastUpdateTime` at this point because the upload won't
                    // actually resume until the user asks for it.
                    this.uppy.emit('restore-confirmed');
                    return;
                }
                $f22a72e7b80fdb1a$var$_classPrivateFieldLooseBase(this, $f22a72e7b80fdb1a$var$_lastUpdateTime)[$f22a72e7b80fdb1a$var$_lastUpdateTime] = performance.now();
                $f22a72e7b80fdb1a$var$_classPrivateFieldLooseBase(this, $f22a72e7b80fdb1a$var$_previousUploadedBytes)[$f22a72e7b80fdb1a$var$_previousUploadedBytes] = 0;
            }
        });
        this.id = this.opts.id || 'StatusBar';
        this.title = 'StatusBar';
        this.type = 'progressindicator';
        this.defaultLocale = (0, $f9ab456b3e2aaacb$export$2e2bcd8739ae039);
        this.i18nInit();
        this.render = this.render.bind(this);
        this.install = this.install.bind(this);
    }
    render(state) {
        const { capabilities: capabilities, files: files, allowNewUpload: allowNewUpload, totalProgress: totalProgress, error: error, recoveredState: recoveredState } = state;
        const { newFiles: newFiles, startedFiles: startedFiles, completeFiles: completeFiles, isUploadStarted: isUploadStarted, isAllComplete: isAllComplete, isAllErrored: isAllErrored, isAllPaused: isAllPaused, isUploadInProgress: isUploadInProgress, isSomeGhost: isSomeGhost } = this.uppy.getObjectOfFilesPerState();
        // If some state was recovered, we want to show Upload button/counter
        // for all the files, because in this case it’s not an Upload button,
        // but “Confirm Restore Button”
        const newFilesOrRecovered = recoveredState ? Object.values(files) : newFiles;
        const resumableUploads = !!capabilities.resumableUploads;
        const supportsUploadProgress = capabilities.uploadProgress !== false;
        let totalSize = 0;
        let totalUploadedSize = 0;
        startedFiles.forEach((file)=>{
            totalSize += file.progress.bytesTotal || 0;
            totalUploadedSize += file.progress.bytesUploaded || 0;
        });
        const totalETA = $f22a72e7b80fdb1a$var$_classPrivateFieldLooseBase(this, $f22a72e7b80fdb1a$var$_computeSmoothETA)[$f22a72e7b80fdb1a$var$_computeSmoothETA]({
            uploaded: totalUploadedSize,
            total: totalSize,
            remaining: totalSize - totalUploadedSize
        });
        return (0, $4af84b49d740c94f$export$2e2bcd8739ae039)({
            error: error,
            uploadState: $f22a72e7b80fdb1a$var$getUploadingState(error, isAllComplete, recoveredState, state.files || {}),
            allowNewUpload: allowNewUpload,
            totalProgress: totalProgress,
            totalSize: totalSize,
            totalUploadedSize: totalUploadedSize,
            isAllComplete: false,
            isAllPaused: isAllPaused,
            isAllErrored: // @ts-expect-error TODO: remove this in 4.x branch
            isAllErrored,
            isUploadStarted: isUploadStarted,
            isUploadInProgress: isUploadInProgress,
            isSomeGhost: isSomeGhost,
            recoveredState: recoveredState,
            complete: completeFiles.length,
            newFiles: newFilesOrRecovered.length,
            numUploads: startedFiles.length,
            totalETA: totalETA,
            files: files,
            i18n: this.i18n,
            uppy: this.uppy,
            startUpload: this.startUpload,
            doneButtonHandler: this.opts.doneButtonHandler,
            resumableUploads: resumableUploads,
            supportsUploadProgress: supportsUploadProgress,
            showProgressDetails: this.opts.showProgressDetails,
            hideUploadButton: this.opts.hideUploadButton,
            hideRetryButton: this.opts.hideRetryButton,
            hidePauseResumeButton: this.opts.hidePauseResumeButton,
            hideCancelButton: this.opts.hideCancelButton,
            hideAfterFinish: this.opts.hideAfterFinish,
            // ts-expect-error TODO: remove this in 4.x branch
            isTargetDOMEl: this.isTargetDOMEl
        });
    }
    onMount() {
        // Set the text direction if the page has not defined one.
        const element = this.el;
        const direction = (0, $82cce0c04a5d7a26$export$2e2bcd8739ae039)(element);
        if (!direction) element.dir = 'ltr';
    }
    install() {
        const { target: target } = this.opts;
        if (target) this.mount(target, this);
        this.uppy.on('upload', $f22a72e7b80fdb1a$var$_classPrivateFieldLooseBase(this, $f22a72e7b80fdb1a$var$_onUploadStart)[$f22a72e7b80fdb1a$var$_onUploadStart]);
        // To cover the use case where the status bar is installed while the upload
        // has started, we set `lastUpdateTime` right away.
        $f22a72e7b80fdb1a$var$_classPrivateFieldLooseBase(this, $f22a72e7b80fdb1a$var$_lastUpdateTime)[$f22a72e7b80fdb1a$var$_lastUpdateTime] = performance.now();
        $f22a72e7b80fdb1a$var$_classPrivateFieldLooseBase(this, $f22a72e7b80fdb1a$var$_previousUploadedBytes)[$f22a72e7b80fdb1a$var$_previousUploadedBytes] = this.uppy.getFiles().reduce((pv, file)=>pv + file.progress.bytesUploaded, 0);
    }
    uninstall() {
        this.unmount();
        this.uppy.off('upload', $f22a72e7b80fdb1a$var$_classPrivateFieldLooseBase(this, $f22a72e7b80fdb1a$var$_onUploadStart)[$f22a72e7b80fdb1a$var$_onUploadStart]);
    }
}
function $f22a72e7b80fdb1a$var$_computeSmoothETA2(totalBytes) {
    var _classPrivateFieldLoo, _classPrivateFieldLoo2;
    if (totalBytes.total === 0 || totalBytes.remaining === 0) return 0;
    // When state is restored, lastUpdateTime is still nullish at this point.
    (_classPrivateFieldLoo2 = (_classPrivateFieldLoo = $f22a72e7b80fdb1a$var$_classPrivateFieldLooseBase(this, $f22a72e7b80fdb1a$var$_lastUpdateTime))[$f22a72e7b80fdb1a$var$_lastUpdateTime]) != null ? _classPrivateFieldLoo2 : _classPrivateFieldLoo[$f22a72e7b80fdb1a$var$_lastUpdateTime] = performance.now();
    const dt = performance.now() - $f22a72e7b80fdb1a$var$_classPrivateFieldLooseBase(this, $f22a72e7b80fdb1a$var$_lastUpdateTime)[$f22a72e7b80fdb1a$var$_lastUpdateTime];
    if (dt === 0) {
        var _classPrivateFieldLoo3;
        return Math.round(((_classPrivateFieldLoo3 = $f22a72e7b80fdb1a$var$_classPrivateFieldLooseBase(this, $f22a72e7b80fdb1a$var$_previousETA)[$f22a72e7b80fdb1a$var$_previousETA]) != null ? _classPrivateFieldLoo3 : 0) / 100) / 10;
    }
    const uploadedBytesSinceLastTick = totalBytes.uploaded - $f22a72e7b80fdb1a$var$_classPrivateFieldLooseBase(this, $f22a72e7b80fdb1a$var$_previousUploadedBytes)[$f22a72e7b80fdb1a$var$_previousUploadedBytes];
    $f22a72e7b80fdb1a$var$_classPrivateFieldLooseBase(this, $f22a72e7b80fdb1a$var$_previousUploadedBytes)[$f22a72e7b80fdb1a$var$_previousUploadedBytes] = totalBytes.uploaded;
    // uploadedBytesSinceLastTick can be negative in some cases (packet loss?)
    // in which case, we wait for next tick to update ETA.
    if (uploadedBytesSinceLastTick <= 0) {
        var _classPrivateFieldLoo4;
        return Math.round(((_classPrivateFieldLoo4 = $f22a72e7b80fdb1a$var$_classPrivateFieldLooseBase(this, $f22a72e7b80fdb1a$var$_previousETA)[$f22a72e7b80fdb1a$var$_previousETA]) != null ? _classPrivateFieldLoo4 : 0) / 100) / 10;
    }
    const currentSpeed = uploadedBytesSinceLastTick / dt;
    const filteredSpeed = $f22a72e7b80fdb1a$var$_classPrivateFieldLooseBase(this, $f22a72e7b80fdb1a$var$_previousSpeed)[$f22a72e7b80fdb1a$var$_previousSpeed] == null ? currentSpeed : (0, $4e5b770b58150a1e$export$2e2bcd8739ae039)(currentSpeed, $f22a72e7b80fdb1a$var$_classPrivateFieldLooseBase(this, $f22a72e7b80fdb1a$var$_previousSpeed)[$f22a72e7b80fdb1a$var$_previousSpeed], $f22a72e7b80fdb1a$var$speedFilterHalfLife, dt);
    $f22a72e7b80fdb1a$var$_classPrivateFieldLooseBase(this, $f22a72e7b80fdb1a$var$_previousSpeed)[$f22a72e7b80fdb1a$var$_previousSpeed] = filteredSpeed;
    const instantETA = totalBytes.remaining / filteredSpeed;
    const updatedPreviousETA = Math.max($f22a72e7b80fdb1a$var$_classPrivateFieldLooseBase(this, $f22a72e7b80fdb1a$var$_previousETA)[$f22a72e7b80fdb1a$var$_previousETA] - dt, 0);
    const filteredETA = $f22a72e7b80fdb1a$var$_classPrivateFieldLooseBase(this, $f22a72e7b80fdb1a$var$_previousETA)[$f22a72e7b80fdb1a$var$_previousETA] == null ? instantETA : (0, $4e5b770b58150a1e$export$2e2bcd8739ae039)(instantETA, updatedPreviousETA, $f22a72e7b80fdb1a$var$ETAFilterHalfLife, dt);
    $f22a72e7b80fdb1a$var$_classPrivateFieldLooseBase(this, $f22a72e7b80fdb1a$var$_previousETA)[$f22a72e7b80fdb1a$var$_previousETA] = filteredETA;
    $f22a72e7b80fdb1a$var$_classPrivateFieldLooseBase(this, $f22a72e7b80fdb1a$var$_lastUpdateTime)[$f22a72e7b80fdb1a$var$_lastUpdateTime] = performance.now();
    return Math.round(filteredETA / 100) / 10;
}
$f22a72e7b80fdb1a$export$2e2bcd8739ae039.VERSION = $f22a72e7b80fdb1a$var$packageJson.version;




/* eslint-disable jsx-a11y/no-noninteractive-element-interactions  */ /* eslint-disable jsx-a11y/click-events-have-key-events */ 


const $aaa56faedf37f661$var$TRANSITION_MS = 300;
class $aaa56faedf37f661$export$2e2bcd8739ae039 extends (0, $4d2e93495e50cc85$export$16fa2f45be04daa8) {
    constructor(){
        super(...arguments);
        this.ref = (0, $4d2e93495e50cc85$export$7d1e3a5e95ceca43)();
    }
    componentWillEnter(callback) {
        this.ref.current.style.opacity = '1';
        this.ref.current.style.transform = 'none';
        setTimeout(callback, $aaa56faedf37f661$var$TRANSITION_MS);
    }
    componentWillLeave(callback) {
        this.ref.current.style.opacity = '0';
        this.ref.current.style.transform = 'translateY(350%)';
        setTimeout(callback, $aaa56faedf37f661$var$TRANSITION_MS);
    }
    render() {
        const { children: children } = this.props;
        return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
            className: "uppy-Informer-animated",
            ref: this.ref
        }, children);
    }
}


// INFO: not typing copy pasted libarary code
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
/* eslint-disable */ /**
 * @source https://github.com/developit/preact-transition-group
 */ 
function $39136bc8da03ed4c$var$assign(obj, props) {
    return Object.assign(obj, props);
}
function $39136bc8da03ed4c$var$getKey(vnode, fallback) {
    var _vnode$key;
    return (_vnode$key = vnode == null ? void 0 : vnode.key) != null ? _vnode$key : fallback;
}
function $39136bc8da03ed4c$var$linkRef(component, name) {
    const cache = component._ptgLinkedRefs || (component._ptgLinkedRefs = {});
    return cache[name] || (cache[name] = (c)=>{
        component.refs[name] = c;
    });
}
function $39136bc8da03ed4c$var$getChildMapping(children) {
    const out = {};
    for(let i = 0; i < children.length; i++)if (children[i] != null) {
        const key = $39136bc8da03ed4c$var$getKey(children[i], i.toString(36));
        out[key] = children[i];
    }
    return out;
}
function $39136bc8da03ed4c$var$mergeChildMappings(prev, next) {
    prev = prev || {};
    next = next || {};
    const getValueForKey = (key)=>next.hasOwnProperty(key) ? next[key] : prev[key];
    // For each key of `next`, the list of keys to insert before that key in
    // the combined list
    const nextKeysPending = {};
    let pendingKeys = [];
    for(const prevKey in prev){
        if (next.hasOwnProperty(prevKey)) {
            if (pendingKeys.length) {
                nextKeysPending[prevKey] = pendingKeys;
                pendingKeys = [];
            }
        } else pendingKeys.push(prevKey);
    }
    const childMapping = {};
    for(const nextKey in next){
        if (nextKeysPending.hasOwnProperty(nextKey)) for(let i = 0; i < nextKeysPending[nextKey].length; i++){
            const pendingNextKey = nextKeysPending[nextKey][i];
            childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
        }
        childMapping[nextKey] = getValueForKey(nextKey);
    }
    // Finally, add the keys which didn't appear before any key in `next`
    for(let i = 0; i < pendingKeys.length; i++)childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
    return childMapping;
}
const $39136bc8da03ed4c$var$identity = (i)=>i;
class $39136bc8da03ed4c$var$TransitionGroup extends (0, $4d2e93495e50cc85$export$16fa2f45be04daa8) {
    constructor(props, context){
        super(props, context);
        this.refs = {};
        this.state = {
            children: $39136bc8da03ed4c$var$getChildMapping((0, $4d2e93495e50cc85$export$47e4c5b300681277)((0, $4d2e93495e50cc85$export$47e4c5b300681277)(this.props.children)) || [])
        };
        this.performAppear = this.performAppear.bind(this);
        this.performEnter = this.performEnter.bind(this);
        this.performLeave = this.performLeave.bind(this);
    }
    componentWillMount() {
        this.currentlyTransitioningKeys = {};
        this.keysToAbortLeave = [];
        this.keysToEnter = [];
        this.keysToLeave = [];
    }
    componentDidMount() {
        const initialChildMapping = this.state.children;
        for(const key in initialChildMapping)if (initialChildMapping[key]) // this.performAppear(getKey(initialChildMapping[key], key));
        this.performAppear(key);
    }
    componentWillReceiveProps(nextProps) {
        const nextChildMapping = $39136bc8da03ed4c$var$getChildMapping((0, $4d2e93495e50cc85$export$47e4c5b300681277)(nextProps.children) || []);
        const prevChildMapping = this.state.children;
        this.setState((prevState)=>({
                children: $39136bc8da03ed4c$var$mergeChildMappings(prevState.children, nextChildMapping)
            }));
        let key;
        for(key in nextChildMapping)if (nextChildMapping.hasOwnProperty(key)) {
            const hasPrev = prevChildMapping && prevChildMapping.hasOwnProperty(key);
            // We should re-enter the component and abort its leave function
            if (nextChildMapping[key] && hasPrev && this.currentlyTransitioningKeys[key]) {
                this.keysToEnter.push(key);
                this.keysToAbortLeave.push(key);
            } else if (nextChildMapping[key] && !hasPrev && !this.currentlyTransitioningKeys[key]) this.keysToEnter.push(key);
        }
        for(key in prevChildMapping)if (prevChildMapping.hasOwnProperty(key)) {
            const hasNext = nextChildMapping && nextChildMapping.hasOwnProperty(key);
            if (prevChildMapping[key] && !hasNext && !this.currentlyTransitioningKeys[key]) this.keysToLeave.push(key);
        }
    }
    componentDidUpdate() {
        const { keysToEnter: keysToEnter } = this;
        this.keysToEnter = [];
        keysToEnter.forEach(this.performEnter);
        const { keysToLeave: keysToLeave } = this;
        this.keysToLeave = [];
        keysToLeave.forEach(this.performLeave);
    }
    _finishAbort(key) {
        const idx = this.keysToAbortLeave.indexOf(key);
        if (idx !== -1) this.keysToAbortLeave.splice(idx, 1);
    }
    performAppear(key) {
        this.currentlyTransitioningKeys[key] = true;
        const component = this.refs[key];
        if (component != null && component.componentWillAppear) component.componentWillAppear(this._handleDoneAppearing.bind(this, key));
        else this._handleDoneAppearing(key);
    }
    _handleDoneAppearing(key) {
        const component = this.refs[key];
        if (component != null && component.componentDidAppear) component.componentDidAppear();
        delete this.currentlyTransitioningKeys[key];
        this._finishAbort(key);
        const currentChildMapping = $39136bc8da03ed4c$var$getChildMapping((0, $4d2e93495e50cc85$export$47e4c5b300681277)(this.props.children) || []);
        if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) // This was removed before it had fully appeared. Remove it.
        this.performLeave(key);
    }
    performEnter(key) {
        this.currentlyTransitioningKeys[key] = true;
        const component = this.refs[key];
        if (component != null && component.componentWillEnter) component.componentWillEnter(this._handleDoneEntering.bind(this, key));
        else this._handleDoneEntering(key);
    }
    _handleDoneEntering(key) {
        const component = this.refs[key];
        if (component != null && component.componentDidEnter) component.componentDidEnter();
        delete this.currentlyTransitioningKeys[key];
        this._finishAbort(key);
        const currentChildMapping = $39136bc8da03ed4c$var$getChildMapping((0, $4d2e93495e50cc85$export$47e4c5b300681277)(this.props.children) || []);
        if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) // This was removed before it had fully entered. Remove it.
        this.performLeave(key);
    }
    performLeave(key) {
        // If we should immediately abort this leave function,
        // don't run the leave transition at all.
        const idx = this.keysToAbortLeave.indexOf(key);
        if (idx !== -1) return;
        this.currentlyTransitioningKeys[key] = true;
        const component = this.refs[key];
        if (component != null && component.componentWillLeave) component.componentWillLeave(this._handleDoneLeaving.bind(this, key));
        else // Note that this is somewhat dangerous b/c it calls setState()
        // again, effectively mutating the component before all the work
        // is done.
        this._handleDoneLeaving(key);
    }
    _handleDoneLeaving(key) {
        // If we should immediately abort the leave,
        // then skip this altogether
        const idx = this.keysToAbortLeave.indexOf(key);
        if (idx !== -1) return;
        const component = this.refs[key];
        if (component != null && component.componentDidLeave) component.componentDidLeave();
        delete this.currentlyTransitioningKeys[key];
        const currentChildMapping = $39136bc8da03ed4c$var$getChildMapping((0, $4d2e93495e50cc85$export$47e4c5b300681277)(this.props.children) || []);
        if (currentChildMapping && currentChildMapping.hasOwnProperty(key)) // This entered again before it fully left. Add it again.
        this.performEnter(key);
        else {
            const children = $39136bc8da03ed4c$var$assign({}, this.state.children);
            delete children[key];
            this.setState({
                children: children
            });
        }
    }
    render(_ref, _ref2) {
        let { childFactory: childFactory, transitionLeave: transitionLeave, transitionName: transitionName, transitionAppear: transitionAppear, transitionEnter: transitionEnter, transitionLeaveTimeout: transitionLeaveTimeout, transitionEnterTimeout: transitionEnterTimeout, transitionAppearTimeout: transitionAppearTimeout, component: component, ...props } = _ref;
        let { children: children } = _ref2;
        // TODO: we could get rid of the need for the wrapper node
        // by cloning a single child
        const childrenToRender = Object.entries(children).map((_ref3)=>{
            let [key, child] = _ref3;
            if (!child) return undefined;
            const ref = $39136bc8da03ed4c$var$linkRef(this, key);
            return (0, $4d2e93495e50cc85$export$e530037191fcd5d7)(childFactory(child), {
                ref: ref,
                key: key
            });
        }).filter(Boolean);
        return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)(component, props, childrenToRender);
    }
}
$39136bc8da03ed4c$var$TransitionGroup.defaultProps = {
    component: 'span',
    childFactory: $39136bc8da03ed4c$var$identity
};
var $39136bc8da03ed4c$export$2e2bcd8739ae039 = $39136bc8da03ed4c$var$TransitionGroup;


// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore We don't want TS to generate types for the package.json
const $2d1e3e0d76faae78$var$packageJson = {
    "version": "3.1.0"
};
class $2d1e3e0d76faae78$export$2e2bcd8739ae039 extends (0, $5d08dd66a9cc6899$export$2e2bcd8739ae039) {
    constructor(uppy, opts){
        super(uppy, opts);
        this.render = (state)=>{
            return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
                className: "uppy uppy-Informer"
            }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $39136bc8da03ed4c$export$2e2bcd8739ae039), null, state.info.map((info)=>(0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $aaa56faedf37f661$export$2e2bcd8739ae039), {
                    key: info.message
                }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("p", {
                    role: "alert"
                }, info.message, ' ', info.details && (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("span", {
                    "aria-label": info.details,
                    "data-microtip-position": "top-left",
                    "data-microtip-size": "medium",
                    role: "tooltip",
                    onClick: ()=>// eslint-disable-next-line no-alert
                        alert(`${info.message} \n\n ${info.details}`)
                }, "?"))))));
        };
        this.type = 'progressindicator';
        this.id = this.opts.id || 'Informer';
        this.title = 'Informer';
    }
    install() {
        const { target: target } = this.opts;
        if (target) this.mount(target, this);
    }
}
$2d1e3e0d76faae78$export$2e2bcd8739ae039.VERSION = $2d1e3e0d76faae78$var$packageJson.version;





const $8f6efe9c4afa65c2$var$DATA_URL_PATTERN = /^data:([^/]+\/[^,;]+(?:[^,]*?))(;base64)?,([\s\S]*)$/;
function $8f6efe9c4afa65c2$var$dataURItoBlob(dataURI, opts, toFile) {
    var _ref, _opts$mimeType;
    // get the base64 data
    const dataURIData = $8f6efe9c4afa65c2$var$DATA_URL_PATTERN.exec(dataURI);
    // user may provide mime type, if not get it from data URI
    const mimeType = (_ref = (_opts$mimeType = opts.mimeType) != null ? _opts$mimeType : dataURIData == null ? void 0 : dataURIData[1]) != null ? _ref : 'plain/text';
    let data; // We add `!` to tell TS we're OK with `data` being not defined when the dataURI is invalid.
    if ((dataURIData == null ? void 0 : dataURIData[2]) != null) {
        const binary = atob(decodeURIComponent(dataURIData[3]));
        const bytes = new Uint8Array(binary.length);
        for(let i = 0; i < binary.length; i++)bytes[i] = binary.charCodeAt(i);
        data = [
            bytes
        ];
    } else if ((dataURIData == null ? void 0 : dataURIData[3]) != null) data = [
        decodeURIComponent(dataURIData[3])
    ];
    // Convert to a File?
    if (toFile) return new File(data, opts.name || '', {
        type: mimeType
    });
    return new Blob(data, {
        type: mimeType
    });
}
var $8f6efe9c4afa65c2$export$2e2bcd8739ae039 = $8f6efe9c4afa65c2$var$dataURItoBlob;


/**
 * Check if a URL string is an object URL from `URL.createObjectURL`.
 */ function $3b72dc28c9f79a38$export$2e2bcd8739ae039(url) {
    return url.startsWith('blob:');
}


function $2e3a76623b3bbcc9$export$2e2bcd8739ae039(fileType) {
    if (!fileType) return false;
    // list of images that browsers can preview
    return /^[^/]+\/(jpe?g|gif|png|svg|svg\+xml|bmp|webp|avif)$/.test(fileType);
}



var $gnS5A = parcelRequire("gnS5A");
var $7785655e028eb2bd$export$2e2bcd8739ae039 = {
    strings: {
        generatingThumbnails: 'Generating thumbnails...'
    }
};


// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore We don't want TS to generate types for the package.json
const $f92c4ad36d89e394$var$packageJson = {
    "version": "3.1.0"
};
/**
 * Save a <canvas> element's content to a Blob object.
 *
 */ function $f92c4ad36d89e394$var$canvasToBlob(canvas, type, quality) {
    try {
        canvas.getContext('2d').getImageData(0, 0, 1, 1);
    } catch (err) {
        if (err.code === 18) return Promise.reject(new Error('cannot read image, probably an svg with external resources'));
    }
    if (canvas.toBlob) return new Promise((resolve)=>{
        canvas.toBlob(resolve, type, quality);
    }).then((blob)=>{
        if (blob === null) throw new Error('cannot read image, probably an svg with external resources');
        return blob;
    });
    return Promise.resolve().then(()=>{
        return (0, $8f6efe9c4afa65c2$export$2e2bcd8739ae039)(canvas.toDataURL(type, quality), {});
    }).then((blob)=>{
        if (blob === null) throw new Error('could not extract blob, probably an old browser');
        return blob;
    });
}
function $f92c4ad36d89e394$var$rotateImage(image, translate) {
    let w = image.width;
    let h = image.height;
    if (translate.deg === 90 || translate.deg === 270) {
        w = image.height;
        h = image.width;
    }
    const canvas = document.createElement('canvas');
    canvas.width = w;
    canvas.height = h;
    const context = canvas.getContext('2d');
    context.translate(w / 2, h / 2);
    if (translate.canvas) {
        context.rotate(translate.rad);
        context.scale(translate.scaleX, translate.scaleY);
    }
    context.drawImage(image, -image.width / 2, -image.height / 2, image.width, image.height);
    return canvas;
}
/**
 * Make sure the image doesn’t exceed browser/device canvas limits.
 * For ios with 256 RAM and ie
 */ function $f92c4ad36d89e394$var$protect(image) {
    // https://stackoverflow.com/questions/6081483/maximum-size-of-a-canvas-element
    const ratio = image.width / image.height;
    const maxSquare = 5000000; // ios max canvas square
    const maxSize = 4096; // ie max canvas dimensions
    let maxW = Math.floor(Math.sqrt(maxSquare * ratio));
    let maxH = Math.floor(maxSquare / Math.sqrt(maxSquare * ratio));
    if (maxW > maxSize) {
        maxW = maxSize;
        maxH = Math.round(maxW / ratio);
    }
    if (maxH > maxSize) {
        maxH = maxSize;
        maxW = Math.round(ratio * maxH);
    }
    if (image.width > maxW) {
        const canvas = document.createElement('canvas');
        canvas.width = maxW;
        canvas.height = maxH;
        canvas.getContext('2d').drawImage(image, 0, 0, maxW, maxH);
        return canvas;
    }
    return image;
}
const $f92c4ad36d89e394$var$defaultOptions = {
    thumbnailWidth: null,
    thumbnailHeight: null,
    thumbnailType: 'image/jpeg',
    waitForThumbnailsBeforeUpload: false,
    lazy: false
};
class $f92c4ad36d89e394$export$2e2bcd8739ae039 extends (0, $5d08dd66a9cc6899$export$2e2bcd8739ae039) {
    constructor(uppy, opts){
        super(uppy, {
            ...$f92c4ad36d89e394$var$defaultOptions,
            ...opts
        });
        this.onFileAdded = (file)=>{
            if (!file.preview && file.data && (0, $2e3a76623b3bbcc9$export$2e2bcd8739ae039)(file.type) && !file.isRemote) this.addToQueue(file.id);
        };
        /**
     * Cancel a lazy request for a thumbnail if the thumbnail has not yet been generated.
     */ this.onCancelRequest = (file)=>{
            const index = this.queue.indexOf(file.id);
            if (index !== -1) this.queue.splice(index, 1);
        };
        /**
     * Clean up the thumbnail for a file. Cancel lazy requests and free the thumbnail URL.
     */ this.onFileRemoved = (file)=>{
            const index = this.queue.indexOf(file.id);
            if (index !== -1) this.queue.splice(index, 1);
            // Clean up object URLs.
            if (file.preview && (0, $3b72dc28c9f79a38$export$2e2bcd8739ae039)(file.preview)) URL.revokeObjectURL(file.preview);
        };
        this.onRestored = ()=>{
            const restoredFiles = this.uppy.getFiles().filter((file)=>file.isRestored);
            restoredFiles.forEach((file)=>{
                // Only add blob URLs; they are likely invalid after being restored.
                if (!file.preview || (0, $3b72dc28c9f79a38$export$2e2bcd8739ae039)(file.preview)) this.addToQueue(file.id);
            });
        };
        this.onAllFilesRemoved = ()=>{
            this.queue = [];
        };
        this.waitUntilAllProcessed = (fileIDs)=>{
            fileIDs.forEach((fileID)=>{
                const file = this.uppy.getFile(fileID);
                this.uppy.emit('preprocess-progress', file, {
                    mode: 'indeterminate',
                    message: this.i18n('generatingThumbnails')
                });
            });
            const emitPreprocessCompleteForAll = ()=>{
                fileIDs.forEach((fileID)=>{
                    const file = this.uppy.getFile(fileID);
                    this.uppy.emit('preprocess-complete', file);
                });
            };
            return new Promise((resolve)=>{
                if (this.queueProcessing) this.uppy.once('thumbnail:all-generated', ()=>{
                    emitPreprocessCompleteForAll();
                    resolve();
                });
                else {
                    emitPreprocessCompleteForAll();
                    resolve();
                }
            });
        };
        this.type = 'modifier';
        this.id = this.opts.id || 'ThumbnailGenerator';
        this.title = 'Thumbnail Generator';
        this.queue = [];
        this.queueProcessing = false;
        this.defaultThumbnailDimension = 200;
        this.thumbnailType = this.opts.thumbnailType;
        this.defaultLocale = (0, $7785655e028eb2bd$export$2e2bcd8739ae039);
        this.i18nInit();
        if (this.opts.lazy && this.opts.waitForThumbnailsBeforeUpload) throw new Error('ThumbnailGenerator: The `lazy` and `waitForThumbnailsBeforeUpload` options are mutually exclusive. Please ensure at most one of them is set to `true`.');
    }
    createThumbnail(file, targetWidth, targetHeight) {
        const originalUrl = URL.createObjectURL(file.data);
        const onload = new Promise((resolve, reject)=>{
            const image = new Image();
            image.src = originalUrl;
            image.addEventListener('load', ()=>{
                URL.revokeObjectURL(originalUrl);
                resolve(image);
            });
            image.addEventListener('error', (event)=>{
                URL.revokeObjectURL(originalUrl);
                reject(event.error || new Error('Could not create thumbnail'));
            });
        });
        const orientationPromise = (0, $gnS5A.rotation)(file.data).catch(()=>1);
        return Promise.all([
            onload,
            orientationPromise
        ]).then((_ref)=>{
            let [image, orientation] = _ref;
            const dimensions = this.getProportionalDimensions(image, targetWidth, targetHeight, orientation.deg);
            const rotatedImage = $f92c4ad36d89e394$var$rotateImage(image, orientation);
            const resizedImage = this.resizeImage(rotatedImage, dimensions.width, dimensions.height);
            return $f92c4ad36d89e394$var$canvasToBlob(resizedImage, this.thumbnailType, 80);
        }).then((blob)=>{
            return URL.createObjectURL(blob);
        });
    }
    /**
   * Get the new calculated dimensions for the given image and a target width
   * or height. If both width and height are given, only width is taken into
   * account. If neither width nor height are given, the default dimension
   * is used.
   */ getProportionalDimensions(img, width, height, deg) {
        // eslint-disable-line no-shadow
        let aspect = img.width / img.height;
        if (deg === 90 || deg === 270) aspect = img.height / img.width;
        if (width != null) return {
            width: width,
            height: Math.round(width / aspect)
        };
        if (height != null) return {
            width: Math.round(height * aspect),
            height: height
        };
        return {
            width: this.defaultThumbnailDimension,
            height: Math.round(this.defaultThumbnailDimension / aspect)
        };
    }
    /**
   * Resize an image to the target `width` and `height`.
   *
   * Returns a Canvas with the resized image on it.
   */ // eslint-disable-next-line class-methods-use-this
    resizeImage(image, targetWidth, targetHeight) {
        // Resizing in steps refactored to use a solution from
        // https://blog.uploadcare.com/image-resize-in-browsers-is-broken-e38eed08df01
        let img = $f92c4ad36d89e394$var$protect(image);
        let steps = Math.ceil(Math.log2(img.width / targetWidth));
        if (steps < 1) steps = 1;
        let sW = targetWidth * 2 ** (steps - 1);
        let sH = targetHeight * 2 ** (steps - 1);
        const x = 2;
        while(steps--){
            const canvas = document.createElement('canvas');
            canvas.width = sW;
            canvas.height = sH;
            canvas.getContext('2d').drawImage(img, 0, 0, sW, sH);
            img = canvas;
            sW = Math.round(sW / x);
            sH = Math.round(sH / x);
        }
        return img;
    }
    /**
   * Set the preview URL for a file.
   */ setPreviewURL(fileID, preview) {
        this.uppy.setFileState(fileID, {
            preview: preview
        });
    }
    addToQueue(fileID) {
        this.queue.push(fileID);
        if (this.queueProcessing === false) this.processQueue();
    }
    processQueue() {
        this.queueProcessing = true;
        if (this.queue.length > 0) {
            const current = this.uppy.getFile(this.queue.shift());
            if (!current) {
                this.uppy.log('[ThumbnailGenerator] file was removed before a thumbnail could be generated, but not removed from the queue. This is probably a bug', 'error');
                return Promise.resolve();
            }
            return this.requestThumbnail(current).catch(()=>{}) // eslint-disable-line node/handle-callback-err
            .then(()=>this.processQueue());
        }
        this.queueProcessing = false;
        this.uppy.log('[ThumbnailGenerator] Emptied thumbnail queue');
        this.uppy.emit('thumbnail:all-generated');
        return Promise.resolve();
    }
    requestThumbnail(file) {
        if ((0, $2e3a76623b3bbcc9$export$2e2bcd8739ae039)(file.type) && !file.isRemote) return this.createThumbnail(file, this.opts.thumbnailWidth, this.opts.thumbnailHeight).then((preview)=>{
            this.setPreviewURL(file.id, preview);
            this.uppy.log(`[ThumbnailGenerator] Generated thumbnail for ${file.id}`);
            this.uppy.emit('thumbnail:generated', this.uppy.getFile(file.id), preview);
        }).catch((err)=>{
            this.uppy.log(`[ThumbnailGenerator] Failed thumbnail for ${file.id}:`, 'warning');
            this.uppy.log(err, 'warning');
            this.uppy.emit('thumbnail:error', this.uppy.getFile(file.id), err);
        });
        return Promise.resolve();
    }
    install() {
        this.uppy.on('file-removed', this.onFileRemoved);
        this.uppy.on('cancel-all', this.onAllFilesRemoved);
        if (this.opts.lazy) {
            this.uppy.on('thumbnail:request', this.onFileAdded);
            this.uppy.on('thumbnail:cancel', this.onCancelRequest);
        } else {
            this.uppy.on('thumbnail:request', this.onFileAdded);
            this.uppy.on('file-added', this.onFileAdded);
            this.uppy.on('restored', this.onRestored);
        }
        if (this.opts.waitForThumbnailsBeforeUpload) this.uppy.addPreProcessor(this.waitUntilAllProcessed);
    }
    uninstall() {
        this.uppy.off('file-removed', this.onFileRemoved);
        this.uppy.off('cancel-all', this.onAllFilesRemoved);
        if (this.opts.lazy) {
            this.uppy.off('thumbnail:request', this.onFileAdded);
            this.uppy.off('thumbnail:cancel', this.onCancelRequest);
        } else {
            this.uppy.off('thumbnail:request', this.onFileAdded);
            this.uppy.off('file-added', this.onFileAdded);
            this.uppy.off('restored', this.onRestored);
        }
        if (this.opts.waitForThumbnailsBeforeUpload) this.uppy.removePreProcessor(this.waitUntilAllProcessed);
    }
}
$f92c4ad36d89e394$export$2e2bcd8739ae039.VERSION = $f92c4ad36d89e394$var$packageJson.version;



/**
 * Find one or more DOM elements.
 */ function $3da4efa7f88c23a6$var$findAllDOMElements(element) {
    if (typeof element === 'string') {
        const elements = document.querySelectorAll(element);
        return elements.length === 0 ? null : Array.from(elements);
    }
    if (typeof element === 'object' && (0, $dcdea5a9bf8353ff$export$2e2bcd8739ae039)(element)) return [
        element
    ];
    return null;
}
var $3da4efa7f88c23a6$export$2e2bcd8739ae039 = $3da4efa7f88c23a6$var$findAllDOMElements;


/**
 * Converts list into array
 */ var $d737086ca91a9c7d$export$2e2bcd8739ae039 = Array.from;


/**
 * Recursive function, calls the original callback() when the directory is entirely parsed.
 */ function $b08bd893356e01b1$export$2e2bcd8739ae039(directoryReader, oldEntries, logDropError, _ref) {
    let { onSuccess: onSuccess } = _ref;
    directoryReader.readEntries((entries)=>{
        const newEntries = [
            ...oldEntries,
            ...entries
        ];
        // According to the FileSystem API spec, getFilesAndDirectoriesFromDirectory()
        // must be called until it calls the onSuccess with an empty array.
        if (entries.length) queueMicrotask(()=>{
            $b08bd893356e01b1$export$2e2bcd8739ae039(directoryReader, newEntries, logDropError, {
                onSuccess: onSuccess
            });
        });
        else onSuccess(newEntries);
    }, // Make sure we resolve on error anyway, it's fine if only one directory couldn't be parsed!
    (error)=>{
        logDropError(error);
        onSuccess(oldEntries);
    });
}


/**
 * Polyfill for the new (experimental) getAsFileSystemHandle API (using the popular webkitGetAsEntry behind the scenes)
 * so that we can switch to the getAsFileSystemHandle API once it (hopefully) becomes standard
 */ function $e30d9f0f4292db6d$var$getAsFileSystemHandleFromEntry(entry, logDropError) {
    if (entry == null) return entry;
    return {
        kind: // eslint-disable-next-line no-nested-ternary
        entry.isFile ? 'file' : entry.isDirectory ? 'directory' : undefined,
        name: entry.name,
        getFile () {
            return new Promise((resolve, reject)=>entry.file(resolve, reject));
        },
        async *values () {
            // If the file is a directory.
            const directoryReader = entry.createReader();
            const entries = await new Promise((resolve)=>{
                (0, $b08bd893356e01b1$export$2e2bcd8739ae039)(directoryReader, [], logDropError, {
                    onSuccess: (dirEntries)=>resolve(dirEntries.map((file)=>$e30d9f0f4292db6d$var$getAsFileSystemHandleFromEntry(file, logDropError)))
                });
            });
            yield* entries;
        },
        isSameEntry: undefined
    };
}
function $e30d9f0f4292db6d$var$createPromiseToAddFileOrParseDirectory(entry, relativePath, lastResortFile) {
    try {
        if (lastResortFile === void 0) lastResortFile = undefined;
        return async function*() {
            const getNextRelativePath = ()=>`${relativePath}/${entry.name}`;
            // For each dropped item, - make sure it's a file/directory, and start deepening in!
            if (entry.kind === 'file') {
                const file = await entry.getFile();
                if (file != null) {
                    file.relativePath = relativePath ? getNextRelativePath() : null;
                    yield file;
                } else if (lastResortFile != null) yield lastResortFile;
            } else if (entry.kind === 'directory') for await (const handle of entry.values())// Recurse on the directory, appending the dir name to the relative path
            yield* $e30d9f0f4292db6d$var$createPromiseToAddFileOrParseDirectory(handle, relativePath ? getNextRelativePath() : entry.name);
            else if (lastResortFile != null) yield lastResortFile;
        }();
    } catch (e) {
        return Promise.reject(e);
    }
}
async function* $e30d9f0f4292db6d$export$2e2bcd8739ae039(dataTransfer, logDropError) {
    // Retrieving the dropped items must happen synchronously
    // otherwise only the first item gets treated and the other ones are garbage collected.
    // https://github.com/transloadit/uppy/pull/3998
    const fileSystemHandles = await Promise.all(Array.from(dataTransfer.items, async (item)=>{
        var _fileSystemHandle;
        let fileSystemHandle;
        // TODO enable getAsFileSystemHandle API once we can get it working with subdirectories
        // IMPORTANT: Need to check isSecureContext *before* calling getAsFileSystemHandle
        // or else Chrome will crash when running in HTTP: https://github.com/transloadit/uppy/issues/4133
        // if (window.isSecureContext && item.getAsFileSystemHandle != null)
        // fileSystemHandle = await item.getAsFileSystemHandle()
        // `webkitGetAsEntry` exists in all popular browsers (including non-WebKit browsers),
        // however it may be renamed to getAsEntry() in the future, so you should code defensively, looking for both.
        // from https://developer.mozilla.org/en-US/docs/Web/API/DataTransferItem/webkitGetAsEntry
        const getAsEntry = ()=>typeof item.getAsEntry === 'function' ? item.getAsEntry() : item.webkitGetAsEntry();
        // eslint-disable-next-line prefer-const
        (_fileSystemHandle = fileSystemHandle) != null ? _fileSystemHandle : fileSystemHandle = $e30d9f0f4292db6d$var$getAsFileSystemHandleFromEntry(getAsEntry(), logDropError);
        return {
            fileSystemHandle: fileSystemHandle,
            lastResortFile: item.getAsFile() // can be used as a fallback in case other methods fail
        };
    }));
    for (const { lastResortFile: lastResortFile, fileSystemHandle: fileSystemHandle } of fileSystemHandles){
        // fileSystemHandle and lastResortFile can be null when we drop an url.
        if (fileSystemHandle != null) try {
            yield* $e30d9f0f4292db6d$var$createPromiseToAddFileOrParseDirectory(fileSystemHandle, '', lastResortFile);
        } catch (err) {
            // Example: If dropping a symbolic link, Chromium will throw:
            // "DOMException: A requested file or directory could not be found at the time an operation was processed.",
            // So we will use lastResortFile instead. See https://github.com/transloadit/uppy/issues/3505.
            if (lastResortFile != null) yield lastResortFile;
            else logDropError(err);
        }
        else if (lastResortFile != null) yield lastResortFile;
    }
}



function $d5d92a586549e3b5$export$2e2bcd8739ae039(dataTransfer) {
    const files = (0, $d737086ca91a9c7d$export$2e2bcd8739ae039)(dataTransfer.files);
    return Promise.resolve(files);
}


async function $954bacbcaff60289$export$2e2bcd8739ae039(dataTransfer, options) {
    var _options$logDropError;
    // Get all files from all subdirs. Works (at least) in Chrome, Mozilla, and Safari
    const logDropError = (_options$logDropError = options == null ? void 0 : options.logDropError) != null ? _options$logDropError : Function.prototype;
    try {
        const accumulator = [];
        for await (const file of (0, $e30d9f0f4292db6d$export$2e2bcd8739ae039)(dataTransfer, logDropError))accumulator.push(file);
        return accumulator;
    // Otherwise just return all first-order files
    } catch  {
        return (0, $d5d92a586549e3b5$export$2e2bcd8739ae039)(dataTransfer);
    }
}



var $11d558640132ea3e$exports = {};
"use strict";



/* eslint-disable react/require-default-props */ 

var $e28f05d17e052ff9$var$t, $e28f05d17e052ff9$var$r, $e28f05d17e052ff9$var$u, $e28f05d17e052ff9$var$i, $e28f05d17e052ff9$var$o = 0, $e28f05d17e052ff9$var$f = [], $e28f05d17e052ff9$var$c = [], $e28f05d17e052ff9$var$e = (0, $4d2e93495e50cc85$export$41c562ebe57d11e2), $e28f05d17e052ff9$var$a = $e28f05d17e052ff9$var$e.__b, $e28f05d17e052ff9$var$v = $e28f05d17e052ff9$var$e.__r, $e28f05d17e052ff9$var$l = $e28f05d17e052ff9$var$e.diffed, $e28f05d17e052ff9$var$m = $e28f05d17e052ff9$var$e.__c, $e28f05d17e052ff9$var$s = $e28f05d17e052ff9$var$e.unmount, $e28f05d17e052ff9$var$d = $e28f05d17e052ff9$var$e.__;
function $e28f05d17e052ff9$var$h(n, t) {
    $e28f05d17e052ff9$var$e.__h && $e28f05d17e052ff9$var$e.__h($e28f05d17e052ff9$var$r, n, $e28f05d17e052ff9$var$o || t), $e28f05d17e052ff9$var$o = 0;
    var u = $e28f05d17e052ff9$var$r.__H || ($e28f05d17e052ff9$var$r.__H = {
        __: [],
        __h: []
    });
    return n >= u.__.length && u.__.push({
        __V: $e28f05d17e052ff9$var$c
    }), u.__[n];
}
function $e28f05d17e052ff9$export$60241385465d0a34(n) {
    return $e28f05d17e052ff9$var$o = 1, $e28f05d17e052ff9$export$13e3392192263954($e28f05d17e052ff9$var$D, n);
}
function $e28f05d17e052ff9$export$13e3392192263954(n, u, i) {
    var o = $e28f05d17e052ff9$var$h($e28f05d17e052ff9$var$t++, 2);
    if (o.t = n, !o.__c && (o.__ = [
        i ? i(u) : $e28f05d17e052ff9$var$D(void 0, u),
        function(n) {
            var t = o.__N ? o.__N[0] : o.__[0], r = o.t(t, n);
            t !== r && (o.__N = [
                r,
                o.__[1]
            ], o.__c.setState({}));
        }
    ], o.__c = $e28f05d17e052ff9$var$r, !$e28f05d17e052ff9$var$r.u)) {
        var f = function(n, t, r) {
            if (!o.__c.__H) return !0;
            var u = o.__c.__H.__.filter(function(n) {
                return !!n.__c;
            });
            if (u.every(function(n) {
                return !n.__N;
            })) return !c || c.call(this, n, t, r);
            var i = !1;
            return u.forEach(function(n) {
                if (n.__N) {
                    var t = n.__[0];
                    n.__ = n.__N, n.__N = void 0, t !== n.__[0] && (i = !0);
                }
            }), !(!i && o.__c.props === n) && (!c || c.call(this, n, t, r));
        };
        $e28f05d17e052ff9$var$r.u = !0;
        var c = $e28f05d17e052ff9$var$r.shouldComponentUpdate, e = $e28f05d17e052ff9$var$r.componentWillUpdate;
        $e28f05d17e052ff9$var$r.componentWillUpdate = function(n, t, r) {
            if (this.__e) {
                var u = c;
                c = void 0, f(n, t, r), c = u;
            }
            e && e.call(this, n, t, r);
        }, $e28f05d17e052ff9$var$r.shouldComponentUpdate = f;
    }
    return o.__N || o.__;
}
function $e28f05d17e052ff9$export$6d9c69b0de29b591(n, u) {
    var i = $e28f05d17e052ff9$var$h($e28f05d17e052ff9$var$t++, 3);
    !$e28f05d17e052ff9$var$e.__s && $e28f05d17e052ff9$var$C(i.__H, u) && (i.__ = n, i.i = u, $e28f05d17e052ff9$var$r.__H.__h.push(i));
}
function $e28f05d17e052ff9$export$e5c5a5f917a5871c(n, u) {
    var i = $e28f05d17e052ff9$var$h($e28f05d17e052ff9$var$t++, 4);
    !$e28f05d17e052ff9$var$e.__s && $e28f05d17e052ff9$var$C(i.__H, u) && (i.__ = n, i.i = u, $e28f05d17e052ff9$var$r.__h.push(i));
}
function $e28f05d17e052ff9$export$b8f5890fc79d6aca(n) {
    return $e28f05d17e052ff9$var$o = 5, $e28f05d17e052ff9$export$1538c33de8887b59(function() {
        return {
            current: n
        };
    }, []);
}
function $e28f05d17e052ff9$export$d5a552a76deda3c2(n, t, r) {
    $e28f05d17e052ff9$var$o = 6, $e28f05d17e052ff9$export$e5c5a5f917a5871c(function() {
        return "function" == typeof n ? (n(t()), function() {
            return n(null);
        }) : n ? (n.current = t(), function() {
            return n.current = null;
        }) : void 0;
    }, null == r ? r : r.concat(n));
}
function $e28f05d17e052ff9$export$1538c33de8887b59(n, r) {
    var u = $e28f05d17e052ff9$var$h($e28f05d17e052ff9$var$t++, 7);
    return $e28f05d17e052ff9$var$C(u.__H, r) ? (u.__V = n(), u.i = r, u.__h = n, u.__V) : u.__;
}
function $e28f05d17e052ff9$export$35808ee640e87ca7(n, t) {
    return $e28f05d17e052ff9$var$o = 8, $e28f05d17e052ff9$export$1538c33de8887b59(function() {
        return n;
    }, t);
}
function $e28f05d17e052ff9$export$fae74005e78b1a27(n) {
    var u = $e28f05d17e052ff9$var$r.context[n.__c], i = $e28f05d17e052ff9$var$h($e28f05d17e052ff9$var$t++, 9);
    return i.c = n, u ? (null == i.__ && (i.__ = !0, u.sub($e28f05d17e052ff9$var$r)), u.props.value) : n.__;
}
function $e28f05d17e052ff9$export$dc8fbce3eb94dc1e(n, t) {
    $e28f05d17e052ff9$var$e.useDebugValue && $e28f05d17e052ff9$var$e.useDebugValue(t ? t(n) : n);
}
function $e28f05d17e052ff9$export$c052f6604b7d51fe(n) {
    var u = $e28f05d17e052ff9$var$h($e28f05d17e052ff9$var$t++, 10), i = $e28f05d17e052ff9$export$60241385465d0a34();
    return u.__ = n, $e28f05d17e052ff9$var$r.componentDidCatch || ($e28f05d17e052ff9$var$r.componentDidCatch = function(n, t) {
        u.__ && u.__(n, t), i[1](n);
    }), [
        i[0],
        function() {
            i[1](void 0);
        }
    ];
}
function $e28f05d17e052ff9$export$f680877a34711e37() {
    var n = $e28f05d17e052ff9$var$h($e28f05d17e052ff9$var$t++, 11);
    if (!n.__) {
        for(var u = $e28f05d17e052ff9$var$r.__v; null !== u && !u.__m && null !== u.__;)u = u.__;
        var i = u.__m || (u.__m = [
            0,
            0
        ]);
        n.__ = "P" + i[0] + "-" + i[1]++;
    }
    return n.__;
}
function $e28f05d17e052ff9$var$j() {
    for(var n; n = $e28f05d17e052ff9$var$f.shift();)if (n.__P && n.__H) try {
        n.__H.__h.forEach($e28f05d17e052ff9$var$z), n.__H.__h.forEach($e28f05d17e052ff9$var$B), n.__H.__h = [];
    } catch (t) {
        n.__H.__h = [], $e28f05d17e052ff9$var$e.__e(t, n.__v);
    }
}
$e28f05d17e052ff9$var$e.__b = function(n) {
    $e28f05d17e052ff9$var$r = null, $e28f05d17e052ff9$var$a && $e28f05d17e052ff9$var$a(n);
}, $e28f05d17e052ff9$var$e.__ = function(n, t) {
    n && t.__k && t.__k.__m && (n.__m = t.__k.__m), $e28f05d17e052ff9$var$d && $e28f05d17e052ff9$var$d(n, t);
}, $e28f05d17e052ff9$var$e.__r = function(n) {
    $e28f05d17e052ff9$var$v && $e28f05d17e052ff9$var$v(n), $e28f05d17e052ff9$var$t = 0;
    var i = ($e28f05d17e052ff9$var$r = n.__c).__H;
    i && ($e28f05d17e052ff9$var$u === $e28f05d17e052ff9$var$r ? (i.__h = [], $e28f05d17e052ff9$var$r.__h = [], i.__.forEach(function(n) {
        n.__N && (n.__ = n.__N), n.__V = $e28f05d17e052ff9$var$c, n.__N = n.i = void 0;
    })) : (i.__h.forEach($e28f05d17e052ff9$var$z), i.__h.forEach($e28f05d17e052ff9$var$B), i.__h = [], $e28f05d17e052ff9$var$t = 0)), $e28f05d17e052ff9$var$u = $e28f05d17e052ff9$var$r;
}, $e28f05d17e052ff9$var$e.diffed = function(n) {
    $e28f05d17e052ff9$var$l && $e28f05d17e052ff9$var$l(n);
    var t = n.__c;
    t && t.__H && (t.__H.__h.length && (1 !== $e28f05d17e052ff9$var$f.push(t) && $e28f05d17e052ff9$var$i === $e28f05d17e052ff9$var$e.requestAnimationFrame || (($e28f05d17e052ff9$var$i = $e28f05d17e052ff9$var$e.requestAnimationFrame) || $e28f05d17e052ff9$var$w)($e28f05d17e052ff9$var$j)), t.__H.__.forEach(function(n) {
        n.i && (n.__H = n.i), n.__V !== $e28f05d17e052ff9$var$c && (n.__ = n.__V), n.i = void 0, n.__V = $e28f05d17e052ff9$var$c;
    })), $e28f05d17e052ff9$var$u = $e28f05d17e052ff9$var$r = null;
}, $e28f05d17e052ff9$var$e.__c = function(n, t) {
    t.some(function(n) {
        try {
            n.__h.forEach($e28f05d17e052ff9$var$z), n.__h = n.__h.filter(function(n) {
                return !n.__ || $e28f05d17e052ff9$var$B(n);
            });
        } catch (r) {
            t.some(function(n) {
                n.__h && (n.__h = []);
            }), t = [], $e28f05d17e052ff9$var$e.__e(r, n.__v);
        }
    }), $e28f05d17e052ff9$var$m && $e28f05d17e052ff9$var$m(n, t);
}, $e28f05d17e052ff9$var$e.unmount = function(n) {
    $e28f05d17e052ff9$var$s && $e28f05d17e052ff9$var$s(n);
    var t, r = n.__c;
    r && r.__H && (r.__H.__.forEach(function(n) {
        try {
            $e28f05d17e052ff9$var$z(n);
        } catch (n) {
            t = n;
        }
    }), r.__H = void 0, t && $e28f05d17e052ff9$var$e.__e(t, r.__v));
};
var $e28f05d17e052ff9$var$k = "function" == typeof requestAnimationFrame;
function $e28f05d17e052ff9$var$w(n) {
    var t, r = function() {
        clearTimeout(u), $e28f05d17e052ff9$var$k && cancelAnimationFrame(t), setTimeout(n);
    }, u = setTimeout(r, 100);
    $e28f05d17e052ff9$var$k && (t = requestAnimationFrame(r));
}
function $e28f05d17e052ff9$var$z(n) {
    var t = $e28f05d17e052ff9$var$r, u = n.__c;
    "function" == typeof u && (n.__c = void 0, u()), $e28f05d17e052ff9$var$r = t;
}
function $e28f05d17e052ff9$var$B(n) {
    var t = $e28f05d17e052ff9$var$r;
    n.__c = n.__(), $e28f05d17e052ff9$var$r = t;
}
function $e28f05d17e052ff9$var$C(n, t) {
    return !n || n.length !== t.length || t.some(function(t, r) {
        return t !== n[r];
    });
}
function $e28f05d17e052ff9$var$D(n, t) {
    return "function" == typeof t ? t(n) : t;
}


function $616f0acd28bd0dc4$var$GoogleIcon() {
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("svg", {
        width: "26",
        height: "26",
        viewBox: "0 0 26 26",
        xmlns: "http://www.w3.org/2000/svg"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("g", {
        fill: "none",
        "fill-rule": "evenodd"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("circle", {
        fill: "#FFF",
        cx: "13",
        cy: "13",
        r: "13"
    }), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        d: "M21.64 13.205c0-.639-.057-1.252-.164-1.841H13v3.481h4.844a4.14 4.14 0 01-1.796 2.716v2.259h2.908c1.702-1.567 2.684-3.875 2.684-6.615z",
        fill: "#4285F4",
        "fill-rule": "nonzero"
    }), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        d: "M13 22c2.43 0 4.467-.806 5.956-2.18l-2.908-2.259c-.806.54-1.837.86-3.048.86-2.344 0-4.328-1.584-5.036-3.711H4.957v2.332A8.997 8.997 0 0013 22z",
        fill: "#34A853",
        "fill-rule": "nonzero"
    }), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        d: "M7.964 14.71A5.41 5.41 0 017.682 13c0-.593.102-1.17.282-1.71V8.958H4.957A8.996 8.996 0 004 13c0 1.452.348 2.827.957 4.042l3.007-2.332z",
        fill: "#FBBC05",
        "fill-rule": "nonzero"
    }), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        d: "M13 7.58c1.321 0 2.508.454 3.44 1.345l2.582-2.58C17.463 4.891 15.426 4 13 4a8.997 8.997 0 00-8.043 4.958l3.007 2.332C8.672 9.163 10.656 7.58 13 7.58z",
        fill: "#EA4335",
        "fill-rule": "nonzero"
    }), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        d: "M4 4h18v18H4z"
    })));
}
function $616f0acd28bd0dc4$var$DefaultForm(_ref) {
    let { pluginName: pluginName, i18n: i18n, onAuth: onAuth } = _ref;
    // In order to comply with Google's brand we need to create a different button
    // for the Google Drive plugin
    const isGoogleDrive = pluginName === 'Google Drive';
    const onSubmit = (0, $e28f05d17e052ff9$export$35808ee640e87ca7)((e)=>{
        e.preventDefault();
        onAuth();
    }, [
        onAuth
    ]);
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("form", {
        onSubmit: onSubmit
    }, isGoogleDrive ? (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("button", {
        type: "submit",
        className: "uppy-u-reset uppy-c-btn uppy-c-btn-primary uppy-Provider-authBtn uppy-Provider-btn-google",
        "data-uppy-super-focusable": true
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)($616f0acd28bd0dc4$var$GoogleIcon, null), i18n('signInWithGoogle')) : (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("button", {
        type: "submit",
        className: "uppy-u-reset uppy-c-btn uppy-c-btn-primary uppy-Provider-authBtn",
        "data-uppy-super-focusable": true
    }, i18n('authenticateWith', {
        pluginName: pluginName
    })));
}
const $616f0acd28bd0dc4$var$defaultRenderForm = (_ref2)=>{
    let { pluginName: pluginName, i18n: i18n, onAuth: onAuth } = _ref2;
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)($616f0acd28bd0dc4$var$DefaultForm, {
        pluginName: pluginName,
        i18n: i18n,
        onAuth: onAuth
    });
};
function $616f0acd28bd0dc4$export$2e2bcd8739ae039(props) {
    const { loading: loading, pluginName: pluginName, pluginIcon: pluginIcon, i18n: i18n, handleAuth: handleAuth, renderForm: renderForm = $616f0acd28bd0dc4$var$defaultRenderForm } = props;
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-Provider-auth"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-Provider-authIcon"
    }, pluginIcon()), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-Provider-authTitle"
    }, i18n('authenticateWithTitle', {
        pluginName: pluginName
    })), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-Provider-authForm"
    }, renderForm({
        pluginName: pluginName,
        i18n: i18n,
        loading: loading,
        onAuth: handleAuth
    })));
}


/* eslint-disable react/destructuring-assignment */ 

function $4ee9dcacd7f26785$export$2e2bcd8739ae039(_ref) {
    let { i18n: i18n, logout: logout, username: username } = _ref;
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $4d2e93495e50cc85$export$ffb0004e005737fa), null, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("span", {
        className: "uppy-ProviderBrowser-user",
        key: "username"
    }, username), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("button", {
        type: "button",
        onClick: logout,
        className: "uppy-u-reset uppy-c-btn uppy-ProviderBrowser-userLogout",
        key: "logout"
    }, i18n('logOut')));
}



const $48839592a474f204$var$Breadcrumb = (props)=>{
    const { getFolder: getFolder, title: title, isLast: isLast } = props;
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $4d2e93495e50cc85$export$ffb0004e005737fa), null, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("button", {
        type: "button",
        className: "uppy-u-reset uppy-c-btn",
        onClick: getFolder
    }, title), !isLast ? ' / ' : '');
};
function $48839592a474f204$export$2e2bcd8739ae039(props) {
    const { getFolder: getFolder, title: title, breadcrumbsIcon: breadcrumbsIcon, breadcrumbs: breadcrumbs } = props;
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-Provider-breadcrumbs"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-Provider-breadcrumbsIcon"
    }, breadcrumbsIcon), breadcrumbs.map((directory, i)=>(0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)($48839592a474f204$var$Breadcrumb, {
            key: directory.id,
            getFolder: ()=>getFolder(directory.requestPath, directory.name),
            title: i === 0 ? title : directory.name,
            isLast: i + 1 === breadcrumbs.length
        })));
}


function $6b1b801e011f359f$export$2e2bcd8739ae039(props) {
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $4d2e93495e50cc85$export$ffb0004e005737fa), null, props.showBreadcrumbs && (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $48839592a474f204$export$2e2bcd8739ae039), {
        getFolder: props.getFolder,
        breadcrumbs: props.breadcrumbs,
        breadcrumbsIcon: props.pluginIcon && props.pluginIcon(),
        title: props.title
    }), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $4ee9dcacd7f26785$export$2e2bcd8739ae039), {
        logout: props.logout,
        username: props.username,
        i18n: props.i18n
    }));
}


/* eslint-disable react/require-default-props */ 


function $d0cca3c9705b0857$export$2e2bcd8739ae039(file) {
    return {
        ...file,
        type: file.mimeType,
        extension: file.name ? (0, $09afbe8d004816d5$export$2e2bcd8739ae039)(file.name).extension : null
    };
}




function $aba06cd85441b3f8$var$_extends() {
    $aba06cd85441b3f8$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $aba06cd85441b3f8$var$_extends.apply(this, arguments);
}
const $aba06cd85441b3f8$var$STYLE_INNER = {
    position: 'relative',
    // Disabled for our use case: the wrapper elements around FileList already deal with overflow,
    // and this additional property would hide things that we want to show.
    //
    // overflow: 'hidden',
    width: '100%',
    minHeight: '100%'
};
const $aba06cd85441b3f8$var$STYLE_CONTENT = {
    position: 'absolute',
    top: 0,
    left: 0,
    // Because the `top` value gets set to some offset, this `height` being 100% would make the scrollbar
    // stretch far beyond the content. For our use case, the content div actually can get its height from
    // the elements inside it, so we don't need to specify a `height` property at all.
    //
    // height: '100%',
    width: '100%',
    overflow: 'visible'
};
class $aba06cd85441b3f8$var$VirtualList extends (0, $4d2e93495e50cc85$export$16fa2f45be04daa8) {
    constructor(props){
        super(props);
        // The currently focused node, used to retain focus when the visible rows change.
        // To avoid update loops, this should not cause state updates, so it's kept as a plain property.
        this.handleScroll = ()=>{
            this.setState({
                offset: this.base.scrollTop
            });
        };
        this.handleResize = ()=>{
            this.resize();
        };
        this.focusElement = null;
        this.state = {
            offset: 0,
            height: 0
        };
    }
    componentDidMount() {
        this.resize();
        window.addEventListener('resize', this.handleResize);
    }
    // TODO: refactor to stable lifecycle method
    // eslint-disable-next-line
    componentWillUpdate() {
        if (this.base.contains(document.activeElement)) this.focusElement = document.activeElement;
    }
    componentDidUpdate() {
        // Maintain focus when rows are added and removed.
        if (this.focusElement && this.focusElement.parentNode && document.activeElement !== this.focusElement) this.focusElement.focus();
        this.focusElement = null;
        this.resize();
    }
    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
    }
    resize() {
        const { height: height } = this.state;
        if (height !== this.base.offsetHeight) this.setState({
            height: this.base.offsetHeight
        });
    }
    render(_ref) {
        let { data: data, rowHeight: rowHeight, renderRow: renderRow, overscanCount: overscanCount = 10, ...props } = _ref;
        const { offset: offset, height: height } = this.state;
        // first visible row index
        let start = Math.floor(offset / rowHeight);
        // actual number of visible rows (without overscan)
        let visibleRowCount = Math.floor(height / rowHeight);
        // Overscan: render blocks of rows modulo an overscan row count
        // This dramatically reduces DOM writes during scrolling
        if (overscanCount) {
            start = Math.max(0, start - start % overscanCount);
            visibleRowCount += overscanCount;
        }
        // last visible + overscan row index + padding to allow keyboard focus to travel past the visible area
        const end = start + visibleRowCount + 4;
        // data slice currently in viewport plus overscan items
        const selection = data.slice(start, end);
        const styleInner = {
            ...$aba06cd85441b3f8$var$STYLE_INNER,
            height: data.length * rowHeight
        };
        const styleContent = {
            ...$aba06cd85441b3f8$var$STYLE_CONTENT,
            top: start * rowHeight
        };
        // The `role="presentation"` attributes ensure that these wrapper elements are not treated as list
        // items by accessibility and outline tools.
        return(// eslint-disable-next-line react/jsx-props-no-spreading
        (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", $aba06cd85441b3f8$var$_extends({
            onScroll: this.handleScroll
        }, props), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
            role: "presentation",
            style: styleInner
        }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
            role: "presentation",
            style: styleContent
        }, selection.map(renderRow)))));
    }
}
var $aba06cd85441b3f8$export$2e2bcd8739ae039 = $aba06cd85441b3f8$var$VirtualList;


/* eslint-disable react/require-default-props */ 

let $a0ee3b646e338d67$var$urlAlphabet = 'useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict';
let $a0ee3b646e338d67$export$62e99e5c9f473d7f = (alphabet, defaultSize = 21)=>{
    return (size = defaultSize)=>{
        let id = '';
        let i = size | 0;
        while(i--)id += alphabet[Math.random() * alphabet.length | 0];
        return id;
    };
};
let $a0ee3b646e338d67$export$ac4959f4f1338dfc = (size = 21)=>{
    let id = '';
    let i = size | 0;
    while(i--)id += $a0ee3b646e338d67$var$urlAlphabet[Math.random() * 64 | 0];
    return id;
};


function $a64872f8825ef0cd$export$2e2bcd8739ae039(props) {
    const { search: search, searchOnInput: searchOnInput, searchTerm: searchTerm, showButton: showButton, inputLabel: inputLabel, clearSearchLabel: clearSearchLabel, buttonLabel: buttonLabel, clearSearch: clearSearch, inputClassName: inputClassName, buttonCSSClassName: buttonCSSClassName } = props;
    const [searchText, setSearchText] = (0, $e28f05d17e052ff9$export$60241385465d0a34)(searchTerm != null ? searchTerm : '');
    // const debouncedSearch = debounce((q) => search(q), 1000)
    const validateAndSearch = (0, $e28f05d17e052ff9$export$35808ee640e87ca7)((ev)=>{
        ev.preventDefault();
        search(searchText);
    }, [
        search,
        searchText
    ]);
    const handleInput = (0, $e28f05d17e052ff9$export$35808ee640e87ca7)((ev)=>{
        const inputValue = ev.target.value;
        setSearchText(inputValue);
        if (searchOnInput) search(inputValue);
    }, [
        setSearchText,
        searchOnInput,
        search
    ]);
    const handleReset = ()=>{
        setSearchText('');
        if (clearSearch) clearSearch();
    };
    const [form] = (0, $e28f05d17e052ff9$export$60241385465d0a34)(()=>{
        const formEl = document.createElement('form');
        formEl.setAttribute('tabindex', '-1');
        formEl.id = (0, $a0ee3b646e338d67$export$ac4959f4f1338dfc)();
        return formEl;
    });
    (0, $e28f05d17e052ff9$export$6d9c69b0de29b591)(()=>{
        document.body.appendChild(form);
        form.addEventListener('submit', validateAndSearch);
        return ()=>{
            form.removeEventListener('submit', validateAndSearch);
            document.body.removeChild(form);
        };
    }, [
        form,
        validateAndSearch
    ]);
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $4d2e93495e50cc85$export$ffb0004e005737fa), null, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("input", {
        className: `uppy-u-reset ${inputClassName}`,
        type: "search",
        "aria-label": inputLabel,
        placeholder: inputLabel,
        value: searchText,
        onInput: handleInput,
        form: form.id,
        "data-uppy-super-focusable": true
    }), !showButton && (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("svg", {
        "aria-hidden": "true",
        focusable: "false",
        className: "uppy-c-icon uppy-ProviderBrowser-searchFilterIcon",
        width: "12",
        height: "12",
        viewBox: "0 0 12 12"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        d: "M8.638 7.99l3.172 3.172a.492.492 0 1 1-.697.697L7.91 8.656a4.977 4.977 0 0 1-2.983.983C2.206 9.639 0 7.481 0 4.819 0 2.158 2.206 0 4.927 0c2.721 0 4.927 2.158 4.927 4.82a4.74 4.74 0 0 1-1.216 3.17zm-3.71.685c2.176 0 3.94-1.726 3.94-3.856 0-2.129-1.764-3.855-3.94-3.855C2.75.964.984 2.69.984 4.819c0 2.13 1.765 3.856 3.942 3.856z"
    })), !showButton && searchText && (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("button", {
        className: "uppy-u-reset uppy-ProviderBrowser-searchFilterReset",
        type: "button",
        "aria-label": clearSearchLabel,
        title: clearSearchLabel,
        onClick: handleReset
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("svg", {
        "aria-hidden": "true",
        focusable: "false",
        className: "uppy-c-icon",
        viewBox: "0 0 19 19"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        d: "M17.318 17.232L9.94 9.854 9.586 9.5l-.354.354-7.378 7.378h.707l-.62-.62v.706L9.318 9.94l.354-.354-.354-.354L1.94 1.854v.707l.62-.62h-.706l7.378 7.378.354.354.354-.354 7.378-7.378h-.707l.622.62v-.706L9.854 9.232l-.354.354.354.354 7.378 7.378.708-.707-7.38-7.378v.708l7.38-7.38.353-.353-.353-.353-.622-.622-.353-.353-.354.352-7.378 7.38h.708L2.56 1.23 2.208.88l-.353.353-.622.62-.353.355.352.353 7.38 7.38v-.708l-7.38 7.38-.353.353.352.353.622.622.353.353.354-.353 7.38-7.38h-.708l7.38 7.38z"
    }))), showButton && (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("button", {
        className: `uppy-u-reset uppy-c-btn uppy-c-btn-primary ${buttonCSSClassName}`,
        type: "submit",
        form: form.id
    }, buttonLabel));
}



function $4ab2a94a3ee5ad67$export$2e2bcd8739ae039(_ref) {
    let { cancel: cancel, done: done, i18n: i18n, selected: selected } = _ref;
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-ProviderBrowser-footer"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("button", {
        className: "uppy-u-reset uppy-c-btn uppy-c-btn-primary",
        onClick: done,
        type: "button"
    }, i18n('selectX', {
        smart_count: selected
    })), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("button", {
        className: "uppy-u-reset uppy-c-btn uppy-c-btn-link",
        onClick: cancel,
        type: "button"
    }, i18n('cancel')));
}




/* eslint-disable react/require-default-props */ 
function $eeb730e0d52603b2$var$FileIcon() {
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("svg", {
        "aria-hidden": "true",
        focusable: "false",
        className: "uppy-c-icon",
        width: 11,
        height: 14.5,
        viewBox: "0 0 44 58"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        d: "M27.437.517a1 1 0 0 0-.094.03H4.25C2.037.548.217 2.368.217 4.58v48.405c0 2.212 1.82 4.03 4.03 4.03H39.03c2.21 0 4.03-1.818 4.03-4.03V15.61a1 1 0 0 0-.03-.28 1 1 0 0 0 0-.093 1 1 0 0 0-.03-.032 1 1 0 0 0 0-.03 1 1 0 0 0-.032-.063 1 1 0 0 0-.03-.063 1 1 0 0 0-.032 0 1 1 0 0 0-.03-.063 1 1 0 0 0-.032-.03 1 1 0 0 0-.03-.063 1 1 0 0 0-.063-.062l-14.593-14a1 1 0 0 0-.062-.062A1 1 0 0 0 28 .708a1 1 0 0 0-.374-.157 1 1 0 0 0-.156 0 1 1 0 0 0-.03-.03l-.003-.003zM4.25 2.547h22.218v9.97c0 2.21 1.82 4.03 4.03 4.03h10.564v36.438a2.02 2.02 0 0 1-2.032 2.032H4.25c-1.13 0-2.032-.9-2.032-2.032V4.58c0-1.13.902-2.032 2.03-2.032zm24.218 1.345l10.375 9.937.75.718H30.5c-1.13 0-2.032-.9-2.032-2.03V3.89z"
    }));
}
function $eeb730e0d52603b2$var$FolderIcon() {
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("svg", {
        "aria-hidden": "true",
        focusable: "false",
        className: "uppy-c-icon",
        style: {
            minWidth: 16,
            marginRight: 3
        },
        viewBox: "0 0 276.157 276.157"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        d: "M273.08 101.378c-3.3-4.65-8.86-7.32-15.254-7.32h-24.34V67.59c0-10.2-8.3-18.5-18.5-18.5h-85.322c-3.63 0-9.295-2.875-11.436-5.805l-6.386-8.735c-4.982-6.814-15.104-11.954-23.546-11.954H58.73c-9.292 0-18.638 6.608-21.737 15.372l-2.033 5.752c-.958 2.71-4.72 5.37-7.596 5.37H18.5C8.3 49.09 0 57.39 0 67.59v167.07c0 .886.16 1.73.443 2.52.152 3.306 1.18 6.424 3.053 9.064 3.3 4.652 8.86 7.32 15.255 7.32h188.487c11.395 0 23.27-8.425 27.035-19.18l40.677-116.188c2.11-6.035 1.43-12.164-1.87-16.816zM18.5 64.088h8.864c9.295 0 18.64-6.607 21.738-15.37l2.032-5.75c.96-2.712 4.722-5.373 7.597-5.373h29.565c3.63 0 9.295 2.876 11.437 5.806l6.386 8.735c4.982 6.815 15.104 11.954 23.546 11.954h85.322c1.898 0 3.5 1.602 3.5 3.5v26.47H69.34c-11.395 0-23.27 8.423-27.035 19.178L15 191.23V67.59c0-1.898 1.603-3.5 3.5-3.5zm242.29 49.15l-40.676 116.188c-1.674 4.78-7.812 9.135-12.877 9.135H18.75c-1.447 0-2.576-.372-3.02-.997-.442-.625-.422-1.814.057-3.18l40.677-116.19c1.674-4.78 7.812-9.134 12.877-9.134h188.487c1.448 0 2.577.372 3.02.997.443.625.423 1.814-.056 3.18z"
    }));
}
function $eeb730e0d52603b2$var$VideoIcon() {
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("svg", {
        "aria-hidden": "true",
        focusable: "false",
        style: {
            width: 16,
            marginRight: 4
        },
        viewBox: "0 0 58 58"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        d: "M36.537 28.156l-11-7a1.005 1.005 0 0 0-1.02-.033C24.2 21.3 24 21.635 24 22v14a1 1 0 0 0 1.537.844l11-7a1.002 1.002 0 0 0 0-1.688zM26 34.18V23.82L34.137 29 26 34.18z"
    }), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        d: "M57 6H1a1 1 0 0 0-1 1v44a1 1 0 0 0 1 1h56a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1zM10 28H2v-9h8v9zm-8 2h8v9H2v-9zm10 10V8h34v42H12V40zm44-12h-8v-9h8v9zm-8 2h8v9h-8v-9zm8-22v9h-8V8h8zM2 8h8v9H2V8zm0 42v-9h8v9H2zm54 0h-8v-9h8v9z"
    }));
}
function $eeb730e0d52603b2$export$2e2bcd8739ae039(props) {
    const { itemIconString: itemIconString } = props;
    if (itemIconString === null) return null;
    switch(itemIconString){
        case 'file':
            return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)($eeb730e0d52603b2$var$FileIcon, null);
        case 'folder':
            return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)($eeb730e0d52603b2$var$FolderIcon, null);
        case 'video':
            return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)($eeb730e0d52603b2$var$VideoIcon, null);
        default:
            {
                const { alt: alt } = props;
                return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("img", {
                    src: itemIconString,
                    alt: alt,
                    referrerPolicy: "no-referrer",
                    loading: "lazy",
                    width: 16,
                    height: 16
                });
            }
    }
}


/* eslint-disable react/require-default-props */ 

function $34c44cdae6ac04e3$var$GridListItem(props) {
    const { className: className, isDisabled: isDisabled, restrictionError: restrictionError, isChecked: isChecked, title: title, itemIconEl: itemIconEl, showTitles: showTitles, toggleCheckbox: toggleCheckbox, recordShiftKeyPress: recordShiftKeyPress, id: id, children: children } = props;
    const checkBoxClassName = (0, (/*@__PURE__*/$parcel$interopDefault($02c2aab7657be691$exports)))('uppy-u-reset', 'uppy-ProviderBrowserItem-checkbox', 'uppy-ProviderBrowserItem-checkbox--grid', {
        'uppy-ProviderBrowserItem-checkbox--is-checked': isChecked
    });
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("li", {
        className: className,
        title: isDisabled ? restrictionError == null ? void 0 : restrictionError.message : undefined
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("input", {
        type: "checkbox",
        className: checkBoxClassName,
        onChange: toggleCheckbox,
        onKeyDown: recordShiftKeyPress,
        onMouseDown: recordShiftKeyPress,
        name: "listitem",
        id: id,
        checked: isChecked,
        disabled: isDisabled,
        "data-uppy-super-focusable": true
    }), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("label", {
        htmlFor: id,
        "aria-label": title,
        className: "uppy-u-reset uppy-ProviderBrowserItem-inner"
    }, itemIconEl, showTitles && title, children));
}
var $34c44cdae6ac04e3$export$2e2bcd8739ae039 = $34c44cdae6ac04e3$var$GridListItem;


/* eslint-disable react/require-default-props */ 
function $1a9b1423cd47af37$export$2e2bcd8739ae039(props) {
    const { className: className, isDisabled: isDisabled, restrictionError: restrictionError, isCheckboxDisabled: isCheckboxDisabled, isChecked: isChecked, toggleCheckbox: toggleCheckbox, recordShiftKeyPress: recordShiftKeyPress, type: type, id: id, itemIconEl: itemIconEl, title: title, handleFolderClick: handleFolderClick, showTitles: showTitles, i18n: i18n } = props;
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("li", {
        className: className,
        title: isDisabled ? restrictionError == null ? void 0 : restrictionError.message : undefined
    }, !isCheckboxDisabled ? (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("input", {
        type: "checkbox",
        className: `uppy-u-reset uppy-ProviderBrowserItem-checkbox ${isChecked ? 'uppy-ProviderBrowserItem-checkbox--is-checked' : ''}`,
        onChange: toggleCheckbox,
        onKeyDown: recordShiftKeyPress,
        onMouseDown: recordShiftKeyPress,
        name: "listitem",
        id: id,
        checked: isChecked,
        "aria-label": type === 'file' ? null : i18n('allFilesFromFolderNamed', {
            name: title
        }),
        disabled: isDisabled,
        "data-uppy-super-focusable": true
    }) : null, type === 'file' ? // label for a checkbox
    (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("label", {
        htmlFor: id,
        className: "uppy-u-reset uppy-ProviderBrowserItem-inner"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-ProviderBrowserItem-iconWrap"
    }, itemIconEl), showTitles && title) : (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("button", {
        type: "button",
        className: "uppy-u-reset uppy-c-btn uppy-ProviderBrowserItem-inner",
        onClick: handleFolderClick,
        "aria-label": i18n('openFolderNamed', {
            name: title
        })
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-ProviderBrowserItem-iconWrap"
    }, itemIconEl), showTitles && title ? (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("span", null, title) : i18n('unnamed')));
}


function $7f388d6d579fe299$var$_extends() {
    $7f388d6d579fe299$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $7f388d6d579fe299$var$_extends.apply(this, arguments);
}
function $7f388d6d579fe299$export$2e2bcd8739ae039(props) {
    const { author: author, getItemIcon: getItemIcon, isChecked: isChecked, isDisabled: isDisabled, viewType: viewType } = props;
    const itemIconString = getItemIcon();
    const className = (0, (/*@__PURE__*/$parcel$interopDefault($02c2aab7657be691$exports)))('uppy-ProviderBrowserItem', {
        'uppy-ProviderBrowserItem--selected': isChecked
    }, {
        'uppy-ProviderBrowserItem--disabled': isDisabled
    }, {
        'uppy-ProviderBrowserItem--noPreview': itemIconString === 'video'
    });
    const itemIconEl = (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $eeb730e0d52603b2$export$2e2bcd8739ae039), {
        itemIconString: itemIconString
    });
    switch(viewType){
        case 'grid':
            return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $34c44cdae6ac04e3$export$2e2bcd8739ae039), $7f388d6d579fe299$var$_extends({}, props, {
                className: className,
                itemIconEl: itemIconEl
            }));
        case 'list':
            return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $1a9b1423cd47af37$export$2e2bcd8739ae039), $7f388d6d579fe299$var$_extends({}, props, {
                className: className,
                itemIconEl: itemIconEl
            }));
        case 'unsplash':
            return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $34c44cdae6ac04e3$export$2e2bcd8739ae039), $7f388d6d579fe299$var$_extends({}, props, {
                className: className,
                itemIconEl: itemIconEl
            }), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("a", {
                href: `${author.url}?utm_source=Companion&utm_medium=referral`,
                target: "_blank",
                rel: "noopener noreferrer",
                className: "uppy-ProviderBrowserItem-author",
                tabIndex: -1
            }, author.name));
        default:
            throw new Error(`There is no such type ${viewType}`);
    }
}


const $ffc120143b595bcb$var$VIRTUAL_SHARED_DIR = 'shared-with-me';
function $ffc120143b595bcb$var$ListItem(props) {
    const { currentSelection: currentSelection, uppyFiles: uppyFiles, viewType: viewType, isChecked: isChecked, toggleCheckbox: toggleCheckbox, recordShiftKeyPress: recordShiftKeyPress, showTitles: showTitles, i18n: i18n, validateRestrictions: validateRestrictions, getNextFolder: getNextFolder, f: f } = props;
    if (f.isFolder) return (0, $7f388d6d579fe299$export$2e2bcd8739ae039)({
        showTitles: showTitles,
        viewType: viewType,
        i18n: i18n,
        id: f.id,
        title: f.name,
        getItemIcon: ()=>f.icon,
        isChecked: isChecked(f),
        toggleCheckbox: (event)=>toggleCheckbox(event, f),
        recordShiftKeyPress: recordShiftKeyPress,
        type: 'folder',
        // TODO: when was this supposed to be true?
        isDisabled: false,
        isCheckboxDisabled: f.id === $ffc120143b595bcb$var$VIRTUAL_SHARED_DIR,
        // getNextFolder always exists when f.isFolder is true
        handleFolderClick: ()=>getNextFolder(f)
    });
    const restrictionError = validateRestrictions((0, $d0cca3c9705b0857$export$2e2bcd8739ae039)(f), [
        ...uppyFiles,
        ...currentSelection
    ]);
    return (0, $7f388d6d579fe299$export$2e2bcd8739ae039)({
        id: f.id,
        title: f.name,
        author: f.author,
        getItemIcon: ()=>viewType === 'grid' && f.thumbnail ? f.thumbnail : f.icon,
        isChecked: isChecked(f),
        toggleCheckbox: (event)=>toggleCheckbox(event, f),
        isCheckboxDisabled: false,
        recordShiftKeyPress: recordShiftKeyPress,
        showTitles: showTitles,
        viewType: viewType,
        i18n: i18n,
        type: 'file',
        isDisabled: Boolean(restrictionError) && !isChecked(f),
        restrictionError: restrictionError
    });
}
function $ffc120143b595bcb$var$Browser(props) {
    const { currentSelection: currentSelection, folders: folders, files: files, uppyFiles: uppyFiles, viewType: viewType, headerComponent: headerComponent, showBreadcrumbs: showBreadcrumbs, isChecked: isChecked, toggleCheckbox: toggleCheckbox, recordShiftKeyPress: recordShiftKeyPress, handleScroll: handleScroll, showTitles: showTitles, i18n: i18n, validateRestrictions: validateRestrictions, isLoading: isLoading, showSearchFilter: showSearchFilter, search: search, searchTerm: searchTerm, clearSearch: clearSearch, searchOnInput: searchOnInput, searchInputLabel: searchInputLabel, clearSearchLabel: clearSearchLabel, getNextFolder: getNextFolder, cancel: cancel, done: done, noResultsLabel: noResultsLabel, virtualList: virtualList } = props;
    const selected = currentSelection.length;
    const rows = (0, $e28f05d17e052ff9$export$1538c33de8887b59)(()=>[
            ...folders,
            ...files
        ], [
        folders,
        files
    ]);
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($02c2aab7657be691$exports)))('uppy-ProviderBrowser', `uppy-ProviderBrowser-viewType--${viewType}`)
    }, headerComponent && (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-ProviderBrowser-header"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($02c2aab7657be691$exports)))('uppy-ProviderBrowser-headerBar', !showBreadcrumbs && 'uppy-ProviderBrowser-headerBar--simple')
    }, headerComponent)), showSearchFilter && (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        class: "uppy-ProviderBrowser-searchFilter"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $a64872f8825ef0cd$export$2e2bcd8739ae039), {
        search: search,
        searchTerm: searchTerm,
        clearSearch: clearSearch,
        inputLabel: searchInputLabel,
        clearSearchLabel: clearSearchLabel,
        inputClassName: "uppy-ProviderBrowser-searchFilterInput",
        searchOnInput: searchOnInput
    })), (()=>{
        if (isLoading) return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
            className: "uppy-Provider-loading"
        }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("span", null, typeof isLoading === 'string' ? isLoading : i18n('loading')));
        if (!folders.length && !files.length) return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
            className: "uppy-Provider-empty"
        }, noResultsLabel);
        if (virtualList) return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
            className: "uppy-ProviderBrowser-body"
        }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("ul", {
            className: "uppy-ProviderBrowser-list"
        }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $aba06cd85441b3f8$export$2e2bcd8739ae039), {
            data: rows,
            renderRow: (f)=>(0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)($ffc120143b595bcb$var$ListItem, {
                    currentSelection: currentSelection,
                    uppyFiles: uppyFiles,
                    viewType: viewType,
                    isChecked: isChecked,
                    toggleCheckbox: toggleCheckbox,
                    recordShiftKeyPress: recordShiftKeyPress,
                    showTitles: showTitles,
                    i18n: i18n,
                    validateRestrictions: validateRestrictions,
                    getNextFolder: getNextFolder,
                    f: f
                }),
            rowHeight: 31
        })));
        return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
            className: "uppy-ProviderBrowser-body"
        }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("ul", {
            className: "uppy-ProviderBrowser-list",
            onScroll: handleScroll,
            role: "listbox",
            tabIndex: -1
        }, rows.map((f)=>(0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)($ffc120143b595bcb$var$ListItem, {
                currentSelection: currentSelection,
                uppyFiles: uppyFiles,
                viewType: viewType,
                isChecked: isChecked,
                toggleCheckbox: toggleCheckbox,
                recordShiftKeyPress: recordShiftKeyPress,
                showTitles: showTitles,
                i18n: i18n,
                validateRestrictions: validateRestrictions,
                getNextFolder: getNextFolder,
                f: f
            }))));
    })(), selected > 0 && (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $4ab2a94a3ee5ad67$export$2e2bcd8739ae039), {
        selected: selected,
        done: done,
        cancel: cancel,
        i18n: i18n
    }));
}
var $ffc120143b595bcb$export$2e2bcd8739ae039 = $ffc120143b595bcb$var$Browser;



class $284651d7489bd34f$export$2e2bcd8739ae039 extends (0, $4d2e93495e50cc85$export$16fa2f45be04daa8) {
    componentWillUnmount() {
        const { onUnmount: onUnmount } = this.props;
        onUnmount();
    }
    render() {
        const { children: children } = this.props;
        return (0, $4d2e93495e50cc85$export$47e4c5b300681277)(children)[0];
    }
}



class $2b848f45ec727ac0$export$2e2bcd8739ae039 {
    constructor(plugin, opts){
        this.filterItems = (items)=>{
            const state = this.plugin.getPluginState();
            if (!state.filterInput || state.filterInput === '') return items;
            return items.filter((folder)=>{
                return folder.name.toLowerCase().indexOf(state.filterInput.toLowerCase()) !== -1;
            });
        };
        this.recordShiftKeyPress = (e)=>{
            this.isShiftKeyPressed = e.shiftKey;
        };
        this.isChecked = (file)=>{
            const { currentSelection: currentSelection } = this.plugin.getPluginState();
            // comparing id instead of the file object, because the reference to the object
            // changes when we switch folders, and the file list is updated
            return currentSelection.some((item)=>item.id === file.id);
        };
        this.plugin = plugin;
        this.provider = opts.provider;
        this.opts = opts;
        this.isHandlingScroll = false;
        this.preFirstRender = this.preFirstRender.bind(this);
        this.handleError = this.handleError.bind(this);
        this.clearSelection = this.clearSelection.bind(this);
        this.cancelPicking = this.cancelPicking.bind(this);
    }
    preFirstRender() {
        this.plugin.setPluginState({
            didFirstRender: true
        });
        this.plugin.onFirstRender();
    }
    shouldHandleScroll(event) {
        const { scrollHeight: scrollHeight, scrollTop: scrollTop, offsetHeight: offsetHeight } = event.target;
        const scrollPosition = scrollHeight - (scrollTop + offsetHeight);
        return scrollPosition < 50 && !this.isHandlingScroll;
    }
    clearSelection() {
        this.plugin.setPluginState({
            currentSelection: [],
            filterInput: ''
        });
    }
    cancelPicking() {
        this.clearSelection();
        const dashboard = this.plugin.uppy.getPlugin('Dashboard');
        if (dashboard) // @ts-expect-error impossible to type this correctly without adding dashboard
        // as a dependency to this package.
        dashboard.hideAllPanels();
    }
    handleError(error) {
        var _error$cause;
        const { uppy: uppy } = this.plugin;
        const message = uppy.i18n('companionError');
        uppy.log(error.toString());
        if (error.isAuthError || ((_error$cause = error.cause) == null ? void 0 : _error$cause.name) === 'AbortError') // authError just means we're not authenticated, don't show to user
        // AbortError means the user has clicked "cancel" on an operation
        return;
        uppy.info({
            message: message,
            details: error.toString()
        }, 'error', 5000);
    }
    registerRequestClient() {
        this.requestClientId = this.provider.provider;
        this.plugin.uppy.registerRequestClient(this.requestClientId, this.provider);
    }
    // TODO: document what is a "tagFile" or get rid of this concept
    getTagFile(file) {
        const tagFile = {
            id: file.id,
            source: this.plugin.id,
            name: file.name || file.id,
            type: file.mimeType,
            isRemote: true,
            data: file,
            // @ts-expect-error meta is filled conditionally below
            meta: {},
            body: {
                fileId: file.id
            },
            remote: {
                companionUrl: this.plugin.opts.companionUrl,
                // @ts-expect-error untyped for now
                url: `${this.provider.fileUrl(file.requestPath)}`,
                body: {
                    fileId: file.id
                },
                providerName: this.provider.name,
                provider: this.provider.provider,
                requestClientId: this.requestClientId
            }
        };
        if (file.thumbnail) tagFile.preview = file.thumbnail;
        if (file.author) {
            if (file.author.name != null) tagFile.meta.authorName = String(file.author.name);
            if (file.author.url) tagFile.meta.authorUrl = file.author.url;
        }
        // add relativePath similar to non-remote files: https://github.com/transloadit/uppy/pull/4486#issuecomment-1579203717
        if (file.relDirPath != null) tagFile.meta.relativePath = file.relDirPath ? `${file.relDirPath}/${tagFile.name}` : null;
        // and absolutePath (with leading slash) https://github.com/transloadit/uppy/pull/4537#issuecomment-1614236655
        if (file.absDirPath != null) tagFile.meta.absolutePath = file.absDirPath ? `/${file.absDirPath}/${tagFile.name}` : `/${tagFile.name}`;
        return tagFile;
    }
    /**
   * Toggles file/folder checkbox to on/off state while updating files list.
   *
   * Note that some extra complexity comes from supporting shift+click to
   * toggle multiple checkboxes at once, which is done by getting all files
   * in between last checked file and current one.
   */ toggleCheckbox(e, file) {
        e.stopPropagation();
        e.preventDefault();
        e.currentTarget.focus();
        const { folders: folders, files: files } = this.plugin.getPluginState();
        const items = this.filterItems(folders.concat(files));
        // Shift-clicking selects a single consecutive list of items
        // starting at the previous click.
        if (this.lastCheckbox && this.isShiftKeyPressed) {
            const { currentSelection: currentSelection } = this.plugin.getPluginState();
            const prevIndex = items.indexOf(this.lastCheckbox);
            const currentIndex = items.indexOf(file);
            const newSelection = prevIndex < currentIndex ? items.slice(prevIndex, currentIndex + 1) : items.slice(currentIndex, prevIndex + 1);
            const reducedNewSelection = [];
            // Check restrictions on each file in currentSelection,
            // reduce it to only contain files that pass restrictions
            for (const item of newSelection){
                const { uppy: uppy } = this.plugin;
                const restrictionError = uppy.validateRestrictions((0, $d0cca3c9705b0857$export$2e2bcd8739ae039)(item), [
                    ...uppy.getFiles(),
                    ...reducedNewSelection
                ]);
                if (!restrictionError) reducedNewSelection.push(item);
                else uppy.info({
                    message: restrictionError.message
                }, 'error', uppy.opts.infoTimeout);
            }
            this.plugin.setPluginState({
                currentSelection: [
                    ...new Set([
                        ...currentSelection,
                        ...reducedNewSelection
                    ])
                ]
            });
            return;
        }
        this.lastCheckbox = file;
        const { currentSelection: currentSelection } = this.plugin.getPluginState();
        if (this.isChecked(file)) this.plugin.setPluginState({
            currentSelection: currentSelection.filter((item)=>item.id !== file.id)
        });
        else this.plugin.setPluginState({
            currentSelection: currentSelection.concat([
                file
            ])
        });
    }
    setLoading(loading) {
        this.plugin.setPluginState({
            loading: loading
        });
    }
}


function $671181bcc8a0cf10$var$_classPrivateFieldLooseBase(receiver, privateKey) {
    if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) throw new TypeError("attempted to use private field on non-instance");
    return receiver;
}
var $671181bcc8a0cf10$var$id = 0;
function $671181bcc8a0cf10$var$_classPrivateFieldLooseKey(name) {
    return "__private_" + $671181bcc8a0cf10$var$id++ + "_" + name;
}
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore We don't want TS to generate types for the package.json
const $671181bcc8a0cf10$var$packageJson = {
    "version": "3.13.0"
};
function $671181bcc8a0cf10$var$formatBreadcrumbs(breadcrumbs) {
    return breadcrumbs.slice(1).map((directory)=>directory.name).join('/');
}
function $671181bcc8a0cf10$var$prependPath(path, component) {
    if (!path) return component;
    return `${path}/${component}`;
}
function $671181bcc8a0cf10$export$b9ab270927e310e4() {
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("svg", {
        "aria-hidden": "true",
        focusable: "false",
        width: "30",
        height: "30",
        viewBox: "0 0 30 30"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        d: "M15 30c8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15C6.716 0 0 6.716 0 15c0 8.284 6.716 15 15 15zm4.258-12.676v6.846h-8.426v-6.846H5.204l9.82-12.364 9.82 12.364H19.26z"
    }));
}
const $671181bcc8a0cf10$var$defaultOptions = {
    viewType: 'list',
    showTitles: true,
    showFilter: true,
    showBreadcrumbs: true,
    loadAllFiles: false,
    virtualList: false
};
var $671181bcc8a0cf10$var$_abortController = /*#__PURE__*/ $671181bcc8a0cf10$var$_classPrivateFieldLooseKey("abortController");
var $671181bcc8a0cf10$var$_withAbort = /*#__PURE__*/ $671181bcc8a0cf10$var$_classPrivateFieldLooseKey("withAbort");
var $671181bcc8a0cf10$var$_list = /*#__PURE__*/ $671181bcc8a0cf10$var$_classPrivateFieldLooseKey("list");
var $671181bcc8a0cf10$var$_listFilesAndFolders = /*#__PURE__*/ $671181bcc8a0cf10$var$_classPrivateFieldLooseKey("listFilesAndFolders");
var $671181bcc8a0cf10$var$_recursivelyListAllFiles = /*#__PURE__*/ $671181bcc8a0cf10$var$_classPrivateFieldLooseKey("recursivelyListAllFiles");
class $671181bcc8a0cf10$export$2e2bcd8739ae039 extends (0, $2b848f45ec727ac0$export$2e2bcd8739ae039) {
    constructor(plugin, opts){
        super(plugin, {
            ...$671181bcc8a0cf10$var$defaultOptions,
            ...opts
        });
        // Logic
        Object.defineProperty(this, $671181bcc8a0cf10$var$_recursivelyListAllFiles, {
            value: $671181bcc8a0cf10$var$_recursivelyListAllFiles2
        });
        Object.defineProperty(this, $671181bcc8a0cf10$var$_listFilesAndFolders, {
            value: $671181bcc8a0cf10$var$_listFilesAndFolders2
        });
        Object.defineProperty(this, $671181bcc8a0cf10$var$_list, {
            value: $671181bcc8a0cf10$var$_list2
        });
        Object.defineProperty(this, $671181bcc8a0cf10$var$_withAbort, {
            value: $671181bcc8a0cf10$var$_withAbort2
        });
        Object.defineProperty(this, $671181bcc8a0cf10$var$_abortController, {
            writable: true,
            value: void 0
        });
        this.filterQuery = this.filterQuery.bind(this);
        this.clearFilter = this.clearFilter.bind(this);
        this.getFolder = this.getFolder.bind(this);
        this.getNextFolder = this.getNextFolder.bind(this);
        this.logout = this.logout.bind(this);
        this.handleAuth = this.handleAuth.bind(this);
        this.handleScroll = this.handleScroll.bind(this);
        this.donePicking = this.donePicking.bind(this);
        // Visual
        this.render = this.render.bind(this);
        // Set default state for the plugin
        this.plugin.setPluginState({
            authenticated: undefined,
            // we don't know yet
            files: [],
            folders: [],
            breadcrumbs: [],
            filterInput: '',
            isSearchVisible: false,
            currentSelection: []
        });
        this.registerRequestClient();
    }
    // eslint-disable-next-line class-methods-use-this
    tearDown() {
    // Nothing.
    }
    /**
   * Select a folder based on its id: fetches the folder and then updates state with its contents
   * TODO rename to something better like selectFolder or navigateToFolder (breaking change?)
   *
   */ async getFolder(requestPath, name) {
        this.setLoading(true);
        try {
            await $671181bcc8a0cf10$var$_classPrivateFieldLooseBase(this, $671181bcc8a0cf10$var$_withAbort)[$671181bcc8a0cf10$var$_withAbort](async (signal)=>{
                this.lastCheckbox = undefined;
                let { breadcrumbs: breadcrumbs } = this.plugin.getPluginState();
                const index = breadcrumbs.findIndex((dir)=>requestPath === dir.requestPath);
                if (index !== -1) // means we navigated back to a known directory (already in the stack), so cut the stack off there
                breadcrumbs = breadcrumbs.slice(0, index + 1);
                else // we have navigated into a new (unknown) folder, add it to the stack
                breadcrumbs = [
                    ...breadcrumbs,
                    {
                        requestPath: requestPath,
                        name: name
                    }
                ];
                this.nextPagePath = requestPath;
                let files = [];
                let folders = [];
                do {
                    const { files: newFiles, folders: newFolders } = await $671181bcc8a0cf10$var$_classPrivateFieldLooseBase(this, $671181bcc8a0cf10$var$_listFilesAndFolders)[$671181bcc8a0cf10$var$_listFilesAndFolders]({
                        breadcrumbs: breadcrumbs,
                        signal: signal
                    });
                    files = files.concat(newFiles);
                    folders = folders.concat(newFolders);
                    this.setLoading(this.plugin.uppy.i18n('loadedXFiles', {
                        numFiles: files.length + folders.length
                    }));
                }while (this.opts.loadAllFiles && this.nextPagePath);
                this.plugin.setPluginState({
                    folders: folders,
                    files: files,
                    breadcrumbs: breadcrumbs,
                    filterInput: ''
                });
            });
        } catch (err) {
            // This is the first call that happens when the provider view loads, after auth, so it's probably nice to show any
            // error occurring here to the user.
            if ((err == null ? void 0 : err.name) === 'UserFacingApiError') {
                this.plugin.uppy.info({
                    message: this.plugin.uppy.i18n(err.message)
                }, 'warning', 5000);
                return;
            }
            this.handleError(err);
        } finally{
            this.setLoading(false);
        }
    }
    /**
   * Fetches new folder
   */ getNextFolder(folder) {
        this.getFolder(folder.requestPath, folder.name);
        this.lastCheckbox = undefined;
    }
    /**
   * Removes session token on client side.
   */ async logout() {
        try {
            await $671181bcc8a0cf10$var$_classPrivateFieldLooseBase(this, $671181bcc8a0cf10$var$_withAbort)[$671181bcc8a0cf10$var$_withAbort](async (signal)=>{
                const res = await this.provider.logout({
                    signal: signal
                });
                // res.ok is from the JSON body, not to be confused with Response.ok
                if (res.ok) {
                    if (!res.revoked) {
                        const message = this.plugin.uppy.i18n('companionUnauthorizeHint', {
                            provider: this.plugin.title,
                            url: res.manual_revoke_url
                        });
                        this.plugin.uppy.info(message, 'info', 7000);
                    }
                    const newState = {
                        authenticated: false,
                        files: [],
                        folders: [],
                        breadcrumbs: [],
                        filterInput: ''
                    };
                    this.plugin.setPluginState(newState);
                }
            });
        } catch (err) {
            this.handleError(err);
        }
    }
    filterQuery(input) {
        this.plugin.setPluginState({
            filterInput: input
        });
    }
    clearFilter() {
        this.plugin.setPluginState({
            filterInput: ''
        });
    }
    async handleAuth(authFormData) {
        try {
            await $671181bcc8a0cf10$var$_classPrivateFieldLooseBase(this, $671181bcc8a0cf10$var$_withAbort)[$671181bcc8a0cf10$var$_withAbort](async (signal)=>{
                this.setLoading(true);
                await this.provider.login({
                    authFormData: authFormData,
                    signal: signal
                });
                this.plugin.setPluginState({
                    authenticated: true
                });
                this.preFirstRender();
            });
        } catch (err) {
            if (err.name === 'UserFacingApiError') {
                this.plugin.uppy.info({
                    message: this.plugin.uppy.i18n(err.message)
                }, 'warning', 5000);
                return;
            }
            this.plugin.uppy.log(`login failed: ${err.message}`);
        } finally{
            this.setLoading(false);
        }
    }
    async handleScroll(event) {
        if (this.shouldHandleScroll(event) && this.nextPagePath) {
            this.isHandlingScroll = true;
            try {
                await $671181bcc8a0cf10$var$_classPrivateFieldLooseBase(this, $671181bcc8a0cf10$var$_withAbort)[$671181bcc8a0cf10$var$_withAbort](async (signal)=>{
                    const { files: files, folders: folders, breadcrumbs: breadcrumbs } = this.plugin.getPluginState();
                    const { files: newFiles, folders: newFolders } = await $671181bcc8a0cf10$var$_classPrivateFieldLooseBase(this, $671181bcc8a0cf10$var$_listFilesAndFolders)[$671181bcc8a0cf10$var$_listFilesAndFolders]({
                        breadcrumbs: breadcrumbs,
                        signal: signal
                    });
                    const combinedFiles = files.concat(newFiles);
                    const combinedFolders = folders.concat(newFolders);
                    this.plugin.setPluginState({
                        folders: combinedFolders,
                        files: combinedFiles
                    });
                });
            } catch (error) {
                this.handleError(error);
            } finally{
                this.isHandlingScroll = false;
            }
        }
    }
    async donePicking() {
        this.setLoading(true);
        try {
            await $671181bcc8a0cf10$var$_classPrivateFieldLooseBase(this, $671181bcc8a0cf10$var$_withAbort)[$671181bcc8a0cf10$var$_withAbort](async (signal)=>{
                const { currentSelection: currentSelection } = this.plugin.getPluginState();
                const messages = [];
                const newFiles = [];
                for (const selectedItem of currentSelection){
                    const { requestPath: requestPath } = selectedItem;
                    const withRelDirPath = (newItem)=>({
                            ...newItem,
                            // calculate the file's path relative to the user's selected item's path
                            // see https://github.com/transloadit/uppy/pull/4537#issuecomment-1614236655
                            relDirPath: newItem.absDirPath.replace(selectedItem.absDirPath, '').replace(/^\//, '')
                        });
                    if (selectedItem.isFolder) {
                        let isEmpty = true;
                        let numNewFiles = 0;
                        const queue = new (0, (/*@__PURE__*/$parcel$interopDefault($11d558640132ea3e$exports)))({
                            concurrency: 6
                        });
                        const onFiles = (files)=>{
                            for (const newFile of files){
                                const tagFile = this.getTagFile(newFile);
                                const id = (0, $d67267bb9859462b$export$2ff5b23440673856)(tagFile, this.plugin.uppy.getID());
                                // If the same folder is added again, we don't want to send
                                // X amount of duplicate file notifications, we want to say
                                // the folder was already added. This checks if all files are duplicate,
                                // if that's the case, we don't add the files.
                                if (!this.plugin.uppy.checkIfFileAlreadyExists(id)) {
                                    newFiles.push(withRelDirPath(newFile));
                                    numNewFiles++;
                                    this.setLoading(this.plugin.uppy.i18n('addedNumFiles', {
                                        numFiles: numNewFiles
                                    }));
                                }
                                isEmpty = false;
                            }
                        };
                        await $671181bcc8a0cf10$var$_classPrivateFieldLooseBase(this, $671181bcc8a0cf10$var$_recursivelyListAllFiles)[$671181bcc8a0cf10$var$_recursivelyListAllFiles]({
                            requestPath: requestPath,
                            absDirPath: $671181bcc8a0cf10$var$prependPath(selectedItem.absDirPath, selectedItem.name),
                            relDirPath: selectedItem.name,
                            queue: queue,
                            onFiles: onFiles,
                            signal: signal
                        });
                        await queue.onIdle();
                        let message;
                        if (isEmpty) message = this.plugin.uppy.i18n('emptyFolderAdded');
                        else if (numNewFiles === 0) message = this.plugin.uppy.i18n('folderAlreadyAdded', {
                            folder: selectedItem.name
                        });
                        else // TODO we don't really know at this point whether any files were actually added
                        // (only later after addFiles has been called) so we should probably rewrite this.
                        // Example: If all files fail to add due to restriction error, it will still say "Added 100 files from folder"
                        message = this.plugin.uppy.i18n('folderAdded', {
                            smart_count: numNewFiles,
                            folder: selectedItem.name
                        });
                        messages.push(message);
                    } else newFiles.push(withRelDirPath(selectedItem));
                }
                // Note: this.plugin.uppy.addFiles must be only run once we are done fetching all files,
                // because it will cause the loading screen to disappear,
                // and that will allow the user to start the upload, so we need to make sure we have
                // finished all async operations before we add any file
                // see https://github.com/transloadit/uppy/pull/4384
                this.plugin.uppy.log('Adding files from a remote provider');
                this.plugin.uppy.addFiles(// @ts-expect-error `addFiles` expects `body` to be `File` or `Blob`,
                // but as the todo comment in `View.ts` indicates, we strangly pass `CompanionFile` as `body`.
                // For now it's better to ignore than to have a potential breaking change.
                newFiles.map((file)=>this.getTagFile(file, this.requestClientId)));
                this.plugin.setPluginState({
                    filterInput: ''
                });
                messages.forEach((message)=>this.plugin.uppy.info(message));
                this.clearSelection();
            });
        } catch (err) {
            this.handleError(err);
        } finally{
            this.setLoading(false);
        }
    }
    render(state, viewOptions) {
        var _this = this;
        if (viewOptions === void 0) viewOptions = {};
        const { authenticated: authenticated, didFirstRender: didFirstRender } = this.plugin.getPluginState();
        const { i18n: i18n } = this.plugin.uppy;
        if (!didFirstRender) this.preFirstRender();
        const targetViewOptions = {
            ...this.opts,
            ...viewOptions
        };
        const { files: files, folders: folders, filterInput: filterInput, loading: loading, currentSelection: currentSelection } = this.plugin.getPluginState();
        const { isChecked: isChecked, recordShiftKeyPress: recordShiftKeyPress, filterItems: filterItems } = this;
        const hasInput = filterInput !== '';
        const pluginIcon = this.plugin.icon || $671181bcc8a0cf10$export$b9ab270927e310e4;
        const headerProps = {
            showBreadcrumbs: targetViewOptions.showBreadcrumbs,
            getFolder: this.getFolder,
            breadcrumbs: this.plugin.getPluginState().breadcrumbs,
            pluginIcon: pluginIcon,
            title: this.plugin.title,
            logout: this.logout,
            username: this.username,
            i18n: i18n
        };
        const browserProps = {
            isChecked: isChecked,
            toggleCheckbox: this.toggleCheckbox.bind(this),
            recordShiftKeyPress: recordShiftKeyPress,
            currentSelection: currentSelection,
            files: hasInput ? filterItems(files) : files,
            folders: hasInput ? filterItems(folders) : folders,
            getNextFolder: this.getNextFolder,
            getFolder: this.getFolder,
            loadAllFiles: this.opts.loadAllFiles,
            virtualList: this.opts.virtualList,
            // For SearchFilterInput component
            showSearchFilter: targetViewOptions.showFilter,
            search: this.filterQuery,
            clearSearch: this.clearFilter,
            searchTerm: filterInput,
            searchOnInput: true,
            searchInputLabel: i18n('filter'),
            clearSearchLabel: i18n('resetFilter'),
            noResultsLabel: i18n('noFilesFound'),
            logout: this.logout,
            handleScroll: this.handleScroll,
            done: this.donePicking,
            cancel: this.cancelPicking,
            // eslint-disable-next-line react/jsx-props-no-spreading
            headerComponent: (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $6b1b801e011f359f$export$2e2bcd8739ae039), headerProps),
            title: this.plugin.title,
            viewType: targetViewOptions.viewType,
            showTitles: targetViewOptions.showTitles,
            showBreadcrumbs: targetViewOptions.showBreadcrumbs,
            pluginIcon: pluginIcon,
            i18n: this.plugin.uppy.i18n,
            uppyFiles: this.plugin.uppy.getFiles(),
            validateRestrictions: function() {
                return _this.plugin.uppy.validateRestrictions(...arguments);
            },
            isLoading: loading
        };
        if (authenticated === false) return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $284651d7489bd34f$export$2e2bcd8739ae039), {
            onUnmount: this.clearSelection
        }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $616f0acd28bd0dc4$export$2e2bcd8739ae039), {
            pluginName: this.plugin.title,
            pluginIcon: pluginIcon,
            handleAuth: this.handleAuth,
            i18n: this.plugin.uppy.i18nArray,
            renderForm: this.opts.renderAuthForm,
            loading: loading
        }));
        return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $284651d7489bd34f$export$2e2bcd8739ae039), {
            onUnmount: this.clearSelection
        }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $ffc120143b595bcb$export$2e2bcd8739ae039), browserProps));
    }
}
async function $671181bcc8a0cf10$var$_withAbort2(op) {
    var _classPrivateFieldLoo;
    // prevent multiple requests in parallel from causing race conditions
    (_classPrivateFieldLoo = $671181bcc8a0cf10$var$_classPrivateFieldLooseBase(this, $671181bcc8a0cf10$var$_abortController)[$671181bcc8a0cf10$var$_abortController]) == null || _classPrivateFieldLoo.abort();
    const abortController = new AbortController();
    $671181bcc8a0cf10$var$_classPrivateFieldLooseBase(this, $671181bcc8a0cf10$var$_abortController)[$671181bcc8a0cf10$var$_abortController] = abortController;
    const cancelRequest = ()=>{
        abortController.abort();
        this.clearSelection();
    };
    try {
        // @ts-expect-error this should be typed in @uppy/dashboard.
        // Even then I don't think we can make this work without adding dashboard
        // as a dependency to provider-views.
        this.plugin.uppy.on('dashboard:close-panel', cancelRequest);
        this.plugin.uppy.on('cancel-all', cancelRequest);
        await op(abortController.signal);
    } finally{
        // @ts-expect-error this should be typed in @uppy/dashboard.
        // Even then I don't think we can make this work without adding dashboard
        // as a dependency to provider-views.
        this.plugin.uppy.off('dashboard:close-panel', cancelRequest);
        this.plugin.uppy.off('cancel-all', cancelRequest);
        $671181bcc8a0cf10$var$_classPrivateFieldLooseBase(this, $671181bcc8a0cf10$var$_abortController)[$671181bcc8a0cf10$var$_abortController] = undefined;
    }
}
async function $671181bcc8a0cf10$var$_list2(_ref) {
    let { requestPath: requestPath, absDirPath: absDirPath, signal: signal } = _ref;
    const { username: username, nextPagePath: nextPagePath, items: items } = await this.provider.list(requestPath, {
        signal: signal
    });
    this.username = username || this.username;
    return {
        items: items.map((item)=>({
                ...item,
                absDirPath: absDirPath
            })),
        nextPagePath: nextPagePath
    };
}
async function $671181bcc8a0cf10$var$_listFilesAndFolders2(_ref2) {
    let { breadcrumbs: breadcrumbs, signal: signal } = _ref2;
    const absDirPath = $671181bcc8a0cf10$var$formatBreadcrumbs(breadcrumbs);
    const { items: items, nextPagePath: nextPagePath } = await $671181bcc8a0cf10$var$_classPrivateFieldLooseBase(this, $671181bcc8a0cf10$var$_list)[$671181bcc8a0cf10$var$_list]({
        requestPath: this.nextPagePath,
        absDirPath: absDirPath,
        signal: signal
    });
    this.nextPagePath = nextPagePath;
    const files = [];
    const folders = [];
    items.forEach((item)=>{
        if (item.isFolder) folders.push(item);
        else files.push(item);
    });
    return {
        files: files,
        folders: folders
    };
}
async function $671181bcc8a0cf10$var$_recursivelyListAllFiles2(_ref3) {
    let { requestPath: requestPath, absDirPath: absDirPath, relDirPath: relDirPath, queue: queue, onFiles: onFiles, signal: signal } = _ref3;
    let curPath = requestPath;
    while(curPath){
        const res = await $671181bcc8a0cf10$var$_classPrivateFieldLooseBase(this, $671181bcc8a0cf10$var$_list)[$671181bcc8a0cf10$var$_list]({
            requestPath: curPath,
            absDirPath: absDirPath,
            signal: signal
        });
        curPath = res.nextPagePath;
        const files = res.items.filter((item)=>!item.isFolder);
        const folders = res.items.filter((item)=>item.isFolder);
        onFiles(files);
        // recursively queue call to self for each folder
        const promises = folders.map(async (folder)=>queue.add(async ()=>$671181bcc8a0cf10$var$_classPrivateFieldLooseBase(this, $671181bcc8a0cf10$var$_recursivelyListAllFiles)[$671181bcc8a0cf10$var$_recursivelyListAllFiles]({
                    requestPath: folder.requestPath,
                    absDirPath: $671181bcc8a0cf10$var$prependPath(absDirPath, folder.name),
                    relDirPath: $671181bcc8a0cf10$var$prependPath(relDirPath, folder.name),
                    queue: queue,
                    onFiles: onFiles,
                    signal: signal
                })));
        await Promise.all(promises); // in case we get an error
    }
}
$671181bcc8a0cf10$export$2e2bcd8739ae039.VERSION = $671181bcc8a0cf10$var$packageJson.version;









function $3174b53b600a62c5$var$_classPrivateFieldLooseBase(receiver, privateKey) {
    if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) throw new TypeError("attempted to use private field on non-instance");
    return receiver;
}
var $3174b53b600a62c5$var$id = 0;
function $3174b53b600a62c5$var$_classPrivateFieldLooseKey(name) {
    return "__private_" + $3174b53b600a62c5$var$id++ + "_" + name;
}
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore We don't want TS to generate types for the package.json
const $3174b53b600a62c5$var$packageJson = {
    "version": "3.13.0"
};
const $3174b53b600a62c5$var$defaultState = {
    isInputMode: true,
    files: [],
    folders: [],
    breadcrumbs: [],
    filterInput: '',
    currentSelection: [],
    searchTerm: null
};
const $3174b53b600a62c5$var$defaultOptions = {
    viewType: 'grid',
    showTitles: true,
    showFilter: true,
    showBreadcrumbs: true
};
var $3174b53b600a62c5$var$_updateFilesAndInputMode = /*#__PURE__*/ $3174b53b600a62c5$var$_classPrivateFieldLooseKey("updateFilesAndInputMode");
class $3174b53b600a62c5$export$2e2bcd8739ae039 extends (0, $2b848f45ec727ac0$export$2e2bcd8739ae039) {
    constructor(plugin, opts){
        super(plugin, {
            ...$3174b53b600a62c5$var$defaultOptions,
            ...opts
        });
        Object.defineProperty(this, $3174b53b600a62c5$var$_updateFilesAndInputMode, {
            value: $3174b53b600a62c5$var$_updateFilesAndInputMode2
        });
        this.nextPageQuery = null;
        this.search = this.search.bind(this);
        this.clearSearch = this.clearSearch.bind(this);
        this.resetPluginState = this.resetPluginState.bind(this);
        this.handleScroll = this.handleScroll.bind(this);
        this.donePicking = this.donePicking.bind(this);
        this.render = this.render.bind(this);
        this.plugin.setPluginState($3174b53b600a62c5$var$defaultState);
        this.registerRequestClient();
    }
    // eslint-disable-next-line class-methods-use-this
    tearDown() {
    // Nothing.
    }
    resetPluginState() {
        this.plugin.setPluginState($3174b53b600a62c5$var$defaultState);
    }
    async search(query) {
        const { searchTerm: searchTerm } = this.plugin.getPluginState();
        if (query && query === searchTerm) // no need to search again as this is the same as the previous search
        return;
        this.setLoading(true);
        try {
            const res = await this.provider.search(query);
            $3174b53b600a62c5$var$_classPrivateFieldLooseBase(this, $3174b53b600a62c5$var$_updateFilesAndInputMode)[$3174b53b600a62c5$var$_updateFilesAndInputMode](res, []);
        } catch (err) {
            this.handleError(err);
        } finally{
            this.setLoading(false);
        }
    }
    clearSearch() {
        this.plugin.setPluginState({
            currentSelection: [],
            files: [],
            searchTerm: null
        });
    }
    async handleScroll(event) {
        const query = this.nextPageQuery || null;
        if (this.shouldHandleScroll(event) && query) {
            this.isHandlingScroll = true;
            try {
                const { files: files, searchTerm: searchTerm } = this.plugin.getPluginState();
                const response = await this.provider.search(searchTerm, query);
                $3174b53b600a62c5$var$_classPrivateFieldLooseBase(this, $3174b53b600a62c5$var$_updateFilesAndInputMode)[$3174b53b600a62c5$var$_updateFilesAndInputMode](response, files);
            } catch (error) {
                this.handleError(error);
            } finally{
                this.isHandlingScroll = false;
            }
        }
    }
    donePicking() {
        const { currentSelection: currentSelection } = this.plugin.getPluginState();
        this.plugin.uppy.log('Adding remote search provider files');
        this.plugin.uppy.addFiles(currentSelection.map((file)=>this.getTagFile(file)));
        this.resetPluginState();
    }
    render(state, viewOptions) {
        var _this = this;
        if (viewOptions === void 0) viewOptions = {};
        const { didFirstRender: didFirstRender, isInputMode: isInputMode, searchTerm: searchTerm } = this.plugin.getPluginState();
        const { i18n: i18n } = this.plugin.uppy;
        if (!didFirstRender) this.preFirstRender();
        const targetViewOptions = {
            ...this.opts,
            ...viewOptions
        };
        const { files: files, folders: folders, filterInput: filterInput, loading: loading, currentSelection: currentSelection } = this.plugin.getPluginState();
        const { isChecked: isChecked, filterItems: filterItems, recordShiftKeyPress: recordShiftKeyPress } = this;
        const hasInput = filterInput !== '';
        const browserProps = {
            isChecked: isChecked,
            toggleCheckbox: this.toggleCheckbox.bind(this),
            recordShiftKeyPress: recordShiftKeyPress,
            currentSelection: currentSelection,
            files: hasInput ? filterItems(files) : files,
            folders: hasInput ? filterItems(folders) : folders,
            handleScroll: this.handleScroll,
            done: this.donePicking,
            cancel: this.cancelPicking,
            // For SearchFilterInput component
            showSearchFilter: targetViewOptions.showFilter,
            search: this.search,
            clearSearch: this.clearSearch,
            searchTerm: searchTerm,
            searchOnInput: false,
            searchInputLabel: i18n('search'),
            clearSearchLabel: i18n('resetSearch'),
            noResultsLabel: i18n('noSearchResults'),
            title: this.plugin.title,
            viewType: targetViewOptions.viewType,
            showTitles: targetViewOptions.showTitles,
            showFilter: targetViewOptions.showFilter,
            isLoading: loading,
            showBreadcrumbs: targetViewOptions.showBreadcrumbs,
            pluginIcon: this.plugin.icon,
            i18n: i18n,
            uppyFiles: this.plugin.uppy.getFiles(),
            validateRestrictions: function() {
                return _this.plugin.uppy.validateRestrictions(...arguments);
            }
        };
        if (isInputMode) return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $284651d7489bd34f$export$2e2bcd8739ae039), {
            onUnmount: this.resetPluginState
        }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
            className: "uppy-SearchProvider"
        }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $a64872f8825ef0cd$export$2e2bcd8739ae039), {
            search: this.search,
            inputLabel: i18n('enterTextToSearch'),
            buttonLabel: i18n('searchImages'),
            inputClassName: "uppy-c-textInput uppy-SearchProvider-input",
            buttonCSSClassName: "uppy-SearchProvider-searchButton",
            showButton: true
        })));
        return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $284651d7489bd34f$export$2e2bcd8739ae039), {
            onUnmount: this.resetPluginState
        }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $ffc120143b595bcb$export$2e2bcd8739ae039), browserProps));
    }
}
function $3174b53b600a62c5$var$_updateFilesAndInputMode2(res, files) {
    this.nextPageQuery = res.nextPageQuery;
    res.items.forEach((item)=>{
        files.push(item);
    });
    this.plugin.setPluginState({
        currentSelection: [],
        isInputMode: false,
        files: files,
        searchTerm: res.searchedFor
    });
}
$3174b53b600a62c5$export$2e2bcd8739ae039.VERSION = $3174b53b600a62c5$var$packageJson.version;






let $ee6f2436cceea22a$var$urlAlphabet = 'useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict';
let $ee6f2436cceea22a$export$62e99e5c9f473d7f = (alphabet, defaultSize = 21)=>{
    return (size = defaultSize)=>{
        let id = '';
        let i = size | 0;
        while(i--)id += alphabet[Math.random() * alphabet.length | 0];
        return id;
    };
};
let $ee6f2436cceea22a$export$ac4959f4f1338dfc = (size = 21)=>{
    let id = '';
    let i = size | 0;
    while(i--)id += $ee6f2436cceea22a$var$urlAlphabet[Math.random() * 64 | 0];
    return id;
};


var $e66b69e563b626e6$var$safeIsNaN = Number.isNaN || function ponyfill(value) {
    return typeof value === 'number' && value !== value;
};
function $e66b69e563b626e6$var$isEqual(first, second) {
    if (first === second) return true;
    if ($e66b69e563b626e6$var$safeIsNaN(first) && $e66b69e563b626e6$var$safeIsNaN(second)) return true;
    return false;
}
function $e66b69e563b626e6$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (!$e66b69e563b626e6$var$isEqual(newInputs[i], lastInputs[i])) return false;
    }
    return true;
}
function $e66b69e563b626e6$export$2e2bcd8739ae039(resultFn, isEqual) {
    if (isEqual === void 0) isEqual = $e66b69e563b626e6$var$areInputsEqual;
    var cache = null;
    function memoized() {
        var newArgs = [];
        for(var _i = 0; _i < arguments.length; _i++)newArgs[_i] = arguments[_i];
        if (cache && cache.lastThis === this && isEqual(newArgs, cache.lastArgs)) return cache.lastResult;
        var lastResult = resultFn.apply(this, newArgs);
        cache = {
            lastResult: lastResult,
            lastArgs: newArgs,
            lastThis: this
        };
        return lastResult;
    }
    memoized.clear = function clear() {
        cache = null;
    };
    return memoized;
}



var $a6c8757fba02bc34$export$2e2bcd8739ae039 = [
    'a[href]:not([tabindex^="-"]):not([inert]):not([aria-hidden])',
    'area[href]:not([tabindex^="-"]):not([inert]):not([aria-hidden])',
    'input:not([disabled]):not([inert]):not([aria-hidden])',
    'select:not([disabled]):not([inert]):not([aria-hidden])',
    'textarea:not([disabled]):not([inert]):not([aria-hidden])',
    'button:not([disabled]):not([inert]):not([aria-hidden])',
    'iframe:not([tabindex^="-"]):not([inert]):not([aria-hidden])',
    'object:not([tabindex^="-"]):not([inert]):not([aria-hidden])',
    'embed:not([tabindex^="-"]):not([inert]):not([aria-hidden])',
    '[contenteditable]:not([tabindex^="-"]):not([inert]):not([aria-hidden])',
    '[tabindex]:not([tabindex^="-"]):not([inert]):not([aria-hidden])'
];


/**
 * @returns {HTMLElement} - either dashboard element, or the overlay that's most on top
 */ function $0a4934e80baa1792$export$2e2bcd8739ae039(dashboardEl, activeOverlayType) {
    if (activeOverlayType) {
        const overlayEl = dashboardEl.querySelector(`[data-uppy-paneltype="${activeOverlayType}"]`);
        // if an overlay is already mounted
        if (overlayEl) return overlayEl;
    }
    return dashboardEl;
}


function $f5d602e6112dba3d$var$focusOnFirstNode(event, nodes) {
    const node = nodes[0];
    if (node) {
        node.focus();
        event.preventDefault();
    }
}
function $f5d602e6112dba3d$var$focusOnLastNode(event, nodes) {
    const node = nodes[nodes.length - 1];
    if (node) {
        node.focus();
        event.preventDefault();
    }
}
// ___Why not just use (focusedItemIndex === -1)?
//    Firefox thinks <ul> is focusable, but we don't have <ul>s in our FOCUSABLE_ELEMENTS. Which means that if we tab into
//    the <ul>, code will think that we are not in the active overlay, and we should focusOnFirstNode() of the currently
//    active overlay!
//    [Practical check] if we use (focusedItemIndex === -1), instagram provider in firefox will never get focus on its pics
//    in the <ul>.
function $f5d602e6112dba3d$var$isFocusInOverlay(activeOverlayEl) {
    return activeOverlayEl.contains(document.activeElement);
}
function $f5d602e6112dba3d$export$f41e0874aee57111(event, activeOverlayType, dashboardEl) {
    const activeOverlayEl = (0, $0a4934e80baa1792$export$2e2bcd8739ae039)(dashboardEl, activeOverlayType);
    const focusableNodes = (0, $d737086ca91a9c7d$export$2e2bcd8739ae039)(activeOverlayEl.querySelectorAll((0, $a6c8757fba02bc34$export$2e2bcd8739ae039)));
    const focusedItemIndex = focusableNodes.indexOf(document.activeElement);
    // If we pressed tab, and focus is not yet within the current overlay - focus on
    // the first element within the current overlay.
    // This is a safety measure (for when user returns from another tab e.g.), most
    // plugins will try to focus on some important element as it loads.
    if (!$f5d602e6112dba3d$var$isFocusInOverlay(activeOverlayEl)) $f5d602e6112dba3d$var$focusOnFirstNode(event, focusableNodes);
    else if (event.shiftKey && focusedItemIndex === 0) $f5d602e6112dba3d$var$focusOnLastNode(event, focusableNodes);
    else if (!event.shiftKey && focusedItemIndex === focusableNodes.length - 1) $f5d602e6112dba3d$var$focusOnFirstNode(event, focusableNodes);
}
function $f5d602e6112dba3d$export$66fd63158b65050a(event, activeOverlayType, dashboardEl) {
    // ___When we're in the bare 'Drop files here, paste, browse or import from' screen
    if (activeOverlayType === null) ;
    else // Trap the focus inside this overlay!
    // User can close the overlay (click 'Done') if they want to travel away from Uppy.
    $f5d602e6112dba3d$export$f41e0874aee57111(event, activeOverlayType, dashboardEl);
}





function $33dc1dd867a7b8b6$export$2e2bcd8739ae039() {
    let lastFocusWasOnSuperFocusableEl = false;
    const superFocus = (dashboardEl, activeOverlayType)=>{
        const overlayEl = (0, $0a4934e80baa1792$export$2e2bcd8739ae039)(dashboardEl, activeOverlayType);
        const isFocusInOverlay = overlayEl.contains(document.activeElement);
        // If focus is already in the topmost overlay, AND on last update we focused on the superfocusable
        // element - then leave focus up to the user.
        // [Practical check] without this line, typing in the search input in googledrive overlay won't work.
        if (isFocusInOverlay && lastFocusWasOnSuperFocusableEl) return;
        const superFocusableEl = overlayEl.querySelector('[data-uppy-super-focusable]');
        // If we are already in the topmost overlay, AND there are no super focusable elements yet, - leave focus up to the user.
        // [Practical check] without this line, if you are in an empty folder in google drive, and something's uploading in the
        // bg, - focus will be jumping to Done all the time.
        if (isFocusInOverlay && !superFocusableEl) return;
        if (superFocusableEl) {
            superFocusableEl.focus({
                preventScroll: true
            });
            lastFocusWasOnSuperFocusableEl = true;
        } else {
            const firstEl = overlayEl.querySelector((0, $a6c8757fba02bc34$export$2e2bcd8739ae039));
            firstEl == null || firstEl.focus({
                preventScroll: true
            });
            lastFocusWasOnSuperFocusableEl = false;
        }
    };
    // ___Why do we need to debounce?
    //    1. To deal with animations: overlay changes via animations, which results in the DOM updating AFTER plugin.update()
    //       already executed.
    //    [Practical check] without debounce, if we open the Url overlay, and click 'Done', Dashboard won't get focused again.
    //    [Practical check] if we delay 250ms instead of 260ms - IE11 won't get focused in same situation.
    //    2. Performance: there can be many state update()s in a second, and this function is called every time.
    return (0, (/*@__PURE__*/$parcel$interopDefault($8284bc2b60dc4bc4$exports)))(superFocus, 260);
}




/**
 * Checks if the browser supports Drag & Drop (not supported on mobile devices, for example).
 */ function $5e3c26e19f70d299$export$2e2bcd8739ae039() {
    const div = document.body;
    if (!('draggable' in div) || !('ondragstart' in div && 'ondrop' in div)) return false;
    if (!('FormData' in window)) return false;
    if (!('FileReader' in window)) return false;
    return true;
}





// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck Typing this file requires more work, skipping it to unblock the rest of the transition.
/* eslint-disable react/destructuring-assignment */ 

var $1181142648d48c51$exports = {};
$1181142648d48c51$exports = function isShallowEqual(a, b) {
    if (a === b) return true;
    for(var i in a)if (!(i in b)) return false;
    for(var i in b)if (a[i] !== b[i]) return false;
    return true;
};





function $7fe1d951359cc6e1$var$iconImage() {
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("svg", {
        "aria-hidden": "true",
        focusable: "false",
        width: "25",
        height: "25",
        viewBox: "0 0 25 25"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("g", {
        fill: "#686DE0",
        fillRule: "evenodd"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        d: "M5 7v10h15V7H5zm0-1h15a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1z",
        fillRule: "nonzero"
    }), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        d: "M6.35 17.172l4.994-5.026a.5.5 0 0 1 .707 0l2.16 2.16 3.505-3.505a.5.5 0 0 1 .707 0l2.336 2.31-.707.72-1.983-1.97-3.505 3.505a.5.5 0 0 1-.707 0l-2.16-2.159-3.938 3.939-1.409.026z",
        fillRule: "nonzero"
    }), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("circle", {
        cx: "7.5",
        cy: "9.5",
        r: "1.5"
    })));
}
function $7fe1d951359cc6e1$var$iconAudio() {
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("svg", {
        "aria-hidden": "true",
        focusable: "false",
        className: "uppy-c-icon",
        width: "25",
        height: "25",
        viewBox: "0 0 25 25"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        d: "M9.5 18.64c0 1.14-1.145 2-2.5 2s-2.5-.86-2.5-2c0-1.14 1.145-2 2.5-2 .557 0 1.079.145 1.5.396V7.25a.5.5 0 0 1 .379-.485l9-2.25A.5.5 0 0 1 18.5 5v11.64c0 1.14-1.145 2-2.5 2s-2.5-.86-2.5-2c0-1.14 1.145-2 2.5-2 .557 0 1.079.145 1.5.396V8.67l-8 2v7.97zm8-11v-2l-8 2v2l8-2zM7 19.64c.855 0 1.5-.484 1.5-1s-.645-1-1.5-1-1.5.484-1.5 1 .645 1 1.5 1zm9-2c.855 0 1.5-.484 1.5-1s-.645-1-1.5-1-1.5.484-1.5 1 .645 1 1.5 1z",
        fill: "#049BCF",
        fillRule: "nonzero"
    }));
}
function $7fe1d951359cc6e1$var$iconVideo() {
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("svg", {
        "aria-hidden": "true",
        focusable: "false",
        className: "uppy-c-icon",
        width: "25",
        height: "25",
        viewBox: "0 0 25 25"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        d: "M16 11.834l4.486-2.691A1 1 0 0 1 22 10v6a1 1 0 0 1-1.514.857L16 14.167V17a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v2.834zM15 9H5v8h10V9zm1 4l5 3v-6l-5 3z",
        fill: "#19AF67",
        fillRule: "nonzero"
    }));
}
function $7fe1d951359cc6e1$var$iconPDF() {
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("svg", {
        "aria-hidden": "true",
        focusable: "false",
        className: "uppy-c-icon",
        width: "25",
        height: "25",
        viewBox: "0 0 25 25"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        d: "M9.766 8.295c-.691-1.843-.539-3.401.747-3.726 1.643-.414 2.505.938 2.39 3.299-.039.79-.194 1.662-.537 3.148.324.49.66.967 1.055 1.51.17.231.382.488.629.757 1.866-.128 3.653.114 4.918.655 1.487.635 2.192 1.685 1.614 2.84-.566 1.133-1.839 1.084-3.416.249-1.141-.604-2.457-1.634-3.51-2.707a13.467 13.467 0 0 0-2.238.426c-1.392 4.051-4.534 6.453-5.707 4.572-.986-1.58 1.38-4.206 4.914-5.375.097-.322.185-.656.264-1.001.08-.353.306-1.31.407-1.737-.678-1.059-1.2-2.031-1.53-2.91zm2.098 4.87c-.033.144-.068.287-.104.427l.033-.01-.012.038a14.065 14.065 0 0 1 1.02-.197l-.032-.033.052-.004a7.902 7.902 0 0 1-.208-.271c-.197-.27-.38-.526-.555-.775l-.006.028-.002-.003c-.076.323-.148.632-.186.8zm5.77 2.978c1.143.605 1.832.632 2.054.187.26-.519-.087-1.034-1.113-1.473-.911-.39-2.175-.608-3.55-.608.845.766 1.787 1.459 2.609 1.894zM6.559 18.789c.14.223.693.16 1.425-.413.827-.648 1.61-1.747 2.208-3.206-2.563 1.064-4.102 2.867-3.633 3.62zm5.345-10.97c.088-1.793-.351-2.48-1.146-2.28-.473.119-.564 1.05-.056 2.405.213.566.52 1.188.908 1.859.18-.858.268-1.453.294-1.984z",
        fill: "#E2514A",
        fillRule: "nonzero"
    }));
}
function $7fe1d951359cc6e1$var$iconArchive() {
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("svg", {
        "aria-hidden": "true",
        focusable: "false",
        width: "25",
        height: "25",
        viewBox: "0 0 25 25"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        d: "M10.45 2.05h1.05a.5.5 0 0 1 .5.5v.024a.5.5 0 0 1-.5.5h-1.05a.5.5 0 0 1-.5-.5V2.55a.5.5 0 0 1 .5-.5zm2.05 1.024h1.05a.5.5 0 0 1 .5.5V3.6a.5.5 0 0 1-.5.5H12.5a.5.5 0 0 1-.5-.5v-.025a.5.5 0 0 1 .5-.5v-.001zM10.45 0h1.05a.5.5 0 0 1 .5.5v.025a.5.5 0 0 1-.5.5h-1.05a.5.5 0 0 1-.5-.5V.5a.5.5 0 0 1 .5-.5zm2.05 1.025h1.05a.5.5 0 0 1 .5.5v.024a.5.5 0 0 1-.5.5H12.5a.5.5 0 0 1-.5-.5v-.024a.5.5 0 0 1 .5-.5zm-2.05 3.074h1.05a.5.5 0 0 1 .5.5v.025a.5.5 0 0 1-.5.5h-1.05a.5.5 0 0 1-.5-.5v-.025a.5.5 0 0 1 .5-.5zm2.05 1.025h1.05a.5.5 0 0 1 .5.5v.024a.5.5 0 0 1-.5.5H12.5a.5.5 0 0 1-.5-.5v-.024a.5.5 0 0 1 .5-.5zm-2.05 1.024h1.05a.5.5 0 0 1 .5.5v.025a.5.5 0 0 1-.5.5h-1.05a.5.5 0 0 1-.5-.5v-.025a.5.5 0 0 1 .5-.5zm2.05 1.025h1.05a.5.5 0 0 1 .5.5v.025a.5.5 0 0 1-.5.5H12.5a.5.5 0 0 1-.5-.5v-.025a.5.5 0 0 1 .5-.5zm-2.05 1.025h1.05a.5.5 0 0 1 .5.5v.025a.5.5 0 0 1-.5.5h-1.05a.5.5 0 0 1-.5-.5v-.025a.5.5 0 0 1 .5-.5zm2.05 1.025h1.05a.5.5 0 0 1 .5.5v.024a.5.5 0 0 1-.5.5H12.5a.5.5 0 0 1-.5-.5v-.024a.5.5 0 0 1 .5-.5zm-1.656 3.074l-.82 5.946c.52.302 1.174.458 1.976.458.803 0 1.455-.156 1.975-.458l-.82-5.946h-2.311zm0-1.025h2.312c.512 0 .946.378 1.015.885l.82 5.946c.056.412-.142.817-.501 1.026-.686.398-1.515.597-2.49.597-.974 0-1.804-.199-2.49-.597a1.025 1.025 0 0 1-.5-1.026l.819-5.946c.07-.507.503-.885 1.015-.885zm.545 6.6a.5.5 0 0 1-.397-.561l.143-.999a.5.5 0 0 1 .495-.429h.74a.5.5 0 0 1 .495.43l.143.998a.5.5 0 0 1-.397.561c-.404.08-.819.08-1.222 0z",
        fill: "#00C469",
        fillRule: "nonzero"
    }));
}
function $7fe1d951359cc6e1$var$iconFile() {
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("svg", {
        "aria-hidden": "true",
        focusable: "false",
        className: "uppy-c-icon",
        width: "25",
        height: "25",
        viewBox: "0 0 25 25"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("g", {
        fill: "#A7AFB7",
        fillRule: "nonzero"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        d: "M5.5 22a.5.5 0 0 1-.5-.5v-18a.5.5 0 0 1 .5-.5h10.719a.5.5 0 0 1 .367.16l3.281 3.556a.5.5 0 0 1 .133.339V21.5a.5.5 0 0 1-.5.5h-14zm.5-1h13V7.25L16 4H6v17z"
    }), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        d: "M15 4v3a1 1 0 0 0 1 1h3V7h-3V4h-1z"
    })));
}
function $7fe1d951359cc6e1$var$iconText() {
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("svg", {
        "aria-hidden": "true",
        focusable: "false",
        className: "uppy-c-icon",
        width: "25",
        height: "25",
        viewBox: "0 0 25 25"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        d: "M4.5 7h13a.5.5 0 1 1 0 1h-13a.5.5 0 0 1 0-1zm0 3h15a.5.5 0 1 1 0 1h-15a.5.5 0 1 1 0-1zm0 3h15a.5.5 0 1 1 0 1h-15a.5.5 0 1 1 0-1zm0 3h10a.5.5 0 1 1 0 1h-10a.5.5 0 1 1 0-1z",
        fill: "#5A5E69",
        fillRule: "nonzero"
    }));
}
function $7fe1d951359cc6e1$export$2e2bcd8739ae039(fileType) {
    const defaultChoice = {
        color: '#838999',
        icon: $7fe1d951359cc6e1$var$iconFile()
    };
    if (!fileType) return defaultChoice;
    const fileTypeGeneral = fileType.split('/')[0];
    const fileTypeSpecific = fileType.split('/')[1];
    // Text
    if (fileTypeGeneral === 'text') return {
        color: '#5a5e69',
        icon: $7fe1d951359cc6e1$var$iconText()
    };
    // Image
    if (fileTypeGeneral === 'image') return {
        color: '#686de0',
        icon: $7fe1d951359cc6e1$var$iconImage()
    };
    // Audio
    if (fileTypeGeneral === 'audio') return {
        color: '#068dbb',
        icon: $7fe1d951359cc6e1$var$iconAudio()
    };
    // Video
    if (fileTypeGeneral === 'video') return {
        color: '#19af67',
        icon: $7fe1d951359cc6e1$var$iconVideo()
    };
    // PDF
    if (fileTypeGeneral === 'application' && fileTypeSpecific === 'pdf') return {
        color: '#e25149',
        icon: $7fe1d951359cc6e1$var$iconPDF()
    };
    // Archive
    const archiveTypes = [
        'zip',
        'x-7z-compressed',
        'x-zip-compressed',
        'x-rar-compressed',
        'x-tar',
        'x-gzip',
        'x-apple-diskimage'
    ];
    if (fileTypeGeneral === 'application' && archiveTypes.indexOf(fileTypeSpecific) !== -1) return {
        color: '#00C469',
        icon: $7fe1d951359cc6e1$var$iconArchive()
    };
    return defaultChoice;
}


function $9e2af7705a2c15c5$export$2e2bcd8739ae039(props) {
    const { file: file } = props;
    if (file.preview) return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("img", {
        className: "uppy-Dashboard-Item-previewImg",
        alt: file.name,
        src: file.preview
    });
    const { color: color, icon: icon } = (0, $7fe1d951359cc6e1$export$2e2bcd8739ae039)(file.type);
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-Dashboard-Item-previewIconWrap"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("span", {
        className: "uppy-Dashboard-Item-previewIcon",
        style: {
            color: color
        }
    }, icon), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("svg", {
        "aria-hidden": "true",
        focusable: "false",
        className: "uppy-Dashboard-Item-previewIconBg",
        width: "58",
        height: "76",
        viewBox: "0 0 58 76"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("rect", {
        fill: "#FFF",
        width: "58",
        height: "76",
        rx: "3",
        fillRule: "evenodd"
    })));
}



const $e8c1f4ca43ed49b9$var$metaFieldIdToName = (metaFieldId, metaFields)=>{
    const fields = typeof metaFields === 'function' ? metaFields() : metaFields;
    const field = fields.filter((f)=>f.id === metaFieldId);
    return field[0].name;
};
function $e8c1f4ca43ed49b9$export$2e2bcd8739ae039(props) {
    const { file: file, toggleFileCard: toggleFileCard, i18n: i18n, metaFields: metaFields } = props;
    const { missingRequiredMetaFields: missingRequiredMetaFields } = file;
    if (!(missingRequiredMetaFields != null && missingRequiredMetaFields.length)) return null;
    const metaFieldsString = missingRequiredMetaFields.map((missingMetaField)=>$e8c1f4ca43ed49b9$var$metaFieldIdToName(missingMetaField, metaFields)).join(', ');
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-Dashboard-Item-errorMessage"
    }, i18n('missingRequiredMetaFields', {
        smart_count: missingRequiredMetaFields.length,
        fields: metaFieldsString
    }), ' ', (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("button", {
        type: "button",
        class: "uppy-u-reset uppy-Dashboard-Item-errorMessageBtn",
        onClick: ()=>toggleFileCard(true, file.id)
    }, i18n('editFile')));
}



function $bfd13c8521ef3809$export$2e2bcd8739ae039(props) {
    const { file: file, i18n: i18n, toggleFileCard: toggleFileCard, metaFields: metaFields, showLinkToFileUploadResult: showLinkToFileUploadResult } = props;
    const white = 'rgba(255, 255, 255, 0.5)';
    const previewBackgroundColor = file.preview ? white : (0, $7fe1d951359cc6e1$export$2e2bcd8739ae039)(file.type).color;
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-Dashboard-Item-previewInnerWrap",
        style: {
            backgroundColor: previewBackgroundColor
        }
    }, showLinkToFileUploadResult && file.uploadURL && (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("a", {
        className: "uppy-Dashboard-Item-previewLink",
        href: file.uploadURL,
        rel: "noreferrer noopener",
        target: "_blank",
        "aria-label": file.meta.name
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("span", {
        hidden: true
    }, file.meta.name)), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $9e2af7705a2c15c5$export$2e2bcd8739ae039), {
        file: file
    }), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $e8c1f4ca43ed49b9$export$2e2bcd8739ae039), {
        file: file,
        i18n: i18n,
        toggleFileCard: toggleFileCard,
        metaFields: metaFields
    }));
}


/* eslint-disable react/destructuring-assignment */ 
function $130a6df4f019eb5d$var$onPauseResumeCancelRetry(props) {
    if (props.isUploaded) return;
    if (props.error && !props.hideRetryButton) {
        props.uppy.retryUpload(props.file.id);
        return;
    }
    if (props.resumableUploads && !props.hidePauseResumeButton) props.uppy.pauseResume(props.file.id);
    else if (props.individualCancellation && !props.hideCancelButton) props.uppy.removeFile(props.file.id);
}
function $130a6df4f019eb5d$var$progressIndicatorTitle(props) {
    if (props.isUploaded) return props.i18n('uploadComplete');
    if (props.error) return props.i18n('retryUpload');
    if (props.resumableUploads) {
        if (props.file.isPaused) return props.i18n('resumeUpload');
        return props.i18n('pauseUpload');
    }
    if (props.individualCancellation) return props.i18n('cancelUpload');
    return '';
}
function $130a6df4f019eb5d$var$ProgressIndicatorButton(props) {
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-Dashboard-Item-progress"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("button", {
        className: "uppy-u-reset uppy-c-btn uppy-Dashboard-Item-progressIndicator",
        type: "button",
        "aria-label": $130a6df4f019eb5d$var$progressIndicatorTitle(props),
        title: $130a6df4f019eb5d$var$progressIndicatorTitle(props),
        onClick: ()=>$130a6df4f019eb5d$var$onPauseResumeCancelRetry(props)
    }, props.children));
}
function $130a6df4f019eb5d$var$ProgressCircleContainer(_ref) {
    let { children: children } = _ref;
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("svg", {
        "aria-hidden": "true",
        focusable: "false",
        width: "70",
        height: "70",
        viewBox: "0 0 36 36",
        className: "uppy-c-icon uppy-Dashboard-Item-progressIcon--circle"
    }, children);
}
function $130a6df4f019eb5d$var$ProgressCircle(_ref2) {
    let { progress: progress } = _ref2;
    // circle length equals 2 * PI * R
    const circleLength = 2 * Math.PI * 15;
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("g", null, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("circle", {
        className: "uppy-Dashboard-Item-progressIcon--bg",
        r: "15",
        cx: "18",
        cy: "18",
        "stroke-width": "2",
        fill: "none"
    }), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("circle", {
        className: "uppy-Dashboard-Item-progressIcon--progress",
        r: "15",
        cx: "18",
        cy: "18",
        transform: "rotate(-90, 18, 18)",
        fill: "none",
        "stroke-width": "2",
        "stroke-dasharray": circleLength,
        "stroke-dashoffset": circleLength - circleLength / 100 * progress
    }));
}
function $130a6df4f019eb5d$export$2e2bcd8739ae039(props) {
    // Nothing if upload has not started
    if (!props.file.progress.uploadStarted) return null;
    // Green checkmark when complete
    if (props.isUploaded) return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-Dashboard-Item-progress"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-Dashboard-Item-progressIndicator"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)($130a6df4f019eb5d$var$ProgressCircleContainer, null, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("circle", {
        r: "15",
        cx: "18",
        cy: "18",
        fill: "#1bb240"
    }), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("polygon", {
        className: "uppy-Dashboard-Item-progressIcon--check",
        transform: "translate(2, 3)",
        points: "14 22.5 7 15.2457065 8.99985857 13.1732815 14 18.3547104 22.9729883 9 25 11.1005634"
    }))));
    if (props.recoveredState) return undefined;
    // Retry button for error
    if (props.error && !props.hideRetryButton) return(// eslint-disable-next-line react/jsx-props-no-spreading
    (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)($130a6df4f019eb5d$var$ProgressIndicatorButton, props, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("svg", {
        "aria-hidden": "true",
        focusable: "false",
        className: "uppy-c-icon uppy-Dashboard-Item-progressIcon--retry",
        width: "28",
        height: "31",
        viewBox: "0 0 16 19"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        d: "M16 11a8 8 0 1 1-8-8v2a6 6 0 1 0 6 6h2z"
    }), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        d: "M7.9 3H10v2H7.9z"
    }), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        d: "M8.536.5l3.535 3.536-1.414 1.414L7.12 1.914z"
    }), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        d: "M10.657 2.621l1.414 1.415L8.536 7.57 7.12 6.157z"
    }))));
    // Pause/resume button for resumable uploads
    if (props.resumableUploads && !props.hidePauseResumeButton) return(// eslint-disable-next-line react/jsx-props-no-spreading
    (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)($130a6df4f019eb5d$var$ProgressIndicatorButton, props, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)($130a6df4f019eb5d$var$ProgressCircleContainer, null, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)($130a6df4f019eb5d$var$ProgressCircle, {
        progress: props.file.progress.percentage
    }), props.file.isPaused ? (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("polygon", {
        className: "uppy-Dashboard-Item-progressIcon--play",
        transform: "translate(3, 3)",
        points: "12 20 12 10 20 15"
    }) : (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("g", {
        className: "uppy-Dashboard-Item-progressIcon--pause",
        transform: "translate(14.5, 13)"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("rect", {
        x: "0",
        y: "0",
        width: "2",
        height: "10",
        rx: "0"
    }), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("rect", {
        x: "5",
        y: "0",
        width: "2",
        height: "10",
        rx: "0"
    })))));
    // Cancel button for non-resumable uploads if individualCancellation is supported (not bundled)
    if (!props.resumableUploads && props.individualCancellation && !props.hideCancelButton) return(// eslint-disable-next-line react/jsx-props-no-spreading
    (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)($130a6df4f019eb5d$var$ProgressIndicatorButton, props, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)($130a6df4f019eb5d$var$ProgressCircleContainer, null, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)($130a6df4f019eb5d$var$ProgressCircle, {
        progress: props.file.progress.percentage
    }), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("polygon", {
        className: "cancel",
        transform: "translate(2, 2)",
        points: "19.8856516 11.0625 16 14.9481516 12.1019737 11.0625 11.0625 12.1143484 14.9481516 16 11.0625 19.8980263 12.1019737 20.9375 16 17.0518484 19.8856516 20.9375 20.9375 19.8980263 17.0518484 16 20.9375 12"
    }))));
    // Just progress when buttons are disabled
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-Dashboard-Item-progress"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-Dashboard-Item-progressIndicator"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)($130a6df4f019eb5d$var$ProgressCircleContainer, null, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)($130a6df4f019eb5d$var$ProgressCircle, {
        progress: props.file.progress.percentage
    }))));
}


/* eslint-disable react/destructuring-assignment */ 

/**
 * Truncates a string to the given number of chars (maxLength) by inserting '...' in the middle of that string.
 * Partially taken from https://stackoverflow.com/a/5723274/3192470.
 */ const $1e7f833197af6f70$var$separator = '...';
function $1e7f833197af6f70$export$2e2bcd8739ae039(string, maxLength) {
    // Return the empty string if maxLength is zero
    if (maxLength === 0) return '';
    // Return original string if it's already shorter than maxLength
    if (string.length <= maxLength) return string;
    // Return truncated substring appended of the ellipsis char if string can't be meaningfully truncated
    if (maxLength <= $1e7f833197af6f70$var$separator.length + 1) return `${string.slice(0, maxLength - 1)}\u{2026}`;
    const charsToShow = maxLength - $1e7f833197af6f70$var$separator.length;
    const frontChars = Math.ceil(charsToShow / 2);
    const backChars = Math.floor(charsToShow / 2);
    return string.slice(0, frontChars) + $1e7f833197af6f70$var$separator + string.slice(-backChars);
}



const $35b148ba1db29747$var$renderFileName = (props)=>{
    const { author: author, name: name } = props.file.meta;
    function getMaxNameLength() {
        if (props.isSingleFile && props.containerHeight >= 350) return 90;
        if (props.containerWidth <= 352) return 35;
        if (props.containerWidth <= 576) return 60;
        // When `author` is present, we want to make sure
        // the file name fits on one line so we can place
        // the author on the second line.
        return author ? 20 : 30;
    }
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-Dashboard-Item-name",
        title: name
    }, (0, $1e7f833197af6f70$export$2e2bcd8739ae039)(name, getMaxNameLength()));
};
const $35b148ba1db29747$var$renderAuthor = (props)=>{
    var _props$file$remote;
    const { author: author } = props.file.meta;
    const providerName = (_props$file$remote = props.file.remote) == null ? void 0 : _props$file$remote.providerName;
    const dot = `\u00B7`;
    if (!author) return null;
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-Dashboard-Item-author"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("a", {
        href: `${author.url}?utm_source=Companion&utm_medium=referral`,
        target: "_blank",
        rel: "noopener noreferrer"
    }, (0, $1e7f833197af6f70$export$2e2bcd8739ae039)(author.name, 13)), providerName ? (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $4d2e93495e50cc85$export$ffb0004e005737fa), null, ` ${dot} `, providerName, ` ${dot} `) : null);
};
const $35b148ba1db29747$var$renderFileSize = (props)=>props.file.size && (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-Dashboard-Item-statusSize"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($06e80194017bcce5$exports)))(props.file.size));
const $35b148ba1db29747$var$ReSelectButton = (props)=>props.file.isGhost && (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("span", null, ' \u2022 ', (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("button", {
        className: "uppy-u-reset uppy-c-btn uppy-Dashboard-Item-reSelect",
        type: "button",
        onClick: props.toggleAddFilesPanel
    }, props.i18n('reSelect')));
const $35b148ba1db29747$var$ErrorButton = (_ref)=>{
    let { file: file, onClick: onClick } = _ref;
    if (file.error) return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("button", {
        className: "uppy-u-reset uppy-c-btn uppy-Dashboard-Item-errorDetails",
        "aria-label": file.error,
        "data-microtip-position": "bottom",
        "data-microtip-size": "medium",
        onClick: onClick,
        type: "button"
    }, "?");
    return null;
};
function $35b148ba1db29747$export$2e2bcd8739ae039(props) {
    const { file: file } = props;
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-Dashboard-Item-fileInfo",
        "data-uppy-file-source": file.source
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-Dashboard-Item-fileName"
    }, $35b148ba1db29747$var$renderFileName(props), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)($35b148ba1db29747$var$ErrorButton, {
        file: props.file,
        onClick: ()=>alert(props.file.error) // TODO: move to a custom alert implementation
    })), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-Dashboard-Item-status"
    }, $35b148ba1db29747$var$renderAuthor(props), $35b148ba1db29747$var$renderFileSize(props), $35b148ba1db29747$var$ReSelectButton(props)), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $e8c1f4ca43ed49b9$export$2e2bcd8739ae039), {
        file: props.file,
        i18n: props.i18n,
        toggleFileCard: props.toggleFileCard,
        metaFields: props.metaFields
    }));
}



/**
 * Copies text to clipboard by creating an almost invisible textarea,
 * adding text there, then running execCommand('copy').
 * Falls back to prompt() when the easy way fails (hello, Safari!)
 * From http://stackoverflow.com/a/30810322
 *
 * @param {string} textToCopy
 * @param {string} fallbackString
 * @returns {Promise}
 */ function $1402db5492a36d8b$export$2e2bcd8739ae039(textToCopy, fallbackString) {
    if (fallbackString === void 0) fallbackString = 'Copy the URL below';
    return new Promise((resolve)=>{
        const textArea = document.createElement('textarea');
        textArea.setAttribute('style', {
            position: 'fixed',
            top: 0,
            left: 0,
            width: '2em',
            height: '2em',
            padding: 0,
            border: 'none',
            outline: 'none',
            boxShadow: 'none',
            background: 'transparent'
        });
        textArea.value = textToCopy;
        document.body.appendChild(textArea);
        textArea.select();
        const magicCopyFailed = ()=>{
            document.body.removeChild(textArea);
            // eslint-disable-next-line no-alert
            window.prompt(fallbackString, textToCopy);
            resolve();
        };
        try {
            const successful = document.execCommand('copy');
            if (!successful) return magicCopyFailed();
            document.body.removeChild(textArea);
            return resolve();
        } catch (err) {
            document.body.removeChild(textArea);
            return magicCopyFailed();
        }
    });
}


function $d15239db21f41277$var$EditButton(_ref) {
    let { file: file, uploadInProgressOrComplete: uploadInProgressOrComplete, metaFields: metaFields, canEditFile: canEditFile, i18n: i18n, onClick: onClick } = _ref;
    if (!uploadInProgressOrComplete && metaFields && metaFields.length > 0 || !uploadInProgressOrComplete && canEditFile(file)) return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("button", {
        className: "uppy-u-reset uppy-c-btn uppy-Dashboard-Item-action uppy-Dashboard-Item-action--edit",
        type: "button",
        "aria-label": i18n('editFileWithFilename', {
            file: file.meta.name
        }),
        title: i18n('editFileWithFilename', {
            file: file.meta.name
        }),
        onClick: ()=>onClick()
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("svg", {
        "aria-hidden": "true",
        focusable: "false",
        className: "uppy-c-icon",
        width: "14",
        height: "14",
        viewBox: "0 0 14 14"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("g", {
        fillRule: "evenodd"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        d: "M1.5 10.793h2.793A1 1 0 0 0 5 10.5L11.5 4a1 1 0 0 0 0-1.414L9.707.793a1 1 0 0 0-1.414 0l-6.5 6.5A1 1 0 0 0 1.5 8v2.793zm1-1V8L9 1.5l1.793 1.793-6.5 6.5H2.5z",
        fillRule: "nonzero"
    }), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("rect", {
        x: "1",
        y: "12.293",
        width: "11",
        height: "1",
        rx: ".5"
    }), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        fillRule: "nonzero",
        d: "M6.793 2.5L9.5 5.207l.707-.707L7.5 1.793z"
    }))));
    return null;
}
function $d15239db21f41277$var$RemoveButton(_ref2) {
    let { i18n: i18n, onClick: onClick, file: file } = _ref2;
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("button", {
        className: "uppy-u-reset uppy-Dashboard-Item-action uppy-Dashboard-Item-action--remove",
        type: "button",
        "aria-label": i18n('removeFile', {
            file: file.meta.name
        }),
        title: i18n('removeFile', {
            file: file.meta.name
        }),
        onClick: ()=>onClick()
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("svg", {
        "aria-hidden": "true",
        focusable: "false",
        className: "uppy-c-icon",
        width: "18",
        height: "18",
        viewBox: "0 0 18 18"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        d: "M9 0C4.034 0 0 4.034 0 9s4.034 9 9 9 9-4.034 9-9-4.034-9-9-9z"
    }), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        fill: "#FFF",
        d: "M13 12.222l-.778.778L9 9.778 5.778 13 5 12.222 8.222 9 5 5.778 5.778 5 9 8.222 12.222 5l.778.778L9.778 9z"
    })));
}
const $d15239db21f41277$var$copyLinkToClipboard = (event, props)=>{
    (0, $1402db5492a36d8b$export$2e2bcd8739ae039)(props.file.uploadURL, props.i18n('copyLinkToClipboardFallback')).then(()=>{
        props.uppy.log('Link copied to clipboard.');
        props.uppy.info(props.i18n('copyLinkToClipboardSuccess'), 'info', 3000);
    }).catch(props.uppy.log)// avoid losing focus
    .then(()=>event.target.focus({
            preventScroll: true
        }));
};
function $d15239db21f41277$var$CopyLinkButton(props) {
    const { i18n: i18n } = props;
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("button", {
        className: "uppy-u-reset uppy-Dashboard-Item-action uppy-Dashboard-Item-action--copyLink",
        type: "button",
        "aria-label": i18n('copyLink'),
        title: i18n('copyLink'),
        onClick: (event)=>$d15239db21f41277$var$copyLinkToClipboard(event, props)
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("svg", {
        "aria-hidden": "true",
        focusable: "false",
        className: "uppy-c-icon",
        width: "14",
        height: "14",
        viewBox: "0 0 14 12"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        d: "M7.94 7.703a2.613 2.613 0 0 1-.626 2.681l-.852.851a2.597 2.597 0 0 1-1.849.766A2.616 2.616 0 0 1 2.764 7.54l.852-.852a2.596 2.596 0 0 1 2.69-.625L5.267 7.099a1.44 1.44 0 0 0-.833.407l-.852.851a1.458 1.458 0 0 0 1.03 2.486c.39 0 .755-.152 1.03-.426l.852-.852c.231-.231.363-.522.406-.824l1.04-1.038zm4.295-5.937A2.596 2.596 0 0 0 10.387 1c-.698 0-1.355.272-1.849.766l-.852.851a2.614 2.614 0 0 0-.624 2.688l1.036-1.036c.041-.304.173-.6.407-.833l.852-.852c.275-.275.64-.426 1.03-.426a1.458 1.458 0 0 1 1.03 2.486l-.852.851a1.442 1.442 0 0 1-.824.406l-1.04 1.04a2.596 2.596 0 0 0 2.683-.628l.851-.85a2.616 2.616 0 0 0 0-3.697zm-6.88 6.883a.577.577 0 0 0 .82 0l3.474-3.474a.579.579 0 1 0-.819-.82L5.355 7.83a.579.579 0 0 0 0 .819z"
    })));
}
function $d15239db21f41277$export$2e2bcd8739ae039(props) {
    const { uppy: uppy, file: file, uploadInProgressOrComplete: uploadInProgressOrComplete, canEditFile: canEditFile, metaFields: metaFields, showLinkToFileUploadResult: showLinkToFileUploadResult, showRemoveButton: showRemoveButton, i18n: i18n, toggleFileCard: toggleFileCard, openFileEditor: openFileEditor } = props;
    const editAction = ()=>{
        if (metaFields && metaFields.length > 0) toggleFileCard(true, file.id);
        else openFileEditor(file);
    };
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-Dashboard-Item-actionWrapper"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)($d15239db21f41277$var$EditButton, {
        i18n: i18n,
        file: file,
        uploadInProgressOrComplete: uploadInProgressOrComplete,
        canEditFile: canEditFile,
        metaFields: metaFields,
        onClick: editAction
    }), showLinkToFileUploadResult && file.uploadURL ? (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)($d15239db21f41277$var$CopyLinkButton, {
        file: file,
        uppy: uppy,
        i18n: i18n
    }) : null, showRemoveButton ? (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)($d15239db21f41277$var$RemoveButton, {
        i18n: i18n,
        file: file,
        uppy: uppy,
        onClick: ()=>uppy.removeFile(file.id, 'removed-by-user')
    }) : null);
}


class $ed540296fca56761$export$2e2bcd8739ae039 extends (0, $4d2e93495e50cc85$export$16fa2f45be04daa8) {
    componentDidMount() {
        const { file: file } = this.props;
        if (!file.preview) this.props.handleRequestThumbnail(file);
    }
    shouldComponentUpdate(nextProps) {
        return !(0, (/*@__PURE__*/$parcel$interopDefault($1181142648d48c51$exports)))(this.props, nextProps);
    }
    // VirtualList mounts FileItems again and they emit `thumbnail:request`
    // Otherwise thumbnails are broken or missing after Golden Retriever restores files
    componentDidUpdate() {
        const { file: file } = this.props;
        if (!file.preview) this.props.handleRequestThumbnail(file);
    }
    componentWillUnmount() {
        const { file: file } = this.props;
        if (!file.preview) this.props.handleCancelThumbnail(file);
    }
    render() {
        const { file: file } = this.props;
        const isProcessing = file.progress.preprocess || file.progress.postprocess;
        const isUploaded = file.progress.uploadComplete && !isProcessing && !file.error;
        const uploadInProgressOrComplete = file.progress.uploadStarted || isProcessing;
        const uploadInProgress = file.progress.uploadStarted && !file.progress.uploadComplete || isProcessing;
        const error = file.error || false;
        // File that Golden Retriever was able to partly restore (only meta, not blob),
        // users still need to re-add it, so it’s a ghost
        const { isGhost: isGhost } = file;
        let showRemoveButton = this.props.individualCancellation ? !isUploaded : !uploadInProgress && !isUploaded;
        if (isUploaded && this.props.showRemoveButtonAfterComplete) showRemoveButton = true;
        const dashboardItemClass = (0, (/*@__PURE__*/$parcel$interopDefault($02c2aab7657be691$exports)))({
            'uppy-Dashboard-Item': true,
            'is-inprogress': uploadInProgress && !this.props.recoveredState,
            'is-processing': isProcessing,
            'is-complete': isUploaded,
            'is-error': !!error,
            'is-resumable': this.props.resumableUploads,
            'is-noIndividualCancellation': !this.props.individualCancellation,
            'is-ghost': isGhost
        });
        return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
            className: dashboardItemClass,
            id: `uppy_${file.id}`,
            role: this.props.role
        }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
            className: "uppy-Dashboard-Item-preview"
        }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $bfd13c8521ef3809$export$2e2bcd8739ae039), {
            file: file,
            showLinkToFileUploadResult: this.props.showLinkToFileUploadResult,
            i18n: this.props.i18n,
            toggleFileCard: this.props.toggleFileCard,
            metaFields: this.props.metaFields
        }), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $130a6df4f019eb5d$export$2e2bcd8739ae039), {
            uppy: this.props.uppy,
            file: file,
            error: error,
            isUploaded: isUploaded,
            hideRetryButton: this.props.hideRetryButton,
            hideCancelButton: this.props.hideCancelButton,
            hidePauseResumeButton: this.props.hidePauseResumeButton,
            recoveredState: this.props.recoveredState,
            showRemoveButtonAfterComplete: this.props.showRemoveButtonAfterComplete,
            resumableUploads: this.props.resumableUploads,
            individualCancellation: this.props.individualCancellation,
            i18n: this.props.i18n
        })), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
            className: "uppy-Dashboard-Item-fileInfoAndButtons"
        }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $35b148ba1db29747$export$2e2bcd8739ae039), {
            file: file,
            id: this.props.id,
            acquirers: this.props.acquirers,
            containerWidth: this.props.containerWidth,
            containerHeight: this.props.containerHeight,
            i18n: this.props.i18n,
            toggleAddFilesPanel: this.props.toggleAddFilesPanel,
            toggleFileCard: this.props.toggleFileCard,
            metaFields: this.props.metaFields,
            isSingleFile: this.props.isSingleFile
        }), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $d15239db21f41277$export$2e2bcd8739ae039), {
            file: file,
            metaFields: this.props.metaFields,
            showLinkToFileUploadResult: this.props.showLinkToFileUploadResult,
            showRemoveButton: showRemoveButton,
            canEditFile: this.props.canEditFile,
            uploadInProgressOrComplete: uploadInProgressOrComplete,
            toggleFileCard: this.props.toggleFileCard,
            openFileEditor: this.props.openFileEditor,
            uppy: this.props.uppy,
            i18n: this.props.i18n
        })));
    }
}


function $7a578b6cd2206257$var$chunks(list, size) {
    const chunked = [];
    let currentChunk = [];
    list.forEach((item)=>{
        if (currentChunk.length < size) currentChunk.push(item);
        else {
            chunked.push(currentChunk);
            currentChunk = [
                item
            ];
        }
    });
    if (currentChunk.length) chunked.push(currentChunk);
    return chunked;
}
function $7a578b6cd2206257$export$2e2bcd8739ae039(_ref) {
    let { id: id, error: error, i18n: i18n, uppy: uppy, files: files, acquirers: acquirers, resumableUploads: resumableUploads, hideRetryButton: hideRetryButton, hidePauseResumeButton: hidePauseResumeButton, hideCancelButton: hideCancelButton, showLinkToFileUploadResult: showLinkToFileUploadResult, showRemoveButtonAfterComplete: showRemoveButtonAfterComplete, isWide: isWide, metaFields: metaFields, isSingleFile: isSingleFile, toggleFileCard: toggleFileCard, handleRequestThumbnail: handleRequestThumbnail, handleCancelThumbnail: handleCancelThumbnail, recoveredState: recoveredState, individualCancellation: individualCancellation, itemsPerRow: itemsPerRow, openFileEditor: openFileEditor, canEditFile: canEditFile, toggleAddFilesPanel: toggleAddFilesPanel, containerWidth: containerWidth, containerHeight: containerHeight } = _ref;
    // It's not great that this is hardcoded!
    // It's ESPECIALLY not great that this is checking against `itemsPerRow`!
    const rowHeight = itemsPerRow === 1 ? // Mobile
    71 : 200;
    // Sort files by file.isGhost, ghost files first, only if recoveredState is present
    const rows = (0, $e28f05d17e052ff9$export$1538c33de8887b59)(()=>{
        const sortByGhostComesFirst = (file1, file2)=>files[file2].isGhost - files[file1].isGhost;
        const fileIds = Object.keys(files);
        if (recoveredState) fileIds.sort(sortByGhostComesFirst);
        return $7a578b6cd2206257$var$chunks(fileIds, itemsPerRow);
    }, [
        files,
        itemsPerRow,
        recoveredState
    ]);
    const renderRow = (row // The `role="presentation` attribute ensures that the list items are properly
    )=>// associated with the `VirtualList` element.
        // We use the first file ID as the key—this should not change across scroll rerenders
        (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
            class: "uppy-Dashboard-filesInner",
            role: "presentation",
            key: row[0]
        }, row.map((fileID)=>(0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $ed540296fca56761$export$2e2bcd8739ae039), {
                key: fileID,
                uppy: uppy,
                id: id,
                error: error,
                i18n: i18n,
                acquirers: acquirers,
                resumableUploads: resumableUploads,
                individualCancellation: individualCancellation,
                hideRetryButton: hideRetryButton,
                hidePauseResumeButton: hidePauseResumeButton,
                hideCancelButton: hideCancelButton,
                showLinkToFileUploadResult: showLinkToFileUploadResult,
                showRemoveButtonAfterComplete: showRemoveButtonAfterComplete,
                isWide: isWide,
                metaFields: metaFields,
                recoveredState: recoveredState,
                isSingleFile: isSingleFile,
                containerWidth: containerWidth,
                containerHeight: containerHeight,
                toggleFileCard: toggleFileCard,
                handleRequestThumbnail: handleRequestThumbnail,
                handleCancelThumbnail: handleCancelThumbnail,
                role: "listitem",
                openFileEditor: openFileEditor,
                canEditFile: canEditFile,
                toggleAddFilesPanel: toggleAddFilesPanel,
                file: files[fileID]
            })));
    if (isSingleFile) return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        class: "uppy-Dashboard-files"
    }, renderRow(rows[0]));
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $aba06cd85441b3f8$export$2e2bcd8739ae039), {
        class: "uppy-Dashboard-files",
        role: "list",
        data: rows,
        renderRow: renderRow,
        rowHeight: rowHeight
    });
}



let $3f3c0a16d9cbe8a2$var$_Symbol$for;
$3f3c0a16d9cbe8a2$var$_Symbol$for = Symbol.for('uppy test: disable unused locale key warning');
class $3f3c0a16d9cbe8a2$var$AddFiles extends (0, $4d2e93495e50cc85$export$16fa2f45be04daa8) {
    constructor(){
        super(...arguments);
        this.triggerFileInputClick = ()=>{
            this.fileInput.click();
        };
        this.triggerFolderInputClick = ()=>{
            this.folderInput.click();
        };
        this.triggerVideoCameraInputClick = ()=>{
            this.mobileVideoFileInput.click();
        };
        this.triggerPhotoCameraInputClick = ()=>{
            this.mobilePhotoFileInput.click();
        };
        this.onFileInputChange = (event)=>{
            this.props.handleInputChange(event);
            // We clear the input after a file is selected, because otherwise
            // change event is not fired in Chrome and Safari when a file
            // with the same name is selected.
            // ___Why not use value="" on <input/> instead?
            //    Because if we use that method of clearing the input,
            //    Chrome will not trigger change if we drop the same file twice (Issue #768).
            event.target.value = null; // eslint-disable-line no-param-reassign
        };
        this.renderHiddenInput = (isFolder, refCallback)=>{
            return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("input", {
                className: "uppy-Dashboard-input",
                hidden: true,
                "aria-hidden": "true",
                tabIndex: -1,
                webkitdirectory: isFolder,
                type: "file",
                name: "files[]",
                multiple: this.props.maxNumberOfFiles !== 1,
                onChange: this.onFileInputChange,
                accept: this.props.allowedFileTypes,
                ref: refCallback
            });
        };
        this.renderHiddenCameraInput = (type, nativeCameraFacingMode, refCallback)=>{
            const typeToAccept = {
                photo: 'image/*',
                video: 'video/*'
            };
            const accept = typeToAccept[type];
            return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("input", {
                className: "uppy-Dashboard-input",
                hidden: true,
                "aria-hidden": "true",
                tabIndex: -1,
                type: "file",
                name: `camera-${type}`,
                onChange: this.onFileInputChange,
                capture: nativeCameraFacingMode,
                accept: accept,
                ref: refCallback
            });
        };
        this.renderMyDeviceAcquirer = ()=>{
            return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
                className: "uppy-DashboardTab",
                role: "presentation",
                "data-uppy-acquirer-id": "MyDevice"
            }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("button", {
                type: "button",
                className: "uppy-u-reset uppy-c-btn uppy-DashboardTab-btn",
                role: "tab",
                tabIndex: 0,
                "data-uppy-super-focusable": true,
                onClick: this.triggerFileInputClick
            }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
                className: "uppy-DashboardTab-inner"
            }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("svg", {
                className: "uppy-DashboardTab-iconMyDevice",
                "aria-hidden": "true",
                focusable: "false",
                width: "32",
                height: "32",
                viewBox: "0 0 32 32"
            }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
                d: "M8.45 22.087l-1.305-6.674h17.678l-1.572 6.674H8.45zm4.975-12.412l1.083 1.765a.823.823 0 00.715.386h7.951V13.5H8.587V9.675h4.838zM26.043 13.5h-1.195v-2.598c0-.463-.336-.75-.798-.75h-8.356l-1.082-1.766A.823.823 0 0013.897 8H7.728c-.462 0-.815.256-.815.718V13.5h-.956a.97.97 0 00-.746.37.972.972 0 00-.19.81l1.724 8.565c.095.44.484.755.933.755H24c.44 0 .824-.3.929-.727l2.043-8.568a.972.972 0 00-.176-.825.967.967 0 00-.753-.38z",
                fill: "currentcolor",
                "fill-rule": "evenodd"
            }))), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
                className: "uppy-DashboardTab-name"
            }, this.props.i18n('myDevice'))));
        };
        this.renderPhotoCamera = ()=>{
            return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
                className: "uppy-DashboardTab",
                role: "presentation",
                "data-uppy-acquirer-id": "MobilePhotoCamera"
            }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("button", {
                type: "button",
                className: "uppy-u-reset uppy-c-btn uppy-DashboardTab-btn",
                role: "tab",
                tabIndex: 0,
                "data-uppy-super-focusable": true,
                onClick: this.triggerPhotoCameraInputClick
            }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
                className: "uppy-DashboardTab-inner"
            }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("svg", {
                "aria-hidden": "true",
                focusable: "false",
                width: "32",
                height: "32",
                viewBox: "0 0 32 32"
            }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
                d: "M23.5 9.5c1.417 0 2.5 1.083 2.5 2.5v9.167c0 1.416-1.083 2.5-2.5 2.5h-15c-1.417 0-2.5-1.084-2.5-2.5V12c0-1.417 1.083-2.5 2.5-2.5h2.917l1.416-2.167C13 7.167 13.25 7 13.5 7h5c.25 0 .5.167.667.333L20.583 9.5H23.5zM16 11.417a4.706 4.706 0 00-4.75 4.75 4.704 4.704 0 004.75 4.75 4.703 4.703 0 004.75-4.75c0-2.663-2.09-4.75-4.75-4.75zm0 7.825c-1.744 0-3.076-1.332-3.076-3.074 0-1.745 1.333-3.077 3.076-3.077 1.744 0 3.074 1.333 3.074 3.076s-1.33 3.075-3.074 3.075z",
                fill: "#02B383",
                "fill-rule": "nonzero"
            }))), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
                className: "uppy-DashboardTab-name"
            }, this.props.i18n('takePictureBtn'))));
        };
        this.renderVideoCamera = ()=>{
            return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
                className: "uppy-DashboardTab",
                role: "presentation",
                "data-uppy-acquirer-id": "MobileVideoCamera"
            }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("button", {
                type: "button",
                className: "uppy-u-reset uppy-c-btn uppy-DashboardTab-btn",
                role: "tab",
                tabIndex: 0,
                "data-uppy-super-focusable": true,
                onClick: this.triggerVideoCameraInputClick
            }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
                className: "uppy-DashboardTab-inner"
            }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("svg", {
                "aria-hidden": "true",
                width: "32",
                height: "32",
                viewBox: "0 0 32 32"
            }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
                fill: "#FF675E",
                fillRule: "nonzero",
                d: "m21.254 14.277 2.941-2.588c.797-.313 1.243.818 1.09 1.554-.01 2.094.02 4.189-.017 6.282-.126.915-1.145 1.08-1.58.34l-2.434-2.142c-.192.287-.504 1.305-.738.468-.104-1.293-.028-2.596-.05-3.894.047-.312.381.823.426 1.069.063-.384.206-.744.362-1.09zm-12.939-3.73c3.858.013 7.717-.025 11.574.02.912.129 1.492 1.237 1.351 2.217-.019 2.412.04 4.83-.03 7.239-.17 1.025-1.166 1.59-2.029 1.429-3.705-.012-7.41.025-11.114-.019-.913-.129-1.492-1.237-1.352-2.217.018-2.404-.036-4.813.029-7.214.136-.82.83-1.473 1.571-1.454z "
            }))), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
                className: "uppy-DashboardTab-name"
            }, this.props.i18n('recordVideoBtn'))));
        };
        this.renderBrowseButton = (text, onClickFn)=>{
            const numberOfAcquirers = this.props.acquirers.length;
            return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("button", {
                type: "button",
                className: "uppy-u-reset uppy-c-btn uppy-Dashboard-browse",
                onClick: onClickFn,
                "data-uppy-super-focusable": numberOfAcquirers === 0
            }, text);
        };
        this.renderDropPasteBrowseTagline = (numberOfAcquirers)=>{
            const browseFiles = this.renderBrowseButton(this.props.i18n('browseFiles'), this.triggerFileInputClick);
            const browseFolders = this.renderBrowseButton(this.props.i18n('browseFolders'), this.triggerFolderInputClick);
            // in order to keep the i18n CamelCase and options lower (as are defaults) we will want to transform a lower
            // to Camel
            const lowerFMSelectionType = this.props.fileManagerSelectionType;
            const camelFMSelectionType = lowerFMSelectionType.charAt(0).toUpperCase() + lowerFMSelectionType.slice(1);
            return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
                class: "uppy-Dashboard-AddFiles-title"
            }, // eslint-disable-next-line no-nested-ternary
            this.props.disableLocalFiles ? this.props.i18n('importFiles') : numberOfAcquirers > 0 ? this.props.i18nArray(`dropPasteImport${camelFMSelectionType}`, {
                browseFiles: browseFiles,
                browseFolders: browseFolders,
                browse: browseFiles
            }) : this.props.i18nArray(`dropPaste${camelFMSelectionType}`, {
                browseFiles: browseFiles,
                browseFolders: browseFolders,
                browse: browseFiles
            }));
        };
        this.renderAcquirer = (acquirer)=>{
            var _this$props$activePic;
            return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
                className: "uppy-DashboardTab",
                role: "presentation",
                "data-uppy-acquirer-id": acquirer.id
            }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("button", {
                type: "button",
                className: "uppy-u-reset uppy-c-btn uppy-DashboardTab-btn",
                role: "tab",
                tabIndex: 0,
                "data-cy": acquirer.id,
                "aria-controls": `uppy-DashboardContent-panel--${acquirer.id}`,
                "aria-selected": ((_this$props$activePic = this.props.activePickerPanel) == null ? void 0 : _this$props$activePic.id) === acquirer.id,
                "data-uppy-super-focusable": true,
                onClick: ()=>this.props.showPanel(acquirer.id)
            }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
                className: "uppy-DashboardTab-inner"
            }, acquirer.icon()), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
                className: "uppy-DashboardTab-name"
            }, acquirer.name)));
        };
        this.renderAcquirers = (acquirers)=>{
            // Group last two buttons, so we don’t end up with
            // just one button on a new line
            const acquirersWithoutLastTwo = [
                ...acquirers
            ];
            const lastTwoAcquirers = acquirersWithoutLastTwo.splice(acquirers.length - 2, acquirers.length);
            return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $4d2e93495e50cc85$export$ffb0004e005737fa), null, acquirersWithoutLastTwo.map((acquirer)=>this.renderAcquirer(acquirer)), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("span", {
                role: "presentation",
                style: {
                    'white-space': 'nowrap'
                }
            }, lastTwoAcquirers.map((acquirer)=>this.renderAcquirer(acquirer))));
        };
        this.renderSourcesList = (acquirers, disableLocalFiles)=>{
            const { showNativePhotoCameraButton: showNativePhotoCameraButton, showNativeVideoCameraButton: showNativeVideoCameraButton } = this.props;
            let list = [];
            const myDeviceKey = 'myDevice';
            if (!disableLocalFiles) list.push({
                key: myDeviceKey,
                elements: this.renderMyDeviceAcquirer()
            });
            if (showNativePhotoCameraButton) list.push({
                key: 'nativePhotoCameraButton',
                elements: this.renderPhotoCamera()
            });
            if (showNativeVideoCameraButton) list.push({
                key: 'nativePhotoCameraButton',
                elements: this.renderVideoCamera()
            });
            list.push(...acquirers.map((acquirer)=>({
                    key: acquirer.id,
                    elements: this.renderAcquirer(acquirer)
                })));
            // doesn't make sense to show only a lonely "My Device"
            const hasOnlyMyDevice = list.length === 1 && list[0].key === myDeviceKey;
            if (hasOnlyMyDevice) list = [];
            // Group last two buttons, so we don’t end up with
            // just one button on a new line
            const listWithoutLastTwo = [
                ...list
            ];
            const lastTwo = listWithoutLastTwo.splice(list.length - 2, list.length);
            const renderList = (l)=>l.map((_ref)=>{
                    let { key: key, elements: elements } = _ref;
                    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $4d2e93495e50cc85$export$ffb0004e005737fa), {
                        key: key
                    }, elements);
                });
            return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $4d2e93495e50cc85$export$ffb0004e005737fa), null, this.renderDropPasteBrowseTagline(list.length), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
                className: "uppy-Dashboard-AddFiles-list",
                role: "tablist"
            }, renderList(listWithoutLastTwo), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("span", {
                role: "presentation",
                style: {
                    'white-space': 'nowrap'
                }
            }, renderList(lastTwo))));
        };
    }
    [$3f3c0a16d9cbe8a2$var$_Symbol$for]() {
        // Those are actually used in `renderDropPasteBrowseTagline` method.
        this.props.i18nArray('dropPasteBoth');
        this.props.i18nArray('dropPasteFiles');
        this.props.i18nArray('dropPasteFolders');
        this.props.i18nArray('dropPasteImportBoth');
        this.props.i18nArray('dropPasteImportFiles');
        this.props.i18nArray('dropPasteImportFolders');
    }
    renderPoweredByUppy() {
        const { i18nArray: i18nArray } = this.props;
        const uppyBranding = (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("span", null, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("svg", {
            "aria-hidden": "true",
            focusable: "false",
            className: "uppy-c-icon uppy-Dashboard-poweredByIcon",
            width: "11",
            height: "11",
            viewBox: "0 0 11 11"
        }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
            d: "M7.365 10.5l-.01-4.045h2.612L5.5.806l-4.467 5.65h2.604l.01 4.044h3.718z",
            fillRule: "evenodd"
        })), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("span", {
            className: "uppy-Dashboard-poweredByUppy"
        }, "Uppy"));
        const linkText = i18nArray('poweredBy', {
            uppy: uppyBranding
        });
        return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("a", {
            tabIndex: -1,
            href: "https://uppy.io",
            rel: "noreferrer noopener",
            target: "_blank",
            className: "uppy-Dashboard-poweredBy"
        }, linkText);
    }
    render() {
        const { showNativePhotoCameraButton: showNativePhotoCameraButton, showNativeVideoCameraButton: showNativeVideoCameraButton, nativeCameraFacingMode: nativeCameraFacingMode } = this.props;
        return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
            className: "uppy-Dashboard-AddFiles"
        }, this.renderHiddenInput(false, (ref)=>{
            this.fileInput = ref;
        }), this.renderHiddenInput(true, (ref)=>{
            this.folderInput = ref;
        }), showNativePhotoCameraButton && this.renderHiddenCameraInput('photo', nativeCameraFacingMode, (ref)=>{
            this.mobilePhotoFileInput = ref;
        }), showNativeVideoCameraButton && this.renderHiddenCameraInput('video', nativeCameraFacingMode, (ref)=>{
            this.mobileVideoFileInput = ref;
        }), this.renderSourcesList(this.props.acquirers, this.props.disableLocalFiles), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
            className: "uppy-Dashboard-AddFiles-info"
        }, this.props.note && (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
            className: "uppy-Dashboard-note"
        }, this.props.note), this.props.proudlyDisplayPoweredByUppy && this.renderPoweredByUppy(this.props)));
    }
}
var $3f3c0a16d9cbe8a2$export$2e2bcd8739ae039 = $3f3c0a16d9cbe8a2$var$AddFiles;


/* eslint-disable react/destructuring-assignment */ 


const $175934b4bbc4fb46$var$AddFilesPanel = (props)=>{
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($02c2aab7657be691$exports)))('uppy-Dashboard-AddFilesPanel', props.className),
        "data-uppy-panelType": "AddFiles",
        "aria-hidden": !props.showAddFilesPanel
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-DashboardContent-bar"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-DashboardContent-title",
        role: "heading",
        "aria-level": "1"
    }, props.i18n('addingMoreFiles')), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("button", {
        className: "uppy-DashboardContent-back",
        type: "button",
        onClick: ()=>props.toggleAddFilesPanel(false)
    }, props.i18n('back'))), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $3f3c0a16d9cbe8a2$export$2e2bcd8739ae039), props));
};
var $175934b4bbc4fb46$export$2e2bcd8739ae039 = $175934b4bbc4fb46$var$AddFilesPanel;




// ignore drop/paste events if they are not in input or textarea —
// otherwise when Url plugin adds drop/paste listeners to this.el,
// draging UI elements or pasting anything into any field triggers those events —
// Url treats them as URLs that need to be imported
function $cb1052d4a6aa569a$var$ignoreEvent(ev) {
    const { tagName: tagName } = ev.target;
    if (tagName === 'INPUT' || tagName === 'TEXTAREA') {
        ev.stopPropagation();
        return;
    }
    ev.preventDefault();
    ev.stopPropagation();
}
var $cb1052d4a6aa569a$export$2e2bcd8739ae039 = $cb1052d4a6aa569a$var$ignoreEvent;


function $e3578ca53f5728a8$var$PickerPanelContent(_ref) {
    let { activePickerPanel: activePickerPanel, className: className, hideAllPanels: hideAllPanels, i18n: i18n, state: state, uppy: uppy } = _ref;
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($02c2aab7657be691$exports)))('uppy-DashboardContent-panel', className),
        role: "tabpanel",
        "data-uppy-panelType": "PickerPanel",
        id: `uppy-DashboardContent-panel--${activePickerPanel.id}`,
        onDragOver: (0, $cb1052d4a6aa569a$export$2e2bcd8739ae039),
        onDragLeave: (0, $cb1052d4a6aa569a$export$2e2bcd8739ae039),
        onDrop: (0, $cb1052d4a6aa569a$export$2e2bcd8739ae039),
        onPaste: (0, $cb1052d4a6aa569a$export$2e2bcd8739ae039)
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-DashboardContent-bar"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-DashboardContent-title",
        role: "heading",
        "aria-level": "1"
    }, i18n('importFrom', {
        name: activePickerPanel.name
    })), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("button", {
        className: "uppy-DashboardContent-back",
        type: "button",
        onClick: hideAllPanels
    }, i18n('cancel'))), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-DashboardContent-panelBody"
    }, uppy.getPlugin(activePickerPanel.id).render(state)));
}
var $e3578ca53f5728a8$export$2e2bcd8739ae039 = $e3578ca53f5728a8$var$PickerPanelContent;


/* eslint-disable react/destructuring-assignment */ 

function $d8360bbc75e6a373$var$EditorPanel(props) {
    const file = props.files[props.fileCardFor];
    const handleCancel = ()=>{
        props.uppy.emit('file-editor:cancel', file);
        props.closeFileEditor();
    };
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($02c2aab7657be691$exports)))('uppy-DashboardContent-panel', props.className),
        role: "tabpanel",
        "data-uppy-panelType": "FileEditor",
        id: "uppy-DashboardContent-panel--editor"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-DashboardContent-bar"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-DashboardContent-title",
        role: "heading",
        "aria-level": "1"
    }, props.i18nArray('editing', {
        file: (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("span", {
            className: "uppy-DashboardContent-titleFile"
        }, file.meta ? file.meta.name : file.name)
    })), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("button", {
        className: "uppy-DashboardContent-back",
        type: "button",
        onClick: handleCancel
    }, props.i18n('cancel')), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("button", {
        className: "uppy-DashboardContent-save",
        type: "button",
        onClick: props.saveFileEditor
    }, props.i18n('save'))), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-DashboardContent-panelBody"
    }, props.editors.map((target)=>{
        return props.uppy.getPlugin(target.id).render(props.state);
    })));
}
var $d8360bbc75e6a373$export$2e2bcd8739ae039 = $d8360bbc75e6a373$var$EditorPanel;



const $915070fc553cba86$var$uploadStates = {
    STATE_ERROR: 'error',
    STATE_WAITING: 'waiting',
    STATE_PREPROCESSING: 'preprocessing',
    STATE_UPLOADING: 'uploading',
    STATE_POSTPROCESSING: 'postprocessing',
    STATE_COMPLETE: 'complete',
    STATE_PAUSED: 'paused'
};
function $915070fc553cba86$var$getUploadingState(isAllErrored, isAllComplete, isAllPaused, files) {
    if (files === void 0) files = {};
    if (isAllErrored) return $915070fc553cba86$var$uploadStates.STATE_ERROR;
    if (isAllComplete) return $915070fc553cba86$var$uploadStates.STATE_COMPLETE;
    if (isAllPaused) return $915070fc553cba86$var$uploadStates.STATE_PAUSED;
    let state = $915070fc553cba86$var$uploadStates.STATE_WAITING;
    const fileIDs = Object.keys(files);
    for(let i = 0; i < fileIDs.length; i++){
        const { progress: progress } = files[fileIDs[i]];
        // If ANY files are being uploaded right now, show the uploading state.
        if (progress.uploadStarted && !progress.uploadComplete) return $915070fc553cba86$var$uploadStates.STATE_UPLOADING;
        // If files are being preprocessed AND postprocessed at this time, we show the
        // preprocess state. If any files are being uploaded we show uploading.
        if (progress.preprocess && state !== $915070fc553cba86$var$uploadStates.STATE_UPLOADING) state = $915070fc553cba86$var$uploadStates.STATE_PREPROCESSING;
        // If NO files are being preprocessed or uploaded right now, but some files are
        // being postprocessed, show the postprocess state.
        if (progress.postprocess && state !== $915070fc553cba86$var$uploadStates.STATE_UPLOADING && state !== $915070fc553cba86$var$uploadStates.STATE_PREPROCESSING) state = $915070fc553cba86$var$uploadStates.STATE_POSTPROCESSING;
    }
    return state;
}
function $915070fc553cba86$var$UploadStatus(_ref) {
    let { files: files, i18n: i18n, isAllComplete: isAllComplete, isAllErrored: isAllErrored, isAllPaused: isAllPaused, inProgressNotPausedFiles: inProgressNotPausedFiles, newFiles: newFiles, processingFiles: processingFiles } = _ref;
    const uploadingState = $915070fc553cba86$var$getUploadingState(isAllErrored, isAllComplete, isAllPaused, files);
    switch(uploadingState){
        case 'uploading':
            return i18n('uploadingXFiles', {
                smart_count: inProgressNotPausedFiles.length
            });
        case 'preprocessing':
        case 'postprocessing':
            return i18n('processingXFiles', {
                smart_count: processingFiles.length
            });
        case 'paused':
            return i18n('uploadPaused');
        case 'waiting':
            return i18n('xFilesSelected', {
                smart_count: newFiles.length
            });
        case 'complete':
            return i18n('uploadComplete');
        case 'error':
            return i18n('error');
        default:
    }
}
function $915070fc553cba86$var$PanelTopBar(props) {
    const { i18n: i18n, isAllComplete: isAllComplete, hideCancelButton: hideCancelButton, maxNumberOfFiles: maxNumberOfFiles, toggleAddFilesPanel: toggleAddFilesPanel, uppy: uppy } = props;
    let { allowNewUpload: allowNewUpload } = props;
    // TODO maybe this should be done in ../Dashboard.jsx, then just pass that down as `allowNewUpload`
    if (allowNewUpload && maxNumberOfFiles) // eslint-disable-next-line react/destructuring-assignment
    allowNewUpload = props.totalFileCount < props.maxNumberOfFiles;
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-DashboardContent-bar"
    }, !isAllComplete && !hideCancelButton ? (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("button", {
        className: "uppy-DashboardContent-back",
        type: "button",
        onClick: ()=>uppy.cancelAll()
    }, i18n('cancel')) : (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", null), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-DashboardContent-title",
        role: "heading",
        "aria-level": "1"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)($915070fc553cba86$var$UploadStatus, props)), allowNewUpload ? (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("button", {
        className: "uppy-DashboardContent-addMore",
        type: "button",
        "aria-label": i18n('addMoreFiles'),
        title: i18n('addMoreFiles'),
        onClick: ()=>toggleAddFilesPanel(true)
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("svg", {
        "aria-hidden": "true",
        focusable: "false",
        className: "uppy-c-icon",
        width: "15",
        height: "15",
        viewBox: "0 0 15 15"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        d: "M8 6.5h6a.5.5 0 0 1 .5.5v.5a.5.5 0 0 1-.5.5H8v6a.5.5 0 0 1-.5.5H7a.5.5 0 0 1-.5-.5V8h-6a.5.5 0 0 1-.5-.5V7a.5.5 0 0 1 .5-.5h6v-6A.5.5 0 0 1 7 0h.5a.5.5 0 0 1 .5.5v6z"
    })), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("span", {
        className: "uppy-DashboardContent-addMoreCaption"
    }, i18n('addMore'))) : (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", null));
}
var $915070fc553cba86$export$2e2bcd8739ae039 = $915070fc553cba86$var$PanelTopBar;










function $fca34f2366194ceb$export$2e2bcd8739ae039(props) {
    const { computedMetaFields: computedMetaFields, requiredMetaFields: requiredMetaFields, updateMeta: updateMeta, form: form, formState: formState } = props;
    const fieldCSSClasses = {
        text: 'uppy-u-reset uppy-c-textInput uppy-Dashboard-FileCard-input'
    };
    return computedMetaFields.map((field)=>{
        const id = `uppy-Dashboard-FileCard-input-${field.id}`;
        const required = requiredMetaFields.includes(field.id);
        return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("fieldset", {
            key: field.id,
            className: "uppy-Dashboard-FileCard-fieldset"
        }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("label", {
            className: "uppy-Dashboard-FileCard-label",
            htmlFor: id
        }, field.name), field.render !== undefined ? field.render({
            value: formState[field.id],
            onChange: (newVal)=>updateMeta(newVal, field.id),
            fieldCSSClasses: fieldCSSClasses,
            required: required,
            form: form.id
        }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)) : (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("input", {
            className: fieldCSSClasses.text,
            id: id,
            form: form.id,
            type: field.type || 'text',
            required: required,
            value: formState[field.id],
            placeholder: field.placeholder,
            onInput: (ev)=>updateMeta(ev.target.value, field.id),
            "data-uppy-super-focusable": true
        }));
    });
}


function $af43f3a66035ecee$export$2e2bcd8739ae039(props) {
    var _getMetaFields;
    const { files: files, fileCardFor: fileCardFor, toggleFileCard: toggleFileCard, saveFileCard: saveFileCard, metaFields: metaFields, requiredMetaFields: requiredMetaFields, openFileEditor: openFileEditor, i18n: i18n, i18nArray: i18nArray, className: className, canEditFile: canEditFile } = props;
    const getMetaFields = ()=>{
        return typeof metaFields === 'function' ? metaFields(files[fileCardFor]) : metaFields;
    };
    const file = files[fileCardFor];
    const computedMetaFields = (_getMetaFields = getMetaFields()) != null ? _getMetaFields : [];
    const showEditButton = canEditFile(file);
    const storedMetaData = {};
    computedMetaFields.forEach((field)=>{
        var _file$meta$field$id;
        storedMetaData[field.id] = (_file$meta$field$id = file.meta[field.id]) != null ? _file$meta$field$id : '';
    });
    const [formState, setFormState] = (0, $e28f05d17e052ff9$export$60241385465d0a34)(storedMetaData);
    const handleSave = (0, $e28f05d17e052ff9$export$35808ee640e87ca7)((ev)=>{
        ev.preventDefault();
        saveFileCard(formState, fileCardFor);
    }, [
        saveFileCard,
        formState,
        fileCardFor
    ]);
    const updateMeta = (newVal, name)=>{
        setFormState({
            ...formState,
            [name]: newVal
        });
    };
    const handleCancel = ()=>{
        toggleFileCard(false);
    };
    const [form] = (0, $e28f05d17e052ff9$export$60241385465d0a34)(()=>{
        const formEl = document.createElement('form');
        formEl.setAttribute('tabindex', '-1');
        formEl.id = (0, $ee6f2436cceea22a$export$ac4959f4f1338dfc)();
        return formEl;
    });
    (0, $e28f05d17e052ff9$export$6d9c69b0de29b591)(()=>{
        document.body.appendChild(form);
        form.addEventListener('submit', handleSave);
        return ()=>{
            form.removeEventListener('submit', handleSave);
            document.body.removeChild(form);
        };
    }, [
        form,
        handleSave
    ]);
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($02c2aab7657be691$exports)))('uppy-Dashboard-FileCard', className),
        "data-uppy-panelType": "FileCard",
        onDragOver: (0, $cb1052d4a6aa569a$export$2e2bcd8739ae039),
        onDragLeave: (0, $cb1052d4a6aa569a$export$2e2bcd8739ae039),
        onDrop: (0, $cb1052d4a6aa569a$export$2e2bcd8739ae039),
        onPaste: (0, $cb1052d4a6aa569a$export$2e2bcd8739ae039)
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-DashboardContent-bar"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-DashboardContent-title",
        role: "heading",
        "aria-level": "1"
    }, i18nArray('editing', {
        file: (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("span", {
            className: "uppy-DashboardContent-titleFile"
        }, file.meta ? file.meta.name : file.name)
    })), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("button", {
        className: "uppy-DashboardContent-back",
        type: "button",
        form: form.id,
        title: i18n('finishEditingFile'),
        onClick: handleCancel
    }, i18n('cancel'))), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-Dashboard-FileCard-inner"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-Dashboard-FileCard-preview",
        style: {
            backgroundColor: (0, $7fe1d951359cc6e1$export$2e2bcd8739ae039)(file.type).color
        }
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $9e2af7705a2c15c5$export$2e2bcd8739ae039), {
        file: file
    }), showEditButton && (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("button", {
        type: "button",
        className: "uppy-u-reset uppy-c-btn uppy-Dashboard-FileCard-edit",
        onClick: (event)=>{
            // When opening the image editor we want to save any meta fields changes.
            // Otherwise it's confusing for the user to click save in the editor,
            // but the changes here are discarded. This bypasses validation,
            // but we are okay with that.
            handleSave(event);
            openFileEditor(file);
        }
    }, i18n('editImage'))), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-Dashboard-FileCard-info"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $fca34f2366194ceb$export$2e2bcd8739ae039), {
        computedMetaFields: computedMetaFields,
        requiredMetaFields: requiredMetaFields,
        updateMeta: updateMeta,
        form: form,
        formState: formState
    })), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-Dashboard-FileCard-actions"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("button", {
        className: "uppy-u-reset uppy-c-btn uppy-c-btn-primary uppy-Dashboard-FileCard-actionsBtn",
        type: "submit",
        form: form.id
    }, i18n('saveChanges')), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("button", {
        className: "uppy-u-reset uppy-c-btn uppy-c-btn-link uppy-Dashboard-FileCard-actionsBtn",
        type: "button",
        onClick: handleCancel,
        form: form.id
    }, i18n('cancel')))));
}





const $35cf1967ab48fc35$var$transitionName = 'uppy-transition-slideDownUp';
const $35cf1967ab48fc35$var$duration = 250;
/**
 * Vertical slide transition.
 *
 * This can take a _single_ child component, which _must_ accept a `className` prop.
 *
 * Currently this is specific to the `uppy-transition-slideDownUp` transition,
 * but it should be simple to extend this for any type of single-element
 * transition by setting the CSS name and duration as props.
 */ function $35cf1967ab48fc35$var$Slide(_ref) {
    let { children: children } = _ref;
    const [cachedChildren, setCachedChildren] = (0, $e28f05d17e052ff9$export$60241385465d0a34)(null);
    const [className, setClassName] = (0, $e28f05d17e052ff9$export$60241385465d0a34)('');
    const enterTimeoutRef = (0, $e28f05d17e052ff9$export$b8f5890fc79d6aca)();
    const leaveTimeoutRef = (0, $e28f05d17e052ff9$export$b8f5890fc79d6aca)();
    const animationFrameRef = (0, $e28f05d17e052ff9$export$b8f5890fc79d6aca)();
    const handleEnterTransition = ()=>{
        setClassName(`${$35cf1967ab48fc35$var$transitionName}-enter`);
        cancelAnimationFrame(animationFrameRef.current);
        clearTimeout(leaveTimeoutRef.current);
        leaveTimeoutRef.current = undefined;
        animationFrameRef.current = requestAnimationFrame(()=>{
            setClassName(`${$35cf1967ab48fc35$var$transitionName}-enter ${$35cf1967ab48fc35$var$transitionName}-enter-active`);
            enterTimeoutRef.current = setTimeout(()=>{
                setClassName('');
            }, $35cf1967ab48fc35$var$duration);
        });
    };
    const handleLeaveTransition = ()=>{
        setClassName(`${$35cf1967ab48fc35$var$transitionName}-leave`);
        cancelAnimationFrame(animationFrameRef.current);
        clearTimeout(enterTimeoutRef.current);
        enterTimeoutRef.current = undefined;
        animationFrameRef.current = requestAnimationFrame(()=>{
            setClassName(`${$35cf1967ab48fc35$var$transitionName}-leave ${$35cf1967ab48fc35$var$transitionName}-leave-active`);
            leaveTimeoutRef.current = setTimeout(()=>{
                setCachedChildren(null);
                setClassName('');
            }, $35cf1967ab48fc35$var$duration);
        });
    };
    (0, $e28f05d17e052ff9$export$6d9c69b0de29b591)(()=>{
        const child = (0, $4d2e93495e50cc85$export$47e4c5b300681277)(children)[0];
        if (cachedChildren === child) return;
        if (child && !cachedChildren) handleEnterTransition();
        else if (cachedChildren && !child && !leaveTimeoutRef.current) handleLeaveTransition();
        setCachedChildren(child);
    }, [
        children,
        cachedChildren
    ]); // Dependency array to trigger effect on children change
    (0, $e28f05d17e052ff9$export$6d9c69b0de29b591)(()=>{
        return ()=>{
            clearTimeout(enterTimeoutRef.current);
            clearTimeout(leaveTimeoutRef.current);
            cancelAnimationFrame(animationFrameRef.current);
        };
    }, []); // Cleanup useEffect
    if (!cachedChildren) return null;
    return (0, $4d2e93495e50cc85$export$e530037191fcd5d7)(cachedChildren, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($02c2aab7657be691$exports)))(className, cachedChildren.props.className)
    });
}
var $35cf1967ab48fc35$export$2e2bcd8739ae039 = $35cf1967ab48fc35$var$Slide;


function $8dc96b7f61bbef1d$var$_extends() {
    $8dc96b7f61bbef1d$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $8dc96b7f61bbef1d$var$_extends.apply(this, arguments);
}
// http://dev.edenspiekermann.com/2016/02/11/introducing-accessible-modal-dialog
// https://github.com/ghosh/micromodal
const $8dc96b7f61bbef1d$var$WIDTH_XL = 900;
const $8dc96b7f61bbef1d$var$WIDTH_LG = 700;
const $8dc96b7f61bbef1d$var$WIDTH_MD = 576;
const $8dc96b7f61bbef1d$var$HEIGHT_MD = 330;
function $8dc96b7f61bbef1d$export$2e2bcd8739ae039(props) {
    const isNoFiles = props.totalFileCount === 0;
    const isSingleFile = props.totalFileCount === 1;
    const isSizeMD = props.containerWidth > $8dc96b7f61bbef1d$var$WIDTH_MD;
    const isSizeHeightMD = props.containerHeight > $8dc96b7f61bbef1d$var$HEIGHT_MD;
    const dashboardClassName = (0, (/*@__PURE__*/$parcel$interopDefault($02c2aab7657be691$exports)))({
        'uppy-Dashboard': true,
        'uppy-Dashboard--isDisabled': props.disabled,
        'uppy-Dashboard--animateOpenClose': props.animateOpenClose,
        'uppy-Dashboard--isClosing': props.isClosing,
        'uppy-Dashboard--isDraggingOver': props.isDraggingOver,
        'uppy-Dashboard--modal': !props.inline,
        'uppy-size--md': props.containerWidth > $8dc96b7f61bbef1d$var$WIDTH_MD,
        'uppy-size--lg': props.containerWidth > $8dc96b7f61bbef1d$var$WIDTH_LG,
        'uppy-size--xl': props.containerWidth > $8dc96b7f61bbef1d$var$WIDTH_XL,
        'uppy-size--height-md': props.containerHeight > $8dc96b7f61bbef1d$var$HEIGHT_MD,
        // We might want to enable this in the future
        // 'uppy-size--height-lg': props.containerHeight > HEIGHT_LG,
        // 'uppy-size--height-xl': props.containerHeight > HEIGHT_XL,
        'uppy-Dashboard--isAddFilesPanelVisible': props.showAddFilesPanel,
        'uppy-Dashboard--isInnerWrapVisible': props.areInsidesReadyToBeVisible,
        // Only enable “centered single file” mode when Dashboard is tall enough
        'uppy-Dashboard--singleFile': props.singleFileFullScreen && isSingleFile && isSizeHeightMD
    });
    // Important: keep these in sync with the percent width values in `src/components/FileItem/index.scss`.
    let itemsPerRow = 1; // mobile
    if (props.containerWidth > $8dc96b7f61bbef1d$var$WIDTH_XL) itemsPerRow = 5;
    else if (props.containerWidth > $8dc96b7f61bbef1d$var$WIDTH_LG) itemsPerRow = 4;
    else if (props.containerWidth > $8dc96b7f61bbef1d$var$WIDTH_MD) itemsPerRow = 3;
    const showFileList = props.showSelectedFiles && !isNoFiles;
    const numberOfFilesForRecovery = props.recoveredState ? Object.keys(props.recoveredState.files).length : null;
    const numberOfGhosts = props.files ? Object.keys(props.files).filter((fileID)=>props.files[fileID].isGhost).length : null;
    const renderRestoredText = ()=>{
        if (numberOfGhosts > 0) return props.i18n('recoveredXFiles', {
            smart_count: numberOfGhosts
        });
        return props.i18n('recoveredAllFiles');
    };
    const dashboard = (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: dashboardClassName,
        "data-uppy-theme": props.theme,
        "data-uppy-num-acquirers": props.acquirers.length,
        "data-uppy-drag-drop-supported": !props.disableLocalFiles && (0, $5e3c26e19f70d299$export$2e2bcd8739ae039)(),
        "aria-hidden": props.inline ? 'false' : props.isHidden,
        "aria-disabled": props.disabled,
        "aria-label": !props.inline ? props.i18n('dashboardWindowTitle') : props.i18n('dashboardTitle'),
        onPaste: props.handlePaste,
        onDragOver: props.handleDragOver,
        onDragLeave: props.handleDragLeave,
        onDrop: props.handleDrop
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        "aria-hidden": "true",
        className: "uppy-Dashboard-overlay",
        tabIndex: -1,
        onClick: props.handleClickOutside
    }), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-Dashboard-inner",
        "aria-modal": !props.inline && 'true',
        role: props.inline ? undefined : 'dialog',
        style: {
            width: props.inline && props.width ? props.width : '',
            height: props.inline && props.height ? props.height : ''
        }
    }, !props.inline ? (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("button", {
        className: "uppy-u-reset uppy-Dashboard-close",
        type: "button",
        "aria-label": props.i18n('closeModal'),
        title: props.i18n('closeModal'),
        onClick: props.closeModal
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("span", {
        "aria-hidden": "true"
    }, "\xD7")) : null, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-Dashboard-innerWrap"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-Dashboard-dropFilesHereHint"
    }, props.i18n('dropHint')), showFileList && (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $915070fc553cba86$export$2e2bcd8739ae039), props), numberOfFilesForRecovery && (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-Dashboard-serviceMsg"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("svg", {
        className: "uppy-Dashboard-serviceMsg-icon",
        "aria-hidden": "true",
        focusable: "false",
        width: "21",
        height: "16",
        viewBox: "0 0 24 19"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("g", {
        transform: "translate(0 -1)",
        fill: "none",
        fillRule: "evenodd"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        d: "M12.857 1.43l10.234 17.056A1 1 0 0122.234 20H1.766a1 1 0 01-.857-1.514L11.143 1.429a1 1 0 011.714 0z",
        fill: "#FFD300"
    }), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        fill: "#000",
        d: "M11 6h2l-.3 8h-1.4z"
    }), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("circle", {
        fill: "#000",
        cx: "12",
        cy: "17",
        r: "1"
    }))), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("strong", {
        className: "uppy-Dashboard-serviceMsg-title"
    }, props.i18n('sessionRestored')), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-Dashboard-serviceMsg-text"
    }, renderRestoredText())), showFileList ? (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $7a578b6cd2206257$export$2e2bcd8739ae039), {
        id: props.id,
        error: props.error,
        i18n: props.i18n,
        uppy: props.uppy,
        files: props.files,
        acquirers: props.acquirers,
        resumableUploads: props.resumableUploads,
        hideRetryButton: props.hideRetryButton,
        hidePauseResumeButton: props.hidePauseResumeButton,
        hideCancelButton: props.hideCancelButton,
        showLinkToFileUploadResult: props.showLinkToFileUploadResult,
        showRemoveButtonAfterComplete: props.showRemoveButtonAfterComplete,
        isWide: props.isWide,
        metaFields: props.metaFields,
        toggleFileCard: props.toggleFileCard,
        handleRequestThumbnail: props.handleRequestThumbnail,
        handleCancelThumbnail: props.handleCancelThumbnail,
        recoveredState: props.recoveredState,
        individualCancellation: props.individualCancellation,
        openFileEditor: props.openFileEditor,
        canEditFile: props.canEditFile,
        toggleAddFilesPanel: props.toggleAddFilesPanel,
        isSingleFile: isSingleFile,
        itemsPerRow: itemsPerRow
    }) : (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $3f3c0a16d9cbe8a2$export$2e2bcd8739ae039), $8dc96b7f61bbef1d$var$_extends({}, props, {
        isSizeMD: isSizeMD
    })), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $35cf1967ab48fc35$export$2e2bcd8739ae039), null, props.showAddFilesPanel ? (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $175934b4bbc4fb46$export$2e2bcd8739ae039), $8dc96b7f61bbef1d$var$_extends({
        key: "AddFiles"
    }, props, {
        isSizeMD: isSizeMD
    })) : null), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $35cf1967ab48fc35$export$2e2bcd8739ae039), null, props.fileCardFor ? (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $af43f3a66035ecee$export$2e2bcd8739ae039), $8dc96b7f61bbef1d$var$_extends({
        key: "FileCard"
    }, props)) : null), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $35cf1967ab48fc35$export$2e2bcd8739ae039), null, props.activePickerPanel ? (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $e3578ca53f5728a8$export$2e2bcd8739ae039), $8dc96b7f61bbef1d$var$_extends({
        key: "Picker"
    }, props)) : null), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $35cf1967ab48fc35$export$2e2bcd8739ae039), null, props.showFileEditor ? (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $d8360bbc75e6a373$export$2e2bcd8739ae039), $8dc96b7f61bbef1d$var$_extends({
        key: "Editor"
    }, props)) : null), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-Dashboard-progressindicators"
    }, props.progressindicators.map((target)=>{
        return props.uppy.getPlugin(target.id).render(props.state);
    })))));
    return dashboard;
}


var $c4158ae05dd76b13$export$2e2bcd8739ae039 = {
    strings: {
        // When `inline: false`, used as the screen reader label for the button that closes the modal.
        closeModal: 'Close Modal',
        // Used as the screen reader label for the plus (+) button that shows the “Add more files” screen
        addMoreFiles: 'Add more files',
        addingMoreFiles: 'Adding more files',
        // Used as the header for import panels, e.g., “Import from Google Drive”.
        importFrom: 'Import from %{name}',
        // When `inline: false`, used as the screen reader label for the dashboard modal.
        dashboardWindowTitle: 'Uppy Dashboard Window (Press escape to close)',
        // When `inline: true`, used as the screen reader label for the dashboard area.
        dashboardTitle: 'Uppy Dashboard',
        // Shown in the Informer when a link to a file was copied to the clipboard.
        copyLinkToClipboardSuccess: 'Link copied to clipboard.',
        // Used when a link cannot be copied automatically — the user has to select the text from the
        // input element below this string.
        copyLinkToClipboardFallback: 'Copy the URL below',
        // Used as the hover title and screen reader label for buttons that copy a file link.
        copyLink: 'Copy link',
        back: 'Back',
        // Used as the screen reader label for buttons that remove a file.
        removeFile: 'Remove file',
        // Used as the screen reader label for buttons that open the metadata editor panel for a file.
        editFile: 'Edit file',
        editImage: 'Edit image',
        // Shown in the panel header for the metadata editor. Rendered as “Editing image.png”.
        editing: 'Editing %{file}',
        // Shown on the main upload screen when an upload error occurs
        error: 'Error',
        // Used as the screen reader label for the button that saves metadata edits and returns to the
        // file list view.
        finishEditingFile: 'Finish editing file',
        saveChanges: 'Save changes',
        // Used as the label for the tab button that opens the system file selection dialog.
        myDevice: 'My Device',
        dropHint: 'Drop your files here',
        // Used as the hover text and screen reader label for file progress indicators when
        // they have been fully uploaded.
        uploadComplete: 'Upload complete',
        uploadPaused: 'Upload paused',
        // Used as the hover text and screen reader label for the buttons to resume paused uploads.
        resumeUpload: 'Resume upload',
        // Used as the hover text and screen reader label for the buttons to pause uploads.
        pauseUpload: 'Pause upload',
        // Used as the hover text and screen reader label for the buttons to retry failed uploads.
        retryUpload: 'Retry upload',
        // Used as the hover text and screen reader label for the buttons to cancel uploads.
        cancelUpload: 'Cancel upload',
        // Used in a title, how many files are currently selected
        xFilesSelected: {
            0: '%{smart_count} file selected',
            1: '%{smart_count} files selected'
        },
        uploadingXFiles: {
            0: 'Uploading %{smart_count} file',
            1: 'Uploading %{smart_count} files'
        },
        processingXFiles: {
            0: 'Processing %{smart_count} file',
            1: 'Processing %{smart_count} files'
        },
        // The "powered by Uppy" link at the bottom of the Dashboard.
        poweredBy: 'Powered by %{uppy}',
        addMore: 'Add more',
        editFileWithFilename: 'Edit file %{file}',
        save: 'Save',
        cancel: 'Cancel',
        dropPasteFiles: 'Drop files here or %{browseFiles}',
        dropPasteFolders: 'Drop files here or %{browseFolders}',
        dropPasteBoth: 'Drop files here, %{browseFiles} or %{browseFolders}',
        dropPasteImportFiles: 'Drop files here, %{browseFiles} or import from:',
        dropPasteImportFolders: 'Drop files here, %{browseFolders} or import from:',
        dropPasteImportBoth: 'Drop files here, %{browseFiles}, %{browseFolders} or import from:',
        importFiles: 'Import files from:',
        browseFiles: 'browse files',
        browseFolders: 'browse folders',
        recoveredXFiles: {
            0: 'We could not fully recover 1 file. Please re-select it and resume the upload.',
            1: 'We could not fully recover %{smart_count} files. Please re-select them and resume the upload.'
        },
        recoveredAllFiles: 'We restored all files. You can now resume the upload.',
        sessionRestored: 'Session restored',
        reSelect: 'Re-select',
        missingRequiredMetaFields: {
            0: 'Missing required meta field: %{fields}.',
            1: 'Missing required meta fields: %{fields}.'
        },
        // Used for native device camera buttons on mobile
        takePictureBtn: 'Take Picture',
        recordVideoBtn: 'Record Video'
    }
};


function $b868dcf7a47332e3$var$_classPrivateFieldLooseBase(receiver, privateKey) {
    if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) throw new TypeError("attempted to use private field on non-instance");
    return receiver;
}
var $b868dcf7a47332e3$var$id = 0;
function $b868dcf7a47332e3$var$_classPrivateFieldLooseKey(name) {
    return "__private_" + $b868dcf7a47332e3$var$id++ + "_" + name;
}
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore We don't want TS to generate types for the package.json
const $b868dcf7a47332e3$var$packageJson = {
    "version": "3.9.1"
};
const $b868dcf7a47332e3$var$memoize = (0, $e66b69e563b626e6$export$2e2bcd8739ae039).default || (0, $e66b69e563b626e6$export$2e2bcd8739ae039);
const $b868dcf7a47332e3$var$TAB_KEY = 9;
const $b868dcf7a47332e3$var$ESC_KEY = 27;
function $b868dcf7a47332e3$var$createPromise() {
    const o = {};
    o.promise = new Promise((resolve, reject)=>{
        o.resolve = resolve;
        o.reject = reject;
    });
    return o;
}
// set default options, must be kept in sync with packages/@uppy/react/src/DashboardModal.js
const $b868dcf7a47332e3$var$defaultOptions = {
    target: 'body',
    metaFields: [],
    inline: false,
    width: 750,
    height: 550,
    thumbnailWidth: 280,
    thumbnailType: 'image/jpeg',
    waitForThumbnailsBeforeUpload: false,
    defaultPickerIcon: $671181bcc8a0cf10$export$b9ab270927e310e4,
    showLinkToFileUploadResult: false,
    showProgressDetails: false,
    hideUploadButton: false,
    hideCancelButton: false,
    hideRetryButton: false,
    hidePauseResumeButton: false,
    hideProgressAfterFinish: false,
    note: null,
    closeModalOnClickOutside: false,
    closeAfterFinish: false,
    singleFileFullScreen: true,
    disableStatusBar: false,
    disableInformer: false,
    disableThumbnailGenerator: false,
    disablePageScrollWhenModalOpen: true,
    animateOpenClose: true,
    fileManagerSelectionType: 'files',
    proudlyDisplayPoweredByUppy: true,
    showSelectedFiles: true,
    showRemoveButtonAfterComplete: false,
    browserBackButtonClose: false,
    showNativePhotoCameraButton: false,
    showNativeVideoCameraButton: false,
    theme: 'light',
    autoOpen: null,
    autoOpenFileEditor: false,
    disabled: false,
    disableLocalFiles: false,
    // Dynamic default options, they have to be defined in the constructor (because
    // they require access to the `this` keyword), but we still want them to
    // appear in the default options so TS knows they'll be defined.
    doneButtonHandler: undefined,
    onRequestCloseModal: null
};
/**
 * Dashboard UI with previews, metadata editing, tabs for various services and more
 */ var $b868dcf7a47332e3$var$_disabledNodes = /*#__PURE__*/ $b868dcf7a47332e3$var$_classPrivateFieldLooseKey("disabledNodes");
var $b868dcf7a47332e3$var$_generateLargeThumbnailIfSingleFile = /*#__PURE__*/ $b868dcf7a47332e3$var$_classPrivateFieldLooseKey("generateLargeThumbnailIfSingleFile");
var $b868dcf7a47332e3$var$_openFileEditorWhenFilesAdded = /*#__PURE__*/ $b868dcf7a47332e3$var$_classPrivateFieldLooseKey("openFileEditorWhenFilesAdded");
var $b868dcf7a47332e3$var$_attachRenderFunctionToTarget = /*#__PURE__*/ $b868dcf7a47332e3$var$_classPrivateFieldLooseKey("attachRenderFunctionToTarget");
var $b868dcf7a47332e3$var$_isTargetSupported = /*#__PURE__*/ $b868dcf7a47332e3$var$_classPrivateFieldLooseKey("isTargetSupported");
var $b868dcf7a47332e3$var$_getAcquirers = /*#__PURE__*/ $b868dcf7a47332e3$var$_classPrivateFieldLooseKey("getAcquirers");
var $b868dcf7a47332e3$var$_getProgressIndicators = /*#__PURE__*/ $b868dcf7a47332e3$var$_classPrivateFieldLooseKey("getProgressIndicators");
var $b868dcf7a47332e3$var$_getEditors = /*#__PURE__*/ $b868dcf7a47332e3$var$_classPrivateFieldLooseKey("getEditors");
var $b868dcf7a47332e3$var$_addSpecifiedPluginsFromOptions = /*#__PURE__*/ $b868dcf7a47332e3$var$_classPrivateFieldLooseKey("addSpecifiedPluginsFromOptions");
var $b868dcf7a47332e3$var$_autoDiscoverPlugins = /*#__PURE__*/ $b868dcf7a47332e3$var$_classPrivateFieldLooseKey("autoDiscoverPlugins");
var $b868dcf7a47332e3$var$_addSupportedPluginIfNoTarget = /*#__PURE__*/ $b868dcf7a47332e3$var$_classPrivateFieldLooseKey("addSupportedPluginIfNoTarget");
class $b868dcf7a47332e3$export$2e2bcd8739ae039 extends (0, $5d08dd66a9cc6899$export$2e2bcd8739ae039) {
    // Timeouts
    constructor(uppy, _opts){
        var _this$opts4, _this$opts4$onRequest;
        // support for the legacy `autoOpenFileEditor` option,
        // TODO: we can remove this code when we update the Uppy major version
        let autoOpen;
        if (!_opts) autoOpen = null;
        else if (_opts.autoOpen === undefined) autoOpen = _opts.autoOpenFileEditor ? 'imageEditor' : null;
        else autoOpen = _opts.autoOpen;
        super(uppy, {
            ...$b868dcf7a47332e3$var$defaultOptions,
            ..._opts,
            autoOpen: autoOpen
        });
        Object.defineProperty(this, $b868dcf7a47332e3$var$_disabledNodes, {
            writable: true,
            value: void 0
        });
        this.modalName = `uppy-Dashboard-${(0, $ee6f2436cceea22a$export$ac4959f4f1338dfc)()}`;
        this.superFocus = (0, $33dc1dd867a7b8b6$export$2e2bcd8739ae039)();
        this.ifFocusedOnUppyRecently = false;
        this.removeTarget = (plugin)=>{
            const pluginState = this.getPluginState();
            // filter out the one we want to remove
            const newTargets = pluginState.targets.filter((target)=>target.id !== plugin.id);
            this.setPluginState({
                targets: newTargets
            });
        };
        this.addTarget = (plugin)=>{
            const callerPluginId = plugin.id || plugin.constructor.name;
            const callerPluginName = plugin.title || callerPluginId;
            const callerPluginType = plugin.type;
            if (callerPluginType !== 'acquirer' && callerPluginType !== 'progressindicator' && callerPluginType !== 'editor') {
                const msg = 'Dashboard: can only be targeted by plugins of types: acquirer, progressindicator, editor';
                this.uppy.log(msg, 'error');
                return null;
            }
            const target = {
                id: callerPluginId,
                name: callerPluginName,
                type: callerPluginType
            };
            const state = this.getPluginState();
            const newTargets = state.targets.slice();
            newTargets.push(target);
            this.setPluginState({
                targets: newTargets
            });
            return this.el;
        };
        this.hideAllPanels = ()=>{
            var _state$activePickerPa;
            const state = this.getPluginState();
            const update = {
                activePickerPanel: undefined,
                showAddFilesPanel: false,
                activeOverlayType: null,
                fileCardFor: null,
                showFileEditor: false
            };
            if (state.activePickerPanel === update.activePickerPanel && state.showAddFilesPanel === update.showAddFilesPanel && state.showFileEditor === update.showFileEditor && state.activeOverlayType === update.activeOverlayType) // avoid doing a state update if nothing changed
            return;
            this.setPluginState(update);
            this.uppy.emit('dashboard:close-panel', (_state$activePickerPa = state.activePickerPanel) == null ? void 0 : _state$activePickerPa.id);
        };
        this.showPanel = (id)=>{
            const { targets: targets } = this.getPluginState();
            const activePickerPanel = targets.find((target)=>{
                return target.type === 'acquirer' && target.id === id;
            });
            this.setPluginState({
                activePickerPanel: activePickerPanel,
                activeOverlayType: 'PickerPanel'
            });
            this.uppy.emit('dashboard:show-panel', id);
        };
        this.canEditFile = (file)=>{
            const { targets: targets } = this.getPluginState();
            const editors = $b868dcf7a47332e3$var$_classPrivateFieldLooseBase(this, $b868dcf7a47332e3$var$_getEditors)[$b868dcf7a47332e3$var$_getEditors](targets);
            return editors.some((target)=>this.uppy.getPlugin(target.id).canEditFile(file));
        };
        this.openFileEditor = (file)=>{
            const { targets: targets } = this.getPluginState();
            const editors = $b868dcf7a47332e3$var$_classPrivateFieldLooseBase(this, $b868dcf7a47332e3$var$_getEditors)[$b868dcf7a47332e3$var$_getEditors](targets);
            this.setPluginState({
                showFileEditor: true,
                fileCardFor: file.id || null,
                activeOverlayType: 'FileEditor'
            });
            editors.forEach((editor)=>{
                this.uppy.getPlugin(editor.id).selectFile(file);
            });
        };
        this.closeFileEditor = ()=>{
            const { metaFields: metaFields } = this.getPluginState();
            const isMetaEditorEnabled = metaFields && metaFields.length > 0;
            if (isMetaEditorEnabled) this.setPluginState({
                showFileEditor: false,
                activeOverlayType: 'FileCard'
            });
            else this.setPluginState({
                showFileEditor: false,
                fileCardFor: null,
                activeOverlayType: 'AddFiles'
            });
        };
        this.saveFileEditor = ()=>{
            const { targets: targets } = this.getPluginState();
            const editors = $b868dcf7a47332e3$var$_classPrivateFieldLooseBase(this, $b868dcf7a47332e3$var$_getEditors)[$b868dcf7a47332e3$var$_getEditors](targets);
            editors.forEach((editor)=>{
                this.uppy.getPlugin(editor.id).save();
            });
            this.closeFileEditor();
        };
        this.openModal = ()=>{
            const { promise: promise, resolve: resolve } = $b868dcf7a47332e3$var$createPromise();
            // save scroll position
            this.savedScrollPosition = window.pageYOffset;
            // save active element, so we can restore focus when modal is closed
            this.savedActiveElement = document.activeElement;
            if (this.opts.disablePageScrollWhenModalOpen) document.body.classList.add('uppy-Dashboard-isFixed');
            if (this.opts.animateOpenClose && this.getPluginState().isClosing) {
                const handler = ()=>{
                    this.setPluginState({
                        isHidden: false
                    });
                    this.el.removeEventListener('animationend', handler, false);
                    resolve();
                };
                this.el.addEventListener('animationend', handler, false);
            } else {
                this.setPluginState({
                    isHidden: false
                });
                resolve();
            }
            if (this.opts.browserBackButtonClose) this.updateBrowserHistory();
            // handle ESC and TAB keys in modal dialog
            document.addEventListener('keydown', this.handleKeyDownInModal);
            this.uppy.emit('dashboard:modal-open');
            return promise;
        };
        this.closeModal = (opts)=>{
            var _opts$manualClose;
            // Whether the modal is being closed by the user (`true`) or by other means (e.g. browser back button)
            const manualClose = (_opts$manualClose = opts == null ? void 0 : opts.manualClose) != null ? _opts$manualClose : true;
            const { isHidden: isHidden, isClosing: isClosing } = this.getPluginState();
            if (isHidden || isClosing) // short-circuit if animation is ongoing
            return undefined;
            const { promise: promise, resolve: resolve } = $b868dcf7a47332e3$var$createPromise();
            if (this.opts.disablePageScrollWhenModalOpen) document.body.classList.remove('uppy-Dashboard-isFixed');
            if (this.opts.animateOpenClose) {
                this.setPluginState({
                    isClosing: true
                });
                const handler = ()=>{
                    this.setPluginState({
                        isHidden: true,
                        isClosing: false
                    });
                    this.superFocus.cancel();
                    this.savedActiveElement.focus();
                    this.el.removeEventListener('animationend', handler, false);
                    resolve();
                };
                this.el.addEventListener('animationend', handler, false);
            } else {
                this.setPluginState({
                    isHidden: true
                });
                this.superFocus.cancel();
                this.savedActiveElement.focus();
                resolve();
            }
            // handle ESC and TAB keys in modal dialog
            document.removeEventListener('keydown', this.handleKeyDownInModal);
            if (manualClose) {
                if (this.opts.browserBackButtonClose) {
                    var _history$state;
                    // Make sure that the latest entry in the history state is our modal name
                    // eslint-disable-next-line no-restricted-globals
                    if ((_history$state = history.state) != null && _history$state[this.modalName]) // Go back in history to clear out the entry we created (ultimately closing the modal)
                    // eslint-disable-next-line no-restricted-globals
                    history.back();
                }
            }
            this.uppy.emit('dashboard:modal-closed');
            return promise;
        };
        this.isModalOpen = ()=>{
            return !this.getPluginState().isHidden || false;
        };
        this.requestCloseModal = ()=>{
            if (this.opts.onRequestCloseModal) return this.opts.onRequestCloseModal();
            return this.closeModal();
        };
        this.setDarkModeCapability = (isDarkModeOn)=>{
            const { capabilities: capabilities } = this.uppy.getState();
            this.uppy.setState({
                capabilities: {
                    ...capabilities,
                    darkMode: isDarkModeOn
                }
            });
        };
        this.handleSystemDarkModeChange = (event)=>{
            const isDarkModeOnNow = event.matches;
            this.uppy.log(`[Dashboard] Dark mode is ${isDarkModeOnNow ? 'on' : 'off'}`);
            this.setDarkModeCapability(isDarkModeOnNow);
        };
        this.toggleFileCard = (show, fileID)=>{
            const file = this.uppy.getFile(fileID);
            if (show) this.uppy.emit('dashboard:file-edit-start', file);
            else this.uppy.emit('dashboard:file-edit-complete', file);
            this.setPluginState({
                fileCardFor: show ? fileID : null,
                activeOverlayType: show ? 'FileCard' : null
            });
        };
        this.toggleAddFilesPanel = (show)=>{
            this.setPluginState({
                showAddFilesPanel: show,
                activeOverlayType: show ? 'AddFiles' : null
            });
        };
        this.addFiles = (files)=>{
            const descriptors = files.map((file)=>({
                    source: this.id,
                    name: file.name,
                    type: file.type,
                    data: file,
                    meta: {
                        // path of the file relative to the ancestor directory the user selected.
                        // e.g. 'docs/Old Prague/airbnb.pdf'
                        relativePath: file.relativePath || file.webkitRelativePath || null
                    }
                }));
            try {
                this.uppy.addFiles(descriptors);
            } catch (err) {
                this.uppy.log(err);
            }
        };
        // ___Why make insides of Dashboard invisible until first ResizeObserver event is emitted?
        //    ResizeOberserver doesn't emit the first resize event fast enough, users can see the jump from one .uppy-size-- to
        //    another (e.g. in Safari)
        // ___Why not apply visibility property to .uppy-Dashboard-inner?
        //    Because ideally, acc to specs, ResizeObserver should see invisible elements as of width 0. So even though applying
        //    invisibility to .uppy-Dashboard-inner works now, it may not work in the future.
        this.startListeningToResize = ()=>{
            // Watch for Dashboard container (`.uppy-Dashboard-inner`) resize
            // and update containerWidth/containerHeight in plugin state accordingly.
            // Emits first event on initialization.
            this.resizeObserver = new ResizeObserver((entries)=>{
                const uppyDashboardInnerEl = entries[0];
                const { width: width, height: height } = uppyDashboardInnerEl.contentRect;
                this.setPluginState({
                    containerWidth: width,
                    containerHeight: height,
                    areInsidesReadyToBeVisible: true
                });
            });
            this.resizeObserver.observe(this.el.querySelector('.uppy-Dashboard-inner'));
            // If ResizeObserver fails to emit an event telling us what size to use - default to the mobile view
            this.makeDashboardInsidesVisibleAnywayTimeout = setTimeout(()=>{
                const pluginState = this.getPluginState();
                const isModalAndClosed = !this.opts.inline && pluginState.isHidden;
                if (// We might want to enable this in the future
                // if ResizeObserver hasn't yet fired,
                !pluginState.areInsidesReadyToBeVisible && // and it's not due to the modal being closed
                !isModalAndClosed) {
                    this.uppy.log("[Dashboard] resize event didn\u2019t fire on time: defaulted to mobile layout", 'warning');
                    this.setPluginState({
                        areInsidesReadyToBeVisible: true
                    });
                }
            }, 1000);
        };
        this.stopListeningToResize = ()=>{
            this.resizeObserver.disconnect();
            clearTimeout(this.makeDashboardInsidesVisibleAnywayTimeout);
        };
        // Records whether we have been interacting with uppy right now,
        // which is then used to determine whether state updates should trigger a refocusing.
        this.recordIfFocusedOnUppyRecently = (event)=>{
            if (this.el.contains(event.target)) this.ifFocusedOnUppyRecently = true;
            else {
                this.ifFocusedOnUppyRecently = false;
                // ___Why run this.superFocus.cancel here when it already runs in superFocusOnEachUpdate?
                //    Because superFocus is debounced, when we move from Uppy to some other element on the page,
                //    previously run superFocus sometimes hits and moves focus back to Uppy.
                this.superFocus.cancel();
            }
        };
        this.disableInteractiveElements = (disable)=>{
            var _classPrivateFieldLoo;
            const NODES_TO_DISABLE = [
                'a[href]',
                'input:not([disabled])',
                'select:not([disabled])',
                'textarea:not([disabled])',
                'button:not([disabled])',
                '[role="button"]:not([disabled])'
            ];
            const nodesToDisable = (_classPrivateFieldLoo = $b868dcf7a47332e3$var$_classPrivateFieldLooseBase(this, $b868dcf7a47332e3$var$_disabledNodes)[$b868dcf7a47332e3$var$_disabledNodes]) != null ? _classPrivateFieldLoo : (0, $d737086ca91a9c7d$export$2e2bcd8739ae039)(this.el.querySelectorAll(NODES_TO_DISABLE)).filter((node)=>!node.classList.contains('uppy-Dashboard-close'));
            for (const node of nodesToDisable)// Links can’t have `disabled` attr, so we use `aria-disabled` for a11y
            if (node.tagName === 'A') node.setAttribute('aria-disabled', disable);
            else node.disabled = disable;
            if (disable) $b868dcf7a47332e3$var$_classPrivateFieldLooseBase(this, $b868dcf7a47332e3$var$_disabledNodes)[$b868dcf7a47332e3$var$_disabledNodes] = nodesToDisable;
            else $b868dcf7a47332e3$var$_classPrivateFieldLooseBase(this, $b868dcf7a47332e3$var$_disabledNodes)[$b868dcf7a47332e3$var$_disabledNodes] = null;
            this.dashboardIsDisabled = disable;
        };
        this.updateBrowserHistory = ()=>{
            var _history$state2;
            // Ensure history state does not already contain our modal name to avoid double-pushing
            // eslint-disable-next-line no-restricted-globals
            if (!((_history$state2 = history.state) != null && _history$state2[this.modalName])) // Push to history so that the page is not lost on browser back button press
            // eslint-disable-next-line no-restricted-globals
            history.pushState({
                // eslint-disable-next-line no-restricted-globals
                ...history.state,
                [this.modalName]: true
            }, '');
            // Listen for back button presses
            window.addEventListener('popstate', this.handlePopState, false);
        };
        this.handlePopState = (event)=>{
            var _event$state;
            // Close the modal if the history state no longer contains our modal name
            if (this.isModalOpen() && (!event.state || !event.state[this.modalName])) this.closeModal({
                manualClose: false
            });
            // When the browser back button is pressed and uppy is now the latest entry
            // in the history but the modal is closed, fix the history by removing the
            // uppy history entry.
            // This occurs when another entry is added into the history state while the
            // modal is open, and then the modal gets manually closed.
            // Solves PR #575 (https://github.com/transloadit/uppy/pull/575)
            if (!this.isModalOpen() && (_event$state = event.state) != null && _event$state[this.modalName]) // eslint-disable-next-line no-restricted-globals
            history.back();
        };
        this.handleKeyDownInModal = (event)=>{
            // close modal on esc key press
            if (event.keyCode === $b868dcf7a47332e3$var$ESC_KEY) this.requestCloseModal();
            // trap focus on tab key press
            if (event.keyCode === $b868dcf7a47332e3$var$TAB_KEY) $f5d602e6112dba3d$export$f41e0874aee57111(event, this.getPluginState().activeOverlayType, this.el);
        };
        this.handleClickOutside = ()=>{
            if (this.opts.closeModalOnClickOutside) this.requestCloseModal();
        };
        this.handlePaste = (event)=>{
            // Let any acquirer plugin (Url/Webcam/etc.) handle pastes to the root
            this.uppy.iteratePlugins((plugin)=>{
                if (plugin.type === 'acquirer') plugin.handleRootPaste == null || plugin.handleRootPaste(event);
            });
            // Add all dropped files
            const files = (0, $d737086ca91a9c7d$export$2e2bcd8739ae039)(event.clipboardData.files);
            if (files.length > 0) {
                this.uppy.log('[Dashboard] Files pasted');
                this.addFiles(files);
            }
        };
        this.handleInputChange = (event)=>{
            event.preventDefault();
            const files = (0, $d737086ca91a9c7d$export$2e2bcd8739ae039)(event.target.files);
            if (files.length > 0) {
                this.uppy.log('[Dashboard] Files selected through input');
                this.addFiles(files);
            }
        };
        this.handleDragOver = (event)=>{
            var _this$opts$onDragOver, _this$opts;
            event.preventDefault();
            event.stopPropagation();
            // Check if some plugin can handle the datatransfer without files —
            // for instance, the Url plugin can import a url
            const canSomePluginHandleRootDrop = ()=>{
                let somePluginCanHandleRootDrop = true;
                this.uppy.iteratePlugins((plugin)=>{
                    if (plugin.canHandleRootDrop != null && plugin.canHandleRootDrop(event)) somePluginCanHandleRootDrop = true;
                });
                return somePluginCanHandleRootDrop;
            };
            // Check if the "type" of the datatransfer object includes files
            const doesEventHaveFiles = ()=>{
                const { types: types } = event.dataTransfer;
                return types.some((type)=>type === 'Files');
            };
            // Deny drop, if no plugins can handle datatransfer, there are no files,
            // or when opts.disabled is set, or new uploads are not allowed
            const somePluginCanHandleRootDrop = canSomePluginHandleRootDrop();
            const hasFiles = doesEventHaveFiles();
            if (!somePluginCanHandleRootDrop && !hasFiles || this.opts.disabled || // opts.disableLocalFiles should only be taken into account if no plugins
            // can handle the datatransfer
            this.opts.disableLocalFiles && (hasFiles || !somePluginCanHandleRootDrop) || !this.uppy.getState().allowNewUpload) {
                event.dataTransfer.dropEffect = 'none'; // eslint-disable-line no-param-reassign
                clearTimeout(this.removeDragOverClassTimeout);
                return;
            }
            // Add a small (+) icon on drop
            // (and prevent browsers from interpreting this as files being _moved_ into the
            // browser, https://github.com/transloadit/uppy/issues/1978).
            event.dataTransfer.dropEffect = 'copy'; // eslint-disable-line no-param-reassign
            clearTimeout(this.removeDragOverClassTimeout);
            this.setPluginState({
                isDraggingOver: true
            });
            (_this$opts$onDragOver = (_this$opts = this.opts).onDragOver) == null || _this$opts$onDragOver.call(_this$opts, event);
        };
        this.handleDragLeave = (event)=>{
            var _this$opts$onDragLeav, _this$opts2;
            event.preventDefault();
            event.stopPropagation();
            clearTimeout(this.removeDragOverClassTimeout);
            // Timeout against flickering, this solution is taken from drag-drop library.
            // Solution with 'pointer-events: none' didn't work across browsers.
            this.removeDragOverClassTimeout = setTimeout(()=>{
                this.setPluginState({
                    isDraggingOver: false
                });
            }, 50);
            (_this$opts$onDragLeav = (_this$opts2 = this.opts).onDragLeave) == null || _this$opts$onDragLeav.call(_this$opts2, event);
        };
        this.handleDrop = async (event)=>{
            var _this$opts$onDrop, _this$opts3;
            event.preventDefault();
            event.stopPropagation();
            clearTimeout(this.removeDragOverClassTimeout);
            this.setPluginState({
                isDraggingOver: false
            });
            // Let any acquirer plugin (Url/Webcam/etc.) handle drops to the root
            this.uppy.iteratePlugins((plugin)=>{
                if (plugin.type === 'acquirer') plugin.handleRootDrop == null || plugin.handleRootDrop(event);
            });
            // Add all dropped files
            let executedDropErrorOnce = false;
            const logDropError = (error)=>{
                this.uppy.log(error, 'error');
                // In practice all drop errors are most likely the same,
                // so let's just show one to avoid overwhelming the user
                if (!executedDropErrorOnce) {
                    this.uppy.info(error.message, 'error');
                    executedDropErrorOnce = true;
                }
            };
            this.uppy.log('[Dashboard] Processing dropped files');
            // Add all dropped files
            const files = await (0, $954bacbcaff60289$export$2e2bcd8739ae039)(event.dataTransfer, {
                logDropError: logDropError
            });
            if (files.length > 0) {
                this.uppy.log('[Dashboard] Files dropped');
                this.addFiles(files);
            }
            (_this$opts$onDrop = (_this$opts3 = this.opts).onDrop) == null || _this$opts$onDrop.call(_this$opts3, event);
        };
        this.handleRequestThumbnail = (file)=>{
            if (!this.opts.waitForThumbnailsBeforeUpload) this.uppy.emit('thumbnail:request', file);
        };
        /**
     * We cancel thumbnail requests when a file item component unmounts to avoid
     * clogging up the queue when the user scrolls past many elements.
     */ this.handleCancelThumbnail = (file)=>{
            if (!this.opts.waitForThumbnailsBeforeUpload) this.uppy.emit('thumbnail:cancel', file);
        };
        this.handleKeyDownInInline = (event)=>{
            // Trap focus on tab key press.
            if (event.keyCode === $b868dcf7a47332e3$var$TAB_KEY) $f5d602e6112dba3d$export$66fd63158b65050a(event, this.getPluginState().activeOverlayType, this.el);
        };
        // ___Why do we listen to the 'paste' event on a document instead of onPaste={props.handlePaste} prop,
        //    or this.el.addEventListener('paste')?
        //    Because (at least) Chrome doesn't handle paste if focus is on some button, e.g. 'My Device'.
        //    => Therefore, the best option is to listen to all 'paste' events, and only react to them when we are focused on our
        //       particular Uppy instance.
        // ___Why do we still need onPaste={props.handlePaste} for the DashboardUi?
        //    Because if we click on the 'Drop files here' caption e.g., `document.activeElement` will be 'body'. Which means our
        //    standard determination of whether we're pasting into our Uppy instance won't work.
        //    => Therefore, we need a traditional onPaste={props.handlePaste} handler too.
        this.handlePasteOnBody = (event)=>{
            const isFocusInOverlay = this.el.contains(document.activeElement);
            if (isFocusInOverlay) this.handlePaste(event);
        };
        this.handleComplete = (_ref)=>{
            let { failed: failed } = _ref;
            if (this.opts.closeAfterFinish && !(failed != null && failed.length)) // All uploads are done
            this.requestCloseModal();
        };
        this.handleCancelRestore = ()=>{
            this.uppy.emit('restore-canceled');
        };
        Object.defineProperty(this, $b868dcf7a47332e3$var$_generateLargeThumbnailIfSingleFile, {
            writable: true,
            value: ()=>{
                if (this.opts.disableThumbnailGenerator) return;
                const LARGE_THUMBNAIL = 600;
                const files = this.uppy.getFiles();
                if (files.length === 1) {
                    const thumbnailGenerator = this.uppy.getPlugin(`${this.id}:ThumbnailGenerator`);
                    thumbnailGenerator == null || thumbnailGenerator.setOptions({
                        thumbnailWidth: LARGE_THUMBNAIL
                    });
                    const fileForThumbnail = {
                        ...files[0],
                        preview: undefined
                    };
                    thumbnailGenerator == null || thumbnailGenerator.requestThumbnail(fileForThumbnail).then(()=>{
                        thumbnailGenerator == null || thumbnailGenerator.setOptions({
                            thumbnailWidth: this.opts.thumbnailWidth
                        });
                    });
                }
            }
        });
        Object.defineProperty(this, $b868dcf7a47332e3$var$_openFileEditorWhenFilesAdded, {
            writable: true,
            value: (files)=>{
                const firstFile = files[0];
                const { metaFields: metaFields } = this.getPluginState();
                const isMetaEditorEnabled = metaFields && metaFields.length > 0;
                const isImageEditorEnabled = this.canEditFile(firstFile);
                if (isMetaEditorEnabled && this.opts.autoOpen === 'metaEditor') this.toggleFileCard(true, firstFile.id);
                else if (isImageEditorEnabled && this.opts.autoOpen === 'imageEditor') this.openFileEditor(firstFile);
            }
        });
        this.initEvents = ()=>{
            // Modal open button
            if (this.opts.trigger && !this.opts.inline) {
                const showModalTrigger = (0, $3da4efa7f88c23a6$export$2e2bcd8739ae039)(this.opts.trigger);
                if (showModalTrigger) showModalTrigger.forEach((trigger)=>trigger.addEventListener('click', this.openModal));
                else this.uppy.log('Dashboard modal trigger not found. Make sure `trigger` is set in Dashboard options, unless you are planning to call `dashboard.openModal()` method yourself', 'warning');
            }
            this.startListeningToResize();
            document.addEventListener('paste', this.handlePasteOnBody);
            this.uppy.on('plugin-added', $b868dcf7a47332e3$var$_classPrivateFieldLooseBase(this, $b868dcf7a47332e3$var$_addSupportedPluginIfNoTarget)[$b868dcf7a47332e3$var$_addSupportedPluginIfNoTarget]);
            this.uppy.on('plugin-remove', this.removeTarget);
            this.uppy.on('file-added', this.hideAllPanels);
            this.uppy.on('dashboard:modal-closed', this.hideAllPanels);
            this.uppy.on('complete', this.handleComplete);
            this.uppy.on('files-added', $b868dcf7a47332e3$var$_classPrivateFieldLooseBase(this, $b868dcf7a47332e3$var$_generateLargeThumbnailIfSingleFile)[$b868dcf7a47332e3$var$_generateLargeThumbnailIfSingleFile]);
            this.uppy.on('file-removed', $b868dcf7a47332e3$var$_classPrivateFieldLooseBase(this, $b868dcf7a47332e3$var$_generateLargeThumbnailIfSingleFile)[$b868dcf7a47332e3$var$_generateLargeThumbnailIfSingleFile]);
            // ___Why fire on capture?
            //    Because this.ifFocusedOnUppyRecently needs to change before onUpdate() fires.
            document.addEventListener('focus', this.recordIfFocusedOnUppyRecently, true);
            document.addEventListener('click', this.recordIfFocusedOnUppyRecently, true);
            if (this.opts.inline) this.el.addEventListener('keydown', this.handleKeyDownInInline);
            if (this.opts.autoOpen) this.uppy.on('files-added', $b868dcf7a47332e3$var$_classPrivateFieldLooseBase(this, $b868dcf7a47332e3$var$_openFileEditorWhenFilesAdded)[$b868dcf7a47332e3$var$_openFileEditorWhenFilesAdded]);
        };
        this.removeEvents = ()=>{
            const showModalTrigger = (0, $3da4efa7f88c23a6$export$2e2bcd8739ae039)(this.opts.trigger);
            if (!this.opts.inline && showModalTrigger) showModalTrigger.forEach((trigger)=>trigger.removeEventListener('click', this.openModal));
            this.stopListeningToResize();
            document.removeEventListener('paste', this.handlePasteOnBody);
            window.removeEventListener('popstate', this.handlePopState, false);
            this.uppy.off('plugin-added', $b868dcf7a47332e3$var$_classPrivateFieldLooseBase(this, $b868dcf7a47332e3$var$_addSupportedPluginIfNoTarget)[$b868dcf7a47332e3$var$_addSupportedPluginIfNoTarget]);
            this.uppy.off('plugin-remove', this.removeTarget);
            this.uppy.off('file-added', this.hideAllPanels);
            this.uppy.off('dashboard:modal-closed', this.hideAllPanels);
            this.uppy.off('complete', this.handleComplete);
            this.uppy.off('files-added', $b868dcf7a47332e3$var$_classPrivateFieldLooseBase(this, $b868dcf7a47332e3$var$_generateLargeThumbnailIfSingleFile)[$b868dcf7a47332e3$var$_generateLargeThumbnailIfSingleFile]);
            this.uppy.off('file-removed', $b868dcf7a47332e3$var$_classPrivateFieldLooseBase(this, $b868dcf7a47332e3$var$_generateLargeThumbnailIfSingleFile)[$b868dcf7a47332e3$var$_generateLargeThumbnailIfSingleFile]);
            document.removeEventListener('focus', this.recordIfFocusedOnUppyRecently);
            document.removeEventListener('click', this.recordIfFocusedOnUppyRecently);
            if (this.opts.inline) this.el.removeEventListener('keydown', this.handleKeyDownInInline);
            if (this.opts.autoOpen) this.uppy.off('files-added', $b868dcf7a47332e3$var$_classPrivateFieldLooseBase(this, $b868dcf7a47332e3$var$_openFileEditorWhenFilesAdded)[$b868dcf7a47332e3$var$_openFileEditorWhenFilesAdded]);
        };
        this.superFocusOnEachUpdate = ()=>{
            const isFocusInUppy = this.el.contains(document.activeElement);
            // When focus is lost on the page (== focus is on body for most browsers, or focus is null for IE11)
            const isFocusNowhere = document.activeElement === document.body || document.activeElement === null;
            const isInformerHidden = this.uppy.getState().info.length === 0;
            const isModal = !this.opts.inline;
            if (// If update is connected to showing the Informer - let the screen reader calmly read it.
            isInformerHidden && // If we are in a modal - always superfocus without concern for other elements
            // on the page (user is unlikely to want to interact with the rest of the page)
            (isModal || // If we are already inside of Uppy, or
            isFocusInUppy || // If we are not focused on anything BUT we have already, at least once, focused on uppy
            //   1. We focus when isFocusNowhere, because when the element we were focused
            //      on disappears (e.g. an overlay), - focus gets lost. If user is typing
            //      something somewhere else on the page, - focus won't be 'nowhere'.
            //   2. We only focus when focus is nowhere AND this.ifFocusedOnUppyRecently,
            //      to avoid focus jumps if we do something else on the page.
            //   [Practical check] Without '&& this.ifFocusedOnUppyRecently', in Safari, in inline mode,
            //                     when file is uploading, - navigate via tab to the checkbox,
            //                     try to press space multiple times. Focus will jump to Uppy.
            isFocusNowhere && this.ifFocusedOnUppyRecently)) this.superFocus(this.el, this.getPluginState().activeOverlayType);
            else this.superFocus.cancel();
        };
        this.afterUpdate = ()=>{
            if (this.opts.disabled && !this.dashboardIsDisabled) {
                this.disableInteractiveElements(true);
                return;
            }
            if (!this.opts.disabled && this.dashboardIsDisabled) this.disableInteractiveElements(false);
            this.superFocusOnEachUpdate();
        };
        this.saveFileCard = (meta, fileID)=>{
            this.uppy.setFileMeta(fileID, meta);
            this.toggleFileCard(false, fileID);
        };
        Object.defineProperty(this, $b868dcf7a47332e3$var$_attachRenderFunctionToTarget, {
            writable: true,
            value: (target)=>{
                const plugin = this.uppy.getPlugin(target.id);
                return {
                    ...target,
                    icon: plugin.icon || this.opts.defaultPickerIcon,
                    render: plugin.render
                };
            }
        });
        Object.defineProperty(this, $b868dcf7a47332e3$var$_isTargetSupported, {
            writable: true,
            value: (target)=>{
                const plugin = this.uppy.getPlugin(target.id);
                // If the plugin does not provide a `supported` check, assume the plugin works everywhere.
                if (typeof plugin.isSupported !== 'function') return true;
                return plugin.isSupported();
            }
        });
        Object.defineProperty(this, $b868dcf7a47332e3$var$_getAcquirers, {
            writable: true,
            value: $b868dcf7a47332e3$var$memoize((targets)=>{
                return targets.filter((target)=>target.type === 'acquirer' && $b868dcf7a47332e3$var$_classPrivateFieldLooseBase(this, $b868dcf7a47332e3$var$_isTargetSupported)[$b868dcf7a47332e3$var$_isTargetSupported](target)).map($b868dcf7a47332e3$var$_classPrivateFieldLooseBase(this, $b868dcf7a47332e3$var$_attachRenderFunctionToTarget)[$b868dcf7a47332e3$var$_attachRenderFunctionToTarget]);
            })
        });
        Object.defineProperty(this, $b868dcf7a47332e3$var$_getProgressIndicators, {
            writable: true,
            value: $b868dcf7a47332e3$var$memoize((targets)=>{
                return targets.filter((target)=>target.type === 'progressindicator').map($b868dcf7a47332e3$var$_classPrivateFieldLooseBase(this, $b868dcf7a47332e3$var$_attachRenderFunctionToTarget)[$b868dcf7a47332e3$var$_attachRenderFunctionToTarget]);
            })
        });
        Object.defineProperty(this, $b868dcf7a47332e3$var$_getEditors, {
            writable: true,
            value: $b868dcf7a47332e3$var$memoize((targets)=>{
                return targets.filter((target)=>target.type === 'editor').map($b868dcf7a47332e3$var$_classPrivateFieldLooseBase(this, $b868dcf7a47332e3$var$_attachRenderFunctionToTarget)[$b868dcf7a47332e3$var$_attachRenderFunctionToTarget]);
            })
        });
        this.render = (state)=>{
            const pluginState = this.getPluginState();
            const { files: files, capabilities: capabilities, allowNewUpload: allowNewUpload } = state;
            const { newFiles: newFiles, uploadStartedFiles: uploadStartedFiles, completeFiles: completeFiles, erroredFiles: erroredFiles, inProgressFiles: inProgressFiles, inProgressNotPausedFiles: inProgressNotPausedFiles, processingFiles: processingFiles, isUploadStarted: isUploadStarted, isAllComplete: isAllComplete, isAllErrored: isAllErrored, isAllPaused: isAllPaused } = this.uppy.getObjectOfFilesPerState();
            const acquirers = $b868dcf7a47332e3$var$_classPrivateFieldLooseBase(this, $b868dcf7a47332e3$var$_getAcquirers)[$b868dcf7a47332e3$var$_getAcquirers](pluginState.targets);
            const progressindicators = $b868dcf7a47332e3$var$_classPrivateFieldLooseBase(this, $b868dcf7a47332e3$var$_getProgressIndicators)[$b868dcf7a47332e3$var$_getProgressIndicators](pluginState.targets);
            const editors = $b868dcf7a47332e3$var$_classPrivateFieldLooseBase(this, $b868dcf7a47332e3$var$_getEditors)[$b868dcf7a47332e3$var$_getEditors](pluginState.targets);
            let theme;
            if (this.opts.theme === 'auto') theme = capabilities.darkMode ? 'dark' : 'light';
            else theme = this.opts.theme;
            if ([
                'files',
                'folders',
                'both'
            ].indexOf(this.opts.fileManagerSelectionType) < 0) {
                this.opts.fileManagerSelectionType = 'files';
                // eslint-disable-next-line no-console
                console.warn(`Unsupported option for "fileManagerSelectionType". Using default of "${this.opts.fileManagerSelectionType}".`);
            }
            return (0, $8dc96b7f61bbef1d$export$2e2bcd8739ae039)({
                state: state,
                isHidden: pluginState.isHidden,
                files: files,
                newFiles: newFiles,
                uploadStartedFiles: uploadStartedFiles,
                completeFiles: completeFiles,
                erroredFiles: erroredFiles,
                inProgressFiles: inProgressFiles,
                inProgressNotPausedFiles: inProgressNotPausedFiles,
                processingFiles: processingFiles,
                isUploadStarted: isUploadStarted,
                isAllComplete: isAllComplete,
                isAllErrored: isAllErrored,
                isAllPaused: isAllPaused,
                totalFileCount: Object.keys(files).length,
                totalProgress: state.totalProgress,
                allowNewUpload: allowNewUpload,
                acquirers: acquirers,
                theme: theme,
                disabled: this.opts.disabled,
                disableLocalFiles: this.opts.disableLocalFiles,
                direction: this.opts.direction,
                activePickerPanel: pluginState.activePickerPanel,
                showFileEditor: pluginState.showFileEditor,
                saveFileEditor: this.saveFileEditor,
                closeFileEditor: this.closeFileEditor,
                disableInteractiveElements: this.disableInteractiveElements,
                animateOpenClose: this.opts.animateOpenClose,
                isClosing: pluginState.isClosing,
                progressindicators: progressindicators,
                editors: editors,
                autoProceed: this.uppy.opts.autoProceed,
                id: this.id,
                closeModal: this.requestCloseModal,
                handleClickOutside: this.handleClickOutside,
                handleInputChange: this.handleInputChange,
                handlePaste: this.handlePaste,
                inline: this.opts.inline,
                showPanel: this.showPanel,
                hideAllPanels: this.hideAllPanels,
                i18n: this.i18n,
                i18nArray: this.i18nArray,
                uppy: this.uppy,
                note: this.opts.note,
                recoveredState: state.recoveredState,
                metaFields: pluginState.metaFields,
                resumableUploads: capabilities.resumableUploads || false,
                individualCancellation: capabilities.individualCancellation,
                isMobileDevice: capabilities.isMobileDevice,
                fileCardFor: pluginState.fileCardFor,
                toggleFileCard: this.toggleFileCard,
                toggleAddFilesPanel: this.toggleAddFilesPanel,
                showAddFilesPanel: pluginState.showAddFilesPanel,
                saveFileCard: this.saveFileCard,
                openFileEditor: this.openFileEditor,
                canEditFile: this.canEditFile,
                width: this.opts.width,
                height: this.opts.height,
                showLinkToFileUploadResult: this.opts.showLinkToFileUploadResult,
                fileManagerSelectionType: this.opts.fileManagerSelectionType,
                proudlyDisplayPoweredByUppy: this.opts.proudlyDisplayPoweredByUppy,
                hideCancelButton: this.opts.hideCancelButton,
                hideRetryButton: this.opts.hideRetryButton,
                hidePauseResumeButton: this.opts.hidePauseResumeButton,
                showRemoveButtonAfterComplete: this.opts.showRemoveButtonAfterComplete,
                containerWidth: pluginState.containerWidth,
                containerHeight: pluginState.containerHeight,
                areInsidesReadyToBeVisible: pluginState.areInsidesReadyToBeVisible,
                isTargetDOMEl: this.isTargetDOMEl,
                parentElement: this.el,
                allowedFileTypes: this.uppy.opts.restrictions.allowedFileTypes,
                maxNumberOfFiles: this.uppy.opts.restrictions.maxNumberOfFiles,
                requiredMetaFields: this.uppy.opts.restrictions.requiredMetaFields,
                showSelectedFiles: this.opts.showSelectedFiles,
                showNativePhotoCameraButton: this.opts.showNativePhotoCameraButton,
                showNativeVideoCameraButton: this.opts.showNativeVideoCameraButton,
                nativeCameraFacingMode: this.opts.nativeCameraFacingMode,
                singleFileFullScreen: this.opts.singleFileFullScreen,
                handleCancelRestore: this.handleCancelRestore,
                handleRequestThumbnail: this.handleRequestThumbnail,
                handleCancelThumbnail: this.handleCancelThumbnail,
                // drag props
                isDraggingOver: pluginState.isDraggingOver,
                handleDragOver: this.handleDragOver,
                handleDragLeave: this.handleDragLeave,
                handleDrop: this.handleDrop
            });
        };
        Object.defineProperty(this, $b868dcf7a47332e3$var$_addSpecifiedPluginsFromOptions, {
            writable: true,
            value: ()=>{
                const plugins = this.opts.plugins || [];
                plugins.forEach((pluginID)=>{
                    const plugin = this.uppy.getPlugin(pluginID);
                    if (plugin) plugin.mount(this, plugin);
                    else this.uppy.log(`[Uppy] Dashboard could not find plugin '${pluginID}', make sure to uppy.use() the plugins you are specifying`, 'warning');
                });
            }
        });
        Object.defineProperty(this, $b868dcf7a47332e3$var$_autoDiscoverPlugins, {
            writable: true,
            value: ()=>{
                this.uppy.iteratePlugins($b868dcf7a47332e3$var$_classPrivateFieldLooseBase(this, $b868dcf7a47332e3$var$_addSupportedPluginIfNoTarget)[$b868dcf7a47332e3$var$_addSupportedPluginIfNoTarget]);
            }
        });
        Object.defineProperty(this, $b868dcf7a47332e3$var$_addSupportedPluginIfNoTarget, {
            writable: true,
            value: (plugin)=>{
                var _plugin$opts;
                // Only these types belong on the Dashboard,
                // we wouldn’t want to try and mount Compressor or Tus, for example.
                const typesAllowed = [
                    'acquirer',
                    'editor'
                ];
                if (plugin && !((_plugin$opts = plugin.opts) != null && _plugin$opts.target) && typesAllowed.includes(plugin.type)) {
                    const pluginAlreadyAdded = this.getPluginState().targets.some((installedPlugin)=>plugin.id === installedPlugin.id);
                    if (!pluginAlreadyAdded) plugin.mount(this, plugin);
                }
            }
        });
        this.install = ()=>{
            // Set default state for Dashboard
            this.setPluginState({
                isHidden: true,
                fileCardFor: null,
                activeOverlayType: null,
                showAddFilesPanel: false,
                activePickerPanel: undefined,
                showFileEditor: false,
                metaFields: this.opts.metaFields,
                targets: [],
                // We'll make them visible once .containerWidth is determined
                areInsidesReadyToBeVisible: false,
                isDraggingOver: false
            });
            const { inline: inline, closeAfterFinish: closeAfterFinish } = this.opts;
            if (inline && closeAfterFinish) throw new Error('[Dashboard] `closeAfterFinish: true` cannot be used on an inline Dashboard, because an inline Dashboard cannot be closed at all. Either set `inline: false`, or disable the `closeAfterFinish` option.');
            const { allowMultipleUploads: allowMultipleUploads, allowMultipleUploadBatches: allowMultipleUploadBatches } = this.uppy.opts;
            if ((allowMultipleUploads || allowMultipleUploadBatches) && closeAfterFinish) this.uppy.log('[Dashboard] When using `closeAfterFinish`, we recommended setting the `allowMultipleUploadBatches` option to `false` in the Uppy constructor. See https://uppy.io/docs/uppy/#allowMultipleUploads-true', 'warning');
            const { target: target } = this.opts;
            if (target) this.mount(target, this);
            if (!this.opts.disableStatusBar) this.uppy.use((0, $f22a72e7b80fdb1a$export$2e2bcd8739ae039), {
                id: `${this.id}:StatusBar`,
                target: this,
                hideUploadButton: this.opts.hideUploadButton,
                hideRetryButton: this.opts.hideRetryButton,
                hidePauseResumeButton: this.opts.hidePauseResumeButton,
                hideCancelButton: this.opts.hideCancelButton,
                showProgressDetails: this.opts.showProgressDetails,
                hideAfterFinish: this.opts.hideProgressAfterFinish,
                locale: this.opts.locale,
                doneButtonHandler: this.opts.doneButtonHandler
            });
            if (!this.opts.disableInformer) this.uppy.use((0, $2d1e3e0d76faae78$export$2e2bcd8739ae039), {
                id: `${this.id}:Informer`,
                target: this
            });
            if (!this.opts.disableThumbnailGenerator) this.uppy.use((0, $f92c4ad36d89e394$export$2e2bcd8739ae039), {
                id: `${this.id}:ThumbnailGenerator`,
                thumbnailWidth: this.opts.thumbnailWidth,
                thumbnailHeight: this.opts.thumbnailHeight,
                thumbnailType: this.opts.thumbnailType,
                waitForThumbnailsBeforeUpload: this.opts.waitForThumbnailsBeforeUpload,
                // If we don't block on thumbnails, we can lazily generate them
                lazy: !this.opts.waitForThumbnailsBeforeUpload
            });
            // Dark Mode / theme
            this.darkModeMediaQuery = typeof window !== 'undefined' && window.matchMedia ? window.matchMedia('(prefers-color-scheme: dark)') : null;
            const isDarkModeOnFromTheStart = this.darkModeMediaQuery ? this.darkModeMediaQuery.matches : false;
            this.uppy.log(`[Dashboard] Dark mode is ${isDarkModeOnFromTheStart ? 'on' : 'off'}`);
            this.setDarkModeCapability(isDarkModeOnFromTheStart);
            if (this.opts.theme === 'auto') {
                var _this$darkModeMediaQu;
                (_this$darkModeMediaQu = this.darkModeMediaQuery) == null || _this$darkModeMediaQu.addListener(this.handleSystemDarkModeChange);
            }
            $b868dcf7a47332e3$var$_classPrivateFieldLooseBase(this, $b868dcf7a47332e3$var$_addSpecifiedPluginsFromOptions)[$b868dcf7a47332e3$var$_addSpecifiedPluginsFromOptions]();
            $b868dcf7a47332e3$var$_classPrivateFieldLooseBase(this, $b868dcf7a47332e3$var$_autoDiscoverPlugins)[$b868dcf7a47332e3$var$_autoDiscoverPlugins]();
            this.initEvents();
        };
        this.uninstall = ()=>{
            if (!this.opts.disableInformer) {
                const informer = this.uppy.getPlugin(`${this.id}:Informer`);
                // Checking if this plugin exists, in case it was removed by uppy-core
                // before the Dashboard was.
                if (informer) this.uppy.removePlugin(informer);
            }
            if (!this.opts.disableStatusBar) {
                const statusBar = this.uppy.getPlugin(`${this.id}:StatusBar`);
                if (statusBar) this.uppy.removePlugin(statusBar);
            }
            if (!this.opts.disableThumbnailGenerator) {
                const thumbnail = this.uppy.getPlugin(`${this.id}:ThumbnailGenerator`);
                if (thumbnail) this.uppy.removePlugin(thumbnail);
            }
            const plugins = this.opts.plugins || [];
            plugins.forEach((pluginID)=>{
                const plugin = this.uppy.getPlugin(pluginID);
                if (plugin) plugin.unmount();
            });
            if (this.opts.theme === 'auto') {
                var _this$darkModeMediaQu2;
                (_this$darkModeMediaQu2 = this.darkModeMediaQuery) == null || _this$darkModeMediaQu2.removeListener(this.handleSystemDarkModeChange);
            }
            if (this.opts.disablePageScrollWhenModalOpen) document.body.classList.remove('uppy-Dashboard-isFixed');
            this.unmount();
            this.removeEvents();
        };
        this.id = this.opts.id || 'Dashboard';
        this.title = 'Dashboard';
        this.type = 'orchestrator';
        this.defaultLocale = (0, $c4158ae05dd76b13$export$2e2bcd8739ae039);
        // Dynamic default options:
        if (this.opts.doneButtonHandler === undefined) // `null` means "do not display a Done button", while `undefined` means
        // "I want the default behavior". For this reason, we need to differentiate `null` and `undefined`.
        this.opts.doneButtonHandler = ()=>{
            this.uppy.clearUploadedFiles();
            this.requestCloseModal();
        };
        (_this$opts4$onRequest = (_this$opts4 = this.opts).onRequestCloseModal) != null ? _this$opts4$onRequest : _this$opts4.onRequestCloseModal = ()=>this.closeModal();
        this.i18nInit();
    }
}
$b868dcf7a47332e3$export$2e2bcd8739ae039.VERSION = $b868dcf7a47332e3$var$packageJson.version;





function $c89f32c7d05a95a3$var$_classPrivateFieldLooseBase(receiver, privateKey) {
    if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) throw new TypeError("attempted to use private field on non-instance");
    return receiver;
}
var $c89f32c7d05a95a3$var$id = 0;
function $c89f32c7d05a95a3$var$_classPrivateFieldLooseKey(name) {
    return "__private_" + $c89f32c7d05a95a3$var$id++ + "_" + name;
}
var $c89f32c7d05a95a3$var$_uppy = /*#__PURE__*/ $c89f32c7d05a95a3$var$_classPrivateFieldLooseKey("uppy");
var $c89f32c7d05a95a3$var$_events = /*#__PURE__*/ $c89f32c7d05a95a3$var$_classPrivateFieldLooseKey("events");
class $c89f32c7d05a95a3$export$2e2bcd8739ae039 {
    constructor(uppy){
        Object.defineProperty(this, $c89f32c7d05a95a3$var$_uppy, {
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, $c89f32c7d05a95a3$var$_events, {
            writable: true,
            value: []
        });
        $c89f32c7d05a95a3$var$_classPrivateFieldLooseBase(this, $c89f32c7d05a95a3$var$_uppy)[$c89f32c7d05a95a3$var$_uppy] = uppy;
    }
    /** @deprecated */ on(event, fn) {
        $c89f32c7d05a95a3$var$_classPrivateFieldLooseBase(this, $c89f32c7d05a95a3$var$_events)[$c89f32c7d05a95a3$var$_events].push([
            event,
            fn
        ]);
        return $c89f32c7d05a95a3$var$_classPrivateFieldLooseBase(this, $c89f32c7d05a95a3$var$_uppy)[$c89f32c7d05a95a3$var$_uppy].on(event, fn);
    }
    remove() {
        for (const [event, fn] of $c89f32c7d05a95a3$var$_classPrivateFieldLooseBase(this, $c89f32c7d05a95a3$var$_events)[$c89f32c7d05a95a3$var$_events].splice(0))$c89f32c7d05a95a3$var$_classPrivateFieldLooseBase(this, $c89f32c7d05a95a3$var$_uppy)[$c89f32c7d05a95a3$var$_uppy].off(event, fn);
    }
    onFilePause(fileID, cb) {
        this.on('upload-pause', (targetFileID, isPaused)=>{
            if (fileID === targetFileID) cb(isPaused);
        });
    }
    onFileRemove(fileID, cb) {
        this.on('file-removed', (file)=>{
            if (fileID === file.id) cb(file.id);
        });
    }
    onPause(fileID, cb) {
        this.on('upload-pause', (targetFileID, isPaused)=>{
            if (fileID === targetFileID) // const isPaused = this.#uppy.pauseResume(fileID)
            cb(isPaused);
        });
    }
    onRetry(fileID, cb) {
        this.on('upload-retry', (targetFileID)=>{
            if (fileID === targetFileID) cb();
        });
    }
    onRetryAll(fileID, cb) {
        this.on('retry-all', ()=>{
            if (!$c89f32c7d05a95a3$var$_classPrivateFieldLooseBase(this, $c89f32c7d05a95a3$var$_uppy)[$c89f32c7d05a95a3$var$_uppy].getFile(fileID)) return;
            cb();
        });
    }
    onPauseAll(fileID, cb) {
        this.on('pause-all', ()=>{
            if (!$c89f32c7d05a95a3$var$_classPrivateFieldLooseBase(this, $c89f32c7d05a95a3$var$_uppy)[$c89f32c7d05a95a3$var$_uppy].getFile(fileID)) return;
            cb();
        });
    }
    onCancelAll(fileID, eventHandler) {
        var _this = this;
        this.on('cancel-all', function() {
            if (!$c89f32c7d05a95a3$var$_classPrivateFieldLooseBase(_this, $c89f32c7d05a95a3$var$_uppy)[$c89f32c7d05a95a3$var$_uppy].getFile(fileID)) return;
            eventHandler(...arguments);
        });
    }
    onResumeAll(fileID, cb) {
        this.on('resume-all', ()=>{
            if (!$c89f32c7d05a95a3$var$_classPrivateFieldLooseBase(this, $c89f32c7d05a95a3$var$_uppy)[$c89f32c7d05a95a3$var$_uppy].getFile(fileID)) return;
            cb();
        });
    }
}


function $6cb886e1a5aec334$var$_classPrivateFieldLooseBase(receiver, privateKey) {
    if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) throw new TypeError("attempted to use private field on non-instance");
    return receiver;
}
var $6cb886e1a5aec334$var$id = 0;
function $6cb886e1a5aec334$var$_classPrivateFieldLooseKey(name) {
    return "__private_" + $6cb886e1a5aec334$var$id++ + "_" + name;
}
function $6cb886e1a5aec334$var$createCancelError(cause) {
    return new Error('Cancelled', {
        cause: cause
    });
}
function $6cb886e1a5aec334$var$abortOn(signal) {
    if (signal != null) {
        var _this$then;
        const abortPromise = ()=>this.abort(signal.reason);
        signal.addEventListener('abort', abortPromise, {
            once: true
        });
        const removeAbortListener = ()=>{
            signal.removeEventListener('abort', abortPromise);
        };
        (_this$then = this.then) == null || _this$then.call(this, removeAbortListener, removeAbortListener);
    }
    return this;
}
var $6cb886e1a5aec334$var$_activeRequests = /*#__PURE__*/ $6cb886e1a5aec334$var$_classPrivateFieldLooseKey("activeRequests");
var $6cb886e1a5aec334$var$_queuedHandlers = /*#__PURE__*/ $6cb886e1a5aec334$var$_classPrivateFieldLooseKey("queuedHandlers");
var $6cb886e1a5aec334$var$_paused = /*#__PURE__*/ $6cb886e1a5aec334$var$_classPrivateFieldLooseKey("paused");
var $6cb886e1a5aec334$var$_pauseTimer = /*#__PURE__*/ $6cb886e1a5aec334$var$_classPrivateFieldLooseKey("pauseTimer");
var $6cb886e1a5aec334$var$_downLimit = /*#__PURE__*/ $6cb886e1a5aec334$var$_classPrivateFieldLooseKey("downLimit");
var $6cb886e1a5aec334$var$_upperLimit = /*#__PURE__*/ $6cb886e1a5aec334$var$_classPrivateFieldLooseKey("upperLimit");
var $6cb886e1a5aec334$var$_rateLimitingTimer = /*#__PURE__*/ $6cb886e1a5aec334$var$_classPrivateFieldLooseKey("rateLimitingTimer");
var $6cb886e1a5aec334$var$_call = /*#__PURE__*/ $6cb886e1a5aec334$var$_classPrivateFieldLooseKey("call");
var $6cb886e1a5aec334$var$_queueNext = /*#__PURE__*/ $6cb886e1a5aec334$var$_classPrivateFieldLooseKey("queueNext");
var $6cb886e1a5aec334$var$_next = /*#__PURE__*/ $6cb886e1a5aec334$var$_classPrivateFieldLooseKey("next");
var $6cb886e1a5aec334$var$_queue = /*#__PURE__*/ $6cb886e1a5aec334$var$_classPrivateFieldLooseKey("queue");
var $6cb886e1a5aec334$var$_dequeue = /*#__PURE__*/ $6cb886e1a5aec334$var$_classPrivateFieldLooseKey("dequeue");
var $6cb886e1a5aec334$var$_resume = /*#__PURE__*/ $6cb886e1a5aec334$var$_classPrivateFieldLooseKey("resume");
var $6cb886e1a5aec334$var$_increaseLimit = /*#__PURE__*/ $6cb886e1a5aec334$var$_classPrivateFieldLooseKey("increaseLimit");
class $6cb886e1a5aec334$export$32306e81289653bc {
    constructor(limit){
        Object.defineProperty(this, $6cb886e1a5aec334$var$_dequeue, {
            value: $6cb886e1a5aec334$var$_dequeue2
        });
        Object.defineProperty(this, $6cb886e1a5aec334$var$_queue, {
            value: $6cb886e1a5aec334$var$_queue2
        });
        Object.defineProperty(this, $6cb886e1a5aec334$var$_next, {
            value: $6cb886e1a5aec334$var$_next2
        });
        Object.defineProperty(this, $6cb886e1a5aec334$var$_queueNext, {
            value: $6cb886e1a5aec334$var$_queueNext2
        });
        Object.defineProperty(this, $6cb886e1a5aec334$var$_call, {
            value: $6cb886e1a5aec334$var$_call2
        });
        Object.defineProperty(this, $6cb886e1a5aec334$var$_activeRequests, {
            writable: true,
            value: 0
        });
        Object.defineProperty(this, $6cb886e1a5aec334$var$_queuedHandlers, {
            writable: true,
            value: []
        });
        Object.defineProperty(this, $6cb886e1a5aec334$var$_paused, {
            writable: true,
            value: false
        });
        Object.defineProperty(this, $6cb886e1a5aec334$var$_pauseTimer, {
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, $6cb886e1a5aec334$var$_downLimit, {
            writable: true,
            value: 1
        });
        Object.defineProperty(this, $6cb886e1a5aec334$var$_upperLimit, {
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, $6cb886e1a5aec334$var$_rateLimitingTimer, {
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, $6cb886e1a5aec334$var$_resume, {
            writable: true,
            value: ()=>this.resume()
        });
        Object.defineProperty(this, $6cb886e1a5aec334$var$_increaseLimit, {
            writable: true,
            value: ()=>{
                if ($6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_paused)[$6cb886e1a5aec334$var$_paused]) {
                    $6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_rateLimitingTimer)[$6cb886e1a5aec334$var$_rateLimitingTimer] = setTimeout($6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_increaseLimit)[$6cb886e1a5aec334$var$_increaseLimit], 0);
                    return;
                }
                $6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_downLimit)[$6cb886e1a5aec334$var$_downLimit] = this.limit;
                this.limit = Math.ceil(($6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_upperLimit)[$6cb886e1a5aec334$var$_upperLimit] + $6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_downLimit)[$6cb886e1a5aec334$var$_downLimit]) / 2);
                for(let i = $6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_downLimit)[$6cb886e1a5aec334$var$_downLimit]; i <= this.limit; i++)$6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_queueNext)[$6cb886e1a5aec334$var$_queueNext]();
                if ($6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_upperLimit)[$6cb886e1a5aec334$var$_upperLimit] - $6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_downLimit)[$6cb886e1a5aec334$var$_downLimit] > 3) $6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_rateLimitingTimer)[$6cb886e1a5aec334$var$_rateLimitingTimer] = setTimeout($6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_increaseLimit)[$6cb886e1a5aec334$var$_increaseLimit], 2000);
                else $6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_downLimit)[$6cb886e1a5aec334$var$_downLimit] = Math.floor($6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_downLimit)[$6cb886e1a5aec334$var$_downLimit] / 2);
            }
        });
        if (typeof limit !== 'number' || limit === 0) this.limit = Infinity;
        else this.limit = limit;
    }
    run(fn, queueOptions) {
        if (!$6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_paused)[$6cb886e1a5aec334$var$_paused] && $6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_activeRequests)[$6cb886e1a5aec334$var$_activeRequests] < this.limit) return $6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_call)[$6cb886e1a5aec334$var$_call](fn);
        return $6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_queue)[$6cb886e1a5aec334$var$_queue](fn, queueOptions);
    }
    wrapSyncFunction(fn, queueOptions) {
        var _this = this;
        return function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            const queuedRequest = _this.run(()=>{
                fn(...args);
                queueMicrotask(()=>queuedRequest.done());
                return ()=>{};
            }, queueOptions);
            return {
                abortOn: $6cb886e1a5aec334$var$abortOn,
                abort () {
                    queuedRequest.abort();
                }
            };
        };
    }
    wrapPromiseFunction(fn, queueOptions) {
        var _this2 = this;
        return function() {
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            let queuedRequest;
            const outerPromise = new Promise((resolve, reject)=>{
                queuedRequest = _this2.run(()=>{
                    let cancelError;
                    let innerPromise;
                    try {
                        innerPromise = Promise.resolve(fn(...args));
                    } catch (err) {
                        innerPromise = Promise.reject(err);
                    }
                    innerPromise.then((result)=>{
                        if (cancelError) reject(cancelError);
                        else {
                            queuedRequest.done();
                            resolve(result);
                        }
                    }, (err)=>{
                        if (cancelError) reject(cancelError);
                        else {
                            queuedRequest.done();
                            reject(err);
                        }
                    });
                    return (cause)=>{
                        cancelError = $6cb886e1a5aec334$var$createCancelError(cause);
                    };
                }, queueOptions);
            });
            outerPromise.abort = (cause)=>{
                queuedRequest.abort(cause);
            };
            outerPromise.abortOn = $6cb886e1a5aec334$var$abortOn;
            return outerPromise;
        };
    }
    resume() {
        $6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_paused)[$6cb886e1a5aec334$var$_paused] = false;
        clearTimeout($6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_pauseTimer)[$6cb886e1a5aec334$var$_pauseTimer]);
        for(let i = 0; i < this.limit; i++)$6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_queueNext)[$6cb886e1a5aec334$var$_queueNext]();
    }
    /**
   * Freezes the queue for a while or indefinitely.
   *
   * @param {number | null } [duration] Duration for the pause to happen, in milliseconds.
   *                                    If omitted, the queue won't resume automatically.
   */ pause(duration) {
        if (duration === void 0) duration = null;
        $6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_paused)[$6cb886e1a5aec334$var$_paused] = true;
        clearTimeout($6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_pauseTimer)[$6cb886e1a5aec334$var$_pauseTimer]);
        if (duration != null) $6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_pauseTimer)[$6cb886e1a5aec334$var$_pauseTimer] = setTimeout($6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_resume)[$6cb886e1a5aec334$var$_resume], duration);
    }
    /**
   * Pauses the queue for a duration, and lower the limit of concurrent requests
   * when the queue resumes. When the queue resumes, it tries to progressively
   * increase the limit in `this.#increaseLimit` until another call is made to
   * `this.rateLimit`.
   * Call this function when using the RateLimitedQueue for network requests and
   * the remote server responds with 429 HTTP code.
   *
   * @param {number} duration in milliseconds.
   */ rateLimit(duration) {
        clearTimeout($6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_rateLimitingTimer)[$6cb886e1a5aec334$var$_rateLimitingTimer]);
        this.pause(duration);
        if (this.limit > 1 && Number.isFinite(this.limit)) {
            $6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_upperLimit)[$6cb886e1a5aec334$var$_upperLimit] = this.limit - 1;
            this.limit = $6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_downLimit)[$6cb886e1a5aec334$var$_downLimit];
            $6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_rateLimitingTimer)[$6cb886e1a5aec334$var$_rateLimitingTimer] = setTimeout($6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_increaseLimit)[$6cb886e1a5aec334$var$_increaseLimit], duration);
        }
    }
    get isPaused() {
        return $6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_paused)[$6cb886e1a5aec334$var$_paused];
    }
}
function $6cb886e1a5aec334$var$_call2(fn) {
    $6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_activeRequests)[$6cb886e1a5aec334$var$_activeRequests] += 1;
    let done = false;
    let cancelActive;
    try {
        cancelActive = fn();
    } catch (err) {
        $6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_activeRequests)[$6cb886e1a5aec334$var$_activeRequests] -= 1;
        throw err;
    }
    return {
        abort: (cause)=>{
            if (done) return;
            done = true;
            $6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_activeRequests)[$6cb886e1a5aec334$var$_activeRequests] -= 1;
            cancelActive == null || cancelActive(cause);
            $6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_queueNext)[$6cb886e1a5aec334$var$_queueNext]();
        },
        done: ()=>{
            if (done) return;
            done = true;
            $6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_activeRequests)[$6cb886e1a5aec334$var$_activeRequests] -= 1;
            $6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_queueNext)[$6cb886e1a5aec334$var$_queueNext]();
        }
    };
}
function $6cb886e1a5aec334$var$_queueNext2() {
    // Do it soon but not immediately, this allows clearing out the entire queue synchronously
    // one by one without continuously _advancing_ it (and starting new tasks before immediately
    // aborting them)
    queueMicrotask(()=>$6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_next)[$6cb886e1a5aec334$var$_next]());
}
function $6cb886e1a5aec334$var$_next2() {
    if ($6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_paused)[$6cb886e1a5aec334$var$_paused] || $6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_activeRequests)[$6cb886e1a5aec334$var$_activeRequests] >= this.limit) return;
    if ($6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_queuedHandlers)[$6cb886e1a5aec334$var$_queuedHandlers].length === 0) return;
    // Dispatch the next request, and update the abort/done handlers
    // so that cancelling it does the Right Thing (and doesn't just try
    // to dequeue an already-running request).
    const next = $6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_queuedHandlers)[$6cb886e1a5aec334$var$_queuedHandlers].shift();
    if (next == null) throw new Error('Invariant violation: next is null');
    const handler = $6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_call)[$6cb886e1a5aec334$var$_call](next.fn);
    next.abort = handler.abort;
    next.done = handler.done;
}
function $6cb886e1a5aec334$var$_queue2(fn, options) {
    const handler = {
        fn: fn,
        priority: (options == null ? void 0 : options.priority) || 0,
        abort: ()=>{
            $6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_dequeue)[$6cb886e1a5aec334$var$_dequeue](handler);
        },
        done: ()=>{
            throw new Error('Cannot mark a queued request as done: this indicates a bug');
        }
    };
    const index = $6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_queuedHandlers)[$6cb886e1a5aec334$var$_queuedHandlers].findIndex((other)=>{
        return handler.priority > other.priority;
    });
    if (index === -1) $6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_queuedHandlers)[$6cb886e1a5aec334$var$_queuedHandlers].push(handler);
    else $6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_queuedHandlers)[$6cb886e1a5aec334$var$_queuedHandlers].splice(index, 0, handler);
    return handler;
}
function $6cb886e1a5aec334$var$_dequeue2(handler) {
    const index = $6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_queuedHandlers)[$6cb886e1a5aec334$var$_queuedHandlers].indexOf(handler);
    if (index !== -1) $6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_queuedHandlers)[$6cb886e1a5aec334$var$_queuedHandlers].splice(index, 1);
}
const $6cb886e1a5aec334$export$603eb9c93e04437 = Symbol('__queue');


class $0026c55df46f9934$var$NetworkError extends Error {
    constructor(error, xhr){
        if (xhr === void 0) xhr = null;
        super(`This looks like a network error, the endpoint might be blocked by an internet provider or a firewall.`);
        this.cause = error;
        this.isNetworkError = true;
        this.request = xhr;
    }
}
var $0026c55df46f9934$export$2e2bcd8739ae039 = $0026c55df46f9934$var$NetworkError;


function $404d4d8ff4ce3ae1$var$isNetworkError(xhr) {
    if (!xhr) return false;
    return xhr.readyState !== 0 && xhr.readyState !== 4 || xhr.status === 0;
}
var $404d4d8ff4ce3ae1$export$2e2bcd8739ae039 = $404d4d8ff4ce3ae1$var$isNetworkError;



function $c8d4b79cf5a3269c$var$_classPrivateFieldLooseBase(receiver, privateKey) {
    if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) throw new TypeError("attempted to use private field on non-instance");
    return receiver;
}
var $c8d4b79cf5a3269c$var$id = 0;
function $c8d4b79cf5a3269c$var$_classPrivateFieldLooseKey(name) {
    return "__private_" + $c8d4b79cf5a3269c$var$id++ + "_" + name;
}
var $c8d4b79cf5a3269c$var$_aliveTimer = /*#__PURE__*/ $c8d4b79cf5a3269c$var$_classPrivateFieldLooseKey("aliveTimer");
var $c8d4b79cf5a3269c$var$_isDone = /*#__PURE__*/ $c8d4b79cf5a3269c$var$_classPrivateFieldLooseKey("isDone");
var $c8d4b79cf5a3269c$var$_onTimedOut = /*#__PURE__*/ $c8d4b79cf5a3269c$var$_classPrivateFieldLooseKey("onTimedOut");
var $c8d4b79cf5a3269c$var$_timeout = /*#__PURE__*/ $c8d4b79cf5a3269c$var$_classPrivateFieldLooseKey("timeout");
/**
 * Helper to abort upload requests if there has not been any progress for `timeout` ms.
 * Create an instance using `timer = new ProgressTimeout(10000, onTimeout)`
 * Call `timer.progress()` to signal that there has been progress of any kind.
 * Call `timer.done()` when the upload has completed.
 */ class $c8d4b79cf5a3269c$var$ProgressTimeout {
    constructor(timeout, // eslint-disable-next-line no-shadow
    timeoutHandler){
        Object.defineProperty(this, $c8d4b79cf5a3269c$var$_aliveTimer, {
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, $c8d4b79cf5a3269c$var$_isDone, {
            writable: true,
            value: false
        });
        Object.defineProperty(this, $c8d4b79cf5a3269c$var$_onTimedOut, {
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, $c8d4b79cf5a3269c$var$_timeout, {
            writable: true,
            value: void 0
        });
        $c8d4b79cf5a3269c$var$_classPrivateFieldLooseBase(this, $c8d4b79cf5a3269c$var$_timeout)[$c8d4b79cf5a3269c$var$_timeout] = timeout;
        $c8d4b79cf5a3269c$var$_classPrivateFieldLooseBase(this, $c8d4b79cf5a3269c$var$_onTimedOut)[$c8d4b79cf5a3269c$var$_onTimedOut] = ()=>timeoutHandler(timeout);
    }
    progress() {
        // Some browsers fire another progress event when the upload is
        // cancelled, so we have to ignore progress after the timer was
        // told to stop.
        if ($c8d4b79cf5a3269c$var$_classPrivateFieldLooseBase(this, $c8d4b79cf5a3269c$var$_isDone)[$c8d4b79cf5a3269c$var$_isDone]) return;
        if ($c8d4b79cf5a3269c$var$_classPrivateFieldLooseBase(this, $c8d4b79cf5a3269c$var$_timeout)[$c8d4b79cf5a3269c$var$_timeout] > 0) {
            clearTimeout($c8d4b79cf5a3269c$var$_classPrivateFieldLooseBase(this, $c8d4b79cf5a3269c$var$_aliveTimer)[$c8d4b79cf5a3269c$var$_aliveTimer]);
            $c8d4b79cf5a3269c$var$_classPrivateFieldLooseBase(this, $c8d4b79cf5a3269c$var$_aliveTimer)[$c8d4b79cf5a3269c$var$_aliveTimer] = setTimeout($c8d4b79cf5a3269c$var$_classPrivateFieldLooseBase(this, $c8d4b79cf5a3269c$var$_onTimedOut)[$c8d4b79cf5a3269c$var$_onTimedOut], $c8d4b79cf5a3269c$var$_classPrivateFieldLooseBase(this, $c8d4b79cf5a3269c$var$_timeout)[$c8d4b79cf5a3269c$var$_timeout]);
        }
    }
    done() {
        if (!$c8d4b79cf5a3269c$var$_classPrivateFieldLooseBase(this, $c8d4b79cf5a3269c$var$_isDone)[$c8d4b79cf5a3269c$var$_isDone]) {
            clearTimeout($c8d4b79cf5a3269c$var$_classPrivateFieldLooseBase(this, $c8d4b79cf5a3269c$var$_aliveTimer)[$c8d4b79cf5a3269c$var$_aliveTimer]);
            $c8d4b79cf5a3269c$var$_classPrivateFieldLooseBase(this, $c8d4b79cf5a3269c$var$_aliveTimer)[$c8d4b79cf5a3269c$var$_aliveTimer] = undefined;
            $c8d4b79cf5a3269c$var$_classPrivateFieldLooseBase(this, $c8d4b79cf5a3269c$var$_isDone)[$c8d4b79cf5a3269c$var$_isDone] = true;
        }
    }
}
var $c8d4b79cf5a3269c$export$2e2bcd8739ae039 = $c8d4b79cf5a3269c$var$ProgressTimeout;


const $e3981d1185f67d50$var$noop = ()=>{};
function $e3981d1185f67d50$export$47fdd40111eda34c(url, options) {
    if (options === void 0) options = {};
    const { body: body = null, headers: headers = {}, method: method = 'GET', onBeforeRequest: onBeforeRequest = $e3981d1185f67d50$var$noop, onUploadProgress: onUploadProgress = $e3981d1185f67d50$var$noop, shouldRetry: shouldRetry = ()=>true, onAfterRequest: onAfterRequest = $e3981d1185f67d50$var$noop, onTimeout: onTimeout = $e3981d1185f67d50$var$noop, responseType: responseType, retries: retries = 3, signal: signal = null, timeout: timeout = 30000, withCredentials: withCredentials = false } = options;
    // 300 ms, 600 ms, 1200 ms, 2400 ms, 4800 ms
    const delay = (attempt)=>0.3 * 2 ** (attempt - 1) * 1000;
    const timer = new (0, $c8d4b79cf5a3269c$export$2e2bcd8739ae039)(timeout, onTimeout);
    function requestWithRetry(retryCount) {
        if (retryCount === void 0) retryCount = 0;
        // eslint-disable-next-line no-async-promise-executor
        return new Promise(async (resolve, reject)=>{
            const xhr = new XMLHttpRequest();
            xhr.open(method, url, true);
            xhr.withCredentials = withCredentials;
            if (responseType) xhr.responseType = responseType;
            signal == null || signal.addEventListener('abort', ()=>{
                xhr.abort();
                // Using DOMException for abort errors aligns with
                // the convention established by the Fetch API.
                reject(new DOMException('Aborted', 'AbortError'));
            });
            xhr.onload = async ()=>{
                await onAfterRequest(xhr, retryCount);
                if (xhr.status >= 200 && xhr.status < 300) {
                    timer.done();
                    resolve(xhr);
                } else if (shouldRetry(xhr) && retryCount < retries) setTimeout(()=>{
                    requestWithRetry(retryCount + 1).then(resolve, reject);
                }, delay(retryCount));
                else {
                    timer.done();
                    reject(new (0, $0026c55df46f9934$export$2e2bcd8739ae039)(xhr.statusText, xhr));
                }
            };
            xhr.onerror = ()=>{
                if (shouldRetry(xhr) && retryCount < retries) setTimeout(()=>{
                    requestWithRetry(retryCount + 1).then(resolve, reject);
                }, delay(retryCount));
                else {
                    timer.done();
                    reject(new (0, $0026c55df46f9934$export$2e2bcd8739ae039)(xhr.statusText, xhr));
                }
            };
            xhr.upload.onprogress = (event)=>{
                timer.progress();
                onUploadProgress(event);
            };
            if (headers) Object.keys(headers).forEach((key)=>{
                xhr.setRequestHeader(key, headers[key]);
            });
            await onBeforeRequest(xhr, retryCount);
            xhr.send(body);
        });
    }
    return requestWithRetry();
}


function $169d20dd56f976c7$export$3bd9b1601aad11ac(files) {
    const hasError = (file)=>'error' in file && !!file.error;
    return files.filter((file)=>!hasError(file));
}
function $169d20dd56f976c7$export$9e8ffa0bfbcfeed6(files) {
    return files.filter((file)=>{
        var _file$progress;
        return !((_file$progress = file.progress) != null && _file$progress.uploadStarted) || !file.isRestored;
    });
}


var $3b2facc875d4722d$export$2e2bcd8739ae039 = {
    strings: {
        // Shown in the Informer if an upload is being canceled because it stalled for too long.
        uploadStalled: 'Upload has not made any progress for %{seconds} seconds. You may want to retry it.'
    }
};


function $cf91058fd9d7f8ee$var$_classPrivateFieldLooseBase(receiver, privateKey) {
    if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) throw new TypeError("attempted to use private field on non-instance");
    return receiver;
}
var $cf91058fd9d7f8ee$var$id = 0;
function $cf91058fd9d7f8ee$var$_classPrivateFieldLooseKey(name) {
    return "__private_" + $cf91058fd9d7f8ee$var$id++ + "_" + name;
}
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore We don't want TS to generate types for the package.json
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore We don't want TS to generate types for the package.json
const $cf91058fd9d7f8ee$var$packageJson = {
    "version": "3.6.8"
};
function $cf91058fd9d7f8ee$var$buildResponseError(xhr, err) {
    let error = err;
    // No error message
    if (!error) error = new Error('Upload error');
    // Got an error message string
    if (typeof error === 'string') error = new Error(error);
    // Got something else
    if (!(error instanceof Error)) error = Object.assign(new Error('Upload error'), {
        data: error
    });
    if ((0, $404d4d8ff4ce3ae1$export$2e2bcd8739ae039)(xhr)) {
        error = new (0, $0026c55df46f9934$export$2e2bcd8739ae039)(error, xhr);
        return error;
    }
    // @ts-expect-error request can only be set on NetworkError
    // but we use NetworkError to distinguish between errors.
    error.request = xhr;
    return error;
}
/**
 * Set `data.type` in the blob to `file.meta.type`,
 * because we might have detected a more accurate file type in Uppy
 * https://stackoverflow.com/a/50875615
 */ function $cf91058fd9d7f8ee$var$setTypeInBlob(file) {
    const dataWithUpdatedType = file.data.slice(0, file.data.size, file.meta.type);
    return dataWithUpdatedType;
}
const $cf91058fd9d7f8ee$var$defaultOptions = {
    formData: true,
    fieldName: 'file',
    method: 'post',
    allowedMetaFields: null,
    responseUrlFieldName: 'url',
    bundle: false,
    headers: {},
    timeout: 30000,
    limit: 5,
    withCredentials: false,
    responseType: '',
    getResponseData (responseText) {
        let parsedResponse = {};
        try {
            parsedResponse = JSON.parse(responseText);
        } catch  {
        // ignore
        }
        // We don't have access to the B (Body) generic here
        // so we have to cast it to any. The user facing types
        // remain correct, this is only to please the merging of default options.
        return parsedResponse;
    },
    getResponseError (_, response) {
        let error = new Error('Upload error');
        if ((0, $404d4d8ff4ce3ae1$export$2e2bcd8739ae039)(response)) error = new (0, $0026c55df46f9934$export$2e2bcd8739ae039)(error, response);
        return error;
    },
    validateStatus (status) {
        return status >= 200 && status < 300;
    }
};
var $cf91058fd9d7f8ee$var$_getFetcher = /*#__PURE__*/ $cf91058fd9d7f8ee$var$_classPrivateFieldLooseKey("getFetcher");
var $cf91058fd9d7f8ee$var$_uploadLocalFile = /*#__PURE__*/ $cf91058fd9d7f8ee$var$_classPrivateFieldLooseKey("uploadLocalFile");
var $cf91058fd9d7f8ee$var$_uploadBundle = /*#__PURE__*/ $cf91058fd9d7f8ee$var$_classPrivateFieldLooseKey("uploadBundle");
var $cf91058fd9d7f8ee$var$_getCompanionClientArgs = /*#__PURE__*/ $cf91058fd9d7f8ee$var$_classPrivateFieldLooseKey("getCompanionClientArgs");
var $cf91058fd9d7f8ee$var$_uploadFiles = /*#__PURE__*/ $cf91058fd9d7f8ee$var$_classPrivateFieldLooseKey("uploadFiles");
var $cf91058fd9d7f8ee$var$_handleUpload = /*#__PURE__*/ $cf91058fd9d7f8ee$var$_classPrivateFieldLooseKey("handleUpload");
class $cf91058fd9d7f8ee$export$2e2bcd8739ae039 extends (0, $336df15d01030489$export$2e2bcd8739ae039) {
    constructor(uppy, _opts){
        super(uppy, {
            ...$cf91058fd9d7f8ee$var$defaultOptions,
            fieldName: _opts.bundle ? 'files[]' : 'file',
            ..._opts
        });
        Object.defineProperty(this, $cf91058fd9d7f8ee$var$_uploadFiles, {
            value: $cf91058fd9d7f8ee$var$_uploadFiles2
        });
        Object.defineProperty(this, $cf91058fd9d7f8ee$var$_getCompanionClientArgs, {
            value: $cf91058fd9d7f8ee$var$_getCompanionClientArgs2
        });
        Object.defineProperty(this, $cf91058fd9d7f8ee$var$_uploadBundle, {
            value: $cf91058fd9d7f8ee$var$_uploadBundle2
        });
        Object.defineProperty(this, $cf91058fd9d7f8ee$var$_uploadLocalFile, {
            value: $cf91058fd9d7f8ee$var$_uploadLocalFile2
        });
        Object.defineProperty(this, $cf91058fd9d7f8ee$var$_getFetcher, {
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, $cf91058fd9d7f8ee$var$_handleUpload, {
            writable: true,
            value: async (fileIDs)=>{
                if (fileIDs.length === 0) {
                    this.uppy.log('[XHRUpload] No files to upload!');
                    return;
                }
                // No limit configured by the user, and no RateLimitedQueue passed in by a "parent" plugin
                // (basically just AwsS3) using the internal symbol
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore untyped internal
                if (this.opts.limit === 0 && !this.opts[0, $6cb886e1a5aec334$export$603eb9c93e04437]) this.uppy.log('[XHRUpload] When uploading multiple files at once, consider setting the `limit` option (to `10` for example), to limit the number of concurrent uploads, which helps prevent memory and network issues: https://uppy.io/docs/xhr-upload/#limit-0', 'warning');
                this.uppy.log('[XHRUpload] Uploading...');
                const files = this.uppy.getFilesByIds(fileIDs);
                const filesFiltered = (0, $169d20dd56f976c7$export$3bd9b1601aad11ac)(files);
                const filesToEmit = (0, $169d20dd56f976c7$export$9e8ffa0bfbcfeed6)(filesFiltered);
                this.uppy.emit('upload-start', filesToEmit);
                if (this.opts.bundle) {
                    // if bundle: true, we don’t support remote uploads
                    const isSomeFileRemote = filesFiltered.some((file)=>file.isRemote);
                    if (isSomeFileRemote) throw new Error("Can\u2019t upload remote files when the `bundle: true` option is set");
                    if (typeof this.opts.headers === 'function') throw new TypeError('`headers` may not be a function when the `bundle: true` option is set');
                    await $cf91058fd9d7f8ee$var$_classPrivateFieldLooseBase(this, $cf91058fd9d7f8ee$var$_uploadBundle)[$cf91058fd9d7f8ee$var$_uploadBundle](filesFiltered);
                } else await $cf91058fd9d7f8ee$var$_classPrivateFieldLooseBase(this, $cf91058fd9d7f8ee$var$_uploadFiles)[$cf91058fd9d7f8ee$var$_uploadFiles](filesFiltered);
            }
        });
        this.type = 'uploader';
        this.id = this.opts.id || 'XHRUpload';
        this.defaultLocale = (0, $3b2facc875d4722d$export$2e2bcd8739ae039);
        this.i18nInit();
        // Simultaneous upload limiting is shared across all uploads with this plugin.
        if ((0, $6cb886e1a5aec334$export$603eb9c93e04437) in this.opts) // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore untyped internal
        this.requests = this.opts[0, $6cb886e1a5aec334$export$603eb9c93e04437];
        else this.requests = new (0, $6cb886e1a5aec334$export$32306e81289653bc)(this.opts.limit);
        if (this.opts.bundle && !this.opts.formData) throw new Error('`opts.formData` must be true when `opts.bundle` is enabled.');
        if (this.opts.bundle && typeof this.opts.headers === 'function') throw new Error('`opts.headers` can not be a function when the `bundle: true` option is set.');
        if ((_opts == null ? void 0 : _opts.allowedMetaFields) === undefined && 'metaFields' in this.opts) throw new Error('The `metaFields` option has been renamed to `allowedMetaFields`.');
        this.uploaderEvents = Object.create(null);
        /**
     * xhr-upload wrapper for `fetcher` to handle user options
     * `validateStatus`, `getResponseError`, `getResponseData`
     * and to emit `upload-progress`, `upload-error`, and `upload-success` events.
     */ $cf91058fd9d7f8ee$var$_classPrivateFieldLooseBase(this, $cf91058fd9d7f8ee$var$_getFetcher)[$cf91058fd9d7f8ee$var$_getFetcher] = (files)=>{
            return async (url, options)=>{
                try {
                    var _options$method;
                    const res = await (0, $e3981d1185f67d50$export$47fdd40111eda34c)(url, {
                        ...options,
                        method: options == null || (_options$method = options.method) == null ? void 0 : _options$method.toUpperCase(),
                        onTimeout: (timeout)=>{
                            const seconds = Math.ceil(timeout / 1000);
                            const error = new Error(this.i18n('uploadStalled', {
                                seconds: seconds
                            }));
                            this.uppy.emit('upload-stalled', error, files);
                        },
                        onUploadProgress: (event)=>{
                            if (event.lengthComputable) for (const file of files)this.uppy.emit('upload-progress', file, {
                                // TODO: do not send `uploader` in next major
                                // @ts-expect-error we can't type this and we should remove it
                                uploader: this,
                                bytesUploaded: event.loaded / event.total * file.size,
                                bytesTotal: file.size
                            });
                        }
                    });
                    if (!this.opts.validateStatus(res.status, res.responseText, res)) throw new (0, $0026c55df46f9934$export$2e2bcd8739ae039)(res.statusText, res);
                    const body = this.opts.getResponseData(res.responseText, res);
                    const uploadURL = body == null ? void 0 : body[this.opts.responseUrlFieldName];
                    for (const file of files)this.uppy.emit('upload-success', file, {
                        status: res.status,
                        body: body,
                        uploadURL: uploadURL
                    });
                    return res;
                } catch (error) {
                    if (error.name === 'AbortError') return undefined;
                    if (error instanceof (0, $0026c55df46f9934$export$2e2bcd8739ae039)) {
                        const request = error.request;
                        const customError = $cf91058fd9d7f8ee$var$buildResponseError(request, this.opts.getResponseError(request.responseText, request));
                        for (const file of files)this.uppy.emit('upload-error', file, customError);
                    }
                    throw error;
                }
            };
        };
    }
    getOptions(file) {
        const overrides = this.uppy.getState().xhrUpload;
        const { headers: headers } = this.opts;
        const opts = {
            ...this.opts,
            ...overrides || {},
            ...file.xhrUpload || {},
            headers: {}
        };
        // Support for `headers` as a function, only in the XHRUpload settings.
        // Options set by other plugins in Uppy state or on the files themselves are still merged in afterward.
        //
        // ```js
        // headers: (file) => ({ expires: file.meta.expires })
        // ```
        if (typeof headers === 'function') opts.headers = headers(file);
        else Object.assign(opts.headers, this.opts.headers);
        if (overrides) Object.assign(opts.headers, overrides.headers);
        if (file.xhrUpload) Object.assign(opts.headers, file.xhrUpload.headers);
        return opts;
    }
    // eslint-disable-next-line class-methods-use-this
    addMetadata(formData, meta, opts) {
        const allowedMetaFields = Array.isArray(opts.allowedMetaFields) ? opts.allowedMetaFields : Object.keys(meta); // Send along all fields by default.
        allowedMetaFields.forEach((item)=>{
            const value = meta[item];
            if (Array.isArray(value)) // In this case we don't transform `item` to add brackets, it's up to
            // the user to add the brackets so it won't be overridden.
            value.forEach((subItem)=>formData.append(item, subItem));
            else formData.append(item, value);
        });
    }
    createFormDataUpload(file, opts) {
        const formPost = new FormData();
        this.addMetadata(formPost, file.meta, opts);
        const dataWithUpdatedType = $cf91058fd9d7f8ee$var$setTypeInBlob(file);
        if (file.name) formPost.append(opts.fieldName, dataWithUpdatedType, file.meta.name);
        else formPost.append(opts.fieldName, dataWithUpdatedType);
        return formPost;
    }
    createBundledUpload(files, opts) {
        const formPost = new FormData();
        const { meta: meta } = this.uppy.getState();
        this.addMetadata(formPost, meta, opts);
        files.forEach((file)=>{
            const options = this.getOptions(file);
            const dataWithUpdatedType = $cf91058fd9d7f8ee$var$setTypeInBlob(file);
            if (file.name) formPost.append(options.fieldName, dataWithUpdatedType, file.name);
            else formPost.append(options.fieldName, dataWithUpdatedType);
        });
        return formPost;
    }
    install() {
        if (this.opts.bundle) {
            const { capabilities: capabilities } = this.uppy.getState();
            this.uppy.setState({
                capabilities: {
                    ...capabilities,
                    individualCancellation: false
                }
            });
        }
        this.uppy.addUploader($cf91058fd9d7f8ee$var$_classPrivateFieldLooseBase(this, $cf91058fd9d7f8ee$var$_handleUpload)[$cf91058fd9d7f8ee$var$_handleUpload]);
    }
    uninstall() {
        if (this.opts.bundle) {
            const { capabilities: capabilities } = this.uppy.getState();
            this.uppy.setState({
                capabilities: {
                    ...capabilities,
                    individualCancellation: true
                }
            });
        }
        this.uppy.removeUploader($cf91058fd9d7f8ee$var$_classPrivateFieldLooseBase(this, $cf91058fd9d7f8ee$var$_handleUpload)[$cf91058fd9d7f8ee$var$_handleUpload]);
    }
}
async function $cf91058fd9d7f8ee$var$_uploadLocalFile2(file) {
    const events = new (0, $c89f32c7d05a95a3$export$2e2bcd8739ae039)(this.uppy);
    const controller = new AbortController();
    const uppyFetch = this.requests.wrapPromiseFunction(async ()=>{
        const opts = this.getOptions(file);
        const fetch = $cf91058fd9d7f8ee$var$_classPrivateFieldLooseBase(this, $cf91058fd9d7f8ee$var$_getFetcher)[$cf91058fd9d7f8ee$var$_getFetcher]([
            file
        ]);
        const body = opts.formData ? this.createFormDataUpload(file, opts) : file.data;
        return fetch(opts.endpoint, {
            ...opts,
            body: body,
            signal: controller.signal
        });
    });
    events.onFileRemove(file.id, ()=>controller.abort());
    events.onCancelAll(file.id, (_ref)=>{
        let { reason: reason } = _ref;
        if (reason === 'user') controller.abort();
    });
    try {
        await uppyFetch().abortOn(controller.signal);
    } catch (error) {
        // TODO: create formal error with name 'AbortError' (this comes from RateLimitedQueue)
        if (error.message !== 'Cancelled') throw error;
    } finally{
        events.remove();
    }
}
async function $cf91058fd9d7f8ee$var$_uploadBundle2(files) {
    const controller = new AbortController();
    const uppyFetch = this.requests.wrapPromiseFunction(async ()=>{
        var _this$uppy$getState$x;
        const optsFromState = (_this$uppy$getState$x = this.uppy.getState().xhrUpload) != null ? _this$uppy$getState$x : {};
        const fetch = $cf91058fd9d7f8ee$var$_classPrivateFieldLooseBase(this, $cf91058fd9d7f8ee$var$_getFetcher)[$cf91058fd9d7f8ee$var$_getFetcher](files);
        const body = this.createBundledUpload(files, {
            ...this.opts,
            ...optsFromState
        });
        return fetch(this.opts.endpoint, {
            // headers can't be a function with bundle: true
            ...this.opts,
            body: body,
            signal: controller.signal
        });
    });
    function abort() {
        controller.abort();
    }
    // We only need to abort on cancel all because
    // individual cancellations are not possible with bundle: true
    this.uppy.once('cancel-all', abort);
    try {
        await uppyFetch().abortOn(controller.signal);
    } catch (error) {
        // TODO: create formal error with name 'AbortError' (this comes from RateLimitedQueue)
        if (error.message !== 'Cancelled') throw error;
    } finally{
        this.uppy.off('cancel-all', abort);
    }
}
function $cf91058fd9d7f8ee$var$_getCompanionClientArgs2(file) {
    var _file$remote;
    const opts = this.getOptions(file);
    const allowedMetaFields = Array.isArray(opts.allowedMetaFields) ? opts.allowedMetaFields : Object.keys(file.meta);
    return {
        ...(_file$remote = file.remote) == null ? void 0 : _file$remote.body,
        protocol: 'multipart',
        endpoint: opts.endpoint,
        size: file.data.size,
        fieldname: opts.fieldName,
        metadata: Object.fromEntries(allowedMetaFields.map((name)=>[
                name,
                file.meta[name]
            ])),
        httpMethod: opts.method,
        useFormData: opts.formData,
        headers: opts.headers
    };
}
async function $cf91058fd9d7f8ee$var$_uploadFiles2(files) {
    await Promise.allSettled(files.map((file)=>{
        if (file.isRemote) {
            const getQueue = ()=>this.requests;
            const controller = new AbortController();
            const removedHandler = (removedFile)=>{
                if (removedFile.id === file.id) controller.abort();
            };
            this.uppy.on('file-removed', removedHandler);
            const uploadPromise = this.uppy.getRequestClientForFile(file).uploadRemoteFile(file, $cf91058fd9d7f8ee$var$_classPrivateFieldLooseBase(this, $cf91058fd9d7f8ee$var$_getCompanionClientArgs)[$cf91058fd9d7f8ee$var$_getCompanionClientArgs](file), {
                signal: controller.signal,
                getQueue: getQueue
            });
            this.requests.wrapSyncFunction(()=>{
                this.uppy.off('file-removed', removedHandler);
            }, {
                priority: -1
            })();
            return uploadPromise;
        }
        return $cf91058fd9d7f8ee$var$_classPrivateFieldLooseBase(this, $cf91058fd9d7f8ee$var$_uploadLocalFile)[$cf91058fd9d7f8ee$var$_uploadLocalFile](file);
    }));
}
// eslint-disable-next-line global-require
$cf91058fd9d7f8ee$export$2e2bcd8739ae039.VERSION = $cf91058fd9d7f8ee$var$packageJson.version;






var $e04f4766b186d0a1$exports = {};
/*!
 * Compressor.js v1.2.1
 * https://fengyuanchen.github.io/compressorjs
 *
 * Copyright 2018-present Chen Fengyuan
 * Released under the MIT license
 *
 * Date: 2023-02-28T14:09:41.732Z
 */ (function(global, factory) {
    $e04f4766b186d0a1$exports = factory();
})($e04f4766b186d0a1$exports, function() {
    'use strict';
    function ownKeys(object, enumerableOnly) {
        var keys = Object.keys(object);
        if (Object.getOwnPropertySymbols) {
            var symbols = Object.getOwnPropertySymbols(object);
            enumerableOnly && (symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            })), keys.push.apply(keys, symbols);
        }
        return keys;
    }
    function _objectSpread2(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = null != arguments[i] ? arguments[i] : {};
            i % 2 ? ownKeys(Object(source), !0).forEach(function(key) {
                _defineProperty(target, key, source[key]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function(key) {
                Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
            });
        }
        return target;
    }
    function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
    }
    function _defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
        }
    }
    function _createClass(Constructor, protoProps, staticProps) {
        if (protoProps) _defineProperties(Constructor.prototype, protoProps);
        if (staticProps) _defineProperties(Constructor, staticProps);
        Object.defineProperty(Constructor, "prototype", {
            writable: false
        });
        return Constructor;
    }
    function _defineProperty(obj, key, value) {
        key = _toPropertyKey(key);
        if (key in obj) Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
        else obj[key] = value;
        return obj;
    }
    function _extends() {
        _extends = Object.assign ? Object.assign.bind() : function(target) {
            for(var i = 1; i < arguments.length; i++){
                var source = arguments[i];
                for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
            }
            return target;
        };
        return _extends.apply(this, arguments);
    }
    function _toPrimitive(input, hint) {
        if (typeof input !== "object" || input === null) return input;
        var prim = input[Symbol.toPrimitive];
        if (prim !== undefined) {
            var res = prim.call(input, hint || "default");
            if (typeof res !== "object") return res;
            throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return (hint === "string" ? String : Number)(input);
    }
    function _toPropertyKey(arg) {
        var key = _toPrimitive(arg, "string");
        return typeof key === "symbol" ? key : String(key);
    }
    var canvasToBlob = {
        exports: {}
    };
    /*
   * JavaScript Canvas to Blob
   * https://github.com/blueimp/JavaScript-Canvas-to-Blob
   *
   * Copyright 2012, Sebastian Tschan
   * https://blueimp.net
   *
   * Licensed under the MIT license:
   * https://opensource.org/licenses/MIT
   *
   * Based on stackoverflow user Stoive's code snippet:
   * http://stackoverflow.com/q/4998908
   */ (function(module1) {
        if (typeof window === 'undefined') return;
        (function(window1) {
            var CanvasPrototype = window1.HTMLCanvasElement && window1.HTMLCanvasElement.prototype;
            var hasBlobConstructor = window1.Blob && function() {
                try {
                    return Boolean(new Blob());
                } catch (e) {
                    return false;
                }
            }();
            var hasArrayBufferViewSupport = hasBlobConstructor && window1.Uint8Array && function() {
                try {
                    return new Blob([
                        new Uint8Array(100)
                    ]).size === 100;
                } catch (e) {
                    return false;
                }
            }();
            var BlobBuilder = window1.BlobBuilder || window1.WebKitBlobBuilder || window1.MozBlobBuilder || window1.MSBlobBuilder;
            var dataURIPattern = /^data:((.*?)(;charset=.*?)?)(;base64)?,/;
            var dataURLtoBlob = (hasBlobConstructor || BlobBuilder) && window1.atob && window1.ArrayBuffer && window1.Uint8Array && function(dataURI) {
                var matches, mediaType, isBase64, dataString, byteString, arrayBuffer, intArray, i, bb;
                // Parse the dataURI components as per RFC 2397
                matches = dataURI.match(dataURIPattern);
                if (!matches) throw new Error('invalid data URI');
                // Default to text/plain;charset=US-ASCII
                mediaType = matches[2] ? matches[1] : 'text/plain' + (matches[3] || ';charset=US-ASCII');
                isBase64 = !!matches[4];
                dataString = dataURI.slice(matches[0].length);
                if (isBase64) // Convert base64 to raw binary data held in a string:
                byteString = atob(dataString);
                else // Convert base64/URLEncoded data component to raw binary:
                byteString = decodeURIComponent(dataString);
                // Write the bytes of the string to an ArrayBuffer:
                arrayBuffer = new ArrayBuffer(byteString.length);
                intArray = new Uint8Array(arrayBuffer);
                for(i = 0; i < byteString.length; i += 1)intArray[i] = byteString.charCodeAt(i);
                // Write the ArrayBuffer (or ArrayBufferView) to a blob:
                if (hasBlobConstructor) return new Blob([
                    hasArrayBufferViewSupport ? intArray : arrayBuffer
                ], {
                    type: mediaType
                });
                bb = new BlobBuilder();
                bb.append(arrayBuffer);
                return bb.getBlob(mediaType);
            };
            if (window1.HTMLCanvasElement && !CanvasPrototype.toBlob) {
                if (CanvasPrototype.mozGetAsFile) CanvasPrototype.toBlob = function(callback, type, quality) {
                    var self = this;
                    setTimeout(function() {
                        if (quality && CanvasPrototype.toDataURL && dataURLtoBlob) callback(dataURLtoBlob(self.toDataURL(type, quality)));
                        else callback(self.mozGetAsFile('blob', type));
                    });
                };
                else if (CanvasPrototype.toDataURL && dataURLtoBlob) {
                    if (CanvasPrototype.msToBlob) CanvasPrototype.toBlob = function(callback, type, quality) {
                        var self = this;
                        setTimeout(function() {
                            if ((type && type !== 'image/png' || quality) && CanvasPrototype.toDataURL && dataURLtoBlob) callback(dataURLtoBlob(self.toDataURL(type, quality)));
                            else callback(self.msToBlob(type));
                        });
                    };
                    else CanvasPrototype.toBlob = function(callback, type, quality) {
                        var self = this;
                        setTimeout(function() {
                            callback(dataURLtoBlob(self.toDataURL(type, quality)));
                        });
                    };
                }
            }
            if (module1.exports) module1.exports = dataURLtoBlob;
            else window1.dataURLtoBlob = dataURLtoBlob;
        })(window);
    })(canvasToBlob);
    var toBlob = canvasToBlob.exports;
    var isBlob = function isBlob(value) {
        if (typeof Blob === 'undefined') return false;
        return value instanceof Blob || Object.prototype.toString.call(value) === '[object Blob]';
    };
    var DEFAULTS = {
        /**
     * Indicates if output the original image instead of the compressed one
     * when the size of the compressed image is greater than the original one's
     * @type {boolean}
     */ strict: true,
        /**
     * Indicates if read the image's Exif Orientation information,
     * and then rotate or flip the image automatically.
     * @type {boolean}
     */ checkOrientation: true,
        /**
     * Indicates if retain the image's Exif information after compressed.
     * @type {boolean}
    */ retainExif: false,
        /**
     * The max width of the output image.
     * @type {number}
     */ maxWidth: Infinity,
        /**
     * The max height of the output image.
     * @type {number}
     */ maxHeight: Infinity,
        /**
     * The min width of the output image.
     * @type {number}
     */ minWidth: 0,
        /**
     * The min height of the output image.
     * @type {number}
     */ minHeight: 0,
        /**
     * The width of the output image.
     * If not specified, the natural width of the source image will be used.
     * @type {number}
     */ width: undefined,
        /**
     * The height of the output image.
     * If not specified, the natural height of the source image will be used.
     * @type {number}
     */ height: undefined,
        /**
     * Sets how the size of the image should be resized to the container
     * specified by the `width` and `height` options.
     * @type {string}
     */ resize: 'none',
        /**
     * The quality of the output image.
     * It must be a number between `0` and `1`,
     * and only available for `image/jpeg` and `image/webp` images.
     * Check out {@link https://developer.mozilla.org/en-US/docs/Web/API/HTMLCanvasElement/toBlob canvas.toBlob}.
     * @type {number}
     */ quality: 0.8,
        /**
     * The mime type of the output image.
     * By default, the original mime type of the source image file will be used.
     * @type {string}
     */ mimeType: 'auto',
        /**
     * Files whose file type is included in this list,
     * and whose file size exceeds the `convertSize` value will be converted to JPEGs.
     * @type {string｜Array}
     */ convertTypes: [
            'image/png'
        ],
        /**
     * PNG files over this size (5 MB by default) will be converted to JPEGs.
     * To disable this, just set the value to `Infinity`.
     * @type {number}
     */ convertSize: 5000000,
        /**
     * The hook function to execute before draw the image into the canvas for compression.
     * @type {Function}
     * @param {CanvasRenderingContext2D} context - The 2d rendering context of the canvas.
     * @param {HTMLCanvasElement} canvas - The canvas for compression.
     * @example
     * function (context, canvas) {
     *   context.fillStyle = '#fff';
     * }
     */ beforeDraw: null,
        /**
     * The hook function to execute after drew the image into the canvas for compression.
     * @type {Function}
     * @param {CanvasRenderingContext2D} context - The 2d rendering context of the canvas.
     * @param {HTMLCanvasElement} canvas - The canvas for compression.
     * @example
     * function (context, canvas) {
     *   context.filter = 'grayscale(100%)';
     * }
     */ drew: null,
        /**
     * The hook function to execute when success to compress the image.
     * @type {Function}
     * @param {File} file - The compressed image File object.
     * @example
     * function (file) {
     *   console.log(file);
     * }
     */ success: null,
        /**
     * The hook function to execute when fail to compress the image.
     * @type {Function}
     * @param {Error} err - An Error object.
     * @example
     * function (err) {
     *   console.log(err.message);
     * }
     */ error: null
    };
    var IS_BROWSER = typeof window !== 'undefined' && typeof window.document !== 'undefined';
    var WINDOW = IS_BROWSER ? window : {};
    /**
   * Check if the given value is a positive number.
   * @param {*} value - The value to check.
   * @returns {boolean} Returns `true` if the given value is a positive number, else `false`.
   */ var isPositiveNumber = function isPositiveNumber(value) {
        return value > 0 && value < Infinity;
    };
    var slice = Array.prototype.slice;
    /**
   * Convert array-like or iterable object to an array.
   * @param {*} value - The value to convert.
   * @returns {Array} Returns a new array.
   */ function toArray(value) {
        return Array.from ? Array.from(value) : slice.call(value);
    }
    var REGEXP_IMAGE_TYPE = /^image\/.+$/;
    /**
   * Check if the given value is a mime type of image.
   * @param {*} value - The value to check.
   * @returns {boolean} Returns `true` if the given is a mime type of image, else `false`.
   */ function isImageType(value) {
        return REGEXP_IMAGE_TYPE.test(value);
    }
    /**
   * Convert image type to extension.
   * @param {string} value - The image type to convert.
   * @returns {boolean} Returns the image extension.
   */ function imageTypeToExtension(value) {
        var extension = isImageType(value) ? value.substr(6) : '';
        if (extension === 'jpeg') extension = 'jpg';
        return ".".concat(extension);
    }
    var fromCharCode = String.fromCharCode;
    /**
   * Get string from char code in data view.
   * @param {DataView} dataView - The data view for read.
   * @param {number} start - The start index.
   * @param {number} length - The read length.
   * @returns {string} The read result.
   */ function getStringFromCharCode(dataView, start, length) {
        var str = '';
        var i;
        length += start;
        for(i = start; i < length; i += 1)str += fromCharCode(dataView.getUint8(i));
        return str;
    }
    var btoa = WINDOW.btoa;
    /**
   * Transform array buffer to Data URL.
   * @param {ArrayBuffer} arrayBuffer - The array buffer to transform.
   * @param {string} mimeType - The mime type of the Data URL.
   * @returns {string} The result Data URL.
   */ function arrayBufferToDataURL(arrayBuffer, mimeType) {
        var chunks = [];
        var chunkSize = 8192;
        var uint8 = new Uint8Array(arrayBuffer);
        while(uint8.length > 0){
            // XXX: Babel's `toConsumableArray` helper will throw error in IE or Safari 9
            // eslint-disable-next-line prefer-spread
            chunks.push(fromCharCode.apply(null, toArray(uint8.subarray(0, chunkSize))));
            uint8 = uint8.subarray(chunkSize);
        }
        return "data:".concat(mimeType, ";base64,").concat(btoa(chunks.join('')));
    }
    /**
   * Get orientation value from given array buffer.
   * @param {ArrayBuffer} arrayBuffer - The array buffer to read.
   * @returns {number} The read orientation value.
   */ function resetAndGetOrientation(arrayBuffer) {
        var dataView = new DataView(arrayBuffer);
        var orientation;
        // Ignores range error when the image does not have correct Exif information
        try {
            var littleEndian;
            var app1Start;
            var ifdStart;
            // Only handle JPEG image (start by 0xFFD8)
            if (dataView.getUint8(0) === 0xFF && dataView.getUint8(1) === 0xD8) {
                var length = dataView.byteLength;
                var offset = 2;
                while(offset + 1 < length){
                    if (dataView.getUint8(offset) === 0xFF && dataView.getUint8(offset + 1) === 0xE1) {
                        app1Start = offset;
                        break;
                    }
                    offset += 1;
                }
            }
            if (app1Start) {
                var exifIDCode = app1Start + 4;
                var tiffOffset = app1Start + 10;
                if (getStringFromCharCode(dataView, exifIDCode, 4) === 'Exif') {
                    var endianness = dataView.getUint16(tiffOffset);
                    littleEndian = endianness === 0x4949;
                    if (littleEndian || endianness === 0x4D4D /* bigEndian */ ) {
                        if (dataView.getUint16(tiffOffset + 2, littleEndian) === 0x002A) {
                            var firstIFDOffset = dataView.getUint32(tiffOffset + 4, littleEndian);
                            if (firstIFDOffset >= 0x00000008) ifdStart = tiffOffset + firstIFDOffset;
                        }
                    }
                }
            }
            if (ifdStart) {
                var _length = dataView.getUint16(ifdStart, littleEndian);
                var _offset;
                var i;
                for(i = 0; i < _length; i += 1){
                    _offset = ifdStart + i * 12 + 2;
                    if (dataView.getUint16(_offset, littleEndian) === 0x0112 /* Orientation */ ) {
                        // 8 is the offset of the current tag's value
                        _offset += 8;
                        // Get the original orientation value
                        orientation = dataView.getUint16(_offset, littleEndian);
                        // Override the orientation with its default value
                        dataView.setUint16(_offset, 1, littleEndian);
                        break;
                    }
                }
            }
        } catch (e) {
            orientation = 1;
        }
        return orientation;
    }
    /**
   * Parse Exif Orientation value.
   * @param {number} orientation - The orientation to parse.
   * @returns {Object} The parsed result.
   */ function parseOrientation(orientation) {
        var rotate = 0;
        var scaleX = 1;
        var scaleY = 1;
        switch(orientation){
            // Flip horizontal
            case 2:
                scaleX = -1;
                break;
            // Rotate left 180°
            case 3:
                rotate = -180;
                break;
            // Flip vertical
            case 4:
                scaleY = -1;
                break;
            // Flip vertical and rotate right 90°
            case 5:
                rotate = 90;
                scaleY = -1;
                break;
            // Rotate right 90°
            case 6:
                rotate = 90;
                break;
            // Flip horizontal and rotate right 90°
            case 7:
                rotate = 90;
                scaleX = -1;
                break;
            // Rotate left 90°
            case 8:
                rotate = -90;
                break;
        }
        return {
            rotate: rotate,
            scaleX: scaleX,
            scaleY: scaleY
        };
    }
    var REGEXP_DECIMALS = /\.\d*(?:0|9){12}\d*$/;
    /**
   * Normalize decimal number.
   * Check out {@link https://0.30000000000000004.com/}
   * @param {number} value - The value to normalize.
   * @param {number} [times=100000000000] - The times for normalizing.
   * @returns {number} Returns the normalized number.
   */ function normalizeDecimalNumber(value) {
        var times = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100000000000;
        return REGEXP_DECIMALS.test(value) ? Math.round(value * times) / times : value;
    }
    /**
   * Get the max sizes in a rectangle under the given aspect ratio.
   * @param {Object} data - The original sizes.
   * @param {string} [type='contain'] - The adjust type.
   * @returns {Object} The result sizes.
   */ function getAdjustedSizes(_ref) {
        var aspectRatio = _ref.aspectRatio, height = _ref.height, width = _ref.width;
        var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'none';
        var isValidWidth = isPositiveNumber(width);
        var isValidHeight = isPositiveNumber(height);
        if (isValidWidth && isValidHeight) {
            var adjustedWidth = height * aspectRatio;
            if ((type === 'contain' || type === 'none') && adjustedWidth > width || type === 'cover' && adjustedWidth < width) height = width / aspectRatio;
            else width = height * aspectRatio;
        } else if (isValidWidth) height = width / aspectRatio;
        else if (isValidHeight) width = height * aspectRatio;
        return {
            width: width,
            height: height
        };
    }
    /**
   * Get Exif information from the given array buffer.
   * @param {ArrayBuffer} arrayBuffer - The array buffer to read.
   * @returns {Array} The read Exif information.
   */ function getExif(arrayBuffer) {
        var array = toArray(new Uint8Array(arrayBuffer));
        var length = array.length;
        var segments = [];
        var start = 0;
        while(start + 3 < length){
            var value = array[start];
            var next = array[start + 1];
            // SOS (Start of Scan)
            if (value === 0xFF && next === 0xDA) break;
            // SOI (Start of Image)
            if (value === 0xFF && next === 0xD8) start += 2;
            else {
                var offset = array[start + 2] * 256 + array[start + 3];
                var end = start + offset + 2;
                var segment = array.slice(start, end);
                segments.push(segment);
                start = end;
            }
        }
        return segments.reduce(function(exifArray, current) {
            if (current[0] === 0xFF && current[1] === 0xE1) return exifArray.concat(current);
            return exifArray;
        }, []);
    }
    /**
   * Insert Exif information into the given array buffer.
   * @param {ArrayBuffer} arrayBuffer - The array buffer to transform.
   * @param {Array} exifArray - The Exif information to insert.
   * @returns {ArrayBuffer} The transformed array buffer.
   */ function insertExif(arrayBuffer, exifArray) {
        var array = toArray(new Uint8Array(arrayBuffer));
        if (array[2] !== 0xFF || array[3] !== 0xE0) return arrayBuffer;
        var app0Length = array[4] * 256 + array[5];
        var newArrayBuffer = [
            0xFF,
            0xD8
        ].concat(exifArray, array.slice(4 + app0Length));
        return new Uint8Array(newArrayBuffer);
    }
    var ArrayBuffer$1 = WINDOW.ArrayBuffer, FileReader = WINDOW.FileReader;
    var URL = WINDOW.URL || WINDOW.webkitURL;
    var REGEXP_EXTENSION = /\.\w+$/;
    var AnotherCompressor = WINDOW.Compressor;
    /**
   * Creates a new image compressor.
   * @class
   */ var Compressor = /*#__PURE__*/ function() {
        /**
     * The constructor of Compressor.
     * @param {File|Blob} file - The target image file for compressing.
     * @param {Object} [options] - The options for compressing.
     */ function Compressor(file, options) {
            _classCallCheck(this, Compressor);
            this.file = file;
            this.exif = [];
            this.image = new Image();
            this.options = _objectSpread2(_objectSpread2({}, DEFAULTS), options);
            this.aborted = false;
            this.result = null;
            this.init();
        }
        _createClass(Compressor, [
            {
                key: "init",
                value: function init() {
                    var _this = this;
                    var file = this.file, options = this.options;
                    if (!isBlob(file)) {
                        this.fail(new Error('The first argument must be a File or Blob object.'));
                        return;
                    }
                    var mimeType = file.type;
                    if (!isImageType(mimeType)) {
                        this.fail(new Error('The first argument must be an image File or Blob object.'));
                        return;
                    }
                    if (!URL || !FileReader) {
                        this.fail(new Error('The current browser does not support image compression.'));
                        return;
                    }
                    if (!ArrayBuffer$1) {
                        options.checkOrientation = false;
                        options.retainExif = false;
                    }
                    var isJPEGImage = mimeType === 'image/jpeg';
                    var checkOrientation = isJPEGImage && options.checkOrientation;
                    var retainExif = isJPEGImage && options.retainExif;
                    if (URL && !checkOrientation && !retainExif) this.load({
                        url: URL.createObjectURL(file)
                    });
                    else {
                        var reader = new FileReader();
                        this.reader = reader;
                        reader.onload = function(_ref) {
                            var target = _ref.target;
                            var result = target.result;
                            var data = {};
                            var orientation = 1;
                            if (checkOrientation) {
                                // Reset the orientation value to its default value 1
                                // as some iOS browsers will render image with its orientation
                                orientation = resetAndGetOrientation(result);
                                if (orientation > 1) _extends(data, parseOrientation(orientation));
                            }
                            if (retainExif) _this.exif = getExif(result);
                            if (checkOrientation || retainExif) {
                                if (!URL || orientation > 1) data.url = arrayBufferToDataURL(result, mimeType);
                                else data.url = URL.createObjectURL(file);
                            } else data.url = result;
                            _this.load(data);
                        };
                        reader.onabort = function() {
                            _this.fail(new Error('Aborted to read the image with FileReader.'));
                        };
                        reader.onerror = function() {
                            _this.fail(new Error('Failed to read the image with FileReader.'));
                        };
                        reader.onloadend = function() {
                            _this.reader = null;
                        };
                        if (checkOrientation || retainExif) reader.readAsArrayBuffer(file);
                        else reader.readAsDataURL(file);
                    }
                }
            },
            {
                key: "load",
                value: function load(data) {
                    var _this2 = this;
                    var file = this.file, image = this.image;
                    image.onload = function() {
                        _this2.draw(_objectSpread2(_objectSpread2({}, data), {}, {
                            naturalWidth: image.naturalWidth,
                            naturalHeight: image.naturalHeight
                        }));
                    };
                    image.onabort = function() {
                        _this2.fail(new Error('Aborted to load the image.'));
                    };
                    image.onerror = function() {
                        _this2.fail(new Error('Failed to load the image.'));
                    };
                    // Match all browsers that use WebKit as the layout engine in iOS devices,
                    // such as Safari for iOS, Chrome for iOS, and in-app browsers.
                    if (WINDOW.navigator && /(?:iPad|iPhone|iPod).*?AppleWebKit/i.test(WINDOW.navigator.userAgent)) // Fix the `The operation is insecure` error (#57)
                    image.crossOrigin = 'anonymous';
                    image.alt = file.name;
                    image.src = data.url;
                }
            },
            {
                key: "draw",
                value: function draw(_ref2) {
                    var _this3 = this;
                    var naturalWidth = _ref2.naturalWidth, naturalHeight = _ref2.naturalHeight, _ref2$rotate = _ref2.rotate, rotate = _ref2$rotate === void 0 ? 0 : _ref2$rotate, _ref2$scaleX = _ref2.scaleX, scaleX = _ref2$scaleX === void 0 ? 1 : _ref2$scaleX, _ref2$scaleY = _ref2.scaleY, scaleY = _ref2$scaleY === void 0 ? 1 : _ref2$scaleY;
                    var file = this.file, image = this.image, options = this.options;
                    var canvas = document.createElement('canvas');
                    var context = canvas.getContext('2d');
                    var is90DegreesRotated = Math.abs(rotate) % 180 === 90;
                    var resizable = (options.resize === 'contain' || options.resize === 'cover') && isPositiveNumber(options.width) && isPositiveNumber(options.height);
                    var maxWidth = Math.max(options.maxWidth, 0) || Infinity;
                    var maxHeight = Math.max(options.maxHeight, 0) || Infinity;
                    var minWidth = Math.max(options.minWidth, 0) || 0;
                    var minHeight = Math.max(options.minHeight, 0) || 0;
                    var aspectRatio = naturalWidth / naturalHeight;
                    var width = options.width, height = options.height;
                    if (is90DegreesRotated) {
                        var _ref3 = [
                            maxHeight,
                            maxWidth
                        ];
                        maxWidth = _ref3[0];
                        maxHeight = _ref3[1];
                        var _ref4 = [
                            minHeight,
                            minWidth
                        ];
                        minWidth = _ref4[0];
                        minHeight = _ref4[1];
                        var _ref5 = [
                            height,
                            width
                        ];
                        width = _ref5[0];
                        height = _ref5[1];
                    }
                    if (resizable) aspectRatio = width / height;
                    var _getAdjustedSizes = getAdjustedSizes({
                        aspectRatio: aspectRatio,
                        width: maxWidth,
                        height: maxHeight
                    }, 'contain');
                    maxWidth = _getAdjustedSizes.width;
                    maxHeight = _getAdjustedSizes.height;
                    var _getAdjustedSizes2 = getAdjustedSizes({
                        aspectRatio: aspectRatio,
                        width: minWidth,
                        height: minHeight
                    }, 'cover');
                    minWidth = _getAdjustedSizes2.width;
                    minHeight = _getAdjustedSizes2.height;
                    if (resizable) {
                        var _getAdjustedSizes3 = getAdjustedSizes({
                            aspectRatio: aspectRatio,
                            width: width,
                            height: height
                        }, options.resize);
                        width = _getAdjustedSizes3.width;
                        height = _getAdjustedSizes3.height;
                    } else {
                        var _getAdjustedSizes4 = getAdjustedSizes({
                            aspectRatio: aspectRatio,
                            width: width,
                            height: height
                        });
                        var _getAdjustedSizes4$wi = _getAdjustedSizes4.width;
                        width = _getAdjustedSizes4$wi === void 0 ? naturalWidth : _getAdjustedSizes4$wi;
                        var _getAdjustedSizes4$he = _getAdjustedSizes4.height;
                        height = _getAdjustedSizes4$he === void 0 ? naturalHeight : _getAdjustedSizes4$he;
                    }
                    width = Math.floor(normalizeDecimalNumber(Math.min(Math.max(width, minWidth), maxWidth)));
                    height = Math.floor(normalizeDecimalNumber(Math.min(Math.max(height, minHeight), maxHeight)));
                    var destX = -width / 2;
                    var destY = -height / 2;
                    var destWidth = width;
                    var destHeight = height;
                    var params = [];
                    if (resizable) {
                        var srcX = 0;
                        var srcY = 0;
                        var srcWidth = naturalWidth;
                        var srcHeight = naturalHeight;
                        var _getAdjustedSizes5 = getAdjustedSizes({
                            aspectRatio: aspectRatio,
                            width: naturalWidth,
                            height: naturalHeight
                        }, {
                            contain: 'cover',
                            cover: 'contain'
                        }[options.resize]);
                        srcWidth = _getAdjustedSizes5.width;
                        srcHeight = _getAdjustedSizes5.height;
                        srcX = (naturalWidth - srcWidth) / 2;
                        srcY = (naturalHeight - srcHeight) / 2;
                        params.push(srcX, srcY, srcWidth, srcHeight);
                    }
                    params.push(destX, destY, destWidth, destHeight);
                    if (is90DegreesRotated) {
                        var _ref6 = [
                            height,
                            width
                        ];
                        width = _ref6[0];
                        height = _ref6[1];
                    }
                    canvas.width = width;
                    canvas.height = height;
                    if (!isImageType(options.mimeType)) options.mimeType = file.type;
                    var fillStyle = 'transparent';
                    // Converts PNG files over the `convertSize` to JPEGs.
                    if (file.size > options.convertSize && options.convertTypes.indexOf(options.mimeType) >= 0) options.mimeType = 'image/jpeg';
                    var isJPEGImage = options.mimeType === 'image/jpeg';
                    if (isJPEGImage) fillStyle = '#fff';
                    // Override the default fill color (#000, black)
                    context.fillStyle = fillStyle;
                    context.fillRect(0, 0, width, height);
                    if (options.beforeDraw) options.beforeDraw.call(this, context, canvas);
                    if (this.aborted) return;
                    context.save();
                    context.translate(width / 2, height / 2);
                    context.rotate(rotate * Math.PI / 180);
                    context.scale(scaleX, scaleY);
                    context.drawImage.apply(context, [
                        image
                    ].concat(params));
                    context.restore();
                    if (options.drew) options.drew.call(this, context, canvas);
                    if (this.aborted) return;
                    var callback = function callback(blob) {
                        if (!_this3.aborted) {
                            var done = function done(result) {
                                return _this3.done({
                                    naturalWidth: naturalWidth,
                                    naturalHeight: naturalHeight,
                                    result: result
                                });
                            };
                            if (blob && isJPEGImage && options.retainExif && _this3.exif && _this3.exif.length > 0) {
                                var next = function next(arrayBuffer) {
                                    return done(toBlob(arrayBufferToDataURL(insertExif(arrayBuffer, _this3.exif), options.mimeType)));
                                };
                                if (blob.arrayBuffer) blob.arrayBuffer().then(next).catch(function() {
                                    _this3.fail(new Error('Failed to read the compressed image with Blob.arrayBuffer().'));
                                });
                                else {
                                    var reader = new FileReader();
                                    _this3.reader = reader;
                                    reader.onload = function(_ref7) {
                                        var target = _ref7.target;
                                        next(target.result);
                                    };
                                    reader.onabort = function() {
                                        _this3.fail(new Error('Aborted to read the compressed image with FileReader.'));
                                    };
                                    reader.onerror = function() {
                                        _this3.fail(new Error('Failed to read the compressed image with FileReader.'));
                                    };
                                    reader.onloadend = function() {
                                        _this3.reader = null;
                                    };
                                    reader.readAsArrayBuffer(blob);
                                }
                            } else done(blob);
                        }
                    };
                    if (canvas.toBlob) canvas.toBlob(callback, options.mimeType, options.quality);
                    else callback(toBlob(canvas.toDataURL(options.mimeType, options.quality)));
                }
            },
            {
                key: "done",
                value: function done(_ref8) {
                    var naturalWidth = _ref8.naturalWidth, naturalHeight = _ref8.naturalHeight, result = _ref8.result;
                    var file = this.file, image = this.image, options = this.options;
                    if (URL && image.src.indexOf('blob:') === 0) URL.revokeObjectURL(image.src);
                    if (result) {
                        // Returns original file if the result is greater than it and without size related options
                        if (options.strict && !options.retainExif && result.size > file.size && options.mimeType === file.type && !(options.width > naturalWidth || options.height > naturalHeight || options.minWidth > naturalWidth || options.minHeight > naturalHeight || options.maxWidth < naturalWidth || options.maxHeight < naturalHeight)) result = file;
                        else {
                            var date = new Date();
                            result.lastModified = date.getTime();
                            result.lastModifiedDate = date;
                            result.name = file.name;
                            // Convert the extension to match its type
                            if (result.name && result.type !== file.type) result.name = result.name.replace(REGEXP_EXTENSION, imageTypeToExtension(result.type));
                        }
                    } else // Returns original file if the result is null in some cases.
                    result = file;
                    this.result = result;
                    if (options.success) options.success.call(this, result);
                }
            },
            {
                key: "fail",
                value: function fail(err) {
                    var options = this.options;
                    if (options.error) options.error.call(this, err);
                    else throw err;
                }
            },
            {
                key: "abort",
                value: function abort() {
                    if (!this.aborted) {
                        this.aborted = true;
                        if (this.reader) this.reader.abort();
                        else if (!this.image.complete) {
                            this.image.onload = null;
                            this.image.onabort();
                        } else this.fail(new Error('The compression process has been aborted.'));
                    }
                }
            }
        ], [
            {
                key: "noConflict",
                value: function noConflict() {
                    window.Compressor = AnotherCompressor;
                    return Compressor;
                }
            },
            {
                key: "setDefaults",
                value: function setDefaults(options) {
                    _extends(DEFAULTS, options);
                }
            }
        ]);
        return Compressor;
    }();
    return Compressor;
});


var $de0418694bba9f03$export$2e2bcd8739ae039 = {
    strings: {
        // Shown in the Status Bar
        compressingImages: 'Compressing images...',
        compressedX: 'Saved %{size} by compressing images'
    }
};


function $d847a4c5a8f23ad9$var$_classPrivateFieldLooseBase(receiver, privateKey) {
    if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) throw new TypeError("attempted to use private field on non-instance");
    return receiver;
}
var $d847a4c5a8f23ad9$var$id = 0;
function $d847a4c5a8f23ad9$var$_classPrivateFieldLooseKey(name) {
    return "__private_" + $d847a4c5a8f23ad9$var$id++ + "_" + name;
}
var $d847a4c5a8f23ad9$var$_RateLimitedQueue = /*#__PURE__*/ $d847a4c5a8f23ad9$var$_classPrivateFieldLooseKey("RateLimitedQueue");
class $d847a4c5a8f23ad9$export$2e2bcd8739ae039 extends (0, $336df15d01030489$export$2e2bcd8739ae039) {
    constructor(uppy, opts){
        super(uppy, opts);
        Object.defineProperty(this, $d847a4c5a8f23ad9$var$_RateLimitedQueue, {
            writable: true,
            value: void 0
        });
        this.id = this.opts.id || 'Compressor';
        this.type = 'modifier';
        this.defaultLocale = (0, $de0418694bba9f03$export$2e2bcd8739ae039);
        const defaultOptions = {
            quality: 0.6,
            limit: 10
        };
        this.opts = {
            ...defaultOptions,
            ...opts
        };
        $d847a4c5a8f23ad9$var$_classPrivateFieldLooseBase(this, $d847a4c5a8f23ad9$var$_RateLimitedQueue)[$d847a4c5a8f23ad9$var$_RateLimitedQueue] = new (0, $6cb886e1a5aec334$export$32306e81289653bc)(this.opts.limit);
        this.i18nInit();
        this.prepareUpload = this.prepareUpload.bind(this);
        this.compress = this.compress.bind(this);
    }
    compress(blob) {
        return new Promise((resolve, reject)=>{
            /* eslint-disable no-new */ new (0, (/*@__PURE__*/$parcel$interopDefault($e04f4766b186d0a1$exports)))(blob, {
                ...this.opts,
                success: resolve,
                error: reject
            });
        });
    }
    async prepareUpload(fileIDs) {
        let totalCompressedSize = 0;
        const compressedFiles = [];
        const compressAndApplyResult = $d847a4c5a8f23ad9$var$_classPrivateFieldLooseBase(this, $d847a4c5a8f23ad9$var$_RateLimitedQueue)[$d847a4c5a8f23ad9$var$_RateLimitedQueue].wrapPromiseFunction(async (file)=>{
            try {
                const compressedBlob = await this.compress(file.data);
                const compressedSavingsSize = file.data.size - compressedBlob.size;
                this.uppy.log(`[Image Compressor] Image ${file.id} compressed by ${(0, (/*@__PURE__*/$parcel$interopDefault($06e80194017bcce5$exports)))(compressedSavingsSize)}`);
                totalCompressedSize += compressedSavingsSize;
                const { name: name, type: type, size: size } = compressedBlob;
                const compressedFileName = (0, $09afbe8d004816d5$export$2e2bcd8739ae039)(name);
                const metaFileName = (0, $09afbe8d004816d5$export$2e2bcd8739ae039)(file.meta.name);
                // Name (file.meta.name) might have been changed by user, so we update only the extension
                const newMetaName = `${metaFileName.name}.${compressedFileName.extension}`;
                this.uppy.setFileState(file.id, {
                    ...name && {
                        name: name
                    },
                    ...compressedFileName.extension && {
                        extension: compressedFileName.extension
                    },
                    ...type && {
                        type: type
                    },
                    ...size && {
                        size: size
                    },
                    data: compressedBlob,
                    meta: {
                        ...file.meta,
                        type: type,
                        name: newMetaName
                    }
                });
                compressedFiles.push(file);
            } catch (err) {
                this.uppy.log(`[Image Compressor] Failed to compress ${file.id}:`, 'warning');
                this.uppy.log(err, 'warning');
            }
        });
        const promises = fileIDs.map((fileID)=>{
            var _file$type;
            const file = this.uppy.getFile(fileID);
            this.uppy.emit('preprocess-progress', file, {
                mode: 'indeterminate',
                message: this.i18n('compressingImages')
            });
            if (file.isRemote) return Promise.resolve();
            // Some browsers (Firefox) add blobs with empty file type, when files are
            // added from a folder. Uppy auto-detects type from extension, but leaves the original blob intact.
            // However, Compressor.js failes when file has no type, so we set it here
            if (!file.data.type) file.data = file.data.slice(0, file.data.size, file.type);
            if (!((_file$type = file.type) != null && _file$type.startsWith('image/'))) return Promise.resolve();
            return compressAndApplyResult(file);
        });
        // Why emit `preprocess-complete` for all files at once, instead of
        // above when each is processed?
        // Because it leads to StatusBar showing a weird “upload 6 files” button,
        // while waiting for all the files to complete pre-processing.
        await Promise.all(promises);
        this.uppy.emit('compressor:complete', compressedFiles);
        // Only show informer if Compressor mananged to save at least a kilobyte
        if (totalCompressedSize > 1024) this.uppy.info(this.i18n('compressedX', {
            size: (0, (/*@__PURE__*/$parcel$interopDefault($06e80194017bcce5$exports)))(totalCompressedSize)
        }), 'info');
        for (const fileID of fileIDs){
            const file = this.uppy.getFile(fileID);
            this.uppy.emit('preprocess-complete', file);
        }
    }
    install() {
        this.uppy.addPreProcessor(this.prepareUpload);
    }
    uninstall() {
        this.uppy.removePreProcessor(this.prepareUpload);
    }
}



const $cb482a25fa64fd81$var$randomUUID = typeof crypto !== 'undefined' && crypto.randomUUID && crypto.randomUUID.bind(crypto);
var $cb482a25fa64fd81$export$2e2bcd8739ae039 = {
    randomUUID: $cb482a25fa64fd81$var$randomUUID
};


// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
let $a4faffbfed8ce8b6$var$getRandomValues;
const $a4faffbfed8ce8b6$var$rnds8 = new Uint8Array(16);
function $a4faffbfed8ce8b6$export$2e2bcd8739ae039() {
    // lazy load so that environments that need to polyfill have a chance to do so
    if (!$a4faffbfed8ce8b6$var$getRandomValues) {
        // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation.
        $a4faffbfed8ce8b6$var$getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto);
        if (!$a4faffbfed8ce8b6$var$getRandomValues) throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    }
    return $a4faffbfed8ce8b6$var$getRandomValues($a4faffbfed8ce8b6$var$rnds8);
}


var $f53d8abb4c91ec67$export$2e2bcd8739ae039 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;


function $8e32bacb71dd477f$var$validate(uuid) {
    return typeof uuid === 'string' && (0, $f53d8abb4c91ec67$export$2e2bcd8739ae039).test(uuid);
}
var $8e32bacb71dd477f$export$2e2bcd8739ae039 = $8e32bacb71dd477f$var$validate;


/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ const $489cbfc69d38cb8e$var$byteToHex = [];
for(let i = 0; i < 256; ++i)$489cbfc69d38cb8e$var$byteToHex.push((i + 0x100).toString(16).slice(1));
function $489cbfc69d38cb8e$export$8fb373d660548968(arr, offset = 0) {
    // Note: Be careful editing this code!  It's been tuned for performance
    // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
    return $489cbfc69d38cb8e$var$byteToHex[arr[offset + 0]] + $489cbfc69d38cb8e$var$byteToHex[arr[offset + 1]] + $489cbfc69d38cb8e$var$byteToHex[arr[offset + 2]] + $489cbfc69d38cb8e$var$byteToHex[arr[offset + 3]] + '-' + $489cbfc69d38cb8e$var$byteToHex[arr[offset + 4]] + $489cbfc69d38cb8e$var$byteToHex[arr[offset + 5]] + '-' + $489cbfc69d38cb8e$var$byteToHex[arr[offset + 6]] + $489cbfc69d38cb8e$var$byteToHex[arr[offset + 7]] + '-' + $489cbfc69d38cb8e$var$byteToHex[arr[offset + 8]] + $489cbfc69d38cb8e$var$byteToHex[arr[offset + 9]] + '-' + $489cbfc69d38cb8e$var$byteToHex[arr[offset + 10]] + $489cbfc69d38cb8e$var$byteToHex[arr[offset + 11]] + $489cbfc69d38cb8e$var$byteToHex[arr[offset + 12]] + $489cbfc69d38cb8e$var$byteToHex[arr[offset + 13]] + $489cbfc69d38cb8e$var$byteToHex[arr[offset + 14]] + $489cbfc69d38cb8e$var$byteToHex[arr[offset + 15]];
}
function $489cbfc69d38cb8e$var$stringify(arr, offset = 0) {
    const uuid = $489cbfc69d38cb8e$export$8fb373d660548968(arr, offset); // Consistency check for valid UUID.  If this throws, it's likely due to one
    // of the following:
    // - One or more input array values don't map to a hex octet (leading to
    // "undefined" in the uuid)
    // - Invalid input values for the RFC `version` or `variant` fields
    if (!(0, $8e32bacb71dd477f$export$2e2bcd8739ae039)(uuid)) throw TypeError('Stringified UUID is invalid');
    return uuid;
}
var $489cbfc69d38cb8e$export$2e2bcd8739ae039 = $489cbfc69d38cb8e$var$stringify;


function $d0666643e2ee88b4$var$v4(options, buf, offset) {
    if ((0, $cb482a25fa64fd81$export$2e2bcd8739ae039).randomUUID && !buf && !options) return (0, $cb482a25fa64fd81$export$2e2bcd8739ae039).randomUUID();
    options = options || {};
    const rnds = options.random || (options.rng || (0, $a4faffbfed8ce8b6$export$2e2bcd8739ae039))(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided
    if (buf) {
        offset = offset || 0;
        for(let i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, $489cbfc69d38cb8e$export$8fb373d660548968)(rnds);
}
var $d0666643e2ee88b4$export$2e2bcd8739ae039 = $d0666643e2ee88b4$var$v4;


const $4dcbb1f6ebd585d1$var$de_DE = {
    strings: {},
    pluralize (count) {
        if (count === 1) return 0;
        return 1;
    }
};
$4dcbb1f6ebd585d1$var$de_DE.strings = {
    addBulkFilesFailed: {
        '0': "Das Hinzuf\xfcgen einer Datei ist aufgrund eines internen Fehlers fehlgeschlagen",
        '1': "Das Hinzuf\xfcgen von %{smart_count} Dateien ist aufgrund eines internen Fehlers fehlgeschlagen"
    },
    addingMoreFiles: "Dateien hinzuf\xfcgen",
    addMore: "Mehr hinzuf\xfcgen",
    addMoreFiles: "Dateien hinzuf\xfcgen",
    allFilesFromFolderNamed: 'Alle Dateien vom Ordner %{name}',
    allowAccessDescription: 'Um Bilder oder Videos mit Ihrer Kamera aufzunehmen, erlauben Sie dieser Website bitte den Zugriff auf Ihre Kamera.',
    allowAccessTitle: 'Bitte erlauben Sie Zugriff auf Ihre Kamera',
    aspectRatioLandscape: 'Zuschneiden auf Querformat (16:9)',
    aspectRatioPortrait: 'Zuschneiden auf Hochformat (9:16)',
    aspectRatioSquare: 'Zuschneiden auf Quadrat',
    authenticateWith: 'Mit %{pluginName} verbinden',
    authenticateWithTitle: "Bitte authentifizieren Sie sich mit %{pluginName}, um Dateien auszuw\xe4hlen",
    back: "Zur\xfcck",
    backToSearch: "Zur\xfcck zur Suche",
    browse: 'durchsuchen',
    browseFiles: 'Dateien durchsuchen',
    browseFolders: 'Ordner durchsuchen',
    cancel: 'Abbrechen',
    cancelUpload: 'Hochladen abbrechen',
    chooseFiles: "Dateien ausw\xe4hlen",
    closeModal: "Fenster schlie\xdfen",
    companionError: 'Verbindung zu Companion fehlgeschlagen',
    companionUnauthorizeHint: "Um die Autorisierung f\xfcr Ihr %{provider} Konto aufzuheben, gehen Sie bitte zu %{url}",
    complete: 'Fertig',
    connectedToInternet: 'Mit dem Internet verbunden',
    copyLink: 'Link kopieren',
    copyLinkToClipboardFallback: 'Untenstehende URL kopieren',
    copyLinkToClipboardSuccess: 'Link in die Zwischenablage kopiert',
    creatingAssembly: 'Das Hochladen wird vorbereiten...',
    creatingAssemblyFailed: 'Transloadit: Assembly konnte nicht erstellt werden',
    dashboardTitle: 'Hochladen von Dateien',
    dashboardWindowTitle: "Hochladen von Dateien (ESC dr\xfccken zum Schlie\xdfen)",
    dataUploadedOfTotal: '%{complete} von %{total}',
    discardRecordedFile: 'Aufgenommene Datei verwerfen',
    done: 'Abgeschlossen',
    dropHereOr: 'Dateien hier ablegen oder %{browse}',
    dropHint: 'Dateien hier ablegen',
    dropPasteBoth: "Dateien hier ablegen/einf\xfcgen, %{browseFiles} oder %{browseFolders}",
    dropPasteFiles: "Dateien hier ablegen/einf\xfcgen oder %{browseFiles}",
    dropPasteFolders: "Dateien hier ablegen/einf\xfcgen oder %{browseFolders}",
    dropPasteImportBoth: "Dateien hier ablegen/einf\xfcgen, %{browse} oder von folgenden Quellen importieren:",
    dropPasteImportFiles: "Dateien hier ablegen/einf\xfcgen, %{browseFiles} oder von folgenden Quellen importieren:",
    dropPasteImportFolders: "Dateien hier ablegen/einf\xfcgen, %{browseFolders} oder von folgenden Quellen importieren:",
    editFile: 'Datei bearbeiten',
    editImage: 'Bild bearbeiten',
    editFileWithFilename: 'Datei %{file} bearbeiten',
    editing: '%{file} bearbeiten',
    emptyFolderAdded: "Keine Dateien hinzugef\xfcgt, da der Ordner leer war",
    encoding: 'Kodieren...',
    enterCorrectUrl: 'Falsche URL: Bitte stellen Sie sicher, dass Sie einen direkten Link zu einer Datei eingeben',
    enterTextToSearch: 'Text zum Suchen von Bildern eingeben',
    enterUrlToImport: 'URL zum Importieren einer Datei eingeben',
    exceedsSize: "Datei %{file} ist gr\xf6\xdfer als die maximal erlaubte Dateigr\xf6\xdfe von %{size}",
    failedToFetch: 'Companion konnte diese URL nicht verarbeiten - stellen Sie bitte sicher, dass sie korrekt ist',
    failedToUpload: 'Fehler beim Hochladen der Datei %{file}',
    filesUploadedOfTotal: {
        '0': '%{complete} von %{smart_count} Datei hochgeladen',
        '1': '%{complete} von %{smart_count} Dateien hochgeladen'
    },
    filter: 'Filter',
    finishEditingFile: 'Bearbeitung beenden',
    flipHorizontal: 'Horizontal spiegeln',
    folderAdded: {
        '0': "Eine Datei von %{folder} hinzugef\xfcgt",
        '1': "%{smart_count} Dateien von %{folder} hinzugef\xfcgt"
    },
    folderAlreadyAdded: 'Der Ordner "%{folder}" wurde bereits hinzugef\xfcgt',
    generatingThumbnails: 'Erstellen von Miniaturansichten...',
    import: 'Importieren',
    importFiles: 'Importiere Dateien von:',
    importFrom: 'Importieren von %{name}',
    inferiorSize: "Diese Datei ist kleiner als die minimal erlaubte Dateigr\xf6\xdfe von %{size}",
    loading: 'Laden...',
    logOut: 'Abmelden',
    micDisabled: 'Zugriff auf Mikrofon von Benutzer abgelehnt',
    missingRequiredMetaField: 'Fehlende erforderliche Meta-Felder',
    missingRequiredMetaFieldOnFile: 'Fehlende erforderliche Meta-Felder in %{fileName}',
    missingRequiredMetaFields: {
        '0': 'Fehlendes erforderliches Meta-Feld: %{fields}.',
        '1': 'Fehlende erforderliche Meta-Felder: %{fields}.'
    },
    myDevice: "Mein Ger\xe4t",
    noCameraDescription: "Bitte Kamera anschlie\xdfen, um Bilder oder Videos aufzunehmen",
    noCameraTitle: "Kamera nicht verf\xfcgbar",
    noDuplicates: "Datei '%{fileName}' existiert bereits und kann nicht erneut hinzugef\xfcgt werden",
    noFilesFound: 'Sie haben hier keine Dateien oder Ordner',
    noInternetConnection: 'Keine Internetverbindung',
    noMoreFilesAllowed: "W\xe4hrend der Upload l\xe4uft, k\xf6nnen keine weiteren Dateien hinzugef\xfcgt werden",
    openFolderNamed: "Ordner %{name} \xf6ffnen",
    pause: 'Pausieren',
    paused: 'Pausiert',
    pauseUpload: 'Hochladen pausieren',
    pluginNameBox: 'Box',
    pluginNameCamera: 'Kamera',
    pluginNameDropbox: 'Dropbox',
    pluginNameFacebook: 'Facebook',
    pluginNameGoogleDrive: 'Google Drive',
    pluginNameInstagram: 'Instagram',
    pluginNameOneDrive: 'OneDrive',
    pluginNameZoom: 'Zoom',
    poweredBy: 'Powered by %{uppy}',
    processingXFiles: {
        '0': 'Eine Datei verarbeiten',
        '1': '%{smart_count} Dateien verarbeiten'
    },
    recording: 'Aufnahme',
    recordingLength: 'Aufnahmedauer %{recording_length}',
    recordingStoppedMaxSize: "Die Aufnahme wurde gestoppt, weil die Dateigr\xf6\xdfe das Limit \xfcberschritten hat",
    recordVideoBtn: 'Video aufnehmen',
    recoveredAllFiles: "Wir haben alle Dateien wiederhergestellt. Sie k\xf6nnen mit dem Hochladen fortfahren.",
    recoveredXFiles: {
        '0': "Wir konnten eine Datei nicht vollst\xe4ndig wiederherstellen. Bitte w\xe4hlen Sie sie erneut aus und fahren Sie dann mit dem Hochladen fort.",
        '1': "Wir konnten %{smart_count} Dateien nicht vollst\xe4ndig wiederherstellen. Bitte w\xe4hlen Sie sie erneut aus und fahren Sie dann mit dem Hochladen fort."
    },
    removeFile: 'Datei entfernen',
    reSelect: "Erneut ausw\xe4hlen",
    resetFilter: "Filter zur\xfccksetzen",
    resume: 'Fortsetzen',
    resumeUpload: 'Hochladen fortsetzen',
    retry: 'Erneut versuchen',
    retryUpload: 'Hochladen erneut versuchen',
    revert: "R\xfcckg\xe4ngig machen",
    rotate: 'Drehen',
    save: 'Speichern',
    saveChanges: "\xc4nderungen speichern",
    searchImages: 'Suche nach Bildern',
    selectX: {
        '0': "W\xe4hlen Sie %{smart_count}",
        '1': "W\xe4hlen Sie %{smart_count}"
    },
    sessionRestored: '',
    smile: "Bitte l\xe4cheln!",
    startCapturing: 'Bildschirmaufnahme starten',
    startRecording: 'Videoaufnahme starten',
    stopCapturing: 'Bildschirmaufnahme stoppen',
    stopRecording: 'Videoaufnahme stoppen',
    streamActive: 'Stream aktiv',
    streamPassive: 'Stream passiv',
    submitRecordedFile: 'Aufgezeichnete Datei verwenden',
    takePicture: 'Ein Foto aufnehmen',
    takePictureBtn: 'Foto aufnehmen',
    timedOut: "Upload f\xfcr %{seconds} Sekunden stehen geblieben, breche ab.",
    upload: 'Hochladen',
    uploadComplete: 'Hochladen abgeschlossen',
    uploadFailed: 'Hochladen fehlgeschlagen',
    uploading: 'Wird hochgeladen',
    uploadingXFiles: {
        '0': 'Eine Datei wird hochgeladen',
        '1': '%{smart_count} Dateien werden hochgeladen'
    },
    uploadPaused: 'Hochladen pausiert',
    uploadXFiles: {
        '0': 'Eine Datei hochladen',
        '1': '%{smart_count} Dateien hochladen'
    },
    uploadXNewFiles: {
        '0': '+%{smart_count} Datei hochladen',
        '1': '+%{smart_count} Dateien hochladen'
    },
    xFilesSelected: {
        '0': "Eine Datei ausgew\xe4hlt",
        '1': "%{smart_count} Dateien ausgew\xe4hlt"
    },
    xMoreFilesAdded: {
        '0': "Eine weitere Datei hinzugef\xfcgt",
        '1': "%{smart_count} weitere Dateien hinzugef\xfcgt"
    },
    xTimeLeft: '%{time} verbleibend',
    youCanOnlyUploadFileTypes: "Sie k\xf6nnen nur folgende Dateitypen hochladen: %{types}",
    youCanOnlyUploadX: {
        '0': "Sie k\xf6nnen nur eine Datei hochladen",
        '1': "Sie k\xf6nnen nur %{smart_count} Dateien hochladen"
    },
    youHaveToAtLeastSelectX: {
        '0': "Sie m\xfcssen mindestens eine Datei ausw\xe4hlen",
        '1': "Sie m\xfcssen mindestens %{smart_count} Dateien ausw\xe4hlen"
    },
    zoomIn: "Vergr\xf6\xdfern",
    zoomOut: 'Verkleinern'
};
// TODO: remove this in the next major?
// @ts-expect-error Uppy can be a global in legacy bundle
if (typeof Uppy !== 'undefined') // @ts-expect-error Uppy can be a global in legacy bundle
globalThis.Uppy.locales.de_DE = $4dcbb1f6ebd585d1$var$de_DE;
var $4dcbb1f6ebd585d1$export$2e2bcd8739ae039 = $4dcbb1f6ebd585d1$var$de_DE;


const $eb5fbf45bcb54698$var$fr_FR = {
    strings: {},
    pluralize (n) {
        if (n <= 1) return 0;
        return 1;
    }
};
$eb5fbf45bcb54698$var$fr_FR.strings = {
    addBulkFilesFailed: {
        '0': "L\u2019ajout de %{smart_count} fichier a \xe9chou\xe9",
        '1': "L\u2019ajout de %{smart_count} fichiers a \xe9chou\xe9"
    },
    addedNumFiles: "%{numFiles} fichier(s) ajout\xe9(s)",
    addingMoreFiles: 'Ajout de fichiers',
    addMore: "Ajouter d\u2019autres",
    addMoreFiles: "Ajouter d\u2019autres fichiers",
    allFilesFromFolderNamed: 'Tous les fichiers du dossier %{name}',
    allowAccessDescription: "Pour prendre des photos ou enregistrer une vid\xe9o, veuillez autoriser l\u2019acc\xe8s \xe0 votre cam\xe9ra pour ce site.",
    allowAccessTitle: "Veuillez autoriser l\u2019acc\xe8s \xe0 votre cam\xe9ra",
    authAborted: 'Authentification interrompue',
    authenticateWith: "Se connecter \xe0 %{pluginName}",
    authenticateWithTitle: "Veuillez vous authentifier avec %{pluginName} pour s\xe9lectionner les fichiers",
    back: 'Retour',
    browse: 'naviguer',
    browseFiles: 'naviguer',
    cancel: 'Annuler',
    cancelUpload: "Annuler le t\xe9l\xe9versement",
    chooseFiles: 'Choisir des fichiers',
    closeModal: "Fermer la fen\xeatre",
    companionError: "Connexion \xe0 Companion a \xe9chou\xe9",
    companionUnauthorizeHint: "Pour vous d\xe9connecter de votre compte %{provider}, veuillez aller \xe0 %{url}",
    complete: "Termin\xe9",
    compressedX: "%{size} \xe9conomis\xe9(s) par la compression",
    compressingImages: "Compression des images\u2026",
    connectedToInternet: "Connect\xe9 \xe0 Internet",
    copyLink: 'Copier le lien',
    copyLinkToClipboardFallback: 'Copier le lien ci-dessous',
    copyLinkToClipboardSuccess: "Lien copi\xe9",
    creatingAssembly: "Pr\xe9paration du t\xe9l\xe9versement\u2026",
    creatingAssemblyFailed: "Transloadit: Impossible de cr\xe9er Assembly",
    dashboardTitle: "T\xe9l\xe9verseur de fichiers",
    dashboardWindowTitle: "Fen\xeatre de t\xe9l\xe9versement de fichiers (Appuyez sur \xc9chap pour fermer)",
    dataUploadedOfTotal: '%{complete} sur %{total}',
    done: "Termin\xe9",
    dropHereOr: "D\xe9poser les fichiers ici ou %{browse}",
    dropHint: "D\xe9posez vos fichiers ici",
    dropPasteBoth: "D\xe9poser les fichiers ici, coller ou %{browse}",
    dropPasteFiles: "D\xe9poser les fichiers ici, coller ou %{browse}",
    dropPasteFolders: "D\xe9poser les fichiers ici, coller ou %{browse}",
    dropPasteImportBoth: "D\xe9poser les fichiers ici, coller, %{browse} ou importer de",
    dropPasteImportFiles: "D\xe9poser les fichiers ici, coller, %{browse} ou importer de",
    dropPasteImportFolders: "D\xe9poser les fichiers ici, coller, %{browse} ou importer de",
    editFile: 'Modifier le fichier',
    editImage: "Modifier l\u2019image",
    editFileWithFilename: 'Modifier le fichier %{file}',
    editing: 'Modification en cours de %{file}',
    emptyFolderAdded: "Aucun fichier n\u2019a \xe9t\xe9 ajout\xe9 depuis un dossier vide",
    encoding: "Traitement\u2026",
    enterCorrectUrl: 'Lien incorrect: Assurez-vous que vous entrez un lien direct vers le fichier',
    enterUrlToImport: 'Entrez le lien pour importer un fichier',
    exceedsSize: "Ce fichier d\xe9passe la taille maximale autoris\xe9e de %{size}",
    failedToFetch: "Companion a \xe9chou\xe9 \xe0 r\xe9cup\xe9rer ce lien, assurez-vous qu\u2019il est correct",
    failedToUpload: "Le t\xe9l\xe9versement de %{file} a \xe9chou\xe9",
    fileSource: 'Fichier source: %{name}',
    filesUploadedOfTotal: {
        '0': "%{complete} sur %{smart_count} fichier t\xe9l\xe9vers\xe9",
        '1': "%{complete} sur %{smart_count} fichiers t\xe9l\xe9vers\xe9s"
    },
    filter: 'Filtrer',
    finishEditingFile: "Terminer l\u2019\xe9dition du fichier",
    folderAdded: {
        '0': "%{smart_count} fichier ajout\xe9 de %{folder}",
        '1': "%{smart_count} fichiers ajout\xe9s de %{folder}"
    },
    generatingThumbnails: "G\xe9n\xe9ration des vignettes\u2026",
    import: 'Importer',
    importFrom: 'Importer de %{name}',
    loading: "Chargement\u2026",
    logOut: "D\xe9connexion",
    micDisabled: "Acc\xe8s au micro refus\xe9 par l\u2019utilisateur",
    myDevice: 'Mon Appareil',
    noDuplicates: 'Impossible d\u2019ajouter le fichier "%{fileName}", il existe d\xe9j\xe0',
    noFilesFound: "Vous n\u2019avez aucun fichier ou dossier ici",
    noInternetConnection: "Pas de connexion \xe0 Internet",
    noMoreFilesAllowed: "Impossible d\u2019ajouter de nouveaux fichiers: en cours de chargement ",
    openFolderNamed: 'Ouvrir %{name}',
    pause: 'Pause',
    pauseUpload: "Mettre en pause le t\xe9l\xe9versement",
    paused: 'En pause',
    poweredBy: "Propuls\xe9 par %{uppy}",
    processingXFiles: {
        '0': 'Traitement de %{smart_count} fichier',
        '1': 'Traitement de %{smart_count} fichiers'
    },
    recording: 'Enregistrement',
    recordingLength: "Dur\xe9e d\u2019enregistrement %{recording_length}",
    recordingStoppedMaxSize: "L\u2019enregistrement s\u2019est arr\xe9t\xe9 car la taille du fichier d\xe9passe la limite",
    removeFile: 'Effacer le fichier %{file}',
    resetFilter: "R\xe9initialiser filtre",
    resume: 'Reprendre',
    resumeUpload: "Reprendre le t\xe9l\xe9versement",
    retry: "R\xe9essayer",
    retryUpload: "R\xe9essayer le t\xe9l\xe9versement",
    save: 'Sauvegarder',
    saveChanges: 'Sauvegarder les modifications',
    selectFileNamed: "S\xe9lectionner le fichier %{name}",
    selectX: {
        '0': "S\xe9lectionner %{smart_count}",
        '1': "S\xe9lectionner %{smart_count}"
    },
    smile: 'Souriez !',
    startRecording: "Commencer l\u2019enregistrement vid\xe9o",
    stopRecording: "Arr\xeater l\u2019enregistrement vid\xe9o",
    streamActive: 'Stream actif',
    streamPassive: 'Stream passif',
    submitRecordedFile: "Envoyer la vid\xe9o enregistr\xe9e",
    takePicture: 'Prendre une photo',
    timedOut: "T\xe9l\xe9versement bloqu\xe9 durant %{seconds} secondes, annulation.",
    unselectFileNamed: "D\xe9s\xe9lectionner le fichier %{name}",
    upload: "T\xe9l\xe9verser",
    uploadComplete: "T\xe9l\xe9versement termin\xe9",
    uploadFailed: "Le t\xe9l\xe9versement a \xe9chou\xe9",
    uploadPaused: "T\xe9l\xe9versement mis en pause",
    uploadStalled: "T\xe9l\xe9versement bloqu\xe9 depuis %{seconds} secondes. Il est peut-\xeatre n\xe9cessaire de recommencer l\u2019op\xe9ration.",
    uploadXFiles: {
        '0': "T\xe9l\xe9verser %{smart_count} fichier",
        '1': "T\xe9l\xe9verser %{smart_count} fichiers"
    },
    uploadXNewFiles: {
        '0': "T\xe9l\xe9verser +%{smart_count} fichier",
        '1': "T\xe9l\xe9verser +%{smart_count} fichiers"
    },
    uploading: "T\xe9l\xe9versement en cours",
    uploadingXFiles: {
        '0': "T\xe9l\xe9versement de %{smart_count} fichier",
        '1': "T\xe9l\xe9versement de %{smart_count} fichiers"
    },
    xFilesSelected: {
        '0': "%{smart_count} fichier s\xe9lectionn\xe9",
        '1': "%{smart_count} fichiers s\xe9lectionn\xe9s"
    },
    xMoreFilesAdded: {
        '0': "%{smart_count} autre fichier ajout\xe9",
        '1': "%{smart_count} autres fichiers ajout\xe9s"
    },
    xTimeLeft: '%{time} restantes',
    youCanOnlyUploadFileTypes: "Vous pouvez seulement t\xe9l\xe9verser: %{types}",
    youCanOnlyUploadX: {
        '0': "Vous pouvez seulement t\xe9l\xe9verser %{smart_count} fichier",
        '1': "Vous pouvez seulement t\xe9l\xe9verser %{smart_count} fichiers"
    },
    youHaveToAtLeastSelectX: {
        '0': "Vous devez s\xe9lectionner au moins %{smart_count} fichier",
        '1': "Vous devez s\xe9lectionner au moins %{smart_count} fichiers"
    }
};
// TODO: remove this in the next major?
// @ts-expect-error Uppy can be a global in legacy bundle
if (typeof Uppy !== 'undefined') // @ts-expect-error Uppy can be a global in legacy bundle
globalThis.Uppy.locales.fr_FR = $eb5fbf45bcb54698$var$fr_FR;
var $eb5fbf45bcb54698$export$2e2bcd8739ae039 = $eb5fbf45bcb54698$var$fr_FR;


const $17e4618551887cdb$var$it_IT = {
    strings: {},
    pluralize (n) {
        if (n === 1) return 0;
        return 1;
    }
};
$17e4618551887cdb$var$it_IT.strings = {
    addMoreFiles: "Aggiungi pi\xf9 file",
    addingMoreFiles: 'Sto aggiungendo altri file',
    allowAccessDescription: "Per acquisire foto o video con la tua fotocamera, abilitane l'accesso da questo sito.",
    allowAccessTitle: "Abilita l'accesso alla fotocamera",
    authenticateWith: 'Connetti a %{pluginName}',
    authenticateWithTitle: 'Autenticati con %{pluginName} per selezionare i file',
    back: 'Indietro',
    addMore: "Aggiungi pi\xf9",
    browse: 'sfoglia',
    browseFiles: 'sfoglia',
    cancel: 'Annulla',
    cancelUpload: 'Annulla upload',
    chooseFiles: 'Scegli i file',
    closeModal: 'Chiudi modale',
    companionError: 'Connessione con Companion fallita',
    complete: 'Completato',
    connectedToInternet: 'Connesso a internet',
    copyLink: 'Copia link',
    copyLinkToClipboardFallback: "Copia l'URL sottostante",
    copyLinkToClipboardSuccess: 'Link copiato',
    creatingAssembly: 'Upload in preparazione...',
    creatingAssemblyFailed: "Transloadit: Non ho potuto creare l'Assembly",
    dashboardTitle: 'File Uploader',
    dashboardWindowTitle: 'File Uploader (Premi Esc per chiudere)',
    dataUploadedOfTotal: '%{complete} di %{total}',
    done: 'Fatto',
    dropHereOr: 'Trascina i file qui o %{browse}',
    dropHint: 'Trascina i file qui',
    dropPasteBoth: 'Trascina i file qui, incolla o %{browse}',
    dropPasteFiles: 'Trascina i file qui, incolla o %{browse}',
    dropPasteFolders: 'Trascina i file qui, incolla o %{browse}',
    dropPasteImportBoth: 'Trascina i file qui, incolla, %{browse} o importa da',
    dropPasteImportFiles: 'Trascina i file qui, incolla, %{browse} o importa da',
    dropPasteImportFolders: 'Trascina i file qui, incolla, %{browse} o importa da',
    editFile: 'Modifica file',
    editImage: 'Modifica immagine',
    editing: 'Modifica %{file}',
    emptyFolderAdded: 'Nessun file aggiunto dalla cartella vuota',
    encoding: 'Encoding...',
    enterCorrectUrl: 'URL non corretta: assicurati che sia un link diretto ad un file',
    enterUrlToImport: "Immetti l'URL per importare un file",
    exceedsSize: 'Questo file supera la dimensione massima di %{size}',
    failedToFetch: 'Impossibile verificare questa URL, assicurati che sia corretta',
    failedToUpload: 'Upload del file %{file} non riuscito',
    fileSource: 'Sorgente file: %{name}',
    filesUploadedOfTotal: {
        '0': '%{complete} di %{smart_count} file caricato',
        '1': '%{complete} di %{smart_count} file caricati'
    },
    filter: 'Filter',
    finishEditingFile: 'Finish editing file',
    folderAdded: {
        '0': 'Aggiunto %{smart_count} file da %{folder}',
        '1': 'Aggiunti %{smart_count} file da %{folder}'
    },
    import: 'Importa',
    importFrom: 'Importa da %{name}',
    loading: 'Caricamento...',
    logOut: 'Logout',
    myDevice: 'Il mio computer',
    noFilesFound: 'Non hai file o cartelle qui',
    noInternetConnection: 'Nessuna connessione a internet',
    pause: 'Pausa',
    pauseUpload: 'Pausa upload',
    paused: 'In pausa',
    poweredBy: 'Powered by %{uppy}',
    processingXFiles: {
        '0': 'Sto processando %{smart_count} file',
        '1': 'Sto processando %{smart_count} file'
    },
    removeFile: 'Rimuovi il file',
    resetFilter: 'Ripristina filtro',
    resume: 'Riprendi',
    resumeUpload: "Riprendi l'upload",
    retry: 'Riprova',
    retryUpload: "Riprova l'upload",
    saveChanges: 'Salva le modifiche',
    selectX: {
        '0': 'Seleziona %{smart_count}',
        '1': 'Seleziona %{smart_count}'
    },
    smile: 'Sorridi!',
    startRecording: 'Inizia la registrazione del video',
    stopRecording: 'Interrompi la registrazione del video',
    takePicture: 'Scatta una foto',
    timedOut: 'Upload fermo da %{seconds} secondi, sto annullando.',
    upload: 'Upload',
    uploadComplete: 'Upload completato',
    uploadFailed: 'Upload non riuscito',
    uploadPaused: 'Upload in pausa',
    uploadXFiles: {
        '0': 'Upload di %{smart_count} file',
        '1': 'Upload di %{smart_count} file'
    },
    uploadXNewFiles: {
        '0': 'Upload +%{smart_count} file',
        '1': 'Upload +%{smart_count} file'
    },
    uploading: 'In caricamento',
    uploadingXFiles: {
        '0': 'Caricando %{smart_count} file',
        '1': 'Caricando %{smart_count} file'
    },
    xFilesSelected: {
        '0': '%{smart_count} file selezionato',
        '1': '%{smart_count} file selezionati'
    },
    xMoreFilesAdded: {
        '0': '%{smart_count} alto file aggiunto',
        '1': '%{smart_count} altri file aggiunti'
    },
    xTimeLeft: '%{time} rimasto',
    youCanOnlyUploadFileTypes: 'Puoi caricare solamente: %{types}',
    youCanOnlyUploadX: {
        '0': 'Puoi caricare %{smart_count} solo file',
        '1': 'Puoi caricare solo %{smart_count} file'
    },
    youHaveToAtLeastSelectX: {
        '0': 'Devi selezionare almeno %{smart_count} file',
        '1': 'Devi selezionare almeno %{smart_count} file'
    },
    selectFileNamed: 'Seleziona il file %{name}',
    unselectFileNamed: 'Deseleziona il file %{name}',
    openFolderNamed: 'Cartella aperta %{name}'
};
// TODO: remove this in the next major?
// @ts-expect-error Uppy can be a global in legacy bundle
if (typeof Uppy !== 'undefined') // @ts-expect-error Uppy can be a global in legacy bundle
globalThis.Uppy.locales.it_IT = $17e4618551887cdb$var$it_IT;
var $17e4618551887cdb$export$2e2bcd8739ae039 = $17e4618551887cdb$var$it_IT;


const $e8c2aad43689e7e3$var$en_US = {
    strings: {},
    pluralize (count) {
        if (count === 1) return 0;
        return 1;
    }
};
$e8c2aad43689e7e3$var$en_US.strings = {
    addBulkFilesFailed: {
        '0': 'Failed to add %{smart_count} file due to an internal error',
        '1': 'Failed to add %{smart_count} files due to internal errors'
    },
    addedNumFiles: 'Added %{numFiles} file(s)',
    addingMoreFiles: 'Adding more files',
    additionalRestrictionsFailed: '%{count} additional restrictions were not fulfilled',
    addMore: 'Add more',
    addMoreFiles: 'Add more files',
    allFilesFromFolderNamed: 'All files from folder %{name}',
    allowAccessDescription: 'In order to take pictures or record video with your camera, please allow camera access for this site.',
    allowAccessTitle: 'Please allow access to your camera',
    allowAudioAccessDescription: 'In order to record audio, please allow microphone access for this site.',
    allowAudioAccessTitle: 'Please allow access to your microphone',
    aspectRatioLandscape: 'Crop landscape (16:9)',
    aspectRatioPortrait: 'Crop portrait (9:16)',
    aspectRatioSquare: 'Crop square',
    authAborted: 'Authentication aborted',
    authenticateWith: 'Connect to %{pluginName}',
    authenticateWithTitle: 'Please authenticate with %{pluginName} to select files',
    back: 'Back',
    browse: 'browse',
    browseFiles: 'browse files',
    browseFolders: 'browse folders',
    cancel: 'Cancel',
    cancelUpload: 'Cancel upload',
    chooseFiles: 'Choose files',
    closeModal: 'Close Modal',
    companionError: 'Connection with Companion failed',
    companionUnauthorizeHint: 'To unauthorize to your %{provider} account, please go to %{url}',
    complete: 'Complete',
    compressedX: 'Saved %{size} by compressing images',
    compressingImages: 'Compressing images...',
    connectedToInternet: 'Connected to the Internet',
    copyLink: 'Copy link',
    copyLinkToClipboardFallback: 'Copy the URL below',
    copyLinkToClipboardSuccess: 'Link copied to clipboard.',
    creatingAssembly: 'Preparing upload...',
    creatingAssemblyFailed: 'Transloadit: Could not create Assembly',
    dashboardTitle: 'Uppy Dashboard',
    dashboardWindowTitle: 'Uppy Dashboard Window (Press escape to close)',
    dataUploadedOfTotal: '%{complete} of %{total}',
    discardRecordedFile: 'Discard recorded file',
    done: 'Done',
    dropHereOr: 'Drop here or %{browse}',
    dropHint: 'Drop your files here',
    dropPasteBoth: 'Drop files here, %{browseFiles} or %{browseFolders}',
    dropPasteFiles: 'Drop files here or %{browseFiles}',
    dropPasteFolders: 'Drop files here or %{browseFolders}',
    dropPasteImportBoth: 'Drop files here, %{browseFiles}, %{browseFolders} or import from:',
    dropPasteImportFiles: 'Drop files here, %{browseFiles} or import from:',
    dropPasteImportFolders: 'Drop files here, %{browseFolders} or import from:',
    editFile: 'Edit file',
    editImage: 'Edit image',
    editFileWithFilename: 'Edit file %{file}',
    editing: 'Editing %{file}',
    emptyFolderAdded: 'No files were added from empty folder',
    encoding: 'Encoding...',
    enterCorrectUrl: 'Incorrect URL: Please make sure you are entering a direct link to a file',
    enterTextToSearch: 'Enter text to search for images',
    enterUrlToImport: 'Enter URL to import a file',
    error: 'Error',
    exceedsSize: '%{file} exceeds maximum allowed size of %{size}',
    failedToFetch: "Companion failed to fetch this URL, please make sure it\u2019s correct",
    failedToUpload: 'Failed to upload %{file}',
    filesUploadedOfTotal: {
        '0': '%{complete} of %{smart_count} file uploaded',
        '1': '%{complete} of %{smart_count} files uploaded'
    },
    filter: 'Filter',
    finishEditingFile: 'Finish editing file',
    flipHorizontal: 'Flip horizontal',
    folderAdded: {
        '0': 'Added %{smart_count} file from %{folder}',
        '1': 'Added %{smart_count} files from %{folder}'
    },
    folderAlreadyAdded: 'The folder "%{folder}" was already added',
    generatingThumbnails: 'Generating thumbnails...',
    import: 'Import',
    importFiles: 'Import files from:',
    importFrom: 'Import from %{name}',
    inferiorSize: 'This file is smaller than the allowed size of %{size}',
    loadedXFiles: 'Loaded %{numFiles} files',
    loading: 'Loading...',
    logOut: 'Log out',
    micDisabled: 'Microphone access denied by user',
    missingRequiredMetaField: 'Missing required meta fields',
    missingRequiredMetaFieldOnFile: 'Missing required meta fields in %{fileName}',
    missingRequiredMetaFields: {
        '0': 'Missing required meta field: %{fields}.',
        '1': 'Missing required meta fields: %{fields}.'
    },
    myDevice: 'My Device',
    noAudioDescription: 'In order to record audio, please connect a microphone or another audio input device',
    noAudioTitle: 'Microphone Not Available',
    noCameraDescription: 'In order to take pictures or record video, please connect a camera device',
    noCameraTitle: 'Camera Not Available',
    noDuplicates: "Cannot add the duplicate file '%{fileName}', it already exists",
    noFilesFound: 'You have no files or folders here',
    noInternetConnection: 'No Internet connection',
    noMoreFilesAllowed: 'Cannot add more files',
    noSearchResults: 'Unfortunately, there are no results for this search',
    openFolderNamed: 'Open folder %{name}',
    pause: 'Pause',
    paused: 'Paused',
    pauseUpload: 'Pause upload',
    pluginNameAudio: 'Audio',
    pluginNameBox: 'Box',
    pluginNameCamera: 'Camera',
    pluginNameDropbox: 'Dropbox',
    pluginNameFacebook: 'Facebook',
    pluginNameGoogleDrive: 'Google Drive',
    pluginNameInstagram: 'Instagram',
    pluginNameOneDrive: 'OneDrive',
    pluginNameZoom: 'Zoom',
    poweredBy: 'Powered by %{uppy}',
    processingXFiles: {
        '0': 'Processing %{smart_count} file',
        '1': 'Processing %{smart_count} files'
    },
    recording: 'Recording',
    recordingLength: 'Recording length %{recording_length}',
    recordingStoppedMaxSize: 'Recording stopped because the file size is about to exceed the limit',
    recordVideoBtn: 'Record Video',
    recoveredAllFiles: 'We restored all files. You can now resume the upload.',
    recoveredXFiles: {
        '0': 'We could not fully recover 1 file. Please re-select it and resume the upload.',
        '1': 'We could not fully recover %{smart_count} files. Please re-select them and resume the upload.'
    },
    removeFile: 'Remove file',
    reSelect: 'Re-select',
    resetFilter: 'Reset filter',
    resetSearch: 'Reset search',
    resume: 'Resume',
    resumeUpload: 'Resume upload',
    retry: 'Retry',
    retryUpload: 'Retry upload',
    revert: 'Revert',
    rotate: 'Rotate',
    save: 'Save',
    saveChanges: 'Save changes',
    search: 'Search',
    searchImages: 'Search for images',
    selectX: {
        '0': 'Select %{smart_count}',
        '1': 'Select %{smart_count}'
    },
    sessionRestored: 'Session restored',
    showErrorDetails: 'Show error details',
    signInWithGoogle: 'Sign in with Google',
    smile: 'Smile!',
    startAudioRecording: 'Begin audio recording',
    startCapturing: 'Begin screen capturing',
    startRecording: 'Begin video recording',
    stopAudioRecording: 'Stop audio recording',
    stopCapturing: 'Stop screen capturing',
    stopRecording: 'Stop video recording',
    streamActive: 'Stream active',
    streamPassive: 'Stream passive',
    submitRecordedFile: 'Submit recorded file',
    takePicture: 'Take a picture',
    takePictureBtn: 'Take Picture',
    timedOut: 'Upload stalled for %{seconds} seconds, aborting.',
    upload: 'Upload',
    uploadComplete: 'Upload complete',
    uploadFailed: 'Upload failed',
    uploading: 'Uploading',
    uploadingXFiles: {
        '0': 'Uploading %{smart_count} file',
        '1': 'Uploading %{smart_count} files'
    },
    uploadPaused: 'Upload paused',
    uploadStalled: 'Upload has not made any progress for %{seconds} seconds. You may want to retry it.',
    uploadXFiles: {
        '0': 'Upload %{smart_count} file',
        '1': 'Upload %{smart_count} files'
    },
    uploadXNewFiles: {
        '0': 'Upload +%{smart_count} file',
        '1': 'Upload +%{smart_count} files'
    },
    xFilesSelected: {
        '0': '%{smart_count} file selected',
        '1': '%{smart_count} files selected'
    },
    xMoreFilesAdded: {
        '0': '%{smart_count} more file added',
        '1': '%{smart_count} more files added'
    },
    xTimeLeft: '%{time} left',
    youCanOnlyUploadFileTypes: 'You can only upload: %{types}',
    youCanOnlyUploadX: {
        '0': 'You can only upload %{smart_count} file',
        '1': 'You can only upload %{smart_count} files'
    },
    youHaveToAtLeastSelectX: {
        '0': 'You have to select at least %{smart_count} file',
        '1': 'You have to select at least %{smart_count} files'
    },
    zoomIn: 'Zoom in',
    zoomOut: 'Zoom out'
};
// TODO: remove this in the next major?
// @ts-expect-error Uppy can be a global in legacy bundle
if (typeof Uppy !== 'undefined') // @ts-expect-error Uppy can be a global in legacy bundle
globalThis.Uppy.locales.en_US = $e8c2aad43689e7e3$var$en_US;
var $e8c2aad43689e7e3$export$2e2bcd8739ae039 = $e8c2aad43689e7e3$var$en_US;


class $2b8eccc7b4db22b8$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super(), this.isWithinIFrame = false;
        this.api = this.getAttribute('data-tk-api') || undefined;
        this.moveAPI = this.getAttribute('data-tk-move-api') || undefined;
        this.usage = this.getAttribute('data-tk-usage') || undefined;
        this.filePath = this.getAttribute('data-tk-file-path') || undefined;
        this.disableCompressor = this.hasAttribute('data-tk-disable-compressor');
        this.outputMimeType = this.getAttribute('data-tk-output-mime-type') || 'image/webp';
        this.maxNumberOfFiles = Number(this.getAttribute('data-tk-max-number-of-files')) || null;
        this.maxFileSize = Number(this.getAttribute('data-tk-max-file-size')) || null;
        this.allowedFileTypes = (this.getAttribute('data-tk-allowed-file-types') || 'image/*').split(',');
        this.locale = Number(this.getAttribute('data-tk-locale')) || 1;
        this.disableUniqueFileNames = this.hasAttribute('data-tk-disable-unique-file-names');
        const getLanguage = {
            1: (0, $4dcbb1f6ebd585d1$export$2e2bcd8739ae039),
            2: (0, $eb5fbf45bcb54698$export$2e2bcd8739ae039),
            3: (0, $e8c2aad43689e7e3$export$2e2bcd8739ae039),
            4: (0, $17e4618551887cdb$export$2e2bcd8739ae039)
        };
        this.language = getLanguage[this.locale];
        this.filePrefix = this.getAttribute('data-tk-file-prefix') || undefined;
        this.isWithinIFrame = this.hasAttribute('data-tk-is-within-iframe');
    }
    connectedCallback() {
        if (!this.api || !this.moveAPI || !this.usage || !this.filePath) throw new Error('FileUploadArea: Attributes are missing!');
        this.init();
    }
    init() {
        const endpoint = `${this.api}${this.usage}`;
        this.uppy = new (0, $b16b91c7840d3bff$export$2e2bcd8739ae039)();
        this.uppy.setOptions({
            restrictions: {
                maxFileSize: this.maxFileSize,
                maxNumberOfFiles: this.maxNumberOfFiles,
                allowedFileTypes: this.allowedFileTypes
            },
            locale: this.language
        });
        this.uppy.use((0, $b868dcf7a47332e3$export$2e2bcd8739ae039), {
            target: this,
            inline: true,
            width: '100%'
        });
        this.uppy.use((0, $cf91058fd9d7f8ee$export$2e2bcd8739ae039), {
            endpoint: endpoint,
            allowedMetaFields: [],
            getResponseData: (responseText, response)=>this.getResponseData(responseText, response)
        });
        !this.disableCompressor && this.uppy.use((0, $d847a4c5a8f23ad9$export$2e2bcd8739ae039), {
            mimeType: this.outputMimeType
        });
        this.uppy.on('file-added', (file)=>{
            const modifiedFileName = this.getFileName(file);
            this.uppy?.setFileMeta(file.id, {
                name: modifiedFileName
            });
            this.uppy?.setFileState(file.id, {
                name: modifiedFileName
            });
        });
    }
    async getResponseData(responseText, response) {
        if (response instanceof XMLHttpRequest && response.status === 200) {
            const response = await this.moveFile();
            const { path: path, success: success } = response.dataAsJson;
            if (!success) {
                const error = {
                    message: 'FAILED!'
                };
                this.uppy?.emit('error', error);
                this.uppy?.emit('upload-cancel', error);
            } else {
                if (this.isWithinIFrame) window.parent.postMessage({
                    mceAction: 'close',
                    content: path,
                    size: {
                        width: 0,
                        height: 0
                    }
                }, '*');
                return {
                    url: path
                };
            }
        }
    }
    async moveFile() {
        const data = {
            usage: this.usage,
            path: this.filePath
        };
        return new Promise((resolve)=>{
            (0, $1653b55d89a7adce$export$24835cb787452b46)({
                requestURL: this.moveAPI,
                resolveHandler: (success)=>resolve(success),
                payload: data
            });
        });
    }
    getFileName(file) {
        if (this.disableUniqueFileNames && this.filePrefix) return `${this.filePrefix}-${file.name}`;
        if (!this.disableUniqueFileNames && this.filePrefix) return `${this.filePrefix}-${(0, $d0666643e2ee88b4$export$2e2bcd8739ae039)()}.${file.extension}`;
        if (!this.disableUniqueFileNames && !this.filePrefix) return `${(0, $d0666643e2ee88b4$export$2e2bcd8739ae039)()}.${file.extension}`;
        return file.name;
    }
}




class $7cfc9025399237fb$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.anchor = this.querySelector('a') || undefined;
        this.emptyClassName = this.getDataAttribute('empty-class-name', 'tk-button__header--empty');
    }
    async connectedCallback() {
        if (!this.anchor) throw new Error('Compare Info: Element is missing!');
        await (0, $f8125d35cd9a4f7a$export$be9343d232c38cbb)('compareStore');
        this.store = (0, $f8125d35cd9a4f7a$export$6ccbb43953eebf8)('compareStore');
        this.unsubscribe = this.store.subscribe(()=>this.render());
        this.render();
    }
    disconnectedCallback() {
        this.unsubscribe && this.unsubscribe();
    }
    render() {
        if (!this.store) return;
        const { categories: categories } = this.store.getState();
        this.anchor?.classList.toggle(this.emptyClassName, categories.length === 0);
        this.anchor?.setAttribute('data-count', String(categories.length));
    }
}



const $fda791df831ac3d3$var$TARGET_ATTR = 'data-tk-section-target';
const $fda791df831ac3d3$var$CHECKBOX_ATTR = 'data-tk-checkbox-toggler';
class $fda791df831ac3d3$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.checkboxes = this.querySelectorAll(`[${$fda791df831ac3d3$var$CHECKBOX_ATTR}]`);
    }
    connectedCallback() {
        if (this.checkboxes.length === 0) return;
        this.registerInputListener();
        this.checkboxes.forEach((checkbox)=>{
            this.clearOtherCheckboxes(checkbox);
        });
    }
    registerInputListener() {
        this.checkboxes?.forEach((checkbox)=>{
            const onToggle = this.toggleVisibility.bind(this);
            this.pushListener({
                event: 'input',
                element: checkbox,
                action: onToggle
            });
        });
    }
    toggleVisibility(event) {
        const target = event.currentTarget;
        this.clearOtherCheckboxes(target);
        const id = target.getAttribute($fda791df831ac3d3$var$CHECKBOX_ATTR);
        const sections = this.querySelectorAll(`[${$fda791df831ac3d3$var$TARGET_ATTR}*="${id}"]`);
        sections.forEach((section)=>{
            const targetName = section.getAttribute($fda791df831ac3d3$var$TARGET_ATTR);
            if (targetName?.includes(';')) {
                const targetNames = targetName.split(';');
                const checkboxList = Array.from(this.checkboxes);
                const atLeastOneChecked = targetNames.some((name)=>{
                    const currentCheckbox = checkboxList.find((checkbox)=>checkbox.getAttribute($fda791df831ac3d3$var$CHECKBOX_ATTR) === name);
                    return currentCheckbox?.checked;
                });
                section.hidden = !atLeastOneChecked;
            } else section.hidden = !target.checked;
        });
    }
    clearOtherCheckboxes(target) {
        const checkboxList = Array.from(this.checkboxes);
        const filteredCheckboxes = checkboxList.filter((checkbox)=>checkbox !== target);
        filteredCheckboxes.forEach((checkbox)=>{
            const id = checkbox.getAttribute($fda791df831ac3d3$var$CHECKBOX_ATTR);
            const sections = this.querySelectorAll(`[${$fda791df831ac3d3$var$TARGET_ATTR}*="${id}"]`);
            sections.forEach((section)=>{
                const targetName = section.getAttribute($fda791df831ac3d3$var$TARGET_ATTR);
                if (targetName?.includes(';')) {
                    const targetNames = targetName.split(';');
                    const checkboxList = Array.from(this.checkboxes);
                    const atLeastOneChecked = targetNames.some((name)=>{
                        const currentCheckbox = checkboxList.find((checkbox)=>checkbox.getAttribute($fda791df831ac3d3$var$CHECKBOX_ATTR) === name);
                        return currentCheckbox?.checked;
                    });
                    section.hidden = !atLeastOneChecked;
                } else section.hidden = !checkbox.checked;
            });
        });
    }
}


var $5e6391609e4b352e$export$c34bb18505e1e253 = [
    "onChange",
    "onClose",
    "onDayCreate",
    "onDestroy",
    "onKeyDown",
    "onMonthChange",
    "onOpen",
    "onParseConfig",
    "onReady",
    "onValueUpdate",
    "onYearChange",
    "onPreCalendarPosition"
];
var $5e6391609e4b352e$export$ebe90cb607ad99e = {
    _disable: [],
    allowInput: false,
    allowInvalidPreload: false,
    altFormat: "F j, Y",
    altInput: false,
    altInputClass: "form-control input",
    animate: typeof window === "object" && window.navigator.userAgent.indexOf("MSIE") === -1,
    ariaDateFormat: "F j, Y",
    autoFillDefaultTime: true,
    clickOpens: true,
    closeOnSelect: true,
    conjunction: ", ",
    dateFormat: "Y-m-d",
    defaultHour: 12,
    defaultMinute: 0,
    defaultSeconds: 0,
    disable: [],
    disableMobile: false,
    enableSeconds: false,
    enableTime: false,
    errorHandler: function(err) {
        return typeof console !== "undefined" && console.warn(err);
    },
    getWeek: function(givenDate) {
        var date = new Date(givenDate.getTime());
        date.setHours(0, 0, 0, 0);
        date.setDate(date.getDate() + 3 - (date.getDay() + 6) % 7);
        var week1 = new Date(date.getFullYear(), 0, 4);
        return 1 + Math.round(((date.getTime() - week1.getTime()) / 86400000 - 3 + (week1.getDay() + 6) % 7) / 7);
    },
    hourIncrement: 1,
    ignoredFocusElements: [],
    inline: false,
    locale: "default",
    minuteIncrement: 5,
    mode: "single",
    monthSelectorType: "dropdown",
    nextArrow: "<svg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 17 17'><g></g><path d='M13.207 8.472l-7.854 7.854-0.707-0.707 7.146-7.146-7.146-7.148 0.707-0.707 7.854 7.854z' /></svg>",
    noCalendar: false,
    now: new Date(),
    onChange: [],
    onClose: [],
    onDayCreate: [],
    onDestroy: [],
    onKeyDown: [],
    onMonthChange: [],
    onOpen: [],
    onParseConfig: [],
    onReady: [],
    onValueUpdate: [],
    onYearChange: [],
    onPreCalendarPosition: [],
    plugins: [],
    position: "auto",
    positionElement: undefined,
    prevArrow: "<svg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 17 17'><g></g><path d='M5.207 8.471l7.146 7.147-0.707 0.707-7.853-7.854 7.854-7.853 0.707 0.707-7.147 7.146z' /></svg>",
    shorthandCurrentMonth: false,
    showMonths: 1,
    static: false,
    time_24hr: false,
    weekNumbers: false,
    wrap: false
};


var $983d310815fae63e$export$33e6c23ebe2ee669 = {
    weekdays: {
        shorthand: [
            "Sun",
            "Mon",
            "Tue",
            "Wed",
            "Thu",
            "Fri",
            "Sat"
        ],
        longhand: [
            "Sunday",
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday"
        ]
    },
    months: {
        shorthand: [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec"
        ],
        longhand: [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December"
        ]
    },
    daysInMonth: [
        31,
        28,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31
    ],
    firstDayOfWeek: 0,
    ordinal: function(nth) {
        var s = nth % 100;
        if (s > 3 && s < 21) return "th";
        switch(s % 10){
            case 1:
                return "st";
            case 2:
                return "nd";
            case 3:
                return "rd";
            default:
                return "th";
        }
    },
    rangeSeparator: " to ",
    weekAbbreviation: "Wk",
    scrollTitle: "Scroll to increment",
    toggleTitle: "Click to toggle",
    amPM: [
        "AM",
        "PM"
    ],
    yearAriaLabel: "Year",
    monthAriaLabel: "Month",
    hourAriaLabel: "Hour",
    minuteAriaLabel: "Minute",
    time_24hr: false
};
var $983d310815fae63e$export$2e2bcd8739ae039 = $983d310815fae63e$export$33e6c23ebe2ee669;


var $1aad83eefaa11659$export$5d04458e2a6c373e = function(number, length) {
    if (length === void 0) length = 2;
    return ("000" + number).slice(length * -1);
};
var $1aad83eefaa11659$export$7d260a2a5f8bc19e = function(bool) {
    return bool === true ? 1 : 0;
};
function $1aad83eefaa11659$export$61fc7d43ac8f84b0(fn, wait) {
    var t;
    return function() {
        var _this = this;
        var args = arguments;
        clearTimeout(t);
        t = setTimeout(function() {
            return fn.apply(_this, args);
        }, wait);
    };
}
var $1aad83eefaa11659$export$3131421a7d01b4fb = function(obj) {
    return obj instanceof Array ? obj : [
        obj
    ];
};


function $8d7d2474ed9a5f7d$export$4a80062ca50b57c7(elem, className, bool) {
    if (bool === true) return elem.classList.add(className);
    elem.classList.remove(className);
}
function $8d7d2474ed9a5f7d$export$c8a8987d4410bf2d(tag, className, content) {
    var e = window.document.createElement(tag);
    className = className || "";
    content = content || "";
    e.className = className;
    if (content !== undefined) e.textContent = content;
    return e;
}
function $8d7d2474ed9a5f7d$export$51cfe97d637c237c(node) {
    while(node.firstChild)node.removeChild(node.firstChild);
}
function $8d7d2474ed9a5f7d$export$25245567f53f158f(node, condition) {
    if (condition(node)) return node;
    else if (node.parentNode) return $8d7d2474ed9a5f7d$export$25245567f53f158f(node.parentNode, condition);
    return undefined;
}
function $8d7d2474ed9a5f7d$export$afe9d610a3284048(inputClassName, opts) {
    var wrapper = $8d7d2474ed9a5f7d$export$c8a8987d4410bf2d("div", "numInputWrapper"), numInput = $8d7d2474ed9a5f7d$export$c8a8987d4410bf2d("input", "numInput " + inputClassName), arrowUp = $8d7d2474ed9a5f7d$export$c8a8987d4410bf2d("span", "arrowUp"), arrowDown = $8d7d2474ed9a5f7d$export$c8a8987d4410bf2d("span", "arrowDown");
    if (navigator.userAgent.indexOf("MSIE 9.0") === -1) numInput.type = "number";
    else {
        numInput.type = "text";
        numInput.pattern = "\\d*";
    }
    if (opts !== undefined) for(var key in opts)numInput.setAttribute(key, opts[key]);
    wrapper.appendChild(numInput);
    wrapper.appendChild(arrowUp);
    wrapper.appendChild(arrowDown);
    return wrapper;
}
function $8d7d2474ed9a5f7d$export$e58f029f0fbfdb29(event) {
    try {
        if (typeof event.composedPath === "function") {
            var path = event.composedPath();
            return path[0];
        }
        return event.target;
    } catch (error) {
        return event.target;
    }
}



var $763bd4de3a8b9966$var$doNothing = function() {
    return undefined;
};
var $763bd4de3a8b9966$export$27a2dd9af757e89c = function(monthNumber, shorthand, locale) {
    return locale.months[shorthand ? "shorthand" : "longhand"][monthNumber];
};
var $763bd4de3a8b9966$export$9490b78b888a863f = {
    D: $763bd4de3a8b9966$var$doNothing,
    F: function(dateObj, monthName, locale) {
        dateObj.setMonth(locale.months.longhand.indexOf(monthName));
    },
    G: function(dateObj, hour) {
        dateObj.setHours((dateObj.getHours() >= 12 ? 12 : 0) + parseFloat(hour));
    },
    H: function(dateObj, hour) {
        dateObj.setHours(parseFloat(hour));
    },
    J: function(dateObj, day) {
        dateObj.setDate(parseFloat(day));
    },
    K: function(dateObj, amPM, locale) {
        dateObj.setHours(dateObj.getHours() % 12 + 12 * (0, $1aad83eefaa11659$export$7d260a2a5f8bc19e)(new RegExp(locale.amPM[1], "i").test(amPM)));
    },
    M: function(dateObj, shortMonth, locale) {
        dateObj.setMonth(locale.months.shorthand.indexOf(shortMonth));
    },
    S: function(dateObj, seconds) {
        dateObj.setSeconds(parseFloat(seconds));
    },
    U: function(_, unixSeconds) {
        return new Date(parseFloat(unixSeconds) * 1000);
    },
    W: function(dateObj, weekNum, locale) {
        var weekNumber = parseInt(weekNum);
        var date = new Date(dateObj.getFullYear(), 0, 2 + (weekNumber - 1) * 7, 0, 0, 0, 0);
        date.setDate(date.getDate() - date.getDay() + locale.firstDayOfWeek);
        return date;
    },
    Y: function(dateObj, year) {
        dateObj.setFullYear(parseFloat(year));
    },
    Z: function(_, ISODate) {
        return new Date(ISODate);
    },
    d: function(dateObj, day) {
        dateObj.setDate(parseFloat(day));
    },
    h: function(dateObj, hour) {
        dateObj.setHours((dateObj.getHours() >= 12 ? 12 : 0) + parseFloat(hour));
    },
    i: function(dateObj, minutes) {
        dateObj.setMinutes(parseFloat(minutes));
    },
    j: function(dateObj, day) {
        dateObj.setDate(parseFloat(day));
    },
    l: $763bd4de3a8b9966$var$doNothing,
    m: function(dateObj, month) {
        dateObj.setMonth(parseFloat(month) - 1);
    },
    n: function(dateObj, month) {
        dateObj.setMonth(parseFloat(month) - 1);
    },
    s: function(dateObj, seconds) {
        dateObj.setSeconds(parseFloat(seconds));
    },
    u: function(_, unixMillSeconds) {
        return new Date(parseFloat(unixMillSeconds));
    },
    w: $763bd4de3a8b9966$var$doNothing,
    y: function(dateObj, year) {
        dateObj.setFullYear(2000 + parseFloat(year));
    }
};
var $763bd4de3a8b9966$export$f5a8dc72fbf63af5 = {
    D: "",
    F: "",
    G: "(\\d\\d|\\d)",
    H: "(\\d\\d|\\d)",
    J: "(\\d\\d|\\d)\\w+",
    K: "",
    M: "",
    S: "(\\d\\d|\\d)",
    U: "(.+)",
    W: "(\\d\\d|\\d)",
    Y: "(\\d{4})",
    Z: "(.+)",
    d: "(\\d\\d|\\d)",
    h: "(\\d\\d|\\d)",
    i: "(\\d\\d|\\d)",
    j: "(\\d\\d|\\d)",
    l: "",
    m: "(\\d\\d|\\d)",
    n: "(\\d\\d|\\d)",
    s: "(\\d\\d|\\d)",
    u: "(.+)",
    w: "(\\d\\d|\\d)",
    y: "(\\d{2})"
};
var $763bd4de3a8b9966$export$55069460464ca7a9 = {
    Z: function(date) {
        return date.toISOString();
    },
    D: function(date, locale, options) {
        return locale.weekdays.shorthand[$763bd4de3a8b9966$export$55069460464ca7a9.w(date, locale, options)];
    },
    F: function(date, locale, options) {
        return $763bd4de3a8b9966$export$27a2dd9af757e89c($763bd4de3a8b9966$export$55069460464ca7a9.n(date, locale, options) - 1, false, locale);
    },
    G: function(date, locale, options) {
        return (0, $1aad83eefaa11659$export$5d04458e2a6c373e)($763bd4de3a8b9966$export$55069460464ca7a9.h(date, locale, options));
    },
    H: function(date) {
        return (0, $1aad83eefaa11659$export$5d04458e2a6c373e)(date.getHours());
    },
    J: function(date, locale) {
        return locale.ordinal !== undefined ? date.getDate() + locale.ordinal(date.getDate()) : date.getDate();
    },
    K: function(date, locale) {
        return locale.amPM[(0, $1aad83eefaa11659$export$7d260a2a5f8bc19e)(date.getHours() > 11)];
    },
    M: function(date, locale) {
        return $763bd4de3a8b9966$export$27a2dd9af757e89c(date.getMonth(), true, locale);
    },
    S: function(date) {
        return (0, $1aad83eefaa11659$export$5d04458e2a6c373e)(date.getSeconds());
    },
    U: function(date) {
        return date.getTime() / 1000;
    },
    W: function(date, _, options) {
        return options.getWeek(date);
    },
    Y: function(date) {
        return (0, $1aad83eefaa11659$export$5d04458e2a6c373e)(date.getFullYear(), 4);
    },
    d: function(date) {
        return (0, $1aad83eefaa11659$export$5d04458e2a6c373e)(date.getDate());
    },
    h: function(date) {
        return date.getHours() % 12 ? date.getHours() % 12 : 12;
    },
    i: function(date) {
        return (0, $1aad83eefaa11659$export$5d04458e2a6c373e)(date.getMinutes());
    },
    j: function(date) {
        return date.getDate();
    },
    l: function(date, locale) {
        return locale.weekdays.longhand[date.getDay()];
    },
    m: function(date) {
        return (0, $1aad83eefaa11659$export$5d04458e2a6c373e)(date.getMonth() + 1);
    },
    n: function(date) {
        return date.getMonth() + 1;
    },
    s: function(date) {
        return date.getSeconds();
    },
    u: function(date) {
        return date.getTime();
    },
    w: function(date) {
        return date.getDay();
    },
    y: function(date) {
        return String(date.getFullYear()).substring(2);
    }
};




var $d16da6e601d564a3$export$ff1a0b75284ac636 = function(_a) {
    var _b = _a.config, config = _b === void 0 ? (0, $5e6391609e4b352e$export$ebe90cb607ad99e) : _b, _c = _a.l10n, l10n = _c === void 0 ? (0, $983d310815fae63e$export$33e6c23ebe2ee669) : _c, _d = _a.isMobile, isMobile = _d === void 0 ? false : _d;
    return function(dateObj, frmt, overrideLocale) {
        var locale = overrideLocale || l10n;
        if (config.formatDate !== undefined && !isMobile) return config.formatDate(dateObj, frmt, locale);
        return frmt.split("").map(function(c, i, arr) {
            return (0, $763bd4de3a8b9966$export$55069460464ca7a9)[c] && arr[i - 1] !== "\\" ? (0, $763bd4de3a8b9966$export$55069460464ca7a9)[c](dateObj, locale, config) : c !== "\\" ? c : "";
        }).join("");
    };
};
var $d16da6e601d564a3$export$cfa2ef2687faeda2 = function(_a) {
    var _b = _a.config, config = _b === void 0 ? (0, $5e6391609e4b352e$export$ebe90cb607ad99e) : _b, _c = _a.l10n, l10n = _c === void 0 ? (0, $983d310815fae63e$export$33e6c23ebe2ee669) : _c;
    return function(date, givenFormat, timeless, customLocale) {
        if (date !== 0 && !date) return undefined;
        var locale = customLocale || l10n;
        var parsedDate;
        var dateOrig = date;
        if (date instanceof Date) parsedDate = new Date(date.getTime());
        else if (typeof date !== "string" && date.toFixed !== undefined) parsedDate = new Date(date);
        else if (typeof date === "string") {
            var format = givenFormat || (config || (0, $5e6391609e4b352e$export$ebe90cb607ad99e)).dateFormat;
            var datestr = String(date).trim();
            if (datestr === "today") {
                parsedDate = new Date();
                timeless = true;
            } else if (config && config.parseDate) parsedDate = config.parseDate(date, format);
            else if (/Z$/.test(datestr) || /GMT$/.test(datestr)) parsedDate = new Date(date);
            else {
                var matched = void 0, ops = [];
                for(var i = 0, matchIndex = 0, regexStr = ""; i < format.length; i++){
                    var token = format[i];
                    var isBackSlash = token === "\\";
                    var escaped = format[i - 1] === "\\" || isBackSlash;
                    if ((0, $763bd4de3a8b9966$export$f5a8dc72fbf63af5)[token] && !escaped) {
                        regexStr += (0, $763bd4de3a8b9966$export$f5a8dc72fbf63af5)[token];
                        var match = new RegExp(regexStr).exec(date);
                        if (match && (matched = true)) ops[token !== "Y" ? "push" : "unshift"]({
                            fn: (0, $763bd4de3a8b9966$export$9490b78b888a863f)[token],
                            val: match[++matchIndex]
                        });
                    } else if (!isBackSlash) regexStr += ".";
                }
                parsedDate = !config || !config.noCalendar ? new Date(new Date().getFullYear(), 0, 1, 0, 0, 0, 0) : new Date(new Date().setHours(0, 0, 0, 0));
                ops.forEach(function(_a) {
                    var fn = _a.fn, val = _a.val;
                    return parsedDate = fn(parsedDate, val, locale) || parsedDate;
                });
                parsedDate = matched ? parsedDate : undefined;
            }
        }
        if (!(parsedDate instanceof Date && !isNaN(parsedDate.getTime()))) {
            config.errorHandler(new Error("Invalid date provided: " + dateOrig));
            return undefined;
        }
        if (timeless === true) parsedDate.setHours(0, 0, 0, 0);
        return parsedDate;
    };
};
function $d16da6e601d564a3$export$c4c806e061935577(date1, date2, timeless) {
    if (timeless === void 0) timeless = true;
    if (timeless !== false) return new Date(date1.getTime()).setHours(0, 0, 0, 0) - new Date(date2.getTime()).setHours(0, 0, 0, 0);
    return date1.getTime() - date2.getTime();
}
function $d16da6e601d564a3$export$15d252ed5f5f8636(date1, date2) {
    return 3600 * (date1.getHours() - date2.getHours()) + 60 * (date1.getMinutes() - date2.getMinutes()) + date1.getSeconds() - date2.getSeconds();
}
var $d16da6e601d564a3$export$a4d69fb5f2026c35 = function(ts, ts1, ts2) {
    return ts > Math.min(ts1, ts2) && ts < Math.max(ts1, ts2);
};
var $d16da6e601d564a3$export$9fafc166baa96839 = function(hours, minutes, seconds) {
    return hours * 3600 + minutes * 60 + seconds;
};
var $d16da6e601d564a3$export$a4ce0def660bfe9e = function(secondsSinceMidnight) {
    var hours = Math.floor(secondsSinceMidnight / 3600), minutes = (secondsSinceMidnight - hours * 3600) / 60;
    return [
        hours,
        minutes,
        secondsSinceMidnight - hours * 3600 - minutes * 60
    ];
};
var $d16da6e601d564a3$export$1f34108aa9eb96ab = {
    DAY: 86400000
};
function $d16da6e601d564a3$export$6df0e87d3fffbd14(config) {
    var hours = config.defaultHour;
    var minutes = config.defaultMinute;
    var seconds = config.defaultSeconds;
    if (config.minDate !== undefined) {
        var minHour = config.minDate.getHours();
        var minMinutes = config.minDate.getMinutes();
        var minSeconds = config.minDate.getSeconds();
        if (hours < minHour) hours = minHour;
        if (hours === minHour && minutes < minMinutes) minutes = minMinutes;
        if (hours === minHour && minutes === minMinutes && seconds < minSeconds) seconds = config.minDate.getSeconds();
    }
    if (config.maxDate !== undefined) {
        var maxHr = config.maxDate.getHours();
        var maxMinutes = config.maxDate.getMinutes();
        hours = Math.min(hours, maxHr);
        if (hours === maxHr) minutes = Math.min(maxMinutes, minutes);
        if (hours === maxHr && minutes === maxMinutes) seconds = config.maxDate.getSeconds();
    }
    return {
        hours: hours,
        minutes: minutes,
        seconds: seconds
    };
}



"use strict";
if (typeof Object.assign !== "function") Object.assign = function(target) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    if (!target) throw TypeError("Cannot convert undefined or null to object");
    var _loop_1 = function(source) {
        if (source) Object.keys(source).forEach(function(key) {
            return target[key] = source[key];
        });
    };
    for(var _a = 0, args_1 = args; _a < args_1.length; _a++){
        var source = args_1[_a];
        _loop_1(source);
    }
    return target;
};


var $9986d07d28cc86ca$var$__assign = undefined && undefined.__assign || function() {
    $9986d07d28cc86ca$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $9986d07d28cc86ca$var$__assign.apply(this, arguments);
};
var $9986d07d28cc86ca$var$__spreadArrays = undefined && undefined.__spreadArrays || function() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
};
var $9986d07d28cc86ca$var$DEBOUNCED_CHANGE_MS = 300;
function $9986d07d28cc86ca$var$FlatpickrInstance(element, instanceConfig) {
    var self = {
        config: $9986d07d28cc86ca$var$__assign($9986d07d28cc86ca$var$__assign({}, (0, $5e6391609e4b352e$export$ebe90cb607ad99e)), $9986d07d28cc86ca$var$flatpickr.defaultConfig),
        l10n: (0, $983d310815fae63e$export$2e2bcd8739ae039)
    };
    self.parseDate = (0, $d16da6e601d564a3$export$cfa2ef2687faeda2)({
        config: self.config,
        l10n: self.l10n
    });
    self._handlers = [];
    self.pluginElements = [];
    self.loadedPlugins = [];
    self._bind = bind;
    self._setHoursFromDate = setHoursFromDate;
    self._positionCalendar = positionCalendar;
    self.changeMonth = changeMonth;
    self.changeYear = changeYear;
    self.clear = clear;
    self.close = close;
    self.onMouseOver = onMouseOver;
    self._createElement = (0, $8d7d2474ed9a5f7d$export$c8a8987d4410bf2d);
    self.createDay = createDay;
    self.destroy = destroy;
    self.isEnabled = isEnabled;
    self.jumpToDate = jumpToDate;
    self.updateValue = updateValue;
    self.open = open;
    self.redraw = redraw;
    self.set = set;
    self.setDate = setDate;
    self.toggle = toggle;
    function setupHelperFunctions() {
        self.utils = {
            getDaysInMonth: function(month, yr) {
                if (month === void 0) month = self.currentMonth;
                if (yr === void 0) yr = self.currentYear;
                if (month === 1 && (yr % 4 === 0 && yr % 100 !== 0 || yr % 400 === 0)) return 29;
                return self.l10n.daysInMonth[month];
            }
        };
    }
    function init() {
        self.element = self.input = element;
        self.isOpen = false;
        parseConfig();
        setupLocale();
        setupInputs();
        setupDates();
        setupHelperFunctions();
        if (!self.isMobile) build();
        bindEvents();
        if (self.selectedDates.length || self.config.noCalendar) {
            if (self.config.enableTime) setHoursFromDate(self.config.noCalendar ? self.latestSelectedDateObj : undefined);
            updateValue(false);
        }
        setCalendarWidth();
        var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
        if (!self.isMobile && isSafari) positionCalendar();
        triggerEvent("onReady");
    }
    function getClosestActiveElement() {
        var _a;
        return ((_a = self.calendarContainer) === null || _a === void 0 ? void 0 : _a.getRootNode()).activeElement || document.activeElement;
    }
    function bindToInstance(fn) {
        return fn.bind(self);
    }
    function setCalendarWidth() {
        var config = self.config;
        if (config.weekNumbers === false && config.showMonths === 1) return;
        else if (config.noCalendar !== true) window.requestAnimationFrame(function() {
            if (self.calendarContainer !== undefined) {
                self.calendarContainer.style.visibility = "hidden";
                self.calendarContainer.style.display = "block";
            }
            if (self.daysContainer !== undefined) {
                var daysWidth = (self.days.offsetWidth + 1) * config.showMonths;
                self.daysContainer.style.width = daysWidth + "px";
                self.calendarContainer.style.width = daysWidth + (self.weekWrapper !== undefined ? self.weekWrapper.offsetWidth : 0) + "px";
                self.calendarContainer.style.removeProperty("visibility");
                self.calendarContainer.style.removeProperty("display");
            }
        });
    }
    function updateTime(e) {
        if (self.selectedDates.length === 0) {
            var defaultDate = self.config.minDate === undefined || (0, $d16da6e601d564a3$export$c4c806e061935577)(new Date(), self.config.minDate) >= 0 ? new Date() : new Date(self.config.minDate.getTime());
            var defaults = (0, $d16da6e601d564a3$export$6df0e87d3fffbd14)(self.config);
            defaultDate.setHours(defaults.hours, defaults.minutes, defaults.seconds, defaultDate.getMilliseconds());
            self.selectedDates = [
                defaultDate
            ];
            self.latestSelectedDateObj = defaultDate;
        }
        if (e !== undefined && e.type !== "blur") timeWrapper(e);
        var prevValue = self._input.value;
        setHoursFromInputs();
        updateValue();
        if (self._input.value !== prevValue) self._debouncedChange();
    }
    function ampm2military(hour, amPM) {
        return hour % 12 + 12 * (0, $1aad83eefaa11659$export$7d260a2a5f8bc19e)(amPM === self.l10n.amPM[1]);
    }
    function military2ampm(hour) {
        switch(hour % 24){
            case 0:
            case 12:
                return 12;
            default:
                return hour % 12;
        }
    }
    function setHoursFromInputs() {
        if (self.hourElement === undefined || self.minuteElement === undefined) return;
        var hours = (parseInt(self.hourElement.value.slice(-2), 10) || 0) % 24, minutes = (parseInt(self.minuteElement.value, 10) || 0) % 60, seconds = self.secondElement !== undefined ? (parseInt(self.secondElement.value, 10) || 0) % 60 : 0;
        if (self.amPM !== undefined) hours = ampm2military(hours, self.amPM.textContent);
        var limitMinHours = self.config.minTime !== undefined || self.config.minDate && self.minDateHasTime && self.latestSelectedDateObj && (0, $d16da6e601d564a3$export$c4c806e061935577)(self.latestSelectedDateObj, self.config.minDate, true) === 0;
        var limitMaxHours = self.config.maxTime !== undefined || self.config.maxDate && self.maxDateHasTime && self.latestSelectedDateObj && (0, $d16da6e601d564a3$export$c4c806e061935577)(self.latestSelectedDateObj, self.config.maxDate, true) === 0;
        if (self.config.maxTime !== undefined && self.config.minTime !== undefined && self.config.minTime > self.config.maxTime) {
            var minBound = (0, $d16da6e601d564a3$export$9fafc166baa96839)(self.config.minTime.getHours(), self.config.minTime.getMinutes(), self.config.minTime.getSeconds());
            var maxBound = (0, $d16da6e601d564a3$export$9fafc166baa96839)(self.config.maxTime.getHours(), self.config.maxTime.getMinutes(), self.config.maxTime.getSeconds());
            var currentTime = (0, $d16da6e601d564a3$export$9fafc166baa96839)(hours, minutes, seconds);
            if (currentTime > maxBound && currentTime < minBound) {
                var result = (0, $d16da6e601d564a3$export$a4ce0def660bfe9e)(minBound);
                hours = result[0];
                minutes = result[1];
                seconds = result[2];
            }
        } else {
            if (limitMaxHours) {
                var maxTime = self.config.maxTime !== undefined ? self.config.maxTime : self.config.maxDate;
                hours = Math.min(hours, maxTime.getHours());
                if (hours === maxTime.getHours()) minutes = Math.min(minutes, maxTime.getMinutes());
                if (minutes === maxTime.getMinutes()) seconds = Math.min(seconds, maxTime.getSeconds());
            }
            if (limitMinHours) {
                var minTime = self.config.minTime !== undefined ? self.config.minTime : self.config.minDate;
                hours = Math.max(hours, minTime.getHours());
                if (hours === minTime.getHours() && minutes < minTime.getMinutes()) minutes = minTime.getMinutes();
                if (minutes === minTime.getMinutes()) seconds = Math.max(seconds, minTime.getSeconds());
            }
        }
        setHours(hours, minutes, seconds);
    }
    function setHoursFromDate(dateObj) {
        var date = dateObj || self.latestSelectedDateObj;
        if (date && date instanceof Date) setHours(date.getHours(), date.getMinutes(), date.getSeconds());
    }
    function setHours(hours, minutes, seconds) {
        if (self.latestSelectedDateObj !== undefined) self.latestSelectedDateObj.setHours(hours % 24, minutes, seconds || 0, 0);
        if (!self.hourElement || !self.minuteElement || self.isMobile) return;
        self.hourElement.value = (0, $1aad83eefaa11659$export$5d04458e2a6c373e)(!self.config.time_24hr ? (12 + hours) % 12 + 12 * (0, $1aad83eefaa11659$export$7d260a2a5f8bc19e)(hours % 12 === 0) : hours);
        self.minuteElement.value = (0, $1aad83eefaa11659$export$5d04458e2a6c373e)(minutes);
        if (self.amPM !== undefined) self.amPM.textContent = self.l10n.amPM[(0, $1aad83eefaa11659$export$7d260a2a5f8bc19e)(hours >= 12)];
        if (self.secondElement !== undefined) self.secondElement.value = (0, $1aad83eefaa11659$export$5d04458e2a6c373e)(seconds);
    }
    function onYearInput(event) {
        var eventTarget = (0, $8d7d2474ed9a5f7d$export$e58f029f0fbfdb29)(event);
        var year = parseInt(eventTarget.value) + (event.delta || 0);
        if (year / 1000 > 1 || event.key === "Enter" && !/[^\d]/.test(year.toString())) changeYear(year);
    }
    function bind(element, event, handler, options) {
        if (event instanceof Array) return event.forEach(function(ev) {
            return bind(element, ev, handler, options);
        });
        if (element instanceof Array) return element.forEach(function(el) {
            return bind(el, event, handler, options);
        });
        element.addEventListener(event, handler, options);
        self._handlers.push({
            remove: function() {
                return element.removeEventListener(event, handler, options);
            }
        });
    }
    function triggerChange() {
        triggerEvent("onChange");
    }
    function bindEvents() {
        if (self.config.wrap) [
            "open",
            "close",
            "toggle",
            "clear"
        ].forEach(function(evt) {
            Array.prototype.forEach.call(self.element.querySelectorAll("[data-" + evt + "]"), function(el) {
                return bind(el, "click", self[evt]);
            });
        });
        if (self.isMobile) {
            setupMobile();
            return;
        }
        var debouncedResize = (0, $1aad83eefaa11659$export$61fc7d43ac8f84b0)(onResize, 50);
        self._debouncedChange = (0, $1aad83eefaa11659$export$61fc7d43ac8f84b0)(triggerChange, $9986d07d28cc86ca$var$DEBOUNCED_CHANGE_MS);
        if (self.daysContainer && !/iPhone|iPad|iPod/i.test(navigator.userAgent)) bind(self.daysContainer, "mouseover", function(e) {
            if (self.config.mode === "range") onMouseOver((0, $8d7d2474ed9a5f7d$export$e58f029f0fbfdb29)(e));
        });
        bind(self._input, "keydown", onKeyDown);
        if (self.calendarContainer !== undefined) bind(self.calendarContainer, "keydown", onKeyDown);
        if (!self.config.inline && !self.config.static) bind(window, "resize", debouncedResize);
        if (window.ontouchstart !== undefined) bind(window.document, "touchstart", documentClick);
        else bind(window.document, "mousedown", documentClick);
        bind(window.document, "focus", documentClick, {
            capture: true
        });
        if (self.config.clickOpens === true) {
            bind(self._input, "focus", self.open);
            bind(self._input, "click", self.open);
        }
        if (self.daysContainer !== undefined) {
            bind(self.monthNav, "click", onMonthNavClick);
            bind(self.monthNav, [
                "keyup",
                "increment"
            ], onYearInput);
            bind(self.daysContainer, "click", selectDate);
        }
        if (self.timeContainer !== undefined && self.minuteElement !== undefined && self.hourElement !== undefined) {
            var selText = function(e) {
                return (0, $8d7d2474ed9a5f7d$export$e58f029f0fbfdb29)(e).select();
            };
            bind(self.timeContainer, [
                "increment"
            ], updateTime);
            bind(self.timeContainer, "blur", updateTime, {
                capture: true
            });
            bind(self.timeContainer, "click", timeIncrement);
            bind([
                self.hourElement,
                self.minuteElement
            ], [
                "focus",
                "click"
            ], selText);
            if (self.secondElement !== undefined) bind(self.secondElement, "focus", function() {
                return self.secondElement && self.secondElement.select();
            });
            if (self.amPM !== undefined) bind(self.amPM, "click", function(e) {
                updateTime(e);
            });
        }
        if (self.config.allowInput) bind(self._input, "blur", onBlur);
    }
    function jumpToDate(jumpDate, triggerChange) {
        var jumpTo = jumpDate !== undefined ? self.parseDate(jumpDate) : self.latestSelectedDateObj || (self.config.minDate && self.config.minDate > self.now ? self.config.minDate : self.config.maxDate && self.config.maxDate < self.now ? self.config.maxDate : self.now);
        var oldYear = self.currentYear;
        var oldMonth = self.currentMonth;
        try {
            if (jumpTo !== undefined) {
                self.currentYear = jumpTo.getFullYear();
                self.currentMonth = jumpTo.getMonth();
            }
        } catch (e) {
            e.message = "Invalid date supplied: " + jumpTo;
            self.config.errorHandler(e);
        }
        if (triggerChange && self.currentYear !== oldYear) {
            triggerEvent("onYearChange");
            buildMonthSwitch();
        }
        if (triggerChange && (self.currentYear !== oldYear || self.currentMonth !== oldMonth)) triggerEvent("onMonthChange");
        self.redraw();
    }
    function timeIncrement(e) {
        var eventTarget = (0, $8d7d2474ed9a5f7d$export$e58f029f0fbfdb29)(e);
        if (~eventTarget.className.indexOf("arrow")) incrementNumInput(e, eventTarget.classList.contains("arrowUp") ? 1 : -1);
    }
    function incrementNumInput(e, delta, inputElem) {
        var target = e && (0, $8d7d2474ed9a5f7d$export$e58f029f0fbfdb29)(e);
        var input = inputElem || target && target.parentNode && target.parentNode.firstChild;
        var event = createEvent("increment");
        event.delta = delta;
        input && input.dispatchEvent(event);
    }
    function build() {
        var fragment = window.document.createDocumentFragment();
        self.calendarContainer = (0, $8d7d2474ed9a5f7d$export$c8a8987d4410bf2d)("div", "flatpickr-calendar");
        self.calendarContainer.tabIndex = -1;
        if (!self.config.noCalendar) {
            fragment.appendChild(buildMonthNav());
            self.innerContainer = (0, $8d7d2474ed9a5f7d$export$c8a8987d4410bf2d)("div", "flatpickr-innerContainer");
            if (self.config.weekNumbers) {
                var _a = buildWeeks(), weekWrapper = _a.weekWrapper, weekNumbers = _a.weekNumbers;
                self.innerContainer.appendChild(weekWrapper);
                self.weekNumbers = weekNumbers;
                self.weekWrapper = weekWrapper;
            }
            self.rContainer = (0, $8d7d2474ed9a5f7d$export$c8a8987d4410bf2d)("div", "flatpickr-rContainer");
            self.rContainer.appendChild(buildWeekdays());
            if (!self.daysContainer) {
                self.daysContainer = (0, $8d7d2474ed9a5f7d$export$c8a8987d4410bf2d)("div", "flatpickr-days");
                self.daysContainer.tabIndex = -1;
            }
            buildDays();
            self.rContainer.appendChild(self.daysContainer);
            self.innerContainer.appendChild(self.rContainer);
            fragment.appendChild(self.innerContainer);
        }
        if (self.config.enableTime) fragment.appendChild(buildTime());
        (0, $8d7d2474ed9a5f7d$export$4a80062ca50b57c7)(self.calendarContainer, "rangeMode", self.config.mode === "range");
        (0, $8d7d2474ed9a5f7d$export$4a80062ca50b57c7)(self.calendarContainer, "animate", self.config.animate === true);
        (0, $8d7d2474ed9a5f7d$export$4a80062ca50b57c7)(self.calendarContainer, "multiMonth", self.config.showMonths > 1);
        self.calendarContainer.appendChild(fragment);
        var customAppend = self.config.appendTo !== undefined && self.config.appendTo.nodeType !== undefined;
        if (self.config.inline || self.config.static) {
            self.calendarContainer.classList.add(self.config.inline ? "inline" : "static");
            if (self.config.inline) {
                if (!customAppend && self.element.parentNode) self.element.parentNode.insertBefore(self.calendarContainer, self._input.nextSibling);
                else if (self.config.appendTo !== undefined) self.config.appendTo.appendChild(self.calendarContainer);
            }
            if (self.config.static) {
                var wrapper = (0, $8d7d2474ed9a5f7d$export$c8a8987d4410bf2d)("div", "flatpickr-wrapper");
                if (self.element.parentNode) self.element.parentNode.insertBefore(wrapper, self.element);
                wrapper.appendChild(self.element);
                if (self.altInput) wrapper.appendChild(self.altInput);
                wrapper.appendChild(self.calendarContainer);
            }
        }
        if (!self.config.static && !self.config.inline) (self.config.appendTo !== undefined ? self.config.appendTo : window.document.body).appendChild(self.calendarContainer);
    }
    function createDay(className, date, _dayNumber, i) {
        var dateIsEnabled = isEnabled(date, true), dayElement = (0, $8d7d2474ed9a5f7d$export$c8a8987d4410bf2d)("span", className, date.getDate().toString());
        dayElement.dateObj = date;
        dayElement.$i = i;
        dayElement.setAttribute("aria-label", self.formatDate(date, self.config.ariaDateFormat));
        if (className.indexOf("hidden") === -1 && (0, $d16da6e601d564a3$export$c4c806e061935577)(date, self.now) === 0) {
            self.todayDateElem = dayElement;
            dayElement.classList.add("today");
            dayElement.setAttribute("aria-current", "date");
        }
        if (dateIsEnabled) {
            dayElement.tabIndex = -1;
            if (isDateSelected(date)) {
                dayElement.classList.add("selected");
                self.selectedDateElem = dayElement;
                if (self.config.mode === "range") {
                    (0, $8d7d2474ed9a5f7d$export$4a80062ca50b57c7)(dayElement, "startRange", self.selectedDates[0] && (0, $d16da6e601d564a3$export$c4c806e061935577)(date, self.selectedDates[0], true) === 0);
                    (0, $8d7d2474ed9a5f7d$export$4a80062ca50b57c7)(dayElement, "endRange", self.selectedDates[1] && (0, $d16da6e601d564a3$export$c4c806e061935577)(date, self.selectedDates[1], true) === 0);
                    if (className === "nextMonthDay") dayElement.classList.add("inRange");
                }
            }
        } else dayElement.classList.add("flatpickr-disabled");
        if (self.config.mode === "range") {
            if (isDateInRange(date) && !isDateSelected(date)) dayElement.classList.add("inRange");
        }
        if (self.weekNumbers && self.config.showMonths === 1 && className !== "prevMonthDay" && i % 7 === 6) self.weekNumbers.insertAdjacentHTML("beforeend", "<span class='flatpickr-day'>" + self.config.getWeek(date) + "</span>");
        triggerEvent("onDayCreate", dayElement);
        return dayElement;
    }
    function focusOnDayElem(targetNode) {
        targetNode.focus();
        if (self.config.mode === "range") onMouseOver(targetNode);
    }
    function getFirstAvailableDay(delta) {
        var startMonth = delta > 0 ? 0 : self.config.showMonths - 1;
        var endMonth = delta > 0 ? self.config.showMonths : -1;
        for(var m = startMonth; m != endMonth; m += delta){
            var month = self.daysContainer.children[m];
            var startIndex = delta > 0 ? 0 : month.children.length - 1;
            var endIndex = delta > 0 ? month.children.length : -1;
            for(var i = startIndex; i != endIndex; i += delta){
                var c = month.children[i];
                if (c.className.indexOf("hidden") === -1 && isEnabled(c.dateObj)) return c;
            }
        }
        return undefined;
    }
    function getNextAvailableDay(current, delta) {
        var givenMonth = current.className.indexOf("Month") === -1 ? current.dateObj.getMonth() : self.currentMonth;
        var endMonth = delta > 0 ? self.config.showMonths : -1;
        var loopDelta = delta > 0 ? 1 : -1;
        for(var m = givenMonth - self.currentMonth; m != endMonth; m += loopDelta){
            var month = self.daysContainer.children[m];
            var startIndex = givenMonth - self.currentMonth === m ? current.$i + delta : delta < 0 ? month.children.length - 1 : 0;
            var numMonthDays = month.children.length;
            for(var i = startIndex; i >= 0 && i < numMonthDays && i != (delta > 0 ? numMonthDays : -1); i += loopDelta){
                var c = month.children[i];
                if (c.className.indexOf("hidden") === -1 && isEnabled(c.dateObj) && Math.abs(current.$i - i) >= Math.abs(delta)) return focusOnDayElem(c);
            }
        }
        self.changeMonth(loopDelta);
        focusOnDay(getFirstAvailableDay(loopDelta), 0);
        return undefined;
    }
    function focusOnDay(current, offset) {
        var activeElement = getClosestActiveElement();
        var dayFocused = isInView(activeElement || document.body);
        var startElem = current !== undefined ? current : dayFocused ? activeElement : self.selectedDateElem !== undefined && isInView(self.selectedDateElem) ? self.selectedDateElem : self.todayDateElem !== undefined && isInView(self.todayDateElem) ? self.todayDateElem : getFirstAvailableDay(offset > 0 ? 1 : -1);
        if (startElem === undefined) self._input.focus();
        else if (!dayFocused) focusOnDayElem(startElem);
        else getNextAvailableDay(startElem, offset);
    }
    function buildMonthDays(year, month) {
        var firstOfMonth = (new Date(year, month, 1).getDay() - self.l10n.firstDayOfWeek + 7) % 7;
        var prevMonthDays = self.utils.getDaysInMonth((month - 1 + 12) % 12, year);
        var daysInMonth = self.utils.getDaysInMonth(month, year), days = window.document.createDocumentFragment(), isMultiMonth = self.config.showMonths > 1, prevMonthDayClass = isMultiMonth ? "prevMonthDay hidden" : "prevMonthDay", nextMonthDayClass = isMultiMonth ? "nextMonthDay hidden" : "nextMonthDay";
        var dayNumber = prevMonthDays + 1 - firstOfMonth, dayIndex = 0;
        for(; dayNumber <= prevMonthDays; dayNumber++, dayIndex++)days.appendChild(createDay("flatpickr-day " + prevMonthDayClass, new Date(year, month - 1, dayNumber), dayNumber, dayIndex));
        for(dayNumber = 1; dayNumber <= daysInMonth; dayNumber++, dayIndex++)days.appendChild(createDay("flatpickr-day", new Date(year, month, dayNumber), dayNumber, dayIndex));
        for(var dayNum = daysInMonth + 1; dayNum <= 42 - firstOfMonth && (self.config.showMonths === 1 || dayIndex % 7 !== 0); dayNum++, dayIndex++)days.appendChild(createDay("flatpickr-day " + nextMonthDayClass, new Date(year, month + 1, dayNum % daysInMonth), dayNum, dayIndex));
        var dayContainer = (0, $8d7d2474ed9a5f7d$export$c8a8987d4410bf2d)("div", "dayContainer");
        dayContainer.appendChild(days);
        return dayContainer;
    }
    function buildDays() {
        if (self.daysContainer === undefined) return;
        (0, $8d7d2474ed9a5f7d$export$51cfe97d637c237c)(self.daysContainer);
        if (self.weekNumbers) (0, $8d7d2474ed9a5f7d$export$51cfe97d637c237c)(self.weekNumbers);
        var frag = document.createDocumentFragment();
        for(var i = 0; i < self.config.showMonths; i++){
            var d = new Date(self.currentYear, self.currentMonth, 1);
            d.setMonth(self.currentMonth + i);
            frag.appendChild(buildMonthDays(d.getFullYear(), d.getMonth()));
        }
        self.daysContainer.appendChild(frag);
        self.days = self.daysContainer.firstChild;
        if (self.config.mode === "range" && self.selectedDates.length === 1) onMouseOver();
    }
    function buildMonthSwitch() {
        if (self.config.showMonths > 1 || self.config.monthSelectorType !== "dropdown") return;
        var shouldBuildMonth = function(month) {
            if (self.config.minDate !== undefined && self.currentYear === self.config.minDate.getFullYear() && month < self.config.minDate.getMonth()) return false;
            return !(self.config.maxDate !== undefined && self.currentYear === self.config.maxDate.getFullYear() && month > self.config.maxDate.getMonth());
        };
        self.monthsDropdownContainer.tabIndex = -1;
        self.monthsDropdownContainer.innerHTML = "";
        for(var i = 0; i < 12; i++){
            if (!shouldBuildMonth(i)) continue;
            var month = (0, $8d7d2474ed9a5f7d$export$c8a8987d4410bf2d)("option", "flatpickr-monthDropdown-month");
            month.value = new Date(self.currentYear, i).getMonth().toString();
            month.textContent = (0, $763bd4de3a8b9966$export$27a2dd9af757e89c)(i, self.config.shorthandCurrentMonth, self.l10n);
            month.tabIndex = -1;
            if (self.currentMonth === i) month.selected = true;
            self.monthsDropdownContainer.appendChild(month);
        }
    }
    function buildMonth() {
        var container = (0, $8d7d2474ed9a5f7d$export$c8a8987d4410bf2d)("div", "flatpickr-month");
        var monthNavFragment = window.document.createDocumentFragment();
        var monthElement;
        if (self.config.showMonths > 1 || self.config.monthSelectorType === "static") monthElement = (0, $8d7d2474ed9a5f7d$export$c8a8987d4410bf2d)("span", "cur-month");
        else {
            self.monthsDropdownContainer = (0, $8d7d2474ed9a5f7d$export$c8a8987d4410bf2d)("select", "flatpickr-monthDropdown-months");
            self.monthsDropdownContainer.setAttribute("aria-label", self.l10n.monthAriaLabel);
            bind(self.monthsDropdownContainer, "change", function(e) {
                var target = (0, $8d7d2474ed9a5f7d$export$e58f029f0fbfdb29)(e);
                var selectedMonth = parseInt(target.value, 10);
                self.changeMonth(selectedMonth - self.currentMonth);
                triggerEvent("onMonthChange");
            });
            buildMonthSwitch();
            monthElement = self.monthsDropdownContainer;
        }
        var yearInput = (0, $8d7d2474ed9a5f7d$export$afe9d610a3284048)("cur-year", {
            tabindex: "-1"
        });
        var yearElement = yearInput.getElementsByTagName("input")[0];
        yearElement.setAttribute("aria-label", self.l10n.yearAriaLabel);
        if (self.config.minDate) yearElement.setAttribute("min", self.config.minDate.getFullYear().toString());
        if (self.config.maxDate) {
            yearElement.setAttribute("max", self.config.maxDate.getFullYear().toString());
            yearElement.disabled = !!self.config.minDate && self.config.minDate.getFullYear() === self.config.maxDate.getFullYear();
        }
        var currentMonth = (0, $8d7d2474ed9a5f7d$export$c8a8987d4410bf2d)("div", "flatpickr-current-month");
        currentMonth.appendChild(monthElement);
        currentMonth.appendChild(yearInput);
        monthNavFragment.appendChild(currentMonth);
        container.appendChild(monthNavFragment);
        return {
            container: container,
            yearElement: yearElement,
            monthElement: monthElement
        };
    }
    function buildMonths() {
        (0, $8d7d2474ed9a5f7d$export$51cfe97d637c237c)(self.monthNav);
        self.monthNav.appendChild(self.prevMonthNav);
        if (self.config.showMonths) {
            self.yearElements = [];
            self.monthElements = [];
        }
        for(var m = self.config.showMonths; m--;){
            var month = buildMonth();
            self.yearElements.push(month.yearElement);
            self.monthElements.push(month.monthElement);
            self.monthNav.appendChild(month.container);
        }
        self.monthNav.appendChild(self.nextMonthNav);
    }
    function buildMonthNav() {
        self.monthNav = (0, $8d7d2474ed9a5f7d$export$c8a8987d4410bf2d)("div", "flatpickr-months");
        self.yearElements = [];
        self.monthElements = [];
        self.prevMonthNav = (0, $8d7d2474ed9a5f7d$export$c8a8987d4410bf2d)("span", "flatpickr-prev-month");
        self.prevMonthNav.innerHTML = self.config.prevArrow;
        self.nextMonthNav = (0, $8d7d2474ed9a5f7d$export$c8a8987d4410bf2d)("span", "flatpickr-next-month");
        self.nextMonthNav.innerHTML = self.config.nextArrow;
        buildMonths();
        Object.defineProperty(self, "_hidePrevMonthArrow", {
            get: function() {
                return self.__hidePrevMonthArrow;
            },
            set: function(bool) {
                if (self.__hidePrevMonthArrow !== bool) {
                    (0, $8d7d2474ed9a5f7d$export$4a80062ca50b57c7)(self.prevMonthNav, "flatpickr-disabled", bool);
                    self.__hidePrevMonthArrow = bool;
                }
            }
        });
        Object.defineProperty(self, "_hideNextMonthArrow", {
            get: function() {
                return self.__hideNextMonthArrow;
            },
            set: function(bool) {
                if (self.__hideNextMonthArrow !== bool) {
                    (0, $8d7d2474ed9a5f7d$export$4a80062ca50b57c7)(self.nextMonthNav, "flatpickr-disabled", bool);
                    self.__hideNextMonthArrow = bool;
                }
            }
        });
        self.currentYearElement = self.yearElements[0];
        updateNavigationCurrentMonth();
        return self.monthNav;
    }
    function buildTime() {
        self.calendarContainer.classList.add("hasTime");
        if (self.config.noCalendar) self.calendarContainer.classList.add("noCalendar");
        var defaults = (0, $d16da6e601d564a3$export$6df0e87d3fffbd14)(self.config);
        self.timeContainer = (0, $8d7d2474ed9a5f7d$export$c8a8987d4410bf2d)("div", "flatpickr-time");
        self.timeContainer.tabIndex = -1;
        var separator = (0, $8d7d2474ed9a5f7d$export$c8a8987d4410bf2d)("span", "flatpickr-time-separator", ":");
        var hourInput = (0, $8d7d2474ed9a5f7d$export$afe9d610a3284048)("flatpickr-hour", {
            "aria-label": self.l10n.hourAriaLabel
        });
        self.hourElement = hourInput.getElementsByTagName("input")[0];
        var minuteInput = (0, $8d7d2474ed9a5f7d$export$afe9d610a3284048)("flatpickr-minute", {
            "aria-label": self.l10n.minuteAriaLabel
        });
        self.minuteElement = minuteInput.getElementsByTagName("input")[0];
        self.hourElement.tabIndex = self.minuteElement.tabIndex = -1;
        self.hourElement.value = (0, $1aad83eefaa11659$export$5d04458e2a6c373e)(self.latestSelectedDateObj ? self.latestSelectedDateObj.getHours() : self.config.time_24hr ? defaults.hours : military2ampm(defaults.hours));
        self.minuteElement.value = (0, $1aad83eefaa11659$export$5d04458e2a6c373e)(self.latestSelectedDateObj ? self.latestSelectedDateObj.getMinutes() : defaults.minutes);
        self.hourElement.setAttribute("step", self.config.hourIncrement.toString());
        self.minuteElement.setAttribute("step", self.config.minuteIncrement.toString());
        self.hourElement.setAttribute("min", self.config.time_24hr ? "0" : "1");
        self.hourElement.setAttribute("max", self.config.time_24hr ? "23" : "12");
        self.hourElement.setAttribute("maxlength", "2");
        self.minuteElement.setAttribute("min", "0");
        self.minuteElement.setAttribute("max", "59");
        self.minuteElement.setAttribute("maxlength", "2");
        self.timeContainer.appendChild(hourInput);
        self.timeContainer.appendChild(separator);
        self.timeContainer.appendChild(minuteInput);
        if (self.config.time_24hr) self.timeContainer.classList.add("time24hr");
        if (self.config.enableSeconds) {
            self.timeContainer.classList.add("hasSeconds");
            var secondInput = (0, $8d7d2474ed9a5f7d$export$afe9d610a3284048)("flatpickr-second");
            self.secondElement = secondInput.getElementsByTagName("input")[0];
            self.secondElement.value = (0, $1aad83eefaa11659$export$5d04458e2a6c373e)(self.latestSelectedDateObj ? self.latestSelectedDateObj.getSeconds() : defaults.seconds);
            self.secondElement.setAttribute("step", self.minuteElement.getAttribute("step"));
            self.secondElement.setAttribute("min", "0");
            self.secondElement.setAttribute("max", "59");
            self.secondElement.setAttribute("maxlength", "2");
            self.timeContainer.appendChild((0, $8d7d2474ed9a5f7d$export$c8a8987d4410bf2d)("span", "flatpickr-time-separator", ":"));
            self.timeContainer.appendChild(secondInput);
        }
        if (!self.config.time_24hr) {
            self.amPM = (0, $8d7d2474ed9a5f7d$export$c8a8987d4410bf2d)("span", "flatpickr-am-pm", self.l10n.amPM[(0, $1aad83eefaa11659$export$7d260a2a5f8bc19e)((self.latestSelectedDateObj ? self.hourElement.value : self.config.defaultHour) > 11)]);
            self.amPM.title = self.l10n.toggleTitle;
            self.amPM.tabIndex = -1;
            self.timeContainer.appendChild(self.amPM);
        }
        return self.timeContainer;
    }
    function buildWeekdays() {
        if (!self.weekdayContainer) self.weekdayContainer = (0, $8d7d2474ed9a5f7d$export$c8a8987d4410bf2d)("div", "flatpickr-weekdays");
        else (0, $8d7d2474ed9a5f7d$export$51cfe97d637c237c)(self.weekdayContainer);
        for(var i = self.config.showMonths; i--;){
            var container = (0, $8d7d2474ed9a5f7d$export$c8a8987d4410bf2d)("div", "flatpickr-weekdaycontainer");
            self.weekdayContainer.appendChild(container);
        }
        updateWeekdays();
        return self.weekdayContainer;
    }
    function updateWeekdays() {
        if (!self.weekdayContainer) return;
        var firstDayOfWeek = self.l10n.firstDayOfWeek;
        var weekdays = $9986d07d28cc86ca$var$__spreadArrays(self.l10n.weekdays.shorthand);
        if (firstDayOfWeek > 0 && firstDayOfWeek < weekdays.length) weekdays = $9986d07d28cc86ca$var$__spreadArrays(weekdays.splice(firstDayOfWeek, weekdays.length), weekdays.splice(0, firstDayOfWeek));
        for(var i = self.config.showMonths; i--;)self.weekdayContainer.children[i].innerHTML = "\n      <span class='flatpickr-weekday'>\n        " + weekdays.join("</span><span class='flatpickr-weekday'>") + "\n      </span>\n      ";
    }
    function buildWeeks() {
        self.calendarContainer.classList.add("hasWeeks");
        var weekWrapper = (0, $8d7d2474ed9a5f7d$export$c8a8987d4410bf2d)("div", "flatpickr-weekwrapper");
        weekWrapper.appendChild((0, $8d7d2474ed9a5f7d$export$c8a8987d4410bf2d)("span", "flatpickr-weekday", self.l10n.weekAbbreviation));
        var weekNumbers = (0, $8d7d2474ed9a5f7d$export$c8a8987d4410bf2d)("div", "flatpickr-weeks");
        weekWrapper.appendChild(weekNumbers);
        return {
            weekWrapper: weekWrapper,
            weekNumbers: weekNumbers
        };
    }
    function changeMonth(value, isOffset) {
        if (isOffset === void 0) isOffset = true;
        var delta = isOffset ? value : value - self.currentMonth;
        if (delta < 0 && self._hidePrevMonthArrow === true || delta > 0 && self._hideNextMonthArrow === true) return;
        self.currentMonth += delta;
        if (self.currentMonth < 0 || self.currentMonth > 11) {
            self.currentYear += self.currentMonth > 11 ? 1 : -1;
            self.currentMonth = (self.currentMonth + 12) % 12;
            triggerEvent("onYearChange");
            buildMonthSwitch();
        }
        buildDays();
        triggerEvent("onMonthChange");
        updateNavigationCurrentMonth();
    }
    function clear(triggerChangeEvent, toInitial) {
        if (triggerChangeEvent === void 0) triggerChangeEvent = true;
        if (toInitial === void 0) toInitial = true;
        self.input.value = "";
        if (self.altInput !== undefined) self.altInput.value = "";
        if (self.mobileInput !== undefined) self.mobileInput.value = "";
        self.selectedDates = [];
        self.latestSelectedDateObj = undefined;
        if (toInitial === true) {
            self.currentYear = self._initialDate.getFullYear();
            self.currentMonth = self._initialDate.getMonth();
        }
        if (self.config.enableTime === true) {
            var _a = (0, $d16da6e601d564a3$export$6df0e87d3fffbd14)(self.config), hours = _a.hours, minutes = _a.minutes, seconds = _a.seconds;
            setHours(hours, minutes, seconds);
        }
        self.redraw();
        if (triggerChangeEvent) triggerEvent("onChange");
    }
    function close() {
        self.isOpen = false;
        if (!self.isMobile) {
            if (self.calendarContainer !== undefined) self.calendarContainer.classList.remove("open");
            if (self._input !== undefined) self._input.classList.remove("active");
        }
        triggerEvent("onClose");
    }
    function destroy() {
        if (self.config !== undefined) triggerEvent("onDestroy");
        for(var i = self._handlers.length; i--;)self._handlers[i].remove();
        self._handlers = [];
        if (self.mobileInput) {
            if (self.mobileInput.parentNode) self.mobileInput.parentNode.removeChild(self.mobileInput);
            self.mobileInput = undefined;
        } else if (self.calendarContainer && self.calendarContainer.parentNode) {
            if (self.config.static && self.calendarContainer.parentNode) {
                var wrapper = self.calendarContainer.parentNode;
                wrapper.lastChild && wrapper.removeChild(wrapper.lastChild);
                if (wrapper.parentNode) {
                    while(wrapper.firstChild)wrapper.parentNode.insertBefore(wrapper.firstChild, wrapper);
                    wrapper.parentNode.removeChild(wrapper);
                }
            } else self.calendarContainer.parentNode.removeChild(self.calendarContainer);
        }
        if (self.altInput) {
            self.input.type = "text";
            if (self.altInput.parentNode) self.altInput.parentNode.removeChild(self.altInput);
            delete self.altInput;
        }
        if (self.input) {
            self.input.type = self.input._type;
            self.input.classList.remove("flatpickr-input");
            self.input.removeAttribute("readonly");
        }
        [
            "_showTimeInput",
            "latestSelectedDateObj",
            "_hideNextMonthArrow",
            "_hidePrevMonthArrow",
            "__hideNextMonthArrow",
            "__hidePrevMonthArrow",
            "isMobile",
            "isOpen",
            "selectedDateElem",
            "minDateHasTime",
            "maxDateHasTime",
            "days",
            "daysContainer",
            "_input",
            "_positionElement",
            "innerContainer",
            "rContainer",
            "monthNav",
            "todayDateElem",
            "calendarContainer",
            "weekdayContainer",
            "prevMonthNav",
            "nextMonthNav",
            "monthsDropdownContainer",
            "currentMonthElement",
            "currentYearElement",
            "navigationCurrentMonth",
            "selectedDateElem",
            "config"
        ].forEach(function(k) {
            try {
                delete self[k];
            } catch (_) {}
        });
    }
    function isCalendarElem(elem) {
        return self.calendarContainer.contains(elem);
    }
    function documentClick(e) {
        if (self.isOpen && !self.config.inline) {
            var eventTarget_1 = (0, $8d7d2474ed9a5f7d$export$e58f029f0fbfdb29)(e);
            var isCalendarElement = isCalendarElem(eventTarget_1);
            var isInput = eventTarget_1 === self.input || eventTarget_1 === self.altInput || self.element.contains(eventTarget_1) || e.path && e.path.indexOf && (~e.path.indexOf(self.input) || ~e.path.indexOf(self.altInput));
            var lostFocus = !isInput && !isCalendarElement && !isCalendarElem(e.relatedTarget);
            var isIgnored = !self.config.ignoredFocusElements.some(function(elem) {
                return elem.contains(eventTarget_1);
            });
            if (lostFocus && isIgnored) {
                if (self.config.allowInput) self.setDate(self._input.value, false, self.config.altInput ? self.config.altFormat : self.config.dateFormat);
                if (self.timeContainer !== undefined && self.minuteElement !== undefined && self.hourElement !== undefined && self.input.value !== "" && self.input.value !== undefined) updateTime();
                self.close();
                if (self.config && self.config.mode === "range" && self.selectedDates.length === 1) self.clear(false);
            }
        }
    }
    function changeYear(newYear) {
        if (!newYear || self.config.minDate && newYear < self.config.minDate.getFullYear() || self.config.maxDate && newYear > self.config.maxDate.getFullYear()) return;
        var newYearNum = newYear, isNewYear = self.currentYear !== newYearNum;
        self.currentYear = newYearNum || self.currentYear;
        if (self.config.maxDate && self.currentYear === self.config.maxDate.getFullYear()) self.currentMonth = Math.min(self.config.maxDate.getMonth(), self.currentMonth);
        else if (self.config.minDate && self.currentYear === self.config.minDate.getFullYear()) self.currentMonth = Math.max(self.config.minDate.getMonth(), self.currentMonth);
        if (isNewYear) {
            self.redraw();
            triggerEvent("onYearChange");
            buildMonthSwitch();
        }
    }
    function isEnabled(date, timeless) {
        var _a;
        if (timeless === void 0) timeless = true;
        var dateToCheck = self.parseDate(date, undefined, timeless);
        if (self.config.minDate && dateToCheck && (0, $d16da6e601d564a3$export$c4c806e061935577)(dateToCheck, self.config.minDate, timeless !== undefined ? timeless : !self.minDateHasTime) < 0 || self.config.maxDate && dateToCheck && (0, $d16da6e601d564a3$export$c4c806e061935577)(dateToCheck, self.config.maxDate, timeless !== undefined ? timeless : !self.maxDateHasTime) > 0) return false;
        if (!self.config.enable && self.config.disable.length === 0) return true;
        if (dateToCheck === undefined) return false;
        var bool = !!self.config.enable, array = (_a = self.config.enable) !== null && _a !== void 0 ? _a : self.config.disable;
        for(var i = 0, d = void 0; i < array.length; i++){
            d = array[i];
            if (typeof d === "function" && d(dateToCheck)) return bool;
            else if (d instanceof Date && dateToCheck !== undefined && d.getTime() === dateToCheck.getTime()) return bool;
            else if (typeof d === "string") {
                var parsed = self.parseDate(d, undefined, true);
                return parsed && parsed.getTime() === dateToCheck.getTime() ? bool : !bool;
            } else if (typeof d === "object" && dateToCheck !== undefined && d.from && d.to && dateToCheck.getTime() >= d.from.getTime() && dateToCheck.getTime() <= d.to.getTime()) return bool;
        }
        return !bool;
    }
    function isInView(elem) {
        if (self.daysContainer !== undefined) return elem.className.indexOf("hidden") === -1 && elem.className.indexOf("flatpickr-disabled") === -1 && self.daysContainer.contains(elem);
        return false;
    }
    function onBlur(e) {
        var isInput = e.target === self._input;
        var valueChanged = self._input.value.trimEnd() !== getDateStr();
        if (isInput && valueChanged && !(e.relatedTarget && isCalendarElem(e.relatedTarget))) self.setDate(self._input.value, true, e.target === self.altInput ? self.config.altFormat : self.config.dateFormat);
    }
    function onKeyDown(e) {
        var eventTarget = (0, $8d7d2474ed9a5f7d$export$e58f029f0fbfdb29)(e);
        var isInput = self.config.wrap ? element.contains(eventTarget) : eventTarget === self._input;
        var allowInput = self.config.allowInput;
        var allowKeydown = self.isOpen && (!allowInput || !isInput);
        var allowInlineKeydown = self.config.inline && isInput && !allowInput;
        if (e.keyCode === 13 && isInput) {
            if (allowInput) {
                self.setDate(self._input.value, true, eventTarget === self.altInput ? self.config.altFormat : self.config.dateFormat);
                self.close();
                return eventTarget.blur();
            } else self.open();
        } else if (isCalendarElem(eventTarget) || allowKeydown || allowInlineKeydown) {
            var isTimeObj = !!self.timeContainer && self.timeContainer.contains(eventTarget);
            switch(e.keyCode){
                case 13:
                    if (isTimeObj) {
                        e.preventDefault();
                        updateTime();
                        focusAndClose();
                    } else selectDate(e);
                    break;
                case 27:
                    e.preventDefault();
                    focusAndClose();
                    break;
                case 8:
                case 46:
                    if (isInput && !self.config.allowInput) {
                        e.preventDefault();
                        self.clear();
                    }
                    break;
                case 37:
                case 39:
                    if (!isTimeObj && !isInput) {
                        e.preventDefault();
                        var activeElement = getClosestActiveElement();
                        if (self.daysContainer !== undefined && (allowInput === false || activeElement && isInView(activeElement))) {
                            var delta_1 = e.keyCode === 39 ? 1 : -1;
                            if (!e.ctrlKey) focusOnDay(undefined, delta_1);
                            else {
                                e.stopPropagation();
                                changeMonth(delta_1);
                                focusOnDay(getFirstAvailableDay(1), 0);
                            }
                        }
                    } else if (self.hourElement) self.hourElement.focus();
                    break;
                case 38:
                case 40:
                    e.preventDefault();
                    var delta = e.keyCode === 40 ? 1 : -1;
                    if (self.daysContainer && eventTarget.$i !== undefined || eventTarget === self.input || eventTarget === self.altInput) {
                        if (e.ctrlKey) {
                            e.stopPropagation();
                            changeYear(self.currentYear - delta);
                            focusOnDay(getFirstAvailableDay(1), 0);
                        } else if (!isTimeObj) focusOnDay(undefined, delta * 7);
                    } else if (eventTarget === self.currentYearElement) changeYear(self.currentYear - delta);
                    else if (self.config.enableTime) {
                        if (!isTimeObj && self.hourElement) self.hourElement.focus();
                        updateTime(e);
                        self._debouncedChange();
                    }
                    break;
                case 9:
                    if (isTimeObj) {
                        var elems = [
                            self.hourElement,
                            self.minuteElement,
                            self.secondElement,
                            self.amPM
                        ].concat(self.pluginElements).filter(function(x) {
                            return x;
                        });
                        var i = elems.indexOf(eventTarget);
                        if (i !== -1) {
                            var target = elems[i + (e.shiftKey ? -1 : 1)];
                            e.preventDefault();
                            (target || self._input).focus();
                        }
                    } else if (!self.config.noCalendar && self.daysContainer && self.daysContainer.contains(eventTarget) && e.shiftKey) {
                        e.preventDefault();
                        self._input.focus();
                    }
                    break;
                default:
                    break;
            }
        }
        if (self.amPM !== undefined && eventTarget === self.amPM) switch(e.key){
            case self.l10n.amPM[0].charAt(0):
            case self.l10n.amPM[0].charAt(0).toLowerCase():
                self.amPM.textContent = self.l10n.amPM[0];
                setHoursFromInputs();
                updateValue();
                break;
            case self.l10n.amPM[1].charAt(0):
            case self.l10n.amPM[1].charAt(0).toLowerCase():
                self.amPM.textContent = self.l10n.amPM[1];
                setHoursFromInputs();
                updateValue();
                break;
        }
        if (isInput || isCalendarElem(eventTarget)) triggerEvent("onKeyDown", e);
    }
    function onMouseOver(elem, cellClass) {
        if (cellClass === void 0) cellClass = "flatpickr-day";
        if (self.selectedDates.length !== 1 || elem && (!elem.classList.contains(cellClass) || elem.classList.contains("flatpickr-disabled"))) return;
        var hoverDate = elem ? elem.dateObj.getTime() : self.days.firstElementChild.dateObj.getTime(), initialDate = self.parseDate(self.selectedDates[0], undefined, true).getTime(), rangeStartDate = Math.min(hoverDate, self.selectedDates[0].getTime()), rangeEndDate = Math.max(hoverDate, self.selectedDates[0].getTime());
        var containsDisabled = false;
        var minRange = 0, maxRange = 0;
        for(var t = rangeStartDate; t < rangeEndDate; t += (0, $d16da6e601d564a3$export$1f34108aa9eb96ab).DAY)if (!isEnabled(new Date(t), true)) {
            containsDisabled = containsDisabled || t > rangeStartDate && t < rangeEndDate;
            if (t < initialDate && (!minRange || t > minRange)) minRange = t;
            else if (t > initialDate && (!maxRange || t < maxRange)) maxRange = t;
        }
        var hoverableCells = Array.from(self.rContainer.querySelectorAll("*:nth-child(-n+" + self.config.showMonths + ") > ." + cellClass));
        hoverableCells.forEach(function(dayElem) {
            var date = dayElem.dateObj;
            var timestamp = date.getTime();
            var outOfRange = minRange > 0 && timestamp < minRange || maxRange > 0 && timestamp > maxRange;
            if (outOfRange) {
                dayElem.classList.add("notAllowed");
                [
                    "inRange",
                    "startRange",
                    "endRange"
                ].forEach(function(c) {
                    dayElem.classList.remove(c);
                });
                return;
            } else if (containsDisabled && !outOfRange) return;
            [
                "startRange",
                "inRange",
                "endRange",
                "notAllowed"
            ].forEach(function(c) {
                dayElem.classList.remove(c);
            });
            if (elem !== undefined) {
                elem.classList.add(hoverDate <= self.selectedDates[0].getTime() ? "startRange" : "endRange");
                if (initialDate < hoverDate && timestamp === initialDate) dayElem.classList.add("startRange");
                else if (initialDate > hoverDate && timestamp === initialDate) dayElem.classList.add("endRange");
                if (timestamp >= minRange && (maxRange === 0 || timestamp <= maxRange) && (0, $d16da6e601d564a3$export$a4d69fb5f2026c35)(timestamp, initialDate, hoverDate)) dayElem.classList.add("inRange");
            }
        });
    }
    function onResize() {
        if (self.isOpen && !self.config.static && !self.config.inline) positionCalendar();
    }
    function open(e, positionElement) {
        if (positionElement === void 0) positionElement = self._positionElement;
        if (self.isMobile === true) {
            if (e) {
                e.preventDefault();
                var eventTarget = (0, $8d7d2474ed9a5f7d$export$e58f029f0fbfdb29)(e);
                if (eventTarget) eventTarget.blur();
            }
            if (self.mobileInput !== undefined) {
                self.mobileInput.focus();
                self.mobileInput.click();
            }
            triggerEvent("onOpen");
            return;
        } else if (self._input.disabled || self.config.inline) return;
        var wasOpen = self.isOpen;
        self.isOpen = true;
        if (!wasOpen) {
            self.calendarContainer.classList.add("open");
            self._input.classList.add("active");
            triggerEvent("onOpen");
            positionCalendar(positionElement);
        }
        if (self.config.enableTime === true && self.config.noCalendar === true) {
            if (self.config.allowInput === false && (e === undefined || !self.timeContainer.contains(e.relatedTarget))) setTimeout(function() {
                return self.hourElement.select();
            }, 50);
        }
    }
    function minMaxDateSetter(type) {
        return function(date) {
            var dateObj = self.config["_" + type + "Date"] = self.parseDate(date, self.config.dateFormat);
            var inverseDateObj = self.config["_" + (type === "min" ? "max" : "min") + "Date"];
            if (dateObj !== undefined) self[type === "min" ? "minDateHasTime" : "maxDateHasTime"] = dateObj.getHours() > 0 || dateObj.getMinutes() > 0 || dateObj.getSeconds() > 0;
            if (self.selectedDates) {
                self.selectedDates = self.selectedDates.filter(function(d) {
                    return isEnabled(d);
                });
                if (!self.selectedDates.length && type === "min") setHoursFromDate(dateObj);
                updateValue();
            }
            if (self.daysContainer) {
                redraw();
                if (dateObj !== undefined) self.currentYearElement[type] = dateObj.getFullYear().toString();
                else self.currentYearElement.removeAttribute(type);
                self.currentYearElement.disabled = !!inverseDateObj && dateObj !== undefined && inverseDateObj.getFullYear() === dateObj.getFullYear();
            }
        };
    }
    function parseConfig() {
        var boolOpts = [
            "wrap",
            "weekNumbers",
            "allowInput",
            "allowInvalidPreload",
            "clickOpens",
            "time_24hr",
            "enableTime",
            "noCalendar",
            "altInput",
            "shorthandCurrentMonth",
            "inline",
            "static",
            "enableSeconds",
            "disableMobile"
        ];
        var userConfig = $9986d07d28cc86ca$var$__assign($9986d07d28cc86ca$var$__assign({}, JSON.parse(JSON.stringify(element.dataset || {}))), instanceConfig);
        var formats = {};
        self.config.parseDate = userConfig.parseDate;
        self.config.formatDate = userConfig.formatDate;
        Object.defineProperty(self.config, "enable", {
            get: function() {
                return self.config._enable;
            },
            set: function(dates) {
                self.config._enable = parseDateRules(dates);
            }
        });
        Object.defineProperty(self.config, "disable", {
            get: function() {
                return self.config._disable;
            },
            set: function(dates) {
                self.config._disable = parseDateRules(dates);
            }
        });
        var timeMode = userConfig.mode === "time";
        if (!userConfig.dateFormat && (userConfig.enableTime || timeMode)) {
            var defaultDateFormat = $9986d07d28cc86ca$var$flatpickr.defaultConfig.dateFormat || (0, $5e6391609e4b352e$export$ebe90cb607ad99e).dateFormat;
            formats.dateFormat = userConfig.noCalendar || timeMode ? "H:i" + (userConfig.enableSeconds ? ":S" : "") : defaultDateFormat + " H:i" + (userConfig.enableSeconds ? ":S" : "");
        }
        if (userConfig.altInput && (userConfig.enableTime || timeMode) && !userConfig.altFormat) {
            var defaultAltFormat = $9986d07d28cc86ca$var$flatpickr.defaultConfig.altFormat || (0, $5e6391609e4b352e$export$ebe90cb607ad99e).altFormat;
            formats.altFormat = userConfig.noCalendar || timeMode ? "h:i" + (userConfig.enableSeconds ? ":S K" : " K") : defaultAltFormat + (" h:i" + (userConfig.enableSeconds ? ":S" : "") + " K");
        }
        Object.defineProperty(self.config, "minDate", {
            get: function() {
                return self.config._minDate;
            },
            set: minMaxDateSetter("min")
        });
        Object.defineProperty(self.config, "maxDate", {
            get: function() {
                return self.config._maxDate;
            },
            set: minMaxDateSetter("max")
        });
        var minMaxTimeSetter = function(type) {
            return function(val) {
                self.config[type === "min" ? "_minTime" : "_maxTime"] = self.parseDate(val, "H:i:S");
            };
        };
        Object.defineProperty(self.config, "minTime", {
            get: function() {
                return self.config._minTime;
            },
            set: minMaxTimeSetter("min")
        });
        Object.defineProperty(self.config, "maxTime", {
            get: function() {
                return self.config._maxTime;
            },
            set: minMaxTimeSetter("max")
        });
        if (userConfig.mode === "time") {
            self.config.noCalendar = true;
            self.config.enableTime = true;
        }
        Object.assign(self.config, formats, userConfig);
        for(var i = 0; i < boolOpts.length; i++)self.config[boolOpts[i]] = self.config[boolOpts[i]] === true || self.config[boolOpts[i]] === "true";
        (0, $5e6391609e4b352e$export$c34bb18505e1e253).filter(function(hook) {
            return self.config[hook] !== undefined;
        }).forEach(function(hook) {
            self.config[hook] = (0, $1aad83eefaa11659$export$3131421a7d01b4fb)(self.config[hook] || []).map(bindToInstance);
        });
        self.isMobile = !self.config.disableMobile && !self.config.inline && self.config.mode === "single" && !self.config.disable.length && !self.config.enable && !self.config.weekNumbers && /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
        for(var i = 0; i < self.config.plugins.length; i++){
            var pluginConf = self.config.plugins[i](self) || {};
            for(var key in pluginConf){
                if ((0, $5e6391609e4b352e$export$c34bb18505e1e253).indexOf(key) > -1) self.config[key] = (0, $1aad83eefaa11659$export$3131421a7d01b4fb)(pluginConf[key]).map(bindToInstance).concat(self.config[key]);
                else if (typeof userConfig[key] === "undefined") self.config[key] = pluginConf[key];
            }
        }
        if (!userConfig.altInputClass) self.config.altInputClass = getInputElem().className + " " + self.config.altInputClass;
        triggerEvent("onParseConfig");
    }
    function getInputElem() {
        return self.config.wrap ? element.querySelector("[data-input]") : element;
    }
    function setupLocale() {
        if (typeof self.config.locale !== "object" && typeof $9986d07d28cc86ca$var$flatpickr.l10ns[self.config.locale] === "undefined") self.config.errorHandler(new Error("flatpickr: invalid locale " + self.config.locale));
        self.l10n = $9986d07d28cc86ca$var$__assign($9986d07d28cc86ca$var$__assign({}, $9986d07d28cc86ca$var$flatpickr.l10ns.default), typeof self.config.locale === "object" ? self.config.locale : self.config.locale !== "default" ? $9986d07d28cc86ca$var$flatpickr.l10ns[self.config.locale] : undefined);
        (0, $763bd4de3a8b9966$export$f5a8dc72fbf63af5).D = "(" + self.l10n.weekdays.shorthand.join("|") + ")";
        (0, $763bd4de3a8b9966$export$f5a8dc72fbf63af5).l = "(" + self.l10n.weekdays.longhand.join("|") + ")";
        (0, $763bd4de3a8b9966$export$f5a8dc72fbf63af5).M = "(" + self.l10n.months.shorthand.join("|") + ")";
        (0, $763bd4de3a8b9966$export$f5a8dc72fbf63af5).F = "(" + self.l10n.months.longhand.join("|") + ")";
        (0, $763bd4de3a8b9966$export$f5a8dc72fbf63af5).K = "(" + self.l10n.amPM[0] + "|" + self.l10n.amPM[1] + "|" + self.l10n.amPM[0].toLowerCase() + "|" + self.l10n.amPM[1].toLowerCase() + ")";
        var userConfig = $9986d07d28cc86ca$var$__assign($9986d07d28cc86ca$var$__assign({}, instanceConfig), JSON.parse(JSON.stringify(element.dataset || {})));
        if (userConfig.time_24hr === undefined && $9986d07d28cc86ca$var$flatpickr.defaultConfig.time_24hr === undefined) self.config.time_24hr = self.l10n.time_24hr;
        self.formatDate = (0, $d16da6e601d564a3$export$ff1a0b75284ac636)(self);
        self.parseDate = (0, $d16da6e601d564a3$export$cfa2ef2687faeda2)({
            config: self.config,
            l10n: self.l10n
        });
    }
    function positionCalendar(customPositionElement) {
        if (typeof self.config.position === "function") return void self.config.position(self, customPositionElement);
        if (self.calendarContainer === undefined) return;
        triggerEvent("onPreCalendarPosition");
        var positionElement = customPositionElement || self._positionElement;
        var calendarHeight = Array.prototype.reduce.call(self.calendarContainer.children, function(acc, child) {
            return acc + child.offsetHeight;
        }, 0), calendarWidth = self.calendarContainer.offsetWidth, configPos = self.config.position.split(" "), configPosVertical = configPos[0], configPosHorizontal = configPos.length > 1 ? configPos[1] : null, inputBounds = positionElement.getBoundingClientRect(), distanceFromBottom = window.innerHeight - inputBounds.bottom, showOnTop = configPosVertical === "above" || configPosVertical !== "below" && distanceFromBottom < calendarHeight && inputBounds.top > calendarHeight;
        var top = window.pageYOffset + inputBounds.top + (!showOnTop ? positionElement.offsetHeight + 2 : -calendarHeight - 2);
        (0, $8d7d2474ed9a5f7d$export$4a80062ca50b57c7)(self.calendarContainer, "arrowTop", !showOnTop);
        (0, $8d7d2474ed9a5f7d$export$4a80062ca50b57c7)(self.calendarContainer, "arrowBottom", showOnTop);
        if (self.config.inline) return;
        var left = window.pageXOffset + inputBounds.left;
        var isCenter = false;
        var isRight = false;
        if (configPosHorizontal === "center") {
            left -= (calendarWidth - inputBounds.width) / 2;
            isCenter = true;
        } else if (configPosHorizontal === "right") {
            left -= calendarWidth - inputBounds.width;
            isRight = true;
        }
        (0, $8d7d2474ed9a5f7d$export$4a80062ca50b57c7)(self.calendarContainer, "arrowLeft", !isCenter && !isRight);
        (0, $8d7d2474ed9a5f7d$export$4a80062ca50b57c7)(self.calendarContainer, "arrowCenter", isCenter);
        (0, $8d7d2474ed9a5f7d$export$4a80062ca50b57c7)(self.calendarContainer, "arrowRight", isRight);
        var right = window.document.body.offsetWidth - (window.pageXOffset + inputBounds.right);
        var rightMost = left + calendarWidth > window.document.body.offsetWidth;
        var centerMost = right + calendarWidth > window.document.body.offsetWidth;
        (0, $8d7d2474ed9a5f7d$export$4a80062ca50b57c7)(self.calendarContainer, "rightMost", rightMost);
        if (self.config.static) return;
        self.calendarContainer.style.top = top + "px";
        if (!rightMost) {
            self.calendarContainer.style.left = left + "px";
            self.calendarContainer.style.right = "auto";
        } else if (!centerMost) {
            self.calendarContainer.style.left = "auto";
            self.calendarContainer.style.right = right + "px";
        } else {
            var doc = getDocumentStyleSheet();
            if (doc === undefined) return;
            var bodyWidth = window.document.body.offsetWidth;
            var centerLeft = Math.max(0, bodyWidth / 2 - calendarWidth / 2);
            var centerBefore = ".flatpickr-calendar.centerMost:before";
            var centerAfter = ".flatpickr-calendar.centerMost:after";
            var centerIndex = doc.cssRules.length;
            var centerStyle = "{left:" + inputBounds.left + "px;right:auto;}";
            (0, $8d7d2474ed9a5f7d$export$4a80062ca50b57c7)(self.calendarContainer, "rightMost", false);
            (0, $8d7d2474ed9a5f7d$export$4a80062ca50b57c7)(self.calendarContainer, "centerMost", true);
            doc.insertRule(centerBefore + "," + centerAfter + centerStyle, centerIndex);
            self.calendarContainer.style.left = centerLeft + "px";
            self.calendarContainer.style.right = "auto";
        }
    }
    function getDocumentStyleSheet() {
        var editableSheet = null;
        for(var i = 0; i < document.styleSheets.length; i++){
            var sheet = document.styleSheets[i];
            if (!sheet.cssRules) continue;
            try {
                sheet.cssRules;
            } catch (err) {
                continue;
            }
            editableSheet = sheet;
            break;
        }
        return editableSheet != null ? editableSheet : createStyleSheet();
    }
    function createStyleSheet() {
        var style = document.createElement("style");
        document.head.appendChild(style);
        return style.sheet;
    }
    function redraw() {
        if (self.config.noCalendar || self.isMobile) return;
        buildMonthSwitch();
        updateNavigationCurrentMonth();
        buildDays();
    }
    function focusAndClose() {
        self._input.focus();
        if (window.navigator.userAgent.indexOf("MSIE") !== -1 || navigator.msMaxTouchPoints !== undefined) setTimeout(self.close, 0);
        else self.close();
    }
    function selectDate(e) {
        e.preventDefault();
        e.stopPropagation();
        var isSelectable = function(day) {
            return day.classList && day.classList.contains("flatpickr-day") && !day.classList.contains("flatpickr-disabled") && !day.classList.contains("notAllowed");
        };
        var t = (0, $8d7d2474ed9a5f7d$export$25245567f53f158f)((0, $8d7d2474ed9a5f7d$export$e58f029f0fbfdb29)(e), isSelectable);
        if (t === undefined) return;
        var target = t;
        var selectedDate = self.latestSelectedDateObj = new Date(target.dateObj.getTime());
        var shouldChangeMonth = (selectedDate.getMonth() < self.currentMonth || selectedDate.getMonth() > self.currentMonth + self.config.showMonths - 1) && self.config.mode !== "range";
        self.selectedDateElem = target;
        if (self.config.mode === "single") self.selectedDates = [
            selectedDate
        ];
        else if (self.config.mode === "multiple") {
            var selectedIndex = isDateSelected(selectedDate);
            if (selectedIndex) self.selectedDates.splice(parseInt(selectedIndex), 1);
            else self.selectedDates.push(selectedDate);
        } else if (self.config.mode === "range") {
            if (self.selectedDates.length === 2) self.clear(false, false);
            self.latestSelectedDateObj = selectedDate;
            self.selectedDates.push(selectedDate);
            if ((0, $d16da6e601d564a3$export$c4c806e061935577)(selectedDate, self.selectedDates[0], true) !== 0) self.selectedDates.sort(function(a, b) {
                return a.getTime() - b.getTime();
            });
        }
        setHoursFromInputs();
        if (shouldChangeMonth) {
            var isNewYear = self.currentYear !== selectedDate.getFullYear();
            self.currentYear = selectedDate.getFullYear();
            self.currentMonth = selectedDate.getMonth();
            if (isNewYear) {
                triggerEvent("onYearChange");
                buildMonthSwitch();
            }
            triggerEvent("onMonthChange");
        }
        updateNavigationCurrentMonth();
        buildDays();
        updateValue();
        if (!shouldChangeMonth && self.config.mode !== "range" && self.config.showMonths === 1) focusOnDayElem(target);
        else if (self.selectedDateElem !== undefined && self.hourElement === undefined) self.selectedDateElem && self.selectedDateElem.focus();
        if (self.hourElement !== undefined) self.hourElement !== undefined && self.hourElement.focus();
        if (self.config.closeOnSelect) {
            var single = self.config.mode === "single" && !self.config.enableTime;
            var range = self.config.mode === "range" && self.selectedDates.length === 2 && !self.config.enableTime;
            if (single || range) focusAndClose();
        }
        triggerChange();
    }
    var CALLBACKS = {
        locale: [
            setupLocale,
            updateWeekdays
        ],
        showMonths: [
            buildMonths,
            setCalendarWidth,
            buildWeekdays
        ],
        minDate: [
            jumpToDate
        ],
        maxDate: [
            jumpToDate
        ],
        positionElement: [
            updatePositionElement
        ],
        clickOpens: [
            function() {
                if (self.config.clickOpens === true) {
                    bind(self._input, "focus", self.open);
                    bind(self._input, "click", self.open);
                } else {
                    self._input.removeEventListener("focus", self.open);
                    self._input.removeEventListener("click", self.open);
                }
            }
        ]
    };
    function set(option, value) {
        if (option !== null && typeof option === "object") {
            Object.assign(self.config, option);
            for(var key in option)if (CALLBACKS[key] !== undefined) CALLBACKS[key].forEach(function(x) {
                return x();
            });
        } else {
            self.config[option] = value;
            if (CALLBACKS[option] !== undefined) CALLBACKS[option].forEach(function(x) {
                return x();
            });
            else if ((0, $5e6391609e4b352e$export$c34bb18505e1e253).indexOf(option) > -1) self.config[option] = (0, $1aad83eefaa11659$export$3131421a7d01b4fb)(value);
        }
        self.redraw();
        updateValue(true);
    }
    function setSelectedDate(inputDate, format) {
        var dates = [];
        if (inputDate instanceof Array) dates = inputDate.map(function(d) {
            return self.parseDate(d, format);
        });
        else if (inputDate instanceof Date || typeof inputDate === "number") dates = [
            self.parseDate(inputDate, format)
        ];
        else if (typeof inputDate === "string") switch(self.config.mode){
            case "single":
            case "time":
                dates = [
                    self.parseDate(inputDate, format)
                ];
                break;
            case "multiple":
                dates = inputDate.split(self.config.conjunction).map(function(date) {
                    return self.parseDate(date, format);
                });
                break;
            case "range":
                dates = inputDate.split(self.l10n.rangeSeparator).map(function(date) {
                    return self.parseDate(date, format);
                });
                break;
            default:
                break;
        }
        else self.config.errorHandler(new Error("Invalid date supplied: " + JSON.stringify(inputDate)));
        self.selectedDates = self.config.allowInvalidPreload ? dates : dates.filter(function(d) {
            return d instanceof Date && isEnabled(d, false);
        });
        if (self.config.mode === "range") self.selectedDates.sort(function(a, b) {
            return a.getTime() - b.getTime();
        });
    }
    function setDate(date, triggerChange, format) {
        if (triggerChange === void 0) triggerChange = false;
        if (format === void 0) format = self.config.dateFormat;
        if (date !== 0 && !date || date instanceof Array && date.length === 0) return self.clear(triggerChange);
        setSelectedDate(date, format);
        self.latestSelectedDateObj = self.selectedDates[self.selectedDates.length - 1];
        self.redraw();
        jumpToDate(undefined, triggerChange);
        setHoursFromDate();
        if (self.selectedDates.length === 0) self.clear(false);
        updateValue(triggerChange);
        if (triggerChange) triggerEvent("onChange");
    }
    function parseDateRules(arr) {
        return arr.slice().map(function(rule) {
            if (typeof rule === "string" || typeof rule === "number" || rule instanceof Date) return self.parseDate(rule, undefined, true);
            else if (rule && typeof rule === "object" && rule.from && rule.to) return {
                from: self.parseDate(rule.from, undefined),
                to: self.parseDate(rule.to, undefined)
            };
            return rule;
        }).filter(function(x) {
            return x;
        });
    }
    function setupDates() {
        self.selectedDates = [];
        self.now = self.parseDate(self.config.now) || new Date();
        var preloadedDate = self.config.defaultDate || ((self.input.nodeName === "INPUT" || self.input.nodeName === "TEXTAREA") && self.input.placeholder && self.input.value === self.input.placeholder ? null : self.input.value);
        if (preloadedDate) setSelectedDate(preloadedDate, self.config.dateFormat);
        self._initialDate = self.selectedDates.length > 0 ? self.selectedDates[0] : self.config.minDate && self.config.minDate.getTime() > self.now.getTime() ? self.config.minDate : self.config.maxDate && self.config.maxDate.getTime() < self.now.getTime() ? self.config.maxDate : self.now;
        self.currentYear = self._initialDate.getFullYear();
        self.currentMonth = self._initialDate.getMonth();
        if (self.selectedDates.length > 0) self.latestSelectedDateObj = self.selectedDates[0];
        if (self.config.minTime !== undefined) self.config.minTime = self.parseDate(self.config.minTime, "H:i");
        if (self.config.maxTime !== undefined) self.config.maxTime = self.parseDate(self.config.maxTime, "H:i");
        self.minDateHasTime = !!self.config.minDate && (self.config.minDate.getHours() > 0 || self.config.minDate.getMinutes() > 0 || self.config.minDate.getSeconds() > 0);
        self.maxDateHasTime = !!self.config.maxDate && (self.config.maxDate.getHours() > 0 || self.config.maxDate.getMinutes() > 0 || self.config.maxDate.getSeconds() > 0);
    }
    function setupInputs() {
        self.input = getInputElem();
        if (!self.input) {
            self.config.errorHandler(new Error("Invalid input element specified"));
            return;
        }
        self.input._type = self.input.type;
        self.input.type = "text";
        self.input.classList.add("flatpickr-input");
        self._input = self.input;
        if (self.config.altInput) {
            self.altInput = (0, $8d7d2474ed9a5f7d$export$c8a8987d4410bf2d)(self.input.nodeName, self.config.altInputClass);
            self._input = self.altInput;
            self.altInput.placeholder = self.input.placeholder;
            self.altInput.disabled = self.input.disabled;
            self.altInput.required = self.input.required;
            self.altInput.tabIndex = self.input.tabIndex;
            self.altInput.type = "text";
            self.input.setAttribute("type", "hidden");
            if (!self.config.static && self.input.parentNode) self.input.parentNode.insertBefore(self.altInput, self.input.nextSibling);
        }
        if (!self.config.allowInput) self._input.setAttribute("readonly", "readonly");
        updatePositionElement();
    }
    function updatePositionElement() {
        self._positionElement = self.config.positionElement || self._input;
    }
    function setupMobile() {
        var inputType = self.config.enableTime ? self.config.noCalendar ? "time" : "datetime-local" : "date";
        self.mobileInput = (0, $8d7d2474ed9a5f7d$export$c8a8987d4410bf2d)("input", self.input.className + " flatpickr-mobile");
        self.mobileInput.tabIndex = 1;
        self.mobileInput.type = inputType;
        self.mobileInput.disabled = self.input.disabled;
        self.mobileInput.required = self.input.required;
        self.mobileInput.placeholder = self.input.placeholder;
        self.mobileFormatStr = inputType === "datetime-local" ? "Y-m-d\\TH:i:S" : inputType === "date" ? "Y-m-d" : "H:i:S";
        if (self.selectedDates.length > 0) self.mobileInput.defaultValue = self.mobileInput.value = self.formatDate(self.selectedDates[0], self.mobileFormatStr);
        if (self.config.minDate) self.mobileInput.min = self.formatDate(self.config.minDate, "Y-m-d");
        if (self.config.maxDate) self.mobileInput.max = self.formatDate(self.config.maxDate, "Y-m-d");
        if (self.input.getAttribute("step")) self.mobileInput.step = String(self.input.getAttribute("step"));
        self.input.type = "hidden";
        if (self.altInput !== undefined) self.altInput.type = "hidden";
        try {
            if (self.input.parentNode) self.input.parentNode.insertBefore(self.mobileInput, self.input.nextSibling);
        } catch (_a) {}
        bind(self.mobileInput, "change", function(e) {
            self.setDate((0, $8d7d2474ed9a5f7d$export$e58f029f0fbfdb29)(e).value, false, self.mobileFormatStr);
            triggerEvent("onChange");
            triggerEvent("onClose");
        });
    }
    function toggle(e) {
        if (self.isOpen === true) return self.close();
        self.open(e);
    }
    function triggerEvent(event, data) {
        if (self.config === undefined) return;
        var hooks = self.config[event];
        if (hooks !== undefined && hooks.length > 0) for(var i = 0; hooks[i] && i < hooks.length; i++)hooks[i](self.selectedDates, self.input.value, self, data);
        if (event === "onChange") {
            self.input.dispatchEvent(createEvent("change"));
            self.input.dispatchEvent(createEvent("input"));
        }
    }
    function createEvent(name) {
        var e = document.createEvent("Event");
        e.initEvent(name, true, true);
        return e;
    }
    function isDateSelected(date) {
        for(var i = 0; i < self.selectedDates.length; i++){
            var selectedDate = self.selectedDates[i];
            if (selectedDate instanceof Date && (0, $d16da6e601d564a3$export$c4c806e061935577)(selectedDate, date) === 0) return "" + i;
        }
        return false;
    }
    function isDateInRange(date) {
        if (self.config.mode !== "range" || self.selectedDates.length < 2) return false;
        return (0, $d16da6e601d564a3$export$c4c806e061935577)(date, self.selectedDates[0]) >= 0 && (0, $d16da6e601d564a3$export$c4c806e061935577)(date, self.selectedDates[1]) <= 0;
    }
    function updateNavigationCurrentMonth() {
        if (self.config.noCalendar || self.isMobile || !self.monthNav) return;
        self.yearElements.forEach(function(yearElement, i) {
            var d = new Date(self.currentYear, self.currentMonth, 1);
            d.setMonth(self.currentMonth + i);
            if (self.config.showMonths > 1 || self.config.monthSelectorType === "static") self.monthElements[i].textContent = (0, $763bd4de3a8b9966$export$27a2dd9af757e89c)(d.getMonth(), self.config.shorthandCurrentMonth, self.l10n) + " ";
            else self.monthsDropdownContainer.value = d.getMonth().toString();
            yearElement.value = d.getFullYear().toString();
        });
        self._hidePrevMonthArrow = self.config.minDate !== undefined && (self.currentYear === self.config.minDate.getFullYear() ? self.currentMonth <= self.config.minDate.getMonth() : self.currentYear < self.config.minDate.getFullYear());
        self._hideNextMonthArrow = self.config.maxDate !== undefined && (self.currentYear === self.config.maxDate.getFullYear() ? self.currentMonth + 1 > self.config.maxDate.getMonth() : self.currentYear > self.config.maxDate.getFullYear());
    }
    function getDateStr(specificFormat) {
        var format = specificFormat || (self.config.altInput ? self.config.altFormat : self.config.dateFormat);
        return self.selectedDates.map(function(dObj) {
            return self.formatDate(dObj, format);
        }).filter(function(d, i, arr) {
            return self.config.mode !== "range" || self.config.enableTime || arr.indexOf(d) === i;
        }).join(self.config.mode !== "range" ? self.config.conjunction : self.l10n.rangeSeparator);
    }
    function updateValue(triggerChange) {
        if (triggerChange === void 0) triggerChange = true;
        if (self.mobileInput !== undefined && self.mobileFormatStr) self.mobileInput.value = self.latestSelectedDateObj !== undefined ? self.formatDate(self.latestSelectedDateObj, self.mobileFormatStr) : "";
        self.input.value = getDateStr(self.config.dateFormat);
        if (self.altInput !== undefined) self.altInput.value = getDateStr(self.config.altFormat);
        if (triggerChange !== false) triggerEvent("onValueUpdate");
    }
    function onMonthNavClick(e) {
        var eventTarget = (0, $8d7d2474ed9a5f7d$export$e58f029f0fbfdb29)(e);
        var isPrevMonth = self.prevMonthNav.contains(eventTarget);
        var isNextMonth = self.nextMonthNav.contains(eventTarget);
        if (isPrevMonth || isNextMonth) changeMonth(isPrevMonth ? -1 : 1);
        else if (self.yearElements.indexOf(eventTarget) >= 0) eventTarget.select();
        else if (eventTarget.classList.contains("arrowUp")) self.changeYear(self.currentYear + 1);
        else if (eventTarget.classList.contains("arrowDown")) self.changeYear(self.currentYear - 1);
    }
    function timeWrapper(e) {
        e.preventDefault();
        var isKeyDown = e.type === "keydown", eventTarget = (0, $8d7d2474ed9a5f7d$export$e58f029f0fbfdb29)(e), input = eventTarget;
        if (self.amPM !== undefined && eventTarget === self.amPM) self.amPM.textContent = self.l10n.amPM[(0, $1aad83eefaa11659$export$7d260a2a5f8bc19e)(self.amPM.textContent === self.l10n.amPM[0])];
        var min = parseFloat(input.getAttribute("min")), max = parseFloat(input.getAttribute("max")), step = parseFloat(input.getAttribute("step")), curValue = parseInt(input.value, 10), delta = e.delta || (isKeyDown ? e.which === 38 ? 1 : -1 : 0);
        var newValue = curValue + step * delta;
        if (typeof input.value !== "undefined" && input.value.length === 2) {
            var isHourElem = input === self.hourElement, isMinuteElem = input === self.minuteElement;
            if (newValue < min) {
                newValue = max + newValue + (0, $1aad83eefaa11659$export$7d260a2a5f8bc19e)(!isHourElem) + ((0, $1aad83eefaa11659$export$7d260a2a5f8bc19e)(isHourElem) && (0, $1aad83eefaa11659$export$7d260a2a5f8bc19e)(!self.amPM));
                if (isMinuteElem) incrementNumInput(undefined, -1, self.hourElement);
            } else if (newValue > max) {
                newValue = input === self.hourElement ? newValue - max - (0, $1aad83eefaa11659$export$7d260a2a5f8bc19e)(!self.amPM) : min;
                if (isMinuteElem) incrementNumInput(undefined, 1, self.hourElement);
            }
            if (self.amPM && isHourElem && (step === 1 ? newValue + curValue === 23 : Math.abs(newValue - curValue) > step)) self.amPM.textContent = self.l10n.amPM[(0, $1aad83eefaa11659$export$7d260a2a5f8bc19e)(self.amPM.textContent === self.l10n.amPM[0])];
            input.value = (0, $1aad83eefaa11659$export$5d04458e2a6c373e)(newValue);
        }
    }
    init();
    return self;
}
function $9986d07d28cc86ca$var$_flatpickr(nodeList, config) {
    var nodes = Array.prototype.slice.call(nodeList).filter(function(x) {
        return x instanceof HTMLElement;
    });
    var instances = [];
    for(var i = 0; i < nodes.length; i++){
        var node = nodes[i];
        try {
            if (node.getAttribute("data-fp-omit") !== null) continue;
            if (node._flatpickr !== undefined) {
                node._flatpickr.destroy();
                node._flatpickr = undefined;
            }
            node._flatpickr = $9986d07d28cc86ca$var$FlatpickrInstance(node, config || {});
            instances.push(node._flatpickr);
        } catch (e) {
            console.error(e);
        }
    }
    return instances.length === 1 ? instances[0] : instances;
}
if (typeof HTMLElement !== "undefined" && typeof HTMLCollection !== "undefined" && typeof NodeList !== "undefined") {
    HTMLCollection.prototype.flatpickr = NodeList.prototype.flatpickr = function(config) {
        return $9986d07d28cc86ca$var$_flatpickr(this, config);
    };
    HTMLElement.prototype.flatpickr = function(config) {
        return $9986d07d28cc86ca$var$_flatpickr([
            this
        ], config);
    };
}
var $9986d07d28cc86ca$var$flatpickr = function(selector, config) {
    if (typeof selector === "string") return $9986d07d28cc86ca$var$_flatpickr(window.document.querySelectorAll(selector), config);
    else if (selector instanceof Node) return $9986d07d28cc86ca$var$_flatpickr([
        selector
    ], config);
    else return $9986d07d28cc86ca$var$_flatpickr(selector, config);
};
$9986d07d28cc86ca$var$flatpickr.defaultConfig = {};
$9986d07d28cc86ca$var$flatpickr.l10ns = {
    en: $9986d07d28cc86ca$var$__assign({}, (0, $983d310815fae63e$export$2e2bcd8739ae039)),
    default: $9986d07d28cc86ca$var$__assign({}, (0, $983d310815fae63e$export$2e2bcd8739ae039))
};
$9986d07d28cc86ca$var$flatpickr.localize = function(l10n) {
    $9986d07d28cc86ca$var$flatpickr.l10ns.default = $9986d07d28cc86ca$var$__assign($9986d07d28cc86ca$var$__assign({}, $9986d07d28cc86ca$var$flatpickr.l10ns.default), l10n);
};
$9986d07d28cc86ca$var$flatpickr.setDefaults = function(config) {
    $9986d07d28cc86ca$var$flatpickr.defaultConfig = $9986d07d28cc86ca$var$__assign($9986d07d28cc86ca$var$__assign({}, $9986d07d28cc86ca$var$flatpickr.defaultConfig), config);
};
$9986d07d28cc86ca$var$flatpickr.parseDate = (0, $d16da6e601d564a3$export$cfa2ef2687faeda2)({});
$9986d07d28cc86ca$var$flatpickr.formatDate = (0, $d16da6e601d564a3$export$ff1a0b75284ac636)({});
$9986d07d28cc86ca$var$flatpickr.compareDates = (0, $d16da6e601d564a3$export$c4c806e061935577);
if (typeof jQuery !== "undefined" && typeof jQuery.fn !== "undefined") jQuery.fn.flatpickr = function(config) {
    return $9986d07d28cc86ca$var$_flatpickr(this, config);
};
Date.prototype.fp_incr = function(days) {
    return new Date(this.getFullYear(), this.getMonth(), this.getDate() + (typeof days === "string" ? parseInt(days, 10) : days));
};
if (typeof window !== "undefined") window.flatpickr = $9986d07d28cc86ca$var$flatpickr;
var $9986d07d28cc86ca$export$2e2bcd8739ae039 = $9986d07d28cc86ca$var$flatpickr;





var $dad224760cee6051$exports = {};
(function(global, factory) {
    factory($dad224760cee6051$exports);
})($dad224760cee6051$exports, function(exports1) {
    'use strict';
    var fp = typeof window !== "undefined" && window.flatpickr !== undefined ? window.flatpickr : {
        l10ns: {}
    };
    var German = {
        weekdays: {
            shorthand: [
                "So",
                "Mo",
                "Di",
                "Mi",
                "Do",
                "Fr",
                "Sa"
            ],
            longhand: [
                "Sonntag",
                "Montag",
                "Dienstag",
                "Mittwoch",
                "Donnerstag",
                "Freitag",
                "Samstag"
            ]
        },
        months: {
            shorthand: [
                "Jan",
                "Feb",
                "M\xe4r",
                "Apr",
                "Mai",
                "Jun",
                "Jul",
                "Aug",
                "Sep",
                "Okt",
                "Nov",
                "Dez"
            ],
            longhand: [
                "Januar",
                "Februar",
                "M\xe4rz",
                "April",
                "Mai",
                "Juni",
                "Juli",
                "August",
                "September",
                "Oktober",
                "November",
                "Dezember"
            ]
        },
        firstDayOfWeek: 1,
        weekAbbreviation: "KW",
        rangeSeparator: " bis ",
        scrollTitle: "Zum \xc4ndern scrollen",
        toggleTitle: "Zum Umschalten klicken",
        time_24hr: true
    };
    fp.l10ns.de = German;
    var de = fp.l10ns;
    exports1.German = German;
    exports1.default = de;
    Object.defineProperty(exports1, '__esModule', {
        value: true
    });
});


var $34ba2808af177678$exports = {};
(function(global, factory) {
    factory($34ba2808af177678$exports);
})($34ba2808af177678$exports, function(exports1) {
    'use strict';
    var fp = typeof window !== "undefined" && window.flatpickr !== undefined ? window.flatpickr : {
        l10ns: {}
    };
    var French = {
        firstDayOfWeek: 1,
        weekdays: {
            shorthand: [
                "dim",
                "lun",
                "mar",
                "mer",
                "jeu",
                "ven",
                "sam"
            ],
            longhand: [
                "dimanche",
                "lundi",
                "mardi",
                "mercredi",
                "jeudi",
                "vendredi",
                "samedi"
            ]
        },
        months: {
            shorthand: [
                "janv",
                "f\xe9vr",
                "mars",
                "avr",
                "mai",
                "juin",
                "juil",
                "ao\xfbt",
                "sept",
                "oct",
                "nov",
                "d\xe9c"
            ],
            longhand: [
                "janvier",
                "f\xe9vrier",
                "mars",
                "avril",
                "mai",
                "juin",
                "juillet",
                "ao\xfbt",
                "septembre",
                "octobre",
                "novembre",
                "d\xe9cembre"
            ]
        },
        ordinal: function(nth) {
            if (nth > 1) return "";
            return "er";
        },
        rangeSeparator: " au ",
        weekAbbreviation: "Sem",
        scrollTitle: "D\xe9filer pour augmenter la valeur",
        toggleTitle: "Cliquer pour basculer",
        time_24hr: true
    };
    fp.l10ns.fr = French;
    var fr = fp.l10ns;
    exports1.French = French;
    exports1.default = fr;
    Object.defineProperty(exports1, '__esModule', {
        value: true
    });
});


var $2d773c0dc38d1892$exports = {};
(function(global, factory) {
    factory($2d773c0dc38d1892$exports);
})($2d773c0dc38d1892$exports, function(exports1) {
    'use strict';
    var fp = typeof window !== "undefined" && window.flatpickr !== undefined ? window.flatpickr : {
        l10ns: {}
    };
    var Italian = {
        weekdays: {
            shorthand: [
                "Dom",
                "Lun",
                "Mar",
                "Mer",
                "Gio",
                "Ven",
                "Sab"
            ],
            longhand: [
                "Domenica",
                "Luned\xec",
                "Marted\xec",
                "Mercoled\xec",
                "Gioved\xec",
                "Venerd\xec",
                "Sabato"
            ]
        },
        months: {
            shorthand: [
                "Gen",
                "Feb",
                "Mar",
                "Apr",
                "Mag",
                "Giu",
                "Lug",
                "Ago",
                "Set",
                "Ott",
                "Nov",
                "Dic"
            ],
            longhand: [
                "Gennaio",
                "Febbraio",
                "Marzo",
                "Aprile",
                "Maggio",
                "Giugno",
                "Luglio",
                "Agosto",
                "Settembre",
                "Ottobre",
                "Novembre",
                "Dicembre"
            ]
        },
        firstDayOfWeek: 1,
        ordinal: function() {
            return "\xb0";
        },
        rangeSeparator: " al ",
        weekAbbreviation: "Se",
        scrollTitle: "Scrolla per aumentare",
        toggleTitle: "Clicca per cambiare",
        time_24hr: true
    };
    fp.l10ns.it = Italian;
    var it = fp.l10ns;
    exports1.Italian = Italian;
    exports1.default = it;
    Object.defineProperty(exports1, '__esModule', {
        value: true
    });
});


var $f182ee79b4a84e83$exports = {};
(function(global, factory) {
    factory($f182ee79b4a84e83$exports);
})($f182ee79b4a84e83$exports, function(exports1) {
    'use strict';
    var english = {
        weekdays: {
            shorthand: [
                "Sun",
                "Mon",
                "Tue",
                "Wed",
                "Thu",
                "Fri",
                "Sat"
            ],
            longhand: [
                "Sunday",
                "Monday",
                "Tuesday",
                "Wednesday",
                "Thursday",
                "Friday",
                "Saturday"
            ]
        },
        months: {
            shorthand: [
                "Jan",
                "Feb",
                "Mar",
                "Apr",
                "May",
                "Jun",
                "Jul",
                "Aug",
                "Sep",
                "Oct",
                "Nov",
                "Dec"
            ],
            longhand: [
                "January",
                "February",
                "March",
                "April",
                "May",
                "June",
                "July",
                "August",
                "September",
                "October",
                "November",
                "December"
            ]
        },
        daysInMonth: [
            31,
            28,
            31,
            30,
            31,
            30,
            31,
            31,
            30,
            31,
            30,
            31
        ],
        firstDayOfWeek: 0,
        ordinal: function(nth) {
            var s = nth % 100;
            if (s > 3 && s < 21) return "th";
            switch(s % 10){
                case 1:
                    return "st";
                case 2:
                    return "nd";
                case 3:
                    return "rd";
                default:
                    return "th";
            }
        },
        rangeSeparator: " to ",
        weekAbbreviation: "Wk",
        scrollTitle: "Scroll to increment",
        toggleTitle: "Click to toggle",
        amPM: [
            "AM",
            "PM"
        ],
        yearAriaLabel: "Year",
        monthAriaLabel: "Month",
        hourAriaLabel: "Hour",
        minuteAriaLabel: "Minute",
        time_24hr: false
    };
    exports1.default = english;
    exports1.english = english;
    Object.defineProperty(exports1, '__esModule', {
        value: true
    });
});


var $99c23931b84cf5a0$var$DatePickerLocale = /*#__PURE__*/ function(DatePickerLocale) {
    DatePickerLocale["DE"] = "de";
    DatePickerLocale["FR"] = "fr";
    DatePickerLocale["IT"] = "it";
    DatePickerLocale["EN"] = "en";
    return DatePickerLocale;
}($99c23931b84cf5a0$var$DatePickerLocale || {});
class $99c23931b84cf5a0$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.fieldElement = this.querySelector('input') || undefined;
        const localeValue = this.getAttribute('data-tk-locale');
        this.localeKey = localeValue && $99c23931b84cf5a0$var$DatePickerLocale[localeValue.toUpperCase()] || "de";
        this.allowMobile = this.hasAttribute('data-tk-allow-mobile');
        this.config = {
            positionElement: this.fieldElement,
            disableMobile: !this.allowMobile,
            locale: this.localeKey,
            wrap: true,
            allowInput: true,
            onValueUpdate: this.handleValueUpdate.bind(this)
        };
    }
    connectedCallback() {
        if (!this.fieldElement) return;
        $99c23931b84cf5a0$export$2e2bcd8739ae039.initLanguages();
    }
    handleValueUpdate() {
        this.fieldElement?.removeAttribute('data-tk-ignore-field');
        this.fieldElement?.dispatchEvent(new InputEvent('input'));
    }
    static initLanguages() {
        (0, $9986d07d28cc86ca$export$2e2bcd8739ae039).localize((0, $dad224760cee6051$exports.German));
        (0, $9986d07d28cc86ca$export$2e2bcd8739ae039).localize((0, $34ba2808af177678$exports.French));
        (0, $9986d07d28cc86ca$export$2e2bcd8739ae039).localize((0, $2d773c0dc38d1892$exports.Italian));
        (0, $9986d07d28cc86ca$export$2e2bcd8739ae039).localize((0, $f182ee79b4a84e83$exports.english));
    }
}


class $e018ac17002873dc$export$2e2bcd8739ae039 extends (0, $99c23931b84cf5a0$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.hideWeekNumbers = this.hasAttribute('data-tk-hide-week-numbers');
        this.minDate = this.getAttribute('data-tk-min-date');
        this.maxDate = this.getAttribute('data-tk-max-date');
        this.mode = this.getAttribute('data-tk-mode') || 'single';
        this.monthSelectorType = this.getAttribute('data-tk-month-selector-type') || 'dropdown';
        this.dateFormat = this.getAttribute('data-tk-date-format') || 'd.m.Y';
        this.conjunction = this.getAttribute('data-tk-conjunction') || ',';
        this.defaultDate = this.getAttribute('data-tk-default-date')?.split(';') || null;
        this.disableDates = this.getAttribute('data-tk-disable-dates')?.split(';') || [];
        this.disableWeekend = this.hasAttribute('data-tk-disable-weekend');
        if (this.getAttribute('data-tk-disable-dates-range')) this.disableDatesRange = JSON.parse(this.getAttribute('data-tk-disable-dates-range'));
    }
    connectedCallback() {
        super.connectedCallback();
        const datePickerConfig = {
            weekNumbers: !this.hideWeekNumbers,
            dateFormat: this.dateFormat,
            minDate: this.minDate,
            maxDate: this.maxDate,
            mode: this.mode,
            monthSelectorType: this.monthSelectorType,
            conjunction: this.conjunction,
            defaultDate: this.defaultDate,
            disable: this.disableDateRanges(),
            onReady: (selectedDates, dateStr, instance)=>{
                this.createCustomActionButtons(instance);
            }
        };
        const config = {
            ...this.config,
            ...datePickerConfig
        };
        this.flatpickr = (0, $9986d07d28cc86ca$export$2e2bcd8739ae039)(this, config);
    }
    renderButton(label, className, action) {
        const button = (0, $2d540709c75492d4$export$2e2bcd8739ae039)(`
            <button class="${className}">
                ${label}
            </button>
        `);
        this.pushListener({
            event: 'click',
            element: button,
            action: action
        });
        return button;
    }
    createCustomActionButtons(instance) {
        const { calendarContainer: calendarContainer } = instance;
        const wrapper = (0, $2d540709c75492d4$export$2e2bcd8739ae039)('<div class="flatpickr-calendar__actions-area"></div>');
        const resetButton = this.renderButton(window.opacc.projectDatepickerTexts.reset, 'tk-button tk-button--secondary tk-button--size-s', this.resetDatePicker.bind(this));
        const todayButton = this.renderButton(window.opacc.projectDatepickerTexts.today, 'tk-button tk-button--secondary tk-button--size-s', this.jumpToToday.bind(this));
        wrapper.appendChild(todayButton);
        wrapper.appendChild(resetButton);
        calendarContainer.appendChild(wrapper);
    }
    jumpToToday() {
        const today = new Date();
        this.flatpickr?.setDate(today, true);
        this.flatpickr?.jumpToDate(today);
    }
    resetDatePicker() {
        this.flatpickr?.clear();
    }
    disableDateRanges() {
        const disableWeekend = (date)=>date.getDay() === 0 || date.getDay() === 6;
        this.disableDates = this.disableDates.map((element)=>element.replace('\n', '').trim());
        return [
            ...this.disableDatesRange ?? [],
            ...this.disableDates ?? [],
            ...this.disableWeekend ? [
                disableWeekend.bind(this)
            ] : []
        ];
    }
}




class $96bb90b027be4c0d$export$2e2bcd8739ae039 extends (0, $99c23931b84cf5a0$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.minTime = this.getAttribute('data-tk-min-time');
        this.maxTime = this.getAttribute('data-tk-max-time');
        this.timeFormat = this.getAttribute('data-tk-time-format') || 'H:i';
        this.defaultHour = Number(this.getAttribute('data-tk-default-hour')) || 12;
        this.defaultMinute = Number(this.getAttribute('data-tk-default-minute')) || 0;
    }
    connectedCallback() {
        super.connectedCallback();
        const timePickerConfig = {
            enableTime: true,
            noCalendar: true,
            time_24hr: true,
            dateFormat: this.timeFormat,
            minTime: this.minTime,
            maxTime: this.maxTime,
            defaultHour: this.defaultHour,
            defaultMinute: this.defaultMinute
        };
        const config = {
            ...this.config,
            ...timePickerConfig
        };
        this.flatpickr = (0, $9986d07d28cc86ca$export$2e2bcd8739ae039)(this, config);
    }
}




var $fe64c06a372e274b$export$bcd15065bd7fecf6 = /*#__PURE__*/ function(SortDirectionEnum) {
    SortDirectionEnum["ASC"] = "ASC";
    SortDirectionEnum["DESC"] = "DESC";
    return SortDirectionEnum;
}({});
const $fe64c06a372e274b$export$633da1651c3bd3f9 = (a, b, direction)=>direction.toUpperCase() === "DESC" ? b.localeCompare(a) : a.localeCompare(b);
const $fe64c06a372e274b$export$dcb32d3e7e407924 = (a, b, direction)=>{
    const numberA = Number(a);
    const numberB = Number(b);
    return direction.toUpperCase() === "DESC" ? numberB - numberA : numberA - numberB;
};
const $fe64c06a372e274b$export$c4c806e061935577 = (a, b, direction)=>{
    const dateFormattedA = a.split('.').reverse().join('-');
    const dateFormattedB = b.split('.').reverse().join('-');
    const dateA = Date.parse(dateFormattedA);
    const dateB = Date.parse(dateFormattedB);
    return direction.toUpperCase() === "DESC" ? dateB - dateA : dateA - dateB;
};
const $fe64c06a372e274b$export$15d252ed5f5f8636 = (a, b, direction)=>{
    const dateA = new Date();
    const dateB = new Date();
    const splittedA = a.split(':').map((item)=>Number(item));
    const splittedB = b.split(':').map((item)=>Number(item));
    dateA.setHours(splittedA.at(0) || 0, splittedA.at(1), splittedA.at(2));
    dateB.setHours(splittedB.at(0) || 0, splittedB.at(1), splittedB.at(2));
    const timeA = dateA.getTime();
    const timeB = dateB.getTime();
    return direction.toUpperCase() === "DESC" ? timeB - timeA : timeA - timeB;
};
const $fe64c06a372e274b$export$ed1371d464d87bcf = (a, b, direction)=>{
    const timeStampListA = a.split(' ');
    const timeStampListB = b.split(' ');
    const dateA = timeStampListA.at(0)?.split('.').reverse().join('-');
    const dateB = timeStampListB.at(0)?.split('.').reverse().join('-');
    const timeA = timeStampListA.at(1);
    const timeB = timeStampListB.at(1);
    const timestampA = Date.parse(`${dateA}T${timeA}`);
    const timestampB = Date.parse(`${dateB}T${timeB}`);
    return direction.toUpperCase() === "DESC" ? timestampB - timestampA : timestampA - timestampB;
};
const $fe64c06a372e274b$export$92f3520fe1ac7383 = (a, b, direction)=>{
    const booleanA = Boolean(a);
    const booleanB = Boolean(b);
    const numberA = Number(booleanA);
    const numberB = Number(booleanB);
    return direction === "DESC" ? numberB - numberA : numberA - numberB;
};



var $2595e2ca594d6789$var$DataMaster = /*#__PURE__*/ function(DataMaster) {
    DataMaster["CLIENT"] = "client";
    return DataMaster;
}($2595e2ca594d6789$var$DataMaster || {});
class $2595e2ca594d6789$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super(), this.gridTemplateColList = [], this.hasAccordionRows = false, this.isHorizontalScrollable = false;
        this.headElement = this.querySelector('[data-tk-table-head]') || undefined;
        if (!this.headElement) throw new Error('Table: Head is missing!');
        this.rowHeadElement = this.headElement.querySelector('[data-tk-table-row]') || undefined;
        this.headShadowClassName = this.getAttribute('data-tk-head-shadow-class-name') || 'tk-table__head-shadow';
        this.isStickyLeft = this.hasAttribute('data-tk-is-sticky-left');
        this.isStickyHead = this.hasAttribute('data-tk-is-sticky-head');
        this.gridTemplateMobile = this.getAttribute('data-tk-grid-template-mobile') || '1fr';
        this.loadedClassName = this.getAttribute('data-tk-loaded-class-name') || 'tk-table--loaded';
        this.stickyLeftClassname = this.getAttribute('data-tk-sticky-left-class-name') || 'tk-table--sticky-left';
        this.rightShadowClassName = this.getAttribute('data-tk-right-shadow-class-name') || 'tk-table__right-shadow';
        this.stickyHeadClassName = this.getAttribute('data-tk-sticky-head-class-name') || 'tk-table--sticky-head';
        this.customCols = this.getAttribute('data-tk-col-width') || 'auto';
        this.observer = new ResizeObserver(this.handleResize.bind(this));
        this.desktopMinWidth = Number(this.getAttribute('data-tk-desktop-min-width')) || 992;
        this.rowLinkSelector = 'data-tk-table-row-link';
        this.table = this.querySelector('table') || undefined;
        this.ascSortClassName = this.getAttribute('data-tk-asc-sort-class-name') || 'tk-table--sort-asc';
        this.descSortClassName = this.getAttribute('data-tk-desc-sort-class-name') || 'tk-table--sort-desc';
        this.isSortTable = Boolean(this.table?.hasAttribute('data-tk-table-sort'));
        this.colAlignStart = this.hasAttribute('data-tk-col-align-start');
        this.colAlignStartClassName = this.getAttribute('data-tk-col-align-start-class-name') || 'tk-table__col--align-left';
        this.colItemAlignCenter = this.hasAttribute('data-tk-col-item-align-center');
        this.colItemAlignCenterClassName = this.getAttribute('data-tk-col-item-align-center-class-name') || 'tk-table__col--item-align-center';
        this.colItemAlignStart = this.hasAttribute('data-tk-col-item-align-start');
        this.colItemAlignStartClassName = this.getAttribute('data-tk-col-item-align-start-class-name') || 'tk-table__col--item-align-start';
        this.colItemAlignEnd = this.hasAttribute('data-tk-col-item-align-end');
        this.colItemAlignEndClassName = this.getAttribute('data-tk-col-item-align-end-class-name') || 'tk-table__col--item-align-end';
        this.tableSelector = '[data-tk-table-sort]';
        this.sortDirectionSelector = '[data-tk-sort-direction]';
        this.tkSortDirectionSelector = 'tkSortDirection';
        this.tkSortAttrSelector = 'tkSortAttr';
        this.tkSortDatatypeSelector = 'tkSortDatatype';
        this.dataMasterSelector = 'data-tk-datamaster';
        this.dataSortAttrSelector = 'data-tk-sort-attr';
        this.hasAccordionRows = this.hasAttribute('data-tk-accordion-rows');
        this.accordionRowHeadActiveClassName = this.getDataAttribute('accordion-row-head-active-class-name', 'tk-table__row--head-accordion-active');
        this.accordionRowBodyActiveClassName = this.getDataAttribute('accordion-row-body-active-class-name', 'tk-table__row--body-accordion-active');
        this.accordionLastElementClassName = this.getDataAttribute('accordion-last-element-class-name', 'tk-table--accordion-last-row');
    }
    connectedCallback() {
        this.classList.add(this.loadedClassName);
        window.viewport.clientWidth < this.desktopMinWidth ? this.setGridMobile() : this.setGrid();
        this.registerViewportListener();
        this.registerScrollListener();
        this.registerRowLinkListener();
        this.observer.observe(this);
        this.isStickyHead && this.setStickyHead();
        this.isSortTable && this.registerTableHeadListener();
        this.colAlignStart && this.setColAlignStart();
        this.colItemAlignCenter && this.setColItemAlign(this.colItemAlignCenterClassName);
        this.colItemAlignStart && this.setColItemAlign(this.colItemAlignStartClassName);
        this.colItemAlignEnd && this.setColItemAlign(this.colItemAlignEndClassName);
        this.hasAccordionRows && this.registerAccordionListener();
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        this.observer.unobserve(this);
    }
    registerViewportListener() {
        const onViewportResize = this.handleViewportResize.bind(this);
        this.pushListener({
            event: 'tk-viewport-resize',
            element: window.viewport,
            action: onViewportResize
        });
    }
    handleViewportResize(event) {
        const customEvent = event;
        if (customEvent.detail.width < this.desktopMinWidth) this.setGridMobile();
        else this.setGrid();
    }
    registerScrollListener() {
        const handleHorizontalScrollListener = this.toggleScrollHorizontalBehavior.bind(this);
        this.pushListener({
            event: 'scroll',
            element: this,
            action: handleHorizontalScrollListener
        });
        if (this.isStickyLeft) {
            const handleStickyLeftListener = this.toggleScrollLeftBehavior.bind(this);
            this.pushListener({
                event: 'scroll',
                element: this,
                action: handleStickyLeftListener
            });
        }
        if (this.isStickyHead) {
            const handleStickyHeadListener = this.toggleScrollTopBehavior.bind(this);
            this.pushListener({
                event: 'scroll',
                element: this,
                action: handleStickyHeadListener
            });
        }
    }
    registerTableHeadListener() {
        const handleSortTable = this.handleSortTable.bind(this);
        this.pushListener({
            event: 'click',
            element: this,
            action: handleSortTable
        });
    }
    registerRowLinkListener() {
        const handleRowLink = this.handleRowLink.bind(this);
        this.pushListener({
            event: 'click',
            element: this,
            action: handleRowLink
        });
    }
    registerAccordionListener() {
        const onClick = this.handleAccordion.bind(this);
        const rows = this.querySelectorAll('[data-tk-table-row-id]');
        rows.forEach((row)=>{
            this.pushListener({
                event: 'click',
                element: row,
                action: onClick
            });
        });
    }
    handleRowLink(event) {
        const target = event.target;
        if (target.closest('a')) return;
        if (target.closest('button')) return;
        const row = target.closest(`[${this.rowLinkSelector}]`);
        if (!row) return;
        const link = row.getAttribute(this.rowLinkSelector);
        if (!link) return;
        window.location.href = link;
    }
    handleSortTable(event) {
        if (!event) return;
        const target = event.target;
        const column = target.closest('th');
        column && column.hasAttribute('data-tk-sort-direction') && this.sortTable(column);
    }
    handleResize(entries) {
        entries.forEach(()=>{
            this.isHorizontalScrollable = this.scrollWidth > this.clientWidth;
            if (this.isHorizontalScrollable && !this.horizontalScrollShadowElement) this.setHorizontalScrollShadow();
            if (!this.horizontalScrollShadowElement) return;
            this.horizontalScrollShadowElement.hidden = !this.isHorizontalScrollable;
            this.boxShadowElement && (this.boxShadowElement.style.width = `${this.scrollWidth}px`);
        });
    }
    setGrid() {
        if (!this.rowHeadElement) return;
        const cols = this.rowHeadElement.childElementCount;
        this.gridTemplateColList = this.customCols?.split(/(?!, ),/g);
        this.style.gridTemplateColumns = this.customCols?.includes(',') ? this.gridTemplateColList?.join(' ') : `repeat(${cols}, ${this.customCols})`;
        if (this.headElement) this.headElement.classList.remove('tk-table__head--force-mobile');
        const titleElements = this.table?.querySelectorAll('[data-tk-table-body] .tk-table__title');
        if (!titleElements) return;
        titleElements.forEach((titleElement)=>{
            titleElement.classList.remove('tk-table__title--force-mobile');
        });
    }
    setGridMobile() {
        this.style.gridTemplateColumns = this.gridTemplateMobile;
        if (this.headElement) this.headElement.classList.add('tk-table__head--force-mobile');
        const titleElements = this.table?.querySelectorAll('[data-tk-table-body] .tk-table__title');
        if (!titleElements) return;
        titleElements.forEach((titleElement)=>{
            titleElement.classList.add('tk-table__title--force-mobile');
        });
    }
    toggleScrollLeftBehavior(event) {
        const element = event.target;
        this.classList.toggle(this.stickyLeftClassname, element.scrollLeft > 0);
    }
    toggleScrollHorizontalBehavior(event) {
        if (!this.horizontalScrollShadowElement) return;
        const { scrollLeft: scrollLeft, scrollWidth: scrollWidth, clientWidth: clientWidth } = event.target;
        this.horizontalScrollShadowElement.hidden = scrollLeft >= scrollWidth - clientWidth;
        this.horizontalScrollShadowElement.style.right = `-${scrollLeft}px`;
    }
    toggleScrollTopBehavior(event) {
        if (!this.boxShadowElement) return;
        const element = event.target;
        this.boxShadowElement.hidden = element.scrollTop === 0;
        this.classList.toggle(this.stickyHeadClassName, element.scrollTop > 0);
        this.boxShadowElement.style.top = `${element.scrollTop}px`;
    }
    setStickyHead() {
        if (!this.headElement) return;
        this.boxShadowElement = (0, $2d540709c75492d4$export$2e2bcd8739ae039)(`<div class='${this.headShadowClassName}' hidden></div>`);
        if (!this.boxShadowElement) return;
        const column = this.rowHeadElement?.firstElementChild;
        const height = column?.getBoundingClientRect().height || 0;
        this.boxShadowElement.style.width = `${this.scrollWidth}px`;
        this.boxShadowElement.style.height = `${height}px`;
        this.headElement.insertAdjacentElement('afterbegin', this.boxShadowElement);
    }
    setHorizontalScrollShadow() {
        this.horizontalScrollShadowElement = (0, $2d540709c75492d4$export$2e2bcd8739ae039)(`<div class='${this.rightShadowClassName}'></div>`);
        if (!this.horizontalScrollShadowElement) return;
        this.insertAdjacentElement('beforeend', this.horizontalScrollShadowElement);
    }
    sortTable(column) {
        const dataMaster = this.table?.getAttribute(this.dataMasterSelector);
        if (dataMaster === "client") {
            this.setOrToggleSortDirection(column);
            this.clearHeadElementClassList(column);
            this.clientSortTable({
                element: column,
                type: column.dataset[this.tkSortDatatypeSelector],
                sortDirection: column.dataset[this.tkSortDirectionSelector],
                column: column.cellIndex
            });
            this.postAsynClientSortState(column);
        } else this.serverAsynTableSortRequest(column);
    }
    clientSortTable(headItem) {
        const tableBody = this.table?.querySelector('[data-tk-table-body]');
        if (!tableBody) return;
        const rows = tableBody.querySelectorAll('[data-tk-table-row]');
        if (!rows) return;
        const rowList = Array.from(rows).map((element)=>{
            const value = Array.from(element.querySelectorAll('[data-tk-table-value]')).at(headItem.column)?.textContent || '';
            return {
                element: element,
                value: value
            };
        });
        const sortTypes = {
            A: (a, b)=>(0, $fe64c06a372e274b$export$633da1651c3bd3f9)(a, b, headItem.sortDirection),
            N: (a, b)=>(0, $fe64c06a372e274b$export$dcb32d3e7e407924)(a, b, headItem.sortDirection),
            D: (a, b)=>(0, $fe64c06a372e274b$export$c4c806e061935577)(a, b, headItem.sortDirection),
            H: (a, b)=>(0, $fe64c06a372e274b$export$15d252ed5f5f8636)(a, b, headItem.sortDirection),
            S: (a, b)=>(0, $fe64c06a372e274b$export$ed1371d464d87bcf)(a, b, headItem.sortDirection),
            B: (a, b)=>(0, $fe64c06a372e274b$export$92f3520fe1ac7383)(a, b, headItem.sortDirection)
        };
        const sortedList = rowList.sort((a, b)=>sortTypes[headItem.type](a.value, b.value));
        tableBody.innerHTML = '';
        sortedList.forEach((item)=>{
            tableBody.appendChild(item.element);
        });
        if (headItem.element.classList.contains(this.ascSortClassName) || headItem.element.classList.contains(this.descSortClassName)) headItem.sortDirection.toUpperCase() === (0, $fe64c06a372e274b$export$bcd15065bd7fecf6).DESC ? headItem.element.classList.replace(this.ascSortClassName, this.descSortClassName) : headItem.element.classList.replace(this.descSortClassName, this.ascSortClassName);
        else headItem.sortDirection.toUpperCase() === (0, $fe64c06a372e274b$export$bcd15065bd7fecf6).DESC ? headItem.element.classList.add(this.descSortClassName) : headItem.element.classList.add(this.ascSortClassName);
    }
    clearHeadElementClassList(column) {
        if (!this.rowHeadElement) return;
        const head = Array.from(this.rowHeadElement.children);
        const filteredHead = head.filter((item)=>item !== column);
        filteredHead.forEach((child)=>{
            const element = child;
            element.classList.remove(this.ascSortClassName);
            element.classList.remove(this.descSortClassName);
        });
    }
    setOrToggleSortDirection(thElement) {
        this.removeUnseletectedSortDir(thElement);
        // toggelt direction auf geklickten header spalte
        thElement.dataset[this.tkSortDirectionSelector] = thElement.dataset[this.tkSortDirectionSelector] === (0, $fe64c06a372e274b$export$bcd15065bd7fecf6).ASC ? (0, $fe64c06a372e274b$export$bcd15065bd7fecf6).DESC : (0, $fe64c06a372e274b$export$bcd15065bd7fecf6).ASC;
    }
    serverAsynTableSortRequest(thElement) {
        this.setOrToggleSortDirection(thElement);
        const url = window.location.href;
        const options = this.getAsynPostOptions(thElement);
        (0, $1653b55d89a7adce$export$24835cb787452b46)({
            requestURL: url,
            resolveHandler: this.asyncTableSortHandler.bind(this),
            payload: options
        });
    }
    postAsynClientSortState(thElement) {
        const url = window.location.href;
        const options = this.getAsynPostOptions(thElement);
        (0, $1653b55d89a7adce$export$24835cb787452b46)({
            requestURL: url,
            resolveHandler: ()=>{},
            payload: options
        });
    }
    asyncTableSortHandler(response) {
        if (!response.success || !response.dataAsHtml) return;
        const html = (0, $2d540709c75492d4$export$2e2bcd8739ae039)(response.dataAsHtml);
        this.replaceAllResponseTable(html);
    }
    replaceAllResponseTable(element) {
        const oldTables = document.querySelectorAll(this.tableSelector);
        const newTables = element.querySelectorAll(this.tableSelector);
        oldTables.forEach((oldTable)=>{
            const correspondingNewTable = Array.from(newTables).find((newTable)=>oldTable.id === newTable.id);
            if (correspondingNewTable) oldTable?.parentNode?.replaceChild(correspondingNewTable, oldTable);
        });
    }
    getAsynPostOptions(thElement) {
        const table = thElement.closest(this.tableSelector);
        if (!table) return {};
        const client = table.getAttribute(this.dataMasterSelector);
        const sortAttribut = thElement.dataset[this.tkSortAttrSelector];
        const sortDirection = thElement.dataset[this.tkSortDirectionSelector];
        const options = {
            type: 'tablesort',
            clientSort: String(!!client),
            tableid: table.id,
            sorting: `{"${sortAttribut}":"${sortDirection}"}`
        };
        return options;
    }
    removeUnseletectedSortDir(thElement) {
        const sortAttribut = thElement.dataset[this.tkSortAttrSelector];
        const table = thElement.closest(this.tableSelector);
        if (!table) return;
        const headers = table.querySelectorAll(this.sortDirectionSelector);
        headers.forEach((header)=>{
            const headerSortAttr = header.dataset[this.tkSortAttrSelector];
            if (headerSortAttr === sortAttribut) return;
            header.dataset[this.tkSortDirectionSelector] = '';
        });
    }
    setColAlignStart() {
        const tableBody = this.table?.querySelector('[data-tk-table-body]');
        if (!tableBody) return;
        const cols = tableBody.querySelectorAll('[data-tk-table-row] td');
        if (!cols) return;
        cols.forEach((col)=>{
            col.classList.add(this.colAlignStartClassName);
        });
    }
    setColItemAlign(className) {
        const tableBody = this.table?.querySelector('[data-tk-table-body]');
        if (!tableBody) return;
        const cols = tableBody.querySelectorAll('[data-tk-table-row] td');
        if (!cols) return;
        cols.forEach((col)=>{
            col.classList.add(className);
        });
    }
    handleAccordion(event) {
        const headElement = event.currentTarget;
        const id = headElement.getAttribute('data-tk-table-row-id');
        if (!id) return;
        const bodyElements = this.querySelectorAll(`[data-tk-table-accordion="${id}"]`);
        const isActive = headElement.classList.toggle(this.accordionRowHeadActiveClassName);
        bodyElements.forEach((element, index)=>{
            element.hidden = !isActive;
            element.classList.toggle(this.accordionRowBodyActiveClassName, isActive);
            if (index === bodyElements.length - 1) element.classList.add(this.accordionLastElementClassName);
        });
    }
}



class $c51b1a9a7c03f7bf$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.chip = this.querySelector('[data-tk-filter-chip-remove]') || undefined;
        this.tkFilter = this.closest('[data-tk-filter-wrapper]') || undefined;
    }
    connectedCallback() {
        if (!this.chip || !this.dataset.tkFilterChipId || !this.dataset.tkFilterChipAttribute || !this.dataset.tkFilterChipValue) return;
        this.filterItem = {
            id: this.dataset.tkFilterChipId,
            attr: this.dataset.tkFilterChipAttribute,
            value: this.dataset.tkFilterChipValue
        };
        this.registerClickListener();
        this.registerFilterListener();
    }
    registerClickListener() {
        const handleRemoveChip = this.removeFilterItem.bind(this);
        this.pushListener({
            event: 'click',
            element: this.chip,
            action: handleRemoveChip
        });
    }
    registerFilterListener() {
        this.tkFilter?.subscribe((data)=>{
            if (data.action === 'REFRESHED') {
                if (!this.tkFilter?.exist(this.filterItem)) this.remove();
            }
        });
    }
    removeFilterItem() {
        this.tkFilter?.delete(this.filterItem);
        this.tkFilter?.post();
    }
}



class $4e5f7d9c5ffa7d20$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.removeAll = this.querySelector('[data-tk-filter-result-remove]') || undefined;
        this.tkFilter = this.closest('[data-tk-filter-wrapper]') || undefined;
    }
    connectedCallback() {
        this.registerClickListener();
        this.registerFilterListener();
    }
    registerClickListener() {
        const handleRemoveAll = this.removeFilterItems.bind(this);
        this.pushListener({
            event: 'click',
            element: this.removeAll,
            action: handleRemoveAll
        });
    }
    registerFilterListener() {
        this.tkFilter?.subscribe((data)=>{
            if (data.action === 'REFRESHED') {
                if (data.filterList.length === 0) this.remove();
            }
        });
    }
    removeFilterItems() {
        this.tkFilter?.deleteAll();
        this.tkFilter?.post();
    }
}






const $f1a4dbe7c35f0ef9$var$group = (array, property)=>array.reduce((result, object)=>{
        const key = object[property];
        if (!result[key]) result[key] = [];
        result[key].push(object);
        return result;
    }, {});
var $f1a4dbe7c35f0ef9$export$2e2bcd8739ae039 = $f1a4dbe7c35f0ef9$var$group;



const $4cfe9ec7fa1b3e1e$var$showDimmer = (elementToAttach, style)=>{
    if (elementToAttach) {
        const dimmer = (0, $2d540709c75492d4$export$2e2bcd8739ae039)('<div class="tk-dimmer tk-dimmer--attached"></div>');
        style && Object.keys(style).forEach((key)=>{
            dimmer.style.setProperty(key, style[key]);
        });
        elementToAttach.insertAdjacentElement('beforeend', dimmer);
        return dimmer;
    } else {
        const dimmer = (0, $2d540709c75492d4$export$2e2bcd8739ae039)('<div class="tk-dimmer"></div>');
        const dialog = Array.from(document.querySelectorAll('dialog[open]'));
        dialog.length > 0 ? dialog.at(-1)?.insertAdjacentElement('beforeend', dimmer) : document.body.insertAdjacentElement('beforeend', dimmer);
        return dimmer;
    }
};
var $4cfe9ec7fa1b3e1e$export$2e2bcd8739ae039 = $4cfe9ec7fa1b3e1e$var$showDimmer;


var $178b0b1cc6a532a3$export$c67e46de1ec7dfa6 = /*#__PURE__*/ function(FilterType) {
    FilterType["RD_FILTER"] = "rd-filter";
    FilterType["URL_PARAM_FILTER"] = "url-param-filter";
    FilterType["SIMPLE_FILTER"] = "simple-filter";
    return FilterType;
}({});
class $178b0b1cc6a532a3$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super(), this.observers = [];
        this.type = this.getAttribute('data-tk-filter-type') || "url-param-filter";
        this.groupId = this.getAttribute('data-tk-filter-group-id') || 'cat';
        this.pageLayout = this.getAttribute('data-tk-page-layout') || 'asyn';
        this.allowURLParamsPrefix = this.getAttribute('data-tk-allow-url-params-prefix') || 'cf-';
        this.filterGroupSelectedClassName = this.getAttribute('data-tk-filter-group-selected-class-name') || 'tk-filter-group--has-selected';
        this.filterList = [];
        this.filterURL = this.getAttribute('data-tk-filter-url') || undefined;
    }
    connectedCallback() {
        this.emit({
            action: 'STARTED',
            filterList: this.filterList
        });
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        this.emit({
            action: 'ENDED',
            filterList: this.filterList
        });
    }
    subscribe(listener) {
        this.observers.push(listener);
    }
    emit(data) {
        this.observers.forEach((listener)=>{
            listener(data);
        });
    }
    add(filterList, isRange = false) {
        const property = this.type === "rd-filter" ? 'id' : 'attr';
        const selectedProperties = new Set(filterList.map((item)=>item[property]));
        selectedProperties.forEach((item)=>{
            this.deleteAllByProp(item);
        });
        if (isRange) {
            const filterValues = filterList.map((item)=>item.value);
            const filterItem = filterList.at(0);
            if (!filterItem) return;
            const { id: id, attr: attr } = filterItem;
            this.filterList.push({
                id: id,
                attr: attr,
                value: $178b0b1cc6a532a3$export$2e2bcd8739ae039.convertToMultiValue(filterValues)
            });
        } else filterList.forEach((item)=>{
            this.filterList.push(item);
        });
    }
    exist({ id: id, attr: attr, value: value }) {
        return this.type === "rd-filter" ? this.filterList.some((item)=>item.id === id && item.value === value) : this.filterList.some((item)=>item.attr === attr && item.value === $178b0b1cc6a532a3$export$2e2bcd8739ae039.neutralizeRangeValue(value));
    }
    delete({ id: id, attr: attr, value: value }) {
        const filteredList = this.filterList.filter((item)=>item.id !== id || item.value !== value || item.attr !== attr);
        this.filterList = filteredList;
    }
    deleteAllByProp(value) {
        const property = this.type === "rd-filter" ? 'id' : 'attr';
        const filteredList = this.filterList.filter((item)=>item[property] !== value);
        this.filterList = filteredList;
    }
    deleteAll() {
        this.filterList = [];
        this.emit({
            action: 'RESETTED',
            filterList: this.filterList
        });
    }
    post() {
        const preparedFilter = this.getPreparedFilter(this.type);
        const request = {
            requestURL: preparedFilter.url,
            resolveHandler: this.refreshResultList.bind(this)
        };
        if (this.type === "simple-filter") request.payload = preparedFilter.data;
        (0, $1653b55d89a7adce$export$24835cb787452b46)(request);
        this.emit({
            action: 'SENDED',
            filterList: this.filterList
        });
        if (this.type === "simple-filter") return;
        !this.filterURL && window.history.replaceState(null, '', preparedFilter.url);
        this.dimmer = (0, $4cfe9ec7fa1b3e1e$export$2e2bcd8739ae039)();
    }
    refreshResultList(response) {
        if (!response || !response.success) return;
        const currentContent = this.querySelector('[data-tk-filter-content]');
        const html = (0, $2d540709c75492d4$export$2e2bcd8739ae039)(response.dataAsHtml, true);
        const newContent = html.querySelector('[data-tk-filter-content]');
        if (!currentContent || !newContent) return;
        currentContent.innerHTML = newContent.innerHTML;
        this.emit({
            action: 'REFRESHED',
            filterList: this.filterList
        });
        this.dimmer?.remove();
    }
    refreshDrilldown() {
        const groupedData = (0, $f1a4dbe7c35f0ef9$export$2e2bcd8739ae039)(this.filterList, 'id');
        const list = [];
        Object.keys(groupedData).forEach((key)=>{
            const values = groupedData[key].map((obj)=>obj.value).join(', ');
            list.push({
                id: key,
                values: values
            });
        });
        this.resetFilterGroups(list.map((item)=>item.id));
        const preparedFilter = this.getPreparedFilter(this.type);
        const request = {
            requestURL: preparedFilter.url,
            resolveHandler: this.refreshDrilldownContent.bind(this)
        };
        if (this.type === "simple-filter") request.payload = preparedFilter.data;
        (0, $1653b55d89a7adce$export$24835cb787452b46)(request);
        this.emit({
            action: 'SENDED',
            filterList: this.filterList
        });
        if (this.type === "simple-filter") return;
        window.history.replaceState(null, '', preparedFilter.url);
    }
    refreshDrilldownContent(response) {
        if (!response || !response.success) return;
        const currentContent = this.querySelector('[data-tk-filter-group-wrapper]');
        const html = (0, $2d540709c75492d4$export$2e2bcd8739ae039)(response.dataAsHtml, true);
        const newContent = html.querySelector('[data-tk-filter-group-wrapper]');
        const articleListContent = this.querySelector('[data-tk-article-list]');
        const articleListHTML = (0, $2d540709c75492d4$export$2e2bcd8739ae039)(response.dataAsHtml, true);
        const newArticleListContent = articleListHTML.querySelector('[data-tk-article-list]');
        if (!currentContent || !newContent || !articleListContent || !newArticleListContent) return;
        currentContent.innerHTML = newContent.innerHTML;
        articleListContent.innerHTML = newArticleListContent.innerHTML;
        currentContent.sync();
        this.emit({
            action: 'REFRESHED-DRILLDOWN',
            filterList: this.filterList
        });
    }
    resetFilterGroups(filteredIds) {
        const filterGroupElements = this.querySelectorAll('[data-tk-filter-group-dropdown]');
        const filterGroupList = Array.from(filterGroupElements);
        const filteredList = filterGroupList.filter((element)=>!filteredIds.includes(element.getAttribute('data-tk-filter-group-dropdown') || ''));
        filteredList.forEach((element)=>{
            element.classList.remove(this.filterGroupSelectedClassName);
            const selectedElement = element.querySelector('[data-tk-filter-group-selected]');
            if (!selectedElement) return;
            selectedElement.textContent = '';
        });
    }
    getPreparedFilter(type) {
        const handlers = {
            'rd-filter': this.prepareRDFilter.bind(this),
            'url-param-filter': this.prepareQueryFilter.bind(this),
            'simple-filter': this.prepareSimpleFilter.bind(this)
        };
        return handlers[type]();
    }
    prepareRDFilter() {
        const groupedArray = this.getGroupedFilterArrayValue('id');
        const jsonString = JSON.stringify(groupedArray);
        const data = {};
        data[this.groupId] = jsonString;
        const urlData = {};
        urlData[this.groupId] = window.btoa(encodeURIComponent(jsonString));
        const url = Object.keys(groupedArray).length > 0 ? this.mergeURLParamsByData(urlData) : this.mergeURLParamsByData(urlData, true);
        return {
            data: data,
            url: url.href
        };
    }
    prepareQueryFilter() {
        const data = this.getGroupedFilter('attr', ',');
        const urlParams = this.getGroupedFilter('attr', '|');
        const url = this.mergeURLParams(urlParams);
        return {
            data: data,
            url: url.href
        };
    }
    prepareSimpleFilter() {
        const groupedArray = (0, $f1a4dbe7c35f0ef9$export$2e2bcd8739ae039)(this.filterList, 'id');
        const jsonString = JSON.stringify(groupedArray);
        const data = {};
        data.selection = jsonString;
        const url = $178b0b1cc6a532a3$export$2e2bcd8739ae039.mergeURLs(this.filterURL) || new URL(window.location.href);
        url.searchParams.set('pagelayout', this.pageLayout);
        return {
            data: data,
            url: url.href
        };
    }
    getGroupedFilter(property, separator) {
        const groupedArray = (0, $f1a4dbe7c35f0ef9$export$2e2bcd8739ae039)(this.filterList, property);
        const result = {};
        Object.keys(groupedArray).forEach((key)=>{
            const values = groupedArray[key].map((obj)=>obj.value).join(separator);
            result[key] = values;
        });
        return result;
    }
    getGroupedFilterArrayValue(property) {
        const groupedArray = (0, $f1a4dbe7c35f0ef9$export$2e2bcd8739ae039)(this.filterList, property);
        const result = {};
        Object.keys(groupedArray).forEach((key)=>{
            const values = groupedArray[key].map((obj)=>obj.value);
            result[key] = values;
        });
        return result;
    }
    mergeURLParamsByData(data, shouldReset = false) {
        const url = $178b0b1cc6a532a3$export$2e2bcd8739ae039.mergeURLs(this.filterURL) || new URL(window.location.href);
        const searchParamList = Array.from(url.searchParams);
        const filteredList = searchParamList.filter((item)=>!item[0].startsWith(this.groupId));
        const existingParams = Object.fromEntries(filteredList);
        const mergedParams = shouldReset ? {
            ...existingParams
        } : {
            ...data,
            ...existingParams
        };
        url.search = new URLSearchParams(mergedParams).toString();
        return url;
    }
    mergeURLParams(selectedParams) {
        const url = $178b0b1cc6a532a3$export$2e2bcd8739ae039.mergeURLs(this.filterURL) || new URL(window.location.href);
        const allowedList = this.allowURLParamsPrefix.split(',');
        const searchParamList = Array.from(url.searchParams);
        const filteredList = searchParamList.filter((item)=>allowedList.every((allowed)=>!item[0].startsWith(allowed)));
        const existingParams = Object.fromEntries(filteredList);
        const mergedParams = {
            ...selectedParams,
            ...existingParams
        };
        url.search = new URLSearchParams(mergedParams).toString();
        return url;
    }
    static convertToMultiValue(multivalues) {
        return `[${multivalues.join('|')}]`;
    }
    static neutralizeRangeValue(value) {
        if (value.includes('[') || value.includes(']')) return value.replaceAll('[', '').replaceAll(']', '');
        return value;
    }
    static mergeURLs(relativeURL) {
        if (!relativeURL) return;
        const baseURL = new URL(window.location.href);
        const mergedURL = new URL(relativeURL, baseURL.origin);
        mergedURL.search = baseURL.search;
        return mergedURL;
    }
}


class $058daee80809af6c$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.tkFilter = this.closest('[data-tk-filter-wrapper]') || undefined;
        this.tkFilterGroup = this.closest('[data-tk-filter-group]') || undefined;
        this.filterForm = this.querySelector('form') || undefined;
        this.applyButton = this.querySelector('[data-tk-filter-apply]') || undefined;
        this.counterElement = this.querySelector('[data-tk-filter-dropdown-counter]') || undefined;
        this.hasItemsClassName = this.getAttribute('data-tk-has-items-class-name') || 'tk-filter-dropdown--has-items';
    }
    connectedCallback() {
        if (!this.dataset.tkFilterDropdownId || !this.dataset.tkFilterDropdownAttribute || !this.filterForm || !this.applyButton) return;
        if (this.checkFilterItems()) this.setupFilterList();
        this.registerListener();
        this.registerFilterListener();
    }
    registerFilterListener() {
        this.tkFilter?.subscribe((data)=>{
            if (data.action !== 'REFRESHED-DRILLDOWN' || !this.counterElement) return;
            const filteredList = data.filterList.filter((item)=>item.id === this.getAttribute('data-tk-filter-dropdown-id'));
            this.counterElement.textContent = String(filteredList.length);
            this.classList.toggle(this.hasItemsClassName, filteredList.length > 0);
        });
    }
    registerListener() {
        const handleFilterSubmit = this.performFilter.bind(this);
        this.pushListener({
            event: 'submit',
            element: this.filterForm,
            action: handleFilterSubmit
        });
        const handleFilterApply = this.applyFilterItem.bind(this);
        this.pushListener({
            event: 'click',
            element: this.applyButton,
            action: handleFilterApply
        });
    }
    setupFilterList() {
        const data = this.getFormData();
        data.length > 0 && this.addFilterItems(data);
    }
    applyFilterItem() {
        const data = this.getFormData();
        if (data.length > 0) this.addFilterItems(data);
        else this.tkFilter?.deleteAllByProp(this.tkFilter?.type === (0, $178b0b1cc6a532a3$export$c67e46de1ec7dfa6).RD_FILTER ? this.dataset.tkFilterDropdownId : this.dataset.tkFilterDropdownAttribute);
        this.tkFilter?.refreshDrilldown();
    }
    performFilter(event) {
        event.preventDefault();
        const data = this.getFormData();
        if (data.length > 0) this.addFilterItems(data);
        else this.tkFilter?.deleteAllByProp(this.tkFilter?.type === (0, $178b0b1cc6a532a3$export$c67e46de1ec7dfa6).RD_FILTER ? this.dataset.tkFilterDropdownId : this.dataset.tkFilterDropdownAttribute);
        this.tkFilter?.post();
    }
    getFormData() {
        const formData = new FormData(this.filterForm);
        const fieldElements = this.filterForm?.querySelectorAll('input, select');
        if (!fieldElements) return [];
        const ignoreFieldElements = Array.from(fieldElements).filter((element)=>element.hasAttribute('data-tk-ignore-field') && !element.closest('[data-tk-filter-dropdown-is-range]'));
        const ignoreFieldNames = ignoreFieldElements.map((field)=>field.getAttribute('name') || '');
        ignoreFieldNames.forEach((name)=>formData.delete(name));
        const dataList = Array.from(formData.entries());
        return dataList.filter((item)=>item[1].toString() !== '').map((item)=>{
            const value = item[1].toString();
            return {
                key: item[0],
                value: value
            };
        });
    }
    checkFilterItems() {
        const data = this.getFormData();
        return Object.keys(data).length > 0;
    }
    addFilterItems(data) {
        this.clearFilterCollection();
        data.forEach((item)=>{
            this.filterCollection.push({
                id: this.dataset.tkFilterDropdownId,
                attr: this.dataset.tkFilterDropdownAttribute,
                value: item.value
            });
        });
        this.tkFilter?.add(this.filterCollection, this.hasAttribute('data-tk-filter-dropdown-is-range'));
    }
    clearFilterCollection() {
        this.filterCollection = [];
    }
}



class $6deb510fe3e19897$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super(), this.groupsShowingCount = 0, this.groupCount = 0;
        this.tkFilter = this.closest('[data-tk-filter-wrapper]') || undefined;
        this.moreGroupWrapperClassName = this.getAttribute('data-tk-filter-group-wrapper-more-class') || 'tk-filter-group-wrapper--expand';
        this.collapseButton = this.querySelector('[data-tk-filter-group-collapse]') || undefined;
        this.expandButton = this.querySelector('[data-tk-filter-group-expand]') || undefined;
        this.closeDrilldownButtons = this.querySelectorAll('[data-tk-close-drilldown]') || undefined;
        this.resizeObserver = new ResizeObserver(this.checkResize.bind(this));
        this.drilldownClassName = this.getAttribute('data-tk-drilldown-class-name') || 'tk-filter-group-wrapper--drilldown';
        this.loadedClassName = this.getAttribute('data-tk-loaded-class-name') || 'tk-filter-group-wrapper--loaded';
    }
    connectedCallback() {
        if (!this.tkFilter || !this.collapseButton || !this.expandButton) throw new Error('TK Filter: Element is missing!');
        this.resizeObserver.observe(this);
        this.registerClickListener();
        this.classList.add(this.loadedClassName);
    }
    sync() {
        this.collapseButton = this.querySelector('[data-tk-filter-group-collapse]') || undefined;
        this.expandButton = this.querySelector('[data-tk-filter-group-expand]') || undefined;
        this.closeDrilldownButtons = this.querySelectorAll('[data-tk-close-drilldown]') || undefined;
        this.listeners.forEach((item)=>{
            item.element.removeEventListener(item.event, item.action);
        });
        this.registerClickListener();
    }
    registerClickListener() {
        const handleCollapseGroups = this.collapseFilterGroups.bind(this);
        this.pushListener({
            event: 'click',
            element: this.collapseButton,
            action: handleCollapseGroups
        });
        const handleExpandGroups = this.expandFilterGroups.bind(this);
        this.pushListener({
            event: 'click',
            element: this.expandButton,
            action: handleExpandGroups
        });
        const handleCloseDrilldown = this.closeDrilldown.bind(this);
        this.closeDrilldownButtons.length > 0 && this.closeDrilldownButtons.forEach((button)=>{
            this.pushListener({
                event: 'click',
                element: button,
                action: handleCloseDrilldown
            });
        });
    }
    collapseFilterGroups() {
        this.classList.remove(this.moreGroupWrapperClassName);
        this.hideCollapseButton();
        this.showExpandButton();
    }
    expandFilterGroups() {
        this.classList.add(this.moreGroupWrapperClassName);
        this.hideExpandButton();
        this.showCollapseButton();
        this.showAllGroups();
    }
    closeDrilldown() {
        this.classList.remove(this.drilldownClassName);
    }
    showExpandButton() {
        if (!this.expandButton) return;
        this.expandButton.hidden = false;
    }
    hideExpandButton() {
        if (!this.expandButton) return;
        this.expandButton.hidden = true;
    }
    showCollapseButton() {
        if (!this.collapseButton) return;
        this.collapseButton.hidden = false;
    }
    hideCollapseButton() {
        if (!this.collapseButton) return;
        this.collapseButton.hidden = true;
    }
    showAllGroups() {
        const childrenList = this.getFilteredGroups();
        childrenList.forEach((element)=>{
            element.hidden = false;
        });
    }
    checkResize(entries) {
        entries.forEach(()=>{
            this.checkGroupLength();
        });
    }
    checkGroupLength() {
        this.showAllGroups();
        this.optimizeGroups();
    }
    optimizeGroups() {
        if (this.classList.contains('tk-filter-group-wrapper--drilldown')) return;
        this.expandButton && (this.expandButton.hidden = true);
        let { scrollWidth: scrollWidth } = this;
        const { width: width, right: right } = this.getBoundingClientRect();
        if (width >= scrollWidth) return;
        scrollWidth = this.scrollWidth;
        const childrenList = this.getFilteredGroups();
        const closestHiddenChild = childrenList.find((child)=>{
            const childRect = child.getBoundingClientRect();
            const childRight = childRect.right;
            return right < childRight;
        });
        if (!closestHiddenChild) return;
        this.expandButton && (this.expandButton.hidden = false);
        const index = childrenList.indexOf(closestHiddenChild);
        this.groupsShowingCount = index - 1;
        this.trimGroupsToMaxCount(childrenList, this.groupsShowingCount);
    }
    getFilteredGroups() {
        return Array.from(this.querySelectorAll('[data-tk-filter-group]'));
    }
    trimGroupsToMaxCount(childrenList, maxShowingGroup) {
        const difference = this.groupCount - maxShowingGroup;
        const lastChildren = childrenList.slice(difference * -1);
        lastChildren.forEach((element)=>{
            element.hidden = true;
        });
    }
}




class $668e651a8805c9ff$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super(), this.isDrilldownActive = false;
        this.wrapper = this.closest('[data-tk-filter-group-wrapper]') || undefined;
        this.isOpenClass = this.getAttribute('data-tk-filter-group-show-class') || 'tk-filter-dropdown--open';
        this.drilldownDropdownClassName = this.getAttribute('data-tk-filter-drilldown-dropdown-class-name') || 'tk-filter-dropdown--drilldown';
        this.filterDropdown = this.querySelector(`#${this.getAttribute('data-tk-filter-group-dropdown')}`) || undefined;
        this.offset = Number(this.getAttribute('data-tk-filter-group-dropdown-offset')) || 4;
        this.drilldownClassName = this.getAttribute('data-tk-drilldown-class-name') || 'tk-filter-group-wrapper--drilldown';
        this.backButton = this.querySelector('[data-tk-filter-dropdown-jump-back]') || undefined;
    }
    connectedCallback() {
        if (!this.filterDropdown || !this.wrapper) return;
        this.attachClickListener();
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        this.filterDropdown?.remove();
    }
    attachClickListener() {
        const handleDropdownVisibility = this.toggleDropdown.bind(this);
        this.pushListener({
            event: 'click',
            element: this,
            action: handleDropdownVisibility
        });
    }
    registerCloseListener() {
        const handleClose = this.close.bind(this);
        this.pushListener({
            event: 'click',
            element: window,
            action: handleClose
        });
        if (!this.backButton) return;
        const handleCloseDropdown = this.closeDropdown.bind(this);
        this.pushListener({
            event: 'click',
            element: this.backButton,
            action: handleCloseDropdown
        });
    }
    toggleDropdown() {
        this.isDrilldownActive = this.wrapper.classList.contains(this.drilldownClassName);
        this.resetDropdownVisibility();
        if (this.filterDropdown.hidden) {
            document.body.insertAdjacentElement('beforeend', this.filterDropdown);
            this.filterDropdown.hidden = false;
            this.filterDropdown.classList.add(this.isOpenClass);
            this.isDrilldownActive && this.filterDropdown.classList.add(this.drilldownDropdownClassName);
            this.alignDropdownToButton();
        } else {
            this.filterDropdown.hidden = true;
            this.filterDropdown.classList.remove(this.isOpenClass);
            this.isDrilldownActive && this.filterDropdown.classList.remove(this.drilldownDropdownClassName);
            this.insertAdjacentElement('beforeend', this.filterDropdown);
        }
    }
    closeDropdown() {
        this.filterDropdown.classList.remove(this.isOpenClass);
    }
    resetDropdownVisibility() {
        const openDropdowns = document.querySelectorAll('[data-tk-filter-dropdown]');
        const dropdownsToClose = Array.from(openDropdowns).filter((dropdown)=>dropdown !== this.filterDropdown);
        dropdownsToClose.forEach((dropdown)=>{
            dropdown.hidden = true;
            dropdown.classList.remove(this.isOpenClass);
        });
    }
    alignDropdownToButton() {
        const { bottom: bottom, left: left } = this.getBoundingClientRect();
        this.filterDropdown.style.top = `${bottom + window.scrollY + this.offset}px`;
        this.filterDropdown.style.left = `${left + window.scrollX}px`;
        setTimeout(()=>{
            this.registerCloseListener();
        }, 0);
    }
    close(event) {
        if (!this.filterDropdown) return;
        const buttonRect = this.getBoundingClientRect();
        const dropdownRect = this.filterDropdown.getBoundingClientRect();
        const rectangles = [
            {
                rectangle: buttonRect
            },
            {
                rectangle: dropdownRect
            }
        ];
        if ((0, $7e8cc8975b3fe464$export$dcbd32acb1a13bc6)(event, rectangles)) {
            this.filterDropdown.hidden = true;
            this.filterDropdown.classList.remove(this.isOpenClass);
            this.removeListener(window);
        }
    }
}



class $c0415a55fc888360$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super(), this.existsMessage = false;
        this.wrapper = this.closest('[data-tk-filter-dropdown]') || undefined;
        this.fieldElement = this.querySelector('input') || undefined;
        this.lastChildClassName = this.getAttribute('data-tk-last-child-class-name') || 'tk-filter-select--last-child';
    }
    connectedCallback() {
        if (!this.wrapper || !this.fieldElement) throw new Error('Filter-Search: Element is missing!');
        this.registerInputListener();
    }
    registerInputListener() {
        const onInput = this.filter.bind(this);
        this.pushListener({
            event: 'input',
            element: this.fieldElement,
            action: onInput
        });
    }
    filter(event) {
        const filterTypes = this.wrapper.querySelector('[data-tk-filter-types]');
        const search = event.target;
        this.resetAll();
        if (!filterTypes || !search) return;
        const value = search.value.toLowerCase();
        const { children: children } = filterTypes;
        const childList = Array.from(children);
        childList.forEach((child)=>{
            const element = child;
            const input = element.querySelector('input');
            const label = element.querySelector('label');
            element.hidden = !input?.value.toLowerCase().includes(value) && !label?.textContent?.toLowerCase().includes(value) || false;
        });
        const visibleChilds = childList.filter((item)=>{
            const element = item;
            return !element.hidden;
        });
        filterTypes.classList.toggle(this.lastChildClassName, visibleChilds.length === 1);
        if (visibleChilds.length === 0) {
            if (this.existsMessage) return;
            const messageElement = $c0415a55fc888360$export$2e2bcd8739ae039.createMessage();
            filterTypes.insertAdjacentElement('beforebegin', messageElement);
            this.existsMessage = true;
        } else if (this.existsMessage) {
            const messageElement = this.wrapper?.querySelector('.tk-message');
            if (!messageElement) return;
            messageElement.remove();
            this.existsMessage = false;
        }
    }
    resetAll() {
        const fiterTypes = this.wrapper.querySelector('[data-tk-filter-types]');
        if (!fiterTypes) return;
        const { children: children } = fiterTypes;
        const childList = Array.from(children);
        childList.forEach((child)=>{
            const element = child;
            element.hidden = false;
        });
    }
    static createMessage() {
        const emptyInfo = document.createElement('div');
        emptyInfo.classList.add('tk-message', 'tk-message--info', 'tk-message--fullwidth');
        emptyInfo.textContent = window.opacc.tkFilterMessages?.emptyResult.text || '';
        return emptyInfo;
    }
}



class $f21079be2cdb055f$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.wrapper = this.closest('[data-tk-filter-dropdown]') || undefined;
        this.button = this.querySelector('button') || undefined;
    }
    connectedCallback() {
        if (!this.button) throw new Error('Select Reset: Button is missing!');
        this.registerClickListener();
    }
    registerClickListener() {
        const onClick = this.reset.bind(this);
        this.pushListener({
            event: 'click',
            element: this.button,
            action: onClick
        });
    }
    reset() {
        const fiterTypes = this.wrapper.querySelector('[data-tk-filter-types]');
        if (!fiterTypes) return;
        const { children: children } = fiterTypes;
        const childList = Array.from(children);
        childList.forEach((child)=>{
            const input = child.querySelector('input');
            if (!input) return;
            input.checked = false;
        });
    }
}



class $b604e9d6535c82d7$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.openDrilldownClass = this.getAttribute('data-tk-filter-drilldown-open-class') || 'tk-filter-group-wrapper--drilldown';
        this.activeFilterClass = this.getAttribute('data-tk-filter-drilldown-active-class') || 'tk-filter-drilldown-button--active';
        this.activeFilterCountWrapper = this.querySelector('[data-tk-filter-drilldown-button-count]') || undefined;
        this.tkFilter = this.closest('[data-tk-filter-wrapper]') || undefined;
    }
    connectedCallback() {
        if (!this.activeFilterCountWrapper || !this.tkFilter) return;
        this.tkFilterGroupWrapper = this.tkFilter.querySelector('[data-tk-filter-group-wrapper]') || undefined;
        if (!this.tkFilterGroupWrapper) return;
        this.registerClickListener();
        this.registerFilterListener();
        this.updateFilterCount();
        this.hidden = !this.isFilterAvailable();
    }
    registerClickListener() {
        const handleDrilldownToggle = this.toggleDrilldown.bind(this);
        this.pushListener({
            event: 'click',
            element: this,
            action: handleDrilldownToggle
        });
    }
    registerFilterListener() {
        this.tkFilter?.subscribe((data)=>{
            if (data.action === 'REFRESHED-DRILLDOWN') this.updateFilterCount();
        });
    }
    toggleDrilldown() {
        this.tkFilterGroupWrapper.classList.add(this.openDrilldownClass);
        this.tkFilterGroupWrapper.showAllGroups();
    }
    updateFilterCount() {
        const activeFilters = [
            ...new Set(this.tkFilter.filterList.map((filter)=>filter.id))
        ];
        if (activeFilters.length > 0) {
            this.activeFilterCountWrapper.innerHTML = `${activeFilters.length}`;
            this.classList.add(this.activeFilterClass);
        } else {
            this.activeFilterCountWrapper.innerHTML = '';
            this.classList.remove(this.activeFilterClass);
        }
    }
    isFilterAvailable() {
        if (!this.tkFilter) return false;
        return this.tkFilter.querySelectorAll('[data-tk-filter-group]').length > 0;
    }
}





class $e884ed7e3be89e23$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.attr = this.getAttribute('data-tk-attr') || undefined;
        this.requestURL = this.getAttribute('data-tk-url') || undefined;
        this.eventHandler = this.getAttribute('data-tk-eventhandler') || 'blur';
        this.forceReload = this.hasAttribute('data-tk-force-reload');
        this.noInitSubmit = this.hasAttribute('data-tk-no-init-submit');
        this.reloadSummary = this.hasAttribute('data-tk-reload-summary');
        this.reloadAfterSubmit = this.hasAttribute('data-tk-reload-after-submit');
        this.summaryContainer = document.querySelector('[data-tk-summary-container]') || undefined;
        this.summeryURL = this.summaryContainer?.getAttribute('data-tk-url') || undefined;
        this.isInit = true;
    }
    connectedCallback() {
        if (!this.requestURL) return;
        this.registerListener();
    }
    registerListener() {
        const formField = this.querySelector('select') || this.querySelector('input') || this.querySelector('textarea') || undefined;
        if (formField) {
            const action = this.submitField.bind(this, formField, false);
            this.pushListener({
                event: this.eventHandler,
                element: formField,
                action: action
            });
            this.submitField(formField, true);
        }
    }
    submitField(element, init) {
        if (this.isInit) {
            this.isInit = false;
            if (this.noInitSubmit) return;
        }
        let value;
        if (element instanceof HTMLInputElement && element.type === 'checkbox') value = element.checked.toString();
        else value = element.value;
        const data = {
            attr: this.attr || '',
            value: value
        };
        this.changeTimeout = setTimeout(()=>{
            (0, $1653b55d89a7adce$export$24835cb787452b46)({
                requestURL: this.requestURL,
                resolveHandler: this.refreshContent.bind(this, init),
                payload: data
            });
        }, 500);
    }
    refreshContent(init) {
        if (init) return;
        // eslint-disable-next-line no-self-assign
        if (this.reloadAfterSubmit) return window.location.href = window.location.href;
        if (this.forceReload) {
            const container = document.querySelector('[data-tk-container]');
            const requestURL = container?.getAttribute('data-tk-content-url');
            if (!container || !requestURL) location.reload();
            else this.fetchContent(container, requestURL);
        }
        if (this.reloadSummary && this.summaryContainer && this.summeryURL) this.fetchContent(this.summaryContainer, this.summeryURL);
    }
    fetchContent(container, requestURL) {
        (0, $1653b55d89a7adce$export$24835cb787452b46)({
            requestURL: requestURL,
            resolveHandler: this.replaceContent.bind(this, container)
        });
    }
    replaceContent(container, response) {
        const body = (0, $2d540709c75492d4$export$2e2bcd8739ae039)(response.dataAsHtml, true);
        container.replaceChildren(body);
        const newTotal = container.querySelector('[data-tk-checkout-total]')?.innerHTML;
        const footerTotal = document.querySelector('[data-op-asyncbasket]');
        if (!newTotal || !footerTotal) return;
        footerTotal.innerHTML = newTotal;
    }
}




class $e40e050d51aeaeef$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.oc = this.getAttribute('data-tk-url') || undefined;
        this.inputs = this.querySelectorAll('input, select') || undefined;
        this.reloadPage = this.hasAttribute('data-tk-reload-page');
    }
    connectedCallback() {
        if (this.inputs.length === 0 || !this.oc) return;
        this.registerListener();
    }
    registerListener() {
        [
            ...this.inputs
        ].forEach((input)=>{
            const action = this.sendRequest.bind(this, input);
            const event = input instanceof HTMLInputElement ? 'focusout' : 'change';
            this.pushListener({
                event: event,
                element: input,
                action: action
            });
        });
    }
    sendRequest(input) {
        const data = {
            value: input.value
        };
        (0, $1653b55d89a7adce$export$24835cb787452b46)({
            requestURL: this.oc,
            resolveHandler: this.logResult.bind(this),
            payload: data
        });
    }
    logResult(reponse) {
        console.log(reponse.dataAsJson);
        if (this.reloadPage) location.reload();
    }
}





const $b314948e6a7c6950$var$isValidJSON = (value)=>{
    try {
        const json = JSON.parse(value);
        return {
            isValid: true,
            json: json
        };
    } catch  {
        return {
            isValid: false
        };
    }
};
var $b314948e6a7c6950$export$2e2bcd8739ae039 = $b314948e6a7c6950$var$isValidJSON;


const $3507ba4caf4aa34e$var$parseBooleanOrString = (value)=>{
    if (value === 'true') return true;
    if (value === 'false') return false;
    return value;
};
var $3507ba4caf4aa34e$export$2e2bcd8739ae039 = $3507ba4caf4aa34e$var$parseBooleanOrString;


const $bf3fdf42d85858f4$var$toSnakeCase = (input)=>input.replace(/([a-z])([A-Z])/g, '$1_$2').toLowerCase();
var $bf3fdf42d85858f4$export$2e2bcd8739ae039 = $bf3fdf42d85858f4$var$toSnakeCase;


class $0efda1b115753384$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super(), this.hasItems = false, this.attributeList = [];
        this.trackerElement = this.closest('[data-tk-tracker-wrapper]') || undefined;
        this.event = this.getAttribute('data-tk-event') || undefined;
        this.isAsync = this.hasAttribute('data-tk-is-async');
        this.asyncAttributesURL = this.getAttribute('data-tk-async-attributes-url') || undefined;
        this.trackerType = this.getAttribute('data-tk-tracker-type') || undefined;
        this.hasItems = this.hasAttribute('data-tk-has-items');
        this.itemsKey = this.getDataAttribute('has-items', 'items');
        this.location = window.location.href;
    }
    async connectedCallback() {
        if (!this.trackerElement) throw new Error('Tracker Element is missing!');
        if (!this.event) throw new Error('Event is not defined');
        if (this.isAsync) this.init();
        else this.pushListener({
            event: 'tk-tracker-ready',
            element: this.trackerElement,
            action: this.init.bind(this)
        });
    }
    async init() {
        this.attributeList = this.extractAttributesFrom(this);
        if (this.hasItems) this.collectItemAttributes();
        await this.getAsyncAttributes();
        this.pushTracker();
    }
    extractAttributesFrom(element) {
        return Object.keys(element.dataset).filter((key)=>!key.startsWith('tk')).map((key)=>this.createAttribute(key, element.dataset[key])).filter(Boolean);
    }
    createAttribute(key, value) {
        const result = (0, $b314948e6a7c6950$export$2e2bcd8739ae039)(value);
        return {
            key: key,
            value: result.isValid ? result.json : (0, $3507ba4caf4aa34e$export$2e2bcd8739ae039)(value)
        };
    }
    collectItemAttributes() {
        const items = Array.from(this.querySelectorAll('[data-tk-item]'));
        const itemAttributes = items.map((item)=>this.extractAttributesFrom(item)).map(this.mapToSnakeCase);
        this.attributeList.push({
            key: this.itemsKey,
            value: itemAttributes
        });
    }
    mapToSnakeCase(attributes) {
        return attributes.reduce((acc, attr)=>{
            const key = (0, $bf3fdf42d85858f4$export$2e2bcd8739ae039)(attr.key);
            // Wenn der Wert ein Array ist, konvertiere ihn in einen String (z.B. JSON.stringify)
            if (Array.isArray(attr.value)) acc[key] = JSON.stringify(attr.value);
            else acc[key] = attr.value;
            return acc;
        }, {});
    }
    async getAsyncAttributes() {
        if (!this.asyncAttributesURL) return;
        await (0, $1653b55d89a7adce$export$24835cb787452b46)({
            requestURL: this.asyncAttributesURL,
            resolveHandler: this.handleAsyncAttributes.bind(this)
        });
    }
    handleAsyncAttributes(response) {
        Object.entries(response.dataAsJson.attributes).forEach(([key, value])=>{
            this.attributeList.push({
                key: value,
                value: response.dataAsJson[key]
            });
        });
    }
    pushTracker() {
        const item = {
            event: this.event,
            location: this.location,
            ...this.attributeList.reduce((acc, attr)=>{
                const key = (0, $bf3fdf42d85858f4$export$2e2bcd8739ae039)(attr.key);
                acc[key] = attr.value;
                return acc;
            }, {})
        };
        this.trackerElement?.dispatchEvent(new CustomEvent('tk-tracking-push', {
            detail: {
                trackerType: this.trackerType,
                item: item
            }
        }));
    }
}



class $c939016b6450b7d5$export$2e2bcd8739ae039 extends (0, $178b0b1cc6a532a3$export$2e2bcd8739ae039) {
    constructor(){
        super();
    }
    mergeURLParamsByData(data, shouldReset = false) {
        const url = (0, $178b0b1cc6a532a3$export$2e2bcd8739ae039).mergeURLs(this.filterURL) || new URL(window.location.href);
        const searchParamList = Array.from(url.searchParams);
        let filteredList = searchParamList.filter((item)=>!item[0].startsWith(this.groupId));
        filteredList = filteredList.filter((param)=>!param[0].startsWith('ppos')); // reset Paging
        const existingParams = Object.fromEntries(filteredList);
        const mergedParams = shouldReset ? {
            ...existingParams
        } : {
            ...data,
            ...existingParams
        };
        url.search = new URLSearchParams(mergedParams).toString();
        return url;
    }
}




class $07afad60c3eff18b$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    connectedCallback() {
        this.registerClickListener();
    }
    get url() {
        return this.getAttribute('data-tca-url') || undefined;
    }
    get target() {
        return this.getAttribute('data-tca-target-area') || undefined;
    }
    registerClickListener() {
        // Suche das übergeordnete Accordion
        const accordion = this.closest('tk-tabs-accordion');
        const header = accordion?.querySelector('[data-tk-accordion-head]');
        if (header) this.pushListener({
            event: 'click',
            element: header,
            action: this.send.bind(this)
        });
        else console.warn('TCAsyncLoader: Kein data-tk-accordion-head gefunden.');
    }
    async send() {
        if (!this.url) {
            console.warn('TCAsyncLoader: Kein data-tca-url definiert.');
            return;
        }
        (0, $1653b55d89a7adce$export$24835cb787452b46)({
            requestURL: this.url,
            resolveHandler: this.refreshContent.bind(this),
            showMessages: false
        });
    }
    refreshContent(response) {
        if (!response?.success) return;
        if (this.target && response.dataAsHtml) {
            const targetElement = document.getElementById(this.target);
            if (targetElement) targetElement.innerHTML = response.dataAsHtml;
            else console.warn(`TCAsyncLoader: Target-Element mit ID "${this.target}" nicht gefunden.`);
        }
    }
}









class $3e722467526ffba8$export$2e2bcd8739ae039 extends (0, $e31d2de11bbf216d$export$2e2bcd8739ae039) {
    constructor(){
        super([
            {
                name: 'tk-manager',
                constructor: (0, $aa35ef9547ba682e$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-viewport',
                constructor: (0, $49fab39bf1404505$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-tracker',
                constructor: (0, $588d148f2c9ac202$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-button-dropdown',
                constructor: (0, $9d20cb2aef3a6ec2$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-header',
                constructor: (0, $1352bbad447b1dc9$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-nav-sidebar',
                constructor: (0, $40898dd22403025f$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-search',
                constructor: (0, $011e7dbf949e9361$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-basket-button',
                constructor: (0, $127c03b03da38c7a$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-carousel',
                constructor: (0, $1e52ca8fdbe257bc$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-context-menu',
                constructor: (0, $d9484b764f1a944d$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-flag',
                constructor: (0, $0d07f57cc5d15afe$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-minibasket',
                constructor: (0, $8b05e2474621c644$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-product-tile',
                constructor: (0, $21ae20c5af7baedb$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-product-variants',
                constructor: (0, $21611c672b0d32ce$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-tooltip',
                constructor: (0, $b4b8cee06c4cfcc8$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-dialog',
                constructor: (0, $2215c02a950e9fbf$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-article-list',
                constructor: (0, $6406837936bc2cfc$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-price',
                constructor: (0, $1ccb7c18f671f1de$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-stock',
                constructor: (0, $ad2181492f474118$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-static-content',
                constructor: (0, $edcef81612fbf4b7$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-tabs-tab',
                constructor: (0, $237e800aa488702c$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-favorite-button',
                constructor: (0, $2c226fea39ede692$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-favorite-info',
                constructor: (0, $38c77688df6cd108$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-form-element',
                constructor: (0, $9a3403e3213d867d$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-form-validator',
                constructor: (0, $21a7ddce6a8de4e2$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-tabs-accordion',
                constructor: (0, $59575c6d2ba9e740$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-compare-button',
                constructor: (0, $cc14b9b65c9c652e$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-selection',
                constructor: (0, $407d2fd9d876caa3$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-file-upload-area',
                constructor: (0, $2b8eccc7b4db22b8$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-compare-info',
                constructor: (0, $7cfc9025399237fb$export$2e2bcd8739ae039)
            },
            {
                name: 'tc-section-toggler',
                constructor: (0, $fda791df831ac3d3$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-form-datepicker',
                constructor: (0, $e018ac17002873dc$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-form-timepicker',
                constructor: (0, $96bb90b027be4c0d$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-table',
                constructor: (0, $2595e2ca594d6789$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-filter',
                constructor: (0, $c939016b6450b7d5$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-filter-chip',
                constructor: (0, $c51b1a9a7c03f7bf$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-filter-result',
                constructor: (0, $4e5f7d9c5ffa7d20$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-filter-dropdown',
                constructor: (0, $058daee80809af6c$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-filter-group-wrapper',
                constructor: (0, $6deb510fe3e19897$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-filter-group',
                constructor: (0, $668e651a8805c9ff$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-filter-search',
                constructor: (0, $c0415a55fc888360$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-filter-select-reset',
                constructor: (0, $f21079be2cdb055f$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-filter-drilldown-button',
                constructor: (0, $b604e9d6535c82d7$export$2e2bcd8739ae039)
            },
            {
                name: 'tc-submit-direct',
                constructor: (0, $e884ed7e3be89e23$export$2e2bcd8739ae039)
            },
            {
                name: 'tc-sessionvar',
                constructor: (0, $e40e050d51aeaeef$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-tracking',
                constructor: (0, $0efda1b115753384$export$2e2bcd8739ae039)
            },
            {
                name: 'tc-asyn-loader',
                constructor: (0, $07afad60c3eff18b$export$2e2bcd8739ae039)
            }
        ]);
    }
}
new $3e722467526ffba8$export$2e2bcd8739ae039();

})();
//# sourceMappingURL=staticcontent.js.map
